/* tslint:disable */
 
//  This file was automatically generated and should not be edited.

export type TrackEventInput = {
  event: string,
  properties?: string | null,
};

export type CreateClientInput = {
  entityId: string,
  client: ClientInput,
  entity: CreateEntityInput,
  suppressInvite?: boolean | null,
  taskSendSMS?: boolean | null,
  partnerId?: string | null,
  managerId?: string | null,
  clientCode?: string | null,
  clientGroupCode?: string | null,
};

export type ClientInput = {
  firstName: string,
  lastName: string,
  name: string,
  email?: string | null,
  mobile?: string | null,
  phone?: string | null,
  address?: AddressInput | null,
};

export type AddressInput = {
  addressId?: string | null,
  contactName?: string | null,
  contactNumber?: string | null,
  fullAddress?: string | null,
  address1: string,
  address2?: string | null,
  country: string,
  countryCode: string,
  city: string,
  state: string,
  stateCode?: string | null,
  postalCode: string,
};

export type CreateEntityInput = {
  type: EntityType,
  taxNumber?: string | null,
  companyNumber?: string | null,
  name: string,
  firstName?: string | null,
  lastName?: string | null,
  address?: AddressInput | null,
  logo?: ImageInput | null,
  brandColour?: string | null,
  website?: string | null,
  isFirm?: boolean | null,
  gstRegistered?: boolean | null,
  gstReportingPeriod?: GSTReportingPeriod | null,
  clientsOnboardingStatus?: ClientsOnboardingStatus | null,
};

export enum EntityType {
  INDIVIDUAL = "INDIVIDUAL",
  SOLE_TRADER = "SOLE_TRADER",
  PARTNERSHIP = "PARTNERSHIP",
  COMPANY = "COMPANY",
  TRUST = "TRUST",
  SELF_MANAGED_SUPER_FUND = "SELF_MANAGED_SUPER_FUND",
  NOT_FOR_PROFIT = "NOT_FOR_PROFIT",
  BPAY = "BPAY",
}


export type ImageInput = {
  alt?: string | null,
  identityId?: string | null,
  key: string,
  level: S3UploadLevel,
  type?: string | null,
};

export enum S3UploadLevel {
  public = "public",
  protected = "protected",
  private = "private",
}


export enum GSTReportingPeriod {
  MONTHLY = "MONTHLY",
  QUARTERLY = "QUARTERLY",
  ANNUALLY = "ANNUALLY",
}


export enum ClientsOnboardingStatus {
  CLIENTS = "CLIENTS",
  ENTITY_USERS = "ENTITY_USERS",
  PAYMENT_METHOD = "PAYMENT_METHOD",
  COMPLETED = "COMPLETED",
}


export type EntityUser = {
  __typename: "EntityUser",
  id: string,
  entityId: string,
  userId: string,
  firmId?: string | null,
  email?: string | null,
  invitedEmail?: string | null,
  ocrEmail?: string | null,
  referredBy?: string | null,
  invitedEntityId?: string | null,
  firmEntityId?: string | null,
  providerContactId?: string | null,
  ownerCode?: string | null,
  clientGroupCode?: string | null,
  clientCode?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  role: EntityUserRole,
  jobTags?: Array< JobTags | null > | null,
  paymentsEnabled?: boolean | null,
  termsInvoiceAccepted?: boolean | null,
  termsOcrAccepted?: boolean | null,
  termsFirmPayTaxAccepted?: boolean | null,
  termsFirmPayTaxDetails?: TermsFirmPayTaxDetails | null,
  entitySearchName?: string | null,
  entity?: Entity | null,
  firm?: Entity | null,
  searchName?: string | null,
  taxNumber?: string | null,
  taskSendSMS?: boolean | null,
  companyNumber?: string | null,
  createdBy?: string | null,
  createdAt: string,
  updatedAt: string,
  status?: EntityUserStatus | null,
  partnerId?: string | null,
  managerId?: string | null,
  archivedAt?: string | null,
  taxPaymentReferences?: TaxPaymentReferences | null,
};

export enum EntityUserRole {
  OWNER = "OWNER",
  ADMIN = "ADMIN",
  ACCOUNTANT = "ACCOUNTANT",
  CONTRIBUTOR = "CONTRIBUTOR",
}


export enum JobTags {
  PARTNER = "PARTNER",
  MANAGER = "MANAGER",
  CLERK = "CLERK",
}


export type TermsFirmPayTaxDetails = {
  __typename: "TermsFirmPayTaxDetails",
  document?: S3Upload | null,
  acceptedAt?: string | null,
  email?: string | null,
  ip?: string | null,
  fullName?: string | null,
  firmId?: string | null,
};

export type S3Upload = {
  __typename: "S3Upload",
  identityId?: string | null,
  key: string,
  level: S3UploadLevel,
  type: S3UploadType,
  name?: string | null,
};

export enum S3UploadType {
  IMAGE = "IMAGE",
  PDF = "PDF",
  VIDEO = "VIDEO",
  FILE = "FILE",
}


export type Entity = {
  __typename: "Entity",
  id: string,
  type: EntityType,
  taxNumber?: string | null,
  companyNumber?: string | null,
  billerCode?: number | null,
  name: string,
  legalName?: string | null,
  businessNames?: Array< string | null > | null,
  searchName?: string | null,
  address?: Address | null,
  logo?: Image | null,
  brandColour?: string | null,
  website?: string | null,
  entityUsers?: ModelEntityUserConnection | null,
  gstRegistered?: boolean | null,
  gstReportingPeriod?: GSTReportingPeriod | null,
  providerEntityId?: string | null,
  providerCompanyId?: string | null,
  providerBillUserCompanyId?: string | null,
  providerBankAccountId?: string | null,
  providerDigitalWalletId?: string | null,
  providerBpayCrn?: string | null,
  contact?: EntityContact | null,
  paymentMethods?: ModelPaymentMethodConnection | null,
  paymentMethodId?: string | null,
  paymentUserId?: string | null,
  disbursementMethodId?: string | null,
  receivingAccounts?: ModelPaymentMethodConnection | null,
  ubosCreated?: boolean | null,
  numUbosCreated?: number | null,
  subCategory?: string | null,
  clientsStatus?: EntityClientsStatus | null,
  ocrEmail?: string | null,
  termsInvoiceAccepted?: boolean | null,
  termsOcrAccepted?: boolean | null,
  owner?: string | null,
  referredBy?: string | null,
  connectedAccount?: string | null,
  accountStatus?: AccountStatus | null,
  customerId?: string | null,
  xeroSyncStatus?: XeroSyncStatus | null,
  xeroLastContactSyncAt?: string | null,
  xeroContactSyncStatus?: XeroSyncStatus | null,
  xeroInvoiceSyncStatus?: XeroSyncStatus | null,
  xeroLastInvoiceSyncAt?: string | null,
  xeroTenantId?: string | null,
  absorbFees?: boolean | null,
  subscriptionTier?: SubscriptionTier | null,
  invitationStatus?: InvitationStatus | null,
  clientsOnboardingStatus?: ClientsOnboardingStatus | null,
  createdBy?: string | null,
  createdByEntityId?: string | null,
  isFirm?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type Address = {
  __typename: "Address",
  addressId?: string | null,
  contactName?: string | null,
  contactNumber?: string | null,
  fullAddress?: string | null,
  address1?: string | null,
  address2?: string | null,
  city?: string | null,
  country: string,
  countryCode: string,
  state: string,
  stateCode?: string | null,
  postalCode: string,
  invalid?: boolean | null,
};

export type Image = {
  __typename: "Image",
  alt?: string | null,
  identityId?: string | null,
  key: string,
  level: S3UploadLevel,
  type?: string | null,
};

export type ModelEntityUserConnection = {
  __typename: "ModelEntityUserConnection",
  items:  Array<EntityUser | null >,
  nextToken?: string | null,
};

export type EntityContact = {
  __typename: "EntityContact",
  firstName?: string | null,
  lastName?: string | null,
  email?: string | null,
  phone?: string | null,
  role?: string | null,
};

export type ModelPaymentMethodConnection = {
  __typename: "ModelPaymentMethodConnection",
  items:  Array<PaymentMethod | null >,
  nextToken?: string | null,
};

export type PaymentMethod = {
  __typename: "PaymentMethod",
  id: string,
  paymentMethodType: PaymentMethodType,
  type?: string | null,
  fullName?: string | null,
  number?: string | null,
  expMonth?: string | null,
  expYear?: string | null,
  accountName?: string | null,
  bankName?: string | null,
  accountNumber?: string | null,
  routingNumber?: string | null,
  holderType?: BankHolderType | null,
  accountType?: BankAccountType | null,
  status?: PaymentMethodStatus | null,
  accountDirection?: AccountDirection | null,
  expiresAt?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  consentId?: string | null,
  consentStatus?: PaymentConsentStatus | null,
  card?: string | null,
  googlepay?: string | null,
  applepay?: string | null,
};

export enum PaymentMethodType {
  CARD = "CARD",
  BANK = "BANK",
  PAYTO = "PAYTO",
  PAYID = "PAYID",
  APPLEPAY = "APPLEPAY",
  GOOGLEPAY = "GOOGLEPAY",
  CONNECTED_ACCOUNT_WALLET = "CONNECTED_ACCOUNT_WALLET",
}


export enum BankHolderType {
  personal = "personal",
  business = "business",
}


export enum BankAccountType {
  savings = "savings",
  checking = "checking",
}


export enum PaymentMethodStatus {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
}


export enum AccountDirection {
  PAYMENT = "PAYMENT",
  DISBURSEMENT = "DISBURSEMENT",
}


export enum PaymentConsentStatus {
  PENDING_VERIFICATION = "PENDING_VERIFICATION",
  VERIFIED = "VERIFIED",
}


export enum EntityClientsStatus {
  ENABLED = "ENABLED",
  DISABLED = "DISABLED",
  REVIEW = "REVIEW",
  DECLINED = "DECLINED",
}


export enum AccountStatus {
  NOT_CREATED = "NOT_CREATED",
  CREATED = "CREATED",
  SUBMITTED = "SUBMITTED",
  ACTION_REQUIRED = "ACTION_REQUIRED",
  ACTIVE = "ACTIVE",
  SUSPENDED = "SUSPENDED",
  NOT_ELIGIBLE = "NOT_ELIGIBLE",
}


export enum XeroSyncStatus {
  UNSYNCED = "UNSYNCED",
  PENDING = "PENDING",
  SYNCED = "SYNCED",
}


export enum SubscriptionTier {
  PRO = "PRO",
  STANDARD = "STANDARD",
  FREE = "FREE",
}


export enum InvitationStatus {
  SUPRESSED = "SUPRESSED",
  SENT = "SENT",
}


export enum EntityUserStatus {
  PENDING = "PENDING",
  ACCEPTED = "ACCEPTED",
  DECLINED = "DECLINED",
}


export type TaxPaymentReferences = {
  __typename: "TaxPaymentReferences",
  itr?: TaxPaymentReference | null,
  other?: TaxPaymentReference | null,
};

export type TaxPaymentReference = {
  __typename: "TaxPaymentReference",
  referenceNumber?: string | null,
  updatedAt?: string | null,
};

export type CreateClientBulkImportInput = {
  entityId: string,
  fileKey: string,
  fields: ClientFieldsInput,
  suppressInvite?: boolean | null,
};

export type ClientFieldsInput = {
  firstName: string,
  lastName: string,
  name: string,
  email: string,
  mobile: string,
  phone?: string | null,
  addressId?: string | null,
  contactName?: string | null,
  contactNumber?: string | null,
  taxNumber?: string | null,
  companyNumber?: string | null,
  address?: string | null,
  address1: string,
  address2?: string | null,
  country: string,
  countryCode?: string | null,
  city: string,
  state: string,
  stateCode?: string | null,
  postalCode: string,
  clientCode?: string | null,
  clientGroupCode?: string | null,
};

export type AddClientOwnerInput = {
  entityId: string,
  email: string,
  firstName: string,
  lastName: string,
  mobile?: string | null,
  firmId: string,
  clientGroupCode?: string | null,
  clientCode?: string | null,
  createdBy?: string | null,
};

export type AddClientOwnerResponse = {
  __typename: "AddClientOwnerResponse",
  success: boolean,
  entityId: string,
  userId: string,
  ownerEntityUserId: string,
  clientGroupCode?: string | null,
  clientCode?: string | null,
  entity?: Entity | null,
  entityUser?: EntityUser | null,
};

export type CreateContactInput = {
  entityId: string,
  firstName: string,
  lastName: string,
  name?: string | null,
  email?: string | null,
  mobile?: string | null,
  phone?: string | null,
  status?: ContactStatus | null,
  taxNumber?: string | null,
  companyNumber?: string | null,
  website?: string | null,
  bank?: ContactBankAccountInput | null,
  bpay?: ContactBpayInput | null,
  address?: AddressInput | null,
  postal?: AddressInput | null,
};

export enum ContactStatus {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
}


export type ContactBankAccountInput = {
  accountName: string,
  accountNumber: string,
  bankName?: string | null,
  routingNumber: string,
  holderType?: BankHolderType | null,
  accountType?: BankAccountType | null,
  country?: string | null,
};

export type ContactBpayInput = {
  billerCode?: number | null,
  referenceNumber?: string | null,
};

export type Contact = {
  __typename: "Contact",
  id: string,
  entityId: string,
  xeroTenantId?: string | null,
  entityType?: EntityType | null,
  firstName?: string | null,
  lastName?: string | null,
  email?: string | null,
  mobile?: string | null,
  phone?: string | null,
  taxNumber?: string | null,
  companyNumber?: string | null,
  name?: string | null,
  legalName?: string | null,
  searchName?: string | null,
  status?: ContactStatus | null,
  website?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  contactType?: ContactType | null,
  bank?: ContactBankAccount | null,
  bpay?: ContactBpay | null,
  invalidFields?: Array< string | null > | null,
  bulkUploadFileKey?: string | null,
  owner?: string | null,
  createdBy?: string | null,
  beneficiaryBankId?: string | null,
  beneficiaryBpayId?: string | null,
  address?: Address | null,
  postal?: Address | null,
  payoutErrors?: Array< string | null > | null,
};

export enum ContactType {
  CLIENT = "CLIENT",
  NORMAL = "NORMAL",
}


export type ContactBankAccount = {
  __typename: "ContactBankAccount",
  id?: string | null,
  accountName?: string | null,
  bankName?: string | null,
  accountNumber: string,
  routingNumber: string,
  holderType?: BankHolderType | null,
  accountType?: BankAccountType | null,
  country?: string | null,
};

export type ContactBpay = {
  __typename: "ContactBpay",
  billerCode?: number | null,
  referenceNumber?: string | null,
};

export type CreateContactBulkImportInput = {
  entityId: string,
  fileKey: string,
  fields: ContactFieldsInput,
};

export type ContactFieldsInput = {
  firstName: string,
  lastName: string,
  name?: string | null,
  email: string,
  mobile?: string | null,
  phone?: string | null,
  taxNumber?: string | null,
  companyNumber?: string | null,
  billerCode?: string | null,
  referenceNumber?: string | null,
  accountName?: string | null,
  bankName?: string | null,
  accountNumber?: string | null,
  routingNumber?: string | null,
  address?: string | null,
  address1?: string | null,
  address2?: string | null,
  country?: string | null,
  countryCode?: string | null,
  city?: string | null,
  state?: string | null,
  stateCode?: string | null,
  postalCode?: string | null,
};

export type UpdateContactInput = {
  id: string,
  entityId?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  email?: string | null,
  mobile?: string | null,
  phone?: string | null,
  status?: ContactStatus | null,
  website?: string | null,
  bank?: ContactBankAccountInput | null,
  bpay?: ContactBpayInput | null,
  address?: AddressInput | null,
  postal?: AddressInput | null,
  payoutErrors?: Array< string | null > | null,
};

export type ResendUserTemporaryPasswordInput = {
  entityId?: string | null,
  userId?: string | null,
  email?: string | null,
};

export type CreateDocumentAnalysisInput = {
  entityId?: string | null,
  firmId?: string | null,
  fileKey?: string | null,
  category?: TaskCategory | null,
};

export enum TaskCategory {
  TAX = "TAX",
  OTHER = "OTHER",
}


export type DocumentAnalysis = {
  __typename: "DocumentAnalysis",
  id: string,
  entityId?: string | null,
  firmId?: string | null,
  fileKey?: string | null,
  documents?:  Array<S3Upload | null > | null,
  status: DocumentAnalysisStatus,
  expenseStatus?: DocumentAnalysisStatus | null,
  queryStatus?: DocumentAnalysisStatus | null,
  matchedBiller?: BillerDetails | null,
  matchedContactId?: string | null,
  matchedContact?: Contact | null,
  matchedEntityId?: string | null,
  matchedEntity?: Entity | null,
  newContact?: DocumentAnalysisContact | null,
  task?: DocumentAnalysisTask | null,
  bpay?: ContactBpay | null,
  bank?: DocumentAnalysisBankAccount | null,
  category?: TaskCategory | null,
  source?: DocumentAnalysisSource | null,
  isCorrect?: boolean | null,
  fromEmail?: string | null,
  textContent?: string | null,
  createdBy?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum DocumentAnalysisStatus {
  IN_PROGRESS = "IN_PROGRESS",
  FAILED = "FAILED",
  SCANNED = "SCANNED",
  COMPLETED = "COMPLETED",
  ARCHIVED = "ARCHIVED",
}


export type BillerDetails = {
  __typename: "BillerDetails",
  billerCode?: number | null,
  billerCategory?: string | null,
  shortName?: string | null,
  longName?: string | null,
  type?: BillerType | null,
  industryCode?: string | null,
  industryCodeDescription?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum BillerType {
  BPAY = "BPAY",
}


export type DocumentAnalysisContact = {
  __typename: "DocumentAnalysisContact",
  firstName?: string | null,
  lastName?: string | null,
  email?: string | null,
  mobile?: string | null,
  phone?: string | null,
  name?: string | null,
  taxNumber?: string | null,
  address?: Address | null,
};

export type DocumentAnalysisTask = {
  __typename: "DocumentAnalysisTask",
  reference?: string | null,
  dueAt?: string | null,
  issuedAt?: string | null,
  lodgementAt?: string | null,
  paymentAt?: string | null,
  gstInclusive?: boolean | null,
  notes?: string | null,
  amount?: number | null,
  gstAmount?: number | null,
  taxAmount?: number | null,
  lineItems?:  Array<DocumentAnalysisLineItem | null > | null,
  numberOfPayments?: number | null,
  paymentFrequency?: PaymentFrequency | null,
  shippingAmount?: number | null,
  settlementStatus?: TaskSettlementStatus | null,
  partnerId?: string | null,
  managerId?: string | null,
  documentType?: DocumentType | null,
  subCategory?: string | null,
  category?: TaskCategory | null,
  period?: string | null,
  year?: string | null,
};

export type DocumentAnalysisLineItem = {
  __typename: "DocumentAnalysisLineItem",
  description?: string | null,
  quantity?: number | null,
  unitPrice?: number | null,
  price?: number | null,
  productCode?: string | null,
  taxType?: TaxType | null,
};

export enum TaxType {
  GST = "GST",
  GST_INCLUSIVE = "GST_INCLUSIVE",
  NO_GST = "NO_GST",
  GST_FREE = "GST_FREE",
}


export enum PaymentFrequency {
  ONCE = "ONCE",
  WEEKLY = "WEEKLY",
  FORTNIGHTLY = "FORTNIGHTLY",
  MONTHLY = "MONTHLY",
  QUARTERLY = "QUARTERLY",
  ANNUALLY = "ANNUALLY",
}


export enum TaskSettlementStatus {
  PAYABLE = "PAYABLE",
  REFUNDABLE = "REFUNDABLE",
  NIL = "NIL",
}


export enum DocumentType {
  NONE = "NONE",
  BAS = "BAS",
  IAS = "IAS",
  PAYG = "PAYG",
  ITR = "ITR",
  FBT = "FBT",
}


export type DocumentAnalysisBankAccount = {
  __typename: "DocumentAnalysisBankAccount",
  accountNumber?: string | null,
  routingNumber?: string | null,
};

export enum DocumentAnalysisSource {
  UPLOAD = "UPLOAD",
  EMAIL = "EMAIL",
}


export type UpdateDocumentAnalysisInput = {
  id: string,
  entityId?: string | null,
  firmId?: string | null,
  jobId?: string | null,
  fileKey?: string | null,
  status?: DocumentAnalysisStatus | null,
  expenseStatus?: DocumentAnalysisStatus | null,
  queryStatus?: DocumentAnalysisStatus | null,
  matchedBiller?: BillerDetailsInput | null,
  matchedContactId?: string | null,
  matchedEntityId?: string | null,
  period?: string | null,
  year?: string | null,
  newContact?: DocumentAnalysisContactInput | null,
  task?: DocumentAnalysisTaskInput | null,
  bpay?: ContactBpayInput | null,
  bank?: DocumentAnalysisBankAccountInput | null,
  source?: DocumentAnalysisSource | null,
  isCorrect?: boolean | null,
  createdBy?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type BillerDetailsInput = {
  billerCode?: number | null,
  billerCategory?: string | null,
  shortName?: string | null,
  longName?: string | null,
  type?: BillerType | null,
  industryCode?: string | null,
  industryCodeDescription?: string | null,
};

export type DocumentAnalysisContactInput = {
  firstName?: string | null,
  lastName?: string | null,
  email?: string | null,
  mobile?: string | null,
  phone?: string | null,
  name?: string | null,
  taxNumber?: string | null,
  companyNumber?: string | null,
  address?: AddressInput | null,
};

export type DocumentAnalysisTaskInput = {
  reference?: string | null,
  dueAt?: string | null,
  issuedAt?: string | null,
  lodgementAt?: string | null,
  paymentAt?: string | null,
  gstInclusive?: boolean | null,
  notes?: string | null,
  amount?: number | null,
  gstAmount?: number | null,
  taxAmount?: number | null,
  lineItems?: Array< DocumentAnalysisLineItemInput | null > | null,
  numberOfPayments?: number | null,
  paymentFrequency?: PaymentFrequency | null,
  shippingAmount?: number | null,
  settlementStatus?: TaskSettlementStatus | null,
  partnerId?: string | null,
  managerId?: string | null,
  documentType?: DocumentType | null,
  category?: TaskCategory | null,
  subCategory?: string | null,
  period?: string | null,
  year?: string | null,
};

export type DocumentAnalysisLineItemInput = {
  quantity?: number | null,
  description?: string | null,
  unitPrice?: number | null,
  price?: number | null,
  productCode?: string | null,
  taxType?: TaxType | null,
};

export type DocumentAnalysisBankAccountInput = {
  accountNumber?: string | null,
  routingNumber?: string | null,
};

export type DeleteDocumentAnalysisInput = {
  id: string,
};

export type UpdateEntityInput = {
  id: string,
  type?: EntityType | null,
  companyNumber?: string | null,
  taxNumber?: string | null,
  name?: string | null,
  address?: AddressInput | null,
  logo?: ImageInput | null,
  brandColour?: string | null,
  paymentMethodId?: string | null,
  disbursementMethodId?: string | null,
  ubosCreated?: boolean | null,
  numUbosCreated?: number | null,
  pepCheckStatus?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  legalName?: string | null,
  contact?: EntityContactInput | null,
  gstRegistered?: boolean | null,
  gstReportingPeriod?: GSTReportingPeriod | null,
  role?: string | null,
  isFirm?: boolean | null,
  termsInvoiceAccepted?: boolean | null,
  termsOcrAccepted?: boolean | null,
  website?: string | null,
  updatedAt?: string | null,
  accountStatus?: AccountStatus | null,
  xeroAccounts?: Array< XeroAccountInput | null > | null,
  absorbFees?: boolean | null,
  clientsStatus?: EntityClientsStatus | null,
  clientsOnboardingStatus?: ClientsOnboardingStatus | null,
  searchName?: string | null,
};

export type EntityContactInput = {
  firstName?: string | null,
  lastName?: string | null,
  email?: string | null,
  phone?: string | null,
};

export type XeroAccountInput = {
  admiinAccount: string,
  xeroAccount: string,
};

export type RegenerateEntityOcrEmailInput = {
  entityId: string,
};

export type DeleteEntityInput = {
  id: string,
};

export type ModelEntityConditionInput = {
  name?: ModelStringInput | null,
  taxNumber?: ModelStringInput | null,
  address?: ModelStringInput | null,
  type?: ModelEntityTypeInput | null,
  owner?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelEntityConditionInput | null > | null,
  or?: Array< ModelEntityConditionInput | null > | null,
  not?: ModelEntityConditionInput | null,
};

export type ModelStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null",
}


export type ModelSizeInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type ModelEntityTypeInput = {
  eq?: EntityType | null,
  ne?: EntityType | null,
};

export type ModelIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export type CreateEntityUserInput = {
  entityId: string,
  userId: string,
  firstName?: string | null,
  lastName?: string | null,
  email?: string | null,
  jobTags?: Array< JobTags | null > | null,
  role?: CreateEntityUserRole | null,
  paymentsEnabled?: boolean | null,
};

export enum CreateEntityUserRole {
  ADMIN = "ADMIN",
  ACCOUNTANT = "ACCOUNTANT",
  CONTRIBUTOR = "CONTRIBUTOR",
}


export type UpdateEntityUserInput = {
  entityId: string,
  userId: string,
  firstName?: string | null,
  lastName?: string | null,
  email?: string | null,
  paymentsEnabled?: boolean | null,
  taskSendSMS?: boolean | null,
  clientGroupCode?: string | null,
  clientCode?: string | null,
  jobTags?: Array< JobTags | null > | null,
  partnerId?: string | null,
  managerId?: string | null,
  linkingEntityId?: string | null,
  linkingUserId?: string | null,
  archivedAt?: string | null,
};

export type AcceptDenyEntityUserStatusInput = {
  entityId: string,
  status: EntityUserStatus,
};

export type sendReferralInvitationEmailInput = {
  email: Array< string >,
};

export type DeleteEntityUserInput = {
  entityId: string,
  userId: string,
};

export type CreateServiceInput = {
  entityId: string,
  title?: string | null,
  description?: string | null,
  amount: number,
  feeType?: FeeType | null,
  taxType: TaxType,
};

export enum FeeType {
  FIXED = "FIXED",
  HOURLY = "HOURLY",
}


export type Service = {
  __typename: "Service",
  id: string,
  entityId: string,
  title?: string | null,
  description?: string | null,
  amount: number,
  feeType?: FeeType | null,
  taxType: TaxType,
  searchName?: string | null,
  status: ServiceStatus,
  createdAt: string,
  updatedAt: string,
};

export enum ServiceStatus {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
}


export type UpdateServiceInput = {
  id: string,
  title?: string | null,
  description?: string | null,
  amount?: number | null,
  feeType?: FeeType | null,
  taxType?: TaxType | null,
  status?: ServiceStatus | null,
};

export type CreateTemplateInput = {
  entityId: string,
  title: string,
  templateJson?: string | null,
  templateHtml?: string | null,
  status: TemplateStatus,
  includeLetterhead?: boolean | null,
};

export enum TemplateStatus {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
}


export type Template = {
  __typename: "Template",
  id: string,
  entityId: string,
  title: string,
  searchName?: string | null,
  templateJson?: string | null,
  templateHtml?: string | null,
  status: TemplateStatus,
  canDelete?: boolean | null,
  type: TemplateType,
  includeLetterhead?: boolean | null,
  createdAt: string,
  updatedAt: string,
};

export enum TemplateType {
  TAX_BINDING = "TAX_BINDING",
  BAS = "BAS",
  ITR = "ITR",
  IAS = "IAS",
  PAYG = "PAYG",
  FBT = "FBT",
  CUSTOM = "CUSTOM",
  LETTERHEAD = "LETTERHEAD",
}


export type UpdateTemplateInput = {
  id: string,
  title?: string | null,
  templateJson?: string | null,
  templateHtml?: string | null,
  includeLetterhead?: boolean | null,
};

export type CreateNotificationInput = {
  title?: string | null,
  message?: string | null,
  status?: NotificationStatus | null,
  type?: string | null,
  owner: string,
};

export enum NotificationStatus {
  UNREAD = "UNREAD",
  READ = "READ",
}


export type Notification = {
  __typename: "Notification",
  id: string,
  title?: string | null,
  message?: string | null,
  status?: NotificationStatus | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  type?: string | null,
  owner: string,
};

export type UpdateNotificationInput = {
  id: string,
  status: NotificationStatus,
};

export type CreateOptionInput = {
  name?: string | null,
  label: string,
  value: string,
  group?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  id?: string | null,
};

export type ModelOptionConditionInput = {
  name?: ModelStringInput | null,
  label?: ModelStringInput | null,
  value?: ModelStringInput | null,
  group?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelOptionConditionInput | null > | null,
  or?: Array< ModelOptionConditionInput | null > | null,
  not?: ModelOptionConditionInput | null,
};

export type Option = {
  __typename: "Option",
  name?: string | null,
  label: string,
  value: string,
  group?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  id: string,
};

export type UpdateOptionInput = {
  name?: string | null,
  label?: string | null,
  value?: string | null,
  group?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  id: string,
};

export type DeleteOptionInput = {
  id: string,
};

export type CreatePaymentInput = {
  entityId: string,
  paymentMethodId: string,
  billPayments: Array< BillsPaymentInput >,
  idempotencyKey?: string | null,
};

export type BillsPaymentInput = {
  id: string,
  paymentType: PaymentType,
  installments: number,
  scheduledAt: string,
  paymentFrequency?: PaymentFrequency | null,
  isUnlimitedRecurring?: boolean | null,
  entityId: string,
};

export enum PaymentType {
  PAY_NOW = "PAY_NOW",
  SCHEDULED = "SCHEDULED",
  INSTALLMENTS = "INSTALLMENTS",
}


export type Payment = {
  __typename: "Payment",
  id: string,
  paymentIntentId?: string | null,
  taskId?: string | null,
  entityId?: string | null,
  payInPaymentId?: string | null,
  providerTransactionId?: string | null,
  paymentProvider?: PaymentProvider | null,
  disbursementId?: string | null,
  fromId: string,
  fromType: FromToType,
  toId?: string | null,
  toType?: FromToType | null,
  buyerId?: string | null,
  sellerId?: string | null,
  entityIdTo?: string | null,
  amount?: number | null,
  netAmount?: number | null,
  payerFees?: number | null,
  totalAmount?: number | null,
  gstAmount?: number | null,
  installment?: number | null,
  installments?: number | null,
  feeAmount?: number | null,
  reference?: string | null,
  paymentType?: PaymentType | null,
  taxAmount?: number | null,
  currency?: string | null,
  feeIds?: Array< string | null > | null,
  ipAddress?: string | null,
  status: PaymentStatus,
  payerUserStatus?: PayerUserStatus | null,
  declinedReason?: string | null,
  isUnlimitedRecurring?: boolean | null,
  payoutFailureReason?: string | null,
  payoutFailureFields?: Array< string | null > | null,
  payoutDetails?: PayoutDetails | null,
  scheduledAt?: string | null,
  paidAt?: string | null,
  declinedAt?: string | null,
  createdAt?: string | null,
  receivedAt?: string | null,
  paidOutAt?: string | null,
  updatedAt?: string | null,
  voidedAt?: string | null,
  owner?: string | null,
  payoutFailedAt?: string | null,
};

export enum PaymentProvider {
  ZAI = "ZAI",
  AIRWALLEX = "AIRWALLEX",
  APP_STORE = "APP_STORE",
  GOOGLE_PLAY = "GOOGLE_PLAY",
}


export enum FromToType {
  ENTITY = "ENTITY",
  CONTACT = "CONTACT",
}


export enum PaymentStatus {
  GUEST_SCHEDULED = "GUEST_SCHEDULED",
  SCHEDULED = "SCHEDULED",
  PENDING_USER_CONFIRMATION = "PENDING_USER_CONFIRMATION",
  PENDING_PAYTO_AGREEMENT_CREATION = "PENDING_PAYTO_AGREEMENT_CREATION",
  REJECTED_PAYTO_PAYMENT_RETRYABLE = "REJECTED_PAYTO_PAYMENT_RETRYABLE",
  REJECTED_PAYTO_PAYMENT_NOT_RETRYABLE = "REJECTED_PAYTO_PAYMENT_NOT_RETRYABLE",
  PENDING_PAYID_TRANSFER = "PENDING_PAYID_TRANSFER",
  RECEIVED_PAYID_TRANSFER = "RECEIVED_PAYID_TRANSFER",
  PENDING_PAYMENT_INITIATION = "PENDING_PAYMENT_INITIATION",
  PAYMENT_INITIATION_REJECTED = "PAYMENT_INITIATION_REJECTED",
  USER_CONFIRMED = "USER_CONFIRMED",
  DECLINED = "DECLINED",
  PENDING = "PENDING",
  PAYMENT_REQUIRED = "PAYMENT_REQUIRED",
  WIRE_PENDING = "WIRE_PENDING",
  PAYMENT_PENDING = "PAYMENT_PENDING",
  PAYMENT_HELD = "PAYMENT_HELD",
  PAYMENT_AUTHORIZED = "PAYMENT_AUTHORIZED",
  VOID_PENDING = "VOID_PENDING",
  VOIDED = "VOIDED",
  FRAUD_HOLD = "FRAUD_HOLD",
  PAYMENT_DEPOSITED = "PAYMENT_DEPOSITED",
  WORK_COMPLETED = "WORK_COMPLETED",
  PROBLEM_FLAGGED = "PROBLEM_FLAGGED",
  PROBLEM_RESOLVE_REQUESTED = "PROBLEM_RESOLVE_REQUESTED",
  PROBLEM_ESCALATED = "PROBLEM_ESCALATED",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
  REFUNDED = "REFUNDED",
  REFUND_PENDING = "REFUND_PENDING",
  REFUND_FLAGGED = "REFUND_FLAGGED",
  OFF_PLATFORM_REFUNDED = "OFF_PLATFORM_REFUNDED",
  PARTIAL_COMPLETED = "PARTIAL_COMPLETED",
  PARTIAL_PAID = "PARTIAL_PAID",
  OFF_PLATFORM_CHARGEDBACK = "OFF_PLATFORM_CHARGEDBACK",
  REQUIRES_PAYMENT_METHOD = "REQUIRES_PAYMENT_METHOD",
  REQUIRES_CUSTOMER_ACTION = "REQUIRES_CUSTOMER_ACTION",
  REQUIRES_CAPTURE = "REQUIRES_CAPTURE",
  SUCCEEDED = "SUCCEEDED",
  PAYOUT_SCHEDULED = "PAYOUT_SCHEDULED",
  PAYOUT_PROCESSING = "PAYOUT_PROCESSING",
  PAYOUT_SENT = "PAYOUT_SENT",
  PAYOUT_FAILED = "PAYOUT_FAILED",
}


export enum PayerUserStatus {
  USER = "USER",
  NON_USER = "NON_USER",
}


export type PayoutDetails = {
  __typename: "PayoutDetails",
  bank?: ContactBankAccount | null,
  bpay?: ContactBpay | null,
};

export type CreatePaymentPayIdInput = {
  entityId: string,
  billPayments: Array< BillsPaymentInput >,
  idempotencyKey?: string | null,
};

export type PayInPayment = {
  __typename: "PayInPayment",
  id: string,
  entityId: string,
  amount?: number | null,
  paymentType?: PaymentType | null,
  status?: PayInPaymentStatus | null,
  taskPayments:  Array<TaskPayment >,
  scheduledAt?: string | null,
  createdBy?: string | null,
  paymentUserId?: string | null,
  receivedAt?: string | null,
  paidOutAt?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum PayInPaymentStatus {
  PENDING_PAYID_TRANSFER = "PENDING_PAYID_TRANSFER",
  RECEIVED_PAYID_TRANSFER = "RECEIVED_PAYID_TRANSFER",
  PAID_OUT_PAYID_TRANSFER = "PAID_OUT_PAYID_TRANSFER",
}


export type TaskPayment = {
  __typename: "TaskPayment",
  id: string,
  paymentType: PaymentType,
  installments: number,
  scheduledAt: string,
};

export type CancelPaymentPayIdInput = {
  id: string,
};

export type RetryPaymentInput = {
  id: string,
  paymentMethodId: string,
};

export type CreateTaskPaymentInput = {
  taskId: string,
  entityId: string,
  paymentMethodId: string,
};

export type CreatePaymentMethodInput = {
  entityId: string,
  paymentMethodId: string,
  paymentMethodType: PaymentMethodType,
  accountDirection?: AccountDirection | null,
};

export type UpdatePaymentMethodInput = {
  id: string,
  status?: PaymentMethodStatus | null,
};

export type CreatePushNotificationInput = {
  starId?: string | null,
  title?: string | null,
  message?: string | null,
};

export type CreateSignatureInput = {
  key: string,
};

export type Signature = {
  __typename: "Signature",
  id: string,
  userId: string,
  key: string,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteSignatureInput = {
  userId: string,
  createdAt: string,
};

export type CreateDocumentAnalysisDocumentUrlInput = {
  documentAnalysisId: string,
};

export type TaskDocumentUrl = {
  __typename: "TaskDocumentUrl",
  url?: string | null,
  expiresAt?: string | null,
};

export type AcceptQuoteInput = {
  token: string,
  annotations?: string | null,
  quoteStatus?: UpdateTaskQuotePublicStatus | null,
};

export enum UpdateTaskQuotePublicStatus {
  ACCEPTED = "ACCEPTED",
  DECLINED = "DECLINED",
}


export type AcceptedQuote = {
  __typename: "AcceptedQuote",
  token?: string | null,
  updatedTask: TaskGuest,
};

export type TaskGuest = {
  __typename: "TaskGuest",
  id: string,
  entityId: string,
  amount?: number | null,
  taxAmount?: number | null,
  annotations?: string | null,
  documentType?: DocumentType | null,
  subCategory?: string | null,
  fromId: string,
  linkedTaskId?: string | null,
  futureLinkedTask?: FutureTaskGuest | null,
  firm?: EntityGuest | null,
  fromEntity?: EntityGuest | null,
  from?: EntityGuest | null,
  fromContact?: ContactGuest | null,
  fromType?: FromToType | null,
  toEntity?: EntityGuest | null,
  toContact?: ContactGuest | null,
  toId?: string | null,
  to?: EntityGuest | null,
  toType?: FromToType | null,
  isFinalSigner?: boolean | null,
  status: TaskStatus,
  signatureStatus?: TaskSignatureStatus | null,
  paymentStatus?: TaskPaymentStatus | null,
  quoteStatus?: TaskQuoteStatus | null,
  invoiceStatus?: InvoiceStatus | null,
  settlementStatus?: TaskSettlementStatus | null,
  type: TaskType,
  category?: TaskCategory | null,
  documents?:  Array<S3Upload | null > | null,
  supportDocuments?:  Array<S3Upload | null > | null,
  numberOfPayments?: number | null,
  paymentFrequency?: PaymentFrequency | null,
  paymentTypes: Array< PaymentType | null >,
  reference?: string | null,
  bpayReferenceNumber?: string | null,
  createdBy: string,
  gstInclusive?: boolean | null,
  entityIdBy?: string | null,
  dueAt: string,
  issuedAt?: string | null,
  notes?: string | null,
  direction?: TaskDirection | null,
  paymentAt?: string | null,
  lodgementAt?: string | null,
  readAt?: string | null,
  paidAt?: string | null,
  quoteAcceptedAt?: string | null,
  completedAt?: string | null,
  owner?: string | null,
  metaHashData?: string | null,
  automaticGenerateInvoice?: boolean | null,
  automaticInvoicePaymentAt?: string | null,
  automaticInvoicePaymentTerms?: PaymentTerms | null,
  quoteRequiresSignature?: boolean | null,
  automaticallyGeneratedFromQuote?: boolean | null,
  termsFirmPayTaxAccepted?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  token?: string | null,
  period?: string | null,
  year?: string | null,
};

export type FutureTaskGuest = {
  __typename: "FutureTaskGuest",
  fromId: string,
  fromType: FromToType,
  from?: EntityGuest | null,
  toId?: string | null,
  toType?: FromToType | null,
  to?: EntityGuest | null,
  numberOfPayments?: number | null,
  paymentFrequency?: PaymentFrequency | null,
  reference: string,
  bpayReferenceNumber?: string | null,
  amount?: number | null,
  gstInclusive?: boolean | null,
  lineItems?:  Array<LineItem | null > | null,
  isUnlimitedRecurring?: boolean | null,
  direction?: TaskDirection | null,
  invoiceStatus?: InvoiceStatus | null,
  dueAt: string,
  paymentAt?: string | null,
  lodgementAt?: string | null,
};

export type EntityGuest = {
  __typename: "EntityGuest",
  id: string,
  name: string,
  taxNumber?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type LineItem = {
  __typename: "LineItem",
  serviceId?: string | null,
  description: string,
  quantity: number,
  unitAmount: number,
  taxType: TaxType,
  lineAmount?: number | null,
  newService?: boolean | null,
};

export enum TaskDirection {
  SENDING = "SENDING",
  RECEIVING = "RECEIVING",
}


export enum InvoiceStatus {
  INVOICE = "INVOICE",
  QUOTE = "QUOTE",
}


export type ContactGuest = {
  __typename: "ContactGuest",
  id: string,
  firstName?: string | null,
  lastName?: string | null,
  name?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum TaskStatus {
  DRAFT = "DRAFT",
  REVIEW = "REVIEW",
  INCOMPLETE = "INCOMPLETE",
  SCHEDULED = "SCHEDULED",
  SCHEDULED_RECURRING = "SCHEDULED_RECURRING",
  COMPLETED = "COMPLETED",
  ARCHIVED = "ARCHIVED",
  ACCEPTED = "ACCEPTED",
  VOIDED = "VOIDED",
}


export enum TaskSignatureStatus {
  MARKED_AS_SIGNED = "MARKED_AS_SIGNED",
  PENDING_SIGNATURE = "PENDING_SIGNATURE",
  SIGNED = "SIGNED",
  NOT_SIGNABLE = "NOT_SIGNABLE",
}


export enum TaskPaymentStatus {
  PENDING_PAYMENT = "PENDING_PAYMENT",
  PENDING_TRANSFER = "PENDING_TRANSFER",
  PENDING_PAYTO_AGREEMENT_CREATION = "PENDING_PAYTO_AGREEMENT_CREATION",
  PENDING_PAYID_TRANSFER = "PENDING_PAYID_TRANSFER",
  PAYTO_AGREEMENT_DECLINED = "PAYTO_AGREEMENT_DECLINED",
  SCHEDULED = "SCHEDULED",
  PAYID_SCHEDULED = "PAYID_SCHEDULED",
  PAYTO_SCHEDULED = "PAYTO_SCHEDULED",
  PAID = "PAID",
  DECLINED = "DECLINED",
  NOT_PAYABLE = "NOT_PAYABLE",
  MARKED_AS_PAID = "MARKED_AS_PAID",
  MARKED_AS_COMPLETED = "MARKED_AS_COMPLETED",
  PAYOUT_FAILED = "PAYOUT_FAILED",
}


export enum TaskQuoteStatus {
  ARCHIVED = "ARCHIVED",
  DECLINED = "DECLINED",
  PENDING_ACCEPTANCE = "PENDING_ACCEPTANCE",
  ACCEPTED = "ACCEPTED",
  MARKED_AS_ACCEPTED = "MARKED_AS_ACCEPTED",
}


export enum TaskType {
  SIGN_PAY = "SIGN_PAY",
  SIGN_ONLY = "SIGN_ONLY",
  PAY_ONLY = "PAY_ONLY",
  QUOTE = "QUOTE",
  DOCUMENT = "DOCUMENT",
}


export enum PaymentTerms {
  IMMEDIATE = "IMMEDIATE",
  THREE_DAYS = "THREE_DAYS",
  ONE_WEEK = "ONE_WEEK",
  FORTNIGHT = "FORTNIGHT",
  MONTH = "MONTH",
}


export type CreateTaskInput = {
  documentAnalysisId?: string | null,
  fromId: string,
  fromType: FromToType,
  toId?: string | null,
  bindingId?: string | null,
  toType?: FromToType | null,
  type: TaskType,
  direction: TaskDirection,
  invoiceStatus?: InvoiceStatus | null,
  documents?: Array< S3UploadInput | null > | null,
  emailMessage?: string | null,
  supportDocuments?: Array< S3UploadInput | null > | null,
  numberOfPayments?: number | null,
  paymentFrequency?: PaymentFrequency | null,
  paymentTypes?: Array< PaymentType | null > | null,
  maximumInstallments?: number | null,
  reference: string,
  bpayReferenceNumber?: string | null,
  amount?: number | null,
  taxAmount?: number | null,
  gstAmount?: number | null,
  notes?: string | null,
  settlementStatus?: TaskSettlementStatus | null,
  signers?: Array< SignerInput | null > | null,
  otherRecipients?: Array< OtherRecipientInput | null > | null,
  annotations?: string | null,
  status?: CreateTaskStatus | null,
  gstInclusive?: boolean | null,
  lineItems?: Array< LineItemInput | null > | null,
  isUnlimitedRecurring?: boolean | null,
  automaticGenerateInvoice?: boolean | null,
  automaticInvoicePaymentAt?: string | null,
  automaticInvoicePaymentTerms?: PaymentTerms | null,
  quoteRequiresSignature?: boolean | null,
  automaticallyGeneratedFromQuote?: boolean | null,
  sendSMS?: boolean | null,
  sendTemplate?: boolean | null,
  includeLetterhead?: boolean | null,
  templateJson?: string | null,
  templateHtml?: string | null,
  documentType?: DocumentType | null,
  subCategory?: string | null,
  dueAt: string,
  issuedAt?: string | null,
  paymentAt?: string | null,
  lodgementAt?: string | null,
  futureLinkedTask?: FutureTaskInput | null,
  period?: string | null,
  year?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type S3UploadInput = {
  identityId?: string | null,
  key: string,
  level: S3UploadLevel,
  type: S3UploadType,
  name?: string | null,
};

export type SignerInput = {
  userId?: string | null,
  signerType?: SignerType | null,
};

export enum SignerType {
  ACCOUNTANT = "ACCOUNTANT",
  ENTITY_USER = "ENTITY_USER",
  CONTACT = "CONTACT",
  GUEST = "GUEST",
}


export type OtherRecipientInput = {
  email: string,
  sendOnCompletion: boolean,
};

export enum CreateTaskStatus {
  REVIEW = "REVIEW",
  DRAFT = "DRAFT",
}


export type LineItemInput = {
  serviceId?: string | null,
  description?: string | null,
  quantity?: number | null,
  unitAmount?: number | null,
  taxType?: TaxType | null,
  lineAmount?: number | null,
  newService?: boolean | null,
};

export type FutureTaskInput = {
  fromId: string,
  fromType?: FromToType | null,
  toId?: string | null,
  toType?: FromToType | null,
  numberOfPayments?: number | null,
  paymentFrequency?: PaymentFrequency | null,
  reference: string,
  bpayReferenceNumber?: string | null,
  amount?: number | null,
  gstInclusive?: boolean | null,
  lineItems?: Array< LineItemInput | null > | null,
  isUnlimitedRecurring?: boolean | null,
  direction?: TaskDirection | null,
  invoiceStatus?: InvoiceStatus | null,
  dueAt: string,
  paymentAt?: string | null,
  lodgementAt?: string | null,
};

export type Task = {
  __typename: "Task",
  entityId: string,
  taskNumber?: string | null,
  invoiceStatus?: InvoiceStatus | null,
  agreementUuid?: string | null,
  documentType?: DocumentType | null,
  subCategory?: string | null,
  id: string,
  linkedTaskId?: string | null,
  managerId?: string | null,
  partnerId?: string | null,
  bindingId?: string | null,
  futureLinkedTask?: FutureTask | null,
  documentAnalysisId?: string | null,
  activity?: ModelActivityConnection | null,
  amount?: number | null,
  taxAmount?: number | null,
  annotations?: string | null,
  entityIdFrom?: string | null,
  fromId: string,
  fromType: FromToType,
  toId?: string | null,
  toType?: FromToType | null,
  firmId?: string | null,
  entityIdTo?: string | null,
  contactIdFrom?: string | null,
  contactIdTo?: string | null,
  contactId?: string | null,
  entityByIdContactId?: string | null,
  firmByIdContactId?: string | null,
  firmById?: string | null,
  searchName?: string | null,
  status: TaskStatus,
  quoteStatus?: TaskQuoteStatus | null,
  signatureStatus?: TaskSignatureStatus | null,
  paymentStatus?: TaskPaymentStatus | null,
  type: TaskType,
  category?: TaskCategory | null,
  documents?:  Array<S3Upload | null > | null,
  emailMessage?: string | null,
  supportDocuments?:  Array<S3Upload | null > | null,
  numberOfPayments?: number | null,
  paymentFrequency?: PaymentFrequency | null,
  paymentTypes: Array< PaymentType | null >,
  maximumInstallments?: number | null,
  reference?: string | null,
  bpayReferenceNumber?: string | null,
  settlementStatus?: TaskSettlementStatus | null,
  signers?:  Array<EntityUser | null > | null,
  otherRecipients?:  Array<OtherRecipient | null > | null,
  payments?: ModelPaymentConnection | null,
  createdBy: string,
  entityIdBy?: string | null,
  dueAt: string,
  issuedAt?: string | null,
  notes?: string | null,
  reviewerFeedback?:  Array<ReviewerFeedback | null > | null,
  direction?: TaskDirection | null,
  readBy?: Array< string | null > | null,
  gstInclusive?: boolean | null,
  isUnlimitedRecurring?: boolean | null,
  owner?: string | null,
  lineItems?:  Array<LineItem | null > | null,
  xeroTenantId?: string | null,
  sendSMS?: boolean | null,
  automaticGenerateInvoice?: boolean | null,
  automaticInvoicePaymentAt?: string | null,
  automaticInvoicePaymentTerms?: PaymentTerms | null,
  quoteRequiresSignature?: boolean | null,
  automaticallyGeneratedFromQuote?: boolean | null,
  sendTemplate?: boolean | null,
  includeLetterhead?: boolean | null,
  templateJson?: string | null,
  templateHtml?: string | null,
  paymentAt?: string | null,
  lodgementAt?: string | null,
  period?: string | null,
  year?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  viewedAt?: string | null,
  readAt?: string | null,
  paidAt?: string | null,
  endAt?: string | null,
  quoteAcceptedAt?: string | null,
  completedAt?: string | null,
  payoutErrors?: Array< string | null > | null,
};

export type FutureTask = {
  __typename: "FutureTask",
  fromId: string,
  fromType: FromToType,
  toId?: string | null,
  toType?: FromToType | null,
  numberOfPayments?: number | null,
  paymentFrequency?: PaymentFrequency | null,
  reference: string,
  bpayReferenceNumber?: string | null,
  amount?: number | null,
  gstInclusive?: boolean | null,
  lineItems?:  Array<LineItem | null > | null,
  isUnlimitedRecurring?: boolean | null,
  direction?: TaskDirection | null,
  invoiceStatus?: InvoiceStatus | null,
  dueAt: string,
  paymentAt?: string | null,
  lodgementAt?: string | null,
};

export type ModelActivityConnection = {
  __typename: "ModelActivityConnection",
  items:  Array<Activity | null >,
  nextToken?: string | null,
};

export type Activity = {
  __typename: "Activity",
  id: string,
  compositeId: string,
  userId?: string | null,
  entityId?: string | null,
  type: ActivityType,
  message?: string | null,
  metadata?: ActivityMetadata | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum ActivityType {
  TASK = "TASK",
  REWARD = "REWARD",
}


export type ActivityMetadata = {
  __typename: "ActivityMetadata",
  name?: string | null,
  email?: string | null,
};

export type OtherRecipient = {
  __typename: "OtherRecipient",
  email: string,
  sendOnCompletion: boolean,
};

export type ModelPaymentConnection = {
  __typename: "ModelPaymentConnection",
  items:  Array<Payment | null >,
  nextToken?: string | null,
};

export type ReviewerFeedback = {
  __typename: "ReviewerFeedback",
  reviewedById: string,
  feedback: string,
  status: ReviewerFeedbackStatus,
  createdAt: string,
};

export enum ReviewerFeedbackStatus {
  PENDING = "PENDING",
  ACTIONED = "ACTIONED",
}


export type CreateBindingTaskInput = {
  tasks?: Array< CreateTaskInput > | null,
  sendTemplate?: boolean | null,
  sendSMS?: boolean | null,
  templateJson?: string | null,
  templateHtml?: string | null,
  includeLetterhead?: boolean | null,
  status?: BindingStatus | null,
  emailMessage?: string | null,
};

export enum BindingStatus {
  REVIEW = "REVIEW",
  DRAFT = "DRAFT",
  SENT = "SENT",
}


export type UpdateBindingTaskInput = {
  id: string,
  status?: BindingStatus | null,
  sendTemplate?: boolean | null,
  sendSMS?: boolean | null,
  emailMessage?: string | null,
};

export type Binding = {
  __typename: "Binding",
  id: string,
  sendTemplate?: boolean | null,
  sendSMS?: boolean | null,
  status?: BindingStatus | null,
  emailMessage?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  documents?:  Array<S3Upload | null > | null,
};

export type UpdateTaskInput = {
  id: string,
  entityId: string,
  bindingId?: string | null,
  paymentStatus?: UpdateTaskPaymentStatus | null,
  signatureStatus?: UpdateTaskSignatureStatus | null,
  quoteStatus?: UpdateTaskQuoteStatus | null,
  status?: UpdateTaskStatus | null,
  invoiceStatus?: InvoiceStatus | null,
  annotations?: string | null,
  amount?: number | null,
  taxAmount?: number | null,
  fromId?: string | null,
  fromType?: FromToType | null,
  toId?: string | null,
  toType?: FromToType | null,
  direction?: TaskDirection | null,
  type?: TaskType | null,
  documents?: Array< S3UploadInput | null > | null,
  emailMessage?: string | null,
  sendSMS?: boolean | null,
  supportDocuments?: Array< S3UploadInput | null > | null,
  paymentTypes?: Array< PaymentType | null > | null,
  maximumInstallments?: number | null,
  paymentFrequency?: PaymentFrequency | null,
  settlementStatus?: TaskSettlementStatus | null,
  numberOfPayments?: number | null,
  reference?: string | null,
  bpayReferenceNumber?: string | null,
  gstAmount?: number | null,
  notes?: string | null,
  reviewerFeedback?: Array< ReviewerFeedbackInput | null > | null,
  signers?: Array< SignerInput | null > | null,
  otherRecipients?: Array< OtherRecipientInput | null > | null,
  gstInclusive?: boolean | null,
  isUnlimitedRecurring?: boolean | null,
  automaticGenerateInvoice?: boolean | null,
  automaticInvoicePaymentAt?: string | null,
  automaticInvoicePaymentTerms?: PaymentTerms | null,
  quoteRequiresSignature?: boolean | null,
  automaticallyGeneratedFromQuote?: boolean | null,
  sendTemplate?: boolean | null,
  includeLetterhead?: boolean | null,
  templateJson?: string | null,
  templateHtml?: string | null,
  documentType?: DocumentType | null,
  subCategory?: string | null,
  dueAt?: string | null,
  issuedAt?: string | null,
  paymentAt?: string | null,
  lodgementAt?: string | null,
  lineItems?: Array< LineItemInput | null > | null,
  futureLinkedTask?: FutureTaskInput | null,
  period?: string | null,
  year?: string | null,
  payoutErrors?: Array< string | null > | null,
};

export enum UpdateTaskPaymentStatus {
  MARKED_AS_PAID = "MARKED_AS_PAID",
  PENDING_PAYMENT = "PENDING_PAYMENT",
  MARKED_AS_COMPLETED = "MARKED_AS_COMPLETED",
}


export enum UpdateTaskSignatureStatus {
  MARKED_AS_SIGNED = "MARKED_AS_SIGNED",
  SIGNED = "SIGNED",
}


export enum UpdateTaskQuoteStatus {
  MARKED_AS_ACCEPTED = "MARKED_AS_ACCEPTED",
  PENDING_ACCEPTANCE = "PENDING_ACCEPTANCE",
}


export enum UpdateTaskStatus {
  INCOMPLETE = "INCOMPLETE",
  DRAFT = "DRAFT",
  REVIEW = "REVIEW",
  ARCHIVED = "ARCHIVED",
  VOIDED = "VOIDED",
}


export type ReviewerFeedbackInput = {
  reviewedById: string,
  feedback: string,
  status: ReviewerFeedbackStatus,
  createdAt: string,
};

export type UpdateTaskPublicInput = {
  token: string,
  annotations?: string | null,
  quoteStatus?: UpdateTaskQuotePublicStatus | null,
  paymentStatus?: UpdateTaskPaymentPublicStatus | null,
};

export enum UpdateTaskPaymentPublicStatus {
  MARKED_AS_PAID = "MARKED_AS_PAID",
}


export type CreateTaskDocumentUrlInput = {
  taskId: string,
  entityId: string,
};

export type CreateTaskDocumentUrlGuestInput = {
  token: string,
};

export type CreateTaskViewedGuestInput = {
  token: string,
};

export type CreateTaskSupportDocumentUrlInput = {
  taskId: string,
  entityId: string,
  key: string,
};

export type CreateTaskSupportDocumentUrlGuestInput = {
  token: string,
  key: string,
};

export type CreateBindingTemplateUrlGuestInput = {
  token: string,
};

export type GenerateHashInput = {
  taskId: string,
  entityId: string,
  paymentId?: string | null,
  resend?: boolean | null,
};

export type GenerateSignatureUrlInput = {
  taskId: string,
  entityId: string,
  signerId: string,
  resend?: boolean | null,
};

export type CreateUploadTaskUrlGuestInput = {
  token: string,
};

export type TaskDocumentUploadUrl = {
  __typename: "TaskDocumentUploadUrl",
  url?: string | null,
};

export type CreateUploadTaskUrlInput = {
  id: string,
  entityId: string,
};

export type UpdateUserInput = {
  id: string,
  about?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  country?: string | null,
  profileImg?: ImageInput | null,
  interests?: Array< string | null > | null,
  locale?: string | null,
  onboardingStatus?: OnboardingStatus | null,
  onboardingEntity?: string | null,
  userType?: UserType | null,
  notificationPreferences?: NotificationPreferencesInput | null,
  selectedSignatureKey?: string | null,
  selectedEntityId?: string | null,
  email?: string | null,
  phone?: string | null,
};

export enum OnboardingStatus {
  PROFILE = "PROFILE",
  BUSINESS = "BUSINESS",
  PLANS = "PLANS",
  COMPLETED = "COMPLETED",
}


export enum UserType {
  Buyers = "Buyers",
  Sellers = "Sellers",
}


export type NotificationPreferencesInput = {
  email?: boolean | null,
  push?: boolean | null,
  sms?: boolean | null,
};

export type User = {
  __typename: "User",
  id: string,
  identityId?: string | null,
  referralCode?: string | null,
  referredBy?: string | null,
  email?: string | null,
  about?: string | null,
  firstName?: string | null,
  firmId?: string | null,
  lastName?: string | null,
  phone?: string | null,
  blocked?: Array< string | null > | null,
  blockedBy?: Array< string | null > | null,
  country?: string | null,
  profileImg?: Image | null,
  interests?: Array< string | null > | null,
  locale?: string | null,
  onboardingStatus?: OnboardingStatus | null,
  onboardingEntity?: string | null,
  selectedEntityId?: string | null,
  selectedSignatureKey?: string | null,
  signatures?: ModelSignatureConnection | null,
  userType?: UserType | null,
  rating?: number | null,
  reportReasons?: Array< string | null > | null,
  notificationPreferences?: NotificationPreferences | null,
  paymentUserId?: string | null,
  providerWalletId?: string | null,
  providerNppCrn?: string | null,
  ipAddress?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  owner?: string | null,
  loyaltyStatus?: RewardStatus | null,
  nextLoyaltyStatus?: RewardStatus | null,
  nextLoyaltyStatusPoint?: number | null,
  statusPoint?: number | null,
  pointsTotal?: number | null,
  pointsBalance?: number | null,
  invitedTo?: string | null,
};

export type ModelSignatureConnection = {
  __typename: "ModelSignatureConnection",
  items:  Array<Signature | null >,
  nextToken?: string | null,
};

export type NotificationPreferences = {
  __typename: "NotificationPreferences",
  email?: boolean | null,
  push?: boolean | null,
  sms?: boolean | null,
};

export enum RewardStatus {
  BRONZE = "BRONZE",
  SILVER = "SILVER",
  GOLD = "GOLD",
  PLATINUM = "PLATINUM",
  DIAMOND = "DIAMOND",
}


export type BlockUserInput = {
  userId?: string | null,
  reason?: ReportReason | null,
};

export enum ReportReason {
  SPAM = "SPAM",
  OFFENSIVE = "OFFENSIVE",
}


export type XeroCreateConsentUrlInput = {
  xeroEnv?: XeroEnv | null,
  scopeSet: XeroScopeSet,
};

export enum XeroEnv {
  LOCAL = "LOCAL",
}


export enum XeroScopeSet {
  PROFILE = "PROFILE",
  ACCOUNTING = "ACCOUNTING",
  CONTACTS = "CONTACTS",
}


export type XeroCreateContactSyncInput = {
  entityId: string,
};

export type XeroCreateInvoiceSyncInput = {
  entityId: string,
};

export type xeroCreateTenantsConnectInput = {
  url: string,
  xeroEnv?: XeroEnv | null,
  scopeSet: XeroScopeSet,
  entityId: string,
};

export type XeroGetProfileInput = {
  url: string,
};

export type XeroDisconnectInput = {
  entityId: string,
};

export type EmailCreateConsentUrlInput = {
  provider: string,
};

export type CreateBeneficiaryInput = {
  entityId: string,
  accountName: string,
  accountNumber: string,
  routingNumber: string,
};

export type CreatePaymentIntentInput = {
  entityId: string,
  taskId: string,
  paymentId?: string | null,
};

export type UpdatePaymentIntentInput = {
  intentId: string,
  taskId: string,
  entityId: string,
};

export type CreatePaymentIntentGuestInput = {
  entityId: string,
  taskId: string,
  paymentId?: string | null,
  billPayments?: Array< BillsPaymentInput > | null,
};

export type GetAuthCodeInput = {
  codeChallenge: string,
  entityId: string,
  type: AuthCodeType,
};

export enum AuthCodeType {
  KYC = "KYC",
  KYB = "KYB",
  KYCRFI = "KYCRFI",
}


export type AddFundsInWalletInput = {
  entityId: string,
  paymentMethodId: string,
  amount: number,
};

export type CapturePaymentIntentInput = {
  entityId: string,
  paymentMethodId?: string | null,
  intentId: string,
};

export type AmountTransferInput = {
  entityId: string,
  amount: number,
};

export type RetryPayoutTransferInput = {
  id: string,
};

export type ResendRemittenceInput = {
  id: string,
};

export type NotifyClientInput = {
  entityId: string,
};

export type ABNInformation = {
  __typename: "ABNInformation",
  abn: string,
  abnStatus: string,
  abnStatusEffectiveFrom: string,
  acn?: string | null,
  addressDate?: string | null,
  addressPostcode?: string | null,
  addressState?: string | null,
  businessName?: Array< string | null > | null,
  entityName?: string | null,
  entityTypeCode?: string | null,
  entityTypeName?: string | null,
  gst?: string | null,
  message?: string | null,
  type?: EntityType | null,
};

export type ModelAbrNameSearchInformationConnection = {
  __typename: "ModelAbrNameSearchInformationConnection",
  items:  Array<AbrNameSearchInformation | null >,
};

export type AbrNameSearchInformation = {
  __typename: "AbrNameSearchInformation",
  abn: string,
  abnStatus: string,
  isCurrent: boolean,
  name: string,
  nameType: string,
  postcode: string,
  state: string,
};

export enum AutocompleteType {
  ENTITY = "ENTITY",
  TAX = "TAX",
}


export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type ModelEntityFilterInput = {
  name?: ModelStringInput | null,
  searchName?: ModelStringInput | null,
  taxNumber?: ModelStringInput | null,
  address?: ModelStringInput | null,
  type?: ModelEntityTypeInput | null,
  owner?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelEntityFilterInput | null > | null,
  or?: Array< ModelEntityFilterInput | null > | null,
  not?: ModelEntityFilterInput | null,
};

export type ModelAutocompleteResultConnection = {
  __typename: "ModelAutocompleteResultConnection",
  items:  Array<AutocompleteResult | null >,
  nextToken?: string | null,
};

export type AutocompleteResult = {
  __typename: "AutocompleteResult",
  id: string,
  value: string,
  label: string,
  info?: string | null,
  type: AutocompleteType,
  searchName: string,
  metadata?: AutocompleteResultMetadata | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type AutocompleteResultMetadata = {
  __typename: "AutocompleteResultMetadata",
  subCategory?: string | null,
  payoutMethod?: PayoutMethod | null,
  billerCode?: number | null,
};

export enum PayoutMethod {
  BANK = "BANK",
  BPAY = "BPAY",
}


export type GetAutoCompleteResult = {
  __typename: "GetAutoCompleteResult",
  entity?: Entity | null,
  contact?: Contact | null,
};

export type ModelBillerConnection = {
  __typename: "ModelBillerConnection",
  items:  Array<Biller | null >,
  nextToken?: string | null,
};

export type Biller = {
  __typename: "Biller",
  billerCode?: number | null,
  shortName?: string | null,
  longName?: string | null,
  type?: BillerType | null,
};

export type ModelContactConnection = {
  __typename: "ModelContactConnection",
  items:  Array<Contact | null >,
  total?: number | null,
};

export type ModelDocumentAnalysisConnection = {
  __typename: "ModelDocumentAnalysisConnection",
  items:  Array<DocumentAnalysis | null >,
  nextToken?: string | null,
};

export type ModelOpenSearchEntityConnection = {
  __typename: "ModelOpenSearchEntityConnection",
  items:  Array<Entity | null >,
  total?: number | null,
};

export type ModelEntityUserOSConnection = {
  __typename: "ModelEntityUserOSConnection",
  items:  Array<EntityUser | null >,
  total?: number | null,
};

export type ModelNotificationFilterInput = {
  status?: NotificationStatusInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  type?: ModelStringInput | null,
  and?: Array< ModelNotificationFilterInput | null > | null,
  or?: Array< ModelNotificationFilterInput | null > | null,
  not?: ModelNotificationFilterInput | null,
};

export type NotificationStatusInput = {
  eq?: NotificationStatus | null,
  ne?: NotificationStatus | null,
};

export type ModelNotificationConnection = {
  __typename: "ModelNotificationConnection",
  items:  Array<Notification | null >,
  nextToken?: string | null,
};

export type ModelOptionFilterInput = {
  name?: ModelStringInput | null,
  label?: ModelStringInput | null,
  value?: ModelStringInput | null,
  group?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelOptionFilterInput | null > | null,
  or?: Array< ModelOptionFilterInput | null > | null,
  not?: ModelOptionFilterInput | null,
};

export type ModelOptionConnection = {
  __typename: "ModelOptionConnection",
  items:  Array<Option | null >,
  nextToken?: string | null,
};

export type ModelStringKeyConditionInput = {
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
};

export type PaymentGuest = {
  __typename: "PaymentGuest",
  id: string,
  entityId: string,
  taskId?: string | null,
  paymentIntentId?: string | null,
  amount?: number | null,
  installment?: number | null,
  installments?: number | null,
  feeAmount?: number | null,
  paymentType?: PaymentType | null,
  taxAmount?: number | null,
  currency?: string | null,
  feeId?: string | null,
  status: PaymentStatus,
  payerUserStatus?: PayerUserStatus | null,
  isUnlimitedRecurring?: boolean | null,
  scheduledAt?: string | null,
  paidAt?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  owner?: string | null,
};

export type ModelServiceFilterInput = {
  status?: ModelServiceStatusInput | null,
  searchName?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelServiceFilterInput | null > | null,
  or?: Array< ModelServiceFilterInput | null > | null,
  not?: ModelServiceFilterInput | null,
};

export type ModelServiceStatusInput = {
  eq?: ServiceStatus | null,
  ne?: ServiceStatus | null,
};

export type ModelServiceConnection = {
  __typename: "ModelServiceConnection",
  items?:  Array<Service | null > | null,
  nextToken?: string | null,
};

export type BindingTasksPublicResult = {
  __typename: "BindingTasksPublicResult",
  tasks:  Array<TaskGuest | null >,
  documents?:  Array<S3Upload | null > | null,
};

export enum TaskSearchStatus {
  INCOMPLETE = "INCOMPLETE",
  SCHEDULED = "SCHEDULED",
  COMPLETED = "COMPLETED",
  DRAFT = "DRAFT",
  REVIEW = "REVIEW",
  ARCHIVED = "ARCHIVED",
}


export enum TaskSearchType {
  ALL = "ALL",
  INVOICES = "INVOICES",
  QUOTES = "QUOTES",
  BILLS = "BILLS",
  TAX_BILLS = "TAX_BILLS",
  ESIGNATURE = "ESIGNATURE",
  DOCUMENTS = "DOCUMENTS",
}


export enum SearchTasksSortBy {
  dueAt = "dueAt",
  createdAt = "createdAt",
  issuedAt = "issuedAt",
  status = "status",
  amount = "amount",
}


export type ModelOpenSearchTaskConnection = {
  __typename: "ModelOpenSearchTaskConnection",
  items:  Array<Task | null >,
  total?: number | null,
};

export type TaskCounts = {
  __typename: "TaskCounts",
  ALL?: number | null,
  TAX_BILLS?: number | null,
  INVOICES?: number | null,
  QUOTES?: number | null,
  BILLS?: number | null,
  ESIGNATURE?: number | null,
};

export type TasksOverdueResponse = {
  __typename: "TasksOverdueResponse",
  TAX_BILLS?: TaskOverdueCounts | null,
  INVOICES?: TaskOverdueCounts | null,
  BILLS?: TaskOverdueCounts | null,
  ESIGNATURE?: TaskOverdueCounts | null,
};

export type TaskOverdueCounts = {
  __typename: "TaskOverdueCounts",
  tasks: number,
  clients: number,
  amount: number,
};

export type ModelTransactionOSConnection = {
  __typename: "ModelTransactionOSConnection",
  items:  Array<Transaction | null >,
  total?: number | null,
};

export type Transaction = {
  __typename: "Transaction",
  id: string,
  amount?: number | null,
  netAmount?: number | null,
  fee?: number | null,
  description?: string | null,
  status?: string | null,
  direction?: TransactionDirection | null,
  taskId?: string | null,
  entityId?: string | null,
  paymentId?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum TransactionDirection {
  PAYMENT = "PAYMENT",
  PAYOUT = "PAYOUT",
}


export type TaskNumber = {
  __typename: "TaskNumber",
  id?: string | null,
  invoice?: number | null,
  quote?: number | null,
};

export type ModelTemplateFilterInput = {
  status?: ModelTemplateStatusInput | null,
  searchName?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelTemplateFilterInput | null > | null,
  or?: Array< ModelTemplateFilterInput | null > | null,
  not?: ModelTemplateFilterInput | null,
};

export type ModelTemplateStatusInput = {
  eq?: TemplateStatus | null,
  ne?: TemplateStatus | null,
};

export type ModelTemplateConnection = {
  __typename: "ModelTemplateConnection",
  items?:  Array<Template | null > | null,
  nextToken?: string | null,
};

export type Translation = {
  __typename: "Translation",
  language: string,
  namespace: string,
  data?: string | null,
};

export type TranslationConnection = {
  __typename: "TranslationConnection",
  language?: string | null,
  items?:  Array<Translation | null > | null,
};

export type ModelUserFilterInput = {
  id?: ModelIDInput | null,
  identityId?: ModelIDInput | null,
  email?: ModelStringInput | null,
  about?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  phone?: ModelStringInput | null,
  blocked?: ModelStringInput | null,
  blockedBy?: ModelStringInput | null,
  country?: ModelStringInput | null,
  interests?: ModelStringInput | null,
  locale?: ModelStringInput | null,
  onboardingStatus?: ModelOnboardingStatusInput | null,
  onboardingEntity?: ModelIDInput | null,
  userType?: ModelUserTypeInput | null,
  reportReasons?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelUserFilterInput | null > | null,
  or?: Array< ModelUserFilterInput | null > | null,
  not?: ModelUserFilterInput | null,
};

export type ModelOnboardingStatusInput = {
  eq?: OnboardingStatus | null,
  ne?: OnboardingStatus | null,
};

export type ModelUserTypeInput = {
  eq?: UserType | null,
  ne?: UserType | null,
};

export type ModelUserConnection = {
  __typename: "ModelUserConnection",
  items:  Array<User | null >,
  nextToken?: string | null,
};

export type ModelActivityFilterInput = {
  userId?: ModelIDInput | null,
  entityId?: ModelIDInput | null,
  type?: ModelActivityTypeInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelActivityFilterInput | null > | null,
  or?: Array< ModelActivityFilterInput | null > | null,
  not?: ModelActivityFilterInput | null,
};

export type ModelActivityTypeInput = {
  eq?: ActivityType | null,
  ne?: ActivityType | null,
};

export type ModelReferralConnection = {
  __typename: "ModelReferralConnection",
  items:  Array<Referral | null >,
  nextToken?: string | null,
};

export type Referral = {
  __typename: "Referral",
  id: string,
  userId: string,
  referredId: string,
  firstName?: string | null,
  lastName?: string | null,
  taskPaidCount?: number | null,
  referredByCode?: string | null,
  referredCompleted?: boolean | null,
  referredSignedStatus?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type XeroContact = {
  __typename: "XeroContact",
  contactID: string,
  contactNumber?: string | null,
  accountNumber?: string | null,
  contactStatus?: ContactStatus | null,
  name?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  emailAddress?: string | null,
  bankAccountDetails?: string | null,
  companyNumber?: string | null,
  taxNumber?: string | null,
  accountsReceivableTaxType?: string | null,
  accountsPayableTaxType?: string | null,
  addresses?:  Array<XeroAddress | null > | null,
  phones?:  Array<XeroPhone | null > | null,
  isSupplier?: boolean | null,
  isCustomer?: boolean | null,
  defaultCurrency?: string | null,
  updatedDateUTC?: string | null,
  contactPersons?:  Array<XeroContactPerson | null > | null,
  xeroNetworkKey?: string | null,
  mergedToContactID?: string | null,
  salesDefaultAccountCode?: string | null,
  purchasesDefaultAccountCode?: string | null,
  salesTrackingCategories?: Array< string | null > | null,
  purchasesTrackingCategories?: Array< string | null > | null,
  salesDefaultLineAmountType?: string | null,
  purchasesDefaultLineAmountType?: string | null,
  trackingCategoryName?: string | null,
  trackingCategoryOption?: string | null,
  paymentTerms?: string | null,
  website?: string | null,
  brandingTheme?: string | null,
  batchPayments?: string | null,
  discount?: number | null,
  validationErrors?: Array< string | null > | null,
  hasValidationErrors?: boolean | null,
  hasAttachments?: boolean | null,
  balances?: Balances | null,
  statusAttributeString?: string | null,
};

export type XeroAddress = {
  __typename: "XeroAddress",
  addressType?: string | null,
  addressLine1?: string | null,
  addressLine2?: string | null,
  addressLine3?: string | null,
  addressLine4?: string | null,
  city?: string | null,
  region?: string | null,
  postalCode?: string | null,
  country?: string | null,
  attentionTo?: string | null,
};

export type XeroPhone = {
  __typename: "XeroPhone",
  phoneType?: string | null,
  phoneNumber?: string | null,
  phoneAreaCode?: string | null,
  phoneCountryCode?: string | null,
};

export type XeroContactPerson = {
  __typename: "XeroContactPerson",
  firstName?: string | null,
  lastName?: string | null,
  emailAddress?: string | null,
  includeInEmails?: boolean | null,
};

export type Balances = {
  __typename: "Balances",
  accountsReceivable?: number | null,
  accountsPayable?: number | null,
};

export enum XeroInvoiceStatus {
  DRAFT = "DRAFT",
  SUBMITTED = "SUBMITTED",
  DELETED = "DELETED",
  AUTHORISED = "AUTHORISED",
  PAID = "PAID",
  VOIDED = "VOIDED",
}


export type XeroInvoice = {
  __typename: "XeroInvoice",
  invoiceID: string,
  type?: string | null,
  status?: XeroInvoiceStatus | null,
  lineAmountTypes?: string | null,
  currencyCode?: string | null,
  date?: string | null,
  dueDate?: string | null,
  lineItems?:  Array<XeroLineItem | null > | null,
  subTotal?: number | null,
  totalTax?: number | null,
  total?: number | null,
  invoiceNumber?: string | null,
  reference?: string | null,
  hasAttachments?: boolean | null,
  updatedDateUTC?: string | null,
  currencyRate?: number | null,
  remainingCredit?: number | null,
  amountDue?: number | null,
  amountPaid?: number | null,
  fullyPaidOnDate?: string | null,
  amountCredited?: number | null,
  brandingThemeID?: string | null,
  hasErrors?: boolean | null,
  contact?: XeroContact | null,
};

export type XeroLineItem = {
  __typename: "XeroLineItem",
  lineItemID: string,
  description?: string | null,
  quantity?: number | null,
  unitAmount?: number | null,
  itemCode?: string | null,
  accountCode?: string | null,
  accountID?: string | null,
  taxType?: string | null,
  taxAmount?: number | null,
  lineAmount?: number | null,
  taxNumber?: number | null,
  discountRate?: number | null,
  discountAmount?: number | null,
  repeatingInvoiceID?: string | null,
};

export type XeroConnectionStatus = {
  __typename: "XeroConnectionStatus",
  isConnected: boolean,
};

export type XeroGetEntityConnectionStatusInput = {
  entityId: string,
};

export type XeroTenant = {
  __typename: "XeroTenant",
  id?: string | null,
  authEventId?: string | null,
  tenantId?: string | null,
  tenantType?: XeroTenantType | null,
  tenantName?: string | null,
  createdDateUtc?: string | null,
  updatedDateUtc?: string | null,
};

export enum XeroTenantType {
  ORGANISATION = "ORGANISATION",
  PRACTICEMANAGER = "PRACTICEMANAGER",
  PRACTICE = "PRACTICE",
}


export type XeroGetAccountsInput = {
  entityId: string,
};

export type XeroAccount = {
  __typename: "XeroAccount",
  code?: string | null,
  name?: string | null,
  accountID?: string | null,
  type?: XeroAccountType | null,
  bankAccountNumber?: string | null,
  status?: XeroAccountStatus | null,
  description?: string | null,
  bankAccountType?: XeroBankAccountType | null,
  currencyCode?: string | null,
  taxType?: string | null,
  enablePaymentsToAccount?: boolean | null,
  showInExpenseClaims?: boolean | null,
  _class?: XeroAccountClass | null,
  systemAccount?: XeroSystemAccountType | null,
  reportingCode?: string | null,
  reportingCodeName?: string | null,
  hasAttachments?: boolean | null,
  updatedDateUTC?: string | null,
  addToWatchlist?: boolean | null,
};

export enum XeroAccountType {
  BANK = "BANK",
  CURRENT = "CURRENT",
  CURRLIAB = "CURRLIAB",
  DEPRECIATN = "DEPRECIATN",
  DIRECTCOSTS = "DIRECTCOSTS",
  EQUITY = "EQUITY",
  EXPENSE = "EXPENSE",
  FIXED = "FIXED",
  INVENTORY = "INVENTORY",
  LIABILITY = "LIABILITY",
  NONCURRENT = "NONCURRENT",
  OTHERINCOME = "OTHERINCOME",
  OVERHEADS = "OVERHEADS",
  PREPAYMENT = "PREPAYMENT",
  REVENUE = "REVENUE",
  SALES = "SALES",
  TERMLIAB = "TERMLIAB",
  PAYG = "PAYG",
}


export enum XeroAccountStatus {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
  DELETED = "DELETED",
}


export enum XeroBankAccountType {
  BANK = "BANK",
  CREDITCARD = "CREDITCARD",
  PAYPAL = "PAYPAL",
  NONE = "NONE",
  Empty = "Empty",
}


export enum XeroAccountClass {
  ASSET = "ASSET",
  EQUITY = "EQUITY",
  EXPENSE = "EXPENSE",
  LIABILITY = "LIABILITY",
  REVENUE = "REVENUE",
}


export enum XeroSystemAccountType {
  DEBTORS = "DEBTORS",
  CREDITORS = "CREDITORS",
  BANKCURRENCYGAIN = "BANKCURRENCYGAIN",
  GST = "GST",
  GSTONIMPORTS = "GSTONIMPORTS",
  HISTORICAL = "HISTORICAL",
  REALISEDCURRENCYGAIN = "REALISEDCURRENCYGAIN",
  RETAINEDEARNINGS = "RETAINEDEARNINGS",
  ROUNDING = "ROUNDING",
  TRACKINGTRANSFERS = "TRACKINGTRANSFERS",
  UNPAIDEXPCLM = "UNPAIDEXPCLM",
  UNREALISEDCURRENCYGAIN = "UNREALISEDCURRENCYGAIN",
  WAGEPAYABLES = "WAGEPAYABLES",
  CISASSETS = "CISASSETS",
  CISASSET = "CISASSET",
  CISLABOUR = "CISLABOUR",
  CISLABOUREXPENSE = "CISLABOUREXPENSE",
  CISLABOURINCOME = "CISLABOURINCOME",
  CISLIABILITY = "CISLIABILITY",
  CISMATERIALS = "CISMATERIALS",
  Empty = "Empty",
}


export type EmailProviderConnectionStatus = {
  __typename: "EmailProviderConnectionStatus",
  isConnected: boolean,
};

export type EntityPayId = {
  __typename: "EntityPayId",
  transferAmount?: number | null,
  payId?: string | null,
  currency?: string | null,
  accountName?: string | null,
  accountNumber?: string | null,
  routingNumber?: string | null,
  currentBalance?: CurrentBalance | null,
};

export type CurrentBalance = {
  __typename: "CurrentBalance",
  availableAmount?: number | null,
  currency?: string | null,
  pendingAmount?: number | null,
  reservedAmount?: number | null,
  payableTaxAmount?: number | null,
  totalAmount?: number | null,
};

export type BalanceHistory = {
  __typename: "BalanceHistory",
  hasMore?: boolean | null,
  items:  Array<BalanceHistoryItem | null >,
  pageBefore?: string | null,
  pageAfter?: string | null,
};

export type BalanceHistoryItem = {
  __typename: "BalanceHistoryItem",
  source?: string | null,
  amount: string,
  currency: string,
  balance: string,
  description?: string | null,
  fee?: string | null,
  postedAt: string,
  sourceType: string,
  transactionType?: string | null,
};

export type AdmiinAccount = {
  __typename: "AdmiinAccount",
  id: string,
  currency?: string | null,
  accountName?: string | null,
  accountNumber?: string | null,
  routingNumber?: string | null,
  currentBalance?: CurrentBalance | null,
};

export enum HistoryType {
  CARD = "CARD",
  ADMIIN_WALLET = "ADMIIN_WALLET",
  FEE_NOT_SEPARATED = "FEE_NOT_SEPARATED",
  INVOICE = "INVOICE",
  EXTERNAL_BANK = "EXTERNAL_BANK",
}


export type ModelTransactionHistory = {
  __typename: "ModelTransactionHistory",
  items:  Array<ModelTransactionHistoryItem | null >,
};

export type ModelTransactionHistoryItem = {
  __typename: "ModelTransactionHistoryItem",
  receiver?: string | null,
  payer?: string | null,
  reference?: string | null,
  description?: string | null,
  netAmount?: number | null,
  payerFees?: number | null,
  taxAmount?: number | null,
  totalAmount?: number | null,
  balance?: number | null,
  amount?: number | null,
  date?: string | null,
};

export type TrackEventMutationVariables = {
  input: TrackEventInput,
};

export type TrackEventMutation = {
  trackEvent: boolean,
};

export type CreateClientMutationVariables = {
  input: CreateClientInput,
};

export type CreateClientMutation = {
  createClient?:  {
    __typename: "EntityUser",
    id: string,
    entityId: string,
    userId: string,
    firmId?: string | null,
    email?: string | null,
    invitedEmail?: string | null,
    ocrEmail?: string | null,
    referredBy?: string | null,
    invitedEntityId?: string | null,
    firmEntityId?: string | null,
    providerContactId?: string | null,
    ownerCode?: string | null,
    clientGroupCode?: string | null,
    clientCode?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    role: EntityUserRole,
    jobTags?: Array< JobTags | null > | null,
    paymentsEnabled?: boolean | null,
    termsInvoiceAccepted?: boolean | null,
    termsOcrAccepted?: boolean | null,
    termsFirmPayTaxAccepted?: boolean | null,
    termsFirmPayTaxDetails?:  {
      __typename: "TermsFirmPayTaxDetails",
      document?:  {
        __typename: "S3Upload",
        identityId?: string | null,
        key: string,
        level: S3UploadLevel,
        type: S3UploadType,
        name?: string | null,
      } | null,
      acceptedAt?: string | null,
      email?: string | null,
      ip?: string | null,
      fullName?: string | null,
      firmId?: string | null,
    } | null,
    entitySearchName?: string | null,
    entity?:  {
      __typename: "Entity",
      id: string,
      type: EntityType,
      taxNumber?: string | null,
      companyNumber?: string | null,
      billerCode?: number | null,
      name: string,
      legalName?: string | null,
      businessNames?: Array< string | null > | null,
      searchName?: string | null,
      address?:  {
        __typename: "Address",
        addressId?: string | null,
        contactName?: string | null,
        contactNumber?: string | null,
        fullAddress?: string | null,
        address1?: string | null,
        address2?: string | null,
        city?: string | null,
        country: string,
        countryCode: string,
        state: string,
        stateCode?: string | null,
        postalCode: string,
        invalid?: boolean | null,
      } | null,
      logo?:  {
        __typename: "Image",
        alt?: string | null,
        identityId?: string | null,
        key: string,
        level: S3UploadLevel,
        type?: string | null,
      } | null,
      brandColour?: string | null,
      website?: string | null,
      entityUsers?:  {
        __typename: "ModelEntityUserConnection",
        items:  Array< {
          __typename: "EntityUser",
          id: string,
          entityId: string,
          userId: string,
          firmId?: string | null,
          email?: string | null,
          invitedEmail?: string | null,
          ocrEmail?: string | null,
          referredBy?: string | null,
          invitedEntityId?: string | null,
          firmEntityId?: string | null,
          providerContactId?: string | null,
          ownerCode?: string | null,
          clientGroupCode?: string | null,
          clientCode?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          role: EntityUserRole,
          jobTags?: Array< JobTags | null > | null,
          paymentsEnabled?: boolean | null,
          termsInvoiceAccepted?: boolean | null,
          termsOcrAccepted?: boolean | null,
          termsFirmPayTaxAccepted?: boolean | null,
          termsFirmPayTaxDetails?:  {
            __typename: "TermsFirmPayTaxDetails",
            document?:  {
              __typename: "S3Upload",
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type: S3UploadType,
              name?: string | null,
            } | null,
            acceptedAt?: string | null,
            email?: string | null,
            ip?: string | null,
            fullName?: string | null,
            firmId?: string | null,
          } | null,
          entitySearchName?: string | null,
          entity?:  {
            __typename: "Entity",
            id: string,
            type: EntityType,
            taxNumber?: string | null,
            companyNumber?: string | null,
            billerCode?: number | null,
            name: string,
            legalName?: string | null,
            businessNames?: Array< string | null > | null,
            searchName?: string | null,
            address?:  {
              __typename: "Address",
              addressId?: string | null,
              contactName?: string | null,
              contactNumber?: string | null,
              fullAddress?: string | null,
              address1?: string | null,
              address2?: string | null,
              city?: string | null,
              country: string,
              countryCode: string,
              state: string,
              stateCode?: string | null,
              postalCode: string,
              invalid?: boolean | null,
            } | null,
            logo?:  {
              __typename: "Image",
              alt?: string | null,
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type?: string | null,
            } | null,
            brandColour?: string | null,
            website?: string | null,
            entityUsers?:  {
              __typename: "ModelEntityUserConnection",
              items:  Array< {
                __typename: "EntityUser",
                id: string,
                entityId: string,
                userId: string,
                firmId?: string | null,
                email?: string | null,
                invitedEmail?: string | null,
                ocrEmail?: string | null,
                referredBy?: string | null,
                invitedEntityId?: string | null,
                firmEntityId?: string | null,
                providerContactId?: string | null,
                ownerCode?: string | null,
                clientGroupCode?: string | null,
                clientCode?: string | null,
                firstName?: string | null,
                lastName?: string | null,
                role: EntityUserRole,
                jobTags?: Array< JobTags | null > | null,
                paymentsEnabled?: boolean | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                termsFirmPayTaxAccepted?: boolean | null,
                entitySearchName?: string | null,
                searchName?: string | null,
                taxNumber?: string | null,
                taskSendSMS?: boolean | null,
                companyNumber?: string | null,
                createdBy?: string | null,
                createdAt: string,
                updatedAt: string,
                status?: EntityUserStatus | null,
                partnerId?: string | null,
                managerId?: string | null,
                archivedAt?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gstRegistered?: boolean | null,
            gstReportingPeriod?: GSTReportingPeriod | null,
            providerEntityId?: string | null,
            providerCompanyId?: string | null,
            providerBillUserCompanyId?: string | null,
            providerBankAccountId?: string | null,
            providerDigitalWalletId?: string | null,
            providerBpayCrn?: string | null,
            contact?:  {
              __typename: "EntityContact",
              firstName?: string | null,
              lastName?: string | null,
              email?: string | null,
              phone?: string | null,
              role?: string | null,
            } | null,
            paymentMethods?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            paymentMethodId?: string | null,
            paymentUserId?: string | null,
            disbursementMethodId?: string | null,
            receivingAccounts?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            ubosCreated?: boolean | null,
            numUbosCreated?: number | null,
            subCategory?: string | null,
            clientsStatus?: EntityClientsStatus | null,
            ocrEmail?: string | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            owner?: string | null,
            referredBy?: string | null,
            connectedAccount?: string | null,
            accountStatus?: AccountStatus | null,
            customerId?: string | null,
            xeroSyncStatus?: XeroSyncStatus | null,
            xeroLastContactSyncAt?: string | null,
            xeroContactSyncStatus?: XeroSyncStatus | null,
            xeroInvoiceSyncStatus?: XeroSyncStatus | null,
            xeroLastInvoiceSyncAt?: string | null,
            xeroTenantId?: string | null,
            absorbFees?: boolean | null,
            subscriptionTier?: SubscriptionTier | null,
            invitationStatus?: InvitationStatus | null,
            clientsOnboardingStatus?: ClientsOnboardingStatus | null,
            createdBy?: string | null,
            createdByEntityId?: string | null,
            isFirm?: boolean | null,
            createdAt?: string | null,
            updatedAt?: string | null,
          } | null,
          firm?:  {
            __typename: "Entity",
            id: string,
            type: EntityType,
            taxNumber?: string | null,
            companyNumber?: string | null,
            billerCode?: number | null,
            name: string,
            legalName?: string | null,
            businessNames?: Array< string | null > | null,
            searchName?: string | null,
            address?:  {
              __typename: "Address",
              addressId?: string | null,
              contactName?: string | null,
              contactNumber?: string | null,
              fullAddress?: string | null,
              address1?: string | null,
              address2?: string | null,
              city?: string | null,
              country: string,
              countryCode: string,
              state: string,
              stateCode?: string | null,
              postalCode: string,
              invalid?: boolean | null,
            } | null,
            logo?:  {
              __typename: "Image",
              alt?: string | null,
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type?: string | null,
            } | null,
            brandColour?: string | null,
            website?: string | null,
            entityUsers?:  {
              __typename: "ModelEntityUserConnection",
              items:  Array< {
                __typename: "EntityUser",
                id: string,
                entityId: string,
                userId: string,
                firmId?: string | null,
                email?: string | null,
                invitedEmail?: string | null,
                ocrEmail?: string | null,
                referredBy?: string | null,
                invitedEntityId?: string | null,
                firmEntityId?: string | null,
                providerContactId?: string | null,
                ownerCode?: string | null,
                clientGroupCode?: string | null,
                clientCode?: string | null,
                firstName?: string | null,
                lastName?: string | null,
                role: EntityUserRole,
                jobTags?: Array< JobTags | null > | null,
                paymentsEnabled?: boolean | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                termsFirmPayTaxAccepted?: boolean | null,
                entitySearchName?: string | null,
                searchName?: string | null,
                taxNumber?: string | null,
                taskSendSMS?: boolean | null,
                companyNumber?: string | null,
                createdBy?: string | null,
                createdAt: string,
                updatedAt: string,
                status?: EntityUserStatus | null,
                partnerId?: string | null,
                managerId?: string | null,
                archivedAt?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gstRegistered?: boolean | null,
            gstReportingPeriod?: GSTReportingPeriod | null,
            providerEntityId?: string | null,
            providerCompanyId?: string | null,
            providerBillUserCompanyId?: string | null,
            providerBankAccountId?: string | null,
            providerDigitalWalletId?: string | null,
            providerBpayCrn?: string | null,
            contact?:  {
              __typename: "EntityContact",
              firstName?: string | null,
              lastName?: string | null,
              email?: string | null,
              phone?: string | null,
              role?: string | null,
            } | null,
            paymentMethods?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            paymentMethodId?: string | null,
            paymentUserId?: string | null,
            disbursementMethodId?: string | null,
            receivingAccounts?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            ubosCreated?: boolean | null,
            numUbosCreated?: number | null,
            subCategory?: string | null,
            clientsStatus?: EntityClientsStatus | null,
            ocrEmail?: string | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            owner?: string | null,
            referredBy?: string | null,
            connectedAccount?: string | null,
            accountStatus?: AccountStatus | null,
            customerId?: string | null,
            xeroSyncStatus?: XeroSyncStatus | null,
            xeroLastContactSyncAt?: string | null,
            xeroContactSyncStatus?: XeroSyncStatus | null,
            xeroInvoiceSyncStatus?: XeroSyncStatus | null,
            xeroLastInvoiceSyncAt?: string | null,
            xeroTenantId?: string | null,
            absorbFees?: boolean | null,
            subscriptionTier?: SubscriptionTier | null,
            invitationStatus?: InvitationStatus | null,
            clientsOnboardingStatus?: ClientsOnboardingStatus | null,
            createdBy?: string | null,
            createdByEntityId?: string | null,
            isFirm?: boolean | null,
            createdAt?: string | null,
            updatedAt?: string | null,
          } | null,
          searchName?: string | null,
          taxNumber?: string | null,
          taskSendSMS?: boolean | null,
          companyNumber?: string | null,
          createdBy?: string | null,
          createdAt: string,
          updatedAt: string,
          status?: EntityUserStatus | null,
          partnerId?: string | null,
          managerId?: string | null,
          archivedAt?: string | null,
          taxPaymentReferences?:  {
            __typename: "TaxPaymentReferences",
            itr?:  {
              __typename: "TaxPaymentReference",
              referenceNumber?: string | null,
              updatedAt?: string | null,
            } | null,
            other?:  {
              __typename: "TaxPaymentReference",
              referenceNumber?: string | null,
              updatedAt?: string | null,
            } | null,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gstRegistered?: boolean | null,
      gstReportingPeriod?: GSTReportingPeriod | null,
      providerEntityId?: string | null,
      providerCompanyId?: string | null,
      providerBillUserCompanyId?: string | null,
      providerBankAccountId?: string | null,
      providerDigitalWalletId?: string | null,
      providerBpayCrn?: string | null,
      contact?:  {
        __typename: "EntityContact",
        firstName?: string | null,
        lastName?: string | null,
        email?: string | null,
        phone?: string | null,
        role?: string | null,
      } | null,
      paymentMethods?:  {
        __typename: "ModelPaymentMethodConnection",
        items:  Array< {
          __typename: "PaymentMethod",
          id: string,
          paymentMethodType: PaymentMethodType,
          type?: string | null,
          fullName?: string | null,
          number?: string | null,
          expMonth?: string | null,
          expYear?: string | null,
          accountName?: string | null,
          bankName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
          holderType?: BankHolderType | null,
          accountType?: BankAccountType | null,
          status?: PaymentMethodStatus | null,
          accountDirection?: AccountDirection | null,
          expiresAt?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          consentId?: string | null,
          consentStatus?: PaymentConsentStatus | null,
          card?: string | null,
          googlepay?: string | null,
          applepay?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      paymentMethodId?: string | null,
      paymentUserId?: string | null,
      disbursementMethodId?: string | null,
      receivingAccounts?:  {
        __typename: "ModelPaymentMethodConnection",
        items:  Array< {
          __typename: "PaymentMethod",
          id: string,
          paymentMethodType: PaymentMethodType,
          type?: string | null,
          fullName?: string | null,
          number?: string | null,
          expMonth?: string | null,
          expYear?: string | null,
          accountName?: string | null,
          bankName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
          holderType?: BankHolderType | null,
          accountType?: BankAccountType | null,
          status?: PaymentMethodStatus | null,
          accountDirection?: AccountDirection | null,
          expiresAt?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          consentId?: string | null,
          consentStatus?: PaymentConsentStatus | null,
          card?: string | null,
          googlepay?: string | null,
          applepay?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      ubosCreated?: boolean | null,
      numUbosCreated?: number | null,
      subCategory?: string | null,
      clientsStatus?: EntityClientsStatus | null,
      ocrEmail?: string | null,
      termsInvoiceAccepted?: boolean | null,
      termsOcrAccepted?: boolean | null,
      owner?: string | null,
      referredBy?: string | null,
      connectedAccount?: string | null,
      accountStatus?: AccountStatus | null,
      customerId?: string | null,
      xeroSyncStatus?: XeroSyncStatus | null,
      xeroLastContactSyncAt?: string | null,
      xeroContactSyncStatus?: XeroSyncStatus | null,
      xeroInvoiceSyncStatus?: XeroSyncStatus | null,
      xeroLastInvoiceSyncAt?: string | null,
      xeroTenantId?: string | null,
      absorbFees?: boolean | null,
      subscriptionTier?: SubscriptionTier | null,
      invitationStatus?: InvitationStatus | null,
      clientsOnboardingStatus?: ClientsOnboardingStatus | null,
      createdBy?: string | null,
      createdByEntityId?: string | null,
      isFirm?: boolean | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    firm?:  {
      __typename: "Entity",
      id: string,
      type: EntityType,
      taxNumber?: string | null,
      companyNumber?: string | null,
      billerCode?: number | null,
      name: string,
      legalName?: string | null,
      businessNames?: Array< string | null > | null,
      searchName?: string | null,
      address?:  {
        __typename: "Address",
        addressId?: string | null,
        contactName?: string | null,
        contactNumber?: string | null,
        fullAddress?: string | null,
        address1?: string | null,
        address2?: string | null,
        city?: string | null,
        country: string,
        countryCode: string,
        state: string,
        stateCode?: string | null,
        postalCode: string,
        invalid?: boolean | null,
      } | null,
      logo?:  {
        __typename: "Image",
        alt?: string | null,
        identityId?: string | null,
        key: string,
        level: S3UploadLevel,
        type?: string | null,
      } | null,
      brandColour?: string | null,
      website?: string | null,
      entityUsers?:  {
        __typename: "ModelEntityUserConnection",
        items:  Array< {
          __typename: "EntityUser",
          id: string,
          entityId: string,
          userId: string,
          firmId?: string | null,
          email?: string | null,
          invitedEmail?: string | null,
          ocrEmail?: string | null,
          referredBy?: string | null,
          invitedEntityId?: string | null,
          firmEntityId?: string | null,
          providerContactId?: string | null,
          ownerCode?: string | null,
          clientGroupCode?: string | null,
          clientCode?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          role: EntityUserRole,
          jobTags?: Array< JobTags | null > | null,
          paymentsEnabled?: boolean | null,
          termsInvoiceAccepted?: boolean | null,
          termsOcrAccepted?: boolean | null,
          termsFirmPayTaxAccepted?: boolean | null,
          termsFirmPayTaxDetails?:  {
            __typename: "TermsFirmPayTaxDetails",
            document?:  {
              __typename: "S3Upload",
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type: S3UploadType,
              name?: string | null,
            } | null,
            acceptedAt?: string | null,
            email?: string | null,
            ip?: string | null,
            fullName?: string | null,
            firmId?: string | null,
          } | null,
          entitySearchName?: string | null,
          entity?:  {
            __typename: "Entity",
            id: string,
            type: EntityType,
            taxNumber?: string | null,
            companyNumber?: string | null,
            billerCode?: number | null,
            name: string,
            legalName?: string | null,
            businessNames?: Array< string | null > | null,
            searchName?: string | null,
            address?:  {
              __typename: "Address",
              addressId?: string | null,
              contactName?: string | null,
              contactNumber?: string | null,
              fullAddress?: string | null,
              address1?: string | null,
              address2?: string | null,
              city?: string | null,
              country: string,
              countryCode: string,
              state: string,
              stateCode?: string | null,
              postalCode: string,
              invalid?: boolean | null,
            } | null,
            logo?:  {
              __typename: "Image",
              alt?: string | null,
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type?: string | null,
            } | null,
            brandColour?: string | null,
            website?: string | null,
            entityUsers?:  {
              __typename: "ModelEntityUserConnection",
              items:  Array< {
                __typename: "EntityUser",
                id: string,
                entityId: string,
                userId: string,
                firmId?: string | null,
                email?: string | null,
                invitedEmail?: string | null,
                ocrEmail?: string | null,
                referredBy?: string | null,
                invitedEntityId?: string | null,
                firmEntityId?: string | null,
                providerContactId?: string | null,
                ownerCode?: string | null,
                clientGroupCode?: string | null,
                clientCode?: string | null,
                firstName?: string | null,
                lastName?: string | null,
                role: EntityUserRole,
                jobTags?: Array< JobTags | null > | null,
                paymentsEnabled?: boolean | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                termsFirmPayTaxAccepted?: boolean | null,
                entitySearchName?: string | null,
                searchName?: string | null,
                taxNumber?: string | null,
                taskSendSMS?: boolean | null,
                companyNumber?: string | null,
                createdBy?: string | null,
                createdAt: string,
                updatedAt: string,
                status?: EntityUserStatus | null,
                partnerId?: string | null,
                managerId?: string | null,
                archivedAt?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gstRegistered?: boolean | null,
            gstReportingPeriod?: GSTReportingPeriod | null,
            providerEntityId?: string | null,
            providerCompanyId?: string | null,
            providerBillUserCompanyId?: string | null,
            providerBankAccountId?: string | null,
            providerDigitalWalletId?: string | null,
            providerBpayCrn?: string | null,
            contact?:  {
              __typename: "EntityContact",
              firstName?: string | null,
              lastName?: string | null,
              email?: string | null,
              phone?: string | null,
              role?: string | null,
            } | null,
            paymentMethods?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            paymentMethodId?: string | null,
            paymentUserId?: string | null,
            disbursementMethodId?: string | null,
            receivingAccounts?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            ubosCreated?: boolean | null,
            numUbosCreated?: number | null,
            subCategory?: string | null,
            clientsStatus?: EntityClientsStatus | null,
            ocrEmail?: string | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            owner?: string | null,
            referredBy?: string | null,
            connectedAccount?: string | null,
            accountStatus?: AccountStatus | null,
            customerId?: string | null,
            xeroSyncStatus?: XeroSyncStatus | null,
            xeroLastContactSyncAt?: string | null,
            xeroContactSyncStatus?: XeroSyncStatus | null,
            xeroInvoiceSyncStatus?: XeroSyncStatus | null,
            xeroLastInvoiceSyncAt?: string | null,
            xeroTenantId?: string | null,
            absorbFees?: boolean | null,
            subscriptionTier?: SubscriptionTier | null,
            invitationStatus?: InvitationStatus | null,
            clientsOnboardingStatus?: ClientsOnboardingStatus | null,
            createdBy?: string | null,
            createdByEntityId?: string | null,
            isFirm?: boolean | null,
            createdAt?: string | null,
            updatedAt?: string | null,
          } | null,
          firm?:  {
            __typename: "Entity",
            id: string,
            type: EntityType,
            taxNumber?: string | null,
            companyNumber?: string | null,
            billerCode?: number | null,
            name: string,
            legalName?: string | null,
            businessNames?: Array< string | null > | null,
            searchName?: string | null,
            address?:  {
              __typename: "Address",
              addressId?: string | null,
              contactName?: string | null,
              contactNumber?: string | null,
              fullAddress?: string | null,
              address1?: string | null,
              address2?: string | null,
              city?: string | null,
              country: string,
              countryCode: string,
              state: string,
              stateCode?: string | null,
              postalCode: string,
              invalid?: boolean | null,
            } | null,
            logo?:  {
              __typename: "Image",
              alt?: string | null,
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type?: string | null,
            } | null,
            brandColour?: string | null,
            website?: string | null,
            entityUsers?:  {
              __typename: "ModelEntityUserConnection",
              items:  Array< {
                __typename: "EntityUser",
                id: string,
                entityId: string,
                userId: string,
                firmId?: string | null,
                email?: string | null,
                invitedEmail?: string | null,
                ocrEmail?: string | null,
                referredBy?: string | null,
                invitedEntityId?: string | null,
                firmEntityId?: string | null,
                providerContactId?: string | null,
                ownerCode?: string | null,
                clientGroupCode?: string | null,
                clientCode?: string | null,
                firstName?: string | null,
                lastName?: string | null,
                role: EntityUserRole,
                jobTags?: Array< JobTags | null > | null,
                paymentsEnabled?: boolean | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                termsFirmPayTaxAccepted?: boolean | null,
                entitySearchName?: string | null,
                searchName?: string | null,
                taxNumber?: string | null,
                taskSendSMS?: boolean | null,
                companyNumber?: string | null,
                createdBy?: string | null,
                createdAt: string,
                updatedAt: string,
                status?: EntityUserStatus | null,
                partnerId?: string | null,
                managerId?: string | null,
                archivedAt?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gstRegistered?: boolean | null,
            gstReportingPeriod?: GSTReportingPeriod | null,
            providerEntityId?: string | null,
            providerCompanyId?: string | null,
            providerBillUserCompanyId?: string | null,
            providerBankAccountId?: string | null,
            providerDigitalWalletId?: string | null,
            providerBpayCrn?: string | null,
            contact?:  {
              __typename: "EntityContact",
              firstName?: string | null,
              lastName?: string | null,
              email?: string | null,
              phone?: string | null,
              role?: string | null,
            } | null,
            paymentMethods?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            paymentMethodId?: string | null,
            paymentUserId?: string | null,
            disbursementMethodId?: string | null,
            receivingAccounts?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            ubosCreated?: boolean | null,
            numUbosCreated?: number | null,
            subCategory?: string | null,
            clientsStatus?: EntityClientsStatus | null,
            ocrEmail?: string | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            owner?: string | null,
            referredBy?: string | null,
            connectedAccount?: string | null,
            accountStatus?: AccountStatus | null,
            customerId?: string | null,
            xeroSyncStatus?: XeroSyncStatus | null,
            xeroLastContactSyncAt?: string | null,
            xeroContactSyncStatus?: XeroSyncStatus | null,
            xeroInvoiceSyncStatus?: XeroSyncStatus | null,
            xeroLastInvoiceSyncAt?: string | null,
            xeroTenantId?: string | null,
            absorbFees?: boolean | null,
            subscriptionTier?: SubscriptionTier | null,
            invitationStatus?: InvitationStatus | null,
            clientsOnboardingStatus?: ClientsOnboardingStatus | null,
            createdBy?: string | null,
            createdByEntityId?: string | null,
            isFirm?: boolean | null,
            createdAt?: string | null,
            updatedAt?: string | null,
          } | null,
          searchName?: string | null,
          taxNumber?: string | null,
          taskSendSMS?: boolean | null,
          companyNumber?: string | null,
          createdBy?: string | null,
          createdAt: string,
          updatedAt: string,
          status?: EntityUserStatus | null,
          partnerId?: string | null,
          managerId?: string | null,
          archivedAt?: string | null,
          taxPaymentReferences?:  {
            __typename: "TaxPaymentReferences",
            itr?:  {
              __typename: "TaxPaymentReference",
              referenceNumber?: string | null,
              updatedAt?: string | null,
            } | null,
            other?:  {
              __typename: "TaxPaymentReference",
              referenceNumber?: string | null,
              updatedAt?: string | null,
            } | null,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gstRegistered?: boolean | null,
      gstReportingPeriod?: GSTReportingPeriod | null,
      providerEntityId?: string | null,
      providerCompanyId?: string | null,
      providerBillUserCompanyId?: string | null,
      providerBankAccountId?: string | null,
      providerDigitalWalletId?: string | null,
      providerBpayCrn?: string | null,
      contact?:  {
        __typename: "EntityContact",
        firstName?: string | null,
        lastName?: string | null,
        email?: string | null,
        phone?: string | null,
        role?: string | null,
      } | null,
      paymentMethods?:  {
        __typename: "ModelPaymentMethodConnection",
        items:  Array< {
          __typename: "PaymentMethod",
          id: string,
          paymentMethodType: PaymentMethodType,
          type?: string | null,
          fullName?: string | null,
          number?: string | null,
          expMonth?: string | null,
          expYear?: string | null,
          accountName?: string | null,
          bankName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
          holderType?: BankHolderType | null,
          accountType?: BankAccountType | null,
          status?: PaymentMethodStatus | null,
          accountDirection?: AccountDirection | null,
          expiresAt?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          consentId?: string | null,
          consentStatus?: PaymentConsentStatus | null,
          card?: string | null,
          googlepay?: string | null,
          applepay?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      paymentMethodId?: string | null,
      paymentUserId?: string | null,
      disbursementMethodId?: string | null,
      receivingAccounts?:  {
        __typename: "ModelPaymentMethodConnection",
        items:  Array< {
          __typename: "PaymentMethod",
          id: string,
          paymentMethodType: PaymentMethodType,
          type?: string | null,
          fullName?: string | null,
          number?: string | null,
          expMonth?: string | null,
          expYear?: string | null,
          accountName?: string | null,
          bankName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
          holderType?: BankHolderType | null,
          accountType?: BankAccountType | null,
          status?: PaymentMethodStatus | null,
          accountDirection?: AccountDirection | null,
          expiresAt?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          consentId?: string | null,
          consentStatus?: PaymentConsentStatus | null,
          card?: string | null,
          googlepay?: string | null,
          applepay?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      ubosCreated?: boolean | null,
      numUbosCreated?: number | null,
      subCategory?: string | null,
      clientsStatus?: EntityClientsStatus | null,
      ocrEmail?: string | null,
      termsInvoiceAccepted?: boolean | null,
      termsOcrAccepted?: boolean | null,
      owner?: string | null,
      referredBy?: string | null,
      connectedAccount?: string | null,
      accountStatus?: AccountStatus | null,
      customerId?: string | null,
      xeroSyncStatus?: XeroSyncStatus | null,
      xeroLastContactSyncAt?: string | null,
      xeroContactSyncStatus?: XeroSyncStatus | null,
      xeroInvoiceSyncStatus?: XeroSyncStatus | null,
      xeroLastInvoiceSyncAt?: string | null,
      xeroTenantId?: string | null,
      absorbFees?: boolean | null,
      subscriptionTier?: SubscriptionTier | null,
      invitationStatus?: InvitationStatus | null,
      clientsOnboardingStatus?: ClientsOnboardingStatus | null,
      createdBy?: string | null,
      createdByEntityId?: string | null,
      isFirm?: boolean | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    searchName?: string | null,
    taxNumber?: string | null,
    taskSendSMS?: boolean | null,
    companyNumber?: string | null,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
    status?: EntityUserStatus | null,
    partnerId?: string | null,
    managerId?: string | null,
    archivedAt?: string | null,
    taxPaymentReferences?:  {
      __typename: "TaxPaymentReferences",
      itr?:  {
        __typename: "TaxPaymentReference",
        referenceNumber?: string | null,
        updatedAt?: string | null,
      } | null,
      other?:  {
        __typename: "TaxPaymentReference",
        referenceNumber?: string | null,
        updatedAt?: string | null,
      } | null,
    } | null,
  } | null,
};

export type CreateClientBulkUploadMutationVariables = {
  input: CreateClientBulkImportInput,
};

export type CreateClientBulkUploadMutation = {
  createClientBulkUpload?: string | null,
};

export type AddClientOwnerMutationVariables = {
  input: AddClientOwnerInput,
};

export type AddClientOwnerMutation = {
  addClientOwner?:  {
    __typename: "AddClientOwnerResponse",
    success: boolean,
    entityId: string,
    userId: string,
    ownerEntityUserId: string,
    clientGroupCode?: string | null,
    clientCode?: string | null,
    entity?:  {
      __typename: "Entity",
      id: string,
      type: EntityType,
      taxNumber?: string | null,
      companyNumber?: string | null,
      billerCode?: number | null,
      name: string,
      legalName?: string | null,
      businessNames?: Array< string | null > | null,
      searchName?: string | null,
      address?:  {
        __typename: "Address",
        addressId?: string | null,
        contactName?: string | null,
        contactNumber?: string | null,
        fullAddress?: string | null,
        address1?: string | null,
        address2?: string | null,
        city?: string | null,
        country: string,
        countryCode: string,
        state: string,
        stateCode?: string | null,
        postalCode: string,
        invalid?: boolean | null,
      } | null,
      logo?:  {
        __typename: "Image",
        alt?: string | null,
        identityId?: string | null,
        key: string,
        level: S3UploadLevel,
        type?: string | null,
      } | null,
      brandColour?: string | null,
      website?: string | null,
      entityUsers?:  {
        __typename: "ModelEntityUserConnection",
        items:  Array< {
          __typename: "EntityUser",
          id: string,
          entityId: string,
          userId: string,
          firmId?: string | null,
          email?: string | null,
          invitedEmail?: string | null,
          ocrEmail?: string | null,
          referredBy?: string | null,
          invitedEntityId?: string | null,
          firmEntityId?: string | null,
          providerContactId?: string | null,
          ownerCode?: string | null,
          clientGroupCode?: string | null,
          clientCode?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          role: EntityUserRole,
          jobTags?: Array< JobTags | null > | null,
          paymentsEnabled?: boolean | null,
          termsInvoiceAccepted?: boolean | null,
          termsOcrAccepted?: boolean | null,
          termsFirmPayTaxAccepted?: boolean | null,
          termsFirmPayTaxDetails?:  {
            __typename: "TermsFirmPayTaxDetails",
            document?:  {
              __typename: "S3Upload",
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type: S3UploadType,
              name?: string | null,
            } | null,
            acceptedAt?: string | null,
            email?: string | null,
            ip?: string | null,
            fullName?: string | null,
            firmId?: string | null,
          } | null,
          entitySearchName?: string | null,
          entity?:  {
            __typename: "Entity",
            id: string,
            type: EntityType,
            taxNumber?: string | null,
            companyNumber?: string | null,
            billerCode?: number | null,
            name: string,
            legalName?: string | null,
            businessNames?: Array< string | null > | null,
            searchName?: string | null,
            address?:  {
              __typename: "Address",
              addressId?: string | null,
              contactName?: string | null,
              contactNumber?: string | null,
              fullAddress?: string | null,
              address1?: string | null,
              address2?: string | null,
              city?: string | null,
              country: string,
              countryCode: string,
              state: string,
              stateCode?: string | null,
              postalCode: string,
              invalid?: boolean | null,
            } | null,
            logo?:  {
              __typename: "Image",
              alt?: string | null,
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type?: string | null,
            } | null,
            brandColour?: string | null,
            website?: string | null,
            entityUsers?:  {
              __typename: "ModelEntityUserConnection",
              items:  Array< {
                __typename: "EntityUser",
                id: string,
                entityId: string,
                userId: string,
                firmId?: string | null,
                email?: string | null,
                invitedEmail?: string | null,
                ocrEmail?: string | null,
                referredBy?: string | null,
                invitedEntityId?: string | null,
                firmEntityId?: string | null,
                providerContactId?: string | null,
                ownerCode?: string | null,
                clientGroupCode?: string | null,
                clientCode?: string | null,
                firstName?: string | null,
                lastName?: string | null,
                role: EntityUserRole,
                jobTags?: Array< JobTags | null > | null,
                paymentsEnabled?: boolean | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                termsFirmPayTaxAccepted?: boolean | null,
                entitySearchName?: string | null,
                searchName?: string | null,
                taxNumber?: string | null,
                taskSendSMS?: boolean | null,
                companyNumber?: string | null,
                createdBy?: string | null,
                createdAt: string,
                updatedAt: string,
                status?: EntityUserStatus | null,
                partnerId?: string | null,
                managerId?: string | null,
                archivedAt?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gstRegistered?: boolean | null,
            gstReportingPeriod?: GSTReportingPeriod | null,
            providerEntityId?: string | null,
            providerCompanyId?: string | null,
            providerBillUserCompanyId?: string | null,
            providerBankAccountId?: string | null,
            providerDigitalWalletId?: string | null,
            providerBpayCrn?: string | null,
            contact?:  {
              __typename: "EntityContact",
              firstName?: string | null,
              lastName?: string | null,
              email?: string | null,
              phone?: string | null,
              role?: string | null,
            } | null,
            paymentMethods?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            paymentMethodId?: string | null,
            paymentUserId?: string | null,
            disbursementMethodId?: string | null,
            receivingAccounts?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            ubosCreated?: boolean | null,
            numUbosCreated?: number | null,
            subCategory?: string | null,
            clientsStatus?: EntityClientsStatus | null,
            ocrEmail?: string | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            owner?: string | null,
            referredBy?: string | null,
            connectedAccount?: string | null,
            accountStatus?: AccountStatus | null,
            customerId?: string | null,
            xeroSyncStatus?: XeroSyncStatus | null,
            xeroLastContactSyncAt?: string | null,
            xeroContactSyncStatus?: XeroSyncStatus | null,
            xeroInvoiceSyncStatus?: XeroSyncStatus | null,
            xeroLastInvoiceSyncAt?: string | null,
            xeroTenantId?: string | null,
            absorbFees?: boolean | null,
            subscriptionTier?: SubscriptionTier | null,
            invitationStatus?: InvitationStatus | null,
            clientsOnboardingStatus?: ClientsOnboardingStatus | null,
            createdBy?: string | null,
            createdByEntityId?: string | null,
            isFirm?: boolean | null,
            createdAt?: string | null,
            updatedAt?: string | null,
          } | null,
          firm?:  {
            __typename: "Entity",
            id: string,
            type: EntityType,
            taxNumber?: string | null,
            companyNumber?: string | null,
            billerCode?: number | null,
            name: string,
            legalName?: string | null,
            businessNames?: Array< string | null > | null,
            searchName?: string | null,
            address?:  {
              __typename: "Address",
              addressId?: string | null,
              contactName?: string | null,
              contactNumber?: string | null,
              fullAddress?: string | null,
              address1?: string | null,
              address2?: string | null,
              city?: string | null,
              country: string,
              countryCode: string,
              state: string,
              stateCode?: string | null,
              postalCode: string,
              invalid?: boolean | null,
            } | null,
            logo?:  {
              __typename: "Image",
              alt?: string | null,
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type?: string | null,
            } | null,
            brandColour?: string | null,
            website?: string | null,
            entityUsers?:  {
              __typename: "ModelEntityUserConnection",
              items:  Array< {
                __typename: "EntityUser",
                id: string,
                entityId: string,
                userId: string,
                firmId?: string | null,
                email?: string | null,
                invitedEmail?: string | null,
                ocrEmail?: string | null,
                referredBy?: string | null,
                invitedEntityId?: string | null,
                firmEntityId?: string | null,
                providerContactId?: string | null,
                ownerCode?: string | null,
                clientGroupCode?: string | null,
                clientCode?: string | null,
                firstName?: string | null,
                lastName?: string | null,
                role: EntityUserRole,
                jobTags?: Array< JobTags | null > | null,
                paymentsEnabled?: boolean | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                termsFirmPayTaxAccepted?: boolean | null,
                entitySearchName?: string | null,
                searchName?: string | null,
                taxNumber?: string | null,
                taskSendSMS?: boolean | null,
                companyNumber?: string | null,
                createdBy?: string | null,
                createdAt: string,
                updatedAt: string,
                status?: EntityUserStatus | null,
                partnerId?: string | null,
                managerId?: string | null,
                archivedAt?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gstRegistered?: boolean | null,
            gstReportingPeriod?: GSTReportingPeriod | null,
            providerEntityId?: string | null,
            providerCompanyId?: string | null,
            providerBillUserCompanyId?: string | null,
            providerBankAccountId?: string | null,
            providerDigitalWalletId?: string | null,
            providerBpayCrn?: string | null,
            contact?:  {
              __typename: "EntityContact",
              firstName?: string | null,
              lastName?: string | null,
              email?: string | null,
              phone?: string | null,
              role?: string | null,
            } | null,
            paymentMethods?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            paymentMethodId?: string | null,
            paymentUserId?: string | null,
            disbursementMethodId?: string | null,
            receivingAccounts?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            ubosCreated?: boolean | null,
            numUbosCreated?: number | null,
            subCategory?: string | null,
            clientsStatus?: EntityClientsStatus | null,
            ocrEmail?: string | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            owner?: string | null,
            referredBy?: string | null,
            connectedAccount?: string | null,
            accountStatus?: AccountStatus | null,
            customerId?: string | null,
            xeroSyncStatus?: XeroSyncStatus | null,
            xeroLastContactSyncAt?: string | null,
            xeroContactSyncStatus?: XeroSyncStatus | null,
            xeroInvoiceSyncStatus?: XeroSyncStatus | null,
            xeroLastInvoiceSyncAt?: string | null,
            xeroTenantId?: string | null,
            absorbFees?: boolean | null,
            subscriptionTier?: SubscriptionTier | null,
            invitationStatus?: InvitationStatus | null,
            clientsOnboardingStatus?: ClientsOnboardingStatus | null,
            createdBy?: string | null,
            createdByEntityId?: string | null,
            isFirm?: boolean | null,
            createdAt?: string | null,
            updatedAt?: string | null,
          } | null,
          searchName?: string | null,
          taxNumber?: string | null,
          taskSendSMS?: boolean | null,
          companyNumber?: string | null,
          createdBy?: string | null,
          createdAt: string,
          updatedAt: string,
          status?: EntityUserStatus | null,
          partnerId?: string | null,
          managerId?: string | null,
          archivedAt?: string | null,
          taxPaymentReferences?:  {
            __typename: "TaxPaymentReferences",
            itr?:  {
              __typename: "TaxPaymentReference",
              referenceNumber?: string | null,
              updatedAt?: string | null,
            } | null,
            other?:  {
              __typename: "TaxPaymentReference",
              referenceNumber?: string | null,
              updatedAt?: string | null,
            } | null,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gstRegistered?: boolean | null,
      gstReportingPeriod?: GSTReportingPeriod | null,
      providerEntityId?: string | null,
      providerCompanyId?: string | null,
      providerBillUserCompanyId?: string | null,
      providerBankAccountId?: string | null,
      providerDigitalWalletId?: string | null,
      providerBpayCrn?: string | null,
      contact?:  {
        __typename: "EntityContact",
        firstName?: string | null,
        lastName?: string | null,
        email?: string | null,
        phone?: string | null,
        role?: string | null,
      } | null,
      paymentMethods?:  {
        __typename: "ModelPaymentMethodConnection",
        items:  Array< {
          __typename: "PaymentMethod",
          id: string,
          paymentMethodType: PaymentMethodType,
          type?: string | null,
          fullName?: string | null,
          number?: string | null,
          expMonth?: string | null,
          expYear?: string | null,
          accountName?: string | null,
          bankName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
          holderType?: BankHolderType | null,
          accountType?: BankAccountType | null,
          status?: PaymentMethodStatus | null,
          accountDirection?: AccountDirection | null,
          expiresAt?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          consentId?: string | null,
          consentStatus?: PaymentConsentStatus | null,
          card?: string | null,
          googlepay?: string | null,
          applepay?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      paymentMethodId?: string | null,
      paymentUserId?: string | null,
      disbursementMethodId?: string | null,
      receivingAccounts?:  {
        __typename: "ModelPaymentMethodConnection",
        items:  Array< {
          __typename: "PaymentMethod",
          id: string,
          paymentMethodType: PaymentMethodType,
          type?: string | null,
          fullName?: string | null,
          number?: string | null,
          expMonth?: string | null,
          expYear?: string | null,
          accountName?: string | null,
          bankName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
          holderType?: BankHolderType | null,
          accountType?: BankAccountType | null,
          status?: PaymentMethodStatus | null,
          accountDirection?: AccountDirection | null,
          expiresAt?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          consentId?: string | null,
          consentStatus?: PaymentConsentStatus | null,
          card?: string | null,
          googlepay?: string | null,
          applepay?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      ubosCreated?: boolean | null,
      numUbosCreated?: number | null,
      subCategory?: string | null,
      clientsStatus?: EntityClientsStatus | null,
      ocrEmail?: string | null,
      termsInvoiceAccepted?: boolean | null,
      termsOcrAccepted?: boolean | null,
      owner?: string | null,
      referredBy?: string | null,
      connectedAccount?: string | null,
      accountStatus?: AccountStatus | null,
      customerId?: string | null,
      xeroSyncStatus?: XeroSyncStatus | null,
      xeroLastContactSyncAt?: string | null,
      xeroContactSyncStatus?: XeroSyncStatus | null,
      xeroInvoiceSyncStatus?: XeroSyncStatus | null,
      xeroLastInvoiceSyncAt?: string | null,
      xeroTenantId?: string | null,
      absorbFees?: boolean | null,
      subscriptionTier?: SubscriptionTier | null,
      invitationStatus?: InvitationStatus | null,
      clientsOnboardingStatus?: ClientsOnboardingStatus | null,
      createdBy?: string | null,
      createdByEntityId?: string | null,
      isFirm?: boolean | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    entityUser?:  {
      __typename: "EntityUser",
      id: string,
      entityId: string,
      userId: string,
      firmId?: string | null,
      email?: string | null,
      invitedEmail?: string | null,
      ocrEmail?: string | null,
      referredBy?: string | null,
      invitedEntityId?: string | null,
      firmEntityId?: string | null,
      providerContactId?: string | null,
      ownerCode?: string | null,
      clientGroupCode?: string | null,
      clientCode?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      role: EntityUserRole,
      jobTags?: Array< JobTags | null > | null,
      paymentsEnabled?: boolean | null,
      termsInvoiceAccepted?: boolean | null,
      termsOcrAccepted?: boolean | null,
      termsFirmPayTaxAccepted?: boolean | null,
      termsFirmPayTaxDetails?:  {
        __typename: "TermsFirmPayTaxDetails",
        document?:  {
          __typename: "S3Upload",
          identityId?: string | null,
          key: string,
          level: S3UploadLevel,
          type: S3UploadType,
          name?: string | null,
        } | null,
        acceptedAt?: string | null,
        email?: string | null,
        ip?: string | null,
        fullName?: string | null,
        firmId?: string | null,
      } | null,
      entitySearchName?: string | null,
      entity?:  {
        __typename: "Entity",
        id: string,
        type: EntityType,
        taxNumber?: string | null,
        companyNumber?: string | null,
        billerCode?: number | null,
        name: string,
        legalName?: string | null,
        businessNames?: Array< string | null > | null,
        searchName?: string | null,
        address?:  {
          __typename: "Address",
          addressId?: string | null,
          contactName?: string | null,
          contactNumber?: string | null,
          fullAddress?: string | null,
          address1?: string | null,
          address2?: string | null,
          city?: string | null,
          country: string,
          countryCode: string,
          state: string,
          stateCode?: string | null,
          postalCode: string,
          invalid?: boolean | null,
        } | null,
        logo?:  {
          __typename: "Image",
          alt?: string | null,
          identityId?: string | null,
          key: string,
          level: S3UploadLevel,
          type?: string | null,
        } | null,
        brandColour?: string | null,
        website?: string | null,
        entityUsers?:  {
          __typename: "ModelEntityUserConnection",
          items:  Array< {
            __typename: "EntityUser",
            id: string,
            entityId: string,
            userId: string,
            firmId?: string | null,
            email?: string | null,
            invitedEmail?: string | null,
            ocrEmail?: string | null,
            referredBy?: string | null,
            invitedEntityId?: string | null,
            firmEntityId?: string | null,
            providerContactId?: string | null,
            ownerCode?: string | null,
            clientGroupCode?: string | null,
            clientCode?: string | null,
            firstName?: string | null,
            lastName?: string | null,
            role: EntityUserRole,
            jobTags?: Array< JobTags | null > | null,
            paymentsEnabled?: boolean | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            termsFirmPayTaxAccepted?: boolean | null,
            termsFirmPayTaxDetails?:  {
              __typename: "TermsFirmPayTaxDetails",
              document?:  {
                __typename: "S3Upload",
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type: S3UploadType,
                name?: string | null,
              } | null,
              acceptedAt?: string | null,
              email?: string | null,
              ip?: string | null,
              fullName?: string | null,
              firmId?: string | null,
            } | null,
            entitySearchName?: string | null,
            entity?:  {
              __typename: "Entity",
              id: string,
              type: EntityType,
              taxNumber?: string | null,
              companyNumber?: string | null,
              billerCode?: number | null,
              name: string,
              legalName?: string | null,
              businessNames?: Array< string | null > | null,
              searchName?: string | null,
              address?:  {
                __typename: "Address",
                addressId?: string | null,
                contactName?: string | null,
                contactNumber?: string | null,
                fullAddress?: string | null,
                address1?: string | null,
                address2?: string | null,
                city?: string | null,
                country: string,
                countryCode: string,
                state: string,
                stateCode?: string | null,
                postalCode: string,
                invalid?: boolean | null,
              } | null,
              logo?:  {
                __typename: "Image",
                alt?: string | null,
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type?: string | null,
              } | null,
              brandColour?: string | null,
              website?: string | null,
              entityUsers?:  {
                __typename: "ModelEntityUserConnection",
                nextToken?: string | null,
              } | null,
              gstRegistered?: boolean | null,
              gstReportingPeriod?: GSTReportingPeriod | null,
              providerEntityId?: string | null,
              providerCompanyId?: string | null,
              providerBillUserCompanyId?: string | null,
              providerBankAccountId?: string | null,
              providerDigitalWalletId?: string | null,
              providerBpayCrn?: string | null,
              contact?:  {
                __typename: "EntityContact",
                firstName?: string | null,
                lastName?: string | null,
                email?: string | null,
                phone?: string | null,
                role?: string | null,
              } | null,
              paymentMethods?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              paymentMethodId?: string | null,
              paymentUserId?: string | null,
              disbursementMethodId?: string | null,
              receivingAccounts?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              ubosCreated?: boolean | null,
              numUbosCreated?: number | null,
              subCategory?: string | null,
              clientsStatus?: EntityClientsStatus | null,
              ocrEmail?: string | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              owner?: string | null,
              referredBy?: string | null,
              connectedAccount?: string | null,
              accountStatus?: AccountStatus | null,
              customerId?: string | null,
              xeroSyncStatus?: XeroSyncStatus | null,
              xeroLastContactSyncAt?: string | null,
              xeroContactSyncStatus?: XeroSyncStatus | null,
              xeroInvoiceSyncStatus?: XeroSyncStatus | null,
              xeroLastInvoiceSyncAt?: string | null,
              xeroTenantId?: string | null,
              absorbFees?: boolean | null,
              subscriptionTier?: SubscriptionTier | null,
              invitationStatus?: InvitationStatus | null,
              clientsOnboardingStatus?: ClientsOnboardingStatus | null,
              createdBy?: string | null,
              createdByEntityId?: string | null,
              isFirm?: boolean | null,
              createdAt?: string | null,
              updatedAt?: string | null,
            } | null,
            firm?:  {
              __typename: "Entity",
              id: string,
              type: EntityType,
              taxNumber?: string | null,
              companyNumber?: string | null,
              billerCode?: number | null,
              name: string,
              legalName?: string | null,
              businessNames?: Array< string | null > | null,
              searchName?: string | null,
              address?:  {
                __typename: "Address",
                addressId?: string | null,
                contactName?: string | null,
                contactNumber?: string | null,
                fullAddress?: string | null,
                address1?: string | null,
                address2?: string | null,
                city?: string | null,
                country: string,
                countryCode: string,
                state: string,
                stateCode?: string | null,
                postalCode: string,
                invalid?: boolean | null,
              } | null,
              logo?:  {
                __typename: "Image",
                alt?: string | null,
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type?: string | null,
              } | null,
              brandColour?: string | null,
              website?: string | null,
              entityUsers?:  {
                __typename: "ModelEntityUserConnection",
                nextToken?: string | null,
              } | null,
              gstRegistered?: boolean | null,
              gstReportingPeriod?: GSTReportingPeriod | null,
              providerEntityId?: string | null,
              providerCompanyId?: string | null,
              providerBillUserCompanyId?: string | null,
              providerBankAccountId?: string | null,
              providerDigitalWalletId?: string | null,
              providerBpayCrn?: string | null,
              contact?:  {
                __typename: "EntityContact",
                firstName?: string | null,
                lastName?: string | null,
                email?: string | null,
                phone?: string | null,
                role?: string | null,
              } | null,
              paymentMethods?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              paymentMethodId?: string | null,
              paymentUserId?: string | null,
              disbursementMethodId?: string | null,
              receivingAccounts?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              ubosCreated?: boolean | null,
              numUbosCreated?: number | null,
              subCategory?: string | null,
              clientsStatus?: EntityClientsStatus | null,
              ocrEmail?: string | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              owner?: string | null,
              referredBy?: string | null,
              connectedAccount?: string | null,
              accountStatus?: AccountStatus | null,
              customerId?: string | null,
              xeroSyncStatus?: XeroSyncStatus | null,
              xeroLastContactSyncAt?: string | null,
              xeroContactSyncStatus?: XeroSyncStatus | null,
              xeroInvoiceSyncStatus?: XeroSyncStatus | null,
              xeroLastInvoiceSyncAt?: string | null,
              xeroTenantId?: string | null,
              absorbFees?: boolean | null,
              subscriptionTier?: SubscriptionTier | null,
              invitationStatus?: InvitationStatus | null,
              clientsOnboardingStatus?: ClientsOnboardingStatus | null,
              createdBy?: string | null,
              createdByEntityId?: string | null,
              isFirm?: boolean | null,
              createdAt?: string | null,
              updatedAt?: string | null,
            } | null,
            searchName?: string | null,
            taxNumber?: string | null,
            taskSendSMS?: boolean | null,
            companyNumber?: string | null,
            createdBy?: string | null,
            createdAt: string,
            updatedAt: string,
            status?: EntityUserStatus | null,
            partnerId?: string | null,
            managerId?: string | null,
            archivedAt?: string | null,
            taxPaymentReferences?:  {
              __typename: "TaxPaymentReferences",
              itr?:  {
                __typename: "TaxPaymentReference",
                referenceNumber?: string | null,
                updatedAt?: string | null,
              } | null,
              other?:  {
                __typename: "TaxPaymentReference",
                referenceNumber?: string | null,
                updatedAt?: string | null,
              } | null,
            } | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        gstRegistered?: boolean | null,
        gstReportingPeriod?: GSTReportingPeriod | null,
        providerEntityId?: string | null,
        providerCompanyId?: string | null,
        providerBillUserCompanyId?: string | null,
        providerBankAccountId?: string | null,
        providerDigitalWalletId?: string | null,
        providerBpayCrn?: string | null,
        contact?:  {
          __typename: "EntityContact",
          firstName?: string | null,
          lastName?: string | null,
          email?: string | null,
          phone?: string | null,
          role?: string | null,
        } | null,
        paymentMethods?:  {
          __typename: "ModelPaymentMethodConnection",
          items:  Array< {
            __typename: "PaymentMethod",
            id: string,
            paymentMethodType: PaymentMethodType,
            type?: string | null,
            fullName?: string | null,
            number?: string | null,
            expMonth?: string | null,
            expYear?: string | null,
            accountName?: string | null,
            bankName?: string | null,
            accountNumber?: string | null,
            routingNumber?: string | null,
            holderType?: BankHolderType | null,
            accountType?: BankAccountType | null,
            status?: PaymentMethodStatus | null,
            accountDirection?: AccountDirection | null,
            expiresAt?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            consentId?: string | null,
            consentStatus?: PaymentConsentStatus | null,
            card?: string | null,
            googlepay?: string | null,
            applepay?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        paymentMethodId?: string | null,
        paymentUserId?: string | null,
        disbursementMethodId?: string | null,
        receivingAccounts?:  {
          __typename: "ModelPaymentMethodConnection",
          items:  Array< {
            __typename: "PaymentMethod",
            id: string,
            paymentMethodType: PaymentMethodType,
            type?: string | null,
            fullName?: string | null,
            number?: string | null,
            expMonth?: string | null,
            expYear?: string | null,
            accountName?: string | null,
            bankName?: string | null,
            accountNumber?: string | null,
            routingNumber?: string | null,
            holderType?: BankHolderType | null,
            accountType?: BankAccountType | null,
            status?: PaymentMethodStatus | null,
            accountDirection?: AccountDirection | null,
            expiresAt?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            consentId?: string | null,
            consentStatus?: PaymentConsentStatus | null,
            card?: string | null,
            googlepay?: string | null,
            applepay?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        ubosCreated?: boolean | null,
        numUbosCreated?: number | null,
        subCategory?: string | null,
        clientsStatus?: EntityClientsStatus | null,
        ocrEmail?: string | null,
        termsInvoiceAccepted?: boolean | null,
        termsOcrAccepted?: boolean | null,
        owner?: string | null,
        referredBy?: string | null,
        connectedAccount?: string | null,
        accountStatus?: AccountStatus | null,
        customerId?: string | null,
        xeroSyncStatus?: XeroSyncStatus | null,
        xeroLastContactSyncAt?: string | null,
        xeroContactSyncStatus?: XeroSyncStatus | null,
        xeroInvoiceSyncStatus?: XeroSyncStatus | null,
        xeroLastInvoiceSyncAt?: string | null,
        xeroTenantId?: string | null,
        absorbFees?: boolean | null,
        subscriptionTier?: SubscriptionTier | null,
        invitationStatus?: InvitationStatus | null,
        clientsOnboardingStatus?: ClientsOnboardingStatus | null,
        createdBy?: string | null,
        createdByEntityId?: string | null,
        isFirm?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      firm?:  {
        __typename: "Entity",
        id: string,
        type: EntityType,
        taxNumber?: string | null,
        companyNumber?: string | null,
        billerCode?: number | null,
        name: string,
        legalName?: string | null,
        businessNames?: Array< string | null > | null,
        searchName?: string | null,
        address?:  {
          __typename: "Address",
          addressId?: string | null,
          contactName?: string | null,
          contactNumber?: string | null,
          fullAddress?: string | null,
          address1?: string | null,
          address2?: string | null,
          city?: string | null,
          country: string,
          countryCode: string,
          state: string,
          stateCode?: string | null,
          postalCode: string,
          invalid?: boolean | null,
        } | null,
        logo?:  {
          __typename: "Image",
          alt?: string | null,
          identityId?: string | null,
          key: string,
          level: S3UploadLevel,
          type?: string | null,
        } | null,
        brandColour?: string | null,
        website?: string | null,
        entityUsers?:  {
          __typename: "ModelEntityUserConnection",
          items:  Array< {
            __typename: "EntityUser",
            id: string,
            entityId: string,
            userId: string,
            firmId?: string | null,
            email?: string | null,
            invitedEmail?: string | null,
            ocrEmail?: string | null,
            referredBy?: string | null,
            invitedEntityId?: string | null,
            firmEntityId?: string | null,
            providerContactId?: string | null,
            ownerCode?: string | null,
            clientGroupCode?: string | null,
            clientCode?: string | null,
            firstName?: string | null,
            lastName?: string | null,
            role: EntityUserRole,
            jobTags?: Array< JobTags | null > | null,
            paymentsEnabled?: boolean | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            termsFirmPayTaxAccepted?: boolean | null,
            termsFirmPayTaxDetails?:  {
              __typename: "TermsFirmPayTaxDetails",
              document?:  {
                __typename: "S3Upload",
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type: S3UploadType,
                name?: string | null,
              } | null,
              acceptedAt?: string | null,
              email?: string | null,
              ip?: string | null,
              fullName?: string | null,
              firmId?: string | null,
            } | null,
            entitySearchName?: string | null,
            entity?:  {
              __typename: "Entity",
              id: string,
              type: EntityType,
              taxNumber?: string | null,
              companyNumber?: string | null,
              billerCode?: number | null,
              name: string,
              legalName?: string | null,
              businessNames?: Array< string | null > | null,
              searchName?: string | null,
              address?:  {
                __typename: "Address",
                addressId?: string | null,
                contactName?: string | null,
                contactNumber?: string | null,
                fullAddress?: string | null,
                address1?: string | null,
                address2?: string | null,
                city?: string | null,
                country: string,
                countryCode: string,
                state: string,
                stateCode?: string | null,
                postalCode: string,
                invalid?: boolean | null,
              } | null,
              logo?:  {
                __typename: "Image",
                alt?: string | null,
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type?: string | null,
              } | null,
              brandColour?: string | null,
              website?: string | null,
              entityUsers?:  {
                __typename: "ModelEntityUserConnection",
                nextToken?: string | null,
              } | null,
              gstRegistered?: boolean | null,
              gstReportingPeriod?: GSTReportingPeriod | null,
              providerEntityId?: string | null,
              providerCompanyId?: string | null,
              providerBillUserCompanyId?: string | null,
              providerBankAccountId?: string | null,
              providerDigitalWalletId?: string | null,
              providerBpayCrn?: string | null,
              contact?:  {
                __typename: "EntityContact",
                firstName?: string | null,
                lastName?: string | null,
                email?: string | null,
                phone?: string | null,
                role?: string | null,
              } | null,
              paymentMethods?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              paymentMethodId?: string | null,
              paymentUserId?: string | null,
              disbursementMethodId?: string | null,
              receivingAccounts?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              ubosCreated?: boolean | null,
              numUbosCreated?: number | null,
              subCategory?: string | null,
              clientsStatus?: EntityClientsStatus | null,
              ocrEmail?: string | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              owner?: string | null,
              referredBy?: string | null,
              connectedAccount?: string | null,
              accountStatus?: AccountStatus | null,
              customerId?: string | null,
              xeroSyncStatus?: XeroSyncStatus | null,
              xeroLastContactSyncAt?: string | null,
              xeroContactSyncStatus?: XeroSyncStatus | null,
              xeroInvoiceSyncStatus?: XeroSyncStatus | null,
              xeroLastInvoiceSyncAt?: string | null,
              xeroTenantId?: string | null,
              absorbFees?: boolean | null,
              subscriptionTier?: SubscriptionTier | null,
              invitationStatus?: InvitationStatus | null,
              clientsOnboardingStatus?: ClientsOnboardingStatus | null,
              createdBy?: string | null,
              createdByEntityId?: string | null,
              isFirm?: boolean | null,
              createdAt?: string | null,
              updatedAt?: string | null,
            } | null,
            firm?:  {
              __typename: "Entity",
              id: string,
              type: EntityType,
              taxNumber?: string | null,
              companyNumber?: string | null,
              billerCode?: number | null,
              name: string,
              legalName?: string | null,
              businessNames?: Array< string | null > | null,
              searchName?: string | null,
              address?:  {
                __typename: "Address",
                addressId?: string | null,
                contactName?: string | null,
                contactNumber?: string | null,
                fullAddress?: string | null,
                address1?: string | null,
                address2?: string | null,
                city?: string | null,
                country: string,
                countryCode: string,
                state: string,
                stateCode?: string | null,
                postalCode: string,
                invalid?: boolean | null,
              } | null,
              logo?:  {
                __typename: "Image",
                alt?: string | null,
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type?: string | null,
              } | null,
              brandColour?: string | null,
              website?: string | null,
              entityUsers?:  {
                __typename: "ModelEntityUserConnection",
                nextToken?: string | null,
              } | null,
              gstRegistered?: boolean | null,
              gstReportingPeriod?: GSTReportingPeriod | null,
              providerEntityId?: string | null,
              providerCompanyId?: string | null,
              providerBillUserCompanyId?: string | null,
              providerBankAccountId?: string | null,
              providerDigitalWalletId?: string | null,
              providerBpayCrn?: string | null,
              contact?:  {
                __typename: "EntityContact",
                firstName?: string | null,
                lastName?: string | null,
                email?: string | null,
                phone?: string | null,
                role?: string | null,
              } | null,
              paymentMethods?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              paymentMethodId?: string | null,
              paymentUserId?: string | null,
              disbursementMethodId?: string | null,
              receivingAccounts?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              ubosCreated?: boolean | null,
              numUbosCreated?: number | null,
              subCategory?: string | null,
              clientsStatus?: EntityClientsStatus | null,
              ocrEmail?: string | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              owner?: string | null,
              referredBy?: string | null,
              connectedAccount?: string | null,
              accountStatus?: AccountStatus | null,
              customerId?: string | null,
              xeroSyncStatus?: XeroSyncStatus | null,
              xeroLastContactSyncAt?: string | null,
              xeroContactSyncStatus?: XeroSyncStatus | null,
              xeroInvoiceSyncStatus?: XeroSyncStatus | null,
              xeroLastInvoiceSyncAt?: string | null,
              xeroTenantId?: string | null,
              absorbFees?: boolean | null,
              subscriptionTier?: SubscriptionTier | null,
              invitationStatus?: InvitationStatus | null,
              clientsOnboardingStatus?: ClientsOnboardingStatus | null,
              createdBy?: string | null,
              createdByEntityId?: string | null,
              isFirm?: boolean | null,
              createdAt?: string | null,
              updatedAt?: string | null,
            } | null,
            searchName?: string | null,
            taxNumber?: string | null,
            taskSendSMS?: boolean | null,
            companyNumber?: string | null,
            createdBy?: string | null,
            createdAt: string,
            updatedAt: string,
            status?: EntityUserStatus | null,
            partnerId?: string | null,
            managerId?: string | null,
            archivedAt?: string | null,
            taxPaymentReferences?:  {
              __typename: "TaxPaymentReferences",
              itr?:  {
                __typename: "TaxPaymentReference",
                referenceNumber?: string | null,
                updatedAt?: string | null,
              } | null,
              other?:  {
                __typename: "TaxPaymentReference",
                referenceNumber?: string | null,
                updatedAt?: string | null,
              } | null,
            } | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        gstRegistered?: boolean | null,
        gstReportingPeriod?: GSTReportingPeriod | null,
        providerEntityId?: string | null,
        providerCompanyId?: string | null,
        providerBillUserCompanyId?: string | null,
        providerBankAccountId?: string | null,
        providerDigitalWalletId?: string | null,
        providerBpayCrn?: string | null,
        contact?:  {
          __typename: "EntityContact",
          firstName?: string | null,
          lastName?: string | null,
          email?: string | null,
          phone?: string | null,
          role?: string | null,
        } | null,
        paymentMethods?:  {
          __typename: "ModelPaymentMethodConnection",
          items:  Array< {
            __typename: "PaymentMethod",
            id: string,
            paymentMethodType: PaymentMethodType,
            type?: string | null,
            fullName?: string | null,
            number?: string | null,
            expMonth?: string | null,
            expYear?: string | null,
            accountName?: string | null,
            bankName?: string | null,
            accountNumber?: string | null,
            routingNumber?: string | null,
            holderType?: BankHolderType | null,
            accountType?: BankAccountType | null,
            status?: PaymentMethodStatus | null,
            accountDirection?: AccountDirection | null,
            expiresAt?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            consentId?: string | null,
            consentStatus?: PaymentConsentStatus | null,
            card?: string | null,
            googlepay?: string | null,
            applepay?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        paymentMethodId?: string | null,
        paymentUserId?: string | null,
        disbursementMethodId?: string | null,
        receivingAccounts?:  {
          __typename: "ModelPaymentMethodConnection",
          items:  Array< {
            __typename: "PaymentMethod",
            id: string,
            paymentMethodType: PaymentMethodType,
            type?: string | null,
            fullName?: string | null,
            number?: string | null,
            expMonth?: string | null,
            expYear?: string | null,
            accountName?: string | null,
            bankName?: string | null,
            accountNumber?: string | null,
            routingNumber?: string | null,
            holderType?: BankHolderType | null,
            accountType?: BankAccountType | null,
            status?: PaymentMethodStatus | null,
            accountDirection?: AccountDirection | null,
            expiresAt?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            consentId?: string | null,
            consentStatus?: PaymentConsentStatus | null,
            card?: string | null,
            googlepay?: string | null,
            applepay?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        ubosCreated?: boolean | null,
        numUbosCreated?: number | null,
        subCategory?: string | null,
        clientsStatus?: EntityClientsStatus | null,
        ocrEmail?: string | null,
        termsInvoiceAccepted?: boolean | null,
        termsOcrAccepted?: boolean | null,
        owner?: string | null,
        referredBy?: string | null,
        connectedAccount?: string | null,
        accountStatus?: AccountStatus | null,
        customerId?: string | null,
        xeroSyncStatus?: XeroSyncStatus | null,
        xeroLastContactSyncAt?: string | null,
        xeroContactSyncStatus?: XeroSyncStatus | null,
        xeroInvoiceSyncStatus?: XeroSyncStatus | null,
        xeroLastInvoiceSyncAt?: string | null,
        xeroTenantId?: string | null,
        absorbFees?: boolean | null,
        subscriptionTier?: SubscriptionTier | null,
        invitationStatus?: InvitationStatus | null,
        clientsOnboardingStatus?: ClientsOnboardingStatus | null,
        createdBy?: string | null,
        createdByEntityId?: string | null,
        isFirm?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      searchName?: string | null,
      taxNumber?: string | null,
      taskSendSMS?: boolean | null,
      companyNumber?: string | null,
      createdBy?: string | null,
      createdAt: string,
      updatedAt: string,
      status?: EntityUserStatus | null,
      partnerId?: string | null,
      managerId?: string | null,
      archivedAt?: string | null,
      taxPaymentReferences?:  {
        __typename: "TaxPaymentReferences",
        itr?:  {
          __typename: "TaxPaymentReference",
          referenceNumber?: string | null,
          updatedAt?: string | null,
        } | null,
        other?:  {
          __typename: "TaxPaymentReference",
          referenceNumber?: string | null,
          updatedAt?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type CreateContactMutationVariables = {
  input: CreateContactInput,
};

export type CreateContactMutation = {
  createContact?:  {
    __typename: "Contact",
    id: string,
    entityId: string,
    xeroTenantId?: string | null,
    entityType?: EntityType | null,
    firstName?: string | null,
    lastName?: string | null,
    email?: string | null,
    mobile?: string | null,
    phone?: string | null,
    taxNumber?: string | null,
    companyNumber?: string | null,
    name?: string | null,
    legalName?: string | null,
    searchName?: string | null,
    status?: ContactStatus | null,
    website?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    contactType?: ContactType | null,
    bank?:  {
      __typename: "ContactBankAccount",
      id?: string | null,
      accountName?: string | null,
      bankName?: string | null,
      accountNumber: string,
      routingNumber: string,
      holderType?: BankHolderType | null,
      accountType?: BankAccountType | null,
      country?: string | null,
    } | null,
    bpay?:  {
      __typename: "ContactBpay",
      billerCode?: number | null,
      referenceNumber?: string | null,
    } | null,
    invalidFields?: Array< string | null > | null,
    bulkUploadFileKey?: string | null,
    owner?: string | null,
    createdBy?: string | null,
    beneficiaryBankId?: string | null,
    beneficiaryBpayId?: string | null,
    address?:  {
      __typename: "Address",
      addressId?: string | null,
      contactName?: string | null,
      contactNumber?: string | null,
      fullAddress?: string | null,
      address1?: string | null,
      address2?: string | null,
      city?: string | null,
      country: string,
      countryCode: string,
      state: string,
      stateCode?: string | null,
      postalCode: string,
      invalid?: boolean | null,
    } | null,
    postal?:  {
      __typename: "Address",
      addressId?: string | null,
      contactName?: string | null,
      contactNumber?: string | null,
      fullAddress?: string | null,
      address1?: string | null,
      address2?: string | null,
      city?: string | null,
      country: string,
      countryCode: string,
      state: string,
      stateCode?: string | null,
      postalCode: string,
      invalid?: boolean | null,
    } | null,
    payoutErrors?: Array< string | null > | null,
  } | null,
};

export type CreateContactBulkUploadMutationVariables = {
  input: CreateContactBulkImportInput,
};

export type CreateContactBulkUploadMutation = {
  createContactBulkUpload?: string | null,
};

export type UpdateContactMutationVariables = {
  input: UpdateContactInput,
};

export type UpdateContactMutation = {
  updateContact?:  {
    __typename: "Contact",
    id: string,
    entityId: string,
    xeroTenantId?: string | null,
    entityType?: EntityType | null,
    firstName?: string | null,
    lastName?: string | null,
    email?: string | null,
    mobile?: string | null,
    phone?: string | null,
    taxNumber?: string | null,
    companyNumber?: string | null,
    name?: string | null,
    legalName?: string | null,
    searchName?: string | null,
    status?: ContactStatus | null,
    website?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    contactType?: ContactType | null,
    bank?:  {
      __typename: "ContactBankAccount",
      id?: string | null,
      accountName?: string | null,
      bankName?: string | null,
      accountNumber: string,
      routingNumber: string,
      holderType?: BankHolderType | null,
      accountType?: BankAccountType | null,
      country?: string | null,
    } | null,
    bpay?:  {
      __typename: "ContactBpay",
      billerCode?: number | null,
      referenceNumber?: string | null,
    } | null,
    invalidFields?: Array< string | null > | null,
    bulkUploadFileKey?: string | null,
    owner?: string | null,
    createdBy?: string | null,
    beneficiaryBankId?: string | null,
    beneficiaryBpayId?: string | null,
    address?:  {
      __typename: "Address",
      addressId?: string | null,
      contactName?: string | null,
      contactNumber?: string | null,
      fullAddress?: string | null,
      address1?: string | null,
      address2?: string | null,
      city?: string | null,
      country: string,
      countryCode: string,
      state: string,
      stateCode?: string | null,
      postalCode: string,
      invalid?: boolean | null,
    } | null,
    postal?:  {
      __typename: "Address",
      addressId?: string | null,
      contactName?: string | null,
      contactNumber?: string | null,
      fullAddress?: string | null,
      address1?: string | null,
      address2?: string | null,
      city?: string | null,
      country: string,
      countryCode: string,
      state: string,
      stateCode?: string | null,
      postalCode: string,
      invalid?: boolean | null,
    } | null,
    payoutErrors?: Array< string | null > | null,
  } | null,
};

export type ResendUserTemporaryPasswordMutationVariables = {
  input: ResendUserTemporaryPasswordInput,
};

export type ResendUserTemporaryPasswordMutation = {
  resendUserTemporaryPassword?: boolean | null,
};

export type CreateDocumentAnalysisMutationVariables = {
  input?: CreateDocumentAnalysisInput | null,
};

export type CreateDocumentAnalysisMutation = {
  createDocumentAnalysis?:  Array< {
    __typename: "DocumentAnalysis",
    id: string,
    entityId?: string | null,
    firmId?: string | null,
    fileKey?: string | null,
    documents?:  Array< {
      __typename: "S3Upload",
      identityId?: string | null,
      key: string,
      level: S3UploadLevel,
      type: S3UploadType,
      name?: string | null,
    } | null > | null,
    status: DocumentAnalysisStatus,
    expenseStatus?: DocumentAnalysisStatus | null,
    queryStatus?: DocumentAnalysisStatus | null,
    matchedBiller?:  {
      __typename: "BillerDetails",
      billerCode?: number | null,
      billerCategory?: string | null,
      shortName?: string | null,
      longName?: string | null,
      type?: BillerType | null,
      industryCode?: string | null,
      industryCodeDescription?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    matchedContactId?: string | null,
    matchedContact?:  {
      __typename: "Contact",
      id: string,
      entityId: string,
      xeroTenantId?: string | null,
      entityType?: EntityType | null,
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      mobile?: string | null,
      phone?: string | null,
      taxNumber?: string | null,
      companyNumber?: string | null,
      name?: string | null,
      legalName?: string | null,
      searchName?: string | null,
      status?: ContactStatus | null,
      website?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      contactType?: ContactType | null,
      bank?:  {
        __typename: "ContactBankAccount",
        id?: string | null,
        accountName?: string | null,
        bankName?: string | null,
        accountNumber: string,
        routingNumber: string,
        holderType?: BankHolderType | null,
        accountType?: BankAccountType | null,
        country?: string | null,
      } | null,
      bpay?:  {
        __typename: "ContactBpay",
        billerCode?: number | null,
        referenceNumber?: string | null,
      } | null,
      invalidFields?: Array< string | null > | null,
      bulkUploadFileKey?: string | null,
      owner?: string | null,
      createdBy?: string | null,
      beneficiaryBankId?: string | null,
      beneficiaryBpayId?: string | null,
      address?:  {
        __typename: "Address",
        addressId?: string | null,
        contactName?: string | null,
        contactNumber?: string | null,
        fullAddress?: string | null,
        address1?: string | null,
        address2?: string | null,
        city?: string | null,
        country: string,
        countryCode: string,
        state: string,
        stateCode?: string | null,
        postalCode: string,
        invalid?: boolean | null,
      } | null,
      postal?:  {
        __typename: "Address",
        addressId?: string | null,
        contactName?: string | null,
        contactNumber?: string | null,
        fullAddress?: string | null,
        address1?: string | null,
        address2?: string | null,
        city?: string | null,
        country: string,
        countryCode: string,
        state: string,
        stateCode?: string | null,
        postalCode: string,
        invalid?: boolean | null,
      } | null,
      payoutErrors?: Array< string | null > | null,
    } | null,
    matchedEntityId?: string | null,
    matchedEntity?:  {
      __typename: "Entity",
      id: string,
      type: EntityType,
      taxNumber?: string | null,
      companyNumber?: string | null,
      billerCode?: number | null,
      name: string,
      legalName?: string | null,
      businessNames?: Array< string | null > | null,
      searchName?: string | null,
      address?:  {
        __typename: "Address",
        addressId?: string | null,
        contactName?: string | null,
        contactNumber?: string | null,
        fullAddress?: string | null,
        address1?: string | null,
        address2?: string | null,
        city?: string | null,
        country: string,
        countryCode: string,
        state: string,
        stateCode?: string | null,
        postalCode: string,
        invalid?: boolean | null,
      } | null,
      logo?:  {
        __typename: "Image",
        alt?: string | null,
        identityId?: string | null,
        key: string,
        level: S3UploadLevel,
        type?: string | null,
      } | null,
      brandColour?: string | null,
      website?: string | null,
      entityUsers?:  {
        __typename: "ModelEntityUserConnection",
        items:  Array< {
          __typename: "EntityUser",
          id: string,
          entityId: string,
          userId: string,
          firmId?: string | null,
          email?: string | null,
          invitedEmail?: string | null,
          ocrEmail?: string | null,
          referredBy?: string | null,
          invitedEntityId?: string | null,
          firmEntityId?: string | null,
          providerContactId?: string | null,
          ownerCode?: string | null,
          clientGroupCode?: string | null,
          clientCode?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          role: EntityUserRole,
          jobTags?: Array< JobTags | null > | null,
          paymentsEnabled?: boolean | null,
          termsInvoiceAccepted?: boolean | null,
          termsOcrAccepted?: boolean | null,
          termsFirmPayTaxAccepted?: boolean | null,
          termsFirmPayTaxDetails?:  {
            __typename: "TermsFirmPayTaxDetails",
            document?:  {
              __typename: "S3Upload",
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type: S3UploadType,
              name?: string | null,
            } | null,
            acceptedAt?: string | null,
            email?: string | null,
            ip?: string | null,
            fullName?: string | null,
            firmId?: string | null,
          } | null,
          entitySearchName?: string | null,
          entity?:  {
            __typename: "Entity",
            id: string,
            type: EntityType,
            taxNumber?: string | null,
            companyNumber?: string | null,
            billerCode?: number | null,
            name: string,
            legalName?: string | null,
            businessNames?: Array< string | null > | null,
            searchName?: string | null,
            address?:  {
              __typename: "Address",
              addressId?: string | null,
              contactName?: string | null,
              contactNumber?: string | null,
              fullAddress?: string | null,
              address1?: string | null,
              address2?: string | null,
              city?: string | null,
              country: string,
              countryCode: string,
              state: string,
              stateCode?: string | null,
              postalCode: string,
              invalid?: boolean | null,
            } | null,
            logo?:  {
              __typename: "Image",
              alt?: string | null,
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type?: string | null,
            } | null,
            brandColour?: string | null,
            website?: string | null,
            entityUsers?:  {
              __typename: "ModelEntityUserConnection",
              items:  Array< {
                __typename: "EntityUser",
                id: string,
                entityId: string,
                userId: string,
                firmId?: string | null,
                email?: string | null,
                invitedEmail?: string | null,
                ocrEmail?: string | null,
                referredBy?: string | null,
                invitedEntityId?: string | null,
                firmEntityId?: string | null,
                providerContactId?: string | null,
                ownerCode?: string | null,
                clientGroupCode?: string | null,
                clientCode?: string | null,
                firstName?: string | null,
                lastName?: string | null,
                role: EntityUserRole,
                jobTags?: Array< JobTags | null > | null,
                paymentsEnabled?: boolean | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                termsFirmPayTaxAccepted?: boolean | null,
                entitySearchName?: string | null,
                searchName?: string | null,
                taxNumber?: string | null,
                taskSendSMS?: boolean | null,
                companyNumber?: string | null,
                createdBy?: string | null,
                createdAt: string,
                updatedAt: string,
                status?: EntityUserStatus | null,
                partnerId?: string | null,
                managerId?: string | null,
                archivedAt?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gstRegistered?: boolean | null,
            gstReportingPeriod?: GSTReportingPeriod | null,
            providerEntityId?: string | null,
            providerCompanyId?: string | null,
            providerBillUserCompanyId?: string | null,
            providerBankAccountId?: string | null,
            providerDigitalWalletId?: string | null,
            providerBpayCrn?: string | null,
            contact?:  {
              __typename: "EntityContact",
              firstName?: string | null,
              lastName?: string | null,
              email?: string | null,
              phone?: string | null,
              role?: string | null,
            } | null,
            paymentMethods?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            paymentMethodId?: string | null,
            paymentUserId?: string | null,
            disbursementMethodId?: string | null,
            receivingAccounts?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            ubosCreated?: boolean | null,
            numUbosCreated?: number | null,
            subCategory?: string | null,
            clientsStatus?: EntityClientsStatus | null,
            ocrEmail?: string | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            owner?: string | null,
            referredBy?: string | null,
            connectedAccount?: string | null,
            accountStatus?: AccountStatus | null,
            customerId?: string | null,
            xeroSyncStatus?: XeroSyncStatus | null,
            xeroLastContactSyncAt?: string | null,
            xeroContactSyncStatus?: XeroSyncStatus | null,
            xeroInvoiceSyncStatus?: XeroSyncStatus | null,
            xeroLastInvoiceSyncAt?: string | null,
            xeroTenantId?: string | null,
            absorbFees?: boolean | null,
            subscriptionTier?: SubscriptionTier | null,
            invitationStatus?: InvitationStatus | null,
            clientsOnboardingStatus?: ClientsOnboardingStatus | null,
            createdBy?: string | null,
            createdByEntityId?: string | null,
            isFirm?: boolean | null,
            createdAt?: string | null,
            updatedAt?: string | null,
          } | null,
          firm?:  {
            __typename: "Entity",
            id: string,
            type: EntityType,
            taxNumber?: string | null,
            companyNumber?: string | null,
            billerCode?: number | null,
            name: string,
            legalName?: string | null,
            businessNames?: Array< string | null > | null,
            searchName?: string | null,
            address?:  {
              __typename: "Address",
              addressId?: string | null,
              contactName?: string | null,
              contactNumber?: string | null,
              fullAddress?: string | null,
              address1?: string | null,
              address2?: string | null,
              city?: string | null,
              country: string,
              countryCode: string,
              state: string,
              stateCode?: string | null,
              postalCode: string,
              invalid?: boolean | null,
            } | null,
            logo?:  {
              __typename: "Image",
              alt?: string | null,
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type?: string | null,
            } | null,
            brandColour?: string | null,
            website?: string | null,
            entityUsers?:  {
              __typename: "ModelEntityUserConnection",
              items:  Array< {
                __typename: "EntityUser",
                id: string,
                entityId: string,
                userId: string,
                firmId?: string | null,
                email?: string | null,
                invitedEmail?: string | null,
                ocrEmail?: string | null,
                referredBy?: string | null,
                invitedEntityId?: string | null,
                firmEntityId?: string | null,
                providerContactId?: string | null,
                ownerCode?: string | null,
                clientGroupCode?: string | null,
                clientCode?: string | null,
                firstName?: string | null,
                lastName?: string | null,
                role: EntityUserRole,
                jobTags?: Array< JobTags | null > | null,
                paymentsEnabled?: boolean | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                termsFirmPayTaxAccepted?: boolean | null,
                entitySearchName?: string | null,
                searchName?: string | null,
                taxNumber?: string | null,
                taskSendSMS?: boolean | null,
                companyNumber?: string | null,
                createdBy?: string | null,
                createdAt: string,
                updatedAt: string,
                status?: EntityUserStatus | null,
                partnerId?: string | null,
                managerId?: string | null,
                archivedAt?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gstRegistered?: boolean | null,
            gstReportingPeriod?: GSTReportingPeriod | null,
            providerEntityId?: string | null,
            providerCompanyId?: string | null,
            providerBillUserCompanyId?: string | null,
            providerBankAccountId?: string | null,
            providerDigitalWalletId?: string | null,
            providerBpayCrn?: string | null,
            contact?:  {
              __typename: "EntityContact",
              firstName?: string | null,
              lastName?: string | null,
              email?: string | null,
              phone?: string | null,
              role?: string | null,
            } | null,
            paymentMethods?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            paymentMethodId?: string | null,
            paymentUserId?: string | null,
            disbursementMethodId?: string | null,
            receivingAccounts?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            ubosCreated?: boolean | null,
            numUbosCreated?: number | null,
            subCategory?: string | null,
            clientsStatus?: EntityClientsStatus | null,
            ocrEmail?: string | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            owner?: string | null,
            referredBy?: string | null,
            connectedAccount?: string | null,
            accountStatus?: AccountStatus | null,
            customerId?: string | null,
            xeroSyncStatus?: XeroSyncStatus | null,
            xeroLastContactSyncAt?: string | null,
            xeroContactSyncStatus?: XeroSyncStatus | null,
            xeroInvoiceSyncStatus?: XeroSyncStatus | null,
            xeroLastInvoiceSyncAt?: string | null,
            xeroTenantId?: string | null,
            absorbFees?: boolean | null,
            subscriptionTier?: SubscriptionTier | null,
            invitationStatus?: InvitationStatus | null,
            clientsOnboardingStatus?: ClientsOnboardingStatus | null,
            createdBy?: string | null,
            createdByEntityId?: string | null,
            isFirm?: boolean | null,
            createdAt?: string | null,
            updatedAt?: string | null,
          } | null,
          searchName?: string | null,
          taxNumber?: string | null,
          taskSendSMS?: boolean | null,
          companyNumber?: string | null,
          createdBy?: string | null,
          createdAt: string,
          updatedAt: string,
          status?: EntityUserStatus | null,
          partnerId?: string | null,
          managerId?: string | null,
          archivedAt?: string | null,
          taxPaymentReferences?:  {
            __typename: "TaxPaymentReferences",
            itr?:  {
              __typename: "TaxPaymentReference",
              referenceNumber?: string | null,
              updatedAt?: string | null,
            } | null,
            other?:  {
              __typename: "TaxPaymentReference",
              referenceNumber?: string | null,
              updatedAt?: string | null,
            } | null,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gstRegistered?: boolean | null,
      gstReportingPeriod?: GSTReportingPeriod | null,
      providerEntityId?: string | null,
      providerCompanyId?: string | null,
      providerBillUserCompanyId?: string | null,
      providerBankAccountId?: string | null,
      providerDigitalWalletId?: string | null,
      providerBpayCrn?: string | null,
      contact?:  {
        __typename: "EntityContact",
        firstName?: string | null,
        lastName?: string | null,
        email?: string | null,
        phone?: string | null,
        role?: string | null,
      } | null,
      paymentMethods?:  {
        __typename: "ModelPaymentMethodConnection",
        items:  Array< {
          __typename: "PaymentMethod",
          id: string,
          paymentMethodType: PaymentMethodType,
          type?: string | null,
          fullName?: string | null,
          number?: string | null,
          expMonth?: string | null,
          expYear?: string | null,
          accountName?: string | null,
          bankName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
          holderType?: BankHolderType | null,
          accountType?: BankAccountType | null,
          status?: PaymentMethodStatus | null,
          accountDirection?: AccountDirection | null,
          expiresAt?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          consentId?: string | null,
          consentStatus?: PaymentConsentStatus | null,
          card?: string | null,
          googlepay?: string | null,
          applepay?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      paymentMethodId?: string | null,
      paymentUserId?: string | null,
      disbursementMethodId?: string | null,
      receivingAccounts?:  {
        __typename: "ModelPaymentMethodConnection",
        items:  Array< {
          __typename: "PaymentMethod",
          id: string,
          paymentMethodType: PaymentMethodType,
          type?: string | null,
          fullName?: string | null,
          number?: string | null,
          expMonth?: string | null,
          expYear?: string | null,
          accountName?: string | null,
          bankName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
          holderType?: BankHolderType | null,
          accountType?: BankAccountType | null,
          status?: PaymentMethodStatus | null,
          accountDirection?: AccountDirection | null,
          expiresAt?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          consentId?: string | null,
          consentStatus?: PaymentConsentStatus | null,
          card?: string | null,
          googlepay?: string | null,
          applepay?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      ubosCreated?: boolean | null,
      numUbosCreated?: number | null,
      subCategory?: string | null,
      clientsStatus?: EntityClientsStatus | null,
      ocrEmail?: string | null,
      termsInvoiceAccepted?: boolean | null,
      termsOcrAccepted?: boolean | null,
      owner?: string | null,
      referredBy?: string | null,
      connectedAccount?: string | null,
      accountStatus?: AccountStatus | null,
      customerId?: string | null,
      xeroSyncStatus?: XeroSyncStatus | null,
      xeroLastContactSyncAt?: string | null,
      xeroContactSyncStatus?: XeroSyncStatus | null,
      xeroInvoiceSyncStatus?: XeroSyncStatus | null,
      xeroLastInvoiceSyncAt?: string | null,
      xeroTenantId?: string | null,
      absorbFees?: boolean | null,
      subscriptionTier?: SubscriptionTier | null,
      invitationStatus?: InvitationStatus | null,
      clientsOnboardingStatus?: ClientsOnboardingStatus | null,
      createdBy?: string | null,
      createdByEntityId?: string | null,
      isFirm?: boolean | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    newContact?:  {
      __typename: "DocumentAnalysisContact",
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      mobile?: string | null,
      phone?: string | null,
      name?: string | null,
      taxNumber?: string | null,
      address?:  {
        __typename: "Address",
        addressId?: string | null,
        contactName?: string | null,
        contactNumber?: string | null,
        fullAddress?: string | null,
        address1?: string | null,
        address2?: string | null,
        city?: string | null,
        country: string,
        countryCode: string,
        state: string,
        stateCode?: string | null,
        postalCode: string,
        invalid?: boolean | null,
      } | null,
    } | null,
    task?:  {
      __typename: "DocumentAnalysisTask",
      reference?: string | null,
      dueAt?: string | null,
      issuedAt?: string | null,
      lodgementAt?: string | null,
      paymentAt?: string | null,
      gstInclusive?: boolean | null,
      notes?: string | null,
      amount?: number | null,
      gstAmount?: number | null,
      taxAmount?: number | null,
      lineItems?:  Array< {
        __typename: "DocumentAnalysisLineItem",
        description?: string | null,
        quantity?: number | null,
        unitPrice?: number | null,
        price?: number | null,
        productCode?: string | null,
        taxType?: TaxType | null,
      } | null > | null,
      numberOfPayments?: number | null,
      paymentFrequency?: PaymentFrequency | null,
      shippingAmount?: number | null,
      settlementStatus?: TaskSettlementStatus | null,
      partnerId?: string | null,
      managerId?: string | null,
      documentType?: DocumentType | null,
      subCategory?: string | null,
      category?: TaskCategory | null,
      period?: string | null,
      year?: string | null,
    } | null,
    bpay?:  {
      __typename: "ContactBpay",
      billerCode?: number | null,
      referenceNumber?: string | null,
    } | null,
    bank?:  {
      __typename: "DocumentAnalysisBankAccount",
      accountNumber?: string | null,
      routingNumber?: string | null,
    } | null,
    category?: TaskCategory | null,
    source?: DocumentAnalysisSource | null,
    isCorrect?: boolean | null,
    fromEmail?: string | null,
    textContent?: string | null,
    createdBy?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null > | null,
};

export type UpdateDocumentAnalysisMutationVariables = {
  input?: UpdateDocumentAnalysisInput | null,
};

export type UpdateDocumentAnalysisMutation = {
  updateDocumentAnalysis?:  {
    __typename: "DocumentAnalysis",
    id: string,
    entityId?: string | null,
    firmId?: string | null,
    fileKey?: string | null,
    documents?:  Array< {
      __typename: "S3Upload",
      identityId?: string | null,
      key: string,
      level: S3UploadLevel,
      type: S3UploadType,
      name?: string | null,
    } | null > | null,
    status: DocumentAnalysisStatus,
    expenseStatus?: DocumentAnalysisStatus | null,
    queryStatus?: DocumentAnalysisStatus | null,
    matchedBiller?:  {
      __typename: "BillerDetails",
      billerCode?: number | null,
      billerCategory?: string | null,
      shortName?: string | null,
      longName?: string | null,
      type?: BillerType | null,
      industryCode?: string | null,
      industryCodeDescription?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    matchedContactId?: string | null,
    matchedContact?:  {
      __typename: "Contact",
      id: string,
      entityId: string,
      xeroTenantId?: string | null,
      entityType?: EntityType | null,
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      mobile?: string | null,
      phone?: string | null,
      taxNumber?: string | null,
      companyNumber?: string | null,
      name?: string | null,
      legalName?: string | null,
      searchName?: string | null,
      status?: ContactStatus | null,
      website?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      contactType?: ContactType | null,
      bank?:  {
        __typename: "ContactBankAccount",
        id?: string | null,
        accountName?: string | null,
        bankName?: string | null,
        accountNumber: string,
        routingNumber: string,
        holderType?: BankHolderType | null,
        accountType?: BankAccountType | null,
        country?: string | null,
      } | null,
      bpay?:  {
        __typename: "ContactBpay",
        billerCode?: number | null,
        referenceNumber?: string | null,
      } | null,
      invalidFields?: Array< string | null > | null,
      bulkUploadFileKey?: string | null,
      owner?: string | null,
      createdBy?: string | null,
      beneficiaryBankId?: string | null,
      beneficiaryBpayId?: string | null,
      address?:  {
        __typename: "Address",
        addressId?: string | null,
        contactName?: string | null,
        contactNumber?: string | null,
        fullAddress?: string | null,
        address1?: string | null,
        address2?: string | null,
        city?: string | null,
        country: string,
        countryCode: string,
        state: string,
        stateCode?: string | null,
        postalCode: string,
        invalid?: boolean | null,
      } | null,
      postal?:  {
        __typename: "Address",
        addressId?: string | null,
        contactName?: string | null,
        contactNumber?: string | null,
        fullAddress?: string | null,
        address1?: string | null,
        address2?: string | null,
        city?: string | null,
        country: string,
        countryCode: string,
        state: string,
        stateCode?: string | null,
        postalCode: string,
        invalid?: boolean | null,
      } | null,
      payoutErrors?: Array< string | null > | null,
    } | null,
    matchedEntityId?: string | null,
    matchedEntity?:  {
      __typename: "Entity",
      id: string,
      type: EntityType,
      taxNumber?: string | null,
      companyNumber?: string | null,
      billerCode?: number | null,
      name: string,
      legalName?: string | null,
      businessNames?: Array< string | null > | null,
      searchName?: string | null,
      address?:  {
        __typename: "Address",
        addressId?: string | null,
        contactName?: string | null,
        contactNumber?: string | null,
        fullAddress?: string | null,
        address1?: string | null,
        address2?: string | null,
        city?: string | null,
        country: string,
        countryCode: string,
        state: string,
        stateCode?: string | null,
        postalCode: string,
        invalid?: boolean | null,
      } | null,
      logo?:  {
        __typename: "Image",
        alt?: string | null,
        identityId?: string | null,
        key: string,
        level: S3UploadLevel,
        type?: string | null,
      } | null,
      brandColour?: string | null,
      website?: string | null,
      entityUsers?:  {
        __typename: "ModelEntityUserConnection",
        items:  Array< {
          __typename: "EntityUser",
          id: string,
          entityId: string,
          userId: string,
          firmId?: string | null,
          email?: string | null,
          invitedEmail?: string | null,
          ocrEmail?: string | null,
          referredBy?: string | null,
          invitedEntityId?: string | null,
          firmEntityId?: string | null,
          providerContactId?: string | null,
          ownerCode?: string | null,
          clientGroupCode?: string | null,
          clientCode?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          role: EntityUserRole,
          jobTags?: Array< JobTags | null > | null,
          paymentsEnabled?: boolean | null,
          termsInvoiceAccepted?: boolean | null,
          termsOcrAccepted?: boolean | null,
          termsFirmPayTaxAccepted?: boolean | null,
          termsFirmPayTaxDetails?:  {
            __typename: "TermsFirmPayTaxDetails",
            document?:  {
              __typename: "S3Upload",
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type: S3UploadType,
              name?: string | null,
            } | null,
            acceptedAt?: string | null,
            email?: string | null,
            ip?: string | null,
            fullName?: string | null,
            firmId?: string | null,
          } | null,
          entitySearchName?: string | null,
          entity?:  {
            __typename: "Entity",
            id: string,
            type: EntityType,
            taxNumber?: string | null,
            companyNumber?: string | null,
            billerCode?: number | null,
            name: string,
            legalName?: string | null,
            businessNames?: Array< string | null > | null,
            searchName?: string | null,
            address?:  {
              __typename: "Address",
              addressId?: string | null,
              contactName?: string | null,
              contactNumber?: string | null,
              fullAddress?: string | null,
              address1?: string | null,
              address2?: string | null,
              city?: string | null,
              country: string,
              countryCode: string,
              state: string,
              stateCode?: string | null,
              postalCode: string,
              invalid?: boolean | null,
            } | null,
            logo?:  {
              __typename: "Image",
              alt?: string | null,
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type?: string | null,
            } | null,
            brandColour?: string | null,
            website?: string | null,
            entityUsers?:  {
              __typename: "ModelEntityUserConnection",
              items:  Array< {
                __typename: "EntityUser",
                id: string,
                entityId: string,
                userId: string,
                firmId?: string | null,
                email?: string | null,
                invitedEmail?: string | null,
                ocrEmail?: string | null,
                referredBy?: string | null,
                invitedEntityId?: string | null,
                firmEntityId?: string | null,
                providerContactId?: string | null,
                ownerCode?: string | null,
                clientGroupCode?: string | null,
                clientCode?: string | null,
                firstName?: string | null,
                lastName?: string | null,
                role: EntityUserRole,
                jobTags?: Array< JobTags | null > | null,
                paymentsEnabled?: boolean | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                termsFirmPayTaxAccepted?: boolean | null,
                entitySearchName?: string | null,
                searchName?: string | null,
                taxNumber?: string | null,
                taskSendSMS?: boolean | null,
                companyNumber?: string | null,
                createdBy?: string | null,
                createdAt: string,
                updatedAt: string,
                status?: EntityUserStatus | null,
                partnerId?: string | null,
                managerId?: string | null,
                archivedAt?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gstRegistered?: boolean | null,
            gstReportingPeriod?: GSTReportingPeriod | null,
            providerEntityId?: string | null,
            providerCompanyId?: string | null,
            providerBillUserCompanyId?: string | null,
            providerBankAccountId?: string | null,
            providerDigitalWalletId?: string | null,
            providerBpayCrn?: string | null,
            contact?:  {
              __typename: "EntityContact",
              firstName?: string | null,
              lastName?: string | null,
              email?: string | null,
              phone?: string | null,
              role?: string | null,
            } | null,
            paymentMethods?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            paymentMethodId?: string | null,
            paymentUserId?: string | null,
            disbursementMethodId?: string | null,
            receivingAccounts?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            ubosCreated?: boolean | null,
            numUbosCreated?: number | null,
            subCategory?: string | null,
            clientsStatus?: EntityClientsStatus | null,
            ocrEmail?: string | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            owner?: string | null,
            referredBy?: string | null,
            connectedAccount?: string | null,
            accountStatus?: AccountStatus | null,
            customerId?: string | null,
            xeroSyncStatus?: XeroSyncStatus | null,
            xeroLastContactSyncAt?: string | null,
            xeroContactSyncStatus?: XeroSyncStatus | null,
            xeroInvoiceSyncStatus?: XeroSyncStatus | null,
            xeroLastInvoiceSyncAt?: string | null,
            xeroTenantId?: string | null,
            absorbFees?: boolean | null,
            subscriptionTier?: SubscriptionTier | null,
            invitationStatus?: InvitationStatus | null,
            clientsOnboardingStatus?: ClientsOnboardingStatus | null,
            createdBy?: string | null,
            createdByEntityId?: string | null,
            isFirm?: boolean | null,
            createdAt?: string | null,
            updatedAt?: string | null,
          } | null,
          firm?:  {
            __typename: "Entity",
            id: string,
            type: EntityType,
            taxNumber?: string | null,
            companyNumber?: string | null,
            billerCode?: number | null,
            name: string,
            legalName?: string | null,
            businessNames?: Array< string | null > | null,
            searchName?: string | null,
            address?:  {
              __typename: "Address",
              addressId?: string | null,
              contactName?: string | null,
              contactNumber?: string | null,
              fullAddress?: string | null,
              address1?: string | null,
              address2?: string | null,
              city?: string | null,
              country: string,
              countryCode: string,
              state: string,
              stateCode?: string | null,
              postalCode: string,
              invalid?: boolean | null,
            } | null,
            logo?:  {
              __typename: "Image",
              alt?: string | null,
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type?: string | null,
            } | null,
            brandColour?: string | null,
            website?: string | null,
            entityUsers?:  {
              __typename: "ModelEntityUserConnection",
              items:  Array< {
                __typename: "EntityUser",
                id: string,
                entityId: string,
                userId: string,
                firmId?: string | null,
                email?: string | null,
                invitedEmail?: string | null,
                ocrEmail?: string | null,
                referredBy?: string | null,
                invitedEntityId?: string | null,
                firmEntityId?: string | null,
                providerContactId?: string | null,
                ownerCode?: string | null,
                clientGroupCode?: string | null,
                clientCode?: string | null,
                firstName?: string | null,
                lastName?: string | null,
                role: EntityUserRole,
                jobTags?: Array< JobTags | null > | null,
                paymentsEnabled?: boolean | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                termsFirmPayTaxAccepted?: boolean | null,
                entitySearchName?: string | null,
                searchName?: string | null,
                taxNumber?: string | null,
                taskSendSMS?: boolean | null,
                companyNumber?: string | null,
                createdBy?: string | null,
                createdAt: string,
                updatedAt: string,
                status?: EntityUserStatus | null,
                partnerId?: string | null,
                managerId?: string | null,
                archivedAt?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gstRegistered?: boolean | null,
            gstReportingPeriod?: GSTReportingPeriod | null,
            providerEntityId?: string | null,
            providerCompanyId?: string | null,
            providerBillUserCompanyId?: string | null,
            providerBankAccountId?: string | null,
            providerDigitalWalletId?: string | null,
            providerBpayCrn?: string | null,
            contact?:  {
              __typename: "EntityContact",
              firstName?: string | null,
              lastName?: string | null,
              email?: string | null,
              phone?: string | null,
              role?: string | null,
            } | null,
            paymentMethods?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            paymentMethodId?: string | null,
            paymentUserId?: string | null,
            disbursementMethodId?: string | null,
            receivingAccounts?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            ubosCreated?: boolean | null,
            numUbosCreated?: number | null,
            subCategory?: string | null,
            clientsStatus?: EntityClientsStatus | null,
            ocrEmail?: string | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            owner?: string | null,
            referredBy?: string | null,
            connectedAccount?: string | null,
            accountStatus?: AccountStatus | null,
            customerId?: string | null,
            xeroSyncStatus?: XeroSyncStatus | null,
            xeroLastContactSyncAt?: string | null,
            xeroContactSyncStatus?: XeroSyncStatus | null,
            xeroInvoiceSyncStatus?: XeroSyncStatus | null,
            xeroLastInvoiceSyncAt?: string | null,
            xeroTenantId?: string | null,
            absorbFees?: boolean | null,
            subscriptionTier?: SubscriptionTier | null,
            invitationStatus?: InvitationStatus | null,
            clientsOnboardingStatus?: ClientsOnboardingStatus | null,
            createdBy?: string | null,
            createdByEntityId?: string | null,
            isFirm?: boolean | null,
            createdAt?: string | null,
            updatedAt?: string | null,
          } | null,
          searchName?: string | null,
          taxNumber?: string | null,
          taskSendSMS?: boolean | null,
          companyNumber?: string | null,
          createdBy?: string | null,
          createdAt: string,
          updatedAt: string,
          status?: EntityUserStatus | null,
          partnerId?: string | null,
          managerId?: string | null,
          archivedAt?: string | null,
          taxPaymentReferences?:  {
            __typename: "TaxPaymentReferences",
            itr?:  {
              __typename: "TaxPaymentReference",
              referenceNumber?: string | null,
              updatedAt?: string | null,
            } | null,
            other?:  {
              __typename: "TaxPaymentReference",
              referenceNumber?: string | null,
              updatedAt?: string | null,
            } | null,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gstRegistered?: boolean | null,
      gstReportingPeriod?: GSTReportingPeriod | null,
      providerEntityId?: string | null,
      providerCompanyId?: string | null,
      providerBillUserCompanyId?: string | null,
      providerBankAccountId?: string | null,
      providerDigitalWalletId?: string | null,
      providerBpayCrn?: string | null,
      contact?:  {
        __typename: "EntityContact",
        firstName?: string | null,
        lastName?: string | null,
        email?: string | null,
        phone?: string | null,
        role?: string | null,
      } | null,
      paymentMethods?:  {
        __typename: "ModelPaymentMethodConnection",
        items:  Array< {
          __typename: "PaymentMethod",
          id: string,
          paymentMethodType: PaymentMethodType,
          type?: string | null,
          fullName?: string | null,
          number?: string | null,
          expMonth?: string | null,
          expYear?: string | null,
          accountName?: string | null,
          bankName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
          holderType?: BankHolderType | null,
          accountType?: BankAccountType | null,
          status?: PaymentMethodStatus | null,
          accountDirection?: AccountDirection | null,
          expiresAt?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          consentId?: string | null,
          consentStatus?: PaymentConsentStatus | null,
          card?: string | null,
          googlepay?: string | null,
          applepay?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      paymentMethodId?: string | null,
      paymentUserId?: string | null,
      disbursementMethodId?: string | null,
      receivingAccounts?:  {
        __typename: "ModelPaymentMethodConnection",
        items:  Array< {
          __typename: "PaymentMethod",
          id: string,
          paymentMethodType: PaymentMethodType,
          type?: string | null,
          fullName?: string | null,
          number?: string | null,
          expMonth?: string | null,
          expYear?: string | null,
          accountName?: string | null,
          bankName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
          holderType?: BankHolderType | null,
          accountType?: BankAccountType | null,
          status?: PaymentMethodStatus | null,
          accountDirection?: AccountDirection | null,
          expiresAt?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          consentId?: string | null,
          consentStatus?: PaymentConsentStatus | null,
          card?: string | null,
          googlepay?: string | null,
          applepay?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      ubosCreated?: boolean | null,
      numUbosCreated?: number | null,
      subCategory?: string | null,
      clientsStatus?: EntityClientsStatus | null,
      ocrEmail?: string | null,
      termsInvoiceAccepted?: boolean | null,
      termsOcrAccepted?: boolean | null,
      owner?: string | null,
      referredBy?: string | null,
      connectedAccount?: string | null,
      accountStatus?: AccountStatus | null,
      customerId?: string | null,
      xeroSyncStatus?: XeroSyncStatus | null,
      xeroLastContactSyncAt?: string | null,
      xeroContactSyncStatus?: XeroSyncStatus | null,
      xeroInvoiceSyncStatus?: XeroSyncStatus | null,
      xeroLastInvoiceSyncAt?: string | null,
      xeroTenantId?: string | null,
      absorbFees?: boolean | null,
      subscriptionTier?: SubscriptionTier | null,
      invitationStatus?: InvitationStatus | null,
      clientsOnboardingStatus?: ClientsOnboardingStatus | null,
      createdBy?: string | null,
      createdByEntityId?: string | null,
      isFirm?: boolean | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    newContact?:  {
      __typename: "DocumentAnalysisContact",
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      mobile?: string | null,
      phone?: string | null,
      name?: string | null,
      taxNumber?: string | null,
      address?:  {
        __typename: "Address",
        addressId?: string | null,
        contactName?: string | null,
        contactNumber?: string | null,
        fullAddress?: string | null,
        address1?: string | null,
        address2?: string | null,
        city?: string | null,
        country: string,
        countryCode: string,
        state: string,
        stateCode?: string | null,
        postalCode: string,
        invalid?: boolean | null,
      } | null,
    } | null,
    task?:  {
      __typename: "DocumentAnalysisTask",
      reference?: string | null,
      dueAt?: string | null,
      issuedAt?: string | null,
      lodgementAt?: string | null,
      paymentAt?: string | null,
      gstInclusive?: boolean | null,
      notes?: string | null,
      amount?: number | null,
      gstAmount?: number | null,
      taxAmount?: number | null,
      lineItems?:  Array< {
        __typename: "DocumentAnalysisLineItem",
        description?: string | null,
        quantity?: number | null,
        unitPrice?: number | null,
        price?: number | null,
        productCode?: string | null,
        taxType?: TaxType | null,
      } | null > | null,
      numberOfPayments?: number | null,
      paymentFrequency?: PaymentFrequency | null,
      shippingAmount?: number | null,
      settlementStatus?: TaskSettlementStatus | null,
      partnerId?: string | null,
      managerId?: string | null,
      documentType?: DocumentType | null,
      subCategory?: string | null,
      category?: TaskCategory | null,
      period?: string | null,
      year?: string | null,
    } | null,
    bpay?:  {
      __typename: "ContactBpay",
      billerCode?: number | null,
      referenceNumber?: string | null,
    } | null,
    bank?:  {
      __typename: "DocumentAnalysisBankAccount",
      accountNumber?: string | null,
      routingNumber?: string | null,
    } | null,
    category?: TaskCategory | null,
    source?: DocumentAnalysisSource | null,
    isCorrect?: boolean | null,
    fromEmail?: string | null,
    textContent?: string | null,
    createdBy?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type DeleteDocumentAnalysisMutationVariables = {
  input?: DeleteDocumentAnalysisInput | null,
};

export type DeleteDocumentAnalysisMutation = {
  deleteDocumentAnalysis?:  {
    __typename: "DocumentAnalysis",
    id: string,
    entityId?: string | null,
    firmId?: string | null,
    fileKey?: string | null,
    documents?:  Array< {
      __typename: "S3Upload",
      identityId?: string | null,
      key: string,
      level: S3UploadLevel,
      type: S3UploadType,
      name?: string | null,
    } | null > | null,
    status: DocumentAnalysisStatus,
    expenseStatus?: DocumentAnalysisStatus | null,
    queryStatus?: DocumentAnalysisStatus | null,
    matchedBiller?:  {
      __typename: "BillerDetails",
      billerCode?: number | null,
      billerCategory?: string | null,
      shortName?: string | null,
      longName?: string | null,
      type?: BillerType | null,
      industryCode?: string | null,
      industryCodeDescription?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    matchedContactId?: string | null,
    matchedContact?:  {
      __typename: "Contact",
      id: string,
      entityId: string,
      xeroTenantId?: string | null,
      entityType?: EntityType | null,
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      mobile?: string | null,
      phone?: string | null,
      taxNumber?: string | null,
      companyNumber?: string | null,
      name?: string | null,
      legalName?: string | null,
      searchName?: string | null,
      status?: ContactStatus | null,
      website?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      contactType?: ContactType | null,
      bank?:  {
        __typename: "ContactBankAccount",
        id?: string | null,
        accountName?: string | null,
        bankName?: string | null,
        accountNumber: string,
        routingNumber: string,
        holderType?: BankHolderType | null,
        accountType?: BankAccountType | null,
        country?: string | null,
      } | null,
      bpay?:  {
        __typename: "ContactBpay",
        billerCode?: number | null,
        referenceNumber?: string | null,
      } | null,
      invalidFields?: Array< string | null > | null,
      bulkUploadFileKey?: string | null,
      owner?: string | null,
      createdBy?: string | null,
      beneficiaryBankId?: string | null,
      beneficiaryBpayId?: string | null,
      address?:  {
        __typename: "Address",
        addressId?: string | null,
        contactName?: string | null,
        contactNumber?: string | null,
        fullAddress?: string | null,
        address1?: string | null,
        address2?: string | null,
        city?: string | null,
        country: string,
        countryCode: string,
        state: string,
        stateCode?: string | null,
        postalCode: string,
        invalid?: boolean | null,
      } | null,
      postal?:  {
        __typename: "Address",
        addressId?: string | null,
        contactName?: string | null,
        contactNumber?: string | null,
        fullAddress?: string | null,
        address1?: string | null,
        address2?: string | null,
        city?: string | null,
        country: string,
        countryCode: string,
        state: string,
        stateCode?: string | null,
        postalCode: string,
        invalid?: boolean | null,
      } | null,
      payoutErrors?: Array< string | null > | null,
    } | null,
    matchedEntityId?: string | null,
    matchedEntity?:  {
      __typename: "Entity",
      id: string,
      type: EntityType,
      taxNumber?: string | null,
      companyNumber?: string | null,
      billerCode?: number | null,
      name: string,
      legalName?: string | null,
      businessNames?: Array< string | null > | null,
      searchName?: string | null,
      address?:  {
        __typename: "Address",
        addressId?: string | null,
        contactName?: string | null,
        contactNumber?: string | null,
        fullAddress?: string | null,
        address1?: string | null,
        address2?: string | null,
        city?: string | null,
        country: string,
        countryCode: string,
        state: string,
        stateCode?: string | null,
        postalCode: string,
        invalid?: boolean | null,
      } | null,
      logo?:  {
        __typename: "Image",
        alt?: string | null,
        identityId?: string | null,
        key: string,
        level: S3UploadLevel,
        type?: string | null,
      } | null,
      brandColour?: string | null,
      website?: string | null,
      entityUsers?:  {
        __typename: "ModelEntityUserConnection",
        items:  Array< {
          __typename: "EntityUser",
          id: string,
          entityId: string,
          userId: string,
          firmId?: string | null,
          email?: string | null,
          invitedEmail?: string | null,
          ocrEmail?: string | null,
          referredBy?: string | null,
          invitedEntityId?: string | null,
          firmEntityId?: string | null,
          providerContactId?: string | null,
          ownerCode?: string | null,
          clientGroupCode?: string | null,
          clientCode?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          role: EntityUserRole,
          jobTags?: Array< JobTags | null > | null,
          paymentsEnabled?: boolean | null,
          termsInvoiceAccepted?: boolean | null,
          termsOcrAccepted?: boolean | null,
          termsFirmPayTaxAccepted?: boolean | null,
          termsFirmPayTaxDetails?:  {
            __typename: "TermsFirmPayTaxDetails",
            document?:  {
              __typename: "S3Upload",
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type: S3UploadType,
              name?: string | null,
            } | null,
            acceptedAt?: string | null,
            email?: string | null,
            ip?: string | null,
            fullName?: string | null,
            firmId?: string | null,
          } | null,
          entitySearchName?: string | null,
          entity?:  {
            __typename: "Entity",
            id: string,
            type: EntityType,
            taxNumber?: string | null,
            companyNumber?: string | null,
            billerCode?: number | null,
            name: string,
            legalName?: string | null,
            businessNames?: Array< string | null > | null,
            searchName?: string | null,
            address?:  {
              __typename: "Address",
              addressId?: string | null,
              contactName?: string | null,
              contactNumber?: string | null,
              fullAddress?: string | null,
              address1?: string | null,
              address2?: string | null,
              city?: string | null,
              country: string,
              countryCode: string,
              state: string,
              stateCode?: string | null,
              postalCode: string,
              invalid?: boolean | null,
            } | null,
            logo?:  {
              __typename: "Image",
              alt?: string | null,
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type?: string | null,
            } | null,
            brandColour?: string | null,
            website?: string | null,
            entityUsers?:  {
              __typename: "ModelEntityUserConnection",
              items:  Array< {
                __typename: "EntityUser",
                id: string,
                entityId: string,
                userId: string,
                firmId?: string | null,
                email?: string | null,
                invitedEmail?: string | null,
                ocrEmail?: string | null,
                referredBy?: string | null,
                invitedEntityId?: string | null,
                firmEntityId?: string | null,
                providerContactId?: string | null,
                ownerCode?: string | null,
                clientGroupCode?: string | null,
                clientCode?: string | null,
                firstName?: string | null,
                lastName?: string | null,
                role: EntityUserRole,
                jobTags?: Array< JobTags | null > | null,
                paymentsEnabled?: boolean | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                termsFirmPayTaxAccepted?: boolean | null,
                entitySearchName?: string | null,
                searchName?: string | null,
                taxNumber?: string | null,
                taskSendSMS?: boolean | null,
                companyNumber?: string | null,
                createdBy?: string | null,
                createdAt: string,
                updatedAt: string,
                status?: EntityUserStatus | null,
                partnerId?: string | null,
                managerId?: string | null,
                archivedAt?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gstRegistered?: boolean | null,
            gstReportingPeriod?: GSTReportingPeriod | null,
            providerEntityId?: string | null,
            providerCompanyId?: string | null,
            providerBillUserCompanyId?: string | null,
            providerBankAccountId?: string | null,
            providerDigitalWalletId?: string | null,
            providerBpayCrn?: string | null,
            contact?:  {
              __typename: "EntityContact",
              firstName?: string | null,
              lastName?: string | null,
              email?: string | null,
              phone?: string | null,
              role?: string | null,
            } | null,
            paymentMethods?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            paymentMethodId?: string | null,
            paymentUserId?: string | null,
            disbursementMethodId?: string | null,
            receivingAccounts?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            ubosCreated?: boolean | null,
            numUbosCreated?: number | null,
            subCategory?: string | null,
            clientsStatus?: EntityClientsStatus | null,
            ocrEmail?: string | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            owner?: string | null,
            referredBy?: string | null,
            connectedAccount?: string | null,
            accountStatus?: AccountStatus | null,
            customerId?: string | null,
            xeroSyncStatus?: XeroSyncStatus | null,
            xeroLastContactSyncAt?: string | null,
            xeroContactSyncStatus?: XeroSyncStatus | null,
            xeroInvoiceSyncStatus?: XeroSyncStatus | null,
            xeroLastInvoiceSyncAt?: string | null,
            xeroTenantId?: string | null,
            absorbFees?: boolean | null,
            subscriptionTier?: SubscriptionTier | null,
            invitationStatus?: InvitationStatus | null,
            clientsOnboardingStatus?: ClientsOnboardingStatus | null,
            createdBy?: string | null,
            createdByEntityId?: string | null,
            isFirm?: boolean | null,
            createdAt?: string | null,
            updatedAt?: string | null,
          } | null,
          firm?:  {
            __typename: "Entity",
            id: string,
            type: EntityType,
            taxNumber?: string | null,
            companyNumber?: string | null,
            billerCode?: number | null,
            name: string,
            legalName?: string | null,
            businessNames?: Array< string | null > | null,
            searchName?: string | null,
            address?:  {
              __typename: "Address",
              addressId?: string | null,
              contactName?: string | null,
              contactNumber?: string | null,
              fullAddress?: string | null,
              address1?: string | null,
              address2?: string | null,
              city?: string | null,
              country: string,
              countryCode: string,
              state: string,
              stateCode?: string | null,
              postalCode: string,
              invalid?: boolean | null,
            } | null,
            logo?:  {
              __typename: "Image",
              alt?: string | null,
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type?: string | null,
            } | null,
            brandColour?: string | null,
            website?: string | null,
            entityUsers?:  {
              __typename: "ModelEntityUserConnection",
              items:  Array< {
                __typename: "EntityUser",
                id: string,
                entityId: string,
                userId: string,
                firmId?: string | null,
                email?: string | null,
                invitedEmail?: string | null,
                ocrEmail?: string | null,
                referredBy?: string | null,
                invitedEntityId?: string | null,
                firmEntityId?: string | null,
                providerContactId?: string | null,
                ownerCode?: string | null,
                clientGroupCode?: string | null,
                clientCode?: string | null,
                firstName?: string | null,
                lastName?: string | null,
                role: EntityUserRole,
                jobTags?: Array< JobTags | null > | null,
                paymentsEnabled?: boolean | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                termsFirmPayTaxAccepted?: boolean | null,
                entitySearchName?: string | null,
                searchName?: string | null,
                taxNumber?: string | null,
                taskSendSMS?: boolean | null,
                companyNumber?: string | null,
                createdBy?: string | null,
                createdAt: string,
                updatedAt: string,
                status?: EntityUserStatus | null,
                partnerId?: string | null,
                managerId?: string | null,
                archivedAt?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gstRegistered?: boolean | null,
            gstReportingPeriod?: GSTReportingPeriod | null,
            providerEntityId?: string | null,
            providerCompanyId?: string | null,
            providerBillUserCompanyId?: string | null,
            providerBankAccountId?: string | null,
            providerDigitalWalletId?: string | null,
            providerBpayCrn?: string | null,
            contact?:  {
              __typename: "EntityContact",
              firstName?: string | null,
              lastName?: string | null,
              email?: string | null,
              phone?: string | null,
              role?: string | null,
            } | null,
            paymentMethods?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            paymentMethodId?: string | null,
            paymentUserId?: string | null,
            disbursementMethodId?: string | null,
            receivingAccounts?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            ubosCreated?: boolean | null,
            numUbosCreated?: number | null,
            subCategory?: string | null,
            clientsStatus?: EntityClientsStatus | null,
            ocrEmail?: string | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            owner?: string | null,
            referredBy?: string | null,
            connectedAccount?: string | null,
            accountStatus?: AccountStatus | null,
            customerId?: string | null,
            xeroSyncStatus?: XeroSyncStatus | null,
            xeroLastContactSyncAt?: string | null,
            xeroContactSyncStatus?: XeroSyncStatus | null,
            xeroInvoiceSyncStatus?: XeroSyncStatus | null,
            xeroLastInvoiceSyncAt?: string | null,
            xeroTenantId?: string | null,
            absorbFees?: boolean | null,
            subscriptionTier?: SubscriptionTier | null,
            invitationStatus?: InvitationStatus | null,
            clientsOnboardingStatus?: ClientsOnboardingStatus | null,
            createdBy?: string | null,
            createdByEntityId?: string | null,
            isFirm?: boolean | null,
            createdAt?: string | null,
            updatedAt?: string | null,
          } | null,
          searchName?: string | null,
          taxNumber?: string | null,
          taskSendSMS?: boolean | null,
          companyNumber?: string | null,
          createdBy?: string | null,
          createdAt: string,
          updatedAt: string,
          status?: EntityUserStatus | null,
          partnerId?: string | null,
          managerId?: string | null,
          archivedAt?: string | null,
          taxPaymentReferences?:  {
            __typename: "TaxPaymentReferences",
            itr?:  {
              __typename: "TaxPaymentReference",
              referenceNumber?: string | null,
              updatedAt?: string | null,
            } | null,
            other?:  {
              __typename: "TaxPaymentReference",
              referenceNumber?: string | null,
              updatedAt?: string | null,
            } | null,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gstRegistered?: boolean | null,
      gstReportingPeriod?: GSTReportingPeriod | null,
      providerEntityId?: string | null,
      providerCompanyId?: string | null,
      providerBillUserCompanyId?: string | null,
      providerBankAccountId?: string | null,
      providerDigitalWalletId?: string | null,
      providerBpayCrn?: string | null,
      contact?:  {
        __typename: "EntityContact",
        firstName?: string | null,
        lastName?: string | null,
        email?: string | null,
        phone?: string | null,
        role?: string | null,
      } | null,
      paymentMethods?:  {
        __typename: "ModelPaymentMethodConnection",
        items:  Array< {
          __typename: "PaymentMethod",
          id: string,
          paymentMethodType: PaymentMethodType,
          type?: string | null,
          fullName?: string | null,
          number?: string | null,
          expMonth?: string | null,
          expYear?: string | null,
          accountName?: string | null,
          bankName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
          holderType?: BankHolderType | null,
          accountType?: BankAccountType | null,
          status?: PaymentMethodStatus | null,
          accountDirection?: AccountDirection | null,
          expiresAt?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          consentId?: string | null,
          consentStatus?: PaymentConsentStatus | null,
          card?: string | null,
          googlepay?: string | null,
          applepay?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      paymentMethodId?: string | null,
      paymentUserId?: string | null,
      disbursementMethodId?: string | null,
      receivingAccounts?:  {
        __typename: "ModelPaymentMethodConnection",
        items:  Array< {
          __typename: "PaymentMethod",
          id: string,
          paymentMethodType: PaymentMethodType,
          type?: string | null,
          fullName?: string | null,
          number?: string | null,
          expMonth?: string | null,
          expYear?: string | null,
          accountName?: string | null,
          bankName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
          holderType?: BankHolderType | null,
          accountType?: BankAccountType | null,
          status?: PaymentMethodStatus | null,
          accountDirection?: AccountDirection | null,
          expiresAt?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          consentId?: string | null,
          consentStatus?: PaymentConsentStatus | null,
          card?: string | null,
          googlepay?: string | null,
          applepay?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      ubosCreated?: boolean | null,
      numUbosCreated?: number | null,
      subCategory?: string | null,
      clientsStatus?: EntityClientsStatus | null,
      ocrEmail?: string | null,
      termsInvoiceAccepted?: boolean | null,
      termsOcrAccepted?: boolean | null,
      owner?: string | null,
      referredBy?: string | null,
      connectedAccount?: string | null,
      accountStatus?: AccountStatus | null,
      customerId?: string | null,
      xeroSyncStatus?: XeroSyncStatus | null,
      xeroLastContactSyncAt?: string | null,
      xeroContactSyncStatus?: XeroSyncStatus | null,
      xeroInvoiceSyncStatus?: XeroSyncStatus | null,
      xeroLastInvoiceSyncAt?: string | null,
      xeroTenantId?: string | null,
      absorbFees?: boolean | null,
      subscriptionTier?: SubscriptionTier | null,
      invitationStatus?: InvitationStatus | null,
      clientsOnboardingStatus?: ClientsOnboardingStatus | null,
      createdBy?: string | null,
      createdByEntityId?: string | null,
      isFirm?: boolean | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    newContact?:  {
      __typename: "DocumentAnalysisContact",
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      mobile?: string | null,
      phone?: string | null,
      name?: string | null,
      taxNumber?: string | null,
      address?:  {
        __typename: "Address",
        addressId?: string | null,
        contactName?: string | null,
        contactNumber?: string | null,
        fullAddress?: string | null,
        address1?: string | null,
        address2?: string | null,
        city?: string | null,
        country: string,
        countryCode: string,
        state: string,
        stateCode?: string | null,
        postalCode: string,
        invalid?: boolean | null,
      } | null,
    } | null,
    task?:  {
      __typename: "DocumentAnalysisTask",
      reference?: string | null,
      dueAt?: string | null,
      issuedAt?: string | null,
      lodgementAt?: string | null,
      paymentAt?: string | null,
      gstInclusive?: boolean | null,
      notes?: string | null,
      amount?: number | null,
      gstAmount?: number | null,
      taxAmount?: number | null,
      lineItems?:  Array< {
        __typename: "DocumentAnalysisLineItem",
        description?: string | null,
        quantity?: number | null,
        unitPrice?: number | null,
        price?: number | null,
        productCode?: string | null,
        taxType?: TaxType | null,
      } | null > | null,
      numberOfPayments?: number | null,
      paymentFrequency?: PaymentFrequency | null,
      shippingAmount?: number | null,
      settlementStatus?: TaskSettlementStatus | null,
      partnerId?: string | null,
      managerId?: string | null,
      documentType?: DocumentType | null,
      subCategory?: string | null,
      category?: TaskCategory | null,
      period?: string | null,
      year?: string | null,
    } | null,
    bpay?:  {
      __typename: "ContactBpay",
      billerCode?: number | null,
      referenceNumber?: string | null,
    } | null,
    bank?:  {
      __typename: "DocumentAnalysisBankAccount",
      accountNumber?: string | null,
      routingNumber?: string | null,
    } | null,
    category?: TaskCategory | null,
    source?: DocumentAnalysisSource | null,
    isCorrect?: boolean | null,
    fromEmail?: string | null,
    textContent?: string | null,
    createdBy?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type CreateEntityMutationVariables = {
  input: CreateEntityInput,
};

export type CreateEntityMutation = {
  createEntity?:  {
    __typename: "Entity",
    id: string,
    type: EntityType,
    taxNumber?: string | null,
    companyNumber?: string | null,
    billerCode?: number | null,
    name: string,
    legalName?: string | null,
    businessNames?: Array< string | null > | null,
    searchName?: string | null,
    address?:  {
      __typename: "Address",
      addressId?: string | null,
      contactName?: string | null,
      contactNumber?: string | null,
      fullAddress?: string | null,
      address1?: string | null,
      address2?: string | null,
      city?: string | null,
      country: string,
      countryCode: string,
      state: string,
      stateCode?: string | null,
      postalCode: string,
      invalid?: boolean | null,
    } | null,
    logo?:  {
      __typename: "Image",
      alt?: string | null,
      identityId?: string | null,
      key: string,
      level: S3UploadLevel,
      type?: string | null,
    } | null,
    brandColour?: string | null,
    website?: string | null,
    entityUsers?:  {
      __typename: "ModelEntityUserConnection",
      items:  Array< {
        __typename: "EntityUser",
        id: string,
        entityId: string,
        userId: string,
        firmId?: string | null,
        email?: string | null,
        invitedEmail?: string | null,
        ocrEmail?: string | null,
        referredBy?: string | null,
        invitedEntityId?: string | null,
        firmEntityId?: string | null,
        providerContactId?: string | null,
        ownerCode?: string | null,
        clientGroupCode?: string | null,
        clientCode?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        role: EntityUserRole,
        jobTags?: Array< JobTags | null > | null,
        paymentsEnabled?: boolean | null,
        termsInvoiceAccepted?: boolean | null,
        termsOcrAccepted?: boolean | null,
        termsFirmPayTaxAccepted?: boolean | null,
        termsFirmPayTaxDetails?:  {
          __typename: "TermsFirmPayTaxDetails",
          document?:  {
            __typename: "S3Upload",
            identityId?: string | null,
            key: string,
            level: S3UploadLevel,
            type: S3UploadType,
            name?: string | null,
          } | null,
          acceptedAt?: string | null,
          email?: string | null,
          ip?: string | null,
          fullName?: string | null,
          firmId?: string | null,
        } | null,
        entitySearchName?: string | null,
        entity?:  {
          __typename: "Entity",
          id: string,
          type: EntityType,
          taxNumber?: string | null,
          companyNumber?: string | null,
          billerCode?: number | null,
          name: string,
          legalName?: string | null,
          businessNames?: Array< string | null > | null,
          searchName?: string | null,
          address?:  {
            __typename: "Address",
            addressId?: string | null,
            contactName?: string | null,
            contactNumber?: string | null,
            fullAddress?: string | null,
            address1?: string | null,
            address2?: string | null,
            city?: string | null,
            country: string,
            countryCode: string,
            state: string,
            stateCode?: string | null,
            postalCode: string,
            invalid?: boolean | null,
          } | null,
          logo?:  {
            __typename: "Image",
            alt?: string | null,
            identityId?: string | null,
            key: string,
            level: S3UploadLevel,
            type?: string | null,
          } | null,
          brandColour?: string | null,
          website?: string | null,
          entityUsers?:  {
            __typename: "ModelEntityUserConnection",
            items:  Array< {
              __typename: "EntityUser",
              id: string,
              entityId: string,
              userId: string,
              firmId?: string | null,
              email?: string | null,
              invitedEmail?: string | null,
              ocrEmail?: string | null,
              referredBy?: string | null,
              invitedEntityId?: string | null,
              firmEntityId?: string | null,
              providerContactId?: string | null,
              ownerCode?: string | null,
              clientGroupCode?: string | null,
              clientCode?: string | null,
              firstName?: string | null,
              lastName?: string | null,
              role: EntityUserRole,
              jobTags?: Array< JobTags | null > | null,
              paymentsEnabled?: boolean | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              termsFirmPayTaxAccepted?: boolean | null,
              termsFirmPayTaxDetails?:  {
                __typename: "TermsFirmPayTaxDetails",
                acceptedAt?: string | null,
                email?: string | null,
                ip?: string | null,
                fullName?: string | null,
                firmId?: string | null,
              } | null,
              entitySearchName?: string | null,
              entity?:  {
                __typename: "Entity",
                id: string,
                type: EntityType,
                taxNumber?: string | null,
                companyNumber?: string | null,
                billerCode?: number | null,
                name: string,
                legalName?: string | null,
                businessNames?: Array< string | null > | null,
                searchName?: string | null,
                brandColour?: string | null,
                website?: string | null,
                gstRegistered?: boolean | null,
                gstReportingPeriod?: GSTReportingPeriod | null,
                providerEntityId?: string | null,
                providerCompanyId?: string | null,
                providerBillUserCompanyId?: string | null,
                providerBankAccountId?: string | null,
                providerDigitalWalletId?: string | null,
                providerBpayCrn?: string | null,
                paymentMethodId?: string | null,
                paymentUserId?: string | null,
                disbursementMethodId?: string | null,
                ubosCreated?: boolean | null,
                numUbosCreated?: number | null,
                subCategory?: string | null,
                clientsStatus?: EntityClientsStatus | null,
                ocrEmail?: string | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                owner?: string | null,
                referredBy?: string | null,
                connectedAccount?: string | null,
                accountStatus?: AccountStatus | null,
                customerId?: string | null,
                xeroSyncStatus?: XeroSyncStatus | null,
                xeroLastContactSyncAt?: string | null,
                xeroContactSyncStatus?: XeroSyncStatus | null,
                xeroInvoiceSyncStatus?: XeroSyncStatus | null,
                xeroLastInvoiceSyncAt?: string | null,
                xeroTenantId?: string | null,
                absorbFees?: boolean | null,
                subscriptionTier?: SubscriptionTier | null,
                invitationStatus?: InvitationStatus | null,
                clientsOnboardingStatus?: ClientsOnboardingStatus | null,
                createdBy?: string | null,
                createdByEntityId?: string | null,
                isFirm?: boolean | null,
                createdAt?: string | null,
                updatedAt?: string | null,
              } | null,
              firm?:  {
                __typename: "Entity",
                id: string,
                type: EntityType,
                taxNumber?: string | null,
                companyNumber?: string | null,
                billerCode?: number | null,
                name: string,
                legalName?: string | null,
                businessNames?: Array< string | null > | null,
                searchName?: string | null,
                brandColour?: string | null,
                website?: string | null,
                gstRegistered?: boolean | null,
                gstReportingPeriod?: GSTReportingPeriod | null,
                providerEntityId?: string | null,
                providerCompanyId?: string | null,
                providerBillUserCompanyId?: string | null,
                providerBankAccountId?: string | null,
                providerDigitalWalletId?: string | null,
                providerBpayCrn?: string | null,
                paymentMethodId?: string | null,
                paymentUserId?: string | null,
                disbursementMethodId?: string | null,
                ubosCreated?: boolean | null,
                numUbosCreated?: number | null,
                subCategory?: string | null,
                clientsStatus?: EntityClientsStatus | null,
                ocrEmail?: string | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                owner?: string | null,
                referredBy?: string | null,
                connectedAccount?: string | null,
                accountStatus?: AccountStatus | null,
                customerId?: string | null,
                xeroSyncStatus?: XeroSyncStatus | null,
                xeroLastContactSyncAt?: string | null,
                xeroContactSyncStatus?: XeroSyncStatus | null,
                xeroInvoiceSyncStatus?: XeroSyncStatus | null,
                xeroLastInvoiceSyncAt?: string | null,
                xeroTenantId?: string | null,
                absorbFees?: boolean | null,
                subscriptionTier?: SubscriptionTier | null,
                invitationStatus?: InvitationStatus | null,
                clientsOnboardingStatus?: ClientsOnboardingStatus | null,
                createdBy?: string | null,
                createdByEntityId?: string | null,
                isFirm?: boolean | null,
                createdAt?: string | null,
                updatedAt?: string | null,
              } | null,
              searchName?: string | null,
              taxNumber?: string | null,
              taskSendSMS?: boolean | null,
              companyNumber?: string | null,
              createdBy?: string | null,
              createdAt: string,
              updatedAt: string,
              status?: EntityUserStatus | null,
              partnerId?: string | null,
              managerId?: string | null,
              archivedAt?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gstRegistered?: boolean | null,
          gstReportingPeriod?: GSTReportingPeriod | null,
          providerEntityId?: string | null,
          providerCompanyId?: string | null,
          providerBillUserCompanyId?: string | null,
          providerBankAccountId?: string | null,
          providerDigitalWalletId?: string | null,
          providerBpayCrn?: string | null,
          contact?:  {
            __typename: "EntityContact",
            firstName?: string | null,
            lastName?: string | null,
            email?: string | null,
            phone?: string | null,
            role?: string | null,
          } | null,
          paymentMethods?:  {
            __typename: "ModelPaymentMethodConnection",
            items:  Array< {
              __typename: "PaymentMethod",
              id: string,
              paymentMethodType: PaymentMethodType,
              type?: string | null,
              fullName?: string | null,
              number?: string | null,
              expMonth?: string | null,
              expYear?: string | null,
              accountName?: string | null,
              bankName?: string | null,
              accountNumber?: string | null,
              routingNumber?: string | null,
              holderType?: BankHolderType | null,
              accountType?: BankAccountType | null,
              status?: PaymentMethodStatus | null,
              accountDirection?: AccountDirection | null,
              expiresAt?: string | null,
              createdAt?: string | null,
              updatedAt?: string | null,
              consentId?: string | null,
              consentStatus?: PaymentConsentStatus | null,
              card?: string | null,
              googlepay?: string | null,
              applepay?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          paymentMethodId?: string | null,
          paymentUserId?: string | null,
          disbursementMethodId?: string | null,
          receivingAccounts?:  {
            __typename: "ModelPaymentMethodConnection",
            items:  Array< {
              __typename: "PaymentMethod",
              id: string,
              paymentMethodType: PaymentMethodType,
              type?: string | null,
              fullName?: string | null,
              number?: string | null,
              expMonth?: string | null,
              expYear?: string | null,
              accountName?: string | null,
              bankName?: string | null,
              accountNumber?: string | null,
              routingNumber?: string | null,
              holderType?: BankHolderType | null,
              accountType?: BankAccountType | null,
              status?: PaymentMethodStatus | null,
              accountDirection?: AccountDirection | null,
              expiresAt?: string | null,
              createdAt?: string | null,
              updatedAt?: string | null,
              consentId?: string | null,
              consentStatus?: PaymentConsentStatus | null,
              card?: string | null,
              googlepay?: string | null,
              applepay?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          ubosCreated?: boolean | null,
          numUbosCreated?: number | null,
          subCategory?: string | null,
          clientsStatus?: EntityClientsStatus | null,
          ocrEmail?: string | null,
          termsInvoiceAccepted?: boolean | null,
          termsOcrAccepted?: boolean | null,
          owner?: string | null,
          referredBy?: string | null,
          connectedAccount?: string | null,
          accountStatus?: AccountStatus | null,
          customerId?: string | null,
          xeroSyncStatus?: XeroSyncStatus | null,
          xeroLastContactSyncAt?: string | null,
          xeroContactSyncStatus?: XeroSyncStatus | null,
          xeroInvoiceSyncStatus?: XeroSyncStatus | null,
          xeroLastInvoiceSyncAt?: string | null,
          xeroTenantId?: string | null,
          absorbFees?: boolean | null,
          subscriptionTier?: SubscriptionTier | null,
          invitationStatus?: InvitationStatus | null,
          clientsOnboardingStatus?: ClientsOnboardingStatus | null,
          createdBy?: string | null,
          createdByEntityId?: string | null,
          isFirm?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | null,
        firm?:  {
          __typename: "Entity",
          id: string,
          type: EntityType,
          taxNumber?: string | null,
          companyNumber?: string | null,
          billerCode?: number | null,
          name: string,
          legalName?: string | null,
          businessNames?: Array< string | null > | null,
          searchName?: string | null,
          address?:  {
            __typename: "Address",
            addressId?: string | null,
            contactName?: string | null,
            contactNumber?: string | null,
            fullAddress?: string | null,
            address1?: string | null,
            address2?: string | null,
            city?: string | null,
            country: string,
            countryCode: string,
            state: string,
            stateCode?: string | null,
            postalCode: string,
            invalid?: boolean | null,
          } | null,
          logo?:  {
            __typename: "Image",
            alt?: string | null,
            identityId?: string | null,
            key: string,
            level: S3UploadLevel,
            type?: string | null,
          } | null,
          brandColour?: string | null,
          website?: string | null,
          entityUsers?:  {
            __typename: "ModelEntityUserConnection",
            items:  Array< {
              __typename: "EntityUser",
              id: string,
              entityId: string,
              userId: string,
              firmId?: string | null,
              email?: string | null,
              invitedEmail?: string | null,
              ocrEmail?: string | null,
              referredBy?: string | null,
              invitedEntityId?: string | null,
              firmEntityId?: string | null,
              providerContactId?: string | null,
              ownerCode?: string | null,
              clientGroupCode?: string | null,
              clientCode?: string | null,
              firstName?: string | null,
              lastName?: string | null,
              role: EntityUserRole,
              jobTags?: Array< JobTags | null > | null,
              paymentsEnabled?: boolean | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              termsFirmPayTaxAccepted?: boolean | null,
              termsFirmPayTaxDetails?:  {
                __typename: "TermsFirmPayTaxDetails",
                acceptedAt?: string | null,
                email?: string | null,
                ip?: string | null,
                fullName?: string | null,
                firmId?: string | null,
              } | null,
              entitySearchName?: string | null,
              entity?:  {
                __typename: "Entity",
                id: string,
                type: EntityType,
                taxNumber?: string | null,
                companyNumber?: string | null,
                billerCode?: number | null,
                name: string,
                legalName?: string | null,
                businessNames?: Array< string | null > | null,
                searchName?: string | null,
                brandColour?: string | null,
                website?: string | null,
                gstRegistered?: boolean | null,
                gstReportingPeriod?: GSTReportingPeriod | null,
                providerEntityId?: string | null,
                providerCompanyId?: string | null,
                providerBillUserCompanyId?: string | null,
                providerBankAccountId?: string | null,
                providerDigitalWalletId?: string | null,
                providerBpayCrn?: string | null,
                paymentMethodId?: string | null,
                paymentUserId?: string | null,
                disbursementMethodId?: string | null,
                ubosCreated?: boolean | null,
                numUbosCreated?: number | null,
                subCategory?: string | null,
                clientsStatus?: EntityClientsStatus | null,
                ocrEmail?: string | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                owner?: string | null,
                referredBy?: string | null,
                connectedAccount?: string | null,
                accountStatus?: AccountStatus | null,
                customerId?: string | null,
                xeroSyncStatus?: XeroSyncStatus | null,
                xeroLastContactSyncAt?: string | null,
                xeroContactSyncStatus?: XeroSyncStatus | null,
                xeroInvoiceSyncStatus?: XeroSyncStatus | null,
                xeroLastInvoiceSyncAt?: string | null,
                xeroTenantId?: string | null,
                absorbFees?: boolean | null,
                subscriptionTier?: SubscriptionTier | null,
                invitationStatus?: InvitationStatus | null,
                clientsOnboardingStatus?: ClientsOnboardingStatus | null,
                createdBy?: string | null,
                createdByEntityId?: string | null,
                isFirm?: boolean | null,
                createdAt?: string | null,
                updatedAt?: string | null,
              } | null,
              firm?:  {
                __typename: "Entity",
                id: string,
                type: EntityType,
                taxNumber?: string | null,
                companyNumber?: string | null,
                billerCode?: number | null,
                name: string,
                legalName?: string | null,
                businessNames?: Array< string | null > | null,
                searchName?: string | null,
                brandColour?: string | null,
                website?: string | null,
                gstRegistered?: boolean | null,
                gstReportingPeriod?: GSTReportingPeriod | null,
                providerEntityId?: string | null,
                providerCompanyId?: string | null,
                providerBillUserCompanyId?: string | null,
                providerBankAccountId?: string | null,
                providerDigitalWalletId?: string | null,
                providerBpayCrn?: string | null,
                paymentMethodId?: string | null,
                paymentUserId?: string | null,
                disbursementMethodId?: string | null,
                ubosCreated?: boolean | null,
                numUbosCreated?: number | null,
                subCategory?: string | null,
                clientsStatus?: EntityClientsStatus | null,
                ocrEmail?: string | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                owner?: string | null,
                referredBy?: string | null,
                connectedAccount?: string | null,
                accountStatus?: AccountStatus | null,
                customerId?: string | null,
                xeroSyncStatus?: XeroSyncStatus | null,
                xeroLastContactSyncAt?: string | null,
                xeroContactSyncStatus?: XeroSyncStatus | null,
                xeroInvoiceSyncStatus?: XeroSyncStatus | null,
                xeroLastInvoiceSyncAt?: string | null,
                xeroTenantId?: string | null,
                absorbFees?: boolean | null,
                subscriptionTier?: SubscriptionTier | null,
                invitationStatus?: InvitationStatus | null,
                clientsOnboardingStatus?: ClientsOnboardingStatus | null,
                createdBy?: string | null,
                createdByEntityId?: string | null,
                isFirm?: boolean | null,
                createdAt?: string | null,
                updatedAt?: string | null,
              } | null,
              searchName?: string | null,
              taxNumber?: string | null,
              taskSendSMS?: boolean | null,
              companyNumber?: string | null,
              createdBy?: string | null,
              createdAt: string,
              updatedAt: string,
              status?: EntityUserStatus | null,
              partnerId?: string | null,
              managerId?: string | null,
              archivedAt?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gstRegistered?: boolean | null,
          gstReportingPeriod?: GSTReportingPeriod | null,
          providerEntityId?: string | null,
          providerCompanyId?: string | null,
          providerBillUserCompanyId?: string | null,
          providerBankAccountId?: string | null,
          providerDigitalWalletId?: string | null,
          providerBpayCrn?: string | null,
          contact?:  {
            __typename: "EntityContact",
            firstName?: string | null,
            lastName?: string | null,
            email?: string | null,
            phone?: string | null,
            role?: string | null,
          } | null,
          paymentMethods?:  {
            __typename: "ModelPaymentMethodConnection",
            items:  Array< {
              __typename: "PaymentMethod",
              id: string,
              paymentMethodType: PaymentMethodType,
              type?: string | null,
              fullName?: string | null,
              number?: string | null,
              expMonth?: string | null,
              expYear?: string | null,
              accountName?: string | null,
              bankName?: string | null,
              accountNumber?: string | null,
              routingNumber?: string | null,
              holderType?: BankHolderType | null,
              accountType?: BankAccountType | null,
              status?: PaymentMethodStatus | null,
              accountDirection?: AccountDirection | null,
              expiresAt?: string | null,
              createdAt?: string | null,
              updatedAt?: string | null,
              consentId?: string | null,
              consentStatus?: PaymentConsentStatus | null,
              card?: string | null,
              googlepay?: string | null,
              applepay?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          paymentMethodId?: string | null,
          paymentUserId?: string | null,
          disbursementMethodId?: string | null,
          receivingAccounts?:  {
            __typename: "ModelPaymentMethodConnection",
            items:  Array< {
              __typename: "PaymentMethod",
              id: string,
              paymentMethodType: PaymentMethodType,
              type?: string | null,
              fullName?: string | null,
              number?: string | null,
              expMonth?: string | null,
              expYear?: string | null,
              accountName?: string | null,
              bankName?: string | null,
              accountNumber?: string | null,
              routingNumber?: string | null,
              holderType?: BankHolderType | null,
              accountType?: BankAccountType | null,
              status?: PaymentMethodStatus | null,
              accountDirection?: AccountDirection | null,
              expiresAt?: string | null,
              createdAt?: string | null,
              updatedAt?: string | null,
              consentId?: string | null,
              consentStatus?: PaymentConsentStatus | null,
              card?: string | null,
              googlepay?: string | null,
              applepay?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          ubosCreated?: boolean | null,
          numUbosCreated?: number | null,
          subCategory?: string | null,
          clientsStatus?: EntityClientsStatus | null,
          ocrEmail?: string | null,
          termsInvoiceAccepted?: boolean | null,
          termsOcrAccepted?: boolean | null,
          owner?: string | null,
          referredBy?: string | null,
          connectedAccount?: string | null,
          accountStatus?: AccountStatus | null,
          customerId?: string | null,
          xeroSyncStatus?: XeroSyncStatus | null,
          xeroLastContactSyncAt?: string | null,
          xeroContactSyncStatus?: XeroSyncStatus | null,
          xeroInvoiceSyncStatus?: XeroSyncStatus | null,
          xeroLastInvoiceSyncAt?: string | null,
          xeroTenantId?: string | null,
          absorbFees?: boolean | null,
          subscriptionTier?: SubscriptionTier | null,
          invitationStatus?: InvitationStatus | null,
          clientsOnboardingStatus?: ClientsOnboardingStatus | null,
          createdBy?: string | null,
          createdByEntityId?: string | null,
          isFirm?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | null,
        searchName?: string | null,
        taxNumber?: string | null,
        taskSendSMS?: boolean | null,
        companyNumber?: string | null,
        createdBy?: string | null,
        createdAt: string,
        updatedAt: string,
        status?: EntityUserStatus | null,
        partnerId?: string | null,
        managerId?: string | null,
        archivedAt?: string | null,
        taxPaymentReferences?:  {
          __typename: "TaxPaymentReferences",
          itr?:  {
            __typename: "TaxPaymentReference",
            referenceNumber?: string | null,
            updatedAt?: string | null,
          } | null,
          other?:  {
            __typename: "TaxPaymentReference",
            referenceNumber?: string | null,
            updatedAt?: string | null,
          } | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    gstRegistered?: boolean | null,
    gstReportingPeriod?: GSTReportingPeriod | null,
    providerEntityId?: string | null,
    providerCompanyId?: string | null,
    providerBillUserCompanyId?: string | null,
    providerBankAccountId?: string | null,
    providerDigitalWalletId?: string | null,
    providerBpayCrn?: string | null,
    contact?:  {
      __typename: "EntityContact",
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      phone?: string | null,
      role?: string | null,
    } | null,
    paymentMethods?:  {
      __typename: "ModelPaymentMethodConnection",
      items:  Array< {
        __typename: "PaymentMethod",
        id: string,
        paymentMethodType: PaymentMethodType,
        type?: string | null,
        fullName?: string | null,
        number?: string | null,
        expMonth?: string | null,
        expYear?: string | null,
        accountName?: string | null,
        bankName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
        holderType?: BankHolderType | null,
        accountType?: BankAccountType | null,
        status?: PaymentMethodStatus | null,
        accountDirection?: AccountDirection | null,
        expiresAt?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        consentId?: string | null,
        consentStatus?: PaymentConsentStatus | null,
        card?: string | null,
        googlepay?: string | null,
        applepay?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    paymentMethodId?: string | null,
    paymentUserId?: string | null,
    disbursementMethodId?: string | null,
    receivingAccounts?:  {
      __typename: "ModelPaymentMethodConnection",
      items:  Array< {
        __typename: "PaymentMethod",
        id: string,
        paymentMethodType: PaymentMethodType,
        type?: string | null,
        fullName?: string | null,
        number?: string | null,
        expMonth?: string | null,
        expYear?: string | null,
        accountName?: string | null,
        bankName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
        holderType?: BankHolderType | null,
        accountType?: BankAccountType | null,
        status?: PaymentMethodStatus | null,
        accountDirection?: AccountDirection | null,
        expiresAt?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        consentId?: string | null,
        consentStatus?: PaymentConsentStatus | null,
        card?: string | null,
        googlepay?: string | null,
        applepay?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    ubosCreated?: boolean | null,
    numUbosCreated?: number | null,
    subCategory?: string | null,
    clientsStatus?: EntityClientsStatus | null,
    ocrEmail?: string | null,
    termsInvoiceAccepted?: boolean | null,
    termsOcrAccepted?: boolean | null,
    owner?: string | null,
    referredBy?: string | null,
    connectedAccount?: string | null,
    accountStatus?: AccountStatus | null,
    customerId?: string | null,
    xeroSyncStatus?: XeroSyncStatus | null,
    xeroLastContactSyncAt?: string | null,
    xeroContactSyncStatus?: XeroSyncStatus | null,
    xeroInvoiceSyncStatus?: XeroSyncStatus | null,
    xeroLastInvoiceSyncAt?: string | null,
    xeroTenantId?: string | null,
    absorbFees?: boolean | null,
    subscriptionTier?: SubscriptionTier | null,
    invitationStatus?: InvitationStatus | null,
    clientsOnboardingStatus?: ClientsOnboardingStatus | null,
    createdBy?: string | null,
    createdByEntityId?: string | null,
    isFirm?: boolean | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type UpdateEntityMutationVariables = {
  input: UpdateEntityInput,
};

export type UpdateEntityMutation = {
  updateEntity?:  {
    __typename: "Entity",
    id: string,
    type: EntityType,
    taxNumber?: string | null,
    companyNumber?: string | null,
    billerCode?: number | null,
    name: string,
    legalName?: string | null,
    businessNames?: Array< string | null > | null,
    searchName?: string | null,
    address?:  {
      __typename: "Address",
      addressId?: string | null,
      contactName?: string | null,
      contactNumber?: string | null,
      fullAddress?: string | null,
      address1?: string | null,
      address2?: string | null,
      city?: string | null,
      country: string,
      countryCode: string,
      state: string,
      stateCode?: string | null,
      postalCode: string,
      invalid?: boolean | null,
    } | null,
    logo?:  {
      __typename: "Image",
      alt?: string | null,
      identityId?: string | null,
      key: string,
      level: S3UploadLevel,
      type?: string | null,
    } | null,
    brandColour?: string | null,
    website?: string | null,
    entityUsers?:  {
      __typename: "ModelEntityUserConnection",
      items:  Array< {
        __typename: "EntityUser",
        id: string,
        entityId: string,
        userId: string,
        firmId?: string | null,
        email?: string | null,
        invitedEmail?: string | null,
        ocrEmail?: string | null,
        referredBy?: string | null,
        invitedEntityId?: string | null,
        firmEntityId?: string | null,
        providerContactId?: string | null,
        ownerCode?: string | null,
        clientGroupCode?: string | null,
        clientCode?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        role: EntityUserRole,
        jobTags?: Array< JobTags | null > | null,
        paymentsEnabled?: boolean | null,
        termsInvoiceAccepted?: boolean | null,
        termsOcrAccepted?: boolean | null,
        termsFirmPayTaxAccepted?: boolean | null,
        termsFirmPayTaxDetails?:  {
          __typename: "TermsFirmPayTaxDetails",
          document?:  {
            __typename: "S3Upload",
            identityId?: string | null,
            key: string,
            level: S3UploadLevel,
            type: S3UploadType,
            name?: string | null,
          } | null,
          acceptedAt?: string | null,
          email?: string | null,
          ip?: string | null,
          fullName?: string | null,
          firmId?: string | null,
        } | null,
        entitySearchName?: string | null,
        entity?:  {
          __typename: "Entity",
          id: string,
          type: EntityType,
          taxNumber?: string | null,
          companyNumber?: string | null,
          billerCode?: number | null,
          name: string,
          legalName?: string | null,
          businessNames?: Array< string | null > | null,
          searchName?: string | null,
          address?:  {
            __typename: "Address",
            addressId?: string | null,
            contactName?: string | null,
            contactNumber?: string | null,
            fullAddress?: string | null,
            address1?: string | null,
            address2?: string | null,
            city?: string | null,
            country: string,
            countryCode: string,
            state: string,
            stateCode?: string | null,
            postalCode: string,
            invalid?: boolean | null,
          } | null,
          logo?:  {
            __typename: "Image",
            alt?: string | null,
            identityId?: string | null,
            key: string,
            level: S3UploadLevel,
            type?: string | null,
          } | null,
          brandColour?: string | null,
          website?: string | null,
          entityUsers?:  {
            __typename: "ModelEntityUserConnection",
            items:  Array< {
              __typename: "EntityUser",
              id: string,
              entityId: string,
              userId: string,
              firmId?: string | null,
              email?: string | null,
              invitedEmail?: string | null,
              ocrEmail?: string | null,
              referredBy?: string | null,
              invitedEntityId?: string | null,
              firmEntityId?: string | null,
              providerContactId?: string | null,
              ownerCode?: string | null,
              clientGroupCode?: string | null,
              clientCode?: string | null,
              firstName?: string | null,
              lastName?: string | null,
              role: EntityUserRole,
              jobTags?: Array< JobTags | null > | null,
              paymentsEnabled?: boolean | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              termsFirmPayTaxAccepted?: boolean | null,
              termsFirmPayTaxDetails?:  {
                __typename: "TermsFirmPayTaxDetails",
                acceptedAt?: string | null,
                email?: string | null,
                ip?: string | null,
                fullName?: string | null,
                firmId?: string | null,
              } | null,
              entitySearchName?: string | null,
              entity?:  {
                __typename: "Entity",
                id: string,
                type: EntityType,
                taxNumber?: string | null,
                companyNumber?: string | null,
                billerCode?: number | null,
                name: string,
                legalName?: string | null,
                businessNames?: Array< string | null > | null,
                searchName?: string | null,
                brandColour?: string | null,
                website?: string | null,
                gstRegistered?: boolean | null,
                gstReportingPeriod?: GSTReportingPeriod | null,
                providerEntityId?: string | null,
                providerCompanyId?: string | null,
                providerBillUserCompanyId?: string | null,
                providerBankAccountId?: string | null,
                providerDigitalWalletId?: string | null,
                providerBpayCrn?: string | null,
                paymentMethodId?: string | null,
                paymentUserId?: string | null,
                disbursementMethodId?: string | null,
                ubosCreated?: boolean | null,
                numUbosCreated?: number | null,
                subCategory?: string | null,
                clientsStatus?: EntityClientsStatus | null,
                ocrEmail?: string | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                owner?: string | null,
                referredBy?: string | null,
                connectedAccount?: string | null,
                accountStatus?: AccountStatus | null,
                customerId?: string | null,
                xeroSyncStatus?: XeroSyncStatus | null,
                xeroLastContactSyncAt?: string | null,
                xeroContactSyncStatus?: XeroSyncStatus | null,
                xeroInvoiceSyncStatus?: XeroSyncStatus | null,
                xeroLastInvoiceSyncAt?: string | null,
                xeroTenantId?: string | null,
                absorbFees?: boolean | null,
                subscriptionTier?: SubscriptionTier | null,
                invitationStatus?: InvitationStatus | null,
                clientsOnboardingStatus?: ClientsOnboardingStatus | null,
                createdBy?: string | null,
                createdByEntityId?: string | null,
                isFirm?: boolean | null,
                createdAt?: string | null,
                updatedAt?: string | null,
              } | null,
              firm?:  {
                __typename: "Entity",
                id: string,
                type: EntityType,
                taxNumber?: string | null,
                companyNumber?: string | null,
                billerCode?: number | null,
                name: string,
                legalName?: string | null,
                businessNames?: Array< string | null > | null,
                searchName?: string | null,
                brandColour?: string | null,
                website?: string | null,
                gstRegistered?: boolean | null,
                gstReportingPeriod?: GSTReportingPeriod | null,
                providerEntityId?: string | null,
                providerCompanyId?: string | null,
                providerBillUserCompanyId?: string | null,
                providerBankAccountId?: string | null,
                providerDigitalWalletId?: string | null,
                providerBpayCrn?: string | null,
                paymentMethodId?: string | null,
                paymentUserId?: string | null,
                disbursementMethodId?: string | null,
                ubosCreated?: boolean | null,
                numUbosCreated?: number | null,
                subCategory?: string | null,
                clientsStatus?: EntityClientsStatus | null,
                ocrEmail?: string | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                owner?: string | null,
                referredBy?: string | null,
                connectedAccount?: string | null,
                accountStatus?: AccountStatus | null,
                customerId?: string | null,
                xeroSyncStatus?: XeroSyncStatus | null,
                xeroLastContactSyncAt?: string | null,
                xeroContactSyncStatus?: XeroSyncStatus | null,
                xeroInvoiceSyncStatus?: XeroSyncStatus | null,
                xeroLastInvoiceSyncAt?: string | null,
                xeroTenantId?: string | null,
                absorbFees?: boolean | null,
                subscriptionTier?: SubscriptionTier | null,
                invitationStatus?: InvitationStatus | null,
                clientsOnboardingStatus?: ClientsOnboardingStatus | null,
                createdBy?: string | null,
                createdByEntityId?: string | null,
                isFirm?: boolean | null,
                createdAt?: string | null,
                updatedAt?: string | null,
              } | null,
              searchName?: string | null,
              taxNumber?: string | null,
              taskSendSMS?: boolean | null,
              companyNumber?: string | null,
              createdBy?: string | null,
              createdAt: string,
              updatedAt: string,
              status?: EntityUserStatus | null,
              partnerId?: string | null,
              managerId?: string | null,
              archivedAt?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gstRegistered?: boolean | null,
          gstReportingPeriod?: GSTReportingPeriod | null,
          providerEntityId?: string | null,
          providerCompanyId?: string | null,
          providerBillUserCompanyId?: string | null,
          providerBankAccountId?: string | null,
          providerDigitalWalletId?: string | null,
          providerBpayCrn?: string | null,
          contact?:  {
            __typename: "EntityContact",
            firstName?: string | null,
            lastName?: string | null,
            email?: string | null,
            phone?: string | null,
            role?: string | null,
          } | null,
          paymentMethods?:  {
            __typename: "ModelPaymentMethodConnection",
            items:  Array< {
              __typename: "PaymentMethod",
              id: string,
              paymentMethodType: PaymentMethodType,
              type?: string | null,
              fullName?: string | null,
              number?: string | null,
              expMonth?: string | null,
              expYear?: string | null,
              accountName?: string | null,
              bankName?: string | null,
              accountNumber?: string | null,
              routingNumber?: string | null,
              holderType?: BankHolderType | null,
              accountType?: BankAccountType | null,
              status?: PaymentMethodStatus | null,
              accountDirection?: AccountDirection | null,
              expiresAt?: string | null,
              createdAt?: string | null,
              updatedAt?: string | null,
              consentId?: string | null,
              consentStatus?: PaymentConsentStatus | null,
              card?: string | null,
              googlepay?: string | null,
              applepay?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          paymentMethodId?: string | null,
          paymentUserId?: string | null,
          disbursementMethodId?: string | null,
          receivingAccounts?:  {
            __typename: "ModelPaymentMethodConnection",
            items:  Array< {
              __typename: "PaymentMethod",
              id: string,
              paymentMethodType: PaymentMethodType,
              type?: string | null,
              fullName?: string | null,
              number?: string | null,
              expMonth?: string | null,
              expYear?: string | null,
              accountName?: string | null,
              bankName?: string | null,
              accountNumber?: string | null,
              routingNumber?: string | null,
              holderType?: BankHolderType | null,
              accountType?: BankAccountType | null,
              status?: PaymentMethodStatus | null,
              accountDirection?: AccountDirection | null,
              expiresAt?: string | null,
              createdAt?: string | null,
              updatedAt?: string | null,
              consentId?: string | null,
              consentStatus?: PaymentConsentStatus | null,
              card?: string | null,
              googlepay?: string | null,
              applepay?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          ubosCreated?: boolean | null,
          numUbosCreated?: number | null,
          subCategory?: string | null,
          clientsStatus?: EntityClientsStatus | null,
          ocrEmail?: string | null,
          termsInvoiceAccepted?: boolean | null,
          termsOcrAccepted?: boolean | null,
          owner?: string | null,
          referredBy?: string | null,
          connectedAccount?: string | null,
          accountStatus?: AccountStatus | null,
          customerId?: string | null,
          xeroSyncStatus?: XeroSyncStatus | null,
          xeroLastContactSyncAt?: string | null,
          xeroContactSyncStatus?: XeroSyncStatus | null,
          xeroInvoiceSyncStatus?: XeroSyncStatus | null,
          xeroLastInvoiceSyncAt?: string | null,
          xeroTenantId?: string | null,
          absorbFees?: boolean | null,
          subscriptionTier?: SubscriptionTier | null,
          invitationStatus?: InvitationStatus | null,
          clientsOnboardingStatus?: ClientsOnboardingStatus | null,
          createdBy?: string | null,
          createdByEntityId?: string | null,
          isFirm?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | null,
        firm?:  {
          __typename: "Entity",
          id: string,
          type: EntityType,
          taxNumber?: string | null,
          companyNumber?: string | null,
          billerCode?: number | null,
          name: string,
          legalName?: string | null,
          businessNames?: Array< string | null > | null,
          searchName?: string | null,
          address?:  {
            __typename: "Address",
            addressId?: string | null,
            contactName?: string | null,
            contactNumber?: string | null,
            fullAddress?: string | null,
            address1?: string | null,
            address2?: string | null,
            city?: string | null,
            country: string,
            countryCode: string,
            state: string,
            stateCode?: string | null,
            postalCode: string,
            invalid?: boolean | null,
          } | null,
          logo?:  {
            __typename: "Image",
            alt?: string | null,
            identityId?: string | null,
            key: string,
            level: S3UploadLevel,
            type?: string | null,
          } | null,
          brandColour?: string | null,
          website?: string | null,
          entityUsers?:  {
            __typename: "ModelEntityUserConnection",
            items:  Array< {
              __typename: "EntityUser",
              id: string,
              entityId: string,
              userId: string,
              firmId?: string | null,
              email?: string | null,
              invitedEmail?: string | null,
              ocrEmail?: string | null,
              referredBy?: string | null,
              invitedEntityId?: string | null,
              firmEntityId?: string | null,
              providerContactId?: string | null,
              ownerCode?: string | null,
              clientGroupCode?: string | null,
              clientCode?: string | null,
              firstName?: string | null,
              lastName?: string | null,
              role: EntityUserRole,
              jobTags?: Array< JobTags | null > | null,
              paymentsEnabled?: boolean | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              termsFirmPayTaxAccepted?: boolean | null,
              termsFirmPayTaxDetails?:  {
                __typename: "TermsFirmPayTaxDetails",
                acceptedAt?: string | null,
                email?: string | null,
                ip?: string | null,
                fullName?: string | null,
                firmId?: string | null,
              } | null,
              entitySearchName?: string | null,
              entity?:  {
                __typename: "Entity",
                id: string,
                type: EntityType,
                taxNumber?: string | null,
                companyNumber?: string | null,
                billerCode?: number | null,
                name: string,
                legalName?: string | null,
                businessNames?: Array< string | null > | null,
                searchName?: string | null,
                brandColour?: string | null,
                website?: string | null,
                gstRegistered?: boolean | null,
                gstReportingPeriod?: GSTReportingPeriod | null,
                providerEntityId?: string | null,
                providerCompanyId?: string | null,
                providerBillUserCompanyId?: string | null,
                providerBankAccountId?: string | null,
                providerDigitalWalletId?: string | null,
                providerBpayCrn?: string | null,
                paymentMethodId?: string | null,
                paymentUserId?: string | null,
                disbursementMethodId?: string | null,
                ubosCreated?: boolean | null,
                numUbosCreated?: number | null,
                subCategory?: string | null,
                clientsStatus?: EntityClientsStatus | null,
                ocrEmail?: string | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                owner?: string | null,
                referredBy?: string | null,
                connectedAccount?: string | null,
                accountStatus?: AccountStatus | null,
                customerId?: string | null,
                xeroSyncStatus?: XeroSyncStatus | null,
                xeroLastContactSyncAt?: string | null,
                xeroContactSyncStatus?: XeroSyncStatus | null,
                xeroInvoiceSyncStatus?: XeroSyncStatus | null,
                xeroLastInvoiceSyncAt?: string | null,
                xeroTenantId?: string | null,
                absorbFees?: boolean | null,
                subscriptionTier?: SubscriptionTier | null,
                invitationStatus?: InvitationStatus | null,
                clientsOnboardingStatus?: ClientsOnboardingStatus | null,
                createdBy?: string | null,
                createdByEntityId?: string | null,
                isFirm?: boolean | null,
                createdAt?: string | null,
                updatedAt?: string | null,
              } | null,
              firm?:  {
                __typename: "Entity",
                id: string,
                type: EntityType,
                taxNumber?: string | null,
                companyNumber?: string | null,
                billerCode?: number | null,
                name: string,
                legalName?: string | null,
                businessNames?: Array< string | null > | null,
                searchName?: string | null,
                brandColour?: string | null,
                website?: string | null,
                gstRegistered?: boolean | null,
                gstReportingPeriod?: GSTReportingPeriod | null,
                providerEntityId?: string | null,
                providerCompanyId?: string | null,
                providerBillUserCompanyId?: string | null,
                providerBankAccountId?: string | null,
                providerDigitalWalletId?: string | null,
                providerBpayCrn?: string | null,
                paymentMethodId?: string | null,
                paymentUserId?: string | null,
                disbursementMethodId?: string | null,
                ubosCreated?: boolean | null,
                numUbosCreated?: number | null,
                subCategory?: string | null,
                clientsStatus?: EntityClientsStatus | null,
                ocrEmail?: string | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                owner?: string | null,
                referredBy?: string | null,
                connectedAccount?: string | null,
                accountStatus?: AccountStatus | null,
                customerId?: string | null,
                xeroSyncStatus?: XeroSyncStatus | null,
                xeroLastContactSyncAt?: string | null,
                xeroContactSyncStatus?: XeroSyncStatus | null,
                xeroInvoiceSyncStatus?: XeroSyncStatus | null,
                xeroLastInvoiceSyncAt?: string | null,
                xeroTenantId?: string | null,
                absorbFees?: boolean | null,
                subscriptionTier?: SubscriptionTier | null,
                invitationStatus?: InvitationStatus | null,
                clientsOnboardingStatus?: ClientsOnboardingStatus | null,
                createdBy?: string | null,
                createdByEntityId?: string | null,
                isFirm?: boolean | null,
                createdAt?: string | null,
                updatedAt?: string | null,
              } | null,
              searchName?: string | null,
              taxNumber?: string | null,
              taskSendSMS?: boolean | null,
              companyNumber?: string | null,
              createdBy?: string | null,
              createdAt: string,
              updatedAt: string,
              status?: EntityUserStatus | null,
              partnerId?: string | null,
              managerId?: string | null,
              archivedAt?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gstRegistered?: boolean | null,
          gstReportingPeriod?: GSTReportingPeriod | null,
          providerEntityId?: string | null,
          providerCompanyId?: string | null,
          providerBillUserCompanyId?: string | null,
          providerBankAccountId?: string | null,
          providerDigitalWalletId?: string | null,
          providerBpayCrn?: string | null,
          contact?:  {
            __typename: "EntityContact",
            firstName?: string | null,
            lastName?: string | null,
            email?: string | null,
            phone?: string | null,
            role?: string | null,
          } | null,
          paymentMethods?:  {
            __typename: "ModelPaymentMethodConnection",
            items:  Array< {
              __typename: "PaymentMethod",
              id: string,
              paymentMethodType: PaymentMethodType,
              type?: string | null,
              fullName?: string | null,
              number?: string | null,
              expMonth?: string | null,
              expYear?: string | null,
              accountName?: string | null,
              bankName?: string | null,
              accountNumber?: string | null,
              routingNumber?: string | null,
              holderType?: BankHolderType | null,
              accountType?: BankAccountType | null,
              status?: PaymentMethodStatus | null,
              accountDirection?: AccountDirection | null,
              expiresAt?: string | null,
              createdAt?: string | null,
              updatedAt?: string | null,
              consentId?: string | null,
              consentStatus?: PaymentConsentStatus | null,
              card?: string | null,
              googlepay?: string | null,
              applepay?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          paymentMethodId?: string | null,
          paymentUserId?: string | null,
          disbursementMethodId?: string | null,
          receivingAccounts?:  {
            __typename: "ModelPaymentMethodConnection",
            items:  Array< {
              __typename: "PaymentMethod",
              id: string,
              paymentMethodType: PaymentMethodType,
              type?: string | null,
              fullName?: string | null,
              number?: string | null,
              expMonth?: string | null,
              expYear?: string | null,
              accountName?: string | null,
              bankName?: string | null,
              accountNumber?: string | null,
              routingNumber?: string | null,
              holderType?: BankHolderType | null,
              accountType?: BankAccountType | null,
              status?: PaymentMethodStatus | null,
              accountDirection?: AccountDirection | null,
              expiresAt?: string | null,
              createdAt?: string | null,
              updatedAt?: string | null,
              consentId?: string | null,
              consentStatus?: PaymentConsentStatus | null,
              card?: string | null,
              googlepay?: string | null,
              applepay?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          ubosCreated?: boolean | null,
          numUbosCreated?: number | null,
          subCategory?: string | null,
          clientsStatus?: EntityClientsStatus | null,
          ocrEmail?: string | null,
          termsInvoiceAccepted?: boolean | null,
          termsOcrAccepted?: boolean | null,
          owner?: string | null,
          referredBy?: string | null,
          connectedAccount?: string | null,
          accountStatus?: AccountStatus | null,
          customerId?: string | null,
          xeroSyncStatus?: XeroSyncStatus | null,
          xeroLastContactSyncAt?: string | null,
          xeroContactSyncStatus?: XeroSyncStatus | null,
          xeroInvoiceSyncStatus?: XeroSyncStatus | null,
          xeroLastInvoiceSyncAt?: string | null,
          xeroTenantId?: string | null,
          absorbFees?: boolean | null,
          subscriptionTier?: SubscriptionTier | null,
          invitationStatus?: InvitationStatus | null,
          clientsOnboardingStatus?: ClientsOnboardingStatus | null,
          createdBy?: string | null,
          createdByEntityId?: string | null,
          isFirm?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | null,
        searchName?: string | null,
        taxNumber?: string | null,
        taskSendSMS?: boolean | null,
        companyNumber?: string | null,
        createdBy?: string | null,
        createdAt: string,
        updatedAt: string,
        status?: EntityUserStatus | null,
        partnerId?: string | null,
        managerId?: string | null,
        archivedAt?: string | null,
        taxPaymentReferences?:  {
          __typename: "TaxPaymentReferences",
          itr?:  {
            __typename: "TaxPaymentReference",
            referenceNumber?: string | null,
            updatedAt?: string | null,
          } | null,
          other?:  {
            __typename: "TaxPaymentReference",
            referenceNumber?: string | null,
            updatedAt?: string | null,
          } | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    gstRegistered?: boolean | null,
    gstReportingPeriod?: GSTReportingPeriod | null,
    providerEntityId?: string | null,
    providerCompanyId?: string | null,
    providerBillUserCompanyId?: string | null,
    providerBankAccountId?: string | null,
    providerDigitalWalletId?: string | null,
    providerBpayCrn?: string | null,
    contact?:  {
      __typename: "EntityContact",
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      phone?: string | null,
      role?: string | null,
    } | null,
    paymentMethods?:  {
      __typename: "ModelPaymentMethodConnection",
      items:  Array< {
        __typename: "PaymentMethod",
        id: string,
        paymentMethodType: PaymentMethodType,
        type?: string | null,
        fullName?: string | null,
        number?: string | null,
        expMonth?: string | null,
        expYear?: string | null,
        accountName?: string | null,
        bankName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
        holderType?: BankHolderType | null,
        accountType?: BankAccountType | null,
        status?: PaymentMethodStatus | null,
        accountDirection?: AccountDirection | null,
        expiresAt?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        consentId?: string | null,
        consentStatus?: PaymentConsentStatus | null,
        card?: string | null,
        googlepay?: string | null,
        applepay?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    paymentMethodId?: string | null,
    paymentUserId?: string | null,
    disbursementMethodId?: string | null,
    receivingAccounts?:  {
      __typename: "ModelPaymentMethodConnection",
      items:  Array< {
        __typename: "PaymentMethod",
        id: string,
        paymentMethodType: PaymentMethodType,
        type?: string | null,
        fullName?: string | null,
        number?: string | null,
        expMonth?: string | null,
        expYear?: string | null,
        accountName?: string | null,
        bankName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
        holderType?: BankHolderType | null,
        accountType?: BankAccountType | null,
        status?: PaymentMethodStatus | null,
        accountDirection?: AccountDirection | null,
        expiresAt?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        consentId?: string | null,
        consentStatus?: PaymentConsentStatus | null,
        card?: string | null,
        googlepay?: string | null,
        applepay?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    ubosCreated?: boolean | null,
    numUbosCreated?: number | null,
    subCategory?: string | null,
    clientsStatus?: EntityClientsStatus | null,
    ocrEmail?: string | null,
    termsInvoiceAccepted?: boolean | null,
    termsOcrAccepted?: boolean | null,
    owner?: string | null,
    referredBy?: string | null,
    connectedAccount?: string | null,
    accountStatus?: AccountStatus | null,
    customerId?: string | null,
    xeroSyncStatus?: XeroSyncStatus | null,
    xeroLastContactSyncAt?: string | null,
    xeroContactSyncStatus?: XeroSyncStatus | null,
    xeroInvoiceSyncStatus?: XeroSyncStatus | null,
    xeroLastInvoiceSyncAt?: string | null,
    xeroTenantId?: string | null,
    absorbFees?: boolean | null,
    subscriptionTier?: SubscriptionTier | null,
    invitationStatus?: InvitationStatus | null,
    clientsOnboardingStatus?: ClientsOnboardingStatus | null,
    createdBy?: string | null,
    createdByEntityId?: string | null,
    isFirm?: boolean | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type RegenerateEntityOcrEmailMutationVariables = {
  input: RegenerateEntityOcrEmailInput,
};

export type RegenerateEntityOcrEmailMutation = {
  regenerateEntityOcrEmail?:  {
    __typename: "Entity",
    id: string,
    type: EntityType,
    taxNumber?: string | null,
    companyNumber?: string | null,
    billerCode?: number | null,
    name: string,
    legalName?: string | null,
    businessNames?: Array< string | null > | null,
    searchName?: string | null,
    address?:  {
      __typename: "Address",
      addressId?: string | null,
      contactName?: string | null,
      contactNumber?: string | null,
      fullAddress?: string | null,
      address1?: string | null,
      address2?: string | null,
      city?: string | null,
      country: string,
      countryCode: string,
      state: string,
      stateCode?: string | null,
      postalCode: string,
      invalid?: boolean | null,
    } | null,
    logo?:  {
      __typename: "Image",
      alt?: string | null,
      identityId?: string | null,
      key: string,
      level: S3UploadLevel,
      type?: string | null,
    } | null,
    brandColour?: string | null,
    website?: string | null,
    entityUsers?:  {
      __typename: "ModelEntityUserConnection",
      items:  Array< {
        __typename: "EntityUser",
        id: string,
        entityId: string,
        userId: string,
        firmId?: string | null,
        email?: string | null,
        invitedEmail?: string | null,
        ocrEmail?: string | null,
        referredBy?: string | null,
        invitedEntityId?: string | null,
        firmEntityId?: string | null,
        providerContactId?: string | null,
        ownerCode?: string | null,
        clientGroupCode?: string | null,
        clientCode?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        role: EntityUserRole,
        jobTags?: Array< JobTags | null > | null,
        paymentsEnabled?: boolean | null,
        termsInvoiceAccepted?: boolean | null,
        termsOcrAccepted?: boolean | null,
        termsFirmPayTaxAccepted?: boolean | null,
        termsFirmPayTaxDetails?:  {
          __typename: "TermsFirmPayTaxDetails",
          document?:  {
            __typename: "S3Upload",
            identityId?: string | null,
            key: string,
            level: S3UploadLevel,
            type: S3UploadType,
            name?: string | null,
          } | null,
          acceptedAt?: string | null,
          email?: string | null,
          ip?: string | null,
          fullName?: string | null,
          firmId?: string | null,
        } | null,
        entitySearchName?: string | null,
        entity?:  {
          __typename: "Entity",
          id: string,
          type: EntityType,
          taxNumber?: string | null,
          companyNumber?: string | null,
          billerCode?: number | null,
          name: string,
          legalName?: string | null,
          businessNames?: Array< string | null > | null,
          searchName?: string | null,
          address?:  {
            __typename: "Address",
            addressId?: string | null,
            contactName?: string | null,
            contactNumber?: string | null,
            fullAddress?: string | null,
            address1?: string | null,
            address2?: string | null,
            city?: string | null,
            country: string,
            countryCode: string,
            state: string,
            stateCode?: string | null,
            postalCode: string,
            invalid?: boolean | null,
          } | null,
          logo?:  {
            __typename: "Image",
            alt?: string | null,
            identityId?: string | null,
            key: string,
            level: S3UploadLevel,
            type?: string | null,
          } | null,
          brandColour?: string | null,
          website?: string | null,
          entityUsers?:  {
            __typename: "ModelEntityUserConnection",
            items:  Array< {
              __typename: "EntityUser",
              id: string,
              entityId: string,
              userId: string,
              firmId?: string | null,
              email?: string | null,
              invitedEmail?: string | null,
              ocrEmail?: string | null,
              referredBy?: string | null,
              invitedEntityId?: string | null,
              firmEntityId?: string | null,
              providerContactId?: string | null,
              ownerCode?: string | null,
              clientGroupCode?: string | null,
              clientCode?: string | null,
              firstName?: string | null,
              lastName?: string | null,
              role: EntityUserRole,
              jobTags?: Array< JobTags | null > | null,
              paymentsEnabled?: boolean | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              termsFirmPayTaxAccepted?: boolean | null,
              termsFirmPayTaxDetails?:  {
                __typename: "TermsFirmPayTaxDetails",
                acceptedAt?: string | null,
                email?: string | null,
                ip?: string | null,
                fullName?: string | null,
                firmId?: string | null,
              } | null,
              entitySearchName?: string | null,
              entity?:  {
                __typename: "Entity",
                id: string,
                type: EntityType,
                taxNumber?: string | null,
                companyNumber?: string | null,
                billerCode?: number | null,
                name: string,
                legalName?: string | null,
                businessNames?: Array< string | null > | null,
                searchName?: string | null,
                brandColour?: string | null,
                website?: string | null,
                gstRegistered?: boolean | null,
                gstReportingPeriod?: GSTReportingPeriod | null,
                providerEntityId?: string | null,
                providerCompanyId?: string | null,
                providerBillUserCompanyId?: string | null,
                providerBankAccountId?: string | null,
                providerDigitalWalletId?: string | null,
                providerBpayCrn?: string | null,
                paymentMethodId?: string | null,
                paymentUserId?: string | null,
                disbursementMethodId?: string | null,
                ubosCreated?: boolean | null,
                numUbosCreated?: number | null,
                subCategory?: string | null,
                clientsStatus?: EntityClientsStatus | null,
                ocrEmail?: string | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                owner?: string | null,
                referredBy?: string | null,
                connectedAccount?: string | null,
                accountStatus?: AccountStatus | null,
                customerId?: string | null,
                xeroSyncStatus?: XeroSyncStatus | null,
                xeroLastContactSyncAt?: string | null,
                xeroContactSyncStatus?: XeroSyncStatus | null,
                xeroInvoiceSyncStatus?: XeroSyncStatus | null,
                xeroLastInvoiceSyncAt?: string | null,
                xeroTenantId?: string | null,
                absorbFees?: boolean | null,
                subscriptionTier?: SubscriptionTier | null,
                invitationStatus?: InvitationStatus | null,
                clientsOnboardingStatus?: ClientsOnboardingStatus | null,
                createdBy?: string | null,
                createdByEntityId?: string | null,
                isFirm?: boolean | null,
                createdAt?: string | null,
                updatedAt?: string | null,
              } | null,
              firm?:  {
                __typename: "Entity",
                id: string,
                type: EntityType,
                taxNumber?: string | null,
                companyNumber?: string | null,
                billerCode?: number | null,
                name: string,
                legalName?: string | null,
                businessNames?: Array< string | null > | null,
                searchName?: string | null,
                brandColour?: string | null,
                website?: string | null,
                gstRegistered?: boolean | null,
                gstReportingPeriod?: GSTReportingPeriod | null,
                providerEntityId?: string | null,
                providerCompanyId?: string | null,
                providerBillUserCompanyId?: string | null,
                providerBankAccountId?: string | null,
                providerDigitalWalletId?: string | null,
                providerBpayCrn?: string | null,
                paymentMethodId?: string | null,
                paymentUserId?: string | null,
                disbursementMethodId?: string | null,
                ubosCreated?: boolean | null,
                numUbosCreated?: number | null,
                subCategory?: string | null,
                clientsStatus?: EntityClientsStatus | null,
                ocrEmail?: string | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                owner?: string | null,
                referredBy?: string | null,
                connectedAccount?: string | null,
                accountStatus?: AccountStatus | null,
                customerId?: string | null,
                xeroSyncStatus?: XeroSyncStatus | null,
                xeroLastContactSyncAt?: string | null,
                xeroContactSyncStatus?: XeroSyncStatus | null,
                xeroInvoiceSyncStatus?: XeroSyncStatus | null,
                xeroLastInvoiceSyncAt?: string | null,
                xeroTenantId?: string | null,
                absorbFees?: boolean | null,
                subscriptionTier?: SubscriptionTier | null,
                invitationStatus?: InvitationStatus | null,
                clientsOnboardingStatus?: ClientsOnboardingStatus | null,
                createdBy?: string | null,
                createdByEntityId?: string | null,
                isFirm?: boolean | null,
                createdAt?: string | null,
                updatedAt?: string | null,
              } | null,
              searchName?: string | null,
              taxNumber?: string | null,
              taskSendSMS?: boolean | null,
              companyNumber?: string | null,
              createdBy?: string | null,
              createdAt: string,
              updatedAt: string,
              status?: EntityUserStatus | null,
              partnerId?: string | null,
              managerId?: string | null,
              archivedAt?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gstRegistered?: boolean | null,
          gstReportingPeriod?: GSTReportingPeriod | null,
          providerEntityId?: string | null,
          providerCompanyId?: string | null,
          providerBillUserCompanyId?: string | null,
          providerBankAccountId?: string | null,
          providerDigitalWalletId?: string | null,
          providerBpayCrn?: string | null,
          contact?:  {
            __typename: "EntityContact",
            firstName?: string | null,
            lastName?: string | null,
            email?: string | null,
            phone?: string | null,
            role?: string | null,
          } | null,
          paymentMethods?:  {
            __typename: "ModelPaymentMethodConnection",
            items:  Array< {
              __typename: "PaymentMethod",
              id: string,
              paymentMethodType: PaymentMethodType,
              type?: string | null,
              fullName?: string | null,
              number?: string | null,
              expMonth?: string | null,
              expYear?: string | null,
              accountName?: string | null,
              bankName?: string | null,
              accountNumber?: string | null,
              routingNumber?: string | null,
              holderType?: BankHolderType | null,
              accountType?: BankAccountType | null,
              status?: PaymentMethodStatus | null,
              accountDirection?: AccountDirection | null,
              expiresAt?: string | null,
              createdAt?: string | null,
              updatedAt?: string | null,
              consentId?: string | null,
              consentStatus?: PaymentConsentStatus | null,
              card?: string | null,
              googlepay?: string | null,
              applepay?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          paymentMethodId?: string | null,
          paymentUserId?: string | null,
          disbursementMethodId?: string | null,
          receivingAccounts?:  {
            __typename: "ModelPaymentMethodConnection",
            items:  Array< {
              __typename: "PaymentMethod",
              id: string,
              paymentMethodType: PaymentMethodType,
              type?: string | null,
              fullName?: string | null,
              number?: string | null,
              expMonth?: string | null,
              expYear?: string | null,
              accountName?: string | null,
              bankName?: string | null,
              accountNumber?: string | null,
              routingNumber?: string | null,
              holderType?: BankHolderType | null,
              accountType?: BankAccountType | null,
              status?: PaymentMethodStatus | null,
              accountDirection?: AccountDirection | null,
              expiresAt?: string | null,
              createdAt?: string | null,
              updatedAt?: string | null,
              consentId?: string | null,
              consentStatus?: PaymentConsentStatus | null,
              card?: string | null,
              googlepay?: string | null,
              applepay?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          ubosCreated?: boolean | null,
          numUbosCreated?: number | null,
          subCategory?: string | null,
          clientsStatus?: EntityClientsStatus | null,
          ocrEmail?: string | null,
          termsInvoiceAccepted?: boolean | null,
          termsOcrAccepted?: boolean | null,
          owner?: string | null,
          referredBy?: string | null,
          connectedAccount?: string | null,
          accountStatus?: AccountStatus | null,
          customerId?: string | null,
          xeroSyncStatus?: XeroSyncStatus | null,
          xeroLastContactSyncAt?: string | null,
          xeroContactSyncStatus?: XeroSyncStatus | null,
          xeroInvoiceSyncStatus?: XeroSyncStatus | null,
          xeroLastInvoiceSyncAt?: string | null,
          xeroTenantId?: string | null,
          absorbFees?: boolean | null,
          subscriptionTier?: SubscriptionTier | null,
          invitationStatus?: InvitationStatus | null,
          clientsOnboardingStatus?: ClientsOnboardingStatus | null,
          createdBy?: string | null,
          createdByEntityId?: string | null,
          isFirm?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | null,
        firm?:  {
          __typename: "Entity",
          id: string,
          type: EntityType,
          taxNumber?: string | null,
          companyNumber?: string | null,
          billerCode?: number | null,
          name: string,
          legalName?: string | null,
          businessNames?: Array< string | null > | null,
          searchName?: string | null,
          address?:  {
            __typename: "Address",
            addressId?: string | null,
            contactName?: string | null,
            contactNumber?: string | null,
            fullAddress?: string | null,
            address1?: string | null,
            address2?: string | null,
            city?: string | null,
            country: string,
            countryCode: string,
            state: string,
            stateCode?: string | null,
            postalCode: string,
            invalid?: boolean | null,
          } | null,
          logo?:  {
            __typename: "Image",
            alt?: string | null,
            identityId?: string | null,
            key: string,
            level: S3UploadLevel,
            type?: string | null,
          } | null,
          brandColour?: string | null,
          website?: string | null,
          entityUsers?:  {
            __typename: "ModelEntityUserConnection",
            items:  Array< {
              __typename: "EntityUser",
              id: string,
              entityId: string,
              userId: string,
              firmId?: string | null,
              email?: string | null,
              invitedEmail?: string | null,
              ocrEmail?: string | null,
              referredBy?: string | null,
              invitedEntityId?: string | null,
              firmEntityId?: string | null,
              providerContactId?: string | null,
              ownerCode?: string | null,
              clientGroupCode?: string | null,
              clientCode?: string | null,
              firstName?: string | null,
              lastName?: string | null,
              role: EntityUserRole,
              jobTags?: Array< JobTags | null > | null,
              paymentsEnabled?: boolean | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              termsFirmPayTaxAccepted?: boolean | null,
              termsFirmPayTaxDetails?:  {
                __typename: "TermsFirmPayTaxDetails",
                acceptedAt?: string | null,
                email?: string | null,
                ip?: string | null,
                fullName?: string | null,
                firmId?: string | null,
              } | null,
              entitySearchName?: string | null,
              entity?:  {
                __typename: "Entity",
                id: string,
                type: EntityType,
                taxNumber?: string | null,
                companyNumber?: string | null,
                billerCode?: number | null,
                name: string,
                legalName?: string | null,
                businessNames?: Array< string | null > | null,
                searchName?: string | null,
                brandColour?: string | null,
                website?: string | null,
                gstRegistered?: boolean | null,
                gstReportingPeriod?: GSTReportingPeriod | null,
                providerEntityId?: string | null,
                providerCompanyId?: string | null,
                providerBillUserCompanyId?: string | null,
                providerBankAccountId?: string | null,
                providerDigitalWalletId?: string | null,
                providerBpayCrn?: string | null,
                paymentMethodId?: string | null,
                paymentUserId?: string | null,
                disbursementMethodId?: string | null,
                ubosCreated?: boolean | null,
                numUbosCreated?: number | null,
                subCategory?: string | null,
                clientsStatus?: EntityClientsStatus | null,
                ocrEmail?: string | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                owner?: string | null,
                referredBy?: string | null,
                connectedAccount?: string | null,
                accountStatus?: AccountStatus | null,
                customerId?: string | null,
                xeroSyncStatus?: XeroSyncStatus | null,
                xeroLastContactSyncAt?: string | null,
                xeroContactSyncStatus?: XeroSyncStatus | null,
                xeroInvoiceSyncStatus?: XeroSyncStatus | null,
                xeroLastInvoiceSyncAt?: string | null,
                xeroTenantId?: string | null,
                absorbFees?: boolean | null,
                subscriptionTier?: SubscriptionTier | null,
                invitationStatus?: InvitationStatus | null,
                clientsOnboardingStatus?: ClientsOnboardingStatus | null,
                createdBy?: string | null,
                createdByEntityId?: string | null,
                isFirm?: boolean | null,
                createdAt?: string | null,
                updatedAt?: string | null,
              } | null,
              firm?:  {
                __typename: "Entity",
                id: string,
                type: EntityType,
                taxNumber?: string | null,
                companyNumber?: string | null,
                billerCode?: number | null,
                name: string,
                legalName?: string | null,
                businessNames?: Array< string | null > | null,
                searchName?: string | null,
                brandColour?: string | null,
                website?: string | null,
                gstRegistered?: boolean | null,
                gstReportingPeriod?: GSTReportingPeriod | null,
                providerEntityId?: string | null,
                providerCompanyId?: string | null,
                providerBillUserCompanyId?: string | null,
                providerBankAccountId?: string | null,
                providerDigitalWalletId?: string | null,
                providerBpayCrn?: string | null,
                paymentMethodId?: string | null,
                paymentUserId?: string | null,
                disbursementMethodId?: string | null,
                ubosCreated?: boolean | null,
                numUbosCreated?: number | null,
                subCategory?: string | null,
                clientsStatus?: EntityClientsStatus | null,
                ocrEmail?: string | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                owner?: string | null,
                referredBy?: string | null,
                connectedAccount?: string | null,
                accountStatus?: AccountStatus | null,
                customerId?: string | null,
                xeroSyncStatus?: XeroSyncStatus | null,
                xeroLastContactSyncAt?: string | null,
                xeroContactSyncStatus?: XeroSyncStatus | null,
                xeroInvoiceSyncStatus?: XeroSyncStatus | null,
                xeroLastInvoiceSyncAt?: string | null,
                xeroTenantId?: string | null,
                absorbFees?: boolean | null,
                subscriptionTier?: SubscriptionTier | null,
                invitationStatus?: InvitationStatus | null,
                clientsOnboardingStatus?: ClientsOnboardingStatus | null,
                createdBy?: string | null,
                createdByEntityId?: string | null,
                isFirm?: boolean | null,
                createdAt?: string | null,
                updatedAt?: string | null,
              } | null,
              searchName?: string | null,
              taxNumber?: string | null,
              taskSendSMS?: boolean | null,
              companyNumber?: string | null,
              createdBy?: string | null,
              createdAt: string,
              updatedAt: string,
              status?: EntityUserStatus | null,
              partnerId?: string | null,
              managerId?: string | null,
              archivedAt?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gstRegistered?: boolean | null,
          gstReportingPeriod?: GSTReportingPeriod | null,
          providerEntityId?: string | null,
          providerCompanyId?: string | null,
          providerBillUserCompanyId?: string | null,
          providerBankAccountId?: string | null,
          providerDigitalWalletId?: string | null,
          providerBpayCrn?: string | null,
          contact?:  {
            __typename: "EntityContact",
            firstName?: string | null,
            lastName?: string | null,
            email?: string | null,
            phone?: string | null,
            role?: string | null,
          } | null,
          paymentMethods?:  {
            __typename: "ModelPaymentMethodConnection",
            items:  Array< {
              __typename: "PaymentMethod",
              id: string,
              paymentMethodType: PaymentMethodType,
              type?: string | null,
              fullName?: string | null,
              number?: string | null,
              expMonth?: string | null,
              expYear?: string | null,
              accountName?: string | null,
              bankName?: string | null,
              accountNumber?: string | null,
              routingNumber?: string | null,
              holderType?: BankHolderType | null,
              accountType?: BankAccountType | null,
              status?: PaymentMethodStatus | null,
              accountDirection?: AccountDirection | null,
              expiresAt?: string | null,
              createdAt?: string | null,
              updatedAt?: string | null,
              consentId?: string | null,
              consentStatus?: PaymentConsentStatus | null,
              card?: string | null,
              googlepay?: string | null,
              applepay?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          paymentMethodId?: string | null,
          paymentUserId?: string | null,
          disbursementMethodId?: string | null,
          receivingAccounts?:  {
            __typename: "ModelPaymentMethodConnection",
            items:  Array< {
              __typename: "PaymentMethod",
              id: string,
              paymentMethodType: PaymentMethodType,
              type?: string | null,
              fullName?: string | null,
              number?: string | null,
              expMonth?: string | null,
              expYear?: string | null,
              accountName?: string | null,
              bankName?: string | null,
              accountNumber?: string | null,
              routingNumber?: string | null,
              holderType?: BankHolderType | null,
              accountType?: BankAccountType | null,
              status?: PaymentMethodStatus | null,
              accountDirection?: AccountDirection | null,
              expiresAt?: string | null,
              createdAt?: string | null,
              updatedAt?: string | null,
              consentId?: string | null,
              consentStatus?: PaymentConsentStatus | null,
              card?: string | null,
              googlepay?: string | null,
              applepay?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          ubosCreated?: boolean | null,
          numUbosCreated?: number | null,
          subCategory?: string | null,
          clientsStatus?: EntityClientsStatus | null,
          ocrEmail?: string | null,
          termsInvoiceAccepted?: boolean | null,
          termsOcrAccepted?: boolean | null,
          owner?: string | null,
          referredBy?: string | null,
          connectedAccount?: string | null,
          accountStatus?: AccountStatus | null,
          customerId?: string | null,
          xeroSyncStatus?: XeroSyncStatus | null,
          xeroLastContactSyncAt?: string | null,
          xeroContactSyncStatus?: XeroSyncStatus | null,
          xeroInvoiceSyncStatus?: XeroSyncStatus | null,
          xeroLastInvoiceSyncAt?: string | null,
          xeroTenantId?: string | null,
          absorbFees?: boolean | null,
          subscriptionTier?: SubscriptionTier | null,
          invitationStatus?: InvitationStatus | null,
          clientsOnboardingStatus?: ClientsOnboardingStatus | null,
          createdBy?: string | null,
          createdByEntityId?: string | null,
          isFirm?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | null,
        searchName?: string | null,
        taxNumber?: string | null,
        taskSendSMS?: boolean | null,
        companyNumber?: string | null,
        createdBy?: string | null,
        createdAt: string,
        updatedAt: string,
        status?: EntityUserStatus | null,
        partnerId?: string | null,
        managerId?: string | null,
        archivedAt?: string | null,
        taxPaymentReferences?:  {
          __typename: "TaxPaymentReferences",
          itr?:  {
            __typename: "TaxPaymentReference",
            referenceNumber?: string | null,
            updatedAt?: string | null,
          } | null,
          other?:  {
            __typename: "TaxPaymentReference",
            referenceNumber?: string | null,
            updatedAt?: string | null,
          } | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    gstRegistered?: boolean | null,
    gstReportingPeriod?: GSTReportingPeriod | null,
    providerEntityId?: string | null,
    providerCompanyId?: string | null,
    providerBillUserCompanyId?: string | null,
    providerBankAccountId?: string | null,
    providerDigitalWalletId?: string | null,
    providerBpayCrn?: string | null,
    contact?:  {
      __typename: "EntityContact",
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      phone?: string | null,
      role?: string | null,
    } | null,
    paymentMethods?:  {
      __typename: "ModelPaymentMethodConnection",
      items:  Array< {
        __typename: "PaymentMethod",
        id: string,
        paymentMethodType: PaymentMethodType,
        type?: string | null,
        fullName?: string | null,
        number?: string | null,
        expMonth?: string | null,
        expYear?: string | null,
        accountName?: string | null,
        bankName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
        holderType?: BankHolderType | null,
        accountType?: BankAccountType | null,
        status?: PaymentMethodStatus | null,
        accountDirection?: AccountDirection | null,
        expiresAt?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        consentId?: string | null,
        consentStatus?: PaymentConsentStatus | null,
        card?: string | null,
        googlepay?: string | null,
        applepay?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    paymentMethodId?: string | null,
    paymentUserId?: string | null,
    disbursementMethodId?: string | null,
    receivingAccounts?:  {
      __typename: "ModelPaymentMethodConnection",
      items:  Array< {
        __typename: "PaymentMethod",
        id: string,
        paymentMethodType: PaymentMethodType,
        type?: string | null,
        fullName?: string | null,
        number?: string | null,
        expMonth?: string | null,
        expYear?: string | null,
        accountName?: string | null,
        bankName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
        holderType?: BankHolderType | null,
        accountType?: BankAccountType | null,
        status?: PaymentMethodStatus | null,
        accountDirection?: AccountDirection | null,
        expiresAt?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        consentId?: string | null,
        consentStatus?: PaymentConsentStatus | null,
        card?: string | null,
        googlepay?: string | null,
        applepay?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    ubosCreated?: boolean | null,
    numUbosCreated?: number | null,
    subCategory?: string | null,
    clientsStatus?: EntityClientsStatus | null,
    ocrEmail?: string | null,
    termsInvoiceAccepted?: boolean | null,
    termsOcrAccepted?: boolean | null,
    owner?: string | null,
    referredBy?: string | null,
    connectedAccount?: string | null,
    accountStatus?: AccountStatus | null,
    customerId?: string | null,
    xeroSyncStatus?: XeroSyncStatus | null,
    xeroLastContactSyncAt?: string | null,
    xeroContactSyncStatus?: XeroSyncStatus | null,
    xeroInvoiceSyncStatus?: XeroSyncStatus | null,
    xeroLastInvoiceSyncAt?: string | null,
    xeroTenantId?: string | null,
    absorbFees?: boolean | null,
    subscriptionTier?: SubscriptionTier | null,
    invitationStatus?: InvitationStatus | null,
    clientsOnboardingStatus?: ClientsOnboardingStatus | null,
    createdBy?: string | null,
    createdByEntityId?: string | null,
    isFirm?: boolean | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type DeleteEntityMutationVariables = {
  input: DeleteEntityInput,
  condition?: ModelEntityConditionInput | null,
};

export type DeleteEntityMutation = {
  deleteEntity?:  {
    __typename: "Entity",
    id: string,
    type: EntityType,
    taxNumber?: string | null,
    companyNumber?: string | null,
    billerCode?: number | null,
    name: string,
    legalName?: string | null,
    businessNames?: Array< string | null > | null,
    searchName?: string | null,
    address?:  {
      __typename: "Address",
      addressId?: string | null,
      contactName?: string | null,
      contactNumber?: string | null,
      fullAddress?: string | null,
      address1?: string | null,
      address2?: string | null,
      city?: string | null,
      country: string,
      countryCode: string,
      state: string,
      stateCode?: string | null,
      postalCode: string,
      invalid?: boolean | null,
    } | null,
    logo?:  {
      __typename: "Image",
      alt?: string | null,
      identityId?: string | null,
      key: string,
      level: S3UploadLevel,
      type?: string | null,
    } | null,
    brandColour?: string | null,
    website?: string | null,
    entityUsers?:  {
      __typename: "ModelEntityUserConnection",
      items:  Array< {
        __typename: "EntityUser",
        id: string,
        entityId: string,
        userId: string,
        firmId?: string | null,
        email?: string | null,
        invitedEmail?: string | null,
        ocrEmail?: string | null,
        referredBy?: string | null,
        invitedEntityId?: string | null,
        firmEntityId?: string | null,
        providerContactId?: string | null,
        ownerCode?: string | null,
        clientGroupCode?: string | null,
        clientCode?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        role: EntityUserRole,
        jobTags?: Array< JobTags | null > | null,
        paymentsEnabled?: boolean | null,
        termsInvoiceAccepted?: boolean | null,
        termsOcrAccepted?: boolean | null,
        termsFirmPayTaxAccepted?: boolean | null,
        termsFirmPayTaxDetails?:  {
          __typename: "TermsFirmPayTaxDetails",
          document?:  {
            __typename: "S3Upload",
            identityId?: string | null,
            key: string,
            level: S3UploadLevel,
            type: S3UploadType,
            name?: string | null,
          } | null,
          acceptedAt?: string | null,
          email?: string | null,
          ip?: string | null,
          fullName?: string | null,
          firmId?: string | null,
        } | null,
        entitySearchName?: string | null,
        entity?:  {
          __typename: "Entity",
          id: string,
          type: EntityType,
          taxNumber?: string | null,
          companyNumber?: string | null,
          billerCode?: number | null,
          name: string,
          legalName?: string | null,
          businessNames?: Array< string | null > | null,
          searchName?: string | null,
          address?:  {
            __typename: "Address",
            addressId?: string | null,
            contactName?: string | null,
            contactNumber?: string | null,
            fullAddress?: string | null,
            address1?: string | null,
            address2?: string | null,
            city?: string | null,
            country: string,
            countryCode: string,
            state: string,
            stateCode?: string | null,
            postalCode: string,
            invalid?: boolean | null,
          } | null,
          logo?:  {
            __typename: "Image",
            alt?: string | null,
            identityId?: string | null,
            key: string,
            level: S3UploadLevel,
            type?: string | null,
          } | null,
          brandColour?: string | null,
          website?: string | null,
          entityUsers?:  {
            __typename: "ModelEntityUserConnection",
            items:  Array< {
              __typename: "EntityUser",
              id: string,
              entityId: string,
              userId: string,
              firmId?: string | null,
              email?: string | null,
              invitedEmail?: string | null,
              ocrEmail?: string | null,
              referredBy?: string | null,
              invitedEntityId?: string | null,
              firmEntityId?: string | null,
              providerContactId?: string | null,
              ownerCode?: string | null,
              clientGroupCode?: string | null,
              clientCode?: string | null,
              firstName?: string | null,
              lastName?: string | null,
              role: EntityUserRole,
              jobTags?: Array< JobTags | null > | null,
              paymentsEnabled?: boolean | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              termsFirmPayTaxAccepted?: boolean | null,
              termsFirmPayTaxDetails?:  {
                __typename: "TermsFirmPayTaxDetails",
                acceptedAt?: string | null,
                email?: string | null,
                ip?: string | null,
                fullName?: string | null,
                firmId?: string | null,
              } | null,
              entitySearchName?: string | null,
              entity?:  {
                __typename: "Entity",
                id: string,
                type: EntityType,
                taxNumber?: string | null,
                companyNumber?: string | null,
                billerCode?: number | null,
                name: string,
                legalName?: string | null,
                businessNames?: Array< string | null > | null,
                searchName?: string | null,
                brandColour?: string | null,
                website?: string | null,
                gstRegistered?: boolean | null,
                gstReportingPeriod?: GSTReportingPeriod | null,
                providerEntityId?: string | null,
                providerCompanyId?: string | null,
                providerBillUserCompanyId?: string | null,
                providerBankAccountId?: string | null,
                providerDigitalWalletId?: string | null,
                providerBpayCrn?: string | null,
                paymentMethodId?: string | null,
                paymentUserId?: string | null,
                disbursementMethodId?: string | null,
                ubosCreated?: boolean | null,
                numUbosCreated?: number | null,
                subCategory?: string | null,
                clientsStatus?: EntityClientsStatus | null,
                ocrEmail?: string | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                owner?: string | null,
                referredBy?: string | null,
                connectedAccount?: string | null,
                accountStatus?: AccountStatus | null,
                customerId?: string | null,
                xeroSyncStatus?: XeroSyncStatus | null,
                xeroLastContactSyncAt?: string | null,
                xeroContactSyncStatus?: XeroSyncStatus | null,
                xeroInvoiceSyncStatus?: XeroSyncStatus | null,
                xeroLastInvoiceSyncAt?: string | null,
                xeroTenantId?: string | null,
                absorbFees?: boolean | null,
                subscriptionTier?: SubscriptionTier | null,
                invitationStatus?: InvitationStatus | null,
                clientsOnboardingStatus?: ClientsOnboardingStatus | null,
                createdBy?: string | null,
                createdByEntityId?: string | null,
                isFirm?: boolean | null,
                createdAt?: string | null,
                updatedAt?: string | null,
              } | null,
              firm?:  {
                __typename: "Entity",
                id: string,
                type: EntityType,
                taxNumber?: string | null,
                companyNumber?: string | null,
                billerCode?: number | null,
                name: string,
                legalName?: string | null,
                businessNames?: Array< string | null > | null,
                searchName?: string | null,
                brandColour?: string | null,
                website?: string | null,
                gstRegistered?: boolean | null,
                gstReportingPeriod?: GSTReportingPeriod | null,
                providerEntityId?: string | null,
                providerCompanyId?: string | null,
                providerBillUserCompanyId?: string | null,
                providerBankAccountId?: string | null,
                providerDigitalWalletId?: string | null,
                providerBpayCrn?: string | null,
                paymentMethodId?: string | null,
                paymentUserId?: string | null,
                disbursementMethodId?: string | null,
                ubosCreated?: boolean | null,
                numUbosCreated?: number | null,
                subCategory?: string | null,
                clientsStatus?: EntityClientsStatus | null,
                ocrEmail?: string | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                owner?: string | null,
                referredBy?: string | null,
                connectedAccount?: string | null,
                accountStatus?: AccountStatus | null,
                customerId?: string | null,
                xeroSyncStatus?: XeroSyncStatus | null,
                xeroLastContactSyncAt?: string | null,
                xeroContactSyncStatus?: XeroSyncStatus | null,
                xeroInvoiceSyncStatus?: XeroSyncStatus | null,
                xeroLastInvoiceSyncAt?: string | null,
                xeroTenantId?: string | null,
                absorbFees?: boolean | null,
                subscriptionTier?: SubscriptionTier | null,
                invitationStatus?: InvitationStatus | null,
                clientsOnboardingStatus?: ClientsOnboardingStatus | null,
                createdBy?: string | null,
                createdByEntityId?: string | null,
                isFirm?: boolean | null,
                createdAt?: string | null,
                updatedAt?: string | null,
              } | null,
              searchName?: string | null,
              taxNumber?: string | null,
              taskSendSMS?: boolean | null,
              companyNumber?: string | null,
              createdBy?: string | null,
              createdAt: string,
              updatedAt: string,
              status?: EntityUserStatus | null,
              partnerId?: string | null,
              managerId?: string | null,
              archivedAt?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gstRegistered?: boolean | null,
          gstReportingPeriod?: GSTReportingPeriod | null,
          providerEntityId?: string | null,
          providerCompanyId?: string | null,
          providerBillUserCompanyId?: string | null,
          providerBankAccountId?: string | null,
          providerDigitalWalletId?: string | null,
          providerBpayCrn?: string | null,
          contact?:  {
            __typename: "EntityContact",
            firstName?: string | null,
            lastName?: string | null,
            email?: string | null,
            phone?: string | null,
            role?: string | null,
          } | null,
          paymentMethods?:  {
            __typename: "ModelPaymentMethodConnection",
            items:  Array< {
              __typename: "PaymentMethod",
              id: string,
              paymentMethodType: PaymentMethodType,
              type?: string | null,
              fullName?: string | null,
              number?: string | null,
              expMonth?: string | null,
              expYear?: string | null,
              accountName?: string | null,
              bankName?: string | null,
              accountNumber?: string | null,
              routingNumber?: string | null,
              holderType?: BankHolderType | null,
              accountType?: BankAccountType | null,
              status?: PaymentMethodStatus | null,
              accountDirection?: AccountDirection | null,
              expiresAt?: string | null,
              createdAt?: string | null,
              updatedAt?: string | null,
              consentId?: string | null,
              consentStatus?: PaymentConsentStatus | null,
              card?: string | null,
              googlepay?: string | null,
              applepay?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          paymentMethodId?: string | null,
          paymentUserId?: string | null,
          disbursementMethodId?: string | null,
          receivingAccounts?:  {
            __typename: "ModelPaymentMethodConnection",
            items:  Array< {
              __typename: "PaymentMethod",
              id: string,
              paymentMethodType: PaymentMethodType,
              type?: string | null,
              fullName?: string | null,
              number?: string | null,
              expMonth?: string | null,
              expYear?: string | null,
              accountName?: string | null,
              bankName?: string | null,
              accountNumber?: string | null,
              routingNumber?: string | null,
              holderType?: BankHolderType | null,
              accountType?: BankAccountType | null,
              status?: PaymentMethodStatus | null,
              accountDirection?: AccountDirection | null,
              expiresAt?: string | null,
              createdAt?: string | null,
              updatedAt?: string | null,
              consentId?: string | null,
              consentStatus?: PaymentConsentStatus | null,
              card?: string | null,
              googlepay?: string | null,
              applepay?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          ubosCreated?: boolean | null,
          numUbosCreated?: number | null,
          subCategory?: string | null,
          clientsStatus?: EntityClientsStatus | null,
          ocrEmail?: string | null,
          termsInvoiceAccepted?: boolean | null,
          termsOcrAccepted?: boolean | null,
          owner?: string | null,
          referredBy?: string | null,
          connectedAccount?: string | null,
          accountStatus?: AccountStatus | null,
          customerId?: string | null,
          xeroSyncStatus?: XeroSyncStatus | null,
          xeroLastContactSyncAt?: string | null,
          xeroContactSyncStatus?: XeroSyncStatus | null,
          xeroInvoiceSyncStatus?: XeroSyncStatus | null,
          xeroLastInvoiceSyncAt?: string | null,
          xeroTenantId?: string | null,
          absorbFees?: boolean | null,
          subscriptionTier?: SubscriptionTier | null,
          invitationStatus?: InvitationStatus | null,
          clientsOnboardingStatus?: ClientsOnboardingStatus | null,
          createdBy?: string | null,
          createdByEntityId?: string | null,
          isFirm?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | null,
        firm?:  {
          __typename: "Entity",
          id: string,
          type: EntityType,
          taxNumber?: string | null,
          companyNumber?: string | null,
          billerCode?: number | null,
          name: string,
          legalName?: string | null,
          businessNames?: Array< string | null > | null,
          searchName?: string | null,
          address?:  {
            __typename: "Address",
            addressId?: string | null,
            contactName?: string | null,
            contactNumber?: string | null,
            fullAddress?: string | null,
            address1?: string | null,
            address2?: string | null,
            city?: string | null,
            country: string,
            countryCode: string,
            state: string,
            stateCode?: string | null,
            postalCode: string,
            invalid?: boolean | null,
          } | null,
          logo?:  {
            __typename: "Image",
            alt?: string | null,
            identityId?: string | null,
            key: string,
            level: S3UploadLevel,
            type?: string | null,
          } | null,
          brandColour?: string | null,
          website?: string | null,
          entityUsers?:  {
            __typename: "ModelEntityUserConnection",
            items:  Array< {
              __typename: "EntityUser",
              id: string,
              entityId: string,
              userId: string,
              firmId?: string | null,
              email?: string | null,
              invitedEmail?: string | null,
              ocrEmail?: string | null,
              referredBy?: string | null,
              invitedEntityId?: string | null,
              firmEntityId?: string | null,
              providerContactId?: string | null,
              ownerCode?: string | null,
              clientGroupCode?: string | null,
              clientCode?: string | null,
              firstName?: string | null,
              lastName?: string | null,
              role: EntityUserRole,
              jobTags?: Array< JobTags | null > | null,
              paymentsEnabled?: boolean | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              termsFirmPayTaxAccepted?: boolean | null,
              termsFirmPayTaxDetails?:  {
                __typename: "TermsFirmPayTaxDetails",
                acceptedAt?: string | null,
                email?: string | null,
                ip?: string | null,
                fullName?: string | null,
                firmId?: string | null,
              } | null,
              entitySearchName?: string | null,
              entity?:  {
                __typename: "Entity",
                id: string,
                type: EntityType,
                taxNumber?: string | null,
                companyNumber?: string | null,
                billerCode?: number | null,
                name: string,
                legalName?: string | null,
                businessNames?: Array< string | null > | null,
                searchName?: string | null,
                brandColour?: string | null,
                website?: string | null,
                gstRegistered?: boolean | null,
                gstReportingPeriod?: GSTReportingPeriod | null,
                providerEntityId?: string | null,
                providerCompanyId?: string | null,
                providerBillUserCompanyId?: string | null,
                providerBankAccountId?: string | null,
                providerDigitalWalletId?: string | null,
                providerBpayCrn?: string | null,
                paymentMethodId?: string | null,
                paymentUserId?: string | null,
                disbursementMethodId?: string | null,
                ubosCreated?: boolean | null,
                numUbosCreated?: number | null,
                subCategory?: string | null,
                clientsStatus?: EntityClientsStatus | null,
                ocrEmail?: string | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                owner?: string | null,
                referredBy?: string | null,
                connectedAccount?: string | null,
                accountStatus?: AccountStatus | null,
                customerId?: string | null,
                xeroSyncStatus?: XeroSyncStatus | null,
                xeroLastContactSyncAt?: string | null,
                xeroContactSyncStatus?: XeroSyncStatus | null,
                xeroInvoiceSyncStatus?: XeroSyncStatus | null,
                xeroLastInvoiceSyncAt?: string | null,
                xeroTenantId?: string | null,
                absorbFees?: boolean | null,
                subscriptionTier?: SubscriptionTier | null,
                invitationStatus?: InvitationStatus | null,
                clientsOnboardingStatus?: ClientsOnboardingStatus | null,
                createdBy?: string | null,
                createdByEntityId?: string | null,
                isFirm?: boolean | null,
                createdAt?: string | null,
                updatedAt?: string | null,
              } | null,
              firm?:  {
                __typename: "Entity",
                id: string,
                type: EntityType,
                taxNumber?: string | null,
                companyNumber?: string | null,
                billerCode?: number | null,
                name: string,
                legalName?: string | null,
                businessNames?: Array< string | null > | null,
                searchName?: string | null,
                brandColour?: string | null,
                website?: string | null,
                gstRegistered?: boolean | null,
                gstReportingPeriod?: GSTReportingPeriod | null,
                providerEntityId?: string | null,
                providerCompanyId?: string | null,
                providerBillUserCompanyId?: string | null,
                providerBankAccountId?: string | null,
                providerDigitalWalletId?: string | null,
                providerBpayCrn?: string | null,
                paymentMethodId?: string | null,
                paymentUserId?: string | null,
                disbursementMethodId?: string | null,
                ubosCreated?: boolean | null,
                numUbosCreated?: number | null,
                subCategory?: string | null,
                clientsStatus?: EntityClientsStatus | null,
                ocrEmail?: string | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                owner?: string | null,
                referredBy?: string | null,
                connectedAccount?: string | null,
                accountStatus?: AccountStatus | null,
                customerId?: string | null,
                xeroSyncStatus?: XeroSyncStatus | null,
                xeroLastContactSyncAt?: string | null,
                xeroContactSyncStatus?: XeroSyncStatus | null,
                xeroInvoiceSyncStatus?: XeroSyncStatus | null,
                xeroLastInvoiceSyncAt?: string | null,
                xeroTenantId?: string | null,
                absorbFees?: boolean | null,
                subscriptionTier?: SubscriptionTier | null,
                invitationStatus?: InvitationStatus | null,
                clientsOnboardingStatus?: ClientsOnboardingStatus | null,
                createdBy?: string | null,
                createdByEntityId?: string | null,
                isFirm?: boolean | null,
                createdAt?: string | null,
                updatedAt?: string | null,
              } | null,
              searchName?: string | null,
              taxNumber?: string | null,
              taskSendSMS?: boolean | null,
              companyNumber?: string | null,
              createdBy?: string | null,
              createdAt: string,
              updatedAt: string,
              status?: EntityUserStatus | null,
              partnerId?: string | null,
              managerId?: string | null,
              archivedAt?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gstRegistered?: boolean | null,
          gstReportingPeriod?: GSTReportingPeriod | null,
          providerEntityId?: string | null,
          providerCompanyId?: string | null,
          providerBillUserCompanyId?: string | null,
          providerBankAccountId?: string | null,
          providerDigitalWalletId?: string | null,
          providerBpayCrn?: string | null,
          contact?:  {
            __typename: "EntityContact",
            firstName?: string | null,
            lastName?: string | null,
            email?: string | null,
            phone?: string | null,
            role?: string | null,
          } | null,
          paymentMethods?:  {
            __typename: "ModelPaymentMethodConnection",
            items:  Array< {
              __typename: "PaymentMethod",
              id: string,
              paymentMethodType: PaymentMethodType,
              type?: string | null,
              fullName?: string | null,
              number?: string | null,
              expMonth?: string | null,
              expYear?: string | null,
              accountName?: string | null,
              bankName?: string | null,
              accountNumber?: string | null,
              routingNumber?: string | null,
              holderType?: BankHolderType | null,
              accountType?: BankAccountType | null,
              status?: PaymentMethodStatus | null,
              accountDirection?: AccountDirection | null,
              expiresAt?: string | null,
              createdAt?: string | null,
              updatedAt?: string | null,
              consentId?: string | null,
              consentStatus?: PaymentConsentStatus | null,
              card?: string | null,
              googlepay?: string | null,
              applepay?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          paymentMethodId?: string | null,
          paymentUserId?: string | null,
          disbursementMethodId?: string | null,
          receivingAccounts?:  {
            __typename: "ModelPaymentMethodConnection",
            items:  Array< {
              __typename: "PaymentMethod",
              id: string,
              paymentMethodType: PaymentMethodType,
              type?: string | null,
              fullName?: string | null,
              number?: string | null,
              expMonth?: string | null,
              expYear?: string | null,
              accountName?: string | null,
              bankName?: string | null,
              accountNumber?: string | null,
              routingNumber?: string | null,
              holderType?: BankHolderType | null,
              accountType?: BankAccountType | null,
              status?: PaymentMethodStatus | null,
              accountDirection?: AccountDirection | null,
              expiresAt?: string | null,
              createdAt?: string | null,
              updatedAt?: string | null,
              consentId?: string | null,
              consentStatus?: PaymentConsentStatus | null,
              card?: string | null,
              googlepay?: string | null,
              applepay?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          ubosCreated?: boolean | null,
          numUbosCreated?: number | null,
          subCategory?: string | null,
          clientsStatus?: EntityClientsStatus | null,
          ocrEmail?: string | null,
          termsInvoiceAccepted?: boolean | null,
          termsOcrAccepted?: boolean | null,
          owner?: string | null,
          referredBy?: string | null,
          connectedAccount?: string | null,
          accountStatus?: AccountStatus | null,
          customerId?: string | null,
          xeroSyncStatus?: XeroSyncStatus | null,
          xeroLastContactSyncAt?: string | null,
          xeroContactSyncStatus?: XeroSyncStatus | null,
          xeroInvoiceSyncStatus?: XeroSyncStatus | null,
          xeroLastInvoiceSyncAt?: string | null,
          xeroTenantId?: string | null,
          absorbFees?: boolean | null,
          subscriptionTier?: SubscriptionTier | null,
          invitationStatus?: InvitationStatus | null,
          clientsOnboardingStatus?: ClientsOnboardingStatus | null,
          createdBy?: string | null,
          createdByEntityId?: string | null,
          isFirm?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | null,
        searchName?: string | null,
        taxNumber?: string | null,
        taskSendSMS?: boolean | null,
        companyNumber?: string | null,
        createdBy?: string | null,
        createdAt: string,
        updatedAt: string,
        status?: EntityUserStatus | null,
        partnerId?: string | null,
        managerId?: string | null,
        archivedAt?: string | null,
        taxPaymentReferences?:  {
          __typename: "TaxPaymentReferences",
          itr?:  {
            __typename: "TaxPaymentReference",
            referenceNumber?: string | null,
            updatedAt?: string | null,
          } | null,
          other?:  {
            __typename: "TaxPaymentReference",
            referenceNumber?: string | null,
            updatedAt?: string | null,
          } | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    gstRegistered?: boolean | null,
    gstReportingPeriod?: GSTReportingPeriod | null,
    providerEntityId?: string | null,
    providerCompanyId?: string | null,
    providerBillUserCompanyId?: string | null,
    providerBankAccountId?: string | null,
    providerDigitalWalletId?: string | null,
    providerBpayCrn?: string | null,
    contact?:  {
      __typename: "EntityContact",
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      phone?: string | null,
      role?: string | null,
    } | null,
    paymentMethods?:  {
      __typename: "ModelPaymentMethodConnection",
      items:  Array< {
        __typename: "PaymentMethod",
        id: string,
        paymentMethodType: PaymentMethodType,
        type?: string | null,
        fullName?: string | null,
        number?: string | null,
        expMonth?: string | null,
        expYear?: string | null,
        accountName?: string | null,
        bankName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
        holderType?: BankHolderType | null,
        accountType?: BankAccountType | null,
        status?: PaymentMethodStatus | null,
        accountDirection?: AccountDirection | null,
        expiresAt?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        consentId?: string | null,
        consentStatus?: PaymentConsentStatus | null,
        card?: string | null,
        googlepay?: string | null,
        applepay?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    paymentMethodId?: string | null,
    paymentUserId?: string | null,
    disbursementMethodId?: string | null,
    receivingAccounts?:  {
      __typename: "ModelPaymentMethodConnection",
      items:  Array< {
        __typename: "PaymentMethod",
        id: string,
        paymentMethodType: PaymentMethodType,
        type?: string | null,
        fullName?: string | null,
        number?: string | null,
        expMonth?: string | null,
        expYear?: string | null,
        accountName?: string | null,
        bankName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
        holderType?: BankHolderType | null,
        accountType?: BankAccountType | null,
        status?: PaymentMethodStatus | null,
        accountDirection?: AccountDirection | null,
        expiresAt?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        consentId?: string | null,
        consentStatus?: PaymentConsentStatus | null,
        card?: string | null,
        googlepay?: string | null,
        applepay?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    ubosCreated?: boolean | null,
    numUbosCreated?: number | null,
    subCategory?: string | null,
    clientsStatus?: EntityClientsStatus | null,
    ocrEmail?: string | null,
    termsInvoiceAccepted?: boolean | null,
    termsOcrAccepted?: boolean | null,
    owner?: string | null,
    referredBy?: string | null,
    connectedAccount?: string | null,
    accountStatus?: AccountStatus | null,
    customerId?: string | null,
    xeroSyncStatus?: XeroSyncStatus | null,
    xeroLastContactSyncAt?: string | null,
    xeroContactSyncStatus?: XeroSyncStatus | null,
    xeroInvoiceSyncStatus?: XeroSyncStatus | null,
    xeroLastInvoiceSyncAt?: string | null,
    xeroTenantId?: string | null,
    absorbFees?: boolean | null,
    subscriptionTier?: SubscriptionTier | null,
    invitationStatus?: InvitationStatus | null,
    clientsOnboardingStatus?: ClientsOnboardingStatus | null,
    createdBy?: string | null,
    createdByEntityId?: string | null,
    isFirm?: boolean | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type CreateEntityUserMutationVariables = {
  input: CreateEntityUserInput,
};

export type CreateEntityUserMutation = {
  createEntityUser?:  {
    __typename: "EntityUser",
    id: string,
    entityId: string,
    userId: string,
    firmId?: string | null,
    email?: string | null,
    invitedEmail?: string | null,
    ocrEmail?: string | null,
    referredBy?: string | null,
    invitedEntityId?: string | null,
    firmEntityId?: string | null,
    providerContactId?: string | null,
    ownerCode?: string | null,
    clientGroupCode?: string | null,
    clientCode?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    role: EntityUserRole,
    jobTags?: Array< JobTags | null > | null,
    paymentsEnabled?: boolean | null,
    termsInvoiceAccepted?: boolean | null,
    termsOcrAccepted?: boolean | null,
    termsFirmPayTaxAccepted?: boolean | null,
    termsFirmPayTaxDetails?:  {
      __typename: "TermsFirmPayTaxDetails",
      document?:  {
        __typename: "S3Upload",
        identityId?: string | null,
        key: string,
        level: S3UploadLevel,
        type: S3UploadType,
        name?: string | null,
      } | null,
      acceptedAt?: string | null,
      email?: string | null,
      ip?: string | null,
      fullName?: string | null,
      firmId?: string | null,
    } | null,
    entitySearchName?: string | null,
    entity?:  {
      __typename: "Entity",
      id: string,
      type: EntityType,
      taxNumber?: string | null,
      companyNumber?: string | null,
      billerCode?: number | null,
      name: string,
      legalName?: string | null,
      businessNames?: Array< string | null > | null,
      searchName?: string | null,
      address?:  {
        __typename: "Address",
        addressId?: string | null,
        contactName?: string | null,
        contactNumber?: string | null,
        fullAddress?: string | null,
        address1?: string | null,
        address2?: string | null,
        city?: string | null,
        country: string,
        countryCode: string,
        state: string,
        stateCode?: string | null,
        postalCode: string,
        invalid?: boolean | null,
      } | null,
      logo?:  {
        __typename: "Image",
        alt?: string | null,
        identityId?: string | null,
        key: string,
        level: S3UploadLevel,
        type?: string | null,
      } | null,
      brandColour?: string | null,
      website?: string | null,
      entityUsers?:  {
        __typename: "ModelEntityUserConnection",
        items:  Array< {
          __typename: "EntityUser",
          id: string,
          entityId: string,
          userId: string,
          firmId?: string | null,
          email?: string | null,
          invitedEmail?: string | null,
          ocrEmail?: string | null,
          referredBy?: string | null,
          invitedEntityId?: string | null,
          firmEntityId?: string | null,
          providerContactId?: string | null,
          ownerCode?: string | null,
          clientGroupCode?: string | null,
          clientCode?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          role: EntityUserRole,
          jobTags?: Array< JobTags | null > | null,
          paymentsEnabled?: boolean | null,
          termsInvoiceAccepted?: boolean | null,
          termsOcrAccepted?: boolean | null,
          termsFirmPayTaxAccepted?: boolean | null,
          termsFirmPayTaxDetails?:  {
            __typename: "TermsFirmPayTaxDetails",
            document?:  {
              __typename: "S3Upload",
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type: S3UploadType,
              name?: string | null,
            } | null,
            acceptedAt?: string | null,
            email?: string | null,
            ip?: string | null,
            fullName?: string | null,
            firmId?: string | null,
          } | null,
          entitySearchName?: string | null,
          entity?:  {
            __typename: "Entity",
            id: string,
            type: EntityType,
            taxNumber?: string | null,
            companyNumber?: string | null,
            billerCode?: number | null,
            name: string,
            legalName?: string | null,
            businessNames?: Array< string | null > | null,
            searchName?: string | null,
            address?:  {
              __typename: "Address",
              addressId?: string | null,
              contactName?: string | null,
              contactNumber?: string | null,
              fullAddress?: string | null,
              address1?: string | null,
              address2?: string | null,
              city?: string | null,
              country: string,
              countryCode: string,
              state: string,
              stateCode?: string | null,
              postalCode: string,
              invalid?: boolean | null,
            } | null,
            logo?:  {
              __typename: "Image",
              alt?: string | null,
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type?: string | null,
            } | null,
            brandColour?: string | null,
            website?: string | null,
            entityUsers?:  {
              __typename: "ModelEntityUserConnection",
              items:  Array< {
                __typename: "EntityUser",
                id: string,
                entityId: string,
                userId: string,
                firmId?: string | null,
                email?: string | null,
                invitedEmail?: string | null,
                ocrEmail?: string | null,
                referredBy?: string | null,
                invitedEntityId?: string | null,
                firmEntityId?: string | null,
                providerContactId?: string | null,
                ownerCode?: string | null,
                clientGroupCode?: string | null,
                clientCode?: string | null,
                firstName?: string | null,
                lastName?: string | null,
                role: EntityUserRole,
                jobTags?: Array< JobTags | null > | null,
                paymentsEnabled?: boolean | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                termsFirmPayTaxAccepted?: boolean | null,
                entitySearchName?: string | null,
                searchName?: string | null,
                taxNumber?: string | null,
                taskSendSMS?: boolean | null,
                companyNumber?: string | null,
                createdBy?: string | null,
                createdAt: string,
                updatedAt: string,
                status?: EntityUserStatus | null,
                partnerId?: string | null,
                managerId?: string | null,
                archivedAt?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gstRegistered?: boolean | null,
            gstReportingPeriod?: GSTReportingPeriod | null,
            providerEntityId?: string | null,
            providerCompanyId?: string | null,
            providerBillUserCompanyId?: string | null,
            providerBankAccountId?: string | null,
            providerDigitalWalletId?: string | null,
            providerBpayCrn?: string | null,
            contact?:  {
              __typename: "EntityContact",
              firstName?: string | null,
              lastName?: string | null,
              email?: string | null,
              phone?: string | null,
              role?: string | null,
            } | null,
            paymentMethods?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            paymentMethodId?: string | null,
            paymentUserId?: string | null,
            disbursementMethodId?: string | null,
            receivingAccounts?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            ubosCreated?: boolean | null,
            numUbosCreated?: number | null,
            subCategory?: string | null,
            clientsStatus?: EntityClientsStatus | null,
            ocrEmail?: string | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            owner?: string | null,
            referredBy?: string | null,
            connectedAccount?: string | null,
            accountStatus?: AccountStatus | null,
            customerId?: string | null,
            xeroSyncStatus?: XeroSyncStatus | null,
            xeroLastContactSyncAt?: string | null,
            xeroContactSyncStatus?: XeroSyncStatus | null,
            xeroInvoiceSyncStatus?: XeroSyncStatus | null,
            xeroLastInvoiceSyncAt?: string | null,
            xeroTenantId?: string | null,
            absorbFees?: boolean | null,
            subscriptionTier?: SubscriptionTier | null,
            invitationStatus?: InvitationStatus | null,
            clientsOnboardingStatus?: ClientsOnboardingStatus | null,
            createdBy?: string | null,
            createdByEntityId?: string | null,
            isFirm?: boolean | null,
            createdAt?: string | null,
            updatedAt?: string | null,
          } | null,
          firm?:  {
            __typename: "Entity",
            id: string,
            type: EntityType,
            taxNumber?: string | null,
            companyNumber?: string | null,
            billerCode?: number | null,
            name: string,
            legalName?: string | null,
            businessNames?: Array< string | null > | null,
            searchName?: string | null,
            address?:  {
              __typename: "Address",
              addressId?: string | null,
              contactName?: string | null,
              contactNumber?: string | null,
              fullAddress?: string | null,
              address1?: string | null,
              address2?: string | null,
              city?: string | null,
              country: string,
              countryCode: string,
              state: string,
              stateCode?: string | null,
              postalCode: string,
              invalid?: boolean | null,
            } | null,
            logo?:  {
              __typename: "Image",
              alt?: string | null,
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type?: string | null,
            } | null,
            brandColour?: string | null,
            website?: string | null,
            entityUsers?:  {
              __typename: "ModelEntityUserConnection",
              items:  Array< {
                __typename: "EntityUser",
                id: string,
                entityId: string,
                userId: string,
                firmId?: string | null,
                email?: string | null,
                invitedEmail?: string | null,
                ocrEmail?: string | null,
                referredBy?: string | null,
                invitedEntityId?: string | null,
                firmEntityId?: string | null,
                providerContactId?: string | null,
                ownerCode?: string | null,
                clientGroupCode?: string | null,
                clientCode?: string | null,
                firstName?: string | null,
                lastName?: string | null,
                role: EntityUserRole,
                jobTags?: Array< JobTags | null > | null,
                paymentsEnabled?: boolean | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                termsFirmPayTaxAccepted?: boolean | null,
                entitySearchName?: string | null,
                searchName?: string | null,
                taxNumber?: string | null,
                taskSendSMS?: boolean | null,
                companyNumber?: string | null,
                createdBy?: string | null,
                createdAt: string,
                updatedAt: string,
                status?: EntityUserStatus | null,
                partnerId?: string | null,
                managerId?: string | null,
                archivedAt?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gstRegistered?: boolean | null,
            gstReportingPeriod?: GSTReportingPeriod | null,
            providerEntityId?: string | null,
            providerCompanyId?: string | null,
            providerBillUserCompanyId?: string | null,
            providerBankAccountId?: string | null,
            providerDigitalWalletId?: string | null,
            providerBpayCrn?: string | null,
            contact?:  {
              __typename: "EntityContact",
              firstName?: string | null,
              lastName?: string | null,
              email?: string | null,
              phone?: string | null,
              role?: string | null,
            } | null,
            paymentMethods?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            paymentMethodId?: string | null,
            paymentUserId?: string | null,
            disbursementMethodId?: string | null,
            receivingAccounts?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            ubosCreated?: boolean | null,
            numUbosCreated?: number | null,
            subCategory?: string | null,
            clientsStatus?: EntityClientsStatus | null,
            ocrEmail?: string | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            owner?: string | null,
            referredBy?: string | null,
            connectedAccount?: string | null,
            accountStatus?: AccountStatus | null,
            customerId?: string | null,
            xeroSyncStatus?: XeroSyncStatus | null,
            xeroLastContactSyncAt?: string | null,
            xeroContactSyncStatus?: XeroSyncStatus | null,
            xeroInvoiceSyncStatus?: XeroSyncStatus | null,
            xeroLastInvoiceSyncAt?: string | null,
            xeroTenantId?: string | null,
            absorbFees?: boolean | null,
            subscriptionTier?: SubscriptionTier | null,
            invitationStatus?: InvitationStatus | null,
            clientsOnboardingStatus?: ClientsOnboardingStatus | null,
            createdBy?: string | null,
            createdByEntityId?: string | null,
            isFirm?: boolean | null,
            createdAt?: string | null,
            updatedAt?: string | null,
          } | null,
          searchName?: string | null,
          taxNumber?: string | null,
          taskSendSMS?: boolean | null,
          companyNumber?: string | null,
          createdBy?: string | null,
          createdAt: string,
          updatedAt: string,
          status?: EntityUserStatus | null,
          partnerId?: string | null,
          managerId?: string | null,
          archivedAt?: string | null,
          taxPaymentReferences?:  {
            __typename: "TaxPaymentReferences",
            itr?:  {
              __typename: "TaxPaymentReference",
              referenceNumber?: string | null,
              updatedAt?: string | null,
            } | null,
            other?:  {
              __typename: "TaxPaymentReference",
              referenceNumber?: string | null,
              updatedAt?: string | null,
            } | null,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gstRegistered?: boolean | null,
      gstReportingPeriod?: GSTReportingPeriod | null,
      providerEntityId?: string | null,
      providerCompanyId?: string | null,
      providerBillUserCompanyId?: string | null,
      providerBankAccountId?: string | null,
      providerDigitalWalletId?: string | null,
      providerBpayCrn?: string | null,
      contact?:  {
        __typename: "EntityContact",
        firstName?: string | null,
        lastName?: string | null,
        email?: string | null,
        phone?: string | null,
        role?: string | null,
      } | null,
      paymentMethods?:  {
        __typename: "ModelPaymentMethodConnection",
        items:  Array< {
          __typename: "PaymentMethod",
          id: string,
          paymentMethodType: PaymentMethodType,
          type?: string | null,
          fullName?: string | null,
          number?: string | null,
          expMonth?: string | null,
          expYear?: string | null,
          accountName?: string | null,
          bankName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
          holderType?: BankHolderType | null,
          accountType?: BankAccountType | null,
          status?: PaymentMethodStatus | null,
          accountDirection?: AccountDirection | null,
          expiresAt?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          consentId?: string | null,
          consentStatus?: PaymentConsentStatus | null,
          card?: string | null,
          googlepay?: string | null,
          applepay?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      paymentMethodId?: string | null,
      paymentUserId?: string | null,
      disbursementMethodId?: string | null,
      receivingAccounts?:  {
        __typename: "ModelPaymentMethodConnection",
        items:  Array< {
          __typename: "PaymentMethod",
          id: string,
          paymentMethodType: PaymentMethodType,
          type?: string | null,
          fullName?: string | null,
          number?: string | null,
          expMonth?: string | null,
          expYear?: string | null,
          accountName?: string | null,
          bankName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
          holderType?: BankHolderType | null,
          accountType?: BankAccountType | null,
          status?: PaymentMethodStatus | null,
          accountDirection?: AccountDirection | null,
          expiresAt?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          consentId?: string | null,
          consentStatus?: PaymentConsentStatus | null,
          card?: string | null,
          googlepay?: string | null,
          applepay?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      ubosCreated?: boolean | null,
      numUbosCreated?: number | null,
      subCategory?: string | null,
      clientsStatus?: EntityClientsStatus | null,
      ocrEmail?: string | null,
      termsInvoiceAccepted?: boolean | null,
      termsOcrAccepted?: boolean | null,
      owner?: string | null,
      referredBy?: string | null,
      connectedAccount?: string | null,
      accountStatus?: AccountStatus | null,
      customerId?: string | null,
      xeroSyncStatus?: XeroSyncStatus | null,
      xeroLastContactSyncAt?: string | null,
      xeroContactSyncStatus?: XeroSyncStatus | null,
      xeroInvoiceSyncStatus?: XeroSyncStatus | null,
      xeroLastInvoiceSyncAt?: string | null,
      xeroTenantId?: string | null,
      absorbFees?: boolean | null,
      subscriptionTier?: SubscriptionTier | null,
      invitationStatus?: InvitationStatus | null,
      clientsOnboardingStatus?: ClientsOnboardingStatus | null,
      createdBy?: string | null,
      createdByEntityId?: string | null,
      isFirm?: boolean | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    firm?:  {
      __typename: "Entity",
      id: string,
      type: EntityType,
      taxNumber?: string | null,
      companyNumber?: string | null,
      billerCode?: number | null,
      name: string,
      legalName?: string | null,
      businessNames?: Array< string | null > | null,
      searchName?: string | null,
      address?:  {
        __typename: "Address",
        addressId?: string | null,
        contactName?: string | null,
        contactNumber?: string | null,
        fullAddress?: string | null,
        address1?: string | null,
        address2?: string | null,
        city?: string | null,
        country: string,
        countryCode: string,
        state: string,
        stateCode?: string | null,
        postalCode: string,
        invalid?: boolean | null,
      } | null,
      logo?:  {
        __typename: "Image",
        alt?: string | null,
        identityId?: string | null,
        key: string,
        level: S3UploadLevel,
        type?: string | null,
      } | null,
      brandColour?: string | null,
      website?: string | null,
      entityUsers?:  {
        __typename: "ModelEntityUserConnection",
        items:  Array< {
          __typename: "EntityUser",
          id: string,
          entityId: string,
          userId: string,
          firmId?: string | null,
          email?: string | null,
          invitedEmail?: string | null,
          ocrEmail?: string | null,
          referredBy?: string | null,
          invitedEntityId?: string | null,
          firmEntityId?: string | null,
          providerContactId?: string | null,
          ownerCode?: string | null,
          clientGroupCode?: string | null,
          clientCode?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          role: EntityUserRole,
          jobTags?: Array< JobTags | null > | null,
          paymentsEnabled?: boolean | null,
          termsInvoiceAccepted?: boolean | null,
          termsOcrAccepted?: boolean | null,
          termsFirmPayTaxAccepted?: boolean | null,
          termsFirmPayTaxDetails?:  {
            __typename: "TermsFirmPayTaxDetails",
            document?:  {
              __typename: "S3Upload",
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type: S3UploadType,
              name?: string | null,
            } | null,
            acceptedAt?: string | null,
            email?: string | null,
            ip?: string | null,
            fullName?: string | null,
            firmId?: string | null,
          } | null,
          entitySearchName?: string | null,
          entity?:  {
            __typename: "Entity",
            id: string,
            type: EntityType,
            taxNumber?: string | null,
            companyNumber?: string | null,
            billerCode?: number | null,
            name: string,
            legalName?: string | null,
            businessNames?: Array< string | null > | null,
            searchName?: string | null,
            address?:  {
              __typename: "Address",
              addressId?: string | null,
              contactName?: string | null,
              contactNumber?: string | null,
              fullAddress?: string | null,
              address1?: string | null,
              address2?: string | null,
              city?: string | null,
              country: string,
              countryCode: string,
              state: string,
              stateCode?: string | null,
              postalCode: string,
              invalid?: boolean | null,
            } | null,
            logo?:  {
              __typename: "Image",
              alt?: string | null,
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type?: string | null,
            } | null,
            brandColour?: string | null,
            website?: string | null,
            entityUsers?:  {
              __typename: "ModelEntityUserConnection",
              items:  Array< {
                __typename: "EntityUser",
                id: string,
                entityId: string,
                userId: string,
                firmId?: string | null,
                email?: string | null,
                invitedEmail?: string | null,
                ocrEmail?: string | null,
                referredBy?: string | null,
                invitedEntityId?: string | null,
                firmEntityId?: string | null,
                providerContactId?: string | null,
                ownerCode?: string | null,
                clientGroupCode?: string | null,
                clientCode?: string | null,
                firstName?: string | null,
                lastName?: string | null,
                role: EntityUserRole,
                jobTags?: Array< JobTags | null > | null,
                paymentsEnabled?: boolean | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                termsFirmPayTaxAccepted?: boolean | null,
                entitySearchName?: string | null,
                searchName?: string | null,
                taxNumber?: string | null,
                taskSendSMS?: boolean | null,
                companyNumber?: string | null,
                createdBy?: string | null,
                createdAt: string,
                updatedAt: string,
                status?: EntityUserStatus | null,
                partnerId?: string | null,
                managerId?: string | null,
                archivedAt?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gstRegistered?: boolean | null,
            gstReportingPeriod?: GSTReportingPeriod | null,
            providerEntityId?: string | null,
            providerCompanyId?: string | null,
            providerBillUserCompanyId?: string | null,
            providerBankAccountId?: string | null,
            providerDigitalWalletId?: string | null,
            providerBpayCrn?: string | null,
            contact?:  {
              __typename: "EntityContact",
              firstName?: string | null,
              lastName?: string | null,
              email?: string | null,
              phone?: string | null,
              role?: string | null,
            } | null,
            paymentMethods?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            paymentMethodId?: string | null,
            paymentUserId?: string | null,
            disbursementMethodId?: string | null,
            receivingAccounts?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            ubosCreated?: boolean | null,
            numUbosCreated?: number | null,
            subCategory?: string | null,
            clientsStatus?: EntityClientsStatus | null,
            ocrEmail?: string | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            owner?: string | null,
            referredBy?: string | null,
            connectedAccount?: string | null,
            accountStatus?: AccountStatus | null,
            customerId?: string | null,
            xeroSyncStatus?: XeroSyncStatus | null,
            xeroLastContactSyncAt?: string | null,
            xeroContactSyncStatus?: XeroSyncStatus | null,
            xeroInvoiceSyncStatus?: XeroSyncStatus | null,
            xeroLastInvoiceSyncAt?: string | null,
            xeroTenantId?: string | null,
            absorbFees?: boolean | null,
            subscriptionTier?: SubscriptionTier | null,
            invitationStatus?: InvitationStatus | null,
            clientsOnboardingStatus?: ClientsOnboardingStatus | null,
            createdBy?: string | null,
            createdByEntityId?: string | null,
            isFirm?: boolean | null,
            createdAt?: string | null,
            updatedAt?: string | null,
          } | null,
          firm?:  {
            __typename: "Entity",
            id: string,
            type: EntityType,
            taxNumber?: string | null,
            companyNumber?: string | null,
            billerCode?: number | null,
            name: string,
            legalName?: string | null,
            businessNames?: Array< string | null > | null,
            searchName?: string | null,
            address?:  {
              __typename: "Address",
              addressId?: string | null,
              contactName?: string | null,
              contactNumber?: string | null,
              fullAddress?: string | null,
              address1?: string | null,
              address2?: string | null,
              city?: string | null,
              country: string,
              countryCode: string,
              state: string,
              stateCode?: string | null,
              postalCode: string,
              invalid?: boolean | null,
            } | null,
            logo?:  {
              __typename: "Image",
              alt?: string | null,
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type?: string | null,
            } | null,
            brandColour?: string | null,
            website?: string | null,
            entityUsers?:  {
              __typename: "ModelEntityUserConnection",
              items:  Array< {
                __typename: "EntityUser",
                id: string,
                entityId: string,
                userId: string,
                firmId?: string | null,
                email?: string | null,
                invitedEmail?: string | null,
                ocrEmail?: string | null,
                referredBy?: string | null,
                invitedEntityId?: string | null,
                firmEntityId?: string | null,
                providerContactId?: string | null,
                ownerCode?: string | null,
                clientGroupCode?: string | null,
                clientCode?: string | null,
                firstName?: string | null,
                lastName?: string | null,
                role: EntityUserRole,
                jobTags?: Array< JobTags | null > | null,
                paymentsEnabled?: boolean | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                termsFirmPayTaxAccepted?: boolean | null,
                entitySearchName?: string | null,
                searchName?: string | null,
                taxNumber?: string | null,
                taskSendSMS?: boolean | null,
                companyNumber?: string | null,
                createdBy?: string | null,
                createdAt: string,
                updatedAt: string,
                status?: EntityUserStatus | null,
                partnerId?: string | null,
                managerId?: string | null,
                archivedAt?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gstRegistered?: boolean | null,
            gstReportingPeriod?: GSTReportingPeriod | null,
            providerEntityId?: string | null,
            providerCompanyId?: string | null,
            providerBillUserCompanyId?: string | null,
            providerBankAccountId?: string | null,
            providerDigitalWalletId?: string | null,
            providerBpayCrn?: string | null,
            contact?:  {
              __typename: "EntityContact",
              firstName?: string | null,
              lastName?: string | null,
              email?: string | null,
              phone?: string | null,
              role?: string | null,
            } | null,
            paymentMethods?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            paymentMethodId?: string | null,
            paymentUserId?: string | null,
            disbursementMethodId?: string | null,
            receivingAccounts?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            ubosCreated?: boolean | null,
            numUbosCreated?: number | null,
            subCategory?: string | null,
            clientsStatus?: EntityClientsStatus | null,
            ocrEmail?: string | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            owner?: string | null,
            referredBy?: string | null,
            connectedAccount?: string | null,
            accountStatus?: AccountStatus | null,
            customerId?: string | null,
            xeroSyncStatus?: XeroSyncStatus | null,
            xeroLastContactSyncAt?: string | null,
            xeroContactSyncStatus?: XeroSyncStatus | null,
            xeroInvoiceSyncStatus?: XeroSyncStatus | null,
            xeroLastInvoiceSyncAt?: string | null,
            xeroTenantId?: string | null,
            absorbFees?: boolean | null,
            subscriptionTier?: SubscriptionTier | null,
            invitationStatus?: InvitationStatus | null,
            clientsOnboardingStatus?: ClientsOnboardingStatus | null,
            createdBy?: string | null,
            createdByEntityId?: string | null,
            isFirm?: boolean | null,
            createdAt?: string | null,
            updatedAt?: string | null,
          } | null,
          searchName?: string | null,
          taxNumber?: string | null,
          taskSendSMS?: boolean | null,
          companyNumber?: string | null,
          createdBy?: string | null,
          createdAt: string,
          updatedAt: string,
          status?: EntityUserStatus | null,
          partnerId?: string | null,
          managerId?: string | null,
          archivedAt?: string | null,
          taxPaymentReferences?:  {
            __typename: "TaxPaymentReferences",
            itr?:  {
              __typename: "TaxPaymentReference",
              referenceNumber?: string | null,
              updatedAt?: string | null,
            } | null,
            other?:  {
              __typename: "TaxPaymentReference",
              referenceNumber?: string | null,
              updatedAt?: string | null,
            } | null,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gstRegistered?: boolean | null,
      gstReportingPeriod?: GSTReportingPeriod | null,
      providerEntityId?: string | null,
      providerCompanyId?: string | null,
      providerBillUserCompanyId?: string | null,
      providerBankAccountId?: string | null,
      providerDigitalWalletId?: string | null,
      providerBpayCrn?: string | null,
      contact?:  {
        __typename: "EntityContact",
        firstName?: string | null,
        lastName?: string | null,
        email?: string | null,
        phone?: string | null,
        role?: string | null,
      } | null,
      paymentMethods?:  {
        __typename: "ModelPaymentMethodConnection",
        items:  Array< {
          __typename: "PaymentMethod",
          id: string,
          paymentMethodType: PaymentMethodType,
          type?: string | null,
          fullName?: string | null,
          number?: string | null,
          expMonth?: string | null,
          expYear?: string | null,
          accountName?: string | null,
          bankName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
          holderType?: BankHolderType | null,
          accountType?: BankAccountType | null,
          status?: PaymentMethodStatus | null,
          accountDirection?: AccountDirection | null,
          expiresAt?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          consentId?: string | null,
          consentStatus?: PaymentConsentStatus | null,
          card?: string | null,
          googlepay?: string | null,
          applepay?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      paymentMethodId?: string | null,
      paymentUserId?: string | null,
      disbursementMethodId?: string | null,
      receivingAccounts?:  {
        __typename: "ModelPaymentMethodConnection",
        items:  Array< {
          __typename: "PaymentMethod",
          id: string,
          paymentMethodType: PaymentMethodType,
          type?: string | null,
          fullName?: string | null,
          number?: string | null,
          expMonth?: string | null,
          expYear?: string | null,
          accountName?: string | null,
          bankName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
          holderType?: BankHolderType | null,
          accountType?: BankAccountType | null,
          status?: PaymentMethodStatus | null,
          accountDirection?: AccountDirection | null,
          expiresAt?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          consentId?: string | null,
          consentStatus?: PaymentConsentStatus | null,
          card?: string | null,
          googlepay?: string | null,
          applepay?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      ubosCreated?: boolean | null,
      numUbosCreated?: number | null,
      subCategory?: string | null,
      clientsStatus?: EntityClientsStatus | null,
      ocrEmail?: string | null,
      termsInvoiceAccepted?: boolean | null,
      termsOcrAccepted?: boolean | null,
      owner?: string | null,
      referredBy?: string | null,
      connectedAccount?: string | null,
      accountStatus?: AccountStatus | null,
      customerId?: string | null,
      xeroSyncStatus?: XeroSyncStatus | null,
      xeroLastContactSyncAt?: string | null,
      xeroContactSyncStatus?: XeroSyncStatus | null,
      xeroInvoiceSyncStatus?: XeroSyncStatus | null,
      xeroLastInvoiceSyncAt?: string | null,
      xeroTenantId?: string | null,
      absorbFees?: boolean | null,
      subscriptionTier?: SubscriptionTier | null,
      invitationStatus?: InvitationStatus | null,
      clientsOnboardingStatus?: ClientsOnboardingStatus | null,
      createdBy?: string | null,
      createdByEntityId?: string | null,
      isFirm?: boolean | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    searchName?: string | null,
    taxNumber?: string | null,
    taskSendSMS?: boolean | null,
    companyNumber?: string | null,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
    status?: EntityUserStatus | null,
    partnerId?: string | null,
    managerId?: string | null,
    archivedAt?: string | null,
    taxPaymentReferences?:  {
      __typename: "TaxPaymentReferences",
      itr?:  {
        __typename: "TaxPaymentReference",
        referenceNumber?: string | null,
        updatedAt?: string | null,
      } | null,
      other?:  {
        __typename: "TaxPaymentReference",
        referenceNumber?: string | null,
        updatedAt?: string | null,
      } | null,
    } | null,
  } | null,
};

export type UpdateEntityUserMutationVariables = {
  input: UpdateEntityUserInput,
};

export type UpdateEntityUserMutation = {
  updateEntityUser?:  {
    __typename: "EntityUser",
    id: string,
    entityId: string,
    userId: string,
    firmId?: string | null,
    email?: string | null,
    invitedEmail?: string | null,
    ocrEmail?: string | null,
    referredBy?: string | null,
    invitedEntityId?: string | null,
    firmEntityId?: string | null,
    providerContactId?: string | null,
    ownerCode?: string | null,
    clientGroupCode?: string | null,
    clientCode?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    role: EntityUserRole,
    jobTags?: Array< JobTags | null > | null,
    paymentsEnabled?: boolean | null,
    termsInvoiceAccepted?: boolean | null,
    termsOcrAccepted?: boolean | null,
    termsFirmPayTaxAccepted?: boolean | null,
    termsFirmPayTaxDetails?:  {
      __typename: "TermsFirmPayTaxDetails",
      document?:  {
        __typename: "S3Upload",
        identityId?: string | null,
        key: string,
        level: S3UploadLevel,
        type: S3UploadType,
        name?: string | null,
      } | null,
      acceptedAt?: string | null,
      email?: string | null,
      ip?: string | null,
      fullName?: string | null,
      firmId?: string | null,
    } | null,
    entitySearchName?: string | null,
    entity?:  {
      __typename: "Entity",
      id: string,
      type: EntityType,
      taxNumber?: string | null,
      companyNumber?: string | null,
      billerCode?: number | null,
      name: string,
      legalName?: string | null,
      businessNames?: Array< string | null > | null,
      searchName?: string | null,
      address?:  {
        __typename: "Address",
        addressId?: string | null,
        contactName?: string | null,
        contactNumber?: string | null,
        fullAddress?: string | null,
        address1?: string | null,
        address2?: string | null,
        city?: string | null,
        country: string,
        countryCode: string,
        state: string,
        stateCode?: string | null,
        postalCode: string,
        invalid?: boolean | null,
      } | null,
      logo?:  {
        __typename: "Image",
        alt?: string | null,
        identityId?: string | null,
        key: string,
        level: S3UploadLevel,
        type?: string | null,
      } | null,
      brandColour?: string | null,
      website?: string | null,
      entityUsers?:  {
        __typename: "ModelEntityUserConnection",
        items:  Array< {
          __typename: "EntityUser",
          id: string,
          entityId: string,
          userId: string,
          firmId?: string | null,
          email?: string | null,
          invitedEmail?: string | null,
          ocrEmail?: string | null,
          referredBy?: string | null,
          invitedEntityId?: string | null,
          firmEntityId?: string | null,
          providerContactId?: string | null,
          ownerCode?: string | null,
          clientGroupCode?: string | null,
          clientCode?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          role: EntityUserRole,
          jobTags?: Array< JobTags | null > | null,
          paymentsEnabled?: boolean | null,
          termsInvoiceAccepted?: boolean | null,
          termsOcrAccepted?: boolean | null,
          termsFirmPayTaxAccepted?: boolean | null,
          termsFirmPayTaxDetails?:  {
            __typename: "TermsFirmPayTaxDetails",
            document?:  {
              __typename: "S3Upload",
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type: S3UploadType,
              name?: string | null,
            } | null,
            acceptedAt?: string | null,
            email?: string | null,
            ip?: string | null,
            fullName?: string | null,
            firmId?: string | null,
          } | null,
          entitySearchName?: string | null,
          entity?:  {
            __typename: "Entity",
            id: string,
            type: EntityType,
            taxNumber?: string | null,
            companyNumber?: string | null,
            billerCode?: number | null,
            name: string,
            legalName?: string | null,
            businessNames?: Array< string | null > | null,
            searchName?: string | null,
            address?:  {
              __typename: "Address",
              addressId?: string | null,
              contactName?: string | null,
              contactNumber?: string | null,
              fullAddress?: string | null,
              address1?: string | null,
              address2?: string | null,
              city?: string | null,
              country: string,
              countryCode: string,
              state: string,
              stateCode?: string | null,
              postalCode: string,
              invalid?: boolean | null,
            } | null,
            logo?:  {
              __typename: "Image",
              alt?: string | null,
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type?: string | null,
            } | null,
            brandColour?: string | null,
            website?: string | null,
            entityUsers?:  {
              __typename: "ModelEntityUserConnection",
              items:  Array< {
                __typename: "EntityUser",
                id: string,
                entityId: string,
                userId: string,
                firmId?: string | null,
                email?: string | null,
                invitedEmail?: string | null,
                ocrEmail?: string | null,
                referredBy?: string | null,
                invitedEntityId?: string | null,
                firmEntityId?: string | null,
                providerContactId?: string | null,
                ownerCode?: string | null,
                clientGroupCode?: string | null,
                clientCode?: string | null,
                firstName?: string | null,
                lastName?: string | null,
                role: EntityUserRole,
                jobTags?: Array< JobTags | null > | null,
                paymentsEnabled?: boolean | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                termsFirmPayTaxAccepted?: boolean | null,
                entitySearchName?: string | null,
                searchName?: string | null,
                taxNumber?: string | null,
                taskSendSMS?: boolean | null,
                companyNumber?: string | null,
                createdBy?: string | null,
                createdAt: string,
                updatedAt: string,
                status?: EntityUserStatus | null,
                partnerId?: string | null,
                managerId?: string | null,
                archivedAt?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gstRegistered?: boolean | null,
            gstReportingPeriod?: GSTReportingPeriod | null,
            providerEntityId?: string | null,
            providerCompanyId?: string | null,
            providerBillUserCompanyId?: string | null,
            providerBankAccountId?: string | null,
            providerDigitalWalletId?: string | null,
            providerBpayCrn?: string | null,
            contact?:  {
              __typename: "EntityContact",
              firstName?: string | null,
              lastName?: string | null,
              email?: string | null,
              phone?: string | null,
              role?: string | null,
            } | null,
            paymentMethods?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            paymentMethodId?: string | null,
            paymentUserId?: string | null,
            disbursementMethodId?: string | null,
            receivingAccounts?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            ubosCreated?: boolean | null,
            numUbosCreated?: number | null,
            subCategory?: string | null,
            clientsStatus?: EntityClientsStatus | null,
            ocrEmail?: string | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            owner?: string | null,
            referredBy?: string | null,
            connectedAccount?: string | null,
            accountStatus?: AccountStatus | null,
            customerId?: string | null,
            xeroSyncStatus?: XeroSyncStatus | null,
            xeroLastContactSyncAt?: string | null,
            xeroContactSyncStatus?: XeroSyncStatus | null,
            xeroInvoiceSyncStatus?: XeroSyncStatus | null,
            xeroLastInvoiceSyncAt?: string | null,
            xeroTenantId?: string | null,
            absorbFees?: boolean | null,
            subscriptionTier?: SubscriptionTier | null,
            invitationStatus?: InvitationStatus | null,
            clientsOnboardingStatus?: ClientsOnboardingStatus | null,
            createdBy?: string | null,
            createdByEntityId?: string | null,
            isFirm?: boolean | null,
            createdAt?: string | null,
            updatedAt?: string | null,
          } | null,
          firm?:  {
            __typename: "Entity",
            id: string,
            type: EntityType,
            taxNumber?: string | null,
            companyNumber?: string | null,
            billerCode?: number | null,
            name: string,
            legalName?: string | null,
            businessNames?: Array< string | null > | null,
            searchName?: string | null,
            address?:  {
              __typename: "Address",
              addressId?: string | null,
              contactName?: string | null,
              contactNumber?: string | null,
              fullAddress?: string | null,
              address1?: string | null,
              address2?: string | null,
              city?: string | null,
              country: string,
              countryCode: string,
              state: string,
              stateCode?: string | null,
              postalCode: string,
              invalid?: boolean | null,
            } | null,
            logo?:  {
              __typename: "Image",
              alt?: string | null,
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type?: string | null,
            } | null,
            brandColour?: string | null,
            website?: string | null,
            entityUsers?:  {
              __typename: "ModelEntityUserConnection",
              items:  Array< {
                __typename: "EntityUser",
                id: string,
                entityId: string,
                userId: string,
                firmId?: string | null,
                email?: string | null,
                invitedEmail?: string | null,
                ocrEmail?: string | null,
                referredBy?: string | null,
                invitedEntityId?: string | null,
                firmEntityId?: string | null,
                providerContactId?: string | null,
                ownerCode?: string | null,
                clientGroupCode?: string | null,
                clientCode?: string | null,
                firstName?: string | null,
                lastName?: string | null,
                role: EntityUserRole,
                jobTags?: Array< JobTags | null > | null,
                paymentsEnabled?: boolean | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                termsFirmPayTaxAccepted?: boolean | null,
                entitySearchName?: string | null,
                searchName?: string | null,
                taxNumber?: string | null,
                taskSendSMS?: boolean | null,
                companyNumber?: string | null,
                createdBy?: string | null,
                createdAt: string,
                updatedAt: string,
                status?: EntityUserStatus | null,
                partnerId?: string | null,
                managerId?: string | null,
                archivedAt?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gstRegistered?: boolean | null,
            gstReportingPeriod?: GSTReportingPeriod | null,
            providerEntityId?: string | null,
            providerCompanyId?: string | null,
            providerBillUserCompanyId?: string | null,
            providerBankAccountId?: string | null,
            providerDigitalWalletId?: string | null,
            providerBpayCrn?: string | null,
            contact?:  {
              __typename: "EntityContact",
              firstName?: string | null,
              lastName?: string | null,
              email?: string | null,
              phone?: string | null,
              role?: string | null,
            } | null,
            paymentMethods?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            paymentMethodId?: string | null,
            paymentUserId?: string | null,
            disbursementMethodId?: string | null,
            receivingAccounts?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            ubosCreated?: boolean | null,
            numUbosCreated?: number | null,
            subCategory?: string | null,
            clientsStatus?: EntityClientsStatus | null,
            ocrEmail?: string | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            owner?: string | null,
            referredBy?: string | null,
            connectedAccount?: string | null,
            accountStatus?: AccountStatus | null,
            customerId?: string | null,
            xeroSyncStatus?: XeroSyncStatus | null,
            xeroLastContactSyncAt?: string | null,
            xeroContactSyncStatus?: XeroSyncStatus | null,
            xeroInvoiceSyncStatus?: XeroSyncStatus | null,
            xeroLastInvoiceSyncAt?: string | null,
            xeroTenantId?: string | null,
            absorbFees?: boolean | null,
            subscriptionTier?: SubscriptionTier | null,
            invitationStatus?: InvitationStatus | null,
            clientsOnboardingStatus?: ClientsOnboardingStatus | null,
            createdBy?: string | null,
            createdByEntityId?: string | null,
            isFirm?: boolean | null,
            createdAt?: string | null,
            updatedAt?: string | null,
          } | null,
          searchName?: string | null,
          taxNumber?: string | null,
          taskSendSMS?: boolean | null,
          companyNumber?: string | null,
          createdBy?: string | null,
          createdAt: string,
          updatedAt: string,
          status?: EntityUserStatus | null,
          partnerId?: string | null,
          managerId?: string | null,
          archivedAt?: string | null,
          taxPaymentReferences?:  {
            __typename: "TaxPaymentReferences",
            itr?:  {
              __typename: "TaxPaymentReference",
              referenceNumber?: string | null,
              updatedAt?: string | null,
            } | null,
            other?:  {
              __typename: "TaxPaymentReference",
              referenceNumber?: string | null,
              updatedAt?: string | null,
            } | null,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gstRegistered?: boolean | null,
      gstReportingPeriod?: GSTReportingPeriod | null,
      providerEntityId?: string | null,
      providerCompanyId?: string | null,
      providerBillUserCompanyId?: string | null,
      providerBankAccountId?: string | null,
      providerDigitalWalletId?: string | null,
      providerBpayCrn?: string | null,
      contact?:  {
        __typename: "EntityContact",
        firstName?: string | null,
        lastName?: string | null,
        email?: string | null,
        phone?: string | null,
        role?: string | null,
      } | null,
      paymentMethods?:  {
        __typename: "ModelPaymentMethodConnection",
        items:  Array< {
          __typename: "PaymentMethod",
          id: string,
          paymentMethodType: PaymentMethodType,
          type?: string | null,
          fullName?: string | null,
          number?: string | null,
          expMonth?: string | null,
          expYear?: string | null,
          accountName?: string | null,
          bankName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
          holderType?: BankHolderType | null,
          accountType?: BankAccountType | null,
          status?: PaymentMethodStatus | null,
          accountDirection?: AccountDirection | null,
          expiresAt?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          consentId?: string | null,
          consentStatus?: PaymentConsentStatus | null,
          card?: string | null,
          googlepay?: string | null,
          applepay?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      paymentMethodId?: string | null,
      paymentUserId?: string | null,
      disbursementMethodId?: string | null,
      receivingAccounts?:  {
        __typename: "ModelPaymentMethodConnection",
        items:  Array< {
          __typename: "PaymentMethod",
          id: string,
          paymentMethodType: PaymentMethodType,
          type?: string | null,
          fullName?: string | null,
          number?: string | null,
          expMonth?: string | null,
          expYear?: string | null,
          accountName?: string | null,
          bankName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
          holderType?: BankHolderType | null,
          accountType?: BankAccountType | null,
          status?: PaymentMethodStatus | null,
          accountDirection?: AccountDirection | null,
          expiresAt?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          consentId?: string | null,
          consentStatus?: PaymentConsentStatus | null,
          card?: string | null,
          googlepay?: string | null,
          applepay?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      ubosCreated?: boolean | null,
      numUbosCreated?: number | null,
      subCategory?: string | null,
      clientsStatus?: EntityClientsStatus | null,
      ocrEmail?: string | null,
      termsInvoiceAccepted?: boolean | null,
      termsOcrAccepted?: boolean | null,
      owner?: string | null,
      referredBy?: string | null,
      connectedAccount?: string | null,
      accountStatus?: AccountStatus | null,
      customerId?: string | null,
      xeroSyncStatus?: XeroSyncStatus | null,
      xeroLastContactSyncAt?: string | null,
      xeroContactSyncStatus?: XeroSyncStatus | null,
      xeroInvoiceSyncStatus?: XeroSyncStatus | null,
      xeroLastInvoiceSyncAt?: string | null,
      xeroTenantId?: string | null,
      absorbFees?: boolean | null,
      subscriptionTier?: SubscriptionTier | null,
      invitationStatus?: InvitationStatus | null,
      clientsOnboardingStatus?: ClientsOnboardingStatus | null,
      createdBy?: string | null,
      createdByEntityId?: string | null,
      isFirm?: boolean | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    firm?:  {
      __typename: "Entity",
      id: string,
      type: EntityType,
      taxNumber?: string | null,
      companyNumber?: string | null,
      billerCode?: number | null,
      name: string,
      legalName?: string | null,
      businessNames?: Array< string | null > | null,
      searchName?: string | null,
      address?:  {
        __typename: "Address",
        addressId?: string | null,
        contactName?: string | null,
        contactNumber?: string | null,
        fullAddress?: string | null,
        address1?: string | null,
        address2?: string | null,
        city?: string | null,
        country: string,
        countryCode: string,
        state: string,
        stateCode?: string | null,
        postalCode: string,
        invalid?: boolean | null,
      } | null,
      logo?:  {
        __typename: "Image",
        alt?: string | null,
        identityId?: string | null,
        key: string,
        level: S3UploadLevel,
        type?: string | null,
      } | null,
      brandColour?: string | null,
      website?: string | null,
      entityUsers?:  {
        __typename: "ModelEntityUserConnection",
        items:  Array< {
          __typename: "EntityUser",
          id: string,
          entityId: string,
          userId: string,
          firmId?: string | null,
          email?: string | null,
          invitedEmail?: string | null,
          ocrEmail?: string | null,
          referredBy?: string | null,
          invitedEntityId?: string | null,
          firmEntityId?: string | null,
          providerContactId?: string | null,
          ownerCode?: string | null,
          clientGroupCode?: string | null,
          clientCode?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          role: EntityUserRole,
          jobTags?: Array< JobTags | null > | null,
          paymentsEnabled?: boolean | null,
          termsInvoiceAccepted?: boolean | null,
          termsOcrAccepted?: boolean | null,
          termsFirmPayTaxAccepted?: boolean | null,
          termsFirmPayTaxDetails?:  {
            __typename: "TermsFirmPayTaxDetails",
            document?:  {
              __typename: "S3Upload",
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type: S3UploadType,
              name?: string | null,
            } | null,
            acceptedAt?: string | null,
            email?: string | null,
            ip?: string | null,
            fullName?: string | null,
            firmId?: string | null,
          } | null,
          entitySearchName?: string | null,
          entity?:  {
            __typename: "Entity",
            id: string,
            type: EntityType,
            taxNumber?: string | null,
            companyNumber?: string | null,
            billerCode?: number | null,
            name: string,
            legalName?: string | null,
            businessNames?: Array< string | null > | null,
            searchName?: string | null,
            address?:  {
              __typename: "Address",
              addressId?: string | null,
              contactName?: string | null,
              contactNumber?: string | null,
              fullAddress?: string | null,
              address1?: string | null,
              address2?: string | null,
              city?: string | null,
              country: string,
              countryCode: string,
              state: string,
              stateCode?: string | null,
              postalCode: string,
              invalid?: boolean | null,
            } | null,
            logo?:  {
              __typename: "Image",
              alt?: string | null,
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type?: string | null,
            } | null,
            brandColour?: string | null,
            website?: string | null,
            entityUsers?:  {
              __typename: "ModelEntityUserConnection",
              items:  Array< {
                __typename: "EntityUser",
                id: string,
                entityId: string,
                userId: string,
                firmId?: string | null,
                email?: string | null,
                invitedEmail?: string | null,
                ocrEmail?: string | null,
                referredBy?: string | null,
                invitedEntityId?: string | null,
                firmEntityId?: string | null,
                providerContactId?: string | null,
                ownerCode?: string | null,
                clientGroupCode?: string | null,
                clientCode?: string | null,
                firstName?: string | null,
                lastName?: string | null,
                role: EntityUserRole,
                jobTags?: Array< JobTags | null > | null,
                paymentsEnabled?: boolean | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                termsFirmPayTaxAccepted?: boolean | null,
                entitySearchName?: string | null,
                searchName?: string | null,
                taxNumber?: string | null,
                taskSendSMS?: boolean | null,
                companyNumber?: string | null,
                createdBy?: string | null,
                createdAt: string,
                updatedAt: string,
                status?: EntityUserStatus | null,
                partnerId?: string | null,
                managerId?: string | null,
                archivedAt?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gstRegistered?: boolean | null,
            gstReportingPeriod?: GSTReportingPeriod | null,
            providerEntityId?: string | null,
            providerCompanyId?: string | null,
            providerBillUserCompanyId?: string | null,
            providerBankAccountId?: string | null,
            providerDigitalWalletId?: string | null,
            providerBpayCrn?: string | null,
            contact?:  {
              __typename: "EntityContact",
              firstName?: string | null,
              lastName?: string | null,
              email?: string | null,
              phone?: string | null,
              role?: string | null,
            } | null,
            paymentMethods?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            paymentMethodId?: string | null,
            paymentUserId?: string | null,
            disbursementMethodId?: string | null,
            receivingAccounts?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            ubosCreated?: boolean | null,
            numUbosCreated?: number | null,
            subCategory?: string | null,
            clientsStatus?: EntityClientsStatus | null,
            ocrEmail?: string | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            owner?: string | null,
            referredBy?: string | null,
            connectedAccount?: string | null,
            accountStatus?: AccountStatus | null,
            customerId?: string | null,
            xeroSyncStatus?: XeroSyncStatus | null,
            xeroLastContactSyncAt?: string | null,
            xeroContactSyncStatus?: XeroSyncStatus | null,
            xeroInvoiceSyncStatus?: XeroSyncStatus | null,
            xeroLastInvoiceSyncAt?: string | null,
            xeroTenantId?: string | null,
            absorbFees?: boolean | null,
            subscriptionTier?: SubscriptionTier | null,
            invitationStatus?: InvitationStatus | null,
            clientsOnboardingStatus?: ClientsOnboardingStatus | null,
            createdBy?: string | null,
            createdByEntityId?: string | null,
            isFirm?: boolean | null,
            createdAt?: string | null,
            updatedAt?: string | null,
          } | null,
          firm?:  {
            __typename: "Entity",
            id: string,
            type: EntityType,
            taxNumber?: string | null,
            companyNumber?: string | null,
            billerCode?: number | null,
            name: string,
            legalName?: string | null,
            businessNames?: Array< string | null > | null,
            searchName?: string | null,
            address?:  {
              __typename: "Address",
              addressId?: string | null,
              contactName?: string | null,
              contactNumber?: string | null,
              fullAddress?: string | null,
              address1?: string | null,
              address2?: string | null,
              city?: string | null,
              country: string,
              countryCode: string,
              state: string,
              stateCode?: string | null,
              postalCode: string,
              invalid?: boolean | null,
            } | null,
            logo?:  {
              __typename: "Image",
              alt?: string | null,
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type?: string | null,
            } | null,
            brandColour?: string | null,
            website?: string | null,
            entityUsers?:  {
              __typename: "ModelEntityUserConnection",
              items:  Array< {
                __typename: "EntityUser",
                id: string,
                entityId: string,
                userId: string,
                firmId?: string | null,
                email?: string | null,
                invitedEmail?: string | null,
                ocrEmail?: string | null,
                referredBy?: string | null,
                invitedEntityId?: string | null,
                firmEntityId?: string | null,
                providerContactId?: string | null,
                ownerCode?: string | null,
                clientGroupCode?: string | null,
                clientCode?: string | null,
                firstName?: string | null,
                lastName?: string | null,
                role: EntityUserRole,
                jobTags?: Array< JobTags | null > | null,
                paymentsEnabled?: boolean | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                termsFirmPayTaxAccepted?: boolean | null,
                entitySearchName?: string | null,
                searchName?: string | null,
                taxNumber?: string | null,
                taskSendSMS?: boolean | null,
                companyNumber?: string | null,
                createdBy?: string | null,
                createdAt: string,
                updatedAt: string,
                status?: EntityUserStatus | null,
                partnerId?: string | null,
                managerId?: string | null,
                archivedAt?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gstRegistered?: boolean | null,
            gstReportingPeriod?: GSTReportingPeriod | null,
            providerEntityId?: string | null,
            providerCompanyId?: string | null,
            providerBillUserCompanyId?: string | null,
            providerBankAccountId?: string | null,
            providerDigitalWalletId?: string | null,
            providerBpayCrn?: string | null,
            contact?:  {
              __typename: "EntityContact",
              firstName?: string | null,
              lastName?: string | null,
              email?: string | null,
              phone?: string | null,
              role?: string | null,
            } | null,
            paymentMethods?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            paymentMethodId?: string | null,
            paymentUserId?: string | null,
            disbursementMethodId?: string | null,
            receivingAccounts?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            ubosCreated?: boolean | null,
            numUbosCreated?: number | null,
            subCategory?: string | null,
            clientsStatus?: EntityClientsStatus | null,
            ocrEmail?: string | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            owner?: string | null,
            referredBy?: string | null,
            connectedAccount?: string | null,
            accountStatus?: AccountStatus | null,
            customerId?: string | null,
            xeroSyncStatus?: XeroSyncStatus | null,
            xeroLastContactSyncAt?: string | null,
            xeroContactSyncStatus?: XeroSyncStatus | null,
            xeroInvoiceSyncStatus?: XeroSyncStatus | null,
            xeroLastInvoiceSyncAt?: string | null,
            xeroTenantId?: string | null,
            absorbFees?: boolean | null,
            subscriptionTier?: SubscriptionTier | null,
            invitationStatus?: InvitationStatus | null,
            clientsOnboardingStatus?: ClientsOnboardingStatus | null,
            createdBy?: string | null,
            createdByEntityId?: string | null,
            isFirm?: boolean | null,
            createdAt?: string | null,
            updatedAt?: string | null,
          } | null,
          searchName?: string | null,
          taxNumber?: string | null,
          taskSendSMS?: boolean | null,
          companyNumber?: string | null,
          createdBy?: string | null,
          createdAt: string,
          updatedAt: string,
          status?: EntityUserStatus | null,
          partnerId?: string | null,
          managerId?: string | null,
          archivedAt?: string | null,
          taxPaymentReferences?:  {
            __typename: "TaxPaymentReferences",
            itr?:  {
              __typename: "TaxPaymentReference",
              referenceNumber?: string | null,
              updatedAt?: string | null,
            } | null,
            other?:  {
              __typename: "TaxPaymentReference",
              referenceNumber?: string | null,
              updatedAt?: string | null,
            } | null,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gstRegistered?: boolean | null,
      gstReportingPeriod?: GSTReportingPeriod | null,
      providerEntityId?: string | null,
      providerCompanyId?: string | null,
      providerBillUserCompanyId?: string | null,
      providerBankAccountId?: string | null,
      providerDigitalWalletId?: string | null,
      providerBpayCrn?: string | null,
      contact?:  {
        __typename: "EntityContact",
        firstName?: string | null,
        lastName?: string | null,
        email?: string | null,
        phone?: string | null,
        role?: string | null,
      } | null,
      paymentMethods?:  {
        __typename: "ModelPaymentMethodConnection",
        items:  Array< {
          __typename: "PaymentMethod",
          id: string,
          paymentMethodType: PaymentMethodType,
          type?: string | null,
          fullName?: string | null,
          number?: string | null,
          expMonth?: string | null,
          expYear?: string | null,
          accountName?: string | null,
          bankName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
          holderType?: BankHolderType | null,
          accountType?: BankAccountType | null,
          status?: PaymentMethodStatus | null,
          accountDirection?: AccountDirection | null,
          expiresAt?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          consentId?: string | null,
          consentStatus?: PaymentConsentStatus | null,
          card?: string | null,
          googlepay?: string | null,
          applepay?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      paymentMethodId?: string | null,
      paymentUserId?: string | null,
      disbursementMethodId?: string | null,
      receivingAccounts?:  {
        __typename: "ModelPaymentMethodConnection",
        items:  Array< {
          __typename: "PaymentMethod",
          id: string,
          paymentMethodType: PaymentMethodType,
          type?: string | null,
          fullName?: string | null,
          number?: string | null,
          expMonth?: string | null,
          expYear?: string | null,
          accountName?: string | null,
          bankName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
          holderType?: BankHolderType | null,
          accountType?: BankAccountType | null,
          status?: PaymentMethodStatus | null,
          accountDirection?: AccountDirection | null,
          expiresAt?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          consentId?: string | null,
          consentStatus?: PaymentConsentStatus | null,
          card?: string | null,
          googlepay?: string | null,
          applepay?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      ubosCreated?: boolean | null,
      numUbosCreated?: number | null,
      subCategory?: string | null,
      clientsStatus?: EntityClientsStatus | null,
      ocrEmail?: string | null,
      termsInvoiceAccepted?: boolean | null,
      termsOcrAccepted?: boolean | null,
      owner?: string | null,
      referredBy?: string | null,
      connectedAccount?: string | null,
      accountStatus?: AccountStatus | null,
      customerId?: string | null,
      xeroSyncStatus?: XeroSyncStatus | null,
      xeroLastContactSyncAt?: string | null,
      xeroContactSyncStatus?: XeroSyncStatus | null,
      xeroInvoiceSyncStatus?: XeroSyncStatus | null,
      xeroLastInvoiceSyncAt?: string | null,
      xeroTenantId?: string | null,
      absorbFees?: boolean | null,
      subscriptionTier?: SubscriptionTier | null,
      invitationStatus?: InvitationStatus | null,
      clientsOnboardingStatus?: ClientsOnboardingStatus | null,
      createdBy?: string | null,
      createdByEntityId?: string | null,
      isFirm?: boolean | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    searchName?: string | null,
    taxNumber?: string | null,
    taskSendSMS?: boolean | null,
    companyNumber?: string | null,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
    status?: EntityUserStatus | null,
    partnerId?: string | null,
    managerId?: string | null,
    archivedAt?: string | null,
    taxPaymentReferences?:  {
      __typename: "TaxPaymentReferences",
      itr?:  {
        __typename: "TaxPaymentReference",
        referenceNumber?: string | null,
        updatedAt?: string | null,
      } | null,
      other?:  {
        __typename: "TaxPaymentReference",
        referenceNumber?: string | null,
        updatedAt?: string | null,
      } | null,
    } | null,
  } | null,
};

export type AcceptDenyEntityUserStatusMutationVariables = {
  input: AcceptDenyEntityUserStatusInput,
};

export type AcceptDenyEntityUserStatusMutation = {
  acceptDenyEntityUserStatus?:  {
    __typename: "EntityUser",
    id: string,
    entityId: string,
    userId: string,
    firmId?: string | null,
    email?: string | null,
    invitedEmail?: string | null,
    ocrEmail?: string | null,
    referredBy?: string | null,
    invitedEntityId?: string | null,
    firmEntityId?: string | null,
    providerContactId?: string | null,
    ownerCode?: string | null,
    clientGroupCode?: string | null,
    clientCode?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    role: EntityUserRole,
    jobTags?: Array< JobTags | null > | null,
    paymentsEnabled?: boolean | null,
    termsInvoiceAccepted?: boolean | null,
    termsOcrAccepted?: boolean | null,
    termsFirmPayTaxAccepted?: boolean | null,
    termsFirmPayTaxDetails?:  {
      __typename: "TermsFirmPayTaxDetails",
      document?:  {
        __typename: "S3Upload",
        identityId?: string | null,
        key: string,
        level: S3UploadLevel,
        type: S3UploadType,
        name?: string | null,
      } | null,
      acceptedAt?: string | null,
      email?: string | null,
      ip?: string | null,
      fullName?: string | null,
      firmId?: string | null,
    } | null,
    entitySearchName?: string | null,
    entity?:  {
      __typename: "Entity",
      id: string,
      type: EntityType,
      taxNumber?: string | null,
      companyNumber?: string | null,
      billerCode?: number | null,
      name: string,
      legalName?: string | null,
      businessNames?: Array< string | null > | null,
      searchName?: string | null,
      address?:  {
        __typename: "Address",
        addressId?: string | null,
        contactName?: string | null,
        contactNumber?: string | null,
        fullAddress?: string | null,
        address1?: string | null,
        address2?: string | null,
        city?: string | null,
        country: string,
        countryCode: string,
        state: string,
        stateCode?: string | null,
        postalCode: string,
        invalid?: boolean | null,
      } | null,
      logo?:  {
        __typename: "Image",
        alt?: string | null,
        identityId?: string | null,
        key: string,
        level: S3UploadLevel,
        type?: string | null,
      } | null,
      brandColour?: string | null,
      website?: string | null,
      entityUsers?:  {
        __typename: "ModelEntityUserConnection",
        items:  Array< {
          __typename: "EntityUser",
          id: string,
          entityId: string,
          userId: string,
          firmId?: string | null,
          email?: string | null,
          invitedEmail?: string | null,
          ocrEmail?: string | null,
          referredBy?: string | null,
          invitedEntityId?: string | null,
          firmEntityId?: string | null,
          providerContactId?: string | null,
          ownerCode?: string | null,
          clientGroupCode?: string | null,
          clientCode?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          role: EntityUserRole,
          jobTags?: Array< JobTags | null > | null,
          paymentsEnabled?: boolean | null,
          termsInvoiceAccepted?: boolean | null,
          termsOcrAccepted?: boolean | null,
          termsFirmPayTaxAccepted?: boolean | null,
          termsFirmPayTaxDetails?:  {
            __typename: "TermsFirmPayTaxDetails",
            document?:  {
              __typename: "S3Upload",
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type: S3UploadType,
              name?: string | null,
            } | null,
            acceptedAt?: string | null,
            email?: string | null,
            ip?: string | null,
            fullName?: string | null,
            firmId?: string | null,
          } | null,
          entitySearchName?: string | null,
          entity?:  {
            __typename: "Entity",
            id: string,
            type: EntityType,
            taxNumber?: string | null,
            companyNumber?: string | null,
            billerCode?: number | null,
            name: string,
            legalName?: string | null,
            businessNames?: Array< string | null > | null,
            searchName?: string | null,
            address?:  {
              __typename: "Address",
              addressId?: string | null,
              contactName?: string | null,
              contactNumber?: string | null,
              fullAddress?: string | null,
              address1?: string | null,
              address2?: string | null,
              city?: string | null,
              country: string,
              countryCode: string,
              state: string,
              stateCode?: string | null,
              postalCode: string,
              invalid?: boolean | null,
            } | null,
            logo?:  {
              __typename: "Image",
              alt?: string | null,
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type?: string | null,
            } | null,
            brandColour?: string | null,
            website?: string | null,
            entityUsers?:  {
              __typename: "ModelEntityUserConnection",
              items:  Array< {
                __typename: "EntityUser",
                id: string,
                entityId: string,
                userId: string,
                firmId?: string | null,
                email?: string | null,
                invitedEmail?: string | null,
                ocrEmail?: string | null,
                referredBy?: string | null,
                invitedEntityId?: string | null,
                firmEntityId?: string | null,
                providerContactId?: string | null,
                ownerCode?: string | null,
                clientGroupCode?: string | null,
                clientCode?: string | null,
                firstName?: string | null,
                lastName?: string | null,
                role: EntityUserRole,
                jobTags?: Array< JobTags | null > | null,
                paymentsEnabled?: boolean | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                termsFirmPayTaxAccepted?: boolean | null,
                entitySearchName?: string | null,
                searchName?: string | null,
                taxNumber?: string | null,
                taskSendSMS?: boolean | null,
                companyNumber?: string | null,
                createdBy?: string | null,
                createdAt: string,
                updatedAt: string,
                status?: EntityUserStatus | null,
                partnerId?: string | null,
                managerId?: string | null,
                archivedAt?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gstRegistered?: boolean | null,
            gstReportingPeriod?: GSTReportingPeriod | null,
            providerEntityId?: string | null,
            providerCompanyId?: string | null,
            providerBillUserCompanyId?: string | null,
            providerBankAccountId?: string | null,
            providerDigitalWalletId?: string | null,
            providerBpayCrn?: string | null,
            contact?:  {
              __typename: "EntityContact",
              firstName?: string | null,
              lastName?: string | null,
              email?: string | null,
              phone?: string | null,
              role?: string | null,
            } | null,
            paymentMethods?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            paymentMethodId?: string | null,
            paymentUserId?: string | null,
            disbursementMethodId?: string | null,
            receivingAccounts?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            ubosCreated?: boolean | null,
            numUbosCreated?: number | null,
            subCategory?: string | null,
            clientsStatus?: EntityClientsStatus | null,
            ocrEmail?: string | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            owner?: string | null,
            referredBy?: string | null,
            connectedAccount?: string | null,
            accountStatus?: AccountStatus | null,
            customerId?: string | null,
            xeroSyncStatus?: XeroSyncStatus | null,
            xeroLastContactSyncAt?: string | null,
            xeroContactSyncStatus?: XeroSyncStatus | null,
            xeroInvoiceSyncStatus?: XeroSyncStatus | null,
            xeroLastInvoiceSyncAt?: string | null,
            xeroTenantId?: string | null,
            absorbFees?: boolean | null,
            subscriptionTier?: SubscriptionTier | null,
            invitationStatus?: InvitationStatus | null,
            clientsOnboardingStatus?: ClientsOnboardingStatus | null,
            createdBy?: string | null,
            createdByEntityId?: string | null,
            isFirm?: boolean | null,
            createdAt?: string | null,
            updatedAt?: string | null,
          } | null,
          firm?:  {
            __typename: "Entity",
            id: string,
            type: EntityType,
            taxNumber?: string | null,
            companyNumber?: string | null,
            billerCode?: number | null,
            name: string,
            legalName?: string | null,
            businessNames?: Array< string | null > | null,
            searchName?: string | null,
            address?:  {
              __typename: "Address",
              addressId?: string | null,
              contactName?: string | null,
              contactNumber?: string | null,
              fullAddress?: string | null,
              address1?: string | null,
              address2?: string | null,
              city?: string | null,
              country: string,
              countryCode: string,
              state: string,
              stateCode?: string | null,
              postalCode: string,
              invalid?: boolean | null,
            } | null,
            logo?:  {
              __typename: "Image",
              alt?: string | null,
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type?: string | null,
            } | null,
            brandColour?: string | null,
            website?: string | null,
            entityUsers?:  {
              __typename: "ModelEntityUserConnection",
              items:  Array< {
                __typename: "EntityUser",
                id: string,
                entityId: string,
                userId: string,
                firmId?: string | null,
                email?: string | null,
                invitedEmail?: string | null,
                ocrEmail?: string | null,
                referredBy?: string | null,
                invitedEntityId?: string | null,
                firmEntityId?: string | null,
                providerContactId?: string | null,
                ownerCode?: string | null,
                clientGroupCode?: string | null,
                clientCode?: string | null,
                firstName?: string | null,
                lastName?: string | null,
                role: EntityUserRole,
                jobTags?: Array< JobTags | null > | null,
                paymentsEnabled?: boolean | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                termsFirmPayTaxAccepted?: boolean | null,
                entitySearchName?: string | null,
                searchName?: string | null,
                taxNumber?: string | null,
                taskSendSMS?: boolean | null,
                companyNumber?: string | null,
                createdBy?: string | null,
                createdAt: string,
                updatedAt: string,
                status?: EntityUserStatus | null,
                partnerId?: string | null,
                managerId?: string | null,
                archivedAt?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gstRegistered?: boolean | null,
            gstReportingPeriod?: GSTReportingPeriod | null,
            providerEntityId?: string | null,
            providerCompanyId?: string | null,
            providerBillUserCompanyId?: string | null,
            providerBankAccountId?: string | null,
            providerDigitalWalletId?: string | null,
            providerBpayCrn?: string | null,
            contact?:  {
              __typename: "EntityContact",
              firstName?: string | null,
              lastName?: string | null,
              email?: string | null,
              phone?: string | null,
              role?: string | null,
            } | null,
            paymentMethods?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            paymentMethodId?: string | null,
            paymentUserId?: string | null,
            disbursementMethodId?: string | null,
            receivingAccounts?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            ubosCreated?: boolean | null,
            numUbosCreated?: number | null,
            subCategory?: string | null,
            clientsStatus?: EntityClientsStatus | null,
            ocrEmail?: string | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            owner?: string | null,
            referredBy?: string | null,
            connectedAccount?: string | null,
            accountStatus?: AccountStatus | null,
            customerId?: string | null,
            xeroSyncStatus?: XeroSyncStatus | null,
            xeroLastContactSyncAt?: string | null,
            xeroContactSyncStatus?: XeroSyncStatus | null,
            xeroInvoiceSyncStatus?: XeroSyncStatus | null,
            xeroLastInvoiceSyncAt?: string | null,
            xeroTenantId?: string | null,
            absorbFees?: boolean | null,
            subscriptionTier?: SubscriptionTier | null,
            invitationStatus?: InvitationStatus | null,
            clientsOnboardingStatus?: ClientsOnboardingStatus | null,
            createdBy?: string | null,
            createdByEntityId?: string | null,
            isFirm?: boolean | null,
            createdAt?: string | null,
            updatedAt?: string | null,
          } | null,
          searchName?: string | null,
          taxNumber?: string | null,
          taskSendSMS?: boolean | null,
          companyNumber?: string | null,
          createdBy?: string | null,
          createdAt: string,
          updatedAt: string,
          status?: EntityUserStatus | null,
          partnerId?: string | null,
          managerId?: string | null,
          archivedAt?: string | null,
          taxPaymentReferences?:  {
            __typename: "TaxPaymentReferences",
            itr?:  {
              __typename: "TaxPaymentReference",
              referenceNumber?: string | null,
              updatedAt?: string | null,
            } | null,
            other?:  {
              __typename: "TaxPaymentReference",
              referenceNumber?: string | null,
              updatedAt?: string | null,
            } | null,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gstRegistered?: boolean | null,
      gstReportingPeriod?: GSTReportingPeriod | null,
      providerEntityId?: string | null,
      providerCompanyId?: string | null,
      providerBillUserCompanyId?: string | null,
      providerBankAccountId?: string | null,
      providerDigitalWalletId?: string | null,
      providerBpayCrn?: string | null,
      contact?:  {
        __typename: "EntityContact",
        firstName?: string | null,
        lastName?: string | null,
        email?: string | null,
        phone?: string | null,
        role?: string | null,
      } | null,
      paymentMethods?:  {
        __typename: "ModelPaymentMethodConnection",
        items:  Array< {
          __typename: "PaymentMethod",
          id: string,
          paymentMethodType: PaymentMethodType,
          type?: string | null,
          fullName?: string | null,
          number?: string | null,
          expMonth?: string | null,
          expYear?: string | null,
          accountName?: string | null,
          bankName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
          holderType?: BankHolderType | null,
          accountType?: BankAccountType | null,
          status?: PaymentMethodStatus | null,
          accountDirection?: AccountDirection | null,
          expiresAt?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          consentId?: string | null,
          consentStatus?: PaymentConsentStatus | null,
          card?: string | null,
          googlepay?: string | null,
          applepay?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      paymentMethodId?: string | null,
      paymentUserId?: string | null,
      disbursementMethodId?: string | null,
      receivingAccounts?:  {
        __typename: "ModelPaymentMethodConnection",
        items:  Array< {
          __typename: "PaymentMethod",
          id: string,
          paymentMethodType: PaymentMethodType,
          type?: string | null,
          fullName?: string | null,
          number?: string | null,
          expMonth?: string | null,
          expYear?: string | null,
          accountName?: string | null,
          bankName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
          holderType?: BankHolderType | null,
          accountType?: BankAccountType | null,
          status?: PaymentMethodStatus | null,
          accountDirection?: AccountDirection | null,
          expiresAt?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          consentId?: string | null,
          consentStatus?: PaymentConsentStatus | null,
          card?: string | null,
          googlepay?: string | null,
          applepay?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      ubosCreated?: boolean | null,
      numUbosCreated?: number | null,
      subCategory?: string | null,
      clientsStatus?: EntityClientsStatus | null,
      ocrEmail?: string | null,
      termsInvoiceAccepted?: boolean | null,
      termsOcrAccepted?: boolean | null,
      owner?: string | null,
      referredBy?: string | null,
      connectedAccount?: string | null,
      accountStatus?: AccountStatus | null,
      customerId?: string | null,
      xeroSyncStatus?: XeroSyncStatus | null,
      xeroLastContactSyncAt?: string | null,
      xeroContactSyncStatus?: XeroSyncStatus | null,
      xeroInvoiceSyncStatus?: XeroSyncStatus | null,
      xeroLastInvoiceSyncAt?: string | null,
      xeroTenantId?: string | null,
      absorbFees?: boolean | null,
      subscriptionTier?: SubscriptionTier | null,
      invitationStatus?: InvitationStatus | null,
      clientsOnboardingStatus?: ClientsOnboardingStatus | null,
      createdBy?: string | null,
      createdByEntityId?: string | null,
      isFirm?: boolean | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    firm?:  {
      __typename: "Entity",
      id: string,
      type: EntityType,
      taxNumber?: string | null,
      companyNumber?: string | null,
      billerCode?: number | null,
      name: string,
      legalName?: string | null,
      businessNames?: Array< string | null > | null,
      searchName?: string | null,
      address?:  {
        __typename: "Address",
        addressId?: string | null,
        contactName?: string | null,
        contactNumber?: string | null,
        fullAddress?: string | null,
        address1?: string | null,
        address2?: string | null,
        city?: string | null,
        country: string,
        countryCode: string,
        state: string,
        stateCode?: string | null,
        postalCode: string,
        invalid?: boolean | null,
      } | null,
      logo?:  {
        __typename: "Image",
        alt?: string | null,
        identityId?: string | null,
        key: string,
        level: S3UploadLevel,
        type?: string | null,
      } | null,
      brandColour?: string | null,
      website?: string | null,
      entityUsers?:  {
        __typename: "ModelEntityUserConnection",
        items:  Array< {
          __typename: "EntityUser",
          id: string,
          entityId: string,
          userId: string,
          firmId?: string | null,
          email?: string | null,
          invitedEmail?: string | null,
          ocrEmail?: string | null,
          referredBy?: string | null,
          invitedEntityId?: string | null,
          firmEntityId?: string | null,
          providerContactId?: string | null,
          ownerCode?: string | null,
          clientGroupCode?: string | null,
          clientCode?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          role: EntityUserRole,
          jobTags?: Array< JobTags | null > | null,
          paymentsEnabled?: boolean | null,
          termsInvoiceAccepted?: boolean | null,
          termsOcrAccepted?: boolean | null,
          termsFirmPayTaxAccepted?: boolean | null,
          termsFirmPayTaxDetails?:  {
            __typename: "TermsFirmPayTaxDetails",
            document?:  {
              __typename: "S3Upload",
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type: S3UploadType,
              name?: string | null,
            } | null,
            acceptedAt?: string | null,
            email?: string | null,
            ip?: string | null,
            fullName?: string | null,
            firmId?: string | null,
          } | null,
          entitySearchName?: string | null,
          entity?:  {
            __typename: "Entity",
            id: string,
            type: EntityType,
            taxNumber?: string | null,
            companyNumber?: string | null,
            billerCode?: number | null,
            name: string,
            legalName?: string | null,
            businessNames?: Array< string | null > | null,
            searchName?: string | null,
            address?:  {
              __typename: "Address",
              addressId?: string | null,
              contactName?: string | null,
              contactNumber?: string | null,
              fullAddress?: string | null,
              address1?: string | null,
              address2?: string | null,
              city?: string | null,
              country: string,
              countryCode: string,
              state: string,
              stateCode?: string | null,
              postalCode: string,
              invalid?: boolean | null,
            } | null,
            logo?:  {
              __typename: "Image",
              alt?: string | null,
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type?: string | null,
            } | null,
            brandColour?: string | null,
            website?: string | null,
            entityUsers?:  {
              __typename: "ModelEntityUserConnection",
              items:  Array< {
                __typename: "EntityUser",
                id: string,
                entityId: string,
                userId: string,
                firmId?: string | null,
                email?: string | null,
                invitedEmail?: string | null,
                ocrEmail?: string | null,
                referredBy?: string | null,
                invitedEntityId?: string | null,
                firmEntityId?: string | null,
                providerContactId?: string | null,
                ownerCode?: string | null,
                clientGroupCode?: string | null,
                clientCode?: string | null,
                firstName?: string | null,
                lastName?: string | null,
                role: EntityUserRole,
                jobTags?: Array< JobTags | null > | null,
                paymentsEnabled?: boolean | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                termsFirmPayTaxAccepted?: boolean | null,
                entitySearchName?: string | null,
                searchName?: string | null,
                taxNumber?: string | null,
                taskSendSMS?: boolean | null,
                companyNumber?: string | null,
                createdBy?: string | null,
                createdAt: string,
                updatedAt: string,
                status?: EntityUserStatus | null,
                partnerId?: string | null,
                managerId?: string | null,
                archivedAt?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gstRegistered?: boolean | null,
            gstReportingPeriod?: GSTReportingPeriod | null,
            providerEntityId?: string | null,
            providerCompanyId?: string | null,
            providerBillUserCompanyId?: string | null,
            providerBankAccountId?: string | null,
            providerDigitalWalletId?: string | null,
            providerBpayCrn?: string | null,
            contact?:  {
              __typename: "EntityContact",
              firstName?: string | null,
              lastName?: string | null,
              email?: string | null,
              phone?: string | null,
              role?: string | null,
            } | null,
            paymentMethods?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            paymentMethodId?: string | null,
            paymentUserId?: string | null,
            disbursementMethodId?: string | null,
            receivingAccounts?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            ubosCreated?: boolean | null,
            numUbosCreated?: number | null,
            subCategory?: string | null,
            clientsStatus?: EntityClientsStatus | null,
            ocrEmail?: string | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            owner?: string | null,
            referredBy?: string | null,
            connectedAccount?: string | null,
            accountStatus?: AccountStatus | null,
            customerId?: string | null,
            xeroSyncStatus?: XeroSyncStatus | null,
            xeroLastContactSyncAt?: string | null,
            xeroContactSyncStatus?: XeroSyncStatus | null,
            xeroInvoiceSyncStatus?: XeroSyncStatus | null,
            xeroLastInvoiceSyncAt?: string | null,
            xeroTenantId?: string | null,
            absorbFees?: boolean | null,
            subscriptionTier?: SubscriptionTier | null,
            invitationStatus?: InvitationStatus | null,
            clientsOnboardingStatus?: ClientsOnboardingStatus | null,
            createdBy?: string | null,
            createdByEntityId?: string | null,
            isFirm?: boolean | null,
            createdAt?: string | null,
            updatedAt?: string | null,
          } | null,
          firm?:  {
            __typename: "Entity",
            id: string,
            type: EntityType,
            taxNumber?: string | null,
            companyNumber?: string | null,
            billerCode?: number | null,
            name: string,
            legalName?: string | null,
            businessNames?: Array< string | null > | null,
            searchName?: string | null,
            address?:  {
              __typename: "Address",
              addressId?: string | null,
              contactName?: string | null,
              contactNumber?: string | null,
              fullAddress?: string | null,
              address1?: string | null,
              address2?: string | null,
              city?: string | null,
              country: string,
              countryCode: string,
              state: string,
              stateCode?: string | null,
              postalCode: string,
              invalid?: boolean | null,
            } | null,
            logo?:  {
              __typename: "Image",
              alt?: string | null,
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type?: string | null,
            } | null,
            brandColour?: string | null,
            website?: string | null,
            entityUsers?:  {
              __typename: "ModelEntityUserConnection",
              items:  Array< {
                __typename: "EntityUser",
                id: string,
                entityId: string,
                userId: string,
                firmId?: string | null,
                email?: string | null,
                invitedEmail?: string | null,
                ocrEmail?: string | null,
                referredBy?: string | null,
                invitedEntityId?: string | null,
                firmEntityId?: string | null,
                providerContactId?: string | null,
                ownerCode?: string | null,
                clientGroupCode?: string | null,
                clientCode?: string | null,
                firstName?: string | null,
                lastName?: string | null,
                role: EntityUserRole,
                jobTags?: Array< JobTags | null > | null,
                paymentsEnabled?: boolean | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                termsFirmPayTaxAccepted?: boolean | null,
                entitySearchName?: string | null,
                searchName?: string | null,
                taxNumber?: string | null,
                taskSendSMS?: boolean | null,
                companyNumber?: string | null,
                createdBy?: string | null,
                createdAt: string,
                updatedAt: string,
                status?: EntityUserStatus | null,
                partnerId?: string | null,
                managerId?: string | null,
                archivedAt?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gstRegistered?: boolean | null,
            gstReportingPeriod?: GSTReportingPeriod | null,
            providerEntityId?: string | null,
            providerCompanyId?: string | null,
            providerBillUserCompanyId?: string | null,
            providerBankAccountId?: string | null,
            providerDigitalWalletId?: string | null,
            providerBpayCrn?: string | null,
            contact?:  {
              __typename: "EntityContact",
              firstName?: string | null,
              lastName?: string | null,
              email?: string | null,
              phone?: string | null,
              role?: string | null,
            } | null,
            paymentMethods?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            paymentMethodId?: string | null,
            paymentUserId?: string | null,
            disbursementMethodId?: string | null,
            receivingAccounts?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            ubosCreated?: boolean | null,
            numUbosCreated?: number | null,
            subCategory?: string | null,
            clientsStatus?: EntityClientsStatus | null,
            ocrEmail?: string | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            owner?: string | null,
            referredBy?: string | null,
            connectedAccount?: string | null,
            accountStatus?: AccountStatus | null,
            customerId?: string | null,
            xeroSyncStatus?: XeroSyncStatus | null,
            xeroLastContactSyncAt?: string | null,
            xeroContactSyncStatus?: XeroSyncStatus | null,
            xeroInvoiceSyncStatus?: XeroSyncStatus | null,
            xeroLastInvoiceSyncAt?: string | null,
            xeroTenantId?: string | null,
            absorbFees?: boolean | null,
            subscriptionTier?: SubscriptionTier | null,
            invitationStatus?: InvitationStatus | null,
            clientsOnboardingStatus?: ClientsOnboardingStatus | null,
            createdBy?: string | null,
            createdByEntityId?: string | null,
            isFirm?: boolean | null,
            createdAt?: string | null,
            updatedAt?: string | null,
          } | null,
          searchName?: string | null,
          taxNumber?: string | null,
          taskSendSMS?: boolean | null,
          companyNumber?: string | null,
          createdBy?: string | null,
          createdAt: string,
          updatedAt: string,
          status?: EntityUserStatus | null,
          partnerId?: string | null,
          managerId?: string | null,
          archivedAt?: string | null,
          taxPaymentReferences?:  {
            __typename: "TaxPaymentReferences",
            itr?:  {
              __typename: "TaxPaymentReference",
              referenceNumber?: string | null,
              updatedAt?: string | null,
            } | null,
            other?:  {
              __typename: "TaxPaymentReference",
              referenceNumber?: string | null,
              updatedAt?: string | null,
            } | null,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gstRegistered?: boolean | null,
      gstReportingPeriod?: GSTReportingPeriod | null,
      providerEntityId?: string | null,
      providerCompanyId?: string | null,
      providerBillUserCompanyId?: string | null,
      providerBankAccountId?: string | null,
      providerDigitalWalletId?: string | null,
      providerBpayCrn?: string | null,
      contact?:  {
        __typename: "EntityContact",
        firstName?: string | null,
        lastName?: string | null,
        email?: string | null,
        phone?: string | null,
        role?: string | null,
      } | null,
      paymentMethods?:  {
        __typename: "ModelPaymentMethodConnection",
        items:  Array< {
          __typename: "PaymentMethod",
          id: string,
          paymentMethodType: PaymentMethodType,
          type?: string | null,
          fullName?: string | null,
          number?: string | null,
          expMonth?: string | null,
          expYear?: string | null,
          accountName?: string | null,
          bankName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
          holderType?: BankHolderType | null,
          accountType?: BankAccountType | null,
          status?: PaymentMethodStatus | null,
          accountDirection?: AccountDirection | null,
          expiresAt?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          consentId?: string | null,
          consentStatus?: PaymentConsentStatus | null,
          card?: string | null,
          googlepay?: string | null,
          applepay?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      paymentMethodId?: string | null,
      paymentUserId?: string | null,
      disbursementMethodId?: string | null,
      receivingAccounts?:  {
        __typename: "ModelPaymentMethodConnection",
        items:  Array< {
          __typename: "PaymentMethod",
          id: string,
          paymentMethodType: PaymentMethodType,
          type?: string | null,
          fullName?: string | null,
          number?: string | null,
          expMonth?: string | null,
          expYear?: string | null,
          accountName?: string | null,
          bankName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
          holderType?: BankHolderType | null,
          accountType?: BankAccountType | null,
          status?: PaymentMethodStatus | null,
          accountDirection?: AccountDirection | null,
          expiresAt?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          consentId?: string | null,
          consentStatus?: PaymentConsentStatus | null,
          card?: string | null,
          googlepay?: string | null,
          applepay?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      ubosCreated?: boolean | null,
      numUbosCreated?: number | null,
      subCategory?: string | null,
      clientsStatus?: EntityClientsStatus | null,
      ocrEmail?: string | null,
      termsInvoiceAccepted?: boolean | null,
      termsOcrAccepted?: boolean | null,
      owner?: string | null,
      referredBy?: string | null,
      connectedAccount?: string | null,
      accountStatus?: AccountStatus | null,
      customerId?: string | null,
      xeroSyncStatus?: XeroSyncStatus | null,
      xeroLastContactSyncAt?: string | null,
      xeroContactSyncStatus?: XeroSyncStatus | null,
      xeroInvoiceSyncStatus?: XeroSyncStatus | null,
      xeroLastInvoiceSyncAt?: string | null,
      xeroTenantId?: string | null,
      absorbFees?: boolean | null,
      subscriptionTier?: SubscriptionTier | null,
      invitationStatus?: InvitationStatus | null,
      clientsOnboardingStatus?: ClientsOnboardingStatus | null,
      createdBy?: string | null,
      createdByEntityId?: string | null,
      isFirm?: boolean | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    searchName?: string | null,
    taxNumber?: string | null,
    taskSendSMS?: boolean | null,
    companyNumber?: string | null,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
    status?: EntityUserStatus | null,
    partnerId?: string | null,
    managerId?: string | null,
    archivedAt?: string | null,
    taxPaymentReferences?:  {
      __typename: "TaxPaymentReferences",
      itr?:  {
        __typename: "TaxPaymentReference",
        referenceNumber?: string | null,
        updatedAt?: string | null,
      } | null,
      other?:  {
        __typename: "TaxPaymentReference",
        referenceNumber?: string | null,
        updatedAt?: string | null,
      } | null,
    } | null,
  } | null,
};

export type SendReferralInvitationEmailMutationVariables = {
  input: sendReferralInvitationEmailInput,
};

export type SendReferralInvitationEmailMutation = {
  sendReferralInvitationEmail?: boolean | null,
};

export type DeleteEntityUserMutationVariables = {
  input?: DeleteEntityUserInput | null,
};

export type DeleteEntityUserMutation = {
  deleteEntityUser?:  {
    __typename: "EntityUser",
    id: string,
    entityId: string,
    userId: string,
    firmId?: string | null,
    email?: string | null,
    invitedEmail?: string | null,
    ocrEmail?: string | null,
    referredBy?: string | null,
    invitedEntityId?: string | null,
    firmEntityId?: string | null,
    providerContactId?: string | null,
    ownerCode?: string | null,
    clientGroupCode?: string | null,
    clientCode?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    role: EntityUserRole,
    jobTags?: Array< JobTags | null > | null,
    paymentsEnabled?: boolean | null,
    termsInvoiceAccepted?: boolean | null,
    termsOcrAccepted?: boolean | null,
    termsFirmPayTaxAccepted?: boolean | null,
    termsFirmPayTaxDetails?:  {
      __typename: "TermsFirmPayTaxDetails",
      document?:  {
        __typename: "S3Upload",
        identityId?: string | null,
        key: string,
        level: S3UploadLevel,
        type: S3UploadType,
        name?: string | null,
      } | null,
      acceptedAt?: string | null,
      email?: string | null,
      ip?: string | null,
      fullName?: string | null,
      firmId?: string | null,
    } | null,
    entitySearchName?: string | null,
    entity?:  {
      __typename: "Entity",
      id: string,
      type: EntityType,
      taxNumber?: string | null,
      companyNumber?: string | null,
      billerCode?: number | null,
      name: string,
      legalName?: string | null,
      businessNames?: Array< string | null > | null,
      searchName?: string | null,
      address?:  {
        __typename: "Address",
        addressId?: string | null,
        contactName?: string | null,
        contactNumber?: string | null,
        fullAddress?: string | null,
        address1?: string | null,
        address2?: string | null,
        city?: string | null,
        country: string,
        countryCode: string,
        state: string,
        stateCode?: string | null,
        postalCode: string,
        invalid?: boolean | null,
      } | null,
      logo?:  {
        __typename: "Image",
        alt?: string | null,
        identityId?: string | null,
        key: string,
        level: S3UploadLevel,
        type?: string | null,
      } | null,
      brandColour?: string | null,
      website?: string | null,
      entityUsers?:  {
        __typename: "ModelEntityUserConnection",
        items:  Array< {
          __typename: "EntityUser",
          id: string,
          entityId: string,
          userId: string,
          firmId?: string | null,
          email?: string | null,
          invitedEmail?: string | null,
          ocrEmail?: string | null,
          referredBy?: string | null,
          invitedEntityId?: string | null,
          firmEntityId?: string | null,
          providerContactId?: string | null,
          ownerCode?: string | null,
          clientGroupCode?: string | null,
          clientCode?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          role: EntityUserRole,
          jobTags?: Array< JobTags | null > | null,
          paymentsEnabled?: boolean | null,
          termsInvoiceAccepted?: boolean | null,
          termsOcrAccepted?: boolean | null,
          termsFirmPayTaxAccepted?: boolean | null,
          termsFirmPayTaxDetails?:  {
            __typename: "TermsFirmPayTaxDetails",
            document?:  {
              __typename: "S3Upload",
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type: S3UploadType,
              name?: string | null,
            } | null,
            acceptedAt?: string | null,
            email?: string | null,
            ip?: string | null,
            fullName?: string | null,
            firmId?: string | null,
          } | null,
          entitySearchName?: string | null,
          entity?:  {
            __typename: "Entity",
            id: string,
            type: EntityType,
            taxNumber?: string | null,
            companyNumber?: string | null,
            billerCode?: number | null,
            name: string,
            legalName?: string | null,
            businessNames?: Array< string | null > | null,
            searchName?: string | null,
            address?:  {
              __typename: "Address",
              addressId?: string | null,
              contactName?: string | null,
              contactNumber?: string | null,
              fullAddress?: string | null,
              address1?: string | null,
              address2?: string | null,
              city?: string | null,
              country: string,
              countryCode: string,
              state: string,
              stateCode?: string | null,
              postalCode: string,
              invalid?: boolean | null,
            } | null,
            logo?:  {
              __typename: "Image",
              alt?: string | null,
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type?: string | null,
            } | null,
            brandColour?: string | null,
            website?: string | null,
            entityUsers?:  {
              __typename: "ModelEntityUserConnection",
              items:  Array< {
                __typename: "EntityUser",
                id: string,
                entityId: string,
                userId: string,
                firmId?: string | null,
                email?: string | null,
                invitedEmail?: string | null,
                ocrEmail?: string | null,
                referredBy?: string | null,
                invitedEntityId?: string | null,
                firmEntityId?: string | null,
                providerContactId?: string | null,
                ownerCode?: string | null,
                clientGroupCode?: string | null,
                clientCode?: string | null,
                firstName?: string | null,
                lastName?: string | null,
                role: EntityUserRole,
                jobTags?: Array< JobTags | null > | null,
                paymentsEnabled?: boolean | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                termsFirmPayTaxAccepted?: boolean | null,
                entitySearchName?: string | null,
                searchName?: string | null,
                taxNumber?: string | null,
                taskSendSMS?: boolean | null,
                companyNumber?: string | null,
                createdBy?: string | null,
                createdAt: string,
                updatedAt: string,
                status?: EntityUserStatus | null,
                partnerId?: string | null,
                managerId?: string | null,
                archivedAt?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gstRegistered?: boolean | null,
            gstReportingPeriod?: GSTReportingPeriod | null,
            providerEntityId?: string | null,
            providerCompanyId?: string | null,
            providerBillUserCompanyId?: string | null,
            providerBankAccountId?: string | null,
            providerDigitalWalletId?: string | null,
            providerBpayCrn?: string | null,
            contact?:  {
              __typename: "EntityContact",
              firstName?: string | null,
              lastName?: string | null,
              email?: string | null,
              phone?: string | null,
              role?: string | null,
            } | null,
            paymentMethods?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            paymentMethodId?: string | null,
            paymentUserId?: string | null,
            disbursementMethodId?: string | null,
            receivingAccounts?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            ubosCreated?: boolean | null,
            numUbosCreated?: number | null,
            subCategory?: string | null,
            clientsStatus?: EntityClientsStatus | null,
            ocrEmail?: string | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            owner?: string | null,
            referredBy?: string | null,
            connectedAccount?: string | null,
            accountStatus?: AccountStatus | null,
            customerId?: string | null,
            xeroSyncStatus?: XeroSyncStatus | null,
            xeroLastContactSyncAt?: string | null,
            xeroContactSyncStatus?: XeroSyncStatus | null,
            xeroInvoiceSyncStatus?: XeroSyncStatus | null,
            xeroLastInvoiceSyncAt?: string | null,
            xeroTenantId?: string | null,
            absorbFees?: boolean | null,
            subscriptionTier?: SubscriptionTier | null,
            invitationStatus?: InvitationStatus | null,
            clientsOnboardingStatus?: ClientsOnboardingStatus | null,
            createdBy?: string | null,
            createdByEntityId?: string | null,
            isFirm?: boolean | null,
            createdAt?: string | null,
            updatedAt?: string | null,
          } | null,
          firm?:  {
            __typename: "Entity",
            id: string,
            type: EntityType,
            taxNumber?: string | null,
            companyNumber?: string | null,
            billerCode?: number | null,
            name: string,
            legalName?: string | null,
            businessNames?: Array< string | null > | null,
            searchName?: string | null,
            address?:  {
              __typename: "Address",
              addressId?: string | null,
              contactName?: string | null,
              contactNumber?: string | null,
              fullAddress?: string | null,
              address1?: string | null,
              address2?: string | null,
              city?: string | null,
              country: string,
              countryCode: string,
              state: string,
              stateCode?: string | null,
              postalCode: string,
              invalid?: boolean | null,
            } | null,
            logo?:  {
              __typename: "Image",
              alt?: string | null,
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type?: string | null,
            } | null,
            brandColour?: string | null,
            website?: string | null,
            entityUsers?:  {
              __typename: "ModelEntityUserConnection",
              items:  Array< {
                __typename: "EntityUser",
                id: string,
                entityId: string,
                userId: string,
                firmId?: string | null,
                email?: string | null,
                invitedEmail?: string | null,
                ocrEmail?: string | null,
                referredBy?: string | null,
                invitedEntityId?: string | null,
                firmEntityId?: string | null,
                providerContactId?: string | null,
                ownerCode?: string | null,
                clientGroupCode?: string | null,
                clientCode?: string | null,
                firstName?: string | null,
                lastName?: string | null,
                role: EntityUserRole,
                jobTags?: Array< JobTags | null > | null,
                paymentsEnabled?: boolean | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                termsFirmPayTaxAccepted?: boolean | null,
                entitySearchName?: string | null,
                searchName?: string | null,
                taxNumber?: string | null,
                taskSendSMS?: boolean | null,
                companyNumber?: string | null,
                createdBy?: string | null,
                createdAt: string,
                updatedAt: string,
                status?: EntityUserStatus | null,
                partnerId?: string | null,
                managerId?: string | null,
                archivedAt?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gstRegistered?: boolean | null,
            gstReportingPeriod?: GSTReportingPeriod | null,
            providerEntityId?: string | null,
            providerCompanyId?: string | null,
            providerBillUserCompanyId?: string | null,
            providerBankAccountId?: string | null,
            providerDigitalWalletId?: string | null,
            providerBpayCrn?: string | null,
            contact?:  {
              __typename: "EntityContact",
              firstName?: string | null,
              lastName?: string | null,
              email?: string | null,
              phone?: string | null,
              role?: string | null,
            } | null,
            paymentMethods?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            paymentMethodId?: string | null,
            paymentUserId?: string | null,
            disbursementMethodId?: string | null,
            receivingAccounts?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            ubosCreated?: boolean | null,
            numUbosCreated?: number | null,
            subCategory?: string | null,
            clientsStatus?: EntityClientsStatus | null,
            ocrEmail?: string | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            owner?: string | null,
            referredBy?: string | null,
            connectedAccount?: string | null,
            accountStatus?: AccountStatus | null,
            customerId?: string | null,
            xeroSyncStatus?: XeroSyncStatus | null,
            xeroLastContactSyncAt?: string | null,
            xeroContactSyncStatus?: XeroSyncStatus | null,
            xeroInvoiceSyncStatus?: XeroSyncStatus | null,
            xeroLastInvoiceSyncAt?: string | null,
            xeroTenantId?: string | null,
            absorbFees?: boolean | null,
            subscriptionTier?: SubscriptionTier | null,
            invitationStatus?: InvitationStatus | null,
            clientsOnboardingStatus?: ClientsOnboardingStatus | null,
            createdBy?: string | null,
            createdByEntityId?: string | null,
            isFirm?: boolean | null,
            createdAt?: string | null,
            updatedAt?: string | null,
          } | null,
          searchName?: string | null,
          taxNumber?: string | null,
          taskSendSMS?: boolean | null,
          companyNumber?: string | null,
          createdBy?: string | null,
          createdAt: string,
          updatedAt: string,
          status?: EntityUserStatus | null,
          partnerId?: string | null,
          managerId?: string | null,
          archivedAt?: string | null,
          taxPaymentReferences?:  {
            __typename: "TaxPaymentReferences",
            itr?:  {
              __typename: "TaxPaymentReference",
              referenceNumber?: string | null,
              updatedAt?: string | null,
            } | null,
            other?:  {
              __typename: "TaxPaymentReference",
              referenceNumber?: string | null,
              updatedAt?: string | null,
            } | null,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gstRegistered?: boolean | null,
      gstReportingPeriod?: GSTReportingPeriod | null,
      providerEntityId?: string | null,
      providerCompanyId?: string | null,
      providerBillUserCompanyId?: string | null,
      providerBankAccountId?: string | null,
      providerDigitalWalletId?: string | null,
      providerBpayCrn?: string | null,
      contact?:  {
        __typename: "EntityContact",
        firstName?: string | null,
        lastName?: string | null,
        email?: string | null,
        phone?: string | null,
        role?: string | null,
      } | null,
      paymentMethods?:  {
        __typename: "ModelPaymentMethodConnection",
        items:  Array< {
          __typename: "PaymentMethod",
          id: string,
          paymentMethodType: PaymentMethodType,
          type?: string | null,
          fullName?: string | null,
          number?: string | null,
          expMonth?: string | null,
          expYear?: string | null,
          accountName?: string | null,
          bankName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
          holderType?: BankHolderType | null,
          accountType?: BankAccountType | null,
          status?: PaymentMethodStatus | null,
          accountDirection?: AccountDirection | null,
          expiresAt?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          consentId?: string | null,
          consentStatus?: PaymentConsentStatus | null,
          card?: string | null,
          googlepay?: string | null,
          applepay?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      paymentMethodId?: string | null,
      paymentUserId?: string | null,
      disbursementMethodId?: string | null,
      receivingAccounts?:  {
        __typename: "ModelPaymentMethodConnection",
        items:  Array< {
          __typename: "PaymentMethod",
          id: string,
          paymentMethodType: PaymentMethodType,
          type?: string | null,
          fullName?: string | null,
          number?: string | null,
          expMonth?: string | null,
          expYear?: string | null,
          accountName?: string | null,
          bankName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
          holderType?: BankHolderType | null,
          accountType?: BankAccountType | null,
          status?: PaymentMethodStatus | null,
          accountDirection?: AccountDirection | null,
          expiresAt?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          consentId?: string | null,
          consentStatus?: PaymentConsentStatus | null,
          card?: string | null,
          googlepay?: string | null,
          applepay?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      ubosCreated?: boolean | null,
      numUbosCreated?: number | null,
      subCategory?: string | null,
      clientsStatus?: EntityClientsStatus | null,
      ocrEmail?: string | null,
      termsInvoiceAccepted?: boolean | null,
      termsOcrAccepted?: boolean | null,
      owner?: string | null,
      referredBy?: string | null,
      connectedAccount?: string | null,
      accountStatus?: AccountStatus | null,
      customerId?: string | null,
      xeroSyncStatus?: XeroSyncStatus | null,
      xeroLastContactSyncAt?: string | null,
      xeroContactSyncStatus?: XeroSyncStatus | null,
      xeroInvoiceSyncStatus?: XeroSyncStatus | null,
      xeroLastInvoiceSyncAt?: string | null,
      xeroTenantId?: string | null,
      absorbFees?: boolean | null,
      subscriptionTier?: SubscriptionTier | null,
      invitationStatus?: InvitationStatus | null,
      clientsOnboardingStatus?: ClientsOnboardingStatus | null,
      createdBy?: string | null,
      createdByEntityId?: string | null,
      isFirm?: boolean | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    firm?:  {
      __typename: "Entity",
      id: string,
      type: EntityType,
      taxNumber?: string | null,
      companyNumber?: string | null,
      billerCode?: number | null,
      name: string,
      legalName?: string | null,
      businessNames?: Array< string | null > | null,
      searchName?: string | null,
      address?:  {
        __typename: "Address",
        addressId?: string | null,
        contactName?: string | null,
        contactNumber?: string | null,
        fullAddress?: string | null,
        address1?: string | null,
        address2?: string | null,
        city?: string | null,
        country: string,
        countryCode: string,
        state: string,
        stateCode?: string | null,
        postalCode: string,
        invalid?: boolean | null,
      } | null,
      logo?:  {
        __typename: "Image",
        alt?: string | null,
        identityId?: string | null,
        key: string,
        level: S3UploadLevel,
        type?: string | null,
      } | null,
      brandColour?: string | null,
      website?: string | null,
      entityUsers?:  {
        __typename: "ModelEntityUserConnection",
        items:  Array< {
          __typename: "EntityUser",
          id: string,
          entityId: string,
          userId: string,
          firmId?: string | null,
          email?: string | null,
          invitedEmail?: string | null,
          ocrEmail?: string | null,
          referredBy?: string | null,
          invitedEntityId?: string | null,
          firmEntityId?: string | null,
          providerContactId?: string | null,
          ownerCode?: string | null,
          clientGroupCode?: string | null,
          clientCode?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          role: EntityUserRole,
          jobTags?: Array< JobTags | null > | null,
          paymentsEnabled?: boolean | null,
          termsInvoiceAccepted?: boolean | null,
          termsOcrAccepted?: boolean | null,
          termsFirmPayTaxAccepted?: boolean | null,
          termsFirmPayTaxDetails?:  {
            __typename: "TermsFirmPayTaxDetails",
            document?:  {
              __typename: "S3Upload",
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type: S3UploadType,
              name?: string | null,
            } | null,
            acceptedAt?: string | null,
            email?: string | null,
            ip?: string | null,
            fullName?: string | null,
            firmId?: string | null,
          } | null,
          entitySearchName?: string | null,
          entity?:  {
            __typename: "Entity",
            id: string,
            type: EntityType,
            taxNumber?: string | null,
            companyNumber?: string | null,
            billerCode?: number | null,
            name: string,
            legalName?: string | null,
            businessNames?: Array< string | null > | null,
            searchName?: string | null,
            address?:  {
              __typename: "Address",
              addressId?: string | null,
              contactName?: string | null,
              contactNumber?: string | null,
              fullAddress?: string | null,
              address1?: string | null,
              address2?: string | null,
              city?: string | null,
              country: string,
              countryCode: string,
              state: string,
              stateCode?: string | null,
              postalCode: string,
              invalid?: boolean | null,
            } | null,
            logo?:  {
              __typename: "Image",
              alt?: string | null,
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type?: string | null,
            } | null,
            brandColour?: string | null,
            website?: string | null,
            entityUsers?:  {
              __typename: "ModelEntityUserConnection",
              items:  Array< {
                __typename: "EntityUser",
                id: string,
                entityId: string,
                userId: string,
                firmId?: string | null,
                email?: string | null,
                invitedEmail?: string | null,
                ocrEmail?: string | null,
                referredBy?: string | null,
                invitedEntityId?: string | null,
                firmEntityId?: string | null,
                providerContactId?: string | null,
                ownerCode?: string | null,
                clientGroupCode?: string | null,
                clientCode?: string | null,
                firstName?: string | null,
                lastName?: string | null,
                role: EntityUserRole,
                jobTags?: Array< JobTags | null > | null,
                paymentsEnabled?: boolean | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                termsFirmPayTaxAccepted?: boolean | null,
                entitySearchName?: string | null,
                searchName?: string | null,
                taxNumber?: string | null,
                taskSendSMS?: boolean | null,
                companyNumber?: string | null,
                createdBy?: string | null,
                createdAt: string,
                updatedAt: string,
                status?: EntityUserStatus | null,
                partnerId?: string | null,
                managerId?: string | null,
                archivedAt?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gstRegistered?: boolean | null,
            gstReportingPeriod?: GSTReportingPeriod | null,
            providerEntityId?: string | null,
            providerCompanyId?: string | null,
            providerBillUserCompanyId?: string | null,
            providerBankAccountId?: string | null,
            providerDigitalWalletId?: string | null,
            providerBpayCrn?: string | null,
            contact?:  {
              __typename: "EntityContact",
              firstName?: string | null,
              lastName?: string | null,
              email?: string | null,
              phone?: string | null,
              role?: string | null,
            } | null,
            paymentMethods?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            paymentMethodId?: string | null,
            paymentUserId?: string | null,
            disbursementMethodId?: string | null,
            receivingAccounts?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            ubosCreated?: boolean | null,
            numUbosCreated?: number | null,
            subCategory?: string | null,
            clientsStatus?: EntityClientsStatus | null,
            ocrEmail?: string | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            owner?: string | null,
            referredBy?: string | null,
            connectedAccount?: string | null,
            accountStatus?: AccountStatus | null,
            customerId?: string | null,
            xeroSyncStatus?: XeroSyncStatus | null,
            xeroLastContactSyncAt?: string | null,
            xeroContactSyncStatus?: XeroSyncStatus | null,
            xeroInvoiceSyncStatus?: XeroSyncStatus | null,
            xeroLastInvoiceSyncAt?: string | null,
            xeroTenantId?: string | null,
            absorbFees?: boolean | null,
            subscriptionTier?: SubscriptionTier | null,
            invitationStatus?: InvitationStatus | null,
            clientsOnboardingStatus?: ClientsOnboardingStatus | null,
            createdBy?: string | null,
            createdByEntityId?: string | null,
            isFirm?: boolean | null,
            createdAt?: string | null,
            updatedAt?: string | null,
          } | null,
          firm?:  {
            __typename: "Entity",
            id: string,
            type: EntityType,
            taxNumber?: string | null,
            companyNumber?: string | null,
            billerCode?: number | null,
            name: string,
            legalName?: string | null,
            businessNames?: Array< string | null > | null,
            searchName?: string | null,
            address?:  {
              __typename: "Address",
              addressId?: string | null,
              contactName?: string | null,
              contactNumber?: string | null,
              fullAddress?: string | null,
              address1?: string | null,
              address2?: string | null,
              city?: string | null,
              country: string,
              countryCode: string,
              state: string,
              stateCode?: string | null,
              postalCode: string,
              invalid?: boolean | null,
            } | null,
            logo?:  {
              __typename: "Image",
              alt?: string | null,
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type?: string | null,
            } | null,
            brandColour?: string | null,
            website?: string | null,
            entityUsers?:  {
              __typename: "ModelEntityUserConnection",
              items:  Array< {
                __typename: "EntityUser",
                id: string,
                entityId: string,
                userId: string,
                firmId?: string | null,
                email?: string | null,
                invitedEmail?: string | null,
                ocrEmail?: string | null,
                referredBy?: string | null,
                invitedEntityId?: string | null,
                firmEntityId?: string | null,
                providerContactId?: string | null,
                ownerCode?: string | null,
                clientGroupCode?: string | null,
                clientCode?: string | null,
                firstName?: string | null,
                lastName?: string | null,
                role: EntityUserRole,
                jobTags?: Array< JobTags | null > | null,
                paymentsEnabled?: boolean | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                termsFirmPayTaxAccepted?: boolean | null,
                entitySearchName?: string | null,
                searchName?: string | null,
                taxNumber?: string | null,
                taskSendSMS?: boolean | null,
                companyNumber?: string | null,
                createdBy?: string | null,
                createdAt: string,
                updatedAt: string,
                status?: EntityUserStatus | null,
                partnerId?: string | null,
                managerId?: string | null,
                archivedAt?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gstRegistered?: boolean | null,
            gstReportingPeriod?: GSTReportingPeriod | null,
            providerEntityId?: string | null,
            providerCompanyId?: string | null,
            providerBillUserCompanyId?: string | null,
            providerBankAccountId?: string | null,
            providerDigitalWalletId?: string | null,
            providerBpayCrn?: string | null,
            contact?:  {
              __typename: "EntityContact",
              firstName?: string | null,
              lastName?: string | null,
              email?: string | null,
              phone?: string | null,
              role?: string | null,
            } | null,
            paymentMethods?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            paymentMethodId?: string | null,
            paymentUserId?: string | null,
            disbursementMethodId?: string | null,
            receivingAccounts?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            ubosCreated?: boolean | null,
            numUbosCreated?: number | null,
            subCategory?: string | null,
            clientsStatus?: EntityClientsStatus | null,
            ocrEmail?: string | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            owner?: string | null,
            referredBy?: string | null,
            connectedAccount?: string | null,
            accountStatus?: AccountStatus | null,
            customerId?: string | null,
            xeroSyncStatus?: XeroSyncStatus | null,
            xeroLastContactSyncAt?: string | null,
            xeroContactSyncStatus?: XeroSyncStatus | null,
            xeroInvoiceSyncStatus?: XeroSyncStatus | null,
            xeroLastInvoiceSyncAt?: string | null,
            xeroTenantId?: string | null,
            absorbFees?: boolean | null,
            subscriptionTier?: SubscriptionTier | null,
            invitationStatus?: InvitationStatus | null,
            clientsOnboardingStatus?: ClientsOnboardingStatus | null,
            createdBy?: string | null,
            createdByEntityId?: string | null,
            isFirm?: boolean | null,
            createdAt?: string | null,
            updatedAt?: string | null,
          } | null,
          searchName?: string | null,
          taxNumber?: string | null,
          taskSendSMS?: boolean | null,
          companyNumber?: string | null,
          createdBy?: string | null,
          createdAt: string,
          updatedAt: string,
          status?: EntityUserStatus | null,
          partnerId?: string | null,
          managerId?: string | null,
          archivedAt?: string | null,
          taxPaymentReferences?:  {
            __typename: "TaxPaymentReferences",
            itr?:  {
              __typename: "TaxPaymentReference",
              referenceNumber?: string | null,
              updatedAt?: string | null,
            } | null,
            other?:  {
              __typename: "TaxPaymentReference",
              referenceNumber?: string | null,
              updatedAt?: string | null,
            } | null,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gstRegistered?: boolean | null,
      gstReportingPeriod?: GSTReportingPeriod | null,
      providerEntityId?: string | null,
      providerCompanyId?: string | null,
      providerBillUserCompanyId?: string | null,
      providerBankAccountId?: string | null,
      providerDigitalWalletId?: string | null,
      providerBpayCrn?: string | null,
      contact?:  {
        __typename: "EntityContact",
        firstName?: string | null,
        lastName?: string | null,
        email?: string | null,
        phone?: string | null,
        role?: string | null,
      } | null,
      paymentMethods?:  {
        __typename: "ModelPaymentMethodConnection",
        items:  Array< {
          __typename: "PaymentMethod",
          id: string,
          paymentMethodType: PaymentMethodType,
          type?: string | null,
          fullName?: string | null,
          number?: string | null,
          expMonth?: string | null,
          expYear?: string | null,
          accountName?: string | null,
          bankName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
          holderType?: BankHolderType | null,
          accountType?: BankAccountType | null,
          status?: PaymentMethodStatus | null,
          accountDirection?: AccountDirection | null,
          expiresAt?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          consentId?: string | null,
          consentStatus?: PaymentConsentStatus | null,
          card?: string | null,
          googlepay?: string | null,
          applepay?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      paymentMethodId?: string | null,
      paymentUserId?: string | null,
      disbursementMethodId?: string | null,
      receivingAccounts?:  {
        __typename: "ModelPaymentMethodConnection",
        items:  Array< {
          __typename: "PaymentMethod",
          id: string,
          paymentMethodType: PaymentMethodType,
          type?: string | null,
          fullName?: string | null,
          number?: string | null,
          expMonth?: string | null,
          expYear?: string | null,
          accountName?: string | null,
          bankName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
          holderType?: BankHolderType | null,
          accountType?: BankAccountType | null,
          status?: PaymentMethodStatus | null,
          accountDirection?: AccountDirection | null,
          expiresAt?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          consentId?: string | null,
          consentStatus?: PaymentConsentStatus | null,
          card?: string | null,
          googlepay?: string | null,
          applepay?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      ubosCreated?: boolean | null,
      numUbosCreated?: number | null,
      subCategory?: string | null,
      clientsStatus?: EntityClientsStatus | null,
      ocrEmail?: string | null,
      termsInvoiceAccepted?: boolean | null,
      termsOcrAccepted?: boolean | null,
      owner?: string | null,
      referredBy?: string | null,
      connectedAccount?: string | null,
      accountStatus?: AccountStatus | null,
      customerId?: string | null,
      xeroSyncStatus?: XeroSyncStatus | null,
      xeroLastContactSyncAt?: string | null,
      xeroContactSyncStatus?: XeroSyncStatus | null,
      xeroInvoiceSyncStatus?: XeroSyncStatus | null,
      xeroLastInvoiceSyncAt?: string | null,
      xeroTenantId?: string | null,
      absorbFees?: boolean | null,
      subscriptionTier?: SubscriptionTier | null,
      invitationStatus?: InvitationStatus | null,
      clientsOnboardingStatus?: ClientsOnboardingStatus | null,
      createdBy?: string | null,
      createdByEntityId?: string | null,
      isFirm?: boolean | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    searchName?: string | null,
    taxNumber?: string | null,
    taskSendSMS?: boolean | null,
    companyNumber?: string | null,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
    status?: EntityUserStatus | null,
    partnerId?: string | null,
    managerId?: string | null,
    archivedAt?: string | null,
    taxPaymentReferences?:  {
      __typename: "TaxPaymentReferences",
      itr?:  {
        __typename: "TaxPaymentReference",
        referenceNumber?: string | null,
        updatedAt?: string | null,
      } | null,
      other?:  {
        __typename: "TaxPaymentReference",
        referenceNumber?: string | null,
        updatedAt?: string | null,
      } | null,
    } | null,
  } | null,
};

export type CreateServiceMutationVariables = {
  input: CreateServiceInput,
};

export type CreateServiceMutation = {
  createService?:  {
    __typename: "Service",
    id: string,
    entityId: string,
    title?: string | null,
    description?: string | null,
    amount: number,
    feeType?: FeeType | null,
    taxType: TaxType,
    searchName?: string | null,
    status: ServiceStatus,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateServiceMutationVariables = {
  input: UpdateServiceInput,
};

export type UpdateServiceMutation = {
  updateService?:  {
    __typename: "Service",
    id: string,
    entityId: string,
    title?: string | null,
    description?: string | null,
    amount: number,
    feeType?: FeeType | null,
    taxType: TaxType,
    searchName?: string | null,
    status: ServiceStatus,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateTemplateMutationVariables = {
  input: CreateTemplateInput,
};

export type CreateTemplateMutation = {
  createTemplate?:  {
    __typename: "Template",
    id: string,
    entityId: string,
    title: string,
    searchName?: string | null,
    templateJson?: string | null,
    templateHtml?: string | null,
    status: TemplateStatus,
    canDelete?: boolean | null,
    type: TemplateType,
    includeLetterhead?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateTemplateMutationVariables = {
  input: UpdateTemplateInput,
};

export type UpdateTemplateMutation = {
  updateTemplate?:  {
    __typename: "Template",
    id: string,
    entityId: string,
    title: string,
    searchName?: string | null,
    templateJson?: string | null,
    templateHtml?: string | null,
    status: TemplateStatus,
    canDelete?: boolean | null,
    type: TemplateType,
    includeLetterhead?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateNotificationMutationVariables = {
  input?: CreateNotificationInput | null,
};

export type CreateNotificationMutation = {
  createNotification?:  {
    __typename: "Notification",
    id: string,
    title?: string | null,
    message?: string | null,
    status?: NotificationStatus | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    type?: string | null,
    owner: string,
  } | null,
};

export type UpdateNotificationMutationVariables = {
  input?: UpdateNotificationInput | null,
};

export type UpdateNotificationMutation = {
  updateNotification?:  {
    __typename: "Notification",
    id: string,
    title?: string | null,
    message?: string | null,
    status?: NotificationStatus | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    type?: string | null,
    owner: string,
  } | null,
};

export type CreateOptionMutationVariables = {
  input: CreateOptionInput,
  condition?: ModelOptionConditionInput | null,
};

export type CreateOptionMutation = {
  createOption?:  {
    __typename: "Option",
    name?: string | null,
    label: string,
    value: string,
    group?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    id: string,
  } | null,
};

export type UpdateOptionMutationVariables = {
  input: UpdateOptionInput,
  condition?: ModelOptionConditionInput | null,
};

export type UpdateOptionMutation = {
  updateOption?:  {
    __typename: "Option",
    name?: string | null,
    label: string,
    value: string,
    group?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    id: string,
  } | null,
};

export type DeleteOptionMutationVariables = {
  input: DeleteOptionInput,
  condition?: ModelOptionConditionInput | null,
};

export type DeleteOptionMutation = {
  deleteOption?:  {
    __typename: "Option",
    name?: string | null,
    label: string,
    value: string,
    group?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    id: string,
  } | null,
};

export type CreatePaymentMutationVariables = {
  input?: CreatePaymentInput | null,
};

export type CreatePaymentMutation = {
  createPayment?:  Array< {
    __typename: "Payment",
    id: string,
    paymentIntentId?: string | null,
    taskId?: string | null,
    entityId?: string | null,
    payInPaymentId?: string | null,
    providerTransactionId?: string | null,
    paymentProvider?: PaymentProvider | null,
    disbursementId?: string | null,
    fromId: string,
    fromType: FromToType,
    toId?: string | null,
    toType?: FromToType | null,
    buyerId?: string | null,
    sellerId?: string | null,
    entityIdTo?: string | null,
    amount?: number | null,
    netAmount?: number | null,
    payerFees?: number | null,
    totalAmount?: number | null,
    gstAmount?: number | null,
    installment?: number | null,
    installments?: number | null,
    feeAmount?: number | null,
    reference?: string | null,
    paymentType?: PaymentType | null,
    taxAmount?: number | null,
    currency?: string | null,
    feeIds?: Array< string | null > | null,
    ipAddress?: string | null,
    status: PaymentStatus,
    payerUserStatus?: PayerUserStatus | null,
    declinedReason?: string | null,
    isUnlimitedRecurring?: boolean | null,
    payoutFailureReason?: string | null,
    payoutFailureFields?: Array< string | null > | null,
    payoutDetails?:  {
      __typename: "PayoutDetails",
      bank?:  {
        __typename: "ContactBankAccount",
        id?: string | null,
        accountName?: string | null,
        bankName?: string | null,
        accountNumber: string,
        routingNumber: string,
        holderType?: BankHolderType | null,
        accountType?: BankAccountType | null,
        country?: string | null,
      } | null,
      bpay?:  {
        __typename: "ContactBpay",
        billerCode?: number | null,
        referenceNumber?: string | null,
      } | null,
    } | null,
    scheduledAt?: string | null,
    paidAt?: string | null,
    declinedAt?: string | null,
    createdAt?: string | null,
    receivedAt?: string | null,
    paidOutAt?: string | null,
    updatedAt?: string | null,
    voidedAt?: string | null,
    owner?: string | null,
    payoutFailedAt?: string | null,
  } | null > | null,
};

export type CreatePaymentPayIdMutationVariables = {
  input?: CreatePaymentPayIdInput | null,
};

export type CreatePaymentPayIdMutation = {
  createPaymentPayId?:  {
    __typename: "PayInPayment",
    id: string,
    entityId: string,
    amount?: number | null,
    paymentType?: PaymentType | null,
    status?: PayInPaymentStatus | null,
    taskPayments:  Array< {
      __typename: "TaskPayment",
      id: string,
      paymentType: PaymentType,
      installments: number,
      scheduledAt: string,
    } >,
    scheduledAt?: string | null,
    createdBy?: string | null,
    paymentUserId?: string | null,
    receivedAt?: string | null,
    paidOutAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type CancelPaymentPayIdMutationVariables = {
  input?: CancelPaymentPayIdInput | null,
};

export type CancelPaymentPayIdMutation = {
  cancelPaymentPayId?:  {
    __typename: "Payment",
    id: string,
    paymentIntentId?: string | null,
    taskId?: string | null,
    entityId?: string | null,
    payInPaymentId?: string | null,
    providerTransactionId?: string | null,
    paymentProvider?: PaymentProvider | null,
    disbursementId?: string | null,
    fromId: string,
    fromType: FromToType,
    toId?: string | null,
    toType?: FromToType | null,
    buyerId?: string | null,
    sellerId?: string | null,
    entityIdTo?: string | null,
    amount?: number | null,
    netAmount?: number | null,
    payerFees?: number | null,
    totalAmount?: number | null,
    gstAmount?: number | null,
    installment?: number | null,
    installments?: number | null,
    feeAmount?: number | null,
    reference?: string | null,
    paymentType?: PaymentType | null,
    taxAmount?: number | null,
    currency?: string | null,
    feeIds?: Array< string | null > | null,
    ipAddress?: string | null,
    status: PaymentStatus,
    payerUserStatus?: PayerUserStatus | null,
    declinedReason?: string | null,
    isUnlimitedRecurring?: boolean | null,
    payoutFailureReason?: string | null,
    payoutFailureFields?: Array< string | null > | null,
    payoutDetails?:  {
      __typename: "PayoutDetails",
      bank?:  {
        __typename: "ContactBankAccount",
        id?: string | null,
        accountName?: string | null,
        bankName?: string | null,
        accountNumber: string,
        routingNumber: string,
        holderType?: BankHolderType | null,
        accountType?: BankAccountType | null,
        country?: string | null,
      } | null,
      bpay?:  {
        __typename: "ContactBpay",
        billerCode?: number | null,
        referenceNumber?: string | null,
      } | null,
    } | null,
    scheduledAt?: string | null,
    paidAt?: string | null,
    declinedAt?: string | null,
    createdAt?: string | null,
    receivedAt?: string | null,
    paidOutAt?: string | null,
    updatedAt?: string | null,
    voidedAt?: string | null,
    owner?: string | null,
    payoutFailedAt?: string | null,
  } | null,
};

export type RetryPaymentMutationVariables = {
  input?: RetryPaymentInput | null,
};

export type RetryPaymentMutation = {
  retryPayment?:  Array< {
    __typename: "Payment",
    id: string,
    paymentIntentId?: string | null,
    taskId?: string | null,
    entityId?: string | null,
    payInPaymentId?: string | null,
    providerTransactionId?: string | null,
    paymentProvider?: PaymentProvider | null,
    disbursementId?: string | null,
    fromId: string,
    fromType: FromToType,
    toId?: string | null,
    toType?: FromToType | null,
    buyerId?: string | null,
    sellerId?: string | null,
    entityIdTo?: string | null,
    amount?: number | null,
    netAmount?: number | null,
    payerFees?: number | null,
    totalAmount?: number | null,
    gstAmount?: number | null,
    installment?: number | null,
    installments?: number | null,
    feeAmount?: number | null,
    reference?: string | null,
    paymentType?: PaymentType | null,
    taxAmount?: number | null,
    currency?: string | null,
    feeIds?: Array< string | null > | null,
    ipAddress?: string | null,
    status: PaymentStatus,
    payerUserStatus?: PayerUserStatus | null,
    declinedReason?: string | null,
    isUnlimitedRecurring?: boolean | null,
    payoutFailureReason?: string | null,
    payoutFailureFields?: Array< string | null > | null,
    payoutDetails?:  {
      __typename: "PayoutDetails",
      bank?:  {
        __typename: "ContactBankAccount",
        id?: string | null,
        accountName?: string | null,
        bankName?: string | null,
        accountNumber: string,
        routingNumber: string,
        holderType?: BankHolderType | null,
        accountType?: BankAccountType | null,
        country?: string | null,
      } | null,
      bpay?:  {
        __typename: "ContactBpay",
        billerCode?: number | null,
        referenceNumber?: string | null,
      } | null,
    } | null,
    scheduledAt?: string | null,
    paidAt?: string | null,
    declinedAt?: string | null,
    createdAt?: string | null,
    receivedAt?: string | null,
    paidOutAt?: string | null,
    updatedAt?: string | null,
    voidedAt?: string | null,
    owner?: string | null,
    payoutFailedAt?: string | null,
  } | null > | null,
};

export type CreateTaskPaymentMutationVariables = {
  input?: CreateTaskPaymentInput | null,
};

export type CreateTaskPaymentMutation = {
  createTaskPayment?:  Array< {
    __typename: "Payment",
    id: string,
    paymentIntentId?: string | null,
    taskId?: string | null,
    entityId?: string | null,
    payInPaymentId?: string | null,
    providerTransactionId?: string | null,
    paymentProvider?: PaymentProvider | null,
    disbursementId?: string | null,
    fromId: string,
    fromType: FromToType,
    toId?: string | null,
    toType?: FromToType | null,
    buyerId?: string | null,
    sellerId?: string | null,
    entityIdTo?: string | null,
    amount?: number | null,
    netAmount?: number | null,
    payerFees?: number | null,
    totalAmount?: number | null,
    gstAmount?: number | null,
    installment?: number | null,
    installments?: number | null,
    feeAmount?: number | null,
    reference?: string | null,
    paymentType?: PaymentType | null,
    taxAmount?: number | null,
    currency?: string | null,
    feeIds?: Array< string | null > | null,
    ipAddress?: string | null,
    status: PaymentStatus,
    payerUserStatus?: PayerUserStatus | null,
    declinedReason?: string | null,
    isUnlimitedRecurring?: boolean | null,
    payoutFailureReason?: string | null,
    payoutFailureFields?: Array< string | null > | null,
    payoutDetails?:  {
      __typename: "PayoutDetails",
      bank?:  {
        __typename: "ContactBankAccount",
        id?: string | null,
        accountName?: string | null,
        bankName?: string | null,
        accountNumber: string,
        routingNumber: string,
        holderType?: BankHolderType | null,
        accountType?: BankAccountType | null,
        country?: string | null,
      } | null,
      bpay?:  {
        __typename: "ContactBpay",
        billerCode?: number | null,
        referenceNumber?: string | null,
      } | null,
    } | null,
    scheduledAt?: string | null,
    paidAt?: string | null,
    declinedAt?: string | null,
    createdAt?: string | null,
    receivedAt?: string | null,
    paidOutAt?: string | null,
    updatedAt?: string | null,
    voidedAt?: string | null,
    owner?: string | null,
    payoutFailedAt?: string | null,
  } | null > | null,
};

export type CreatePaymentMethodMutationVariables = {
  input?: CreatePaymentMethodInput | null,
};

export type CreatePaymentMethodMutation = {
  createPaymentMethod?:  {
    __typename: "PaymentMethod",
    id: string,
    paymentMethodType: PaymentMethodType,
    type?: string | null,
    fullName?: string | null,
    number?: string | null,
    expMonth?: string | null,
    expYear?: string | null,
    accountName?: string | null,
    bankName?: string | null,
    accountNumber?: string | null,
    routingNumber?: string | null,
    holderType?: BankHolderType | null,
    accountType?: BankAccountType | null,
    status?: PaymentMethodStatus | null,
    accountDirection?: AccountDirection | null,
    expiresAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    consentId?: string | null,
    consentStatus?: PaymentConsentStatus | null,
    card?: string | null,
    googlepay?: string | null,
    applepay?: string | null,
  } | null,
};

export type UpdatePaymentMethodMutationVariables = {
  input?: UpdatePaymentMethodInput | null,
};

export type UpdatePaymentMethodMutation = {
  updatePaymentMethod?:  {
    __typename: "PaymentMethod",
    id: string,
    paymentMethodType: PaymentMethodType,
    type?: string | null,
    fullName?: string | null,
    number?: string | null,
    expMonth?: string | null,
    expYear?: string | null,
    accountName?: string | null,
    bankName?: string | null,
    accountNumber?: string | null,
    routingNumber?: string | null,
    holderType?: BankHolderType | null,
    accountType?: BankAccountType | null,
    status?: PaymentMethodStatus | null,
    accountDirection?: AccountDirection | null,
    expiresAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    consentId?: string | null,
    consentStatus?: PaymentConsentStatus | null,
    card?: string | null,
    googlepay?: string | null,
    applepay?: string | null,
  } | null,
};

export type CreatePushNotificationMutationVariables = {
  input?: CreatePushNotificationInput | null,
};

export type CreatePushNotificationMutation = {
  createPushNotification?: string | null,
};

export type CreateSignatureMutationVariables = {
  input?: CreateSignatureInput | null,
};

export type CreateSignatureMutation = {
  createSignature?:  {
    __typename: "Signature",
    id: string,
    userId: string,
    key: string,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type DeleteSignatureMutationVariables = {
  input?: DeleteSignatureInput | null,
};

export type DeleteSignatureMutation = {
  deleteSignature?:  {
    __typename: "Signature",
    id: string,
    userId: string,
    key: string,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type CreateDocumentAnalysisDocumentUrlMutationVariables = {
  input?: CreateDocumentAnalysisDocumentUrlInput | null,
};

export type CreateDocumentAnalysisDocumentUrlMutation = {
  createDocumentAnalysisDocumentUrl?:  {
    __typename: "TaskDocumentUrl",
    url?: string | null,
    expiresAt?: string | null,
  } | null,
};

export type AcceptQuoteGuestMutationVariables = {
  input?: AcceptQuoteInput | null,
};

export type AcceptQuoteGuestMutation = {
  acceptQuoteGuest?:  {
    __typename: "AcceptedQuote",
    token?: string | null,
    updatedTask:  {
      __typename: "TaskGuest",
      id: string,
      entityId: string,
      amount?: number | null,
      taxAmount?: number | null,
      annotations?: string | null,
      documentType?: DocumentType | null,
      subCategory?: string | null,
      fromId: string,
      linkedTaskId?: string | null,
      futureLinkedTask?:  {
        __typename: "FutureTaskGuest",
        fromId: string,
        fromType: FromToType,
        from?:  {
          __typename: "EntityGuest",
          id: string,
          name: string,
          taxNumber?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | null,
        toId?: string | null,
        toType?: FromToType | null,
        to?:  {
          __typename: "EntityGuest",
          id: string,
          name: string,
          taxNumber?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | null,
        numberOfPayments?: number | null,
        paymentFrequency?: PaymentFrequency | null,
        reference: string,
        bpayReferenceNumber?: string | null,
        amount?: number | null,
        gstInclusive?: boolean | null,
        lineItems?:  Array< {
          __typename: "LineItem",
          serviceId?: string | null,
          description: string,
          quantity: number,
          unitAmount: number,
          taxType: TaxType,
          lineAmount?: number | null,
          newService?: boolean | null,
        } | null > | null,
        isUnlimitedRecurring?: boolean | null,
        direction?: TaskDirection | null,
        invoiceStatus?: InvoiceStatus | null,
        dueAt: string,
        paymentAt?: string | null,
        lodgementAt?: string | null,
      } | null,
      firm?:  {
        __typename: "EntityGuest",
        id: string,
        name: string,
        taxNumber?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      fromEntity?:  {
        __typename: "EntityGuest",
        id: string,
        name: string,
        taxNumber?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      from?:  {
        __typename: "EntityGuest",
        id: string,
        name: string,
        taxNumber?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      fromContact?:  {
        __typename: "ContactGuest",
        id: string,
        firstName?: string | null,
        lastName?: string | null,
        name?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      fromType?: FromToType | null,
      toEntity?:  {
        __typename: "EntityGuest",
        id: string,
        name: string,
        taxNumber?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      toContact?:  {
        __typename: "ContactGuest",
        id: string,
        firstName?: string | null,
        lastName?: string | null,
        name?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      toId?: string | null,
      to?:  {
        __typename: "EntityGuest",
        id: string,
        name: string,
        taxNumber?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      toType?: FromToType | null,
      isFinalSigner?: boolean | null,
      status: TaskStatus,
      signatureStatus?: TaskSignatureStatus | null,
      paymentStatus?: TaskPaymentStatus | null,
      quoteStatus?: TaskQuoteStatus | null,
      invoiceStatus?: InvoiceStatus | null,
      settlementStatus?: TaskSettlementStatus | null,
      type: TaskType,
      category?: TaskCategory | null,
      documents?:  Array< {
        __typename: "S3Upload",
        identityId?: string | null,
        key: string,
        level: S3UploadLevel,
        type: S3UploadType,
        name?: string | null,
      } | null > | null,
      supportDocuments?:  Array< {
        __typename: "S3Upload",
        identityId?: string | null,
        key: string,
        level: S3UploadLevel,
        type: S3UploadType,
        name?: string | null,
      } | null > | null,
      numberOfPayments?: number | null,
      paymentFrequency?: PaymentFrequency | null,
      paymentTypes: Array< PaymentType | null >,
      reference?: string | null,
      bpayReferenceNumber?: string | null,
      createdBy: string,
      gstInclusive?: boolean | null,
      entityIdBy?: string | null,
      dueAt: string,
      issuedAt?: string | null,
      notes?: string | null,
      direction?: TaskDirection | null,
      paymentAt?: string | null,
      lodgementAt?: string | null,
      readAt?: string | null,
      paidAt?: string | null,
      quoteAcceptedAt?: string | null,
      completedAt?: string | null,
      owner?: string | null,
      metaHashData?: string | null,
      automaticGenerateInvoice?: boolean | null,
      automaticInvoicePaymentAt?: string | null,
      automaticInvoicePaymentTerms?: PaymentTerms | null,
      quoteRequiresSignature?: boolean | null,
      automaticallyGeneratedFromQuote?: boolean | null,
      termsFirmPayTaxAccepted?: boolean | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      token?: string | null,
      period?: string | null,
      year?: string | null,
    },
  } | null,
};

export type CreateTaskMutationVariables = {
  input?: CreateTaskInput | null,
};

export type CreateTaskMutation = {
  createTask?:  {
    __typename: "Task",
    entityId: string,
    taskNumber?: string | null,
    invoiceStatus?: InvoiceStatus | null,
    agreementUuid?: string | null,
    documentType?: DocumentType | null,
    subCategory?: string | null,
    id: string,
    linkedTaskId?: string | null,
    managerId?: string | null,
    partnerId?: string | null,
    bindingId?: string | null,
    futureLinkedTask?:  {
      __typename: "FutureTask",
      fromId: string,
      fromType: FromToType,
      toId?: string | null,
      toType?: FromToType | null,
      numberOfPayments?: number | null,
      paymentFrequency?: PaymentFrequency | null,
      reference: string,
      bpayReferenceNumber?: string | null,
      amount?: number | null,
      gstInclusive?: boolean | null,
      lineItems?:  Array< {
        __typename: "LineItem",
        serviceId?: string | null,
        description: string,
        quantity: number,
        unitAmount: number,
        taxType: TaxType,
        lineAmount?: number | null,
        newService?: boolean | null,
      } | null > | null,
      isUnlimitedRecurring?: boolean | null,
      direction?: TaskDirection | null,
      invoiceStatus?: InvoiceStatus | null,
      dueAt: string,
      paymentAt?: string | null,
      lodgementAt?: string | null,
    } | null,
    documentAnalysisId?: string | null,
    activity?:  {
      __typename: "ModelActivityConnection",
      items:  Array< {
        __typename: "Activity",
        id: string,
        compositeId: string,
        userId?: string | null,
        entityId?: string | null,
        type: ActivityType,
        message?: string | null,
        metadata?:  {
          __typename: "ActivityMetadata",
          name?: string | null,
          email?: string | null,
        } | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    amount?: number | null,
    taxAmount?: number | null,
    annotations?: string | null,
    entityIdFrom?: string | null,
    fromId: string,
    fromType: FromToType,
    toId?: string | null,
    toType?: FromToType | null,
    firmId?: string | null,
    entityIdTo?: string | null,
    contactIdFrom?: string | null,
    contactIdTo?: string | null,
    contactId?: string | null,
    entityByIdContactId?: string | null,
    firmByIdContactId?: string | null,
    firmById?: string | null,
    searchName?: string | null,
    status: TaskStatus,
    quoteStatus?: TaskQuoteStatus | null,
    signatureStatus?: TaskSignatureStatus | null,
    paymentStatus?: TaskPaymentStatus | null,
    type: TaskType,
    category?: TaskCategory | null,
    documents?:  Array< {
      __typename: "S3Upload",
      identityId?: string | null,
      key: string,
      level: S3UploadLevel,
      type: S3UploadType,
      name?: string | null,
    } | null > | null,
    emailMessage?: string | null,
    supportDocuments?:  Array< {
      __typename: "S3Upload",
      identityId?: string | null,
      key: string,
      level: S3UploadLevel,
      type: S3UploadType,
      name?: string | null,
    } | null > | null,
    numberOfPayments?: number | null,
    paymentFrequency?: PaymentFrequency | null,
    paymentTypes: Array< PaymentType | null >,
    maximumInstallments?: number | null,
    reference?: string | null,
    bpayReferenceNumber?: string | null,
    settlementStatus?: TaskSettlementStatus | null,
    signers?:  Array< {
      __typename: "EntityUser",
      id: string,
      entityId: string,
      userId: string,
      firmId?: string | null,
      email?: string | null,
      invitedEmail?: string | null,
      ocrEmail?: string | null,
      referredBy?: string | null,
      invitedEntityId?: string | null,
      firmEntityId?: string | null,
      providerContactId?: string | null,
      ownerCode?: string | null,
      clientGroupCode?: string | null,
      clientCode?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      role: EntityUserRole,
      jobTags?: Array< JobTags | null > | null,
      paymentsEnabled?: boolean | null,
      termsInvoiceAccepted?: boolean | null,
      termsOcrAccepted?: boolean | null,
      termsFirmPayTaxAccepted?: boolean | null,
      termsFirmPayTaxDetails?:  {
        __typename: "TermsFirmPayTaxDetails",
        document?:  {
          __typename: "S3Upload",
          identityId?: string | null,
          key: string,
          level: S3UploadLevel,
          type: S3UploadType,
          name?: string | null,
        } | null,
        acceptedAt?: string | null,
        email?: string | null,
        ip?: string | null,
        fullName?: string | null,
        firmId?: string | null,
      } | null,
      entitySearchName?: string | null,
      entity?:  {
        __typename: "Entity",
        id: string,
        type: EntityType,
        taxNumber?: string | null,
        companyNumber?: string | null,
        billerCode?: number | null,
        name: string,
        legalName?: string | null,
        businessNames?: Array< string | null > | null,
        searchName?: string | null,
        address?:  {
          __typename: "Address",
          addressId?: string | null,
          contactName?: string | null,
          contactNumber?: string | null,
          fullAddress?: string | null,
          address1?: string | null,
          address2?: string | null,
          city?: string | null,
          country: string,
          countryCode: string,
          state: string,
          stateCode?: string | null,
          postalCode: string,
          invalid?: boolean | null,
        } | null,
        logo?:  {
          __typename: "Image",
          alt?: string | null,
          identityId?: string | null,
          key: string,
          level: S3UploadLevel,
          type?: string | null,
        } | null,
        brandColour?: string | null,
        website?: string | null,
        entityUsers?:  {
          __typename: "ModelEntityUserConnection",
          items:  Array< {
            __typename: "EntityUser",
            id: string,
            entityId: string,
            userId: string,
            firmId?: string | null,
            email?: string | null,
            invitedEmail?: string | null,
            ocrEmail?: string | null,
            referredBy?: string | null,
            invitedEntityId?: string | null,
            firmEntityId?: string | null,
            providerContactId?: string | null,
            ownerCode?: string | null,
            clientGroupCode?: string | null,
            clientCode?: string | null,
            firstName?: string | null,
            lastName?: string | null,
            role: EntityUserRole,
            jobTags?: Array< JobTags | null > | null,
            paymentsEnabled?: boolean | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            termsFirmPayTaxAccepted?: boolean | null,
            termsFirmPayTaxDetails?:  {
              __typename: "TermsFirmPayTaxDetails",
              document?:  {
                __typename: "S3Upload",
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type: S3UploadType,
                name?: string | null,
              } | null,
              acceptedAt?: string | null,
              email?: string | null,
              ip?: string | null,
              fullName?: string | null,
              firmId?: string | null,
            } | null,
            entitySearchName?: string | null,
            entity?:  {
              __typename: "Entity",
              id: string,
              type: EntityType,
              taxNumber?: string | null,
              companyNumber?: string | null,
              billerCode?: number | null,
              name: string,
              legalName?: string | null,
              businessNames?: Array< string | null > | null,
              searchName?: string | null,
              address?:  {
                __typename: "Address",
                addressId?: string | null,
                contactName?: string | null,
                contactNumber?: string | null,
                fullAddress?: string | null,
                address1?: string | null,
                address2?: string | null,
                city?: string | null,
                country: string,
                countryCode: string,
                state: string,
                stateCode?: string | null,
                postalCode: string,
                invalid?: boolean | null,
              } | null,
              logo?:  {
                __typename: "Image",
                alt?: string | null,
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type?: string | null,
              } | null,
              brandColour?: string | null,
              website?: string | null,
              entityUsers?:  {
                __typename: "ModelEntityUserConnection",
                nextToken?: string | null,
              } | null,
              gstRegistered?: boolean | null,
              gstReportingPeriod?: GSTReportingPeriod | null,
              providerEntityId?: string | null,
              providerCompanyId?: string | null,
              providerBillUserCompanyId?: string | null,
              providerBankAccountId?: string | null,
              providerDigitalWalletId?: string | null,
              providerBpayCrn?: string | null,
              contact?:  {
                __typename: "EntityContact",
                firstName?: string | null,
                lastName?: string | null,
                email?: string | null,
                phone?: string | null,
                role?: string | null,
              } | null,
              paymentMethods?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              paymentMethodId?: string | null,
              paymentUserId?: string | null,
              disbursementMethodId?: string | null,
              receivingAccounts?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              ubosCreated?: boolean | null,
              numUbosCreated?: number | null,
              subCategory?: string | null,
              clientsStatus?: EntityClientsStatus | null,
              ocrEmail?: string | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              owner?: string | null,
              referredBy?: string | null,
              connectedAccount?: string | null,
              accountStatus?: AccountStatus | null,
              customerId?: string | null,
              xeroSyncStatus?: XeroSyncStatus | null,
              xeroLastContactSyncAt?: string | null,
              xeroContactSyncStatus?: XeroSyncStatus | null,
              xeroInvoiceSyncStatus?: XeroSyncStatus | null,
              xeroLastInvoiceSyncAt?: string | null,
              xeroTenantId?: string | null,
              absorbFees?: boolean | null,
              subscriptionTier?: SubscriptionTier | null,
              invitationStatus?: InvitationStatus | null,
              clientsOnboardingStatus?: ClientsOnboardingStatus | null,
              createdBy?: string | null,
              createdByEntityId?: string | null,
              isFirm?: boolean | null,
              createdAt?: string | null,
              updatedAt?: string | null,
            } | null,
            firm?:  {
              __typename: "Entity",
              id: string,
              type: EntityType,
              taxNumber?: string | null,
              companyNumber?: string | null,
              billerCode?: number | null,
              name: string,
              legalName?: string | null,
              businessNames?: Array< string | null > | null,
              searchName?: string | null,
              address?:  {
                __typename: "Address",
                addressId?: string | null,
                contactName?: string | null,
                contactNumber?: string | null,
                fullAddress?: string | null,
                address1?: string | null,
                address2?: string | null,
                city?: string | null,
                country: string,
                countryCode: string,
                state: string,
                stateCode?: string | null,
                postalCode: string,
                invalid?: boolean | null,
              } | null,
              logo?:  {
                __typename: "Image",
                alt?: string | null,
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type?: string | null,
              } | null,
              brandColour?: string | null,
              website?: string | null,
              entityUsers?:  {
                __typename: "ModelEntityUserConnection",
                nextToken?: string | null,
              } | null,
              gstRegistered?: boolean | null,
              gstReportingPeriod?: GSTReportingPeriod | null,
              providerEntityId?: string | null,
              providerCompanyId?: string | null,
              providerBillUserCompanyId?: string | null,
              providerBankAccountId?: string | null,
              providerDigitalWalletId?: string | null,
              providerBpayCrn?: string | null,
              contact?:  {
                __typename: "EntityContact",
                firstName?: string | null,
                lastName?: string | null,
                email?: string | null,
                phone?: string | null,
                role?: string | null,
              } | null,
              paymentMethods?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              paymentMethodId?: string | null,
              paymentUserId?: string | null,
              disbursementMethodId?: string | null,
              receivingAccounts?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              ubosCreated?: boolean | null,
              numUbosCreated?: number | null,
              subCategory?: string | null,
              clientsStatus?: EntityClientsStatus | null,
              ocrEmail?: string | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              owner?: string | null,
              referredBy?: string | null,
              connectedAccount?: string | null,
              accountStatus?: AccountStatus | null,
              customerId?: string | null,
              xeroSyncStatus?: XeroSyncStatus | null,
              xeroLastContactSyncAt?: string | null,
              xeroContactSyncStatus?: XeroSyncStatus | null,
              xeroInvoiceSyncStatus?: XeroSyncStatus | null,
              xeroLastInvoiceSyncAt?: string | null,
              xeroTenantId?: string | null,
              absorbFees?: boolean | null,
              subscriptionTier?: SubscriptionTier | null,
              invitationStatus?: InvitationStatus | null,
              clientsOnboardingStatus?: ClientsOnboardingStatus | null,
              createdBy?: string | null,
              createdByEntityId?: string | null,
              isFirm?: boolean | null,
              createdAt?: string | null,
              updatedAt?: string | null,
            } | null,
            searchName?: string | null,
            taxNumber?: string | null,
            taskSendSMS?: boolean | null,
            companyNumber?: string | null,
            createdBy?: string | null,
            createdAt: string,
            updatedAt: string,
            status?: EntityUserStatus | null,
            partnerId?: string | null,
            managerId?: string | null,
            archivedAt?: string | null,
            taxPaymentReferences?:  {
              __typename: "TaxPaymentReferences",
              itr?:  {
                __typename: "TaxPaymentReference",
                referenceNumber?: string | null,
                updatedAt?: string | null,
              } | null,
              other?:  {
                __typename: "TaxPaymentReference",
                referenceNumber?: string | null,
                updatedAt?: string | null,
              } | null,
            } | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        gstRegistered?: boolean | null,
        gstReportingPeriod?: GSTReportingPeriod | null,
        providerEntityId?: string | null,
        providerCompanyId?: string | null,
        providerBillUserCompanyId?: string | null,
        providerBankAccountId?: string | null,
        providerDigitalWalletId?: string | null,
        providerBpayCrn?: string | null,
        contact?:  {
          __typename: "EntityContact",
          firstName?: string | null,
          lastName?: string | null,
          email?: string | null,
          phone?: string | null,
          role?: string | null,
        } | null,
        paymentMethods?:  {
          __typename: "ModelPaymentMethodConnection",
          items:  Array< {
            __typename: "PaymentMethod",
            id: string,
            paymentMethodType: PaymentMethodType,
            type?: string | null,
            fullName?: string | null,
            number?: string | null,
            expMonth?: string | null,
            expYear?: string | null,
            accountName?: string | null,
            bankName?: string | null,
            accountNumber?: string | null,
            routingNumber?: string | null,
            holderType?: BankHolderType | null,
            accountType?: BankAccountType | null,
            status?: PaymentMethodStatus | null,
            accountDirection?: AccountDirection | null,
            expiresAt?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            consentId?: string | null,
            consentStatus?: PaymentConsentStatus | null,
            card?: string | null,
            googlepay?: string | null,
            applepay?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        paymentMethodId?: string | null,
        paymentUserId?: string | null,
        disbursementMethodId?: string | null,
        receivingAccounts?:  {
          __typename: "ModelPaymentMethodConnection",
          items:  Array< {
            __typename: "PaymentMethod",
            id: string,
            paymentMethodType: PaymentMethodType,
            type?: string | null,
            fullName?: string | null,
            number?: string | null,
            expMonth?: string | null,
            expYear?: string | null,
            accountName?: string | null,
            bankName?: string | null,
            accountNumber?: string | null,
            routingNumber?: string | null,
            holderType?: BankHolderType | null,
            accountType?: BankAccountType | null,
            status?: PaymentMethodStatus | null,
            accountDirection?: AccountDirection | null,
            expiresAt?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            consentId?: string | null,
            consentStatus?: PaymentConsentStatus | null,
            card?: string | null,
            googlepay?: string | null,
            applepay?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        ubosCreated?: boolean | null,
        numUbosCreated?: number | null,
        subCategory?: string | null,
        clientsStatus?: EntityClientsStatus | null,
        ocrEmail?: string | null,
        termsInvoiceAccepted?: boolean | null,
        termsOcrAccepted?: boolean | null,
        owner?: string | null,
        referredBy?: string | null,
        connectedAccount?: string | null,
        accountStatus?: AccountStatus | null,
        customerId?: string | null,
        xeroSyncStatus?: XeroSyncStatus | null,
        xeroLastContactSyncAt?: string | null,
        xeroContactSyncStatus?: XeroSyncStatus | null,
        xeroInvoiceSyncStatus?: XeroSyncStatus | null,
        xeroLastInvoiceSyncAt?: string | null,
        xeroTenantId?: string | null,
        absorbFees?: boolean | null,
        subscriptionTier?: SubscriptionTier | null,
        invitationStatus?: InvitationStatus | null,
        clientsOnboardingStatus?: ClientsOnboardingStatus | null,
        createdBy?: string | null,
        createdByEntityId?: string | null,
        isFirm?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      firm?:  {
        __typename: "Entity",
        id: string,
        type: EntityType,
        taxNumber?: string | null,
        companyNumber?: string | null,
        billerCode?: number | null,
        name: string,
        legalName?: string | null,
        businessNames?: Array< string | null > | null,
        searchName?: string | null,
        address?:  {
          __typename: "Address",
          addressId?: string | null,
          contactName?: string | null,
          contactNumber?: string | null,
          fullAddress?: string | null,
          address1?: string | null,
          address2?: string | null,
          city?: string | null,
          country: string,
          countryCode: string,
          state: string,
          stateCode?: string | null,
          postalCode: string,
          invalid?: boolean | null,
        } | null,
        logo?:  {
          __typename: "Image",
          alt?: string | null,
          identityId?: string | null,
          key: string,
          level: S3UploadLevel,
          type?: string | null,
        } | null,
        brandColour?: string | null,
        website?: string | null,
        entityUsers?:  {
          __typename: "ModelEntityUserConnection",
          items:  Array< {
            __typename: "EntityUser",
            id: string,
            entityId: string,
            userId: string,
            firmId?: string | null,
            email?: string | null,
            invitedEmail?: string | null,
            ocrEmail?: string | null,
            referredBy?: string | null,
            invitedEntityId?: string | null,
            firmEntityId?: string | null,
            providerContactId?: string | null,
            ownerCode?: string | null,
            clientGroupCode?: string | null,
            clientCode?: string | null,
            firstName?: string | null,
            lastName?: string | null,
            role: EntityUserRole,
            jobTags?: Array< JobTags | null > | null,
            paymentsEnabled?: boolean | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            termsFirmPayTaxAccepted?: boolean | null,
            termsFirmPayTaxDetails?:  {
              __typename: "TermsFirmPayTaxDetails",
              document?:  {
                __typename: "S3Upload",
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type: S3UploadType,
                name?: string | null,
              } | null,
              acceptedAt?: string | null,
              email?: string | null,
              ip?: string | null,
              fullName?: string | null,
              firmId?: string | null,
            } | null,
            entitySearchName?: string | null,
            entity?:  {
              __typename: "Entity",
              id: string,
              type: EntityType,
              taxNumber?: string | null,
              companyNumber?: string | null,
              billerCode?: number | null,
              name: string,
              legalName?: string | null,
              businessNames?: Array< string | null > | null,
              searchName?: string | null,
              address?:  {
                __typename: "Address",
                addressId?: string | null,
                contactName?: string | null,
                contactNumber?: string | null,
                fullAddress?: string | null,
                address1?: string | null,
                address2?: string | null,
                city?: string | null,
                country: string,
                countryCode: string,
                state: string,
                stateCode?: string | null,
                postalCode: string,
                invalid?: boolean | null,
              } | null,
              logo?:  {
                __typename: "Image",
                alt?: string | null,
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type?: string | null,
              } | null,
              brandColour?: string | null,
              website?: string | null,
              entityUsers?:  {
                __typename: "ModelEntityUserConnection",
                nextToken?: string | null,
              } | null,
              gstRegistered?: boolean | null,
              gstReportingPeriod?: GSTReportingPeriod | null,
              providerEntityId?: string | null,
              providerCompanyId?: string | null,
              providerBillUserCompanyId?: string | null,
              providerBankAccountId?: string | null,
              providerDigitalWalletId?: string | null,
              providerBpayCrn?: string | null,
              contact?:  {
                __typename: "EntityContact",
                firstName?: string | null,
                lastName?: string | null,
                email?: string | null,
                phone?: string | null,
                role?: string | null,
              } | null,
              paymentMethods?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              paymentMethodId?: string | null,
              paymentUserId?: string | null,
              disbursementMethodId?: string | null,
              receivingAccounts?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              ubosCreated?: boolean | null,
              numUbosCreated?: number | null,
              subCategory?: string | null,
              clientsStatus?: EntityClientsStatus | null,
              ocrEmail?: string | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              owner?: string | null,
              referredBy?: string | null,
              connectedAccount?: string | null,
              accountStatus?: AccountStatus | null,
              customerId?: string | null,
              xeroSyncStatus?: XeroSyncStatus | null,
              xeroLastContactSyncAt?: string | null,
              xeroContactSyncStatus?: XeroSyncStatus | null,
              xeroInvoiceSyncStatus?: XeroSyncStatus | null,
              xeroLastInvoiceSyncAt?: string | null,
              xeroTenantId?: string | null,
              absorbFees?: boolean | null,
              subscriptionTier?: SubscriptionTier | null,
              invitationStatus?: InvitationStatus | null,
              clientsOnboardingStatus?: ClientsOnboardingStatus | null,
              createdBy?: string | null,
              createdByEntityId?: string | null,
              isFirm?: boolean | null,
              createdAt?: string | null,
              updatedAt?: string | null,
            } | null,
            firm?:  {
              __typename: "Entity",
              id: string,
              type: EntityType,
              taxNumber?: string | null,
              companyNumber?: string | null,
              billerCode?: number | null,
              name: string,
              legalName?: string | null,
              businessNames?: Array< string | null > | null,
              searchName?: string | null,
              address?:  {
                __typename: "Address",
                addressId?: string | null,
                contactName?: string | null,
                contactNumber?: string | null,
                fullAddress?: string | null,
                address1?: string | null,
                address2?: string | null,
                city?: string | null,
                country: string,
                countryCode: string,
                state: string,
                stateCode?: string | null,
                postalCode: string,
                invalid?: boolean | null,
              } | null,
              logo?:  {
                __typename: "Image",
                alt?: string | null,
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type?: string | null,
              } | null,
              brandColour?: string | null,
              website?: string | null,
              entityUsers?:  {
                __typename: "ModelEntityUserConnection",
                nextToken?: string | null,
              } | null,
              gstRegistered?: boolean | null,
              gstReportingPeriod?: GSTReportingPeriod | null,
              providerEntityId?: string | null,
              providerCompanyId?: string | null,
              providerBillUserCompanyId?: string | null,
              providerBankAccountId?: string | null,
              providerDigitalWalletId?: string | null,
              providerBpayCrn?: string | null,
              contact?:  {
                __typename: "EntityContact",
                firstName?: string | null,
                lastName?: string | null,
                email?: string | null,
                phone?: string | null,
                role?: string | null,
              } | null,
              paymentMethods?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              paymentMethodId?: string | null,
              paymentUserId?: string | null,
              disbursementMethodId?: string | null,
              receivingAccounts?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              ubosCreated?: boolean | null,
              numUbosCreated?: number | null,
              subCategory?: string | null,
              clientsStatus?: EntityClientsStatus | null,
              ocrEmail?: string | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              owner?: string | null,
              referredBy?: string | null,
              connectedAccount?: string | null,
              accountStatus?: AccountStatus | null,
              customerId?: string | null,
              xeroSyncStatus?: XeroSyncStatus | null,
              xeroLastContactSyncAt?: string | null,
              xeroContactSyncStatus?: XeroSyncStatus | null,
              xeroInvoiceSyncStatus?: XeroSyncStatus | null,
              xeroLastInvoiceSyncAt?: string | null,
              xeroTenantId?: string | null,
              absorbFees?: boolean | null,
              subscriptionTier?: SubscriptionTier | null,
              invitationStatus?: InvitationStatus | null,
              clientsOnboardingStatus?: ClientsOnboardingStatus | null,
              createdBy?: string | null,
              createdByEntityId?: string | null,
              isFirm?: boolean | null,
              createdAt?: string | null,
              updatedAt?: string | null,
            } | null,
            searchName?: string | null,
            taxNumber?: string | null,
            taskSendSMS?: boolean | null,
            companyNumber?: string | null,
            createdBy?: string | null,
            createdAt: string,
            updatedAt: string,
            status?: EntityUserStatus | null,
            partnerId?: string | null,
            managerId?: string | null,
            archivedAt?: string | null,
            taxPaymentReferences?:  {
              __typename: "TaxPaymentReferences",
              itr?:  {
                __typename: "TaxPaymentReference",
                referenceNumber?: string | null,
                updatedAt?: string | null,
              } | null,
              other?:  {
                __typename: "TaxPaymentReference",
                referenceNumber?: string | null,
                updatedAt?: string | null,
              } | null,
            } | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        gstRegistered?: boolean | null,
        gstReportingPeriod?: GSTReportingPeriod | null,
        providerEntityId?: string | null,
        providerCompanyId?: string | null,
        providerBillUserCompanyId?: string | null,
        providerBankAccountId?: string | null,
        providerDigitalWalletId?: string | null,
        providerBpayCrn?: string | null,
        contact?:  {
          __typename: "EntityContact",
          firstName?: string | null,
          lastName?: string | null,
          email?: string | null,
          phone?: string | null,
          role?: string | null,
        } | null,
        paymentMethods?:  {
          __typename: "ModelPaymentMethodConnection",
          items:  Array< {
            __typename: "PaymentMethod",
            id: string,
            paymentMethodType: PaymentMethodType,
            type?: string | null,
            fullName?: string | null,
            number?: string | null,
            expMonth?: string | null,
            expYear?: string | null,
            accountName?: string | null,
            bankName?: string | null,
            accountNumber?: string | null,
            routingNumber?: string | null,
            holderType?: BankHolderType | null,
            accountType?: BankAccountType | null,
            status?: PaymentMethodStatus | null,
            accountDirection?: AccountDirection | null,
            expiresAt?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            consentId?: string | null,
            consentStatus?: PaymentConsentStatus | null,
            card?: string | null,
            googlepay?: string | null,
            applepay?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        paymentMethodId?: string | null,
        paymentUserId?: string | null,
        disbursementMethodId?: string | null,
        receivingAccounts?:  {
          __typename: "ModelPaymentMethodConnection",
          items:  Array< {
            __typename: "PaymentMethod",
            id: string,
            paymentMethodType: PaymentMethodType,
            type?: string | null,
            fullName?: string | null,
            number?: string | null,
            expMonth?: string | null,
            expYear?: string | null,
            accountName?: string | null,
            bankName?: string | null,
            accountNumber?: string | null,
            routingNumber?: string | null,
            holderType?: BankHolderType | null,
            accountType?: BankAccountType | null,
            status?: PaymentMethodStatus | null,
            accountDirection?: AccountDirection | null,
            expiresAt?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            consentId?: string | null,
            consentStatus?: PaymentConsentStatus | null,
            card?: string | null,
            googlepay?: string | null,
            applepay?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        ubosCreated?: boolean | null,
        numUbosCreated?: number | null,
        subCategory?: string | null,
        clientsStatus?: EntityClientsStatus | null,
        ocrEmail?: string | null,
        termsInvoiceAccepted?: boolean | null,
        termsOcrAccepted?: boolean | null,
        owner?: string | null,
        referredBy?: string | null,
        connectedAccount?: string | null,
        accountStatus?: AccountStatus | null,
        customerId?: string | null,
        xeroSyncStatus?: XeroSyncStatus | null,
        xeroLastContactSyncAt?: string | null,
        xeroContactSyncStatus?: XeroSyncStatus | null,
        xeroInvoiceSyncStatus?: XeroSyncStatus | null,
        xeroLastInvoiceSyncAt?: string | null,
        xeroTenantId?: string | null,
        absorbFees?: boolean | null,
        subscriptionTier?: SubscriptionTier | null,
        invitationStatus?: InvitationStatus | null,
        clientsOnboardingStatus?: ClientsOnboardingStatus | null,
        createdBy?: string | null,
        createdByEntityId?: string | null,
        isFirm?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      searchName?: string | null,
      taxNumber?: string | null,
      taskSendSMS?: boolean | null,
      companyNumber?: string | null,
      createdBy?: string | null,
      createdAt: string,
      updatedAt: string,
      status?: EntityUserStatus | null,
      partnerId?: string | null,
      managerId?: string | null,
      archivedAt?: string | null,
      taxPaymentReferences?:  {
        __typename: "TaxPaymentReferences",
        itr?:  {
          __typename: "TaxPaymentReference",
          referenceNumber?: string | null,
          updatedAt?: string | null,
        } | null,
        other?:  {
          __typename: "TaxPaymentReference",
          referenceNumber?: string | null,
          updatedAt?: string | null,
        } | null,
      } | null,
    } | null > | null,
    otherRecipients?:  Array< {
      __typename: "OtherRecipient",
      email: string,
      sendOnCompletion: boolean,
    } | null > | null,
    payments?:  {
      __typename: "ModelPaymentConnection",
      items:  Array< {
        __typename: "Payment",
        id: string,
        paymentIntentId?: string | null,
        taskId?: string | null,
        entityId?: string | null,
        payInPaymentId?: string | null,
        providerTransactionId?: string | null,
        paymentProvider?: PaymentProvider | null,
        disbursementId?: string | null,
        fromId: string,
        fromType: FromToType,
        toId?: string | null,
        toType?: FromToType | null,
        buyerId?: string | null,
        sellerId?: string | null,
        entityIdTo?: string | null,
        amount?: number | null,
        netAmount?: number | null,
        payerFees?: number | null,
        totalAmount?: number | null,
        gstAmount?: number | null,
        installment?: number | null,
        installments?: number | null,
        feeAmount?: number | null,
        reference?: string | null,
        paymentType?: PaymentType | null,
        taxAmount?: number | null,
        currency?: string | null,
        feeIds?: Array< string | null > | null,
        ipAddress?: string | null,
        status: PaymentStatus,
        payerUserStatus?: PayerUserStatus | null,
        declinedReason?: string | null,
        isUnlimitedRecurring?: boolean | null,
        payoutFailureReason?: string | null,
        payoutFailureFields?: Array< string | null > | null,
        payoutDetails?:  {
          __typename: "PayoutDetails",
          bank?:  {
            __typename: "ContactBankAccount",
            id?: string | null,
            accountName?: string | null,
            bankName?: string | null,
            accountNumber: string,
            routingNumber: string,
            holderType?: BankHolderType | null,
            accountType?: BankAccountType | null,
            country?: string | null,
          } | null,
          bpay?:  {
            __typename: "ContactBpay",
            billerCode?: number | null,
            referenceNumber?: string | null,
          } | null,
        } | null,
        scheduledAt?: string | null,
        paidAt?: string | null,
        declinedAt?: string | null,
        createdAt?: string | null,
        receivedAt?: string | null,
        paidOutAt?: string | null,
        updatedAt?: string | null,
        voidedAt?: string | null,
        owner?: string | null,
        payoutFailedAt?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdBy: string,
    entityIdBy?: string | null,
    dueAt: string,
    issuedAt?: string | null,
    notes?: string | null,
    reviewerFeedback?:  Array< {
      __typename: "ReviewerFeedback",
      reviewedById: string,
      feedback: string,
      status: ReviewerFeedbackStatus,
      createdAt: string,
    } | null > | null,
    direction?: TaskDirection | null,
    readBy?: Array< string | null > | null,
    gstInclusive?: boolean | null,
    isUnlimitedRecurring?: boolean | null,
    owner?: string | null,
    lineItems?:  Array< {
      __typename: "LineItem",
      serviceId?: string | null,
      description: string,
      quantity: number,
      unitAmount: number,
      taxType: TaxType,
      lineAmount?: number | null,
      newService?: boolean | null,
    } | null > | null,
    xeroTenantId?: string | null,
    sendSMS?: boolean | null,
    automaticGenerateInvoice?: boolean | null,
    automaticInvoicePaymentAt?: string | null,
    automaticInvoicePaymentTerms?: PaymentTerms | null,
    quoteRequiresSignature?: boolean | null,
    automaticallyGeneratedFromQuote?: boolean | null,
    sendTemplate?: boolean | null,
    includeLetterhead?: boolean | null,
    templateJson?: string | null,
    templateHtml?: string | null,
    paymentAt?: string | null,
    lodgementAt?: string | null,
    period?: string | null,
    year?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    viewedAt?: string | null,
    readAt?: string | null,
    paidAt?: string | null,
    endAt?: string | null,
    quoteAcceptedAt?: string | null,
    completedAt?: string | null,
    payoutErrors?: Array< string | null > | null,
  } | null,
};

export type CreateBindingTaskMutationVariables = {
  input?: CreateBindingTaskInput | null,
};

export type CreateBindingTaskMutation = {
  createBindingTask?:  Array< {
    __typename: "Task",
    entityId: string,
    taskNumber?: string | null,
    invoiceStatus?: InvoiceStatus | null,
    agreementUuid?: string | null,
    documentType?: DocumentType | null,
    subCategory?: string | null,
    id: string,
    linkedTaskId?: string | null,
    managerId?: string | null,
    partnerId?: string | null,
    bindingId?: string | null,
    futureLinkedTask?:  {
      __typename: "FutureTask",
      fromId: string,
      fromType: FromToType,
      toId?: string | null,
      toType?: FromToType | null,
      numberOfPayments?: number | null,
      paymentFrequency?: PaymentFrequency | null,
      reference: string,
      bpayReferenceNumber?: string | null,
      amount?: number | null,
      gstInclusive?: boolean | null,
      lineItems?:  Array< {
        __typename: "LineItem",
        serviceId?: string | null,
        description: string,
        quantity: number,
        unitAmount: number,
        taxType: TaxType,
        lineAmount?: number | null,
        newService?: boolean | null,
      } | null > | null,
      isUnlimitedRecurring?: boolean | null,
      direction?: TaskDirection | null,
      invoiceStatus?: InvoiceStatus | null,
      dueAt: string,
      paymentAt?: string | null,
      lodgementAt?: string | null,
    } | null,
    documentAnalysisId?: string | null,
    activity?:  {
      __typename: "ModelActivityConnection",
      items:  Array< {
        __typename: "Activity",
        id: string,
        compositeId: string,
        userId?: string | null,
        entityId?: string | null,
        type: ActivityType,
        message?: string | null,
        metadata?:  {
          __typename: "ActivityMetadata",
          name?: string | null,
          email?: string | null,
        } | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    amount?: number | null,
    taxAmount?: number | null,
    annotations?: string | null,
    entityIdFrom?: string | null,
    fromId: string,
    fromType: FromToType,
    toId?: string | null,
    toType?: FromToType | null,
    firmId?: string | null,
    entityIdTo?: string | null,
    contactIdFrom?: string | null,
    contactIdTo?: string | null,
    contactId?: string | null,
    entityByIdContactId?: string | null,
    firmByIdContactId?: string | null,
    firmById?: string | null,
    searchName?: string | null,
    status: TaskStatus,
    quoteStatus?: TaskQuoteStatus | null,
    signatureStatus?: TaskSignatureStatus | null,
    paymentStatus?: TaskPaymentStatus | null,
    type: TaskType,
    category?: TaskCategory | null,
    documents?:  Array< {
      __typename: "S3Upload",
      identityId?: string | null,
      key: string,
      level: S3UploadLevel,
      type: S3UploadType,
      name?: string | null,
    } | null > | null,
    emailMessage?: string | null,
    supportDocuments?:  Array< {
      __typename: "S3Upload",
      identityId?: string | null,
      key: string,
      level: S3UploadLevel,
      type: S3UploadType,
      name?: string | null,
    } | null > | null,
    numberOfPayments?: number | null,
    paymentFrequency?: PaymentFrequency | null,
    paymentTypes: Array< PaymentType | null >,
    maximumInstallments?: number | null,
    reference?: string | null,
    bpayReferenceNumber?: string | null,
    settlementStatus?: TaskSettlementStatus | null,
    signers?:  Array< {
      __typename: "EntityUser",
      id: string,
      entityId: string,
      userId: string,
      firmId?: string | null,
      email?: string | null,
      invitedEmail?: string | null,
      ocrEmail?: string | null,
      referredBy?: string | null,
      invitedEntityId?: string | null,
      firmEntityId?: string | null,
      providerContactId?: string | null,
      ownerCode?: string | null,
      clientGroupCode?: string | null,
      clientCode?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      role: EntityUserRole,
      jobTags?: Array< JobTags | null > | null,
      paymentsEnabled?: boolean | null,
      termsInvoiceAccepted?: boolean | null,
      termsOcrAccepted?: boolean | null,
      termsFirmPayTaxAccepted?: boolean | null,
      termsFirmPayTaxDetails?:  {
        __typename: "TermsFirmPayTaxDetails",
        document?:  {
          __typename: "S3Upload",
          identityId?: string | null,
          key: string,
          level: S3UploadLevel,
          type: S3UploadType,
          name?: string | null,
        } | null,
        acceptedAt?: string | null,
        email?: string | null,
        ip?: string | null,
        fullName?: string | null,
        firmId?: string | null,
      } | null,
      entitySearchName?: string | null,
      entity?:  {
        __typename: "Entity",
        id: string,
        type: EntityType,
        taxNumber?: string | null,
        companyNumber?: string | null,
        billerCode?: number | null,
        name: string,
        legalName?: string | null,
        businessNames?: Array< string | null > | null,
        searchName?: string | null,
        address?:  {
          __typename: "Address",
          addressId?: string | null,
          contactName?: string | null,
          contactNumber?: string | null,
          fullAddress?: string | null,
          address1?: string | null,
          address2?: string | null,
          city?: string | null,
          country: string,
          countryCode: string,
          state: string,
          stateCode?: string | null,
          postalCode: string,
          invalid?: boolean | null,
        } | null,
        logo?:  {
          __typename: "Image",
          alt?: string | null,
          identityId?: string | null,
          key: string,
          level: S3UploadLevel,
          type?: string | null,
        } | null,
        brandColour?: string | null,
        website?: string | null,
        entityUsers?:  {
          __typename: "ModelEntityUserConnection",
          items:  Array< {
            __typename: "EntityUser",
            id: string,
            entityId: string,
            userId: string,
            firmId?: string | null,
            email?: string | null,
            invitedEmail?: string | null,
            ocrEmail?: string | null,
            referredBy?: string | null,
            invitedEntityId?: string | null,
            firmEntityId?: string | null,
            providerContactId?: string | null,
            ownerCode?: string | null,
            clientGroupCode?: string | null,
            clientCode?: string | null,
            firstName?: string | null,
            lastName?: string | null,
            role: EntityUserRole,
            jobTags?: Array< JobTags | null > | null,
            paymentsEnabled?: boolean | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            termsFirmPayTaxAccepted?: boolean | null,
            termsFirmPayTaxDetails?:  {
              __typename: "TermsFirmPayTaxDetails",
              document?:  {
                __typename: "S3Upload",
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type: S3UploadType,
                name?: string | null,
              } | null,
              acceptedAt?: string | null,
              email?: string | null,
              ip?: string | null,
              fullName?: string | null,
              firmId?: string | null,
            } | null,
            entitySearchName?: string | null,
            entity?:  {
              __typename: "Entity",
              id: string,
              type: EntityType,
              taxNumber?: string | null,
              companyNumber?: string | null,
              billerCode?: number | null,
              name: string,
              legalName?: string | null,
              businessNames?: Array< string | null > | null,
              searchName?: string | null,
              address?:  {
                __typename: "Address",
                addressId?: string | null,
                contactName?: string | null,
                contactNumber?: string | null,
                fullAddress?: string | null,
                address1?: string | null,
                address2?: string | null,
                city?: string | null,
                country: string,
                countryCode: string,
                state: string,
                stateCode?: string | null,
                postalCode: string,
                invalid?: boolean | null,
              } | null,
              logo?:  {
                __typename: "Image",
                alt?: string | null,
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type?: string | null,
              } | null,
              brandColour?: string | null,
              website?: string | null,
              entityUsers?:  {
                __typename: "ModelEntityUserConnection",
                nextToken?: string | null,
              } | null,
              gstRegistered?: boolean | null,
              gstReportingPeriod?: GSTReportingPeriod | null,
              providerEntityId?: string | null,
              providerCompanyId?: string | null,
              providerBillUserCompanyId?: string | null,
              providerBankAccountId?: string | null,
              providerDigitalWalletId?: string | null,
              providerBpayCrn?: string | null,
              contact?:  {
                __typename: "EntityContact",
                firstName?: string | null,
                lastName?: string | null,
                email?: string | null,
                phone?: string | null,
                role?: string | null,
              } | null,
              paymentMethods?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              paymentMethodId?: string | null,
              paymentUserId?: string | null,
              disbursementMethodId?: string | null,
              receivingAccounts?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              ubosCreated?: boolean | null,
              numUbosCreated?: number | null,
              subCategory?: string | null,
              clientsStatus?: EntityClientsStatus | null,
              ocrEmail?: string | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              owner?: string | null,
              referredBy?: string | null,
              connectedAccount?: string | null,
              accountStatus?: AccountStatus | null,
              customerId?: string | null,
              xeroSyncStatus?: XeroSyncStatus | null,
              xeroLastContactSyncAt?: string | null,
              xeroContactSyncStatus?: XeroSyncStatus | null,
              xeroInvoiceSyncStatus?: XeroSyncStatus | null,
              xeroLastInvoiceSyncAt?: string | null,
              xeroTenantId?: string | null,
              absorbFees?: boolean | null,
              subscriptionTier?: SubscriptionTier | null,
              invitationStatus?: InvitationStatus | null,
              clientsOnboardingStatus?: ClientsOnboardingStatus | null,
              createdBy?: string | null,
              createdByEntityId?: string | null,
              isFirm?: boolean | null,
              createdAt?: string | null,
              updatedAt?: string | null,
            } | null,
            firm?:  {
              __typename: "Entity",
              id: string,
              type: EntityType,
              taxNumber?: string | null,
              companyNumber?: string | null,
              billerCode?: number | null,
              name: string,
              legalName?: string | null,
              businessNames?: Array< string | null > | null,
              searchName?: string | null,
              address?:  {
                __typename: "Address",
                addressId?: string | null,
                contactName?: string | null,
                contactNumber?: string | null,
                fullAddress?: string | null,
                address1?: string | null,
                address2?: string | null,
                city?: string | null,
                country: string,
                countryCode: string,
                state: string,
                stateCode?: string | null,
                postalCode: string,
                invalid?: boolean | null,
              } | null,
              logo?:  {
                __typename: "Image",
                alt?: string | null,
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type?: string | null,
              } | null,
              brandColour?: string | null,
              website?: string | null,
              entityUsers?:  {
                __typename: "ModelEntityUserConnection",
                nextToken?: string | null,
              } | null,
              gstRegistered?: boolean | null,
              gstReportingPeriod?: GSTReportingPeriod | null,
              providerEntityId?: string | null,
              providerCompanyId?: string | null,
              providerBillUserCompanyId?: string | null,
              providerBankAccountId?: string | null,
              providerDigitalWalletId?: string | null,
              providerBpayCrn?: string | null,
              contact?:  {
                __typename: "EntityContact",
                firstName?: string | null,
                lastName?: string | null,
                email?: string | null,
                phone?: string | null,
                role?: string | null,
              } | null,
              paymentMethods?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              paymentMethodId?: string | null,
              paymentUserId?: string | null,
              disbursementMethodId?: string | null,
              receivingAccounts?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              ubosCreated?: boolean | null,
              numUbosCreated?: number | null,
              subCategory?: string | null,
              clientsStatus?: EntityClientsStatus | null,
              ocrEmail?: string | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              owner?: string | null,
              referredBy?: string | null,
              connectedAccount?: string | null,
              accountStatus?: AccountStatus | null,
              customerId?: string | null,
              xeroSyncStatus?: XeroSyncStatus | null,
              xeroLastContactSyncAt?: string | null,
              xeroContactSyncStatus?: XeroSyncStatus | null,
              xeroInvoiceSyncStatus?: XeroSyncStatus | null,
              xeroLastInvoiceSyncAt?: string | null,
              xeroTenantId?: string | null,
              absorbFees?: boolean | null,
              subscriptionTier?: SubscriptionTier | null,
              invitationStatus?: InvitationStatus | null,
              clientsOnboardingStatus?: ClientsOnboardingStatus | null,
              createdBy?: string | null,
              createdByEntityId?: string | null,
              isFirm?: boolean | null,
              createdAt?: string | null,
              updatedAt?: string | null,
            } | null,
            searchName?: string | null,
            taxNumber?: string | null,
            taskSendSMS?: boolean | null,
            companyNumber?: string | null,
            createdBy?: string | null,
            createdAt: string,
            updatedAt: string,
            status?: EntityUserStatus | null,
            partnerId?: string | null,
            managerId?: string | null,
            archivedAt?: string | null,
            taxPaymentReferences?:  {
              __typename: "TaxPaymentReferences",
              itr?:  {
                __typename: "TaxPaymentReference",
                referenceNumber?: string | null,
                updatedAt?: string | null,
              } | null,
              other?:  {
                __typename: "TaxPaymentReference",
                referenceNumber?: string | null,
                updatedAt?: string | null,
              } | null,
            } | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        gstRegistered?: boolean | null,
        gstReportingPeriod?: GSTReportingPeriod | null,
        providerEntityId?: string | null,
        providerCompanyId?: string | null,
        providerBillUserCompanyId?: string | null,
        providerBankAccountId?: string | null,
        providerDigitalWalletId?: string | null,
        providerBpayCrn?: string | null,
        contact?:  {
          __typename: "EntityContact",
          firstName?: string | null,
          lastName?: string | null,
          email?: string | null,
          phone?: string | null,
          role?: string | null,
        } | null,
        paymentMethods?:  {
          __typename: "ModelPaymentMethodConnection",
          items:  Array< {
            __typename: "PaymentMethod",
            id: string,
            paymentMethodType: PaymentMethodType,
            type?: string | null,
            fullName?: string | null,
            number?: string | null,
            expMonth?: string | null,
            expYear?: string | null,
            accountName?: string | null,
            bankName?: string | null,
            accountNumber?: string | null,
            routingNumber?: string | null,
            holderType?: BankHolderType | null,
            accountType?: BankAccountType | null,
            status?: PaymentMethodStatus | null,
            accountDirection?: AccountDirection | null,
            expiresAt?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            consentId?: string | null,
            consentStatus?: PaymentConsentStatus | null,
            card?: string | null,
            googlepay?: string | null,
            applepay?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        paymentMethodId?: string | null,
        paymentUserId?: string | null,
        disbursementMethodId?: string | null,
        receivingAccounts?:  {
          __typename: "ModelPaymentMethodConnection",
          items:  Array< {
            __typename: "PaymentMethod",
            id: string,
            paymentMethodType: PaymentMethodType,
            type?: string | null,
            fullName?: string | null,
            number?: string | null,
            expMonth?: string | null,
            expYear?: string | null,
            accountName?: string | null,
            bankName?: string | null,
            accountNumber?: string | null,
            routingNumber?: string | null,
            holderType?: BankHolderType | null,
            accountType?: BankAccountType | null,
            status?: PaymentMethodStatus | null,
            accountDirection?: AccountDirection | null,
            expiresAt?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            consentId?: string | null,
            consentStatus?: PaymentConsentStatus | null,
            card?: string | null,
            googlepay?: string | null,
            applepay?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        ubosCreated?: boolean | null,
        numUbosCreated?: number | null,
        subCategory?: string | null,
        clientsStatus?: EntityClientsStatus | null,
        ocrEmail?: string | null,
        termsInvoiceAccepted?: boolean | null,
        termsOcrAccepted?: boolean | null,
        owner?: string | null,
        referredBy?: string | null,
        connectedAccount?: string | null,
        accountStatus?: AccountStatus | null,
        customerId?: string | null,
        xeroSyncStatus?: XeroSyncStatus | null,
        xeroLastContactSyncAt?: string | null,
        xeroContactSyncStatus?: XeroSyncStatus | null,
        xeroInvoiceSyncStatus?: XeroSyncStatus | null,
        xeroLastInvoiceSyncAt?: string | null,
        xeroTenantId?: string | null,
        absorbFees?: boolean | null,
        subscriptionTier?: SubscriptionTier | null,
        invitationStatus?: InvitationStatus | null,
        clientsOnboardingStatus?: ClientsOnboardingStatus | null,
        createdBy?: string | null,
        createdByEntityId?: string | null,
        isFirm?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      firm?:  {
        __typename: "Entity",
        id: string,
        type: EntityType,
        taxNumber?: string | null,
        companyNumber?: string | null,
        billerCode?: number | null,
        name: string,
        legalName?: string | null,
        businessNames?: Array< string | null > | null,
        searchName?: string | null,
        address?:  {
          __typename: "Address",
          addressId?: string | null,
          contactName?: string | null,
          contactNumber?: string | null,
          fullAddress?: string | null,
          address1?: string | null,
          address2?: string | null,
          city?: string | null,
          country: string,
          countryCode: string,
          state: string,
          stateCode?: string | null,
          postalCode: string,
          invalid?: boolean | null,
        } | null,
        logo?:  {
          __typename: "Image",
          alt?: string | null,
          identityId?: string | null,
          key: string,
          level: S3UploadLevel,
          type?: string | null,
        } | null,
        brandColour?: string | null,
        website?: string | null,
        entityUsers?:  {
          __typename: "ModelEntityUserConnection",
          items:  Array< {
            __typename: "EntityUser",
            id: string,
            entityId: string,
            userId: string,
            firmId?: string | null,
            email?: string | null,
            invitedEmail?: string | null,
            ocrEmail?: string | null,
            referredBy?: string | null,
            invitedEntityId?: string | null,
            firmEntityId?: string | null,
            providerContactId?: string | null,
            ownerCode?: string | null,
            clientGroupCode?: string | null,
            clientCode?: string | null,
            firstName?: string | null,
            lastName?: string | null,
            role: EntityUserRole,
            jobTags?: Array< JobTags | null > | null,
            paymentsEnabled?: boolean | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            termsFirmPayTaxAccepted?: boolean | null,
            termsFirmPayTaxDetails?:  {
              __typename: "TermsFirmPayTaxDetails",
              document?:  {
                __typename: "S3Upload",
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type: S3UploadType,
                name?: string | null,
              } | null,
              acceptedAt?: string | null,
              email?: string | null,
              ip?: string | null,
              fullName?: string | null,
              firmId?: string | null,
            } | null,
            entitySearchName?: string | null,
            entity?:  {
              __typename: "Entity",
              id: string,
              type: EntityType,
              taxNumber?: string | null,
              companyNumber?: string | null,
              billerCode?: number | null,
              name: string,
              legalName?: string | null,
              businessNames?: Array< string | null > | null,
              searchName?: string | null,
              address?:  {
                __typename: "Address",
                addressId?: string | null,
                contactName?: string | null,
                contactNumber?: string | null,
                fullAddress?: string | null,
                address1?: string | null,
                address2?: string | null,
                city?: string | null,
                country: string,
                countryCode: string,
                state: string,
                stateCode?: string | null,
                postalCode: string,
                invalid?: boolean | null,
              } | null,
              logo?:  {
                __typename: "Image",
                alt?: string | null,
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type?: string | null,
              } | null,
              brandColour?: string | null,
              website?: string | null,
              entityUsers?:  {
                __typename: "ModelEntityUserConnection",
                nextToken?: string | null,
              } | null,
              gstRegistered?: boolean | null,
              gstReportingPeriod?: GSTReportingPeriod | null,
              providerEntityId?: string | null,
              providerCompanyId?: string | null,
              providerBillUserCompanyId?: string | null,
              providerBankAccountId?: string | null,
              providerDigitalWalletId?: string | null,
              providerBpayCrn?: string | null,
              contact?:  {
                __typename: "EntityContact",
                firstName?: string | null,
                lastName?: string | null,
                email?: string | null,
                phone?: string | null,
                role?: string | null,
              } | null,
              paymentMethods?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              paymentMethodId?: string | null,
              paymentUserId?: string | null,
              disbursementMethodId?: string | null,
              receivingAccounts?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              ubosCreated?: boolean | null,
              numUbosCreated?: number | null,
              subCategory?: string | null,
              clientsStatus?: EntityClientsStatus | null,
              ocrEmail?: string | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              owner?: string | null,
              referredBy?: string | null,
              connectedAccount?: string | null,
              accountStatus?: AccountStatus | null,
              customerId?: string | null,
              xeroSyncStatus?: XeroSyncStatus | null,
              xeroLastContactSyncAt?: string | null,
              xeroContactSyncStatus?: XeroSyncStatus | null,
              xeroInvoiceSyncStatus?: XeroSyncStatus | null,
              xeroLastInvoiceSyncAt?: string | null,
              xeroTenantId?: string | null,
              absorbFees?: boolean | null,
              subscriptionTier?: SubscriptionTier | null,
              invitationStatus?: InvitationStatus | null,
              clientsOnboardingStatus?: ClientsOnboardingStatus | null,
              createdBy?: string | null,
              createdByEntityId?: string | null,
              isFirm?: boolean | null,
              createdAt?: string | null,
              updatedAt?: string | null,
            } | null,
            firm?:  {
              __typename: "Entity",
              id: string,
              type: EntityType,
              taxNumber?: string | null,
              companyNumber?: string | null,
              billerCode?: number | null,
              name: string,
              legalName?: string | null,
              businessNames?: Array< string | null > | null,
              searchName?: string | null,
              address?:  {
                __typename: "Address",
                addressId?: string | null,
                contactName?: string | null,
                contactNumber?: string | null,
                fullAddress?: string | null,
                address1?: string | null,
                address2?: string | null,
                city?: string | null,
                country: string,
                countryCode: string,
                state: string,
                stateCode?: string | null,
                postalCode: string,
                invalid?: boolean | null,
              } | null,
              logo?:  {
                __typename: "Image",
                alt?: string | null,
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type?: string | null,
              } | null,
              brandColour?: string | null,
              website?: string | null,
              entityUsers?:  {
                __typename: "ModelEntityUserConnection",
                nextToken?: string | null,
              } | null,
              gstRegistered?: boolean | null,
              gstReportingPeriod?: GSTReportingPeriod | null,
              providerEntityId?: string | null,
              providerCompanyId?: string | null,
              providerBillUserCompanyId?: string | null,
              providerBankAccountId?: string | null,
              providerDigitalWalletId?: string | null,
              providerBpayCrn?: string | null,
              contact?:  {
                __typename: "EntityContact",
                firstName?: string | null,
                lastName?: string | null,
                email?: string | null,
                phone?: string | null,
                role?: string | null,
              } | null,
              paymentMethods?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              paymentMethodId?: string | null,
              paymentUserId?: string | null,
              disbursementMethodId?: string | null,
              receivingAccounts?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              ubosCreated?: boolean | null,
              numUbosCreated?: number | null,
              subCategory?: string | null,
              clientsStatus?: EntityClientsStatus | null,
              ocrEmail?: string | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              owner?: string | null,
              referredBy?: string | null,
              connectedAccount?: string | null,
              accountStatus?: AccountStatus | null,
              customerId?: string | null,
              xeroSyncStatus?: XeroSyncStatus | null,
              xeroLastContactSyncAt?: string | null,
              xeroContactSyncStatus?: XeroSyncStatus | null,
              xeroInvoiceSyncStatus?: XeroSyncStatus | null,
              xeroLastInvoiceSyncAt?: string | null,
              xeroTenantId?: string | null,
              absorbFees?: boolean | null,
              subscriptionTier?: SubscriptionTier | null,
              invitationStatus?: InvitationStatus | null,
              clientsOnboardingStatus?: ClientsOnboardingStatus | null,
              createdBy?: string | null,
              createdByEntityId?: string | null,
              isFirm?: boolean | null,
              createdAt?: string | null,
              updatedAt?: string | null,
            } | null,
            searchName?: string | null,
            taxNumber?: string | null,
            taskSendSMS?: boolean | null,
            companyNumber?: string | null,
            createdBy?: string | null,
            createdAt: string,
            updatedAt: string,
            status?: EntityUserStatus | null,
            partnerId?: string | null,
            managerId?: string | null,
            archivedAt?: string | null,
            taxPaymentReferences?:  {
              __typename: "TaxPaymentReferences",
              itr?:  {
                __typename: "TaxPaymentReference",
                referenceNumber?: string | null,
                updatedAt?: string | null,
              } | null,
              other?:  {
                __typename: "TaxPaymentReference",
                referenceNumber?: string | null,
                updatedAt?: string | null,
              } | null,
            } | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        gstRegistered?: boolean | null,
        gstReportingPeriod?: GSTReportingPeriod | null,
        providerEntityId?: string | null,
        providerCompanyId?: string | null,
        providerBillUserCompanyId?: string | null,
        providerBankAccountId?: string | null,
        providerDigitalWalletId?: string | null,
        providerBpayCrn?: string | null,
        contact?:  {
          __typename: "EntityContact",
          firstName?: string | null,
          lastName?: string | null,
          email?: string | null,
          phone?: string | null,
          role?: string | null,
        } | null,
        paymentMethods?:  {
          __typename: "ModelPaymentMethodConnection",
          items:  Array< {
            __typename: "PaymentMethod",
            id: string,
            paymentMethodType: PaymentMethodType,
            type?: string | null,
            fullName?: string | null,
            number?: string | null,
            expMonth?: string | null,
            expYear?: string | null,
            accountName?: string | null,
            bankName?: string | null,
            accountNumber?: string | null,
            routingNumber?: string | null,
            holderType?: BankHolderType | null,
            accountType?: BankAccountType | null,
            status?: PaymentMethodStatus | null,
            accountDirection?: AccountDirection | null,
            expiresAt?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            consentId?: string | null,
            consentStatus?: PaymentConsentStatus | null,
            card?: string | null,
            googlepay?: string | null,
            applepay?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        paymentMethodId?: string | null,
        paymentUserId?: string | null,
        disbursementMethodId?: string | null,
        receivingAccounts?:  {
          __typename: "ModelPaymentMethodConnection",
          items:  Array< {
            __typename: "PaymentMethod",
            id: string,
            paymentMethodType: PaymentMethodType,
            type?: string | null,
            fullName?: string | null,
            number?: string | null,
            expMonth?: string | null,
            expYear?: string | null,
            accountName?: string | null,
            bankName?: string | null,
            accountNumber?: string | null,
            routingNumber?: string | null,
            holderType?: BankHolderType | null,
            accountType?: BankAccountType | null,
            status?: PaymentMethodStatus | null,
            accountDirection?: AccountDirection | null,
            expiresAt?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            consentId?: string | null,
            consentStatus?: PaymentConsentStatus | null,
            card?: string | null,
            googlepay?: string | null,
            applepay?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        ubosCreated?: boolean | null,
        numUbosCreated?: number | null,
        subCategory?: string | null,
        clientsStatus?: EntityClientsStatus | null,
        ocrEmail?: string | null,
        termsInvoiceAccepted?: boolean | null,
        termsOcrAccepted?: boolean | null,
        owner?: string | null,
        referredBy?: string | null,
        connectedAccount?: string | null,
        accountStatus?: AccountStatus | null,
        customerId?: string | null,
        xeroSyncStatus?: XeroSyncStatus | null,
        xeroLastContactSyncAt?: string | null,
        xeroContactSyncStatus?: XeroSyncStatus | null,
        xeroInvoiceSyncStatus?: XeroSyncStatus | null,
        xeroLastInvoiceSyncAt?: string | null,
        xeroTenantId?: string | null,
        absorbFees?: boolean | null,
        subscriptionTier?: SubscriptionTier | null,
        invitationStatus?: InvitationStatus | null,
        clientsOnboardingStatus?: ClientsOnboardingStatus | null,
        createdBy?: string | null,
        createdByEntityId?: string | null,
        isFirm?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      searchName?: string | null,
      taxNumber?: string | null,
      taskSendSMS?: boolean | null,
      companyNumber?: string | null,
      createdBy?: string | null,
      createdAt: string,
      updatedAt: string,
      status?: EntityUserStatus | null,
      partnerId?: string | null,
      managerId?: string | null,
      archivedAt?: string | null,
      taxPaymentReferences?:  {
        __typename: "TaxPaymentReferences",
        itr?:  {
          __typename: "TaxPaymentReference",
          referenceNumber?: string | null,
          updatedAt?: string | null,
        } | null,
        other?:  {
          __typename: "TaxPaymentReference",
          referenceNumber?: string | null,
          updatedAt?: string | null,
        } | null,
      } | null,
    } | null > | null,
    otherRecipients?:  Array< {
      __typename: "OtherRecipient",
      email: string,
      sendOnCompletion: boolean,
    } | null > | null,
    payments?:  {
      __typename: "ModelPaymentConnection",
      items:  Array< {
        __typename: "Payment",
        id: string,
        paymentIntentId?: string | null,
        taskId?: string | null,
        entityId?: string | null,
        payInPaymentId?: string | null,
        providerTransactionId?: string | null,
        paymentProvider?: PaymentProvider | null,
        disbursementId?: string | null,
        fromId: string,
        fromType: FromToType,
        toId?: string | null,
        toType?: FromToType | null,
        buyerId?: string | null,
        sellerId?: string | null,
        entityIdTo?: string | null,
        amount?: number | null,
        netAmount?: number | null,
        payerFees?: number | null,
        totalAmount?: number | null,
        gstAmount?: number | null,
        installment?: number | null,
        installments?: number | null,
        feeAmount?: number | null,
        reference?: string | null,
        paymentType?: PaymentType | null,
        taxAmount?: number | null,
        currency?: string | null,
        feeIds?: Array< string | null > | null,
        ipAddress?: string | null,
        status: PaymentStatus,
        payerUserStatus?: PayerUserStatus | null,
        declinedReason?: string | null,
        isUnlimitedRecurring?: boolean | null,
        payoutFailureReason?: string | null,
        payoutFailureFields?: Array< string | null > | null,
        payoutDetails?:  {
          __typename: "PayoutDetails",
          bank?:  {
            __typename: "ContactBankAccount",
            id?: string | null,
            accountName?: string | null,
            bankName?: string | null,
            accountNumber: string,
            routingNumber: string,
            holderType?: BankHolderType | null,
            accountType?: BankAccountType | null,
            country?: string | null,
          } | null,
          bpay?:  {
            __typename: "ContactBpay",
            billerCode?: number | null,
            referenceNumber?: string | null,
          } | null,
        } | null,
        scheduledAt?: string | null,
        paidAt?: string | null,
        declinedAt?: string | null,
        createdAt?: string | null,
        receivedAt?: string | null,
        paidOutAt?: string | null,
        updatedAt?: string | null,
        voidedAt?: string | null,
        owner?: string | null,
        payoutFailedAt?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdBy: string,
    entityIdBy?: string | null,
    dueAt: string,
    issuedAt?: string | null,
    notes?: string | null,
    reviewerFeedback?:  Array< {
      __typename: "ReviewerFeedback",
      reviewedById: string,
      feedback: string,
      status: ReviewerFeedbackStatus,
      createdAt: string,
    } | null > | null,
    direction?: TaskDirection | null,
    readBy?: Array< string | null > | null,
    gstInclusive?: boolean | null,
    isUnlimitedRecurring?: boolean | null,
    owner?: string | null,
    lineItems?:  Array< {
      __typename: "LineItem",
      serviceId?: string | null,
      description: string,
      quantity: number,
      unitAmount: number,
      taxType: TaxType,
      lineAmount?: number | null,
      newService?: boolean | null,
    } | null > | null,
    xeroTenantId?: string | null,
    sendSMS?: boolean | null,
    automaticGenerateInvoice?: boolean | null,
    automaticInvoicePaymentAt?: string | null,
    automaticInvoicePaymentTerms?: PaymentTerms | null,
    quoteRequiresSignature?: boolean | null,
    automaticallyGeneratedFromQuote?: boolean | null,
    sendTemplate?: boolean | null,
    includeLetterhead?: boolean | null,
    templateJson?: string | null,
    templateHtml?: string | null,
    paymentAt?: string | null,
    lodgementAt?: string | null,
    period?: string | null,
    year?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    viewedAt?: string | null,
    readAt?: string | null,
    paidAt?: string | null,
    endAt?: string | null,
    quoteAcceptedAt?: string | null,
    completedAt?: string | null,
    payoutErrors?: Array< string | null > | null,
  } | null > | null,
};

export type UpdateBindingTaskMutationVariables = {
  input?: UpdateBindingTaskInput | null,
};

export type UpdateBindingTaskMutation = {
  updateBindingTask?:  {
    __typename: "Binding",
    id: string,
    sendTemplate?: boolean | null,
    sendSMS?: boolean | null,
    status?: BindingStatus | null,
    emailMessage?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    documents?:  Array< {
      __typename: "S3Upload",
      identityId?: string | null,
      key: string,
      level: S3UploadLevel,
      type: S3UploadType,
      name?: string | null,
    } | null > | null,
  } | null,
};

export type UpdateTaskMutationVariables = {
  input?: UpdateTaskInput | null,
};

export type UpdateTaskMutation = {
  updateTask?:  {
    __typename: "Task",
    entityId: string,
    taskNumber?: string | null,
    invoiceStatus?: InvoiceStatus | null,
    agreementUuid?: string | null,
    documentType?: DocumentType | null,
    subCategory?: string | null,
    id: string,
    linkedTaskId?: string | null,
    managerId?: string | null,
    partnerId?: string | null,
    bindingId?: string | null,
    futureLinkedTask?:  {
      __typename: "FutureTask",
      fromId: string,
      fromType: FromToType,
      toId?: string | null,
      toType?: FromToType | null,
      numberOfPayments?: number | null,
      paymentFrequency?: PaymentFrequency | null,
      reference: string,
      bpayReferenceNumber?: string | null,
      amount?: number | null,
      gstInclusive?: boolean | null,
      lineItems?:  Array< {
        __typename: "LineItem",
        serviceId?: string | null,
        description: string,
        quantity: number,
        unitAmount: number,
        taxType: TaxType,
        lineAmount?: number | null,
        newService?: boolean | null,
      } | null > | null,
      isUnlimitedRecurring?: boolean | null,
      direction?: TaskDirection | null,
      invoiceStatus?: InvoiceStatus | null,
      dueAt: string,
      paymentAt?: string | null,
      lodgementAt?: string | null,
    } | null,
    documentAnalysisId?: string | null,
    activity?:  {
      __typename: "ModelActivityConnection",
      items:  Array< {
        __typename: "Activity",
        id: string,
        compositeId: string,
        userId?: string | null,
        entityId?: string | null,
        type: ActivityType,
        message?: string | null,
        metadata?:  {
          __typename: "ActivityMetadata",
          name?: string | null,
          email?: string | null,
        } | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    amount?: number | null,
    taxAmount?: number | null,
    annotations?: string | null,
    entityIdFrom?: string | null,
    fromId: string,
    fromType: FromToType,
    toId?: string | null,
    toType?: FromToType | null,
    firmId?: string | null,
    entityIdTo?: string | null,
    contactIdFrom?: string | null,
    contactIdTo?: string | null,
    contactId?: string | null,
    entityByIdContactId?: string | null,
    firmByIdContactId?: string | null,
    firmById?: string | null,
    searchName?: string | null,
    status: TaskStatus,
    quoteStatus?: TaskQuoteStatus | null,
    signatureStatus?: TaskSignatureStatus | null,
    paymentStatus?: TaskPaymentStatus | null,
    type: TaskType,
    category?: TaskCategory | null,
    documents?:  Array< {
      __typename: "S3Upload",
      identityId?: string | null,
      key: string,
      level: S3UploadLevel,
      type: S3UploadType,
      name?: string | null,
    } | null > | null,
    emailMessage?: string | null,
    supportDocuments?:  Array< {
      __typename: "S3Upload",
      identityId?: string | null,
      key: string,
      level: S3UploadLevel,
      type: S3UploadType,
      name?: string | null,
    } | null > | null,
    numberOfPayments?: number | null,
    paymentFrequency?: PaymentFrequency | null,
    paymentTypes: Array< PaymentType | null >,
    maximumInstallments?: number | null,
    reference?: string | null,
    bpayReferenceNumber?: string | null,
    settlementStatus?: TaskSettlementStatus | null,
    signers?:  Array< {
      __typename: "EntityUser",
      id: string,
      entityId: string,
      userId: string,
      firmId?: string | null,
      email?: string | null,
      invitedEmail?: string | null,
      ocrEmail?: string | null,
      referredBy?: string | null,
      invitedEntityId?: string | null,
      firmEntityId?: string | null,
      providerContactId?: string | null,
      ownerCode?: string | null,
      clientGroupCode?: string | null,
      clientCode?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      role: EntityUserRole,
      jobTags?: Array< JobTags | null > | null,
      paymentsEnabled?: boolean | null,
      termsInvoiceAccepted?: boolean | null,
      termsOcrAccepted?: boolean | null,
      termsFirmPayTaxAccepted?: boolean | null,
      termsFirmPayTaxDetails?:  {
        __typename: "TermsFirmPayTaxDetails",
        document?:  {
          __typename: "S3Upload",
          identityId?: string | null,
          key: string,
          level: S3UploadLevel,
          type: S3UploadType,
          name?: string | null,
        } | null,
        acceptedAt?: string | null,
        email?: string | null,
        ip?: string | null,
        fullName?: string | null,
        firmId?: string | null,
      } | null,
      entitySearchName?: string | null,
      entity?:  {
        __typename: "Entity",
        id: string,
        type: EntityType,
        taxNumber?: string | null,
        companyNumber?: string | null,
        billerCode?: number | null,
        name: string,
        legalName?: string | null,
        businessNames?: Array< string | null > | null,
        searchName?: string | null,
        address?:  {
          __typename: "Address",
          addressId?: string | null,
          contactName?: string | null,
          contactNumber?: string | null,
          fullAddress?: string | null,
          address1?: string | null,
          address2?: string | null,
          city?: string | null,
          country: string,
          countryCode: string,
          state: string,
          stateCode?: string | null,
          postalCode: string,
          invalid?: boolean | null,
        } | null,
        logo?:  {
          __typename: "Image",
          alt?: string | null,
          identityId?: string | null,
          key: string,
          level: S3UploadLevel,
          type?: string | null,
        } | null,
        brandColour?: string | null,
        website?: string | null,
        entityUsers?:  {
          __typename: "ModelEntityUserConnection",
          items:  Array< {
            __typename: "EntityUser",
            id: string,
            entityId: string,
            userId: string,
            firmId?: string | null,
            email?: string | null,
            invitedEmail?: string | null,
            ocrEmail?: string | null,
            referredBy?: string | null,
            invitedEntityId?: string | null,
            firmEntityId?: string | null,
            providerContactId?: string | null,
            ownerCode?: string | null,
            clientGroupCode?: string | null,
            clientCode?: string | null,
            firstName?: string | null,
            lastName?: string | null,
            role: EntityUserRole,
            jobTags?: Array< JobTags | null > | null,
            paymentsEnabled?: boolean | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            termsFirmPayTaxAccepted?: boolean | null,
            termsFirmPayTaxDetails?:  {
              __typename: "TermsFirmPayTaxDetails",
              document?:  {
                __typename: "S3Upload",
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type: S3UploadType,
                name?: string | null,
              } | null,
              acceptedAt?: string | null,
              email?: string | null,
              ip?: string | null,
              fullName?: string | null,
              firmId?: string | null,
            } | null,
            entitySearchName?: string | null,
            entity?:  {
              __typename: "Entity",
              id: string,
              type: EntityType,
              taxNumber?: string | null,
              companyNumber?: string | null,
              billerCode?: number | null,
              name: string,
              legalName?: string | null,
              businessNames?: Array< string | null > | null,
              searchName?: string | null,
              address?:  {
                __typename: "Address",
                addressId?: string | null,
                contactName?: string | null,
                contactNumber?: string | null,
                fullAddress?: string | null,
                address1?: string | null,
                address2?: string | null,
                city?: string | null,
                country: string,
                countryCode: string,
                state: string,
                stateCode?: string | null,
                postalCode: string,
                invalid?: boolean | null,
              } | null,
              logo?:  {
                __typename: "Image",
                alt?: string | null,
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type?: string | null,
              } | null,
              brandColour?: string | null,
              website?: string | null,
              entityUsers?:  {
                __typename: "ModelEntityUserConnection",
                nextToken?: string | null,
              } | null,
              gstRegistered?: boolean | null,
              gstReportingPeriod?: GSTReportingPeriod | null,
              providerEntityId?: string | null,
              providerCompanyId?: string | null,
              providerBillUserCompanyId?: string | null,
              providerBankAccountId?: string | null,
              providerDigitalWalletId?: string | null,
              providerBpayCrn?: string | null,
              contact?:  {
                __typename: "EntityContact",
                firstName?: string | null,
                lastName?: string | null,
                email?: string | null,
                phone?: string | null,
                role?: string | null,
              } | null,
              paymentMethods?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              paymentMethodId?: string | null,
              paymentUserId?: string | null,
              disbursementMethodId?: string | null,
              receivingAccounts?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              ubosCreated?: boolean | null,
              numUbosCreated?: number | null,
              subCategory?: string | null,
              clientsStatus?: EntityClientsStatus | null,
              ocrEmail?: string | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              owner?: string | null,
              referredBy?: string | null,
              connectedAccount?: string | null,
              accountStatus?: AccountStatus | null,
              customerId?: string | null,
              xeroSyncStatus?: XeroSyncStatus | null,
              xeroLastContactSyncAt?: string | null,
              xeroContactSyncStatus?: XeroSyncStatus | null,
              xeroInvoiceSyncStatus?: XeroSyncStatus | null,
              xeroLastInvoiceSyncAt?: string | null,
              xeroTenantId?: string | null,
              absorbFees?: boolean | null,
              subscriptionTier?: SubscriptionTier | null,
              invitationStatus?: InvitationStatus | null,
              clientsOnboardingStatus?: ClientsOnboardingStatus | null,
              createdBy?: string | null,
              createdByEntityId?: string | null,
              isFirm?: boolean | null,
              createdAt?: string | null,
              updatedAt?: string | null,
            } | null,
            firm?:  {
              __typename: "Entity",
              id: string,
              type: EntityType,
              taxNumber?: string | null,
              companyNumber?: string | null,
              billerCode?: number | null,
              name: string,
              legalName?: string | null,
              businessNames?: Array< string | null > | null,
              searchName?: string | null,
              address?:  {
                __typename: "Address",
                addressId?: string | null,
                contactName?: string | null,
                contactNumber?: string | null,
                fullAddress?: string | null,
                address1?: string | null,
                address2?: string | null,
                city?: string | null,
                country: string,
                countryCode: string,
                state: string,
                stateCode?: string | null,
                postalCode: string,
                invalid?: boolean | null,
              } | null,
              logo?:  {
                __typename: "Image",
                alt?: string | null,
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type?: string | null,
              } | null,
              brandColour?: string | null,
              website?: string | null,
              entityUsers?:  {
                __typename: "ModelEntityUserConnection",
                nextToken?: string | null,
              } | null,
              gstRegistered?: boolean | null,
              gstReportingPeriod?: GSTReportingPeriod | null,
              providerEntityId?: string | null,
              providerCompanyId?: string | null,
              providerBillUserCompanyId?: string | null,
              providerBankAccountId?: string | null,
              providerDigitalWalletId?: string | null,
              providerBpayCrn?: string | null,
              contact?:  {
                __typename: "EntityContact",
                firstName?: string | null,
                lastName?: string | null,
                email?: string | null,
                phone?: string | null,
                role?: string | null,
              } | null,
              paymentMethods?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              paymentMethodId?: string | null,
              paymentUserId?: string | null,
              disbursementMethodId?: string | null,
              receivingAccounts?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              ubosCreated?: boolean | null,
              numUbosCreated?: number | null,
              subCategory?: string | null,
              clientsStatus?: EntityClientsStatus | null,
              ocrEmail?: string | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              owner?: string | null,
              referredBy?: string | null,
              connectedAccount?: string | null,
              accountStatus?: AccountStatus | null,
              customerId?: string | null,
              xeroSyncStatus?: XeroSyncStatus | null,
              xeroLastContactSyncAt?: string | null,
              xeroContactSyncStatus?: XeroSyncStatus | null,
              xeroInvoiceSyncStatus?: XeroSyncStatus | null,
              xeroLastInvoiceSyncAt?: string | null,
              xeroTenantId?: string | null,
              absorbFees?: boolean | null,
              subscriptionTier?: SubscriptionTier | null,
              invitationStatus?: InvitationStatus | null,
              clientsOnboardingStatus?: ClientsOnboardingStatus | null,
              createdBy?: string | null,
              createdByEntityId?: string | null,
              isFirm?: boolean | null,
              createdAt?: string | null,
              updatedAt?: string | null,
            } | null,
            searchName?: string | null,
            taxNumber?: string | null,
            taskSendSMS?: boolean | null,
            companyNumber?: string | null,
            createdBy?: string | null,
            createdAt: string,
            updatedAt: string,
            status?: EntityUserStatus | null,
            partnerId?: string | null,
            managerId?: string | null,
            archivedAt?: string | null,
            taxPaymentReferences?:  {
              __typename: "TaxPaymentReferences",
              itr?:  {
                __typename: "TaxPaymentReference",
                referenceNumber?: string | null,
                updatedAt?: string | null,
              } | null,
              other?:  {
                __typename: "TaxPaymentReference",
                referenceNumber?: string | null,
                updatedAt?: string | null,
              } | null,
            } | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        gstRegistered?: boolean | null,
        gstReportingPeriod?: GSTReportingPeriod | null,
        providerEntityId?: string | null,
        providerCompanyId?: string | null,
        providerBillUserCompanyId?: string | null,
        providerBankAccountId?: string | null,
        providerDigitalWalletId?: string | null,
        providerBpayCrn?: string | null,
        contact?:  {
          __typename: "EntityContact",
          firstName?: string | null,
          lastName?: string | null,
          email?: string | null,
          phone?: string | null,
          role?: string | null,
        } | null,
        paymentMethods?:  {
          __typename: "ModelPaymentMethodConnection",
          items:  Array< {
            __typename: "PaymentMethod",
            id: string,
            paymentMethodType: PaymentMethodType,
            type?: string | null,
            fullName?: string | null,
            number?: string | null,
            expMonth?: string | null,
            expYear?: string | null,
            accountName?: string | null,
            bankName?: string | null,
            accountNumber?: string | null,
            routingNumber?: string | null,
            holderType?: BankHolderType | null,
            accountType?: BankAccountType | null,
            status?: PaymentMethodStatus | null,
            accountDirection?: AccountDirection | null,
            expiresAt?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            consentId?: string | null,
            consentStatus?: PaymentConsentStatus | null,
            card?: string | null,
            googlepay?: string | null,
            applepay?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        paymentMethodId?: string | null,
        paymentUserId?: string | null,
        disbursementMethodId?: string | null,
        receivingAccounts?:  {
          __typename: "ModelPaymentMethodConnection",
          items:  Array< {
            __typename: "PaymentMethod",
            id: string,
            paymentMethodType: PaymentMethodType,
            type?: string | null,
            fullName?: string | null,
            number?: string | null,
            expMonth?: string | null,
            expYear?: string | null,
            accountName?: string | null,
            bankName?: string | null,
            accountNumber?: string | null,
            routingNumber?: string | null,
            holderType?: BankHolderType | null,
            accountType?: BankAccountType | null,
            status?: PaymentMethodStatus | null,
            accountDirection?: AccountDirection | null,
            expiresAt?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            consentId?: string | null,
            consentStatus?: PaymentConsentStatus | null,
            card?: string | null,
            googlepay?: string | null,
            applepay?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        ubosCreated?: boolean | null,
        numUbosCreated?: number | null,
        subCategory?: string | null,
        clientsStatus?: EntityClientsStatus | null,
        ocrEmail?: string | null,
        termsInvoiceAccepted?: boolean | null,
        termsOcrAccepted?: boolean | null,
        owner?: string | null,
        referredBy?: string | null,
        connectedAccount?: string | null,
        accountStatus?: AccountStatus | null,
        customerId?: string | null,
        xeroSyncStatus?: XeroSyncStatus | null,
        xeroLastContactSyncAt?: string | null,
        xeroContactSyncStatus?: XeroSyncStatus | null,
        xeroInvoiceSyncStatus?: XeroSyncStatus | null,
        xeroLastInvoiceSyncAt?: string | null,
        xeroTenantId?: string | null,
        absorbFees?: boolean | null,
        subscriptionTier?: SubscriptionTier | null,
        invitationStatus?: InvitationStatus | null,
        clientsOnboardingStatus?: ClientsOnboardingStatus | null,
        createdBy?: string | null,
        createdByEntityId?: string | null,
        isFirm?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      firm?:  {
        __typename: "Entity",
        id: string,
        type: EntityType,
        taxNumber?: string | null,
        companyNumber?: string | null,
        billerCode?: number | null,
        name: string,
        legalName?: string | null,
        businessNames?: Array< string | null > | null,
        searchName?: string | null,
        address?:  {
          __typename: "Address",
          addressId?: string | null,
          contactName?: string | null,
          contactNumber?: string | null,
          fullAddress?: string | null,
          address1?: string | null,
          address2?: string | null,
          city?: string | null,
          country: string,
          countryCode: string,
          state: string,
          stateCode?: string | null,
          postalCode: string,
          invalid?: boolean | null,
        } | null,
        logo?:  {
          __typename: "Image",
          alt?: string | null,
          identityId?: string | null,
          key: string,
          level: S3UploadLevel,
          type?: string | null,
        } | null,
        brandColour?: string | null,
        website?: string | null,
        entityUsers?:  {
          __typename: "ModelEntityUserConnection",
          items:  Array< {
            __typename: "EntityUser",
            id: string,
            entityId: string,
            userId: string,
            firmId?: string | null,
            email?: string | null,
            invitedEmail?: string | null,
            ocrEmail?: string | null,
            referredBy?: string | null,
            invitedEntityId?: string | null,
            firmEntityId?: string | null,
            providerContactId?: string | null,
            ownerCode?: string | null,
            clientGroupCode?: string | null,
            clientCode?: string | null,
            firstName?: string | null,
            lastName?: string | null,
            role: EntityUserRole,
            jobTags?: Array< JobTags | null > | null,
            paymentsEnabled?: boolean | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            termsFirmPayTaxAccepted?: boolean | null,
            termsFirmPayTaxDetails?:  {
              __typename: "TermsFirmPayTaxDetails",
              document?:  {
                __typename: "S3Upload",
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type: S3UploadType,
                name?: string | null,
              } | null,
              acceptedAt?: string | null,
              email?: string | null,
              ip?: string | null,
              fullName?: string | null,
              firmId?: string | null,
            } | null,
            entitySearchName?: string | null,
            entity?:  {
              __typename: "Entity",
              id: string,
              type: EntityType,
              taxNumber?: string | null,
              companyNumber?: string | null,
              billerCode?: number | null,
              name: string,
              legalName?: string | null,
              businessNames?: Array< string | null > | null,
              searchName?: string | null,
              address?:  {
                __typename: "Address",
                addressId?: string | null,
                contactName?: string | null,
                contactNumber?: string | null,
                fullAddress?: string | null,
                address1?: string | null,
                address2?: string | null,
                city?: string | null,
                country: string,
                countryCode: string,
                state: string,
                stateCode?: string | null,
                postalCode: string,
                invalid?: boolean | null,
              } | null,
              logo?:  {
                __typename: "Image",
                alt?: string | null,
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type?: string | null,
              } | null,
              brandColour?: string | null,
              website?: string | null,
              entityUsers?:  {
                __typename: "ModelEntityUserConnection",
                nextToken?: string | null,
              } | null,
              gstRegistered?: boolean | null,
              gstReportingPeriod?: GSTReportingPeriod | null,
              providerEntityId?: string | null,
              providerCompanyId?: string | null,
              providerBillUserCompanyId?: string | null,
              providerBankAccountId?: string | null,
              providerDigitalWalletId?: string | null,
              providerBpayCrn?: string | null,
              contact?:  {
                __typename: "EntityContact",
                firstName?: string | null,
                lastName?: string | null,
                email?: string | null,
                phone?: string | null,
                role?: string | null,
              } | null,
              paymentMethods?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              paymentMethodId?: string | null,
              paymentUserId?: string | null,
              disbursementMethodId?: string | null,
              receivingAccounts?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              ubosCreated?: boolean | null,
              numUbosCreated?: number | null,
              subCategory?: string | null,
              clientsStatus?: EntityClientsStatus | null,
              ocrEmail?: string | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              owner?: string | null,
              referredBy?: string | null,
              connectedAccount?: string | null,
              accountStatus?: AccountStatus | null,
              customerId?: string | null,
              xeroSyncStatus?: XeroSyncStatus | null,
              xeroLastContactSyncAt?: string | null,
              xeroContactSyncStatus?: XeroSyncStatus | null,
              xeroInvoiceSyncStatus?: XeroSyncStatus | null,
              xeroLastInvoiceSyncAt?: string | null,
              xeroTenantId?: string | null,
              absorbFees?: boolean | null,
              subscriptionTier?: SubscriptionTier | null,
              invitationStatus?: InvitationStatus | null,
              clientsOnboardingStatus?: ClientsOnboardingStatus | null,
              createdBy?: string | null,
              createdByEntityId?: string | null,
              isFirm?: boolean | null,
              createdAt?: string | null,
              updatedAt?: string | null,
            } | null,
            firm?:  {
              __typename: "Entity",
              id: string,
              type: EntityType,
              taxNumber?: string | null,
              companyNumber?: string | null,
              billerCode?: number | null,
              name: string,
              legalName?: string | null,
              businessNames?: Array< string | null > | null,
              searchName?: string | null,
              address?:  {
                __typename: "Address",
                addressId?: string | null,
                contactName?: string | null,
                contactNumber?: string | null,
                fullAddress?: string | null,
                address1?: string | null,
                address2?: string | null,
                city?: string | null,
                country: string,
                countryCode: string,
                state: string,
                stateCode?: string | null,
                postalCode: string,
                invalid?: boolean | null,
              } | null,
              logo?:  {
                __typename: "Image",
                alt?: string | null,
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type?: string | null,
              } | null,
              brandColour?: string | null,
              website?: string | null,
              entityUsers?:  {
                __typename: "ModelEntityUserConnection",
                nextToken?: string | null,
              } | null,
              gstRegistered?: boolean | null,
              gstReportingPeriod?: GSTReportingPeriod | null,
              providerEntityId?: string | null,
              providerCompanyId?: string | null,
              providerBillUserCompanyId?: string | null,
              providerBankAccountId?: string | null,
              providerDigitalWalletId?: string | null,
              providerBpayCrn?: string | null,
              contact?:  {
                __typename: "EntityContact",
                firstName?: string | null,
                lastName?: string | null,
                email?: string | null,
                phone?: string | null,
                role?: string | null,
              } | null,
              paymentMethods?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              paymentMethodId?: string | null,
              paymentUserId?: string | null,
              disbursementMethodId?: string | null,
              receivingAccounts?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              ubosCreated?: boolean | null,
              numUbosCreated?: number | null,
              subCategory?: string | null,
              clientsStatus?: EntityClientsStatus | null,
              ocrEmail?: string | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              owner?: string | null,
              referredBy?: string | null,
              connectedAccount?: string | null,
              accountStatus?: AccountStatus | null,
              customerId?: string | null,
              xeroSyncStatus?: XeroSyncStatus | null,
              xeroLastContactSyncAt?: string | null,
              xeroContactSyncStatus?: XeroSyncStatus | null,
              xeroInvoiceSyncStatus?: XeroSyncStatus | null,
              xeroLastInvoiceSyncAt?: string | null,
              xeroTenantId?: string | null,
              absorbFees?: boolean | null,
              subscriptionTier?: SubscriptionTier | null,
              invitationStatus?: InvitationStatus | null,
              clientsOnboardingStatus?: ClientsOnboardingStatus | null,
              createdBy?: string | null,
              createdByEntityId?: string | null,
              isFirm?: boolean | null,
              createdAt?: string | null,
              updatedAt?: string | null,
            } | null,
            searchName?: string | null,
            taxNumber?: string | null,
            taskSendSMS?: boolean | null,
            companyNumber?: string | null,
            createdBy?: string | null,
            createdAt: string,
            updatedAt: string,
            status?: EntityUserStatus | null,
            partnerId?: string | null,
            managerId?: string | null,
            archivedAt?: string | null,
            taxPaymentReferences?:  {
              __typename: "TaxPaymentReferences",
              itr?:  {
                __typename: "TaxPaymentReference",
                referenceNumber?: string | null,
                updatedAt?: string | null,
              } | null,
              other?:  {
                __typename: "TaxPaymentReference",
                referenceNumber?: string | null,
                updatedAt?: string | null,
              } | null,
            } | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        gstRegistered?: boolean | null,
        gstReportingPeriod?: GSTReportingPeriod | null,
        providerEntityId?: string | null,
        providerCompanyId?: string | null,
        providerBillUserCompanyId?: string | null,
        providerBankAccountId?: string | null,
        providerDigitalWalletId?: string | null,
        providerBpayCrn?: string | null,
        contact?:  {
          __typename: "EntityContact",
          firstName?: string | null,
          lastName?: string | null,
          email?: string | null,
          phone?: string | null,
          role?: string | null,
        } | null,
        paymentMethods?:  {
          __typename: "ModelPaymentMethodConnection",
          items:  Array< {
            __typename: "PaymentMethod",
            id: string,
            paymentMethodType: PaymentMethodType,
            type?: string | null,
            fullName?: string | null,
            number?: string | null,
            expMonth?: string | null,
            expYear?: string | null,
            accountName?: string | null,
            bankName?: string | null,
            accountNumber?: string | null,
            routingNumber?: string | null,
            holderType?: BankHolderType | null,
            accountType?: BankAccountType | null,
            status?: PaymentMethodStatus | null,
            accountDirection?: AccountDirection | null,
            expiresAt?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            consentId?: string | null,
            consentStatus?: PaymentConsentStatus | null,
            card?: string | null,
            googlepay?: string | null,
            applepay?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        paymentMethodId?: string | null,
        paymentUserId?: string | null,
        disbursementMethodId?: string | null,
        receivingAccounts?:  {
          __typename: "ModelPaymentMethodConnection",
          items:  Array< {
            __typename: "PaymentMethod",
            id: string,
            paymentMethodType: PaymentMethodType,
            type?: string | null,
            fullName?: string | null,
            number?: string | null,
            expMonth?: string | null,
            expYear?: string | null,
            accountName?: string | null,
            bankName?: string | null,
            accountNumber?: string | null,
            routingNumber?: string | null,
            holderType?: BankHolderType | null,
            accountType?: BankAccountType | null,
            status?: PaymentMethodStatus | null,
            accountDirection?: AccountDirection | null,
            expiresAt?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            consentId?: string | null,
            consentStatus?: PaymentConsentStatus | null,
            card?: string | null,
            googlepay?: string | null,
            applepay?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        ubosCreated?: boolean | null,
        numUbosCreated?: number | null,
        subCategory?: string | null,
        clientsStatus?: EntityClientsStatus | null,
        ocrEmail?: string | null,
        termsInvoiceAccepted?: boolean | null,
        termsOcrAccepted?: boolean | null,
        owner?: string | null,
        referredBy?: string | null,
        connectedAccount?: string | null,
        accountStatus?: AccountStatus | null,
        customerId?: string | null,
        xeroSyncStatus?: XeroSyncStatus | null,
        xeroLastContactSyncAt?: string | null,
        xeroContactSyncStatus?: XeroSyncStatus | null,
        xeroInvoiceSyncStatus?: XeroSyncStatus | null,
        xeroLastInvoiceSyncAt?: string | null,
        xeroTenantId?: string | null,
        absorbFees?: boolean | null,
        subscriptionTier?: SubscriptionTier | null,
        invitationStatus?: InvitationStatus | null,
        clientsOnboardingStatus?: ClientsOnboardingStatus | null,
        createdBy?: string | null,
        createdByEntityId?: string | null,
        isFirm?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      searchName?: string | null,
      taxNumber?: string | null,
      taskSendSMS?: boolean | null,
      companyNumber?: string | null,
      createdBy?: string | null,
      createdAt: string,
      updatedAt: string,
      status?: EntityUserStatus | null,
      partnerId?: string | null,
      managerId?: string | null,
      archivedAt?: string | null,
      taxPaymentReferences?:  {
        __typename: "TaxPaymentReferences",
        itr?:  {
          __typename: "TaxPaymentReference",
          referenceNumber?: string | null,
          updatedAt?: string | null,
        } | null,
        other?:  {
          __typename: "TaxPaymentReference",
          referenceNumber?: string | null,
          updatedAt?: string | null,
        } | null,
      } | null,
    } | null > | null,
    otherRecipients?:  Array< {
      __typename: "OtherRecipient",
      email: string,
      sendOnCompletion: boolean,
    } | null > | null,
    payments?:  {
      __typename: "ModelPaymentConnection",
      items:  Array< {
        __typename: "Payment",
        id: string,
        paymentIntentId?: string | null,
        taskId?: string | null,
        entityId?: string | null,
        payInPaymentId?: string | null,
        providerTransactionId?: string | null,
        paymentProvider?: PaymentProvider | null,
        disbursementId?: string | null,
        fromId: string,
        fromType: FromToType,
        toId?: string | null,
        toType?: FromToType | null,
        buyerId?: string | null,
        sellerId?: string | null,
        entityIdTo?: string | null,
        amount?: number | null,
        netAmount?: number | null,
        payerFees?: number | null,
        totalAmount?: number | null,
        gstAmount?: number | null,
        installment?: number | null,
        installments?: number | null,
        feeAmount?: number | null,
        reference?: string | null,
        paymentType?: PaymentType | null,
        taxAmount?: number | null,
        currency?: string | null,
        feeIds?: Array< string | null > | null,
        ipAddress?: string | null,
        status: PaymentStatus,
        payerUserStatus?: PayerUserStatus | null,
        declinedReason?: string | null,
        isUnlimitedRecurring?: boolean | null,
        payoutFailureReason?: string | null,
        payoutFailureFields?: Array< string | null > | null,
        payoutDetails?:  {
          __typename: "PayoutDetails",
          bank?:  {
            __typename: "ContactBankAccount",
            id?: string | null,
            accountName?: string | null,
            bankName?: string | null,
            accountNumber: string,
            routingNumber: string,
            holderType?: BankHolderType | null,
            accountType?: BankAccountType | null,
            country?: string | null,
          } | null,
          bpay?:  {
            __typename: "ContactBpay",
            billerCode?: number | null,
            referenceNumber?: string | null,
          } | null,
        } | null,
        scheduledAt?: string | null,
        paidAt?: string | null,
        declinedAt?: string | null,
        createdAt?: string | null,
        receivedAt?: string | null,
        paidOutAt?: string | null,
        updatedAt?: string | null,
        voidedAt?: string | null,
        owner?: string | null,
        payoutFailedAt?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdBy: string,
    entityIdBy?: string | null,
    dueAt: string,
    issuedAt?: string | null,
    notes?: string | null,
    reviewerFeedback?:  Array< {
      __typename: "ReviewerFeedback",
      reviewedById: string,
      feedback: string,
      status: ReviewerFeedbackStatus,
      createdAt: string,
    } | null > | null,
    direction?: TaskDirection | null,
    readBy?: Array< string | null > | null,
    gstInclusive?: boolean | null,
    isUnlimitedRecurring?: boolean | null,
    owner?: string | null,
    lineItems?:  Array< {
      __typename: "LineItem",
      serviceId?: string | null,
      description: string,
      quantity: number,
      unitAmount: number,
      taxType: TaxType,
      lineAmount?: number | null,
      newService?: boolean | null,
    } | null > | null,
    xeroTenantId?: string | null,
    sendSMS?: boolean | null,
    automaticGenerateInvoice?: boolean | null,
    automaticInvoicePaymentAt?: string | null,
    automaticInvoicePaymentTerms?: PaymentTerms | null,
    quoteRequiresSignature?: boolean | null,
    automaticallyGeneratedFromQuote?: boolean | null,
    sendTemplate?: boolean | null,
    includeLetterhead?: boolean | null,
    templateJson?: string | null,
    templateHtml?: string | null,
    paymentAt?: string | null,
    lodgementAt?: string | null,
    period?: string | null,
    year?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    viewedAt?: string | null,
    readAt?: string | null,
    paidAt?: string | null,
    endAt?: string | null,
    quoteAcceptedAt?: string | null,
    completedAt?: string | null,
    payoutErrors?: Array< string | null > | null,
  } | null,
};

export type UpdateTaskPublicMutationVariables = {
  input?: UpdateTaskPublicInput | null,
};

export type UpdateTaskPublicMutation = {
  updateTaskPublic?:  {
    __typename: "TaskGuest",
    id: string,
    entityId: string,
    amount?: number | null,
    taxAmount?: number | null,
    annotations?: string | null,
    documentType?: DocumentType | null,
    subCategory?: string | null,
    fromId: string,
    linkedTaskId?: string | null,
    futureLinkedTask?:  {
      __typename: "FutureTaskGuest",
      fromId: string,
      fromType: FromToType,
      from?:  {
        __typename: "EntityGuest",
        id: string,
        name: string,
        taxNumber?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      toId?: string | null,
      toType?: FromToType | null,
      to?:  {
        __typename: "EntityGuest",
        id: string,
        name: string,
        taxNumber?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      numberOfPayments?: number | null,
      paymentFrequency?: PaymentFrequency | null,
      reference: string,
      bpayReferenceNumber?: string | null,
      amount?: number | null,
      gstInclusive?: boolean | null,
      lineItems?:  Array< {
        __typename: "LineItem",
        serviceId?: string | null,
        description: string,
        quantity: number,
        unitAmount: number,
        taxType: TaxType,
        lineAmount?: number | null,
        newService?: boolean | null,
      } | null > | null,
      isUnlimitedRecurring?: boolean | null,
      direction?: TaskDirection | null,
      invoiceStatus?: InvoiceStatus | null,
      dueAt: string,
      paymentAt?: string | null,
      lodgementAt?: string | null,
    } | null,
    firm?:  {
      __typename: "EntityGuest",
      id: string,
      name: string,
      taxNumber?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    fromEntity?:  {
      __typename: "EntityGuest",
      id: string,
      name: string,
      taxNumber?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    from?:  {
      __typename: "EntityGuest",
      id: string,
      name: string,
      taxNumber?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    fromContact?:  {
      __typename: "ContactGuest",
      id: string,
      firstName?: string | null,
      lastName?: string | null,
      name?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    fromType?: FromToType | null,
    toEntity?:  {
      __typename: "EntityGuest",
      id: string,
      name: string,
      taxNumber?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    toContact?:  {
      __typename: "ContactGuest",
      id: string,
      firstName?: string | null,
      lastName?: string | null,
      name?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    toId?: string | null,
    to?:  {
      __typename: "EntityGuest",
      id: string,
      name: string,
      taxNumber?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    toType?: FromToType | null,
    isFinalSigner?: boolean | null,
    status: TaskStatus,
    signatureStatus?: TaskSignatureStatus | null,
    paymentStatus?: TaskPaymentStatus | null,
    quoteStatus?: TaskQuoteStatus | null,
    invoiceStatus?: InvoiceStatus | null,
    settlementStatus?: TaskSettlementStatus | null,
    type: TaskType,
    category?: TaskCategory | null,
    documents?:  Array< {
      __typename: "S3Upload",
      identityId?: string | null,
      key: string,
      level: S3UploadLevel,
      type: S3UploadType,
      name?: string | null,
    } | null > | null,
    supportDocuments?:  Array< {
      __typename: "S3Upload",
      identityId?: string | null,
      key: string,
      level: S3UploadLevel,
      type: S3UploadType,
      name?: string | null,
    } | null > | null,
    numberOfPayments?: number | null,
    paymentFrequency?: PaymentFrequency | null,
    paymentTypes: Array< PaymentType | null >,
    reference?: string | null,
    bpayReferenceNumber?: string | null,
    createdBy: string,
    gstInclusive?: boolean | null,
    entityIdBy?: string | null,
    dueAt: string,
    issuedAt?: string | null,
    notes?: string | null,
    direction?: TaskDirection | null,
    paymentAt?: string | null,
    lodgementAt?: string | null,
    readAt?: string | null,
    paidAt?: string | null,
    quoteAcceptedAt?: string | null,
    completedAt?: string | null,
    owner?: string | null,
    metaHashData?: string | null,
    automaticGenerateInvoice?: boolean | null,
    automaticInvoicePaymentAt?: string | null,
    automaticInvoicePaymentTerms?: PaymentTerms | null,
    quoteRequiresSignature?: boolean | null,
    automaticallyGeneratedFromQuote?: boolean | null,
    termsFirmPayTaxAccepted?: boolean | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    token?: string | null,
    period?: string | null,
    year?: string | null,
  } | null,
};

export type RegenerateTaskPublicLinkMutationVariables = {
  token: string,
};

export type RegenerateTaskPublicLinkMutation = {
  regenerateTaskPublicLink?: boolean | null,
};

export type RegenerateBindingPublicLinkMutationVariables = {
  token: string,
};

export type RegenerateBindingPublicLinkMutation = {
  regenerateBindingPublicLink?: string | null,
};

export type CreateTaskDocumentUrlMutationVariables = {
  input?: CreateTaskDocumentUrlInput | null,
};

export type CreateTaskDocumentUrlMutation = {
  createTaskDocumentUrl?:  {
    __typename: "TaskDocumentUrl",
    url?: string | null,
    expiresAt?: string | null,
  } | null,
};

export type CreateTaskDocumentUrlGuestMutationVariables = {
  input?: CreateTaskDocumentUrlGuestInput | null,
};

export type CreateTaskDocumentUrlGuestMutation = {
  createTaskDocumentUrlGuest?:  {
    __typename: "TaskDocumentUrl",
    url?: string | null,
    expiresAt?: string | null,
  } | null,
};

export type CreateTaskViewedGuestMutationVariables = {
  input?: CreateTaskViewedGuestInput | null,
};

export type CreateTaskViewedGuestMutation = {
  createTaskViewedGuest?: boolean | null,
};

export type CreateTaskSupportDocumentUrlMutationVariables = {
  input?: CreateTaskSupportDocumentUrlInput | null,
};

export type CreateTaskSupportDocumentUrlMutation = {
  createTaskSupportDocumentUrl?:  {
    __typename: "TaskDocumentUrl",
    url?: string | null,
    expiresAt?: string | null,
  } | null,
};

export type CreateTaskSupportDocumentUrlGuestMutationVariables = {
  input?: CreateTaskSupportDocumentUrlGuestInput | null,
};

export type CreateTaskSupportDocumentUrlGuestMutation = {
  createTaskSupportDocumentUrlGuest?:  {
    __typename: "TaskDocumentUrl",
    url?: string | null,
    expiresAt?: string | null,
  } | null,
};

export type CreateBindingTemplateUrlGuestMutationVariables = {
  input?: CreateBindingTemplateUrlGuestInput | null,
};

export type CreateBindingTemplateUrlGuestMutation = {
  createBindingTemplateUrlGuest?:  {
    __typename: "TaskDocumentUrl",
    url?: string | null,
    expiresAt?: string | null,
  } | null,
};

export type GenerateHashMutationVariables = {
  input?: GenerateHashInput | null,
};

export type GenerateHashMutation = {
  generateHash?: string | null,
};

export type GenerateSignatureUrlMutationVariables = {
  input?: GenerateSignatureUrlInput | null,
};

export type GenerateSignatureUrlMutation = {
  generateSignatureUrl?: string | null,
};

export type CreateUploadTaskUrlGuestMutationVariables = {
  input?: CreateUploadTaskUrlGuestInput | null,
};

export type CreateUploadTaskUrlGuestMutation = {
  createUploadTaskUrlGuest?:  {
    __typename: "TaskDocumentUploadUrl",
    url?: string | null,
  } | null,
};

export type CreateUploadTaskUrlMutationVariables = {
  input?: CreateUploadTaskUrlInput | null,
};

export type CreateUploadTaskUrlMutation = {
  createUploadTaskUrl?:  {
    __typename: "TaskDocumentUploadUrl",
    url?: string | null,
  } | null,
};

export type UpdateUserMutationVariables = {
  input?: UpdateUserInput | null,
};

export type UpdateUserMutation = {
  updateUser?:  {
    __typename: "User",
    id: string,
    identityId?: string | null,
    referralCode?: string | null,
    referredBy?: string | null,
    email?: string | null,
    about?: string | null,
    firstName?: string | null,
    firmId?: string | null,
    lastName?: string | null,
    phone?: string | null,
    blocked?: Array< string | null > | null,
    blockedBy?: Array< string | null > | null,
    country?: string | null,
    profileImg?:  {
      __typename: "Image",
      alt?: string | null,
      identityId?: string | null,
      key: string,
      level: S3UploadLevel,
      type?: string | null,
    } | null,
    interests?: Array< string | null > | null,
    locale?: string | null,
    onboardingStatus?: OnboardingStatus | null,
    onboardingEntity?: string | null,
    selectedEntityId?: string | null,
    selectedSignatureKey?: string | null,
    signatures?:  {
      __typename: "ModelSignatureConnection",
      items:  Array< {
        __typename: "Signature",
        id: string,
        userId: string,
        key: string,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    userType?: UserType | null,
    rating?: number | null,
    reportReasons?: Array< string | null > | null,
    notificationPreferences?:  {
      __typename: "NotificationPreferences",
      email?: boolean | null,
      push?: boolean | null,
      sms?: boolean | null,
    } | null,
    paymentUserId?: string | null,
    providerWalletId?: string | null,
    providerNppCrn?: string | null,
    ipAddress?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    owner?: string | null,
    loyaltyStatus?: RewardStatus | null,
    nextLoyaltyStatus?: RewardStatus | null,
    nextLoyaltyStatusPoint?: number | null,
    statusPoint?: number | null,
    pointsTotal?: number | null,
    pointsBalance?: number | null,
    invitedTo?: string | null,
  } | null,
};

export type BlockUserMutationVariables = {
  input?: BlockUserInput | null,
};

export type BlockUserMutation = {
  blockUser?:  {
    __typename: "User",
    id: string,
    identityId?: string | null,
    referralCode?: string | null,
    referredBy?: string | null,
    email?: string | null,
    about?: string | null,
    firstName?: string | null,
    firmId?: string | null,
    lastName?: string | null,
    phone?: string | null,
    blocked?: Array< string | null > | null,
    blockedBy?: Array< string | null > | null,
    country?: string | null,
    profileImg?:  {
      __typename: "Image",
      alt?: string | null,
      identityId?: string | null,
      key: string,
      level: S3UploadLevel,
      type?: string | null,
    } | null,
    interests?: Array< string | null > | null,
    locale?: string | null,
    onboardingStatus?: OnboardingStatus | null,
    onboardingEntity?: string | null,
    selectedEntityId?: string | null,
    selectedSignatureKey?: string | null,
    signatures?:  {
      __typename: "ModelSignatureConnection",
      items:  Array< {
        __typename: "Signature",
        id: string,
        userId: string,
        key: string,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    userType?: UserType | null,
    rating?: number | null,
    reportReasons?: Array< string | null > | null,
    notificationPreferences?:  {
      __typename: "NotificationPreferences",
      email?: boolean | null,
      push?: boolean | null,
      sms?: boolean | null,
    } | null,
    paymentUserId?: string | null,
    providerWalletId?: string | null,
    providerNppCrn?: string | null,
    ipAddress?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    owner?: string | null,
    loyaltyStatus?: RewardStatus | null,
    nextLoyaltyStatus?: RewardStatus | null,
    nextLoyaltyStatusPoint?: number | null,
    statusPoint?: number | null,
    pointsTotal?: number | null,
    pointsBalance?: number | null,
    invitedTo?: string | null,
  } | null,
};

export type DeleteAccountMutation = {
  deleteAccount?:  {
    __typename: "User",
    id: string,
    identityId?: string | null,
    referralCode?: string | null,
    referredBy?: string | null,
    email?: string | null,
    about?: string | null,
    firstName?: string | null,
    firmId?: string | null,
    lastName?: string | null,
    phone?: string | null,
    blocked?: Array< string | null > | null,
    blockedBy?: Array< string | null > | null,
    country?: string | null,
    profileImg?:  {
      __typename: "Image",
      alt?: string | null,
      identityId?: string | null,
      key: string,
      level: S3UploadLevel,
      type?: string | null,
    } | null,
    interests?: Array< string | null > | null,
    locale?: string | null,
    onboardingStatus?: OnboardingStatus | null,
    onboardingEntity?: string | null,
    selectedEntityId?: string | null,
    selectedSignatureKey?: string | null,
    signatures?:  {
      __typename: "ModelSignatureConnection",
      items:  Array< {
        __typename: "Signature",
        id: string,
        userId: string,
        key: string,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    userType?: UserType | null,
    rating?: number | null,
    reportReasons?: Array< string | null > | null,
    notificationPreferences?:  {
      __typename: "NotificationPreferences",
      email?: boolean | null,
      push?: boolean | null,
      sms?: boolean | null,
    } | null,
    paymentUserId?: string | null,
    providerWalletId?: string | null,
    providerNppCrn?: string | null,
    ipAddress?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    owner?: string | null,
    loyaltyStatus?: RewardStatus | null,
    nextLoyaltyStatus?: RewardStatus | null,
    nextLoyaltyStatusPoint?: number | null,
    statusPoint?: number | null,
    pointsTotal?: number | null,
    pointsBalance?: number | null,
    invitedTo?: string | null,
  } | null,
};

export type XeroCreateConsentUrlMutationVariables = {
  input?: XeroCreateConsentUrlInput | null,
};

export type XeroCreateConsentUrlMutation = {
  xeroCreateConsentUrl?: string | null,
};

export type XeroCreateContactSyncMutationVariables = {
  input?: XeroCreateContactSyncInput | null,
};

export type XeroCreateContactSyncMutation = {
  xeroCreateContactSync?: boolean | null,
};

export type XeroCreateInvoiceSyncMutationVariables = {
  input?: XeroCreateInvoiceSyncInput | null,
};

export type XeroCreateInvoiceSyncMutation = {
  xeroCreateInvoiceSync?: boolean | null,
};

export type XeroCreateTenantsConnectMutationVariables = {
  input?: xeroCreateTenantsConnectInput | null,
};

export type XeroCreateTenantsConnectMutation = {
  xeroCreateTenantsConnect?: boolean | null,
};

export type XeroGetProfileMutationVariables = {
  input?: XeroGetProfileInput | null,
};

export type XeroGetProfileMutation = {
  xeroGetProfile?: string | null,
};

export type XeroDisconnectMutationVariables = {
  input?: XeroDisconnectInput | null,
};

export type XeroDisconnectMutation = {
  xeroDisconnect?: boolean | null,
};

export type EmailCreateConsentUrlMutationVariables = {
  input?: EmailCreateConsentUrlInput | null,
};

export type EmailCreateConsentUrlMutation = {
  emailCreateConsentUrl?: string | null,
};

export type EmailDisconnectProviderMutationVariables = {
  entityId: string,
  provider: string,
};

export type EmailDisconnectProviderMutation = {
  emailDisconnectProvider?: boolean | null,
};

export type CreateBeneficiaryMutationVariables = {
  input?: CreateBeneficiaryInput | null,
};

export type CreateBeneficiaryMutation = {
  createBeneficiary?: string | null,
};

export type CreatePaymentIntentMutationVariables = {
  input?: CreatePaymentIntentInput | null,
};

export type CreatePaymentIntentMutation = {
  createPaymentIntent?: string | null,
};

export type UpdatePaymentIntentMutationVariables = {
  input?: UpdatePaymentIntentInput | null,
};

export type UpdatePaymentIntentMutation = {
  updatePaymentIntent?: string | null,
};

export type CreatePaymentIntentGuestMutationVariables = {
  input?: CreatePaymentIntentGuestInput | null,
};

export type CreatePaymentIntentGuestMutation = {
  createPaymentIntentGuest?: string | null,
};

export type GetAuthCodeMutationVariables = {
  input: GetAuthCodeInput,
};

export type GetAuthCodeMutation = {
  getAuthCode?: string | null,
};

export type AddFundsInWalletMutationVariables = {
  input?: AddFundsInWalletInput | null,
};

export type AddFundsInWalletMutation = {
  addFundsInWallet?: string | null,
};

export type CapturePaymentIntentMutationVariables = {
  input?: CapturePaymentIntentInput | null,
};

export type CapturePaymentIntentMutation = {
  capturePaymentIntent?: string | null,
};

export type AmountTransferMutationVariables = {
  input?: AmountTransferInput | null,
};

export type AmountTransferMutation = {
  amountTransfer?: string | null,
};

export type RetryPayoutTransferMutationVariables = {
  input?: RetryPayoutTransferInput | null,
};

export type RetryPayoutTransferMutation = {
  retryPayoutTransfer?:  {
    __typename: "Payment",
    id: string,
    paymentIntentId?: string | null,
    taskId?: string | null,
    entityId?: string | null,
    payInPaymentId?: string | null,
    providerTransactionId?: string | null,
    paymentProvider?: PaymentProvider | null,
    disbursementId?: string | null,
    fromId: string,
    fromType: FromToType,
    toId?: string | null,
    toType?: FromToType | null,
    buyerId?: string | null,
    sellerId?: string | null,
    entityIdTo?: string | null,
    amount?: number | null,
    netAmount?: number | null,
    payerFees?: number | null,
    totalAmount?: number | null,
    gstAmount?: number | null,
    installment?: number | null,
    installments?: number | null,
    feeAmount?: number | null,
    reference?: string | null,
    paymentType?: PaymentType | null,
    taxAmount?: number | null,
    currency?: string | null,
    feeIds?: Array< string | null > | null,
    ipAddress?: string | null,
    status: PaymentStatus,
    payerUserStatus?: PayerUserStatus | null,
    declinedReason?: string | null,
    isUnlimitedRecurring?: boolean | null,
    payoutFailureReason?: string | null,
    payoutFailureFields?: Array< string | null > | null,
    payoutDetails?:  {
      __typename: "PayoutDetails",
      bank?:  {
        __typename: "ContactBankAccount",
        id?: string | null,
        accountName?: string | null,
        bankName?: string | null,
        accountNumber: string,
        routingNumber: string,
        holderType?: BankHolderType | null,
        accountType?: BankAccountType | null,
        country?: string | null,
      } | null,
      bpay?:  {
        __typename: "ContactBpay",
        billerCode?: number | null,
        referenceNumber?: string | null,
      } | null,
    } | null,
    scheduledAt?: string | null,
    paidAt?: string | null,
    declinedAt?: string | null,
    createdAt?: string | null,
    receivedAt?: string | null,
    paidOutAt?: string | null,
    updatedAt?: string | null,
    voidedAt?: string | null,
    owner?: string | null,
    payoutFailedAt?: string | null,
  } | null,
};

export type ResendRemittenceMutationVariables = {
  input?: ResendRemittenceInput | null,
};

export type ResendRemittenceMutation = {
  resendRemittence?:  {
    __typename: "Payment",
    id: string,
    paymentIntentId?: string | null,
    taskId?: string | null,
    entityId?: string | null,
    payInPaymentId?: string | null,
    providerTransactionId?: string | null,
    paymentProvider?: PaymentProvider | null,
    disbursementId?: string | null,
    fromId: string,
    fromType: FromToType,
    toId?: string | null,
    toType?: FromToType | null,
    buyerId?: string | null,
    sellerId?: string | null,
    entityIdTo?: string | null,
    amount?: number | null,
    netAmount?: number | null,
    payerFees?: number | null,
    totalAmount?: number | null,
    gstAmount?: number | null,
    installment?: number | null,
    installments?: number | null,
    feeAmount?: number | null,
    reference?: string | null,
    paymentType?: PaymentType | null,
    taxAmount?: number | null,
    currency?: string | null,
    feeIds?: Array< string | null > | null,
    ipAddress?: string | null,
    status: PaymentStatus,
    payerUserStatus?: PayerUserStatus | null,
    declinedReason?: string | null,
    isUnlimitedRecurring?: boolean | null,
    payoutFailureReason?: string | null,
    payoutFailureFields?: Array< string | null > | null,
    payoutDetails?:  {
      __typename: "PayoutDetails",
      bank?:  {
        __typename: "ContactBankAccount",
        id?: string | null,
        accountName?: string | null,
        bankName?: string | null,
        accountNumber: string,
        routingNumber: string,
        holderType?: BankHolderType | null,
        accountType?: BankAccountType | null,
        country?: string | null,
      } | null,
      bpay?:  {
        __typename: "ContactBpay",
        billerCode?: number | null,
        referenceNumber?: string | null,
      } | null,
    } | null,
    scheduledAt?: string | null,
    paidAt?: string | null,
    declinedAt?: string | null,
    createdAt?: string | null,
    receivedAt?: string | null,
    paidOutAt?: string | null,
    updatedAt?: string | null,
    voidedAt?: string | null,
    owner?: string | null,
    payoutFailedAt?: string | null,
  } | null,
};

export type NotifyClientMutationVariables = {
  input?: NotifyClientInput | null,
};

export type NotifyClientMutation = {
  notifyClient?: string | null,
};

export type AbrLookupQueryVariables = {
  abn?: string | null,
};

export type AbrLookupQuery = {
  abrLookup:  {
    __typename: "ABNInformation",
    abn: string,
    abnStatus: string,
    abnStatusEffectiveFrom: string,
    acn?: string | null,
    addressDate?: string | null,
    addressPostcode?: string | null,
    addressState?: string | null,
    businessName?: Array< string | null > | null,
    entityName?: string | null,
    entityTypeCode?: string | null,
    entityTypeName?: string | null,
    gst?: string | null,
    message?: string | null,
    type?: EntityType | null,
  },
};

export type AbrLookupByNameQueryVariables = {
  name?: string | null,
};

export type AbrLookupByNameQuery = {
  abrLookupByName:  {
    __typename: "ModelAbrNameSearchInformationConnection",
    items:  Array< {
      __typename: "AbrNameSearchInformation",
      abn: string,
      abnStatus: string,
      isCurrent: boolean,
      name: string,
      nameType: string,
      postcode: string,
      state: string,
    } | null >,
  },
};

export type AutocompleteResultsByTypeQueryVariables = {
  type: AutocompleteType,
  searchName: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelEntityFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AutocompleteResultsByTypeQuery = {
  autocompleteResultsByType?:  {
    __typename: "ModelAutocompleteResultConnection",
    items:  Array< {
      __typename: "AutocompleteResult",
      id: string,
      value: string,
      label: string,
      info?: string | null,
      type: AutocompleteType,
      searchName: string,
      metadata?:  {
        __typename: "AutocompleteResultMetadata",
        subCategory?: string | null,
        payoutMethod?: PayoutMethod | null,
        billerCode?: number | null,
      } | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAutoCompleteQueryVariables = {
  id: string,
};

export type GetAutoCompleteQuery = {
  getAutoComplete?:  {
    __typename: "GetAutoCompleteResult",
    entity?:  {
      __typename: "Entity",
      id: string,
      type: EntityType,
      taxNumber?: string | null,
      companyNumber?: string | null,
      billerCode?: number | null,
      name: string,
      legalName?: string | null,
      businessNames?: Array< string | null > | null,
      searchName?: string | null,
      address?:  {
        __typename: "Address",
        addressId?: string | null,
        contactName?: string | null,
        contactNumber?: string | null,
        fullAddress?: string | null,
        address1?: string | null,
        address2?: string | null,
        city?: string | null,
        country: string,
        countryCode: string,
        state: string,
        stateCode?: string | null,
        postalCode: string,
        invalid?: boolean | null,
      } | null,
      logo?:  {
        __typename: "Image",
        alt?: string | null,
        identityId?: string | null,
        key: string,
        level: S3UploadLevel,
        type?: string | null,
      } | null,
      brandColour?: string | null,
      website?: string | null,
      entityUsers?:  {
        __typename: "ModelEntityUserConnection",
        items:  Array< {
          __typename: "EntityUser",
          id: string,
          entityId: string,
          userId: string,
          firmId?: string | null,
          email?: string | null,
          invitedEmail?: string | null,
          ocrEmail?: string | null,
          referredBy?: string | null,
          invitedEntityId?: string | null,
          firmEntityId?: string | null,
          providerContactId?: string | null,
          ownerCode?: string | null,
          clientGroupCode?: string | null,
          clientCode?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          role: EntityUserRole,
          jobTags?: Array< JobTags | null > | null,
          paymentsEnabled?: boolean | null,
          termsInvoiceAccepted?: boolean | null,
          termsOcrAccepted?: boolean | null,
          termsFirmPayTaxAccepted?: boolean | null,
          termsFirmPayTaxDetails?:  {
            __typename: "TermsFirmPayTaxDetails",
            document?:  {
              __typename: "S3Upload",
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type: S3UploadType,
              name?: string | null,
            } | null,
            acceptedAt?: string | null,
            email?: string | null,
            ip?: string | null,
            fullName?: string | null,
            firmId?: string | null,
          } | null,
          entitySearchName?: string | null,
          entity?:  {
            __typename: "Entity",
            id: string,
            type: EntityType,
            taxNumber?: string | null,
            companyNumber?: string | null,
            billerCode?: number | null,
            name: string,
            legalName?: string | null,
            businessNames?: Array< string | null > | null,
            searchName?: string | null,
            address?:  {
              __typename: "Address",
              addressId?: string | null,
              contactName?: string | null,
              contactNumber?: string | null,
              fullAddress?: string | null,
              address1?: string | null,
              address2?: string | null,
              city?: string | null,
              country: string,
              countryCode: string,
              state: string,
              stateCode?: string | null,
              postalCode: string,
              invalid?: boolean | null,
            } | null,
            logo?:  {
              __typename: "Image",
              alt?: string | null,
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type?: string | null,
            } | null,
            brandColour?: string | null,
            website?: string | null,
            entityUsers?:  {
              __typename: "ModelEntityUserConnection",
              items:  Array< {
                __typename: "EntityUser",
                id: string,
                entityId: string,
                userId: string,
                firmId?: string | null,
                email?: string | null,
                invitedEmail?: string | null,
                ocrEmail?: string | null,
                referredBy?: string | null,
                invitedEntityId?: string | null,
                firmEntityId?: string | null,
                providerContactId?: string | null,
                ownerCode?: string | null,
                clientGroupCode?: string | null,
                clientCode?: string | null,
                firstName?: string | null,
                lastName?: string | null,
                role: EntityUserRole,
                jobTags?: Array< JobTags | null > | null,
                paymentsEnabled?: boolean | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                termsFirmPayTaxAccepted?: boolean | null,
                entitySearchName?: string | null,
                searchName?: string | null,
                taxNumber?: string | null,
                taskSendSMS?: boolean | null,
                companyNumber?: string | null,
                createdBy?: string | null,
                createdAt: string,
                updatedAt: string,
                status?: EntityUserStatus | null,
                partnerId?: string | null,
                managerId?: string | null,
                archivedAt?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gstRegistered?: boolean | null,
            gstReportingPeriod?: GSTReportingPeriod | null,
            providerEntityId?: string | null,
            providerCompanyId?: string | null,
            providerBillUserCompanyId?: string | null,
            providerBankAccountId?: string | null,
            providerDigitalWalletId?: string | null,
            providerBpayCrn?: string | null,
            contact?:  {
              __typename: "EntityContact",
              firstName?: string | null,
              lastName?: string | null,
              email?: string | null,
              phone?: string | null,
              role?: string | null,
            } | null,
            paymentMethods?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            paymentMethodId?: string | null,
            paymentUserId?: string | null,
            disbursementMethodId?: string | null,
            receivingAccounts?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            ubosCreated?: boolean | null,
            numUbosCreated?: number | null,
            subCategory?: string | null,
            clientsStatus?: EntityClientsStatus | null,
            ocrEmail?: string | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            owner?: string | null,
            referredBy?: string | null,
            connectedAccount?: string | null,
            accountStatus?: AccountStatus | null,
            customerId?: string | null,
            xeroSyncStatus?: XeroSyncStatus | null,
            xeroLastContactSyncAt?: string | null,
            xeroContactSyncStatus?: XeroSyncStatus | null,
            xeroInvoiceSyncStatus?: XeroSyncStatus | null,
            xeroLastInvoiceSyncAt?: string | null,
            xeroTenantId?: string | null,
            absorbFees?: boolean | null,
            subscriptionTier?: SubscriptionTier | null,
            invitationStatus?: InvitationStatus | null,
            clientsOnboardingStatus?: ClientsOnboardingStatus | null,
            createdBy?: string | null,
            createdByEntityId?: string | null,
            isFirm?: boolean | null,
            createdAt?: string | null,
            updatedAt?: string | null,
          } | null,
          firm?:  {
            __typename: "Entity",
            id: string,
            type: EntityType,
            taxNumber?: string | null,
            companyNumber?: string | null,
            billerCode?: number | null,
            name: string,
            legalName?: string | null,
            businessNames?: Array< string | null > | null,
            searchName?: string | null,
            address?:  {
              __typename: "Address",
              addressId?: string | null,
              contactName?: string | null,
              contactNumber?: string | null,
              fullAddress?: string | null,
              address1?: string | null,
              address2?: string | null,
              city?: string | null,
              country: string,
              countryCode: string,
              state: string,
              stateCode?: string | null,
              postalCode: string,
              invalid?: boolean | null,
            } | null,
            logo?:  {
              __typename: "Image",
              alt?: string | null,
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type?: string | null,
            } | null,
            brandColour?: string | null,
            website?: string | null,
            entityUsers?:  {
              __typename: "ModelEntityUserConnection",
              items:  Array< {
                __typename: "EntityUser",
                id: string,
                entityId: string,
                userId: string,
                firmId?: string | null,
                email?: string | null,
                invitedEmail?: string | null,
                ocrEmail?: string | null,
                referredBy?: string | null,
                invitedEntityId?: string | null,
                firmEntityId?: string | null,
                providerContactId?: string | null,
                ownerCode?: string | null,
                clientGroupCode?: string | null,
                clientCode?: string | null,
                firstName?: string | null,
                lastName?: string | null,
                role: EntityUserRole,
                jobTags?: Array< JobTags | null > | null,
                paymentsEnabled?: boolean | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                termsFirmPayTaxAccepted?: boolean | null,
                entitySearchName?: string | null,
                searchName?: string | null,
                taxNumber?: string | null,
                taskSendSMS?: boolean | null,
                companyNumber?: string | null,
                createdBy?: string | null,
                createdAt: string,
                updatedAt: string,
                status?: EntityUserStatus | null,
                partnerId?: string | null,
                managerId?: string | null,
                archivedAt?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gstRegistered?: boolean | null,
            gstReportingPeriod?: GSTReportingPeriod | null,
            providerEntityId?: string | null,
            providerCompanyId?: string | null,
            providerBillUserCompanyId?: string | null,
            providerBankAccountId?: string | null,
            providerDigitalWalletId?: string | null,
            providerBpayCrn?: string | null,
            contact?:  {
              __typename: "EntityContact",
              firstName?: string | null,
              lastName?: string | null,
              email?: string | null,
              phone?: string | null,
              role?: string | null,
            } | null,
            paymentMethods?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            paymentMethodId?: string | null,
            paymentUserId?: string | null,
            disbursementMethodId?: string | null,
            receivingAccounts?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            ubosCreated?: boolean | null,
            numUbosCreated?: number | null,
            subCategory?: string | null,
            clientsStatus?: EntityClientsStatus | null,
            ocrEmail?: string | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            owner?: string | null,
            referredBy?: string | null,
            connectedAccount?: string | null,
            accountStatus?: AccountStatus | null,
            customerId?: string | null,
            xeroSyncStatus?: XeroSyncStatus | null,
            xeroLastContactSyncAt?: string | null,
            xeroContactSyncStatus?: XeroSyncStatus | null,
            xeroInvoiceSyncStatus?: XeroSyncStatus | null,
            xeroLastInvoiceSyncAt?: string | null,
            xeroTenantId?: string | null,
            absorbFees?: boolean | null,
            subscriptionTier?: SubscriptionTier | null,
            invitationStatus?: InvitationStatus | null,
            clientsOnboardingStatus?: ClientsOnboardingStatus | null,
            createdBy?: string | null,
            createdByEntityId?: string | null,
            isFirm?: boolean | null,
            createdAt?: string | null,
            updatedAt?: string | null,
          } | null,
          searchName?: string | null,
          taxNumber?: string | null,
          taskSendSMS?: boolean | null,
          companyNumber?: string | null,
          createdBy?: string | null,
          createdAt: string,
          updatedAt: string,
          status?: EntityUserStatus | null,
          partnerId?: string | null,
          managerId?: string | null,
          archivedAt?: string | null,
          taxPaymentReferences?:  {
            __typename: "TaxPaymentReferences",
            itr?:  {
              __typename: "TaxPaymentReference",
              referenceNumber?: string | null,
              updatedAt?: string | null,
            } | null,
            other?:  {
              __typename: "TaxPaymentReference",
              referenceNumber?: string | null,
              updatedAt?: string | null,
            } | null,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gstRegistered?: boolean | null,
      gstReportingPeriod?: GSTReportingPeriod | null,
      providerEntityId?: string | null,
      providerCompanyId?: string | null,
      providerBillUserCompanyId?: string | null,
      providerBankAccountId?: string | null,
      providerDigitalWalletId?: string | null,
      providerBpayCrn?: string | null,
      contact?:  {
        __typename: "EntityContact",
        firstName?: string | null,
        lastName?: string | null,
        email?: string | null,
        phone?: string | null,
        role?: string | null,
      } | null,
      paymentMethods?:  {
        __typename: "ModelPaymentMethodConnection",
        items:  Array< {
          __typename: "PaymentMethod",
          id: string,
          paymentMethodType: PaymentMethodType,
          type?: string | null,
          fullName?: string | null,
          number?: string | null,
          expMonth?: string | null,
          expYear?: string | null,
          accountName?: string | null,
          bankName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
          holderType?: BankHolderType | null,
          accountType?: BankAccountType | null,
          status?: PaymentMethodStatus | null,
          accountDirection?: AccountDirection | null,
          expiresAt?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          consentId?: string | null,
          consentStatus?: PaymentConsentStatus | null,
          card?: string | null,
          googlepay?: string | null,
          applepay?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      paymentMethodId?: string | null,
      paymentUserId?: string | null,
      disbursementMethodId?: string | null,
      receivingAccounts?:  {
        __typename: "ModelPaymentMethodConnection",
        items:  Array< {
          __typename: "PaymentMethod",
          id: string,
          paymentMethodType: PaymentMethodType,
          type?: string | null,
          fullName?: string | null,
          number?: string | null,
          expMonth?: string | null,
          expYear?: string | null,
          accountName?: string | null,
          bankName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
          holderType?: BankHolderType | null,
          accountType?: BankAccountType | null,
          status?: PaymentMethodStatus | null,
          accountDirection?: AccountDirection | null,
          expiresAt?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          consentId?: string | null,
          consentStatus?: PaymentConsentStatus | null,
          card?: string | null,
          googlepay?: string | null,
          applepay?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      ubosCreated?: boolean | null,
      numUbosCreated?: number | null,
      subCategory?: string | null,
      clientsStatus?: EntityClientsStatus | null,
      ocrEmail?: string | null,
      termsInvoiceAccepted?: boolean | null,
      termsOcrAccepted?: boolean | null,
      owner?: string | null,
      referredBy?: string | null,
      connectedAccount?: string | null,
      accountStatus?: AccountStatus | null,
      customerId?: string | null,
      xeroSyncStatus?: XeroSyncStatus | null,
      xeroLastContactSyncAt?: string | null,
      xeroContactSyncStatus?: XeroSyncStatus | null,
      xeroInvoiceSyncStatus?: XeroSyncStatus | null,
      xeroLastInvoiceSyncAt?: string | null,
      xeroTenantId?: string | null,
      absorbFees?: boolean | null,
      subscriptionTier?: SubscriptionTier | null,
      invitationStatus?: InvitationStatus | null,
      clientsOnboardingStatus?: ClientsOnboardingStatus | null,
      createdBy?: string | null,
      createdByEntityId?: string | null,
      isFirm?: boolean | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    contact?:  {
      __typename: "Contact",
      id: string,
      entityId: string,
      xeroTenantId?: string | null,
      entityType?: EntityType | null,
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      mobile?: string | null,
      phone?: string | null,
      taxNumber?: string | null,
      companyNumber?: string | null,
      name?: string | null,
      legalName?: string | null,
      searchName?: string | null,
      status?: ContactStatus | null,
      website?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      contactType?: ContactType | null,
      bank?:  {
        __typename: "ContactBankAccount",
        id?: string | null,
        accountName?: string | null,
        bankName?: string | null,
        accountNumber: string,
        routingNumber: string,
        holderType?: BankHolderType | null,
        accountType?: BankAccountType | null,
        country?: string | null,
      } | null,
      bpay?:  {
        __typename: "ContactBpay",
        billerCode?: number | null,
        referenceNumber?: string | null,
      } | null,
      invalidFields?: Array< string | null > | null,
      bulkUploadFileKey?: string | null,
      owner?: string | null,
      createdBy?: string | null,
      beneficiaryBankId?: string | null,
      beneficiaryBpayId?: string | null,
      address?:  {
        __typename: "Address",
        addressId?: string | null,
        contactName?: string | null,
        contactNumber?: string | null,
        fullAddress?: string | null,
        address1?: string | null,
        address2?: string | null,
        city?: string | null,
        country: string,
        countryCode: string,
        state: string,
        stateCode?: string | null,
        postalCode: string,
        invalid?: boolean | null,
      } | null,
      postal?:  {
        __typename: "Address",
        addressId?: string | null,
        contactName?: string | null,
        contactNumber?: string | null,
        fullAddress?: string | null,
        address1?: string | null,
        address2?: string | null,
        city?: string | null,
        country: string,
        countryCode: string,
        state: string,
        stateCode?: string | null,
        postalCode: string,
        invalid?: boolean | null,
      } | null,
      payoutErrors?: Array< string | null > | null,
    } | null,
  } | null,
};

export type ListBillersQueryVariables = {
  searchName: string,
};

export type ListBillersQuery = {
  listBillers?:  {
    __typename: "ModelBillerConnection",
    items:  Array< {
      __typename: "Biller",
      billerCode?: number | null,
      shortName?: string | null,
      longName?: string | null,
      type?: BillerType | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetContactQueryVariables = {
  id: string,
};

export type GetContactQuery = {
  getContact?:  {
    __typename: "Contact",
    id: string,
    entityId: string,
    xeroTenantId?: string | null,
    entityType?: EntityType | null,
    firstName?: string | null,
    lastName?: string | null,
    email?: string | null,
    mobile?: string | null,
    phone?: string | null,
    taxNumber?: string | null,
    companyNumber?: string | null,
    name?: string | null,
    legalName?: string | null,
    searchName?: string | null,
    status?: ContactStatus | null,
    website?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    contactType?: ContactType | null,
    bank?:  {
      __typename: "ContactBankAccount",
      id?: string | null,
      accountName?: string | null,
      bankName?: string | null,
      accountNumber: string,
      routingNumber: string,
      holderType?: BankHolderType | null,
      accountType?: BankAccountType | null,
      country?: string | null,
    } | null,
    bpay?:  {
      __typename: "ContactBpay",
      billerCode?: number | null,
      referenceNumber?: string | null,
    } | null,
    invalidFields?: Array< string | null > | null,
    bulkUploadFileKey?: string | null,
    owner?: string | null,
    createdBy?: string | null,
    beneficiaryBankId?: string | null,
    beneficiaryBpayId?: string | null,
    address?:  {
      __typename: "Address",
      addressId?: string | null,
      contactName?: string | null,
      contactNumber?: string | null,
      fullAddress?: string | null,
      address1?: string | null,
      address2?: string | null,
      city?: string | null,
      country: string,
      countryCode: string,
      state: string,
      stateCode?: string | null,
      postalCode: string,
      invalid?: boolean | null,
    } | null,
    postal?:  {
      __typename: "Address",
      addressId?: string | null,
      contactName?: string | null,
      contactNumber?: string | null,
      fullAddress?: string | null,
      address1?: string | null,
      address2?: string | null,
      city?: string | null,
      country: string,
      countryCode: string,
      state: string,
      stateCode?: string | null,
      postalCode: string,
      invalid?: boolean | null,
    } | null,
    payoutErrors?: Array< string | null > | null,
  } | null,
};

export type ContactsByEntityQueryVariables = {
  entityId: string,
  searchName?: string | null,
  sortDirection?: ModelSortDirection | null,
  from?: number | null,
};

export type ContactsByEntityQuery = {
  contactsByEntity?:  {
    __typename: "ModelContactConnection",
    items:  Array< {
      __typename: "Contact",
      id: string,
      entityId: string,
      xeroTenantId?: string | null,
      entityType?: EntityType | null,
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      mobile?: string | null,
      phone?: string | null,
      taxNumber?: string | null,
      companyNumber?: string | null,
      name?: string | null,
      legalName?: string | null,
      searchName?: string | null,
      status?: ContactStatus | null,
      website?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      contactType?: ContactType | null,
      bank?:  {
        __typename: "ContactBankAccount",
        id?: string | null,
        accountName?: string | null,
        bankName?: string | null,
        accountNumber: string,
        routingNumber: string,
        holderType?: BankHolderType | null,
        accountType?: BankAccountType | null,
        country?: string | null,
      } | null,
      bpay?:  {
        __typename: "ContactBpay",
        billerCode?: number | null,
        referenceNumber?: string | null,
      } | null,
      invalidFields?: Array< string | null > | null,
      bulkUploadFileKey?: string | null,
      owner?: string | null,
      createdBy?: string | null,
      beneficiaryBankId?: string | null,
      beneficiaryBpayId?: string | null,
      address?:  {
        __typename: "Address",
        addressId?: string | null,
        contactName?: string | null,
        contactNumber?: string | null,
        fullAddress?: string | null,
        address1?: string | null,
        address2?: string | null,
        city?: string | null,
        country: string,
        countryCode: string,
        state: string,
        stateCode?: string | null,
        postalCode: string,
        invalid?: boolean | null,
      } | null,
      postal?:  {
        __typename: "Address",
        addressId?: string | null,
        contactName?: string | null,
        contactNumber?: string | null,
        fullAddress?: string | null,
        address1?: string | null,
        address2?: string | null,
        city?: string | null,
        country: string,
        countryCode: string,
        state: string,
        stateCode?: string | null,
        postalCode: string,
        invalid?: boolean | null,
      } | null,
      payoutErrors?: Array< string | null > | null,
    } | null >,
    total?: number | null,
  } | null,
};

export type GetDocumentAnalysisQueryVariables = {
  id: string,
};

export type GetDocumentAnalysisQuery = {
  getDocumentAnalysis?:  {
    __typename: "DocumentAnalysis",
    id: string,
    entityId?: string | null,
    firmId?: string | null,
    fileKey?: string | null,
    documents?:  Array< {
      __typename: "S3Upload",
      identityId?: string | null,
      key: string,
      level: S3UploadLevel,
      type: S3UploadType,
      name?: string | null,
    } | null > | null,
    status: DocumentAnalysisStatus,
    expenseStatus?: DocumentAnalysisStatus | null,
    queryStatus?: DocumentAnalysisStatus | null,
    matchedBiller?:  {
      __typename: "BillerDetails",
      billerCode?: number | null,
      billerCategory?: string | null,
      shortName?: string | null,
      longName?: string | null,
      type?: BillerType | null,
      industryCode?: string | null,
      industryCodeDescription?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    matchedContactId?: string | null,
    matchedContact?:  {
      __typename: "Contact",
      id: string,
      entityId: string,
      xeroTenantId?: string | null,
      entityType?: EntityType | null,
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      mobile?: string | null,
      phone?: string | null,
      taxNumber?: string | null,
      companyNumber?: string | null,
      name?: string | null,
      legalName?: string | null,
      searchName?: string | null,
      status?: ContactStatus | null,
      website?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      contactType?: ContactType | null,
      bank?:  {
        __typename: "ContactBankAccount",
        id?: string | null,
        accountName?: string | null,
        bankName?: string | null,
        accountNumber: string,
        routingNumber: string,
        holderType?: BankHolderType | null,
        accountType?: BankAccountType | null,
        country?: string | null,
      } | null,
      bpay?:  {
        __typename: "ContactBpay",
        billerCode?: number | null,
        referenceNumber?: string | null,
      } | null,
      invalidFields?: Array< string | null > | null,
      bulkUploadFileKey?: string | null,
      owner?: string | null,
      createdBy?: string | null,
      beneficiaryBankId?: string | null,
      beneficiaryBpayId?: string | null,
      address?:  {
        __typename: "Address",
        addressId?: string | null,
        contactName?: string | null,
        contactNumber?: string | null,
        fullAddress?: string | null,
        address1?: string | null,
        address2?: string | null,
        city?: string | null,
        country: string,
        countryCode: string,
        state: string,
        stateCode?: string | null,
        postalCode: string,
        invalid?: boolean | null,
      } | null,
      postal?:  {
        __typename: "Address",
        addressId?: string | null,
        contactName?: string | null,
        contactNumber?: string | null,
        fullAddress?: string | null,
        address1?: string | null,
        address2?: string | null,
        city?: string | null,
        country: string,
        countryCode: string,
        state: string,
        stateCode?: string | null,
        postalCode: string,
        invalid?: boolean | null,
      } | null,
      payoutErrors?: Array< string | null > | null,
    } | null,
    matchedEntityId?: string | null,
    matchedEntity?:  {
      __typename: "Entity",
      id: string,
      type: EntityType,
      taxNumber?: string | null,
      companyNumber?: string | null,
      billerCode?: number | null,
      name: string,
      legalName?: string | null,
      businessNames?: Array< string | null > | null,
      searchName?: string | null,
      address?:  {
        __typename: "Address",
        addressId?: string | null,
        contactName?: string | null,
        contactNumber?: string | null,
        fullAddress?: string | null,
        address1?: string | null,
        address2?: string | null,
        city?: string | null,
        country: string,
        countryCode: string,
        state: string,
        stateCode?: string | null,
        postalCode: string,
        invalid?: boolean | null,
      } | null,
      logo?:  {
        __typename: "Image",
        alt?: string | null,
        identityId?: string | null,
        key: string,
        level: S3UploadLevel,
        type?: string | null,
      } | null,
      brandColour?: string | null,
      website?: string | null,
      entityUsers?:  {
        __typename: "ModelEntityUserConnection",
        items:  Array< {
          __typename: "EntityUser",
          id: string,
          entityId: string,
          userId: string,
          firmId?: string | null,
          email?: string | null,
          invitedEmail?: string | null,
          ocrEmail?: string | null,
          referredBy?: string | null,
          invitedEntityId?: string | null,
          firmEntityId?: string | null,
          providerContactId?: string | null,
          ownerCode?: string | null,
          clientGroupCode?: string | null,
          clientCode?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          role: EntityUserRole,
          jobTags?: Array< JobTags | null > | null,
          paymentsEnabled?: boolean | null,
          termsInvoiceAccepted?: boolean | null,
          termsOcrAccepted?: boolean | null,
          termsFirmPayTaxAccepted?: boolean | null,
          termsFirmPayTaxDetails?:  {
            __typename: "TermsFirmPayTaxDetails",
            document?:  {
              __typename: "S3Upload",
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type: S3UploadType,
              name?: string | null,
            } | null,
            acceptedAt?: string | null,
            email?: string | null,
            ip?: string | null,
            fullName?: string | null,
            firmId?: string | null,
          } | null,
          entitySearchName?: string | null,
          entity?:  {
            __typename: "Entity",
            id: string,
            type: EntityType,
            taxNumber?: string | null,
            companyNumber?: string | null,
            billerCode?: number | null,
            name: string,
            legalName?: string | null,
            businessNames?: Array< string | null > | null,
            searchName?: string | null,
            address?:  {
              __typename: "Address",
              addressId?: string | null,
              contactName?: string | null,
              contactNumber?: string | null,
              fullAddress?: string | null,
              address1?: string | null,
              address2?: string | null,
              city?: string | null,
              country: string,
              countryCode: string,
              state: string,
              stateCode?: string | null,
              postalCode: string,
              invalid?: boolean | null,
            } | null,
            logo?:  {
              __typename: "Image",
              alt?: string | null,
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type?: string | null,
            } | null,
            brandColour?: string | null,
            website?: string | null,
            entityUsers?:  {
              __typename: "ModelEntityUserConnection",
              items:  Array< {
                __typename: "EntityUser",
                id: string,
                entityId: string,
                userId: string,
                firmId?: string | null,
                email?: string | null,
                invitedEmail?: string | null,
                ocrEmail?: string | null,
                referredBy?: string | null,
                invitedEntityId?: string | null,
                firmEntityId?: string | null,
                providerContactId?: string | null,
                ownerCode?: string | null,
                clientGroupCode?: string | null,
                clientCode?: string | null,
                firstName?: string | null,
                lastName?: string | null,
                role: EntityUserRole,
                jobTags?: Array< JobTags | null > | null,
                paymentsEnabled?: boolean | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                termsFirmPayTaxAccepted?: boolean | null,
                entitySearchName?: string | null,
                searchName?: string | null,
                taxNumber?: string | null,
                taskSendSMS?: boolean | null,
                companyNumber?: string | null,
                createdBy?: string | null,
                createdAt: string,
                updatedAt: string,
                status?: EntityUserStatus | null,
                partnerId?: string | null,
                managerId?: string | null,
                archivedAt?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gstRegistered?: boolean | null,
            gstReportingPeriod?: GSTReportingPeriod | null,
            providerEntityId?: string | null,
            providerCompanyId?: string | null,
            providerBillUserCompanyId?: string | null,
            providerBankAccountId?: string | null,
            providerDigitalWalletId?: string | null,
            providerBpayCrn?: string | null,
            contact?:  {
              __typename: "EntityContact",
              firstName?: string | null,
              lastName?: string | null,
              email?: string | null,
              phone?: string | null,
              role?: string | null,
            } | null,
            paymentMethods?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            paymentMethodId?: string | null,
            paymentUserId?: string | null,
            disbursementMethodId?: string | null,
            receivingAccounts?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            ubosCreated?: boolean | null,
            numUbosCreated?: number | null,
            subCategory?: string | null,
            clientsStatus?: EntityClientsStatus | null,
            ocrEmail?: string | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            owner?: string | null,
            referredBy?: string | null,
            connectedAccount?: string | null,
            accountStatus?: AccountStatus | null,
            customerId?: string | null,
            xeroSyncStatus?: XeroSyncStatus | null,
            xeroLastContactSyncAt?: string | null,
            xeroContactSyncStatus?: XeroSyncStatus | null,
            xeroInvoiceSyncStatus?: XeroSyncStatus | null,
            xeroLastInvoiceSyncAt?: string | null,
            xeroTenantId?: string | null,
            absorbFees?: boolean | null,
            subscriptionTier?: SubscriptionTier | null,
            invitationStatus?: InvitationStatus | null,
            clientsOnboardingStatus?: ClientsOnboardingStatus | null,
            createdBy?: string | null,
            createdByEntityId?: string | null,
            isFirm?: boolean | null,
            createdAt?: string | null,
            updatedAt?: string | null,
          } | null,
          firm?:  {
            __typename: "Entity",
            id: string,
            type: EntityType,
            taxNumber?: string | null,
            companyNumber?: string | null,
            billerCode?: number | null,
            name: string,
            legalName?: string | null,
            businessNames?: Array< string | null > | null,
            searchName?: string | null,
            address?:  {
              __typename: "Address",
              addressId?: string | null,
              contactName?: string | null,
              contactNumber?: string | null,
              fullAddress?: string | null,
              address1?: string | null,
              address2?: string | null,
              city?: string | null,
              country: string,
              countryCode: string,
              state: string,
              stateCode?: string | null,
              postalCode: string,
              invalid?: boolean | null,
            } | null,
            logo?:  {
              __typename: "Image",
              alt?: string | null,
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type?: string | null,
            } | null,
            brandColour?: string | null,
            website?: string | null,
            entityUsers?:  {
              __typename: "ModelEntityUserConnection",
              items:  Array< {
                __typename: "EntityUser",
                id: string,
                entityId: string,
                userId: string,
                firmId?: string | null,
                email?: string | null,
                invitedEmail?: string | null,
                ocrEmail?: string | null,
                referredBy?: string | null,
                invitedEntityId?: string | null,
                firmEntityId?: string | null,
                providerContactId?: string | null,
                ownerCode?: string | null,
                clientGroupCode?: string | null,
                clientCode?: string | null,
                firstName?: string | null,
                lastName?: string | null,
                role: EntityUserRole,
                jobTags?: Array< JobTags | null > | null,
                paymentsEnabled?: boolean | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                termsFirmPayTaxAccepted?: boolean | null,
                entitySearchName?: string | null,
                searchName?: string | null,
                taxNumber?: string | null,
                taskSendSMS?: boolean | null,
                companyNumber?: string | null,
                createdBy?: string | null,
                createdAt: string,
                updatedAt: string,
                status?: EntityUserStatus | null,
                partnerId?: string | null,
                managerId?: string | null,
                archivedAt?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gstRegistered?: boolean | null,
            gstReportingPeriod?: GSTReportingPeriod | null,
            providerEntityId?: string | null,
            providerCompanyId?: string | null,
            providerBillUserCompanyId?: string | null,
            providerBankAccountId?: string | null,
            providerDigitalWalletId?: string | null,
            providerBpayCrn?: string | null,
            contact?:  {
              __typename: "EntityContact",
              firstName?: string | null,
              lastName?: string | null,
              email?: string | null,
              phone?: string | null,
              role?: string | null,
            } | null,
            paymentMethods?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            paymentMethodId?: string | null,
            paymentUserId?: string | null,
            disbursementMethodId?: string | null,
            receivingAccounts?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            ubosCreated?: boolean | null,
            numUbosCreated?: number | null,
            subCategory?: string | null,
            clientsStatus?: EntityClientsStatus | null,
            ocrEmail?: string | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            owner?: string | null,
            referredBy?: string | null,
            connectedAccount?: string | null,
            accountStatus?: AccountStatus | null,
            customerId?: string | null,
            xeroSyncStatus?: XeroSyncStatus | null,
            xeroLastContactSyncAt?: string | null,
            xeroContactSyncStatus?: XeroSyncStatus | null,
            xeroInvoiceSyncStatus?: XeroSyncStatus | null,
            xeroLastInvoiceSyncAt?: string | null,
            xeroTenantId?: string | null,
            absorbFees?: boolean | null,
            subscriptionTier?: SubscriptionTier | null,
            invitationStatus?: InvitationStatus | null,
            clientsOnboardingStatus?: ClientsOnboardingStatus | null,
            createdBy?: string | null,
            createdByEntityId?: string | null,
            isFirm?: boolean | null,
            createdAt?: string | null,
            updatedAt?: string | null,
          } | null,
          searchName?: string | null,
          taxNumber?: string | null,
          taskSendSMS?: boolean | null,
          companyNumber?: string | null,
          createdBy?: string | null,
          createdAt: string,
          updatedAt: string,
          status?: EntityUserStatus | null,
          partnerId?: string | null,
          managerId?: string | null,
          archivedAt?: string | null,
          taxPaymentReferences?:  {
            __typename: "TaxPaymentReferences",
            itr?:  {
              __typename: "TaxPaymentReference",
              referenceNumber?: string | null,
              updatedAt?: string | null,
            } | null,
            other?:  {
              __typename: "TaxPaymentReference",
              referenceNumber?: string | null,
              updatedAt?: string | null,
            } | null,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gstRegistered?: boolean | null,
      gstReportingPeriod?: GSTReportingPeriod | null,
      providerEntityId?: string | null,
      providerCompanyId?: string | null,
      providerBillUserCompanyId?: string | null,
      providerBankAccountId?: string | null,
      providerDigitalWalletId?: string | null,
      providerBpayCrn?: string | null,
      contact?:  {
        __typename: "EntityContact",
        firstName?: string | null,
        lastName?: string | null,
        email?: string | null,
        phone?: string | null,
        role?: string | null,
      } | null,
      paymentMethods?:  {
        __typename: "ModelPaymentMethodConnection",
        items:  Array< {
          __typename: "PaymentMethod",
          id: string,
          paymentMethodType: PaymentMethodType,
          type?: string | null,
          fullName?: string | null,
          number?: string | null,
          expMonth?: string | null,
          expYear?: string | null,
          accountName?: string | null,
          bankName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
          holderType?: BankHolderType | null,
          accountType?: BankAccountType | null,
          status?: PaymentMethodStatus | null,
          accountDirection?: AccountDirection | null,
          expiresAt?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          consentId?: string | null,
          consentStatus?: PaymentConsentStatus | null,
          card?: string | null,
          googlepay?: string | null,
          applepay?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      paymentMethodId?: string | null,
      paymentUserId?: string | null,
      disbursementMethodId?: string | null,
      receivingAccounts?:  {
        __typename: "ModelPaymentMethodConnection",
        items:  Array< {
          __typename: "PaymentMethod",
          id: string,
          paymentMethodType: PaymentMethodType,
          type?: string | null,
          fullName?: string | null,
          number?: string | null,
          expMonth?: string | null,
          expYear?: string | null,
          accountName?: string | null,
          bankName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
          holderType?: BankHolderType | null,
          accountType?: BankAccountType | null,
          status?: PaymentMethodStatus | null,
          accountDirection?: AccountDirection | null,
          expiresAt?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          consentId?: string | null,
          consentStatus?: PaymentConsentStatus | null,
          card?: string | null,
          googlepay?: string | null,
          applepay?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      ubosCreated?: boolean | null,
      numUbosCreated?: number | null,
      subCategory?: string | null,
      clientsStatus?: EntityClientsStatus | null,
      ocrEmail?: string | null,
      termsInvoiceAccepted?: boolean | null,
      termsOcrAccepted?: boolean | null,
      owner?: string | null,
      referredBy?: string | null,
      connectedAccount?: string | null,
      accountStatus?: AccountStatus | null,
      customerId?: string | null,
      xeroSyncStatus?: XeroSyncStatus | null,
      xeroLastContactSyncAt?: string | null,
      xeroContactSyncStatus?: XeroSyncStatus | null,
      xeroInvoiceSyncStatus?: XeroSyncStatus | null,
      xeroLastInvoiceSyncAt?: string | null,
      xeroTenantId?: string | null,
      absorbFees?: boolean | null,
      subscriptionTier?: SubscriptionTier | null,
      invitationStatus?: InvitationStatus | null,
      clientsOnboardingStatus?: ClientsOnboardingStatus | null,
      createdBy?: string | null,
      createdByEntityId?: string | null,
      isFirm?: boolean | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    newContact?:  {
      __typename: "DocumentAnalysisContact",
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      mobile?: string | null,
      phone?: string | null,
      name?: string | null,
      taxNumber?: string | null,
      address?:  {
        __typename: "Address",
        addressId?: string | null,
        contactName?: string | null,
        contactNumber?: string | null,
        fullAddress?: string | null,
        address1?: string | null,
        address2?: string | null,
        city?: string | null,
        country: string,
        countryCode: string,
        state: string,
        stateCode?: string | null,
        postalCode: string,
        invalid?: boolean | null,
      } | null,
    } | null,
    task?:  {
      __typename: "DocumentAnalysisTask",
      reference?: string | null,
      dueAt?: string | null,
      issuedAt?: string | null,
      lodgementAt?: string | null,
      paymentAt?: string | null,
      gstInclusive?: boolean | null,
      notes?: string | null,
      amount?: number | null,
      gstAmount?: number | null,
      taxAmount?: number | null,
      lineItems?:  Array< {
        __typename: "DocumentAnalysisLineItem",
        description?: string | null,
        quantity?: number | null,
        unitPrice?: number | null,
        price?: number | null,
        productCode?: string | null,
        taxType?: TaxType | null,
      } | null > | null,
      numberOfPayments?: number | null,
      paymentFrequency?: PaymentFrequency | null,
      shippingAmount?: number | null,
      settlementStatus?: TaskSettlementStatus | null,
      partnerId?: string | null,
      managerId?: string | null,
      documentType?: DocumentType | null,
      subCategory?: string | null,
      category?: TaskCategory | null,
      period?: string | null,
      year?: string | null,
    } | null,
    bpay?:  {
      __typename: "ContactBpay",
      billerCode?: number | null,
      referenceNumber?: string | null,
    } | null,
    bank?:  {
      __typename: "DocumentAnalysisBankAccount",
      accountNumber?: string | null,
      routingNumber?: string | null,
    } | null,
    category?: TaskCategory | null,
    source?: DocumentAnalysisSource | null,
    isCorrect?: boolean | null,
    fromEmail?: string | null,
    textContent?: string | null,
    createdBy?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type DocumentAnalysisByEntityStatusQueryVariables = {
  entityId: string,
  status?: DocumentAnalysisStatus | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type DocumentAnalysisByEntityStatusQuery = {
  documentAnalysisByEntityStatus?:  {
    __typename: "ModelDocumentAnalysisConnection",
    items:  Array< {
      __typename: "DocumentAnalysis",
      id: string,
      entityId?: string | null,
      firmId?: string | null,
      fileKey?: string | null,
      documents?:  Array< {
        __typename: "S3Upload",
        identityId?: string | null,
        key: string,
        level: S3UploadLevel,
        type: S3UploadType,
        name?: string | null,
      } | null > | null,
      status: DocumentAnalysisStatus,
      expenseStatus?: DocumentAnalysisStatus | null,
      queryStatus?: DocumentAnalysisStatus | null,
      matchedBiller?:  {
        __typename: "BillerDetails",
        billerCode?: number | null,
        billerCategory?: string | null,
        shortName?: string | null,
        longName?: string | null,
        type?: BillerType | null,
        industryCode?: string | null,
        industryCodeDescription?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      matchedContactId?: string | null,
      matchedContact?:  {
        __typename: "Contact",
        id: string,
        entityId: string,
        xeroTenantId?: string | null,
        entityType?: EntityType | null,
        firstName?: string | null,
        lastName?: string | null,
        email?: string | null,
        mobile?: string | null,
        phone?: string | null,
        taxNumber?: string | null,
        companyNumber?: string | null,
        name?: string | null,
        legalName?: string | null,
        searchName?: string | null,
        status?: ContactStatus | null,
        website?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        contactType?: ContactType | null,
        bank?:  {
          __typename: "ContactBankAccount",
          id?: string | null,
          accountName?: string | null,
          bankName?: string | null,
          accountNumber: string,
          routingNumber: string,
          holderType?: BankHolderType | null,
          accountType?: BankAccountType | null,
          country?: string | null,
        } | null,
        bpay?:  {
          __typename: "ContactBpay",
          billerCode?: number | null,
          referenceNumber?: string | null,
        } | null,
        invalidFields?: Array< string | null > | null,
        bulkUploadFileKey?: string | null,
        owner?: string | null,
        createdBy?: string | null,
        beneficiaryBankId?: string | null,
        beneficiaryBpayId?: string | null,
        address?:  {
          __typename: "Address",
          addressId?: string | null,
          contactName?: string | null,
          contactNumber?: string | null,
          fullAddress?: string | null,
          address1?: string | null,
          address2?: string | null,
          city?: string | null,
          country: string,
          countryCode: string,
          state: string,
          stateCode?: string | null,
          postalCode: string,
          invalid?: boolean | null,
        } | null,
        postal?:  {
          __typename: "Address",
          addressId?: string | null,
          contactName?: string | null,
          contactNumber?: string | null,
          fullAddress?: string | null,
          address1?: string | null,
          address2?: string | null,
          city?: string | null,
          country: string,
          countryCode: string,
          state: string,
          stateCode?: string | null,
          postalCode: string,
          invalid?: boolean | null,
        } | null,
        payoutErrors?: Array< string | null > | null,
      } | null,
      matchedEntityId?: string | null,
      matchedEntity?:  {
        __typename: "Entity",
        id: string,
        type: EntityType,
        taxNumber?: string | null,
        companyNumber?: string | null,
        billerCode?: number | null,
        name: string,
        legalName?: string | null,
        businessNames?: Array< string | null > | null,
        searchName?: string | null,
        address?:  {
          __typename: "Address",
          addressId?: string | null,
          contactName?: string | null,
          contactNumber?: string | null,
          fullAddress?: string | null,
          address1?: string | null,
          address2?: string | null,
          city?: string | null,
          country: string,
          countryCode: string,
          state: string,
          stateCode?: string | null,
          postalCode: string,
          invalid?: boolean | null,
        } | null,
        logo?:  {
          __typename: "Image",
          alt?: string | null,
          identityId?: string | null,
          key: string,
          level: S3UploadLevel,
          type?: string | null,
        } | null,
        brandColour?: string | null,
        website?: string | null,
        entityUsers?:  {
          __typename: "ModelEntityUserConnection",
          items:  Array< {
            __typename: "EntityUser",
            id: string,
            entityId: string,
            userId: string,
            firmId?: string | null,
            email?: string | null,
            invitedEmail?: string | null,
            ocrEmail?: string | null,
            referredBy?: string | null,
            invitedEntityId?: string | null,
            firmEntityId?: string | null,
            providerContactId?: string | null,
            ownerCode?: string | null,
            clientGroupCode?: string | null,
            clientCode?: string | null,
            firstName?: string | null,
            lastName?: string | null,
            role: EntityUserRole,
            jobTags?: Array< JobTags | null > | null,
            paymentsEnabled?: boolean | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            termsFirmPayTaxAccepted?: boolean | null,
            termsFirmPayTaxDetails?:  {
              __typename: "TermsFirmPayTaxDetails",
              document?:  {
                __typename: "S3Upload",
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type: S3UploadType,
                name?: string | null,
              } | null,
              acceptedAt?: string | null,
              email?: string | null,
              ip?: string | null,
              fullName?: string | null,
              firmId?: string | null,
            } | null,
            entitySearchName?: string | null,
            entity?:  {
              __typename: "Entity",
              id: string,
              type: EntityType,
              taxNumber?: string | null,
              companyNumber?: string | null,
              billerCode?: number | null,
              name: string,
              legalName?: string | null,
              businessNames?: Array< string | null > | null,
              searchName?: string | null,
              address?:  {
                __typename: "Address",
                addressId?: string | null,
                contactName?: string | null,
                contactNumber?: string | null,
                fullAddress?: string | null,
                address1?: string | null,
                address2?: string | null,
                city?: string | null,
                country: string,
                countryCode: string,
                state: string,
                stateCode?: string | null,
                postalCode: string,
                invalid?: boolean | null,
              } | null,
              logo?:  {
                __typename: "Image",
                alt?: string | null,
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type?: string | null,
              } | null,
              brandColour?: string | null,
              website?: string | null,
              entityUsers?:  {
                __typename: "ModelEntityUserConnection",
                nextToken?: string | null,
              } | null,
              gstRegistered?: boolean | null,
              gstReportingPeriod?: GSTReportingPeriod | null,
              providerEntityId?: string | null,
              providerCompanyId?: string | null,
              providerBillUserCompanyId?: string | null,
              providerBankAccountId?: string | null,
              providerDigitalWalletId?: string | null,
              providerBpayCrn?: string | null,
              contact?:  {
                __typename: "EntityContact",
                firstName?: string | null,
                lastName?: string | null,
                email?: string | null,
                phone?: string | null,
                role?: string | null,
              } | null,
              paymentMethods?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              paymentMethodId?: string | null,
              paymentUserId?: string | null,
              disbursementMethodId?: string | null,
              receivingAccounts?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              ubosCreated?: boolean | null,
              numUbosCreated?: number | null,
              subCategory?: string | null,
              clientsStatus?: EntityClientsStatus | null,
              ocrEmail?: string | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              owner?: string | null,
              referredBy?: string | null,
              connectedAccount?: string | null,
              accountStatus?: AccountStatus | null,
              customerId?: string | null,
              xeroSyncStatus?: XeroSyncStatus | null,
              xeroLastContactSyncAt?: string | null,
              xeroContactSyncStatus?: XeroSyncStatus | null,
              xeroInvoiceSyncStatus?: XeroSyncStatus | null,
              xeroLastInvoiceSyncAt?: string | null,
              xeroTenantId?: string | null,
              absorbFees?: boolean | null,
              subscriptionTier?: SubscriptionTier | null,
              invitationStatus?: InvitationStatus | null,
              clientsOnboardingStatus?: ClientsOnboardingStatus | null,
              createdBy?: string | null,
              createdByEntityId?: string | null,
              isFirm?: boolean | null,
              createdAt?: string | null,
              updatedAt?: string | null,
            } | null,
            firm?:  {
              __typename: "Entity",
              id: string,
              type: EntityType,
              taxNumber?: string | null,
              companyNumber?: string | null,
              billerCode?: number | null,
              name: string,
              legalName?: string | null,
              businessNames?: Array< string | null > | null,
              searchName?: string | null,
              address?:  {
                __typename: "Address",
                addressId?: string | null,
                contactName?: string | null,
                contactNumber?: string | null,
                fullAddress?: string | null,
                address1?: string | null,
                address2?: string | null,
                city?: string | null,
                country: string,
                countryCode: string,
                state: string,
                stateCode?: string | null,
                postalCode: string,
                invalid?: boolean | null,
              } | null,
              logo?:  {
                __typename: "Image",
                alt?: string | null,
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type?: string | null,
              } | null,
              brandColour?: string | null,
              website?: string | null,
              entityUsers?:  {
                __typename: "ModelEntityUserConnection",
                nextToken?: string | null,
              } | null,
              gstRegistered?: boolean | null,
              gstReportingPeriod?: GSTReportingPeriod | null,
              providerEntityId?: string | null,
              providerCompanyId?: string | null,
              providerBillUserCompanyId?: string | null,
              providerBankAccountId?: string | null,
              providerDigitalWalletId?: string | null,
              providerBpayCrn?: string | null,
              contact?:  {
                __typename: "EntityContact",
                firstName?: string | null,
                lastName?: string | null,
                email?: string | null,
                phone?: string | null,
                role?: string | null,
              } | null,
              paymentMethods?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              paymentMethodId?: string | null,
              paymentUserId?: string | null,
              disbursementMethodId?: string | null,
              receivingAccounts?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              ubosCreated?: boolean | null,
              numUbosCreated?: number | null,
              subCategory?: string | null,
              clientsStatus?: EntityClientsStatus | null,
              ocrEmail?: string | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              owner?: string | null,
              referredBy?: string | null,
              connectedAccount?: string | null,
              accountStatus?: AccountStatus | null,
              customerId?: string | null,
              xeroSyncStatus?: XeroSyncStatus | null,
              xeroLastContactSyncAt?: string | null,
              xeroContactSyncStatus?: XeroSyncStatus | null,
              xeroInvoiceSyncStatus?: XeroSyncStatus | null,
              xeroLastInvoiceSyncAt?: string | null,
              xeroTenantId?: string | null,
              absorbFees?: boolean | null,
              subscriptionTier?: SubscriptionTier | null,
              invitationStatus?: InvitationStatus | null,
              clientsOnboardingStatus?: ClientsOnboardingStatus | null,
              createdBy?: string | null,
              createdByEntityId?: string | null,
              isFirm?: boolean | null,
              createdAt?: string | null,
              updatedAt?: string | null,
            } | null,
            searchName?: string | null,
            taxNumber?: string | null,
            taskSendSMS?: boolean | null,
            companyNumber?: string | null,
            createdBy?: string | null,
            createdAt: string,
            updatedAt: string,
            status?: EntityUserStatus | null,
            partnerId?: string | null,
            managerId?: string | null,
            archivedAt?: string | null,
            taxPaymentReferences?:  {
              __typename: "TaxPaymentReferences",
              itr?:  {
                __typename: "TaxPaymentReference",
                referenceNumber?: string | null,
                updatedAt?: string | null,
              } | null,
              other?:  {
                __typename: "TaxPaymentReference",
                referenceNumber?: string | null,
                updatedAt?: string | null,
              } | null,
            } | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        gstRegistered?: boolean | null,
        gstReportingPeriod?: GSTReportingPeriod | null,
        providerEntityId?: string | null,
        providerCompanyId?: string | null,
        providerBillUserCompanyId?: string | null,
        providerBankAccountId?: string | null,
        providerDigitalWalletId?: string | null,
        providerBpayCrn?: string | null,
        contact?:  {
          __typename: "EntityContact",
          firstName?: string | null,
          lastName?: string | null,
          email?: string | null,
          phone?: string | null,
          role?: string | null,
        } | null,
        paymentMethods?:  {
          __typename: "ModelPaymentMethodConnection",
          items:  Array< {
            __typename: "PaymentMethod",
            id: string,
            paymentMethodType: PaymentMethodType,
            type?: string | null,
            fullName?: string | null,
            number?: string | null,
            expMonth?: string | null,
            expYear?: string | null,
            accountName?: string | null,
            bankName?: string | null,
            accountNumber?: string | null,
            routingNumber?: string | null,
            holderType?: BankHolderType | null,
            accountType?: BankAccountType | null,
            status?: PaymentMethodStatus | null,
            accountDirection?: AccountDirection | null,
            expiresAt?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            consentId?: string | null,
            consentStatus?: PaymentConsentStatus | null,
            card?: string | null,
            googlepay?: string | null,
            applepay?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        paymentMethodId?: string | null,
        paymentUserId?: string | null,
        disbursementMethodId?: string | null,
        receivingAccounts?:  {
          __typename: "ModelPaymentMethodConnection",
          items:  Array< {
            __typename: "PaymentMethod",
            id: string,
            paymentMethodType: PaymentMethodType,
            type?: string | null,
            fullName?: string | null,
            number?: string | null,
            expMonth?: string | null,
            expYear?: string | null,
            accountName?: string | null,
            bankName?: string | null,
            accountNumber?: string | null,
            routingNumber?: string | null,
            holderType?: BankHolderType | null,
            accountType?: BankAccountType | null,
            status?: PaymentMethodStatus | null,
            accountDirection?: AccountDirection | null,
            expiresAt?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            consentId?: string | null,
            consentStatus?: PaymentConsentStatus | null,
            card?: string | null,
            googlepay?: string | null,
            applepay?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        ubosCreated?: boolean | null,
        numUbosCreated?: number | null,
        subCategory?: string | null,
        clientsStatus?: EntityClientsStatus | null,
        ocrEmail?: string | null,
        termsInvoiceAccepted?: boolean | null,
        termsOcrAccepted?: boolean | null,
        owner?: string | null,
        referredBy?: string | null,
        connectedAccount?: string | null,
        accountStatus?: AccountStatus | null,
        customerId?: string | null,
        xeroSyncStatus?: XeroSyncStatus | null,
        xeroLastContactSyncAt?: string | null,
        xeroContactSyncStatus?: XeroSyncStatus | null,
        xeroInvoiceSyncStatus?: XeroSyncStatus | null,
        xeroLastInvoiceSyncAt?: string | null,
        xeroTenantId?: string | null,
        absorbFees?: boolean | null,
        subscriptionTier?: SubscriptionTier | null,
        invitationStatus?: InvitationStatus | null,
        clientsOnboardingStatus?: ClientsOnboardingStatus | null,
        createdBy?: string | null,
        createdByEntityId?: string | null,
        isFirm?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      newContact?:  {
        __typename: "DocumentAnalysisContact",
        firstName?: string | null,
        lastName?: string | null,
        email?: string | null,
        mobile?: string | null,
        phone?: string | null,
        name?: string | null,
        taxNumber?: string | null,
        address?:  {
          __typename: "Address",
          addressId?: string | null,
          contactName?: string | null,
          contactNumber?: string | null,
          fullAddress?: string | null,
          address1?: string | null,
          address2?: string | null,
          city?: string | null,
          country: string,
          countryCode: string,
          state: string,
          stateCode?: string | null,
          postalCode: string,
          invalid?: boolean | null,
        } | null,
      } | null,
      task?:  {
        __typename: "DocumentAnalysisTask",
        reference?: string | null,
        dueAt?: string | null,
        issuedAt?: string | null,
        lodgementAt?: string | null,
        paymentAt?: string | null,
        gstInclusive?: boolean | null,
        notes?: string | null,
        amount?: number | null,
        gstAmount?: number | null,
        taxAmount?: number | null,
        lineItems?:  Array< {
          __typename: "DocumentAnalysisLineItem",
          description?: string | null,
          quantity?: number | null,
          unitPrice?: number | null,
          price?: number | null,
          productCode?: string | null,
          taxType?: TaxType | null,
        } | null > | null,
        numberOfPayments?: number | null,
        paymentFrequency?: PaymentFrequency | null,
        shippingAmount?: number | null,
        settlementStatus?: TaskSettlementStatus | null,
        partnerId?: string | null,
        managerId?: string | null,
        documentType?: DocumentType | null,
        subCategory?: string | null,
        category?: TaskCategory | null,
        period?: string | null,
        year?: string | null,
      } | null,
      bpay?:  {
        __typename: "ContactBpay",
        billerCode?: number | null,
        referenceNumber?: string | null,
      } | null,
      bank?:  {
        __typename: "DocumentAnalysisBankAccount",
        accountNumber?: string | null,
        routingNumber?: string | null,
      } | null,
      category?: TaskCategory | null,
      source?: DocumentAnalysisSource | null,
      isCorrect?: boolean | null,
      fromEmail?: string | null,
      textContent?: string | null,
      createdBy?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type DocumentAnalysisByFirmStatusQueryVariables = {
  firmId: string,
  status?: DocumentAnalysisStatus | null,
  createdBy?: string | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type DocumentAnalysisByFirmStatusQuery = {
  documentAnalysisByFirmStatus?:  {
    __typename: "ModelDocumentAnalysisConnection",
    items:  Array< {
      __typename: "DocumentAnalysis",
      id: string,
      entityId?: string | null,
      firmId?: string | null,
      fileKey?: string | null,
      documents?:  Array< {
        __typename: "S3Upload",
        identityId?: string | null,
        key: string,
        level: S3UploadLevel,
        type: S3UploadType,
        name?: string | null,
      } | null > | null,
      status: DocumentAnalysisStatus,
      expenseStatus?: DocumentAnalysisStatus | null,
      queryStatus?: DocumentAnalysisStatus | null,
      matchedBiller?:  {
        __typename: "BillerDetails",
        billerCode?: number | null,
        billerCategory?: string | null,
        shortName?: string | null,
        longName?: string | null,
        type?: BillerType | null,
        industryCode?: string | null,
        industryCodeDescription?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      matchedContactId?: string | null,
      matchedContact?:  {
        __typename: "Contact",
        id: string,
        entityId: string,
        xeroTenantId?: string | null,
        entityType?: EntityType | null,
        firstName?: string | null,
        lastName?: string | null,
        email?: string | null,
        mobile?: string | null,
        phone?: string | null,
        taxNumber?: string | null,
        companyNumber?: string | null,
        name?: string | null,
        legalName?: string | null,
        searchName?: string | null,
        status?: ContactStatus | null,
        website?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        contactType?: ContactType | null,
        bank?:  {
          __typename: "ContactBankAccount",
          id?: string | null,
          accountName?: string | null,
          bankName?: string | null,
          accountNumber: string,
          routingNumber: string,
          holderType?: BankHolderType | null,
          accountType?: BankAccountType | null,
          country?: string | null,
        } | null,
        bpay?:  {
          __typename: "ContactBpay",
          billerCode?: number | null,
          referenceNumber?: string | null,
        } | null,
        invalidFields?: Array< string | null > | null,
        bulkUploadFileKey?: string | null,
        owner?: string | null,
        createdBy?: string | null,
        beneficiaryBankId?: string | null,
        beneficiaryBpayId?: string | null,
        address?:  {
          __typename: "Address",
          addressId?: string | null,
          contactName?: string | null,
          contactNumber?: string | null,
          fullAddress?: string | null,
          address1?: string | null,
          address2?: string | null,
          city?: string | null,
          country: string,
          countryCode: string,
          state: string,
          stateCode?: string | null,
          postalCode: string,
          invalid?: boolean | null,
        } | null,
        postal?:  {
          __typename: "Address",
          addressId?: string | null,
          contactName?: string | null,
          contactNumber?: string | null,
          fullAddress?: string | null,
          address1?: string | null,
          address2?: string | null,
          city?: string | null,
          country: string,
          countryCode: string,
          state: string,
          stateCode?: string | null,
          postalCode: string,
          invalid?: boolean | null,
        } | null,
        payoutErrors?: Array< string | null > | null,
      } | null,
      matchedEntityId?: string | null,
      matchedEntity?:  {
        __typename: "Entity",
        id: string,
        type: EntityType,
        taxNumber?: string | null,
        companyNumber?: string | null,
        billerCode?: number | null,
        name: string,
        legalName?: string | null,
        businessNames?: Array< string | null > | null,
        searchName?: string | null,
        address?:  {
          __typename: "Address",
          addressId?: string | null,
          contactName?: string | null,
          contactNumber?: string | null,
          fullAddress?: string | null,
          address1?: string | null,
          address2?: string | null,
          city?: string | null,
          country: string,
          countryCode: string,
          state: string,
          stateCode?: string | null,
          postalCode: string,
          invalid?: boolean | null,
        } | null,
        logo?:  {
          __typename: "Image",
          alt?: string | null,
          identityId?: string | null,
          key: string,
          level: S3UploadLevel,
          type?: string | null,
        } | null,
        brandColour?: string | null,
        website?: string | null,
        entityUsers?:  {
          __typename: "ModelEntityUserConnection",
          items:  Array< {
            __typename: "EntityUser",
            id: string,
            entityId: string,
            userId: string,
            firmId?: string | null,
            email?: string | null,
            invitedEmail?: string | null,
            ocrEmail?: string | null,
            referredBy?: string | null,
            invitedEntityId?: string | null,
            firmEntityId?: string | null,
            providerContactId?: string | null,
            ownerCode?: string | null,
            clientGroupCode?: string | null,
            clientCode?: string | null,
            firstName?: string | null,
            lastName?: string | null,
            role: EntityUserRole,
            jobTags?: Array< JobTags | null > | null,
            paymentsEnabled?: boolean | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            termsFirmPayTaxAccepted?: boolean | null,
            termsFirmPayTaxDetails?:  {
              __typename: "TermsFirmPayTaxDetails",
              document?:  {
                __typename: "S3Upload",
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type: S3UploadType,
                name?: string | null,
              } | null,
              acceptedAt?: string | null,
              email?: string | null,
              ip?: string | null,
              fullName?: string | null,
              firmId?: string | null,
            } | null,
            entitySearchName?: string | null,
            entity?:  {
              __typename: "Entity",
              id: string,
              type: EntityType,
              taxNumber?: string | null,
              companyNumber?: string | null,
              billerCode?: number | null,
              name: string,
              legalName?: string | null,
              businessNames?: Array< string | null > | null,
              searchName?: string | null,
              address?:  {
                __typename: "Address",
                addressId?: string | null,
                contactName?: string | null,
                contactNumber?: string | null,
                fullAddress?: string | null,
                address1?: string | null,
                address2?: string | null,
                city?: string | null,
                country: string,
                countryCode: string,
                state: string,
                stateCode?: string | null,
                postalCode: string,
                invalid?: boolean | null,
              } | null,
              logo?:  {
                __typename: "Image",
                alt?: string | null,
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type?: string | null,
              } | null,
              brandColour?: string | null,
              website?: string | null,
              entityUsers?:  {
                __typename: "ModelEntityUserConnection",
                nextToken?: string | null,
              } | null,
              gstRegistered?: boolean | null,
              gstReportingPeriod?: GSTReportingPeriod | null,
              providerEntityId?: string | null,
              providerCompanyId?: string | null,
              providerBillUserCompanyId?: string | null,
              providerBankAccountId?: string | null,
              providerDigitalWalletId?: string | null,
              providerBpayCrn?: string | null,
              contact?:  {
                __typename: "EntityContact",
                firstName?: string | null,
                lastName?: string | null,
                email?: string | null,
                phone?: string | null,
                role?: string | null,
              } | null,
              paymentMethods?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              paymentMethodId?: string | null,
              paymentUserId?: string | null,
              disbursementMethodId?: string | null,
              receivingAccounts?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              ubosCreated?: boolean | null,
              numUbosCreated?: number | null,
              subCategory?: string | null,
              clientsStatus?: EntityClientsStatus | null,
              ocrEmail?: string | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              owner?: string | null,
              referredBy?: string | null,
              connectedAccount?: string | null,
              accountStatus?: AccountStatus | null,
              customerId?: string | null,
              xeroSyncStatus?: XeroSyncStatus | null,
              xeroLastContactSyncAt?: string | null,
              xeroContactSyncStatus?: XeroSyncStatus | null,
              xeroInvoiceSyncStatus?: XeroSyncStatus | null,
              xeroLastInvoiceSyncAt?: string | null,
              xeroTenantId?: string | null,
              absorbFees?: boolean | null,
              subscriptionTier?: SubscriptionTier | null,
              invitationStatus?: InvitationStatus | null,
              clientsOnboardingStatus?: ClientsOnboardingStatus | null,
              createdBy?: string | null,
              createdByEntityId?: string | null,
              isFirm?: boolean | null,
              createdAt?: string | null,
              updatedAt?: string | null,
            } | null,
            firm?:  {
              __typename: "Entity",
              id: string,
              type: EntityType,
              taxNumber?: string | null,
              companyNumber?: string | null,
              billerCode?: number | null,
              name: string,
              legalName?: string | null,
              businessNames?: Array< string | null > | null,
              searchName?: string | null,
              address?:  {
                __typename: "Address",
                addressId?: string | null,
                contactName?: string | null,
                contactNumber?: string | null,
                fullAddress?: string | null,
                address1?: string | null,
                address2?: string | null,
                city?: string | null,
                country: string,
                countryCode: string,
                state: string,
                stateCode?: string | null,
                postalCode: string,
                invalid?: boolean | null,
              } | null,
              logo?:  {
                __typename: "Image",
                alt?: string | null,
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type?: string | null,
              } | null,
              brandColour?: string | null,
              website?: string | null,
              entityUsers?:  {
                __typename: "ModelEntityUserConnection",
                nextToken?: string | null,
              } | null,
              gstRegistered?: boolean | null,
              gstReportingPeriod?: GSTReportingPeriod | null,
              providerEntityId?: string | null,
              providerCompanyId?: string | null,
              providerBillUserCompanyId?: string | null,
              providerBankAccountId?: string | null,
              providerDigitalWalletId?: string | null,
              providerBpayCrn?: string | null,
              contact?:  {
                __typename: "EntityContact",
                firstName?: string | null,
                lastName?: string | null,
                email?: string | null,
                phone?: string | null,
                role?: string | null,
              } | null,
              paymentMethods?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              paymentMethodId?: string | null,
              paymentUserId?: string | null,
              disbursementMethodId?: string | null,
              receivingAccounts?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              ubosCreated?: boolean | null,
              numUbosCreated?: number | null,
              subCategory?: string | null,
              clientsStatus?: EntityClientsStatus | null,
              ocrEmail?: string | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              owner?: string | null,
              referredBy?: string | null,
              connectedAccount?: string | null,
              accountStatus?: AccountStatus | null,
              customerId?: string | null,
              xeroSyncStatus?: XeroSyncStatus | null,
              xeroLastContactSyncAt?: string | null,
              xeroContactSyncStatus?: XeroSyncStatus | null,
              xeroInvoiceSyncStatus?: XeroSyncStatus | null,
              xeroLastInvoiceSyncAt?: string | null,
              xeroTenantId?: string | null,
              absorbFees?: boolean | null,
              subscriptionTier?: SubscriptionTier | null,
              invitationStatus?: InvitationStatus | null,
              clientsOnboardingStatus?: ClientsOnboardingStatus | null,
              createdBy?: string | null,
              createdByEntityId?: string | null,
              isFirm?: boolean | null,
              createdAt?: string | null,
              updatedAt?: string | null,
            } | null,
            searchName?: string | null,
            taxNumber?: string | null,
            taskSendSMS?: boolean | null,
            companyNumber?: string | null,
            createdBy?: string | null,
            createdAt: string,
            updatedAt: string,
            status?: EntityUserStatus | null,
            partnerId?: string | null,
            managerId?: string | null,
            archivedAt?: string | null,
            taxPaymentReferences?:  {
              __typename: "TaxPaymentReferences",
              itr?:  {
                __typename: "TaxPaymentReference",
                referenceNumber?: string | null,
                updatedAt?: string | null,
              } | null,
              other?:  {
                __typename: "TaxPaymentReference",
                referenceNumber?: string | null,
                updatedAt?: string | null,
              } | null,
            } | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        gstRegistered?: boolean | null,
        gstReportingPeriod?: GSTReportingPeriod | null,
        providerEntityId?: string | null,
        providerCompanyId?: string | null,
        providerBillUserCompanyId?: string | null,
        providerBankAccountId?: string | null,
        providerDigitalWalletId?: string | null,
        providerBpayCrn?: string | null,
        contact?:  {
          __typename: "EntityContact",
          firstName?: string | null,
          lastName?: string | null,
          email?: string | null,
          phone?: string | null,
          role?: string | null,
        } | null,
        paymentMethods?:  {
          __typename: "ModelPaymentMethodConnection",
          items:  Array< {
            __typename: "PaymentMethod",
            id: string,
            paymentMethodType: PaymentMethodType,
            type?: string | null,
            fullName?: string | null,
            number?: string | null,
            expMonth?: string | null,
            expYear?: string | null,
            accountName?: string | null,
            bankName?: string | null,
            accountNumber?: string | null,
            routingNumber?: string | null,
            holderType?: BankHolderType | null,
            accountType?: BankAccountType | null,
            status?: PaymentMethodStatus | null,
            accountDirection?: AccountDirection | null,
            expiresAt?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            consentId?: string | null,
            consentStatus?: PaymentConsentStatus | null,
            card?: string | null,
            googlepay?: string | null,
            applepay?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        paymentMethodId?: string | null,
        paymentUserId?: string | null,
        disbursementMethodId?: string | null,
        receivingAccounts?:  {
          __typename: "ModelPaymentMethodConnection",
          items:  Array< {
            __typename: "PaymentMethod",
            id: string,
            paymentMethodType: PaymentMethodType,
            type?: string | null,
            fullName?: string | null,
            number?: string | null,
            expMonth?: string | null,
            expYear?: string | null,
            accountName?: string | null,
            bankName?: string | null,
            accountNumber?: string | null,
            routingNumber?: string | null,
            holderType?: BankHolderType | null,
            accountType?: BankAccountType | null,
            status?: PaymentMethodStatus | null,
            accountDirection?: AccountDirection | null,
            expiresAt?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            consentId?: string | null,
            consentStatus?: PaymentConsentStatus | null,
            card?: string | null,
            googlepay?: string | null,
            applepay?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        ubosCreated?: boolean | null,
        numUbosCreated?: number | null,
        subCategory?: string | null,
        clientsStatus?: EntityClientsStatus | null,
        ocrEmail?: string | null,
        termsInvoiceAccepted?: boolean | null,
        termsOcrAccepted?: boolean | null,
        owner?: string | null,
        referredBy?: string | null,
        connectedAccount?: string | null,
        accountStatus?: AccountStatus | null,
        customerId?: string | null,
        xeroSyncStatus?: XeroSyncStatus | null,
        xeroLastContactSyncAt?: string | null,
        xeroContactSyncStatus?: XeroSyncStatus | null,
        xeroInvoiceSyncStatus?: XeroSyncStatus | null,
        xeroLastInvoiceSyncAt?: string | null,
        xeroTenantId?: string | null,
        absorbFees?: boolean | null,
        subscriptionTier?: SubscriptionTier | null,
        invitationStatus?: InvitationStatus | null,
        clientsOnboardingStatus?: ClientsOnboardingStatus | null,
        createdBy?: string | null,
        createdByEntityId?: string | null,
        isFirm?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      newContact?:  {
        __typename: "DocumentAnalysisContact",
        firstName?: string | null,
        lastName?: string | null,
        email?: string | null,
        mobile?: string | null,
        phone?: string | null,
        name?: string | null,
        taxNumber?: string | null,
        address?:  {
          __typename: "Address",
          addressId?: string | null,
          contactName?: string | null,
          contactNumber?: string | null,
          fullAddress?: string | null,
          address1?: string | null,
          address2?: string | null,
          city?: string | null,
          country: string,
          countryCode: string,
          state: string,
          stateCode?: string | null,
          postalCode: string,
          invalid?: boolean | null,
        } | null,
      } | null,
      task?:  {
        __typename: "DocumentAnalysisTask",
        reference?: string | null,
        dueAt?: string | null,
        issuedAt?: string | null,
        lodgementAt?: string | null,
        paymentAt?: string | null,
        gstInclusive?: boolean | null,
        notes?: string | null,
        amount?: number | null,
        gstAmount?: number | null,
        taxAmount?: number | null,
        lineItems?:  Array< {
          __typename: "DocumentAnalysisLineItem",
          description?: string | null,
          quantity?: number | null,
          unitPrice?: number | null,
          price?: number | null,
          productCode?: string | null,
          taxType?: TaxType | null,
        } | null > | null,
        numberOfPayments?: number | null,
        paymentFrequency?: PaymentFrequency | null,
        shippingAmount?: number | null,
        settlementStatus?: TaskSettlementStatus | null,
        partnerId?: string | null,
        managerId?: string | null,
        documentType?: DocumentType | null,
        subCategory?: string | null,
        category?: TaskCategory | null,
        period?: string | null,
        year?: string | null,
      } | null,
      bpay?:  {
        __typename: "ContactBpay",
        billerCode?: number | null,
        referenceNumber?: string | null,
      } | null,
      bank?:  {
        __typename: "DocumentAnalysisBankAccount",
        accountNumber?: string | null,
        routingNumber?: string | null,
      } | null,
      category?: TaskCategory | null,
      source?: DocumentAnalysisSource | null,
      isCorrect?: boolean | null,
      fromEmail?: string | null,
      textContent?: string | null,
      createdBy?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetEntityQueryVariables = {
  id: string,
};

export type GetEntityQuery = {
  getEntity?:  {
    __typename: "Entity",
    id: string,
    type: EntityType,
    taxNumber?: string | null,
    companyNumber?: string | null,
    billerCode?: number | null,
    name: string,
    legalName?: string | null,
    businessNames?: Array< string | null > | null,
    searchName?: string | null,
    address?:  {
      __typename: "Address",
      addressId?: string | null,
      contactName?: string | null,
      contactNumber?: string | null,
      fullAddress?: string | null,
      address1?: string | null,
      address2?: string | null,
      city?: string | null,
      country: string,
      countryCode: string,
      state: string,
      stateCode?: string | null,
      postalCode: string,
      invalid?: boolean | null,
    } | null,
    logo?:  {
      __typename: "Image",
      alt?: string | null,
      identityId?: string | null,
      key: string,
      level: S3UploadLevel,
      type?: string | null,
    } | null,
    brandColour?: string | null,
    website?: string | null,
    entityUsers?:  {
      __typename: "ModelEntityUserConnection",
      items:  Array< {
        __typename: "EntityUser",
        id: string,
        entityId: string,
        userId: string,
        firmId?: string | null,
        email?: string | null,
        invitedEmail?: string | null,
        ocrEmail?: string | null,
        referredBy?: string | null,
        invitedEntityId?: string | null,
        firmEntityId?: string | null,
        providerContactId?: string | null,
        ownerCode?: string | null,
        clientGroupCode?: string | null,
        clientCode?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        role: EntityUserRole,
        jobTags?: Array< JobTags | null > | null,
        paymentsEnabled?: boolean | null,
        termsInvoiceAccepted?: boolean | null,
        termsOcrAccepted?: boolean | null,
        termsFirmPayTaxAccepted?: boolean | null,
        termsFirmPayTaxDetails?:  {
          __typename: "TermsFirmPayTaxDetails",
          document?:  {
            __typename: "S3Upload",
            identityId?: string | null,
            key: string,
            level: S3UploadLevel,
            type: S3UploadType,
            name?: string | null,
          } | null,
          acceptedAt?: string | null,
          email?: string | null,
          ip?: string | null,
          fullName?: string | null,
          firmId?: string | null,
        } | null,
        entitySearchName?: string | null,
        entity?:  {
          __typename: "Entity",
          id: string,
          type: EntityType,
          taxNumber?: string | null,
          companyNumber?: string | null,
          billerCode?: number | null,
          name: string,
          legalName?: string | null,
          businessNames?: Array< string | null > | null,
          searchName?: string | null,
          address?:  {
            __typename: "Address",
            addressId?: string | null,
            contactName?: string | null,
            contactNumber?: string | null,
            fullAddress?: string | null,
            address1?: string | null,
            address2?: string | null,
            city?: string | null,
            country: string,
            countryCode: string,
            state: string,
            stateCode?: string | null,
            postalCode: string,
            invalid?: boolean | null,
          } | null,
          logo?:  {
            __typename: "Image",
            alt?: string | null,
            identityId?: string | null,
            key: string,
            level: S3UploadLevel,
            type?: string | null,
          } | null,
          brandColour?: string | null,
          website?: string | null,
          entityUsers?:  {
            __typename: "ModelEntityUserConnection",
            items:  Array< {
              __typename: "EntityUser",
              id: string,
              entityId: string,
              userId: string,
              firmId?: string | null,
              email?: string | null,
              invitedEmail?: string | null,
              ocrEmail?: string | null,
              referredBy?: string | null,
              invitedEntityId?: string | null,
              firmEntityId?: string | null,
              providerContactId?: string | null,
              ownerCode?: string | null,
              clientGroupCode?: string | null,
              clientCode?: string | null,
              firstName?: string | null,
              lastName?: string | null,
              role: EntityUserRole,
              jobTags?: Array< JobTags | null > | null,
              paymentsEnabled?: boolean | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              termsFirmPayTaxAccepted?: boolean | null,
              termsFirmPayTaxDetails?:  {
                __typename: "TermsFirmPayTaxDetails",
                acceptedAt?: string | null,
                email?: string | null,
                ip?: string | null,
                fullName?: string | null,
                firmId?: string | null,
              } | null,
              entitySearchName?: string | null,
              entity?:  {
                __typename: "Entity",
                id: string,
                type: EntityType,
                taxNumber?: string | null,
                companyNumber?: string | null,
                billerCode?: number | null,
                name: string,
                legalName?: string | null,
                businessNames?: Array< string | null > | null,
                searchName?: string | null,
                brandColour?: string | null,
                website?: string | null,
                gstRegistered?: boolean | null,
                gstReportingPeriod?: GSTReportingPeriod | null,
                providerEntityId?: string | null,
                providerCompanyId?: string | null,
                providerBillUserCompanyId?: string | null,
                providerBankAccountId?: string | null,
                providerDigitalWalletId?: string | null,
                providerBpayCrn?: string | null,
                paymentMethodId?: string | null,
                paymentUserId?: string | null,
                disbursementMethodId?: string | null,
                ubosCreated?: boolean | null,
                numUbosCreated?: number | null,
                subCategory?: string | null,
                clientsStatus?: EntityClientsStatus | null,
                ocrEmail?: string | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                owner?: string | null,
                referredBy?: string | null,
                connectedAccount?: string | null,
                accountStatus?: AccountStatus | null,
                customerId?: string | null,
                xeroSyncStatus?: XeroSyncStatus | null,
                xeroLastContactSyncAt?: string | null,
                xeroContactSyncStatus?: XeroSyncStatus | null,
                xeroInvoiceSyncStatus?: XeroSyncStatus | null,
                xeroLastInvoiceSyncAt?: string | null,
                xeroTenantId?: string | null,
                absorbFees?: boolean | null,
                subscriptionTier?: SubscriptionTier | null,
                invitationStatus?: InvitationStatus | null,
                clientsOnboardingStatus?: ClientsOnboardingStatus | null,
                createdBy?: string | null,
                createdByEntityId?: string | null,
                isFirm?: boolean | null,
                createdAt?: string | null,
                updatedAt?: string | null,
              } | null,
              firm?:  {
                __typename: "Entity",
                id: string,
                type: EntityType,
                taxNumber?: string | null,
                companyNumber?: string | null,
                billerCode?: number | null,
                name: string,
                legalName?: string | null,
                businessNames?: Array< string | null > | null,
                searchName?: string | null,
                brandColour?: string | null,
                website?: string | null,
                gstRegistered?: boolean | null,
                gstReportingPeriod?: GSTReportingPeriod | null,
                providerEntityId?: string | null,
                providerCompanyId?: string | null,
                providerBillUserCompanyId?: string | null,
                providerBankAccountId?: string | null,
                providerDigitalWalletId?: string | null,
                providerBpayCrn?: string | null,
                paymentMethodId?: string | null,
                paymentUserId?: string | null,
                disbursementMethodId?: string | null,
                ubosCreated?: boolean | null,
                numUbosCreated?: number | null,
                subCategory?: string | null,
                clientsStatus?: EntityClientsStatus | null,
                ocrEmail?: string | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                owner?: string | null,
                referredBy?: string | null,
                connectedAccount?: string | null,
                accountStatus?: AccountStatus | null,
                customerId?: string | null,
                xeroSyncStatus?: XeroSyncStatus | null,
                xeroLastContactSyncAt?: string | null,
                xeroContactSyncStatus?: XeroSyncStatus | null,
                xeroInvoiceSyncStatus?: XeroSyncStatus | null,
                xeroLastInvoiceSyncAt?: string | null,
                xeroTenantId?: string | null,
                absorbFees?: boolean | null,
                subscriptionTier?: SubscriptionTier | null,
                invitationStatus?: InvitationStatus | null,
                clientsOnboardingStatus?: ClientsOnboardingStatus | null,
                createdBy?: string | null,
                createdByEntityId?: string | null,
                isFirm?: boolean | null,
                createdAt?: string | null,
                updatedAt?: string | null,
              } | null,
              searchName?: string | null,
              taxNumber?: string | null,
              taskSendSMS?: boolean | null,
              companyNumber?: string | null,
              createdBy?: string | null,
              createdAt: string,
              updatedAt: string,
              status?: EntityUserStatus | null,
              partnerId?: string | null,
              managerId?: string | null,
              archivedAt?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gstRegistered?: boolean | null,
          gstReportingPeriod?: GSTReportingPeriod | null,
          providerEntityId?: string | null,
          providerCompanyId?: string | null,
          providerBillUserCompanyId?: string | null,
          providerBankAccountId?: string | null,
          providerDigitalWalletId?: string | null,
          providerBpayCrn?: string | null,
          contact?:  {
            __typename: "EntityContact",
            firstName?: string | null,
            lastName?: string | null,
            email?: string | null,
            phone?: string | null,
            role?: string | null,
          } | null,
          paymentMethods?:  {
            __typename: "ModelPaymentMethodConnection",
            items:  Array< {
              __typename: "PaymentMethod",
              id: string,
              paymentMethodType: PaymentMethodType,
              type?: string | null,
              fullName?: string | null,
              number?: string | null,
              expMonth?: string | null,
              expYear?: string | null,
              accountName?: string | null,
              bankName?: string | null,
              accountNumber?: string | null,
              routingNumber?: string | null,
              holderType?: BankHolderType | null,
              accountType?: BankAccountType | null,
              status?: PaymentMethodStatus | null,
              accountDirection?: AccountDirection | null,
              expiresAt?: string | null,
              createdAt?: string | null,
              updatedAt?: string | null,
              consentId?: string | null,
              consentStatus?: PaymentConsentStatus | null,
              card?: string | null,
              googlepay?: string | null,
              applepay?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          paymentMethodId?: string | null,
          paymentUserId?: string | null,
          disbursementMethodId?: string | null,
          receivingAccounts?:  {
            __typename: "ModelPaymentMethodConnection",
            items:  Array< {
              __typename: "PaymentMethod",
              id: string,
              paymentMethodType: PaymentMethodType,
              type?: string | null,
              fullName?: string | null,
              number?: string | null,
              expMonth?: string | null,
              expYear?: string | null,
              accountName?: string | null,
              bankName?: string | null,
              accountNumber?: string | null,
              routingNumber?: string | null,
              holderType?: BankHolderType | null,
              accountType?: BankAccountType | null,
              status?: PaymentMethodStatus | null,
              accountDirection?: AccountDirection | null,
              expiresAt?: string | null,
              createdAt?: string | null,
              updatedAt?: string | null,
              consentId?: string | null,
              consentStatus?: PaymentConsentStatus | null,
              card?: string | null,
              googlepay?: string | null,
              applepay?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          ubosCreated?: boolean | null,
          numUbosCreated?: number | null,
          subCategory?: string | null,
          clientsStatus?: EntityClientsStatus | null,
          ocrEmail?: string | null,
          termsInvoiceAccepted?: boolean | null,
          termsOcrAccepted?: boolean | null,
          owner?: string | null,
          referredBy?: string | null,
          connectedAccount?: string | null,
          accountStatus?: AccountStatus | null,
          customerId?: string | null,
          xeroSyncStatus?: XeroSyncStatus | null,
          xeroLastContactSyncAt?: string | null,
          xeroContactSyncStatus?: XeroSyncStatus | null,
          xeroInvoiceSyncStatus?: XeroSyncStatus | null,
          xeroLastInvoiceSyncAt?: string | null,
          xeroTenantId?: string | null,
          absorbFees?: boolean | null,
          subscriptionTier?: SubscriptionTier | null,
          invitationStatus?: InvitationStatus | null,
          clientsOnboardingStatus?: ClientsOnboardingStatus | null,
          createdBy?: string | null,
          createdByEntityId?: string | null,
          isFirm?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | null,
        firm?:  {
          __typename: "Entity",
          id: string,
          type: EntityType,
          taxNumber?: string | null,
          companyNumber?: string | null,
          billerCode?: number | null,
          name: string,
          legalName?: string | null,
          businessNames?: Array< string | null > | null,
          searchName?: string | null,
          address?:  {
            __typename: "Address",
            addressId?: string | null,
            contactName?: string | null,
            contactNumber?: string | null,
            fullAddress?: string | null,
            address1?: string | null,
            address2?: string | null,
            city?: string | null,
            country: string,
            countryCode: string,
            state: string,
            stateCode?: string | null,
            postalCode: string,
            invalid?: boolean | null,
          } | null,
          logo?:  {
            __typename: "Image",
            alt?: string | null,
            identityId?: string | null,
            key: string,
            level: S3UploadLevel,
            type?: string | null,
          } | null,
          brandColour?: string | null,
          website?: string | null,
          entityUsers?:  {
            __typename: "ModelEntityUserConnection",
            items:  Array< {
              __typename: "EntityUser",
              id: string,
              entityId: string,
              userId: string,
              firmId?: string | null,
              email?: string | null,
              invitedEmail?: string | null,
              ocrEmail?: string | null,
              referredBy?: string | null,
              invitedEntityId?: string | null,
              firmEntityId?: string | null,
              providerContactId?: string | null,
              ownerCode?: string | null,
              clientGroupCode?: string | null,
              clientCode?: string | null,
              firstName?: string | null,
              lastName?: string | null,
              role: EntityUserRole,
              jobTags?: Array< JobTags | null > | null,
              paymentsEnabled?: boolean | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              termsFirmPayTaxAccepted?: boolean | null,
              termsFirmPayTaxDetails?:  {
                __typename: "TermsFirmPayTaxDetails",
                acceptedAt?: string | null,
                email?: string | null,
                ip?: string | null,
                fullName?: string | null,
                firmId?: string | null,
              } | null,
              entitySearchName?: string | null,
              entity?:  {
                __typename: "Entity",
                id: string,
                type: EntityType,
                taxNumber?: string | null,
                companyNumber?: string | null,
                billerCode?: number | null,
                name: string,
                legalName?: string | null,
                businessNames?: Array< string | null > | null,
                searchName?: string | null,
                brandColour?: string | null,
                website?: string | null,
                gstRegistered?: boolean | null,
                gstReportingPeriod?: GSTReportingPeriod | null,
                providerEntityId?: string | null,
                providerCompanyId?: string | null,
                providerBillUserCompanyId?: string | null,
                providerBankAccountId?: string | null,
                providerDigitalWalletId?: string | null,
                providerBpayCrn?: string | null,
                paymentMethodId?: string | null,
                paymentUserId?: string | null,
                disbursementMethodId?: string | null,
                ubosCreated?: boolean | null,
                numUbosCreated?: number | null,
                subCategory?: string | null,
                clientsStatus?: EntityClientsStatus | null,
                ocrEmail?: string | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                owner?: string | null,
                referredBy?: string | null,
                connectedAccount?: string | null,
                accountStatus?: AccountStatus | null,
                customerId?: string | null,
                xeroSyncStatus?: XeroSyncStatus | null,
                xeroLastContactSyncAt?: string | null,
                xeroContactSyncStatus?: XeroSyncStatus | null,
                xeroInvoiceSyncStatus?: XeroSyncStatus | null,
                xeroLastInvoiceSyncAt?: string | null,
                xeroTenantId?: string | null,
                absorbFees?: boolean | null,
                subscriptionTier?: SubscriptionTier | null,
                invitationStatus?: InvitationStatus | null,
                clientsOnboardingStatus?: ClientsOnboardingStatus | null,
                createdBy?: string | null,
                createdByEntityId?: string | null,
                isFirm?: boolean | null,
                createdAt?: string | null,
                updatedAt?: string | null,
              } | null,
              firm?:  {
                __typename: "Entity",
                id: string,
                type: EntityType,
                taxNumber?: string | null,
                companyNumber?: string | null,
                billerCode?: number | null,
                name: string,
                legalName?: string | null,
                businessNames?: Array< string | null > | null,
                searchName?: string | null,
                brandColour?: string | null,
                website?: string | null,
                gstRegistered?: boolean | null,
                gstReportingPeriod?: GSTReportingPeriod | null,
                providerEntityId?: string | null,
                providerCompanyId?: string | null,
                providerBillUserCompanyId?: string | null,
                providerBankAccountId?: string | null,
                providerDigitalWalletId?: string | null,
                providerBpayCrn?: string | null,
                paymentMethodId?: string | null,
                paymentUserId?: string | null,
                disbursementMethodId?: string | null,
                ubosCreated?: boolean | null,
                numUbosCreated?: number | null,
                subCategory?: string | null,
                clientsStatus?: EntityClientsStatus | null,
                ocrEmail?: string | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                owner?: string | null,
                referredBy?: string | null,
                connectedAccount?: string | null,
                accountStatus?: AccountStatus | null,
                customerId?: string | null,
                xeroSyncStatus?: XeroSyncStatus | null,
                xeroLastContactSyncAt?: string | null,
                xeroContactSyncStatus?: XeroSyncStatus | null,
                xeroInvoiceSyncStatus?: XeroSyncStatus | null,
                xeroLastInvoiceSyncAt?: string | null,
                xeroTenantId?: string | null,
                absorbFees?: boolean | null,
                subscriptionTier?: SubscriptionTier | null,
                invitationStatus?: InvitationStatus | null,
                clientsOnboardingStatus?: ClientsOnboardingStatus | null,
                createdBy?: string | null,
                createdByEntityId?: string | null,
                isFirm?: boolean | null,
                createdAt?: string | null,
                updatedAt?: string | null,
              } | null,
              searchName?: string | null,
              taxNumber?: string | null,
              taskSendSMS?: boolean | null,
              companyNumber?: string | null,
              createdBy?: string | null,
              createdAt: string,
              updatedAt: string,
              status?: EntityUserStatus | null,
              partnerId?: string | null,
              managerId?: string | null,
              archivedAt?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gstRegistered?: boolean | null,
          gstReportingPeriod?: GSTReportingPeriod | null,
          providerEntityId?: string | null,
          providerCompanyId?: string | null,
          providerBillUserCompanyId?: string | null,
          providerBankAccountId?: string | null,
          providerDigitalWalletId?: string | null,
          providerBpayCrn?: string | null,
          contact?:  {
            __typename: "EntityContact",
            firstName?: string | null,
            lastName?: string | null,
            email?: string | null,
            phone?: string | null,
            role?: string | null,
          } | null,
          paymentMethods?:  {
            __typename: "ModelPaymentMethodConnection",
            items:  Array< {
              __typename: "PaymentMethod",
              id: string,
              paymentMethodType: PaymentMethodType,
              type?: string | null,
              fullName?: string | null,
              number?: string | null,
              expMonth?: string | null,
              expYear?: string | null,
              accountName?: string | null,
              bankName?: string | null,
              accountNumber?: string | null,
              routingNumber?: string | null,
              holderType?: BankHolderType | null,
              accountType?: BankAccountType | null,
              status?: PaymentMethodStatus | null,
              accountDirection?: AccountDirection | null,
              expiresAt?: string | null,
              createdAt?: string | null,
              updatedAt?: string | null,
              consentId?: string | null,
              consentStatus?: PaymentConsentStatus | null,
              card?: string | null,
              googlepay?: string | null,
              applepay?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          paymentMethodId?: string | null,
          paymentUserId?: string | null,
          disbursementMethodId?: string | null,
          receivingAccounts?:  {
            __typename: "ModelPaymentMethodConnection",
            items:  Array< {
              __typename: "PaymentMethod",
              id: string,
              paymentMethodType: PaymentMethodType,
              type?: string | null,
              fullName?: string | null,
              number?: string | null,
              expMonth?: string | null,
              expYear?: string | null,
              accountName?: string | null,
              bankName?: string | null,
              accountNumber?: string | null,
              routingNumber?: string | null,
              holderType?: BankHolderType | null,
              accountType?: BankAccountType | null,
              status?: PaymentMethodStatus | null,
              accountDirection?: AccountDirection | null,
              expiresAt?: string | null,
              createdAt?: string | null,
              updatedAt?: string | null,
              consentId?: string | null,
              consentStatus?: PaymentConsentStatus | null,
              card?: string | null,
              googlepay?: string | null,
              applepay?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          ubosCreated?: boolean | null,
          numUbosCreated?: number | null,
          subCategory?: string | null,
          clientsStatus?: EntityClientsStatus | null,
          ocrEmail?: string | null,
          termsInvoiceAccepted?: boolean | null,
          termsOcrAccepted?: boolean | null,
          owner?: string | null,
          referredBy?: string | null,
          connectedAccount?: string | null,
          accountStatus?: AccountStatus | null,
          customerId?: string | null,
          xeroSyncStatus?: XeroSyncStatus | null,
          xeroLastContactSyncAt?: string | null,
          xeroContactSyncStatus?: XeroSyncStatus | null,
          xeroInvoiceSyncStatus?: XeroSyncStatus | null,
          xeroLastInvoiceSyncAt?: string | null,
          xeroTenantId?: string | null,
          absorbFees?: boolean | null,
          subscriptionTier?: SubscriptionTier | null,
          invitationStatus?: InvitationStatus | null,
          clientsOnboardingStatus?: ClientsOnboardingStatus | null,
          createdBy?: string | null,
          createdByEntityId?: string | null,
          isFirm?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | null,
        searchName?: string | null,
        taxNumber?: string | null,
        taskSendSMS?: boolean | null,
        companyNumber?: string | null,
        createdBy?: string | null,
        createdAt: string,
        updatedAt: string,
        status?: EntityUserStatus | null,
        partnerId?: string | null,
        managerId?: string | null,
        archivedAt?: string | null,
        taxPaymentReferences?:  {
          __typename: "TaxPaymentReferences",
          itr?:  {
            __typename: "TaxPaymentReference",
            referenceNumber?: string | null,
            updatedAt?: string | null,
          } | null,
          other?:  {
            __typename: "TaxPaymentReference",
            referenceNumber?: string | null,
            updatedAt?: string | null,
          } | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    gstRegistered?: boolean | null,
    gstReportingPeriod?: GSTReportingPeriod | null,
    providerEntityId?: string | null,
    providerCompanyId?: string | null,
    providerBillUserCompanyId?: string | null,
    providerBankAccountId?: string | null,
    providerDigitalWalletId?: string | null,
    providerBpayCrn?: string | null,
    contact?:  {
      __typename: "EntityContact",
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      phone?: string | null,
      role?: string | null,
    } | null,
    paymentMethods?:  {
      __typename: "ModelPaymentMethodConnection",
      items:  Array< {
        __typename: "PaymentMethod",
        id: string,
        paymentMethodType: PaymentMethodType,
        type?: string | null,
        fullName?: string | null,
        number?: string | null,
        expMonth?: string | null,
        expYear?: string | null,
        accountName?: string | null,
        bankName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
        holderType?: BankHolderType | null,
        accountType?: BankAccountType | null,
        status?: PaymentMethodStatus | null,
        accountDirection?: AccountDirection | null,
        expiresAt?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        consentId?: string | null,
        consentStatus?: PaymentConsentStatus | null,
        card?: string | null,
        googlepay?: string | null,
        applepay?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    paymentMethodId?: string | null,
    paymentUserId?: string | null,
    disbursementMethodId?: string | null,
    receivingAccounts?:  {
      __typename: "ModelPaymentMethodConnection",
      items:  Array< {
        __typename: "PaymentMethod",
        id: string,
        paymentMethodType: PaymentMethodType,
        type?: string | null,
        fullName?: string | null,
        number?: string | null,
        expMonth?: string | null,
        expYear?: string | null,
        accountName?: string | null,
        bankName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
        holderType?: BankHolderType | null,
        accountType?: BankAccountType | null,
        status?: PaymentMethodStatus | null,
        accountDirection?: AccountDirection | null,
        expiresAt?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        consentId?: string | null,
        consentStatus?: PaymentConsentStatus | null,
        card?: string | null,
        googlepay?: string | null,
        applepay?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    ubosCreated?: boolean | null,
    numUbosCreated?: number | null,
    subCategory?: string | null,
    clientsStatus?: EntityClientsStatus | null,
    ocrEmail?: string | null,
    termsInvoiceAccepted?: boolean | null,
    termsOcrAccepted?: boolean | null,
    owner?: string | null,
    referredBy?: string | null,
    connectedAccount?: string | null,
    accountStatus?: AccountStatus | null,
    customerId?: string | null,
    xeroSyncStatus?: XeroSyncStatus | null,
    xeroLastContactSyncAt?: string | null,
    xeroContactSyncStatus?: XeroSyncStatus | null,
    xeroInvoiceSyncStatus?: XeroSyncStatus | null,
    xeroLastInvoiceSyncAt?: string | null,
    xeroTenantId?: string | null,
    absorbFees?: boolean | null,
    subscriptionTier?: SubscriptionTier | null,
    invitationStatus?: InvitationStatus | null,
    clientsOnboardingStatus?: ClientsOnboardingStatus | null,
    createdBy?: string | null,
    createdByEntityId?: string | null,
    isFirm?: boolean | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type SearchEntitiesQueryVariables = {
  searchName?: string | null,
  clientsStatus?: EntityClientsStatus | null,
  limit?: number | null,
  from?: number | null,
  sortBy?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type SearchEntitiesQuery = {
  searchEntities?:  {
    __typename: "ModelOpenSearchEntityConnection",
    items:  Array< {
      __typename: "Entity",
      id: string,
      type: EntityType,
      taxNumber?: string | null,
      companyNumber?: string | null,
      billerCode?: number | null,
      name: string,
      legalName?: string | null,
      businessNames?: Array< string | null > | null,
      searchName?: string | null,
      address?:  {
        __typename: "Address",
        addressId?: string | null,
        contactName?: string | null,
        contactNumber?: string | null,
        fullAddress?: string | null,
        address1?: string | null,
        address2?: string | null,
        city?: string | null,
        country: string,
        countryCode: string,
        state: string,
        stateCode?: string | null,
        postalCode: string,
        invalid?: boolean | null,
      } | null,
      logo?:  {
        __typename: "Image",
        alt?: string | null,
        identityId?: string | null,
        key: string,
        level: S3UploadLevel,
        type?: string | null,
      } | null,
      brandColour?: string | null,
      website?: string | null,
      entityUsers?:  {
        __typename: "ModelEntityUserConnection",
        items:  Array< {
          __typename: "EntityUser",
          id: string,
          entityId: string,
          userId: string,
          firmId?: string | null,
          email?: string | null,
          invitedEmail?: string | null,
          ocrEmail?: string | null,
          referredBy?: string | null,
          invitedEntityId?: string | null,
          firmEntityId?: string | null,
          providerContactId?: string | null,
          ownerCode?: string | null,
          clientGroupCode?: string | null,
          clientCode?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          role: EntityUserRole,
          jobTags?: Array< JobTags | null > | null,
          paymentsEnabled?: boolean | null,
          termsInvoiceAccepted?: boolean | null,
          termsOcrAccepted?: boolean | null,
          termsFirmPayTaxAccepted?: boolean | null,
          termsFirmPayTaxDetails?:  {
            __typename: "TermsFirmPayTaxDetails",
            document?:  {
              __typename: "S3Upload",
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type: S3UploadType,
              name?: string | null,
            } | null,
            acceptedAt?: string | null,
            email?: string | null,
            ip?: string | null,
            fullName?: string | null,
            firmId?: string | null,
          } | null,
          entitySearchName?: string | null,
          entity?:  {
            __typename: "Entity",
            id: string,
            type: EntityType,
            taxNumber?: string | null,
            companyNumber?: string | null,
            billerCode?: number | null,
            name: string,
            legalName?: string | null,
            businessNames?: Array< string | null > | null,
            searchName?: string | null,
            address?:  {
              __typename: "Address",
              addressId?: string | null,
              contactName?: string | null,
              contactNumber?: string | null,
              fullAddress?: string | null,
              address1?: string | null,
              address2?: string | null,
              city?: string | null,
              country: string,
              countryCode: string,
              state: string,
              stateCode?: string | null,
              postalCode: string,
              invalid?: boolean | null,
            } | null,
            logo?:  {
              __typename: "Image",
              alt?: string | null,
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type?: string | null,
            } | null,
            brandColour?: string | null,
            website?: string | null,
            entityUsers?:  {
              __typename: "ModelEntityUserConnection",
              items:  Array< {
                __typename: "EntityUser",
                id: string,
                entityId: string,
                userId: string,
                firmId?: string | null,
                email?: string | null,
                invitedEmail?: string | null,
                ocrEmail?: string | null,
                referredBy?: string | null,
                invitedEntityId?: string | null,
                firmEntityId?: string | null,
                providerContactId?: string | null,
                ownerCode?: string | null,
                clientGroupCode?: string | null,
                clientCode?: string | null,
                firstName?: string | null,
                lastName?: string | null,
                role: EntityUserRole,
                jobTags?: Array< JobTags | null > | null,
                paymentsEnabled?: boolean | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                termsFirmPayTaxAccepted?: boolean | null,
                entitySearchName?: string | null,
                searchName?: string | null,
                taxNumber?: string | null,
                taskSendSMS?: boolean | null,
                companyNumber?: string | null,
                createdBy?: string | null,
                createdAt: string,
                updatedAt: string,
                status?: EntityUserStatus | null,
                partnerId?: string | null,
                managerId?: string | null,
                archivedAt?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gstRegistered?: boolean | null,
            gstReportingPeriod?: GSTReportingPeriod | null,
            providerEntityId?: string | null,
            providerCompanyId?: string | null,
            providerBillUserCompanyId?: string | null,
            providerBankAccountId?: string | null,
            providerDigitalWalletId?: string | null,
            providerBpayCrn?: string | null,
            contact?:  {
              __typename: "EntityContact",
              firstName?: string | null,
              lastName?: string | null,
              email?: string | null,
              phone?: string | null,
              role?: string | null,
            } | null,
            paymentMethods?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            paymentMethodId?: string | null,
            paymentUserId?: string | null,
            disbursementMethodId?: string | null,
            receivingAccounts?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            ubosCreated?: boolean | null,
            numUbosCreated?: number | null,
            subCategory?: string | null,
            clientsStatus?: EntityClientsStatus | null,
            ocrEmail?: string | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            owner?: string | null,
            referredBy?: string | null,
            connectedAccount?: string | null,
            accountStatus?: AccountStatus | null,
            customerId?: string | null,
            xeroSyncStatus?: XeroSyncStatus | null,
            xeroLastContactSyncAt?: string | null,
            xeroContactSyncStatus?: XeroSyncStatus | null,
            xeroInvoiceSyncStatus?: XeroSyncStatus | null,
            xeroLastInvoiceSyncAt?: string | null,
            xeroTenantId?: string | null,
            absorbFees?: boolean | null,
            subscriptionTier?: SubscriptionTier | null,
            invitationStatus?: InvitationStatus | null,
            clientsOnboardingStatus?: ClientsOnboardingStatus | null,
            createdBy?: string | null,
            createdByEntityId?: string | null,
            isFirm?: boolean | null,
            createdAt?: string | null,
            updatedAt?: string | null,
          } | null,
          firm?:  {
            __typename: "Entity",
            id: string,
            type: EntityType,
            taxNumber?: string | null,
            companyNumber?: string | null,
            billerCode?: number | null,
            name: string,
            legalName?: string | null,
            businessNames?: Array< string | null > | null,
            searchName?: string | null,
            address?:  {
              __typename: "Address",
              addressId?: string | null,
              contactName?: string | null,
              contactNumber?: string | null,
              fullAddress?: string | null,
              address1?: string | null,
              address2?: string | null,
              city?: string | null,
              country: string,
              countryCode: string,
              state: string,
              stateCode?: string | null,
              postalCode: string,
              invalid?: boolean | null,
            } | null,
            logo?:  {
              __typename: "Image",
              alt?: string | null,
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type?: string | null,
            } | null,
            brandColour?: string | null,
            website?: string | null,
            entityUsers?:  {
              __typename: "ModelEntityUserConnection",
              items:  Array< {
                __typename: "EntityUser",
                id: string,
                entityId: string,
                userId: string,
                firmId?: string | null,
                email?: string | null,
                invitedEmail?: string | null,
                ocrEmail?: string | null,
                referredBy?: string | null,
                invitedEntityId?: string | null,
                firmEntityId?: string | null,
                providerContactId?: string | null,
                ownerCode?: string | null,
                clientGroupCode?: string | null,
                clientCode?: string | null,
                firstName?: string | null,
                lastName?: string | null,
                role: EntityUserRole,
                jobTags?: Array< JobTags | null > | null,
                paymentsEnabled?: boolean | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                termsFirmPayTaxAccepted?: boolean | null,
                entitySearchName?: string | null,
                searchName?: string | null,
                taxNumber?: string | null,
                taskSendSMS?: boolean | null,
                companyNumber?: string | null,
                createdBy?: string | null,
                createdAt: string,
                updatedAt: string,
                status?: EntityUserStatus | null,
                partnerId?: string | null,
                managerId?: string | null,
                archivedAt?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gstRegistered?: boolean | null,
            gstReportingPeriod?: GSTReportingPeriod | null,
            providerEntityId?: string | null,
            providerCompanyId?: string | null,
            providerBillUserCompanyId?: string | null,
            providerBankAccountId?: string | null,
            providerDigitalWalletId?: string | null,
            providerBpayCrn?: string | null,
            contact?:  {
              __typename: "EntityContact",
              firstName?: string | null,
              lastName?: string | null,
              email?: string | null,
              phone?: string | null,
              role?: string | null,
            } | null,
            paymentMethods?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            paymentMethodId?: string | null,
            paymentUserId?: string | null,
            disbursementMethodId?: string | null,
            receivingAccounts?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            ubosCreated?: boolean | null,
            numUbosCreated?: number | null,
            subCategory?: string | null,
            clientsStatus?: EntityClientsStatus | null,
            ocrEmail?: string | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            owner?: string | null,
            referredBy?: string | null,
            connectedAccount?: string | null,
            accountStatus?: AccountStatus | null,
            customerId?: string | null,
            xeroSyncStatus?: XeroSyncStatus | null,
            xeroLastContactSyncAt?: string | null,
            xeroContactSyncStatus?: XeroSyncStatus | null,
            xeroInvoiceSyncStatus?: XeroSyncStatus | null,
            xeroLastInvoiceSyncAt?: string | null,
            xeroTenantId?: string | null,
            absorbFees?: boolean | null,
            subscriptionTier?: SubscriptionTier | null,
            invitationStatus?: InvitationStatus | null,
            clientsOnboardingStatus?: ClientsOnboardingStatus | null,
            createdBy?: string | null,
            createdByEntityId?: string | null,
            isFirm?: boolean | null,
            createdAt?: string | null,
            updatedAt?: string | null,
          } | null,
          searchName?: string | null,
          taxNumber?: string | null,
          taskSendSMS?: boolean | null,
          companyNumber?: string | null,
          createdBy?: string | null,
          createdAt: string,
          updatedAt: string,
          status?: EntityUserStatus | null,
          partnerId?: string | null,
          managerId?: string | null,
          archivedAt?: string | null,
          taxPaymentReferences?:  {
            __typename: "TaxPaymentReferences",
            itr?:  {
              __typename: "TaxPaymentReference",
              referenceNumber?: string | null,
              updatedAt?: string | null,
            } | null,
            other?:  {
              __typename: "TaxPaymentReference",
              referenceNumber?: string | null,
              updatedAt?: string | null,
            } | null,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gstRegistered?: boolean | null,
      gstReportingPeriod?: GSTReportingPeriod | null,
      providerEntityId?: string | null,
      providerCompanyId?: string | null,
      providerBillUserCompanyId?: string | null,
      providerBankAccountId?: string | null,
      providerDigitalWalletId?: string | null,
      providerBpayCrn?: string | null,
      contact?:  {
        __typename: "EntityContact",
        firstName?: string | null,
        lastName?: string | null,
        email?: string | null,
        phone?: string | null,
        role?: string | null,
      } | null,
      paymentMethods?:  {
        __typename: "ModelPaymentMethodConnection",
        items:  Array< {
          __typename: "PaymentMethod",
          id: string,
          paymentMethodType: PaymentMethodType,
          type?: string | null,
          fullName?: string | null,
          number?: string | null,
          expMonth?: string | null,
          expYear?: string | null,
          accountName?: string | null,
          bankName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
          holderType?: BankHolderType | null,
          accountType?: BankAccountType | null,
          status?: PaymentMethodStatus | null,
          accountDirection?: AccountDirection | null,
          expiresAt?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          consentId?: string | null,
          consentStatus?: PaymentConsentStatus | null,
          card?: string | null,
          googlepay?: string | null,
          applepay?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      paymentMethodId?: string | null,
      paymentUserId?: string | null,
      disbursementMethodId?: string | null,
      receivingAccounts?:  {
        __typename: "ModelPaymentMethodConnection",
        items:  Array< {
          __typename: "PaymentMethod",
          id: string,
          paymentMethodType: PaymentMethodType,
          type?: string | null,
          fullName?: string | null,
          number?: string | null,
          expMonth?: string | null,
          expYear?: string | null,
          accountName?: string | null,
          bankName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
          holderType?: BankHolderType | null,
          accountType?: BankAccountType | null,
          status?: PaymentMethodStatus | null,
          accountDirection?: AccountDirection | null,
          expiresAt?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          consentId?: string | null,
          consentStatus?: PaymentConsentStatus | null,
          card?: string | null,
          googlepay?: string | null,
          applepay?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      ubosCreated?: boolean | null,
      numUbosCreated?: number | null,
      subCategory?: string | null,
      clientsStatus?: EntityClientsStatus | null,
      ocrEmail?: string | null,
      termsInvoiceAccepted?: boolean | null,
      termsOcrAccepted?: boolean | null,
      owner?: string | null,
      referredBy?: string | null,
      connectedAccount?: string | null,
      accountStatus?: AccountStatus | null,
      customerId?: string | null,
      xeroSyncStatus?: XeroSyncStatus | null,
      xeroLastContactSyncAt?: string | null,
      xeroContactSyncStatus?: XeroSyncStatus | null,
      xeroInvoiceSyncStatus?: XeroSyncStatus | null,
      xeroLastInvoiceSyncAt?: string | null,
      xeroTenantId?: string | null,
      absorbFees?: boolean | null,
      subscriptionTier?: SubscriptionTier | null,
      invitationStatus?: InvitationStatus | null,
      clientsOnboardingStatus?: ClientsOnboardingStatus | null,
      createdBy?: string | null,
      createdByEntityId?: string | null,
      isFirm?: boolean | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    total?: number | null,
  } | null,
};

export type EntityUsersByUserQueryVariables = {
  searchName?: string | null,
  role?: EntityUserRole | null,
  sortDirection?: ModelSortDirection | null,
  from?: number | null,
  limit?: number | null,
};

export type EntityUsersByUserQuery = {
  entityUsersByUser?:  {
    __typename: "ModelEntityUserOSConnection",
    items:  Array< {
      __typename: "EntityUser",
      id: string,
      entityId: string,
      userId: string,
      firmId?: string | null,
      email?: string | null,
      invitedEmail?: string | null,
      ocrEmail?: string | null,
      referredBy?: string | null,
      invitedEntityId?: string | null,
      firmEntityId?: string | null,
      providerContactId?: string | null,
      ownerCode?: string | null,
      clientGroupCode?: string | null,
      clientCode?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      role: EntityUserRole,
      jobTags?: Array< JobTags | null > | null,
      paymentsEnabled?: boolean | null,
      termsInvoiceAccepted?: boolean | null,
      termsOcrAccepted?: boolean | null,
      termsFirmPayTaxAccepted?: boolean | null,
      termsFirmPayTaxDetails?:  {
        __typename: "TermsFirmPayTaxDetails",
        document?:  {
          __typename: "S3Upload",
          identityId?: string | null,
          key: string,
          level: S3UploadLevel,
          type: S3UploadType,
          name?: string | null,
        } | null,
        acceptedAt?: string | null,
        email?: string | null,
        ip?: string | null,
        fullName?: string | null,
        firmId?: string | null,
      } | null,
      entitySearchName?: string | null,
      entity?:  {
        __typename: "Entity",
        id: string,
        type: EntityType,
        taxNumber?: string | null,
        companyNumber?: string | null,
        billerCode?: number | null,
        name: string,
        legalName?: string | null,
        businessNames?: Array< string | null > | null,
        searchName?: string | null,
        address?:  {
          __typename: "Address",
          addressId?: string | null,
          contactName?: string | null,
          contactNumber?: string | null,
          fullAddress?: string | null,
          address1?: string | null,
          address2?: string | null,
          city?: string | null,
          country: string,
          countryCode: string,
          state: string,
          stateCode?: string | null,
          postalCode: string,
          invalid?: boolean | null,
        } | null,
        logo?:  {
          __typename: "Image",
          alt?: string | null,
          identityId?: string | null,
          key: string,
          level: S3UploadLevel,
          type?: string | null,
        } | null,
        brandColour?: string | null,
        website?: string | null,
        entityUsers?:  {
          __typename: "ModelEntityUserConnection",
          items:  Array< {
            __typename: "EntityUser",
            id: string,
            entityId: string,
            userId: string,
            firmId?: string | null,
            email?: string | null,
            invitedEmail?: string | null,
            ocrEmail?: string | null,
            referredBy?: string | null,
            invitedEntityId?: string | null,
            firmEntityId?: string | null,
            providerContactId?: string | null,
            ownerCode?: string | null,
            clientGroupCode?: string | null,
            clientCode?: string | null,
            firstName?: string | null,
            lastName?: string | null,
            role: EntityUserRole,
            jobTags?: Array< JobTags | null > | null,
            paymentsEnabled?: boolean | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            termsFirmPayTaxAccepted?: boolean | null,
            termsFirmPayTaxDetails?:  {
              __typename: "TermsFirmPayTaxDetails",
              document?:  {
                __typename: "S3Upload",
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type: S3UploadType,
                name?: string | null,
              } | null,
              acceptedAt?: string | null,
              email?: string | null,
              ip?: string | null,
              fullName?: string | null,
              firmId?: string | null,
            } | null,
            entitySearchName?: string | null,
            entity?:  {
              __typename: "Entity",
              id: string,
              type: EntityType,
              taxNumber?: string | null,
              companyNumber?: string | null,
              billerCode?: number | null,
              name: string,
              legalName?: string | null,
              businessNames?: Array< string | null > | null,
              searchName?: string | null,
              address?:  {
                __typename: "Address",
                addressId?: string | null,
                contactName?: string | null,
                contactNumber?: string | null,
                fullAddress?: string | null,
                address1?: string | null,
                address2?: string | null,
                city?: string | null,
                country: string,
                countryCode: string,
                state: string,
                stateCode?: string | null,
                postalCode: string,
                invalid?: boolean | null,
              } | null,
              logo?:  {
                __typename: "Image",
                alt?: string | null,
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type?: string | null,
              } | null,
              brandColour?: string | null,
              website?: string | null,
              entityUsers?:  {
                __typename: "ModelEntityUserConnection",
                nextToken?: string | null,
              } | null,
              gstRegistered?: boolean | null,
              gstReportingPeriod?: GSTReportingPeriod | null,
              providerEntityId?: string | null,
              providerCompanyId?: string | null,
              providerBillUserCompanyId?: string | null,
              providerBankAccountId?: string | null,
              providerDigitalWalletId?: string | null,
              providerBpayCrn?: string | null,
              contact?:  {
                __typename: "EntityContact",
                firstName?: string | null,
                lastName?: string | null,
                email?: string | null,
                phone?: string | null,
                role?: string | null,
              } | null,
              paymentMethods?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              paymentMethodId?: string | null,
              paymentUserId?: string | null,
              disbursementMethodId?: string | null,
              receivingAccounts?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              ubosCreated?: boolean | null,
              numUbosCreated?: number | null,
              subCategory?: string | null,
              clientsStatus?: EntityClientsStatus | null,
              ocrEmail?: string | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              owner?: string | null,
              referredBy?: string | null,
              connectedAccount?: string | null,
              accountStatus?: AccountStatus | null,
              customerId?: string | null,
              xeroSyncStatus?: XeroSyncStatus | null,
              xeroLastContactSyncAt?: string | null,
              xeroContactSyncStatus?: XeroSyncStatus | null,
              xeroInvoiceSyncStatus?: XeroSyncStatus | null,
              xeroLastInvoiceSyncAt?: string | null,
              xeroTenantId?: string | null,
              absorbFees?: boolean | null,
              subscriptionTier?: SubscriptionTier | null,
              invitationStatus?: InvitationStatus | null,
              clientsOnboardingStatus?: ClientsOnboardingStatus | null,
              createdBy?: string | null,
              createdByEntityId?: string | null,
              isFirm?: boolean | null,
              createdAt?: string | null,
              updatedAt?: string | null,
            } | null,
            firm?:  {
              __typename: "Entity",
              id: string,
              type: EntityType,
              taxNumber?: string | null,
              companyNumber?: string | null,
              billerCode?: number | null,
              name: string,
              legalName?: string | null,
              businessNames?: Array< string | null > | null,
              searchName?: string | null,
              address?:  {
                __typename: "Address",
                addressId?: string | null,
                contactName?: string | null,
                contactNumber?: string | null,
                fullAddress?: string | null,
                address1?: string | null,
                address2?: string | null,
                city?: string | null,
                country: string,
                countryCode: string,
                state: string,
                stateCode?: string | null,
                postalCode: string,
                invalid?: boolean | null,
              } | null,
              logo?:  {
                __typename: "Image",
                alt?: string | null,
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type?: string | null,
              } | null,
              brandColour?: string | null,
              website?: string | null,
              entityUsers?:  {
                __typename: "ModelEntityUserConnection",
                nextToken?: string | null,
              } | null,
              gstRegistered?: boolean | null,
              gstReportingPeriod?: GSTReportingPeriod | null,
              providerEntityId?: string | null,
              providerCompanyId?: string | null,
              providerBillUserCompanyId?: string | null,
              providerBankAccountId?: string | null,
              providerDigitalWalletId?: string | null,
              providerBpayCrn?: string | null,
              contact?:  {
                __typename: "EntityContact",
                firstName?: string | null,
                lastName?: string | null,
                email?: string | null,
                phone?: string | null,
                role?: string | null,
              } | null,
              paymentMethods?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              paymentMethodId?: string | null,
              paymentUserId?: string | null,
              disbursementMethodId?: string | null,
              receivingAccounts?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              ubosCreated?: boolean | null,
              numUbosCreated?: number | null,
              subCategory?: string | null,
              clientsStatus?: EntityClientsStatus | null,
              ocrEmail?: string | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              owner?: string | null,
              referredBy?: string | null,
              connectedAccount?: string | null,
              accountStatus?: AccountStatus | null,
              customerId?: string | null,
              xeroSyncStatus?: XeroSyncStatus | null,
              xeroLastContactSyncAt?: string | null,
              xeroContactSyncStatus?: XeroSyncStatus | null,
              xeroInvoiceSyncStatus?: XeroSyncStatus | null,
              xeroLastInvoiceSyncAt?: string | null,
              xeroTenantId?: string | null,
              absorbFees?: boolean | null,
              subscriptionTier?: SubscriptionTier | null,
              invitationStatus?: InvitationStatus | null,
              clientsOnboardingStatus?: ClientsOnboardingStatus | null,
              createdBy?: string | null,
              createdByEntityId?: string | null,
              isFirm?: boolean | null,
              createdAt?: string | null,
              updatedAt?: string | null,
            } | null,
            searchName?: string | null,
            taxNumber?: string | null,
            taskSendSMS?: boolean | null,
            companyNumber?: string | null,
            createdBy?: string | null,
            createdAt: string,
            updatedAt: string,
            status?: EntityUserStatus | null,
            partnerId?: string | null,
            managerId?: string | null,
            archivedAt?: string | null,
            taxPaymentReferences?:  {
              __typename: "TaxPaymentReferences",
              itr?:  {
                __typename: "TaxPaymentReference",
                referenceNumber?: string | null,
                updatedAt?: string | null,
              } | null,
              other?:  {
                __typename: "TaxPaymentReference",
                referenceNumber?: string | null,
                updatedAt?: string | null,
              } | null,
            } | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        gstRegistered?: boolean | null,
        gstReportingPeriod?: GSTReportingPeriod | null,
        providerEntityId?: string | null,
        providerCompanyId?: string | null,
        providerBillUserCompanyId?: string | null,
        providerBankAccountId?: string | null,
        providerDigitalWalletId?: string | null,
        providerBpayCrn?: string | null,
        contact?:  {
          __typename: "EntityContact",
          firstName?: string | null,
          lastName?: string | null,
          email?: string | null,
          phone?: string | null,
          role?: string | null,
        } | null,
        paymentMethods?:  {
          __typename: "ModelPaymentMethodConnection",
          items:  Array< {
            __typename: "PaymentMethod",
            id: string,
            paymentMethodType: PaymentMethodType,
            type?: string | null,
            fullName?: string | null,
            number?: string | null,
            expMonth?: string | null,
            expYear?: string | null,
            accountName?: string | null,
            bankName?: string | null,
            accountNumber?: string | null,
            routingNumber?: string | null,
            holderType?: BankHolderType | null,
            accountType?: BankAccountType | null,
            status?: PaymentMethodStatus | null,
            accountDirection?: AccountDirection | null,
            expiresAt?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            consentId?: string | null,
            consentStatus?: PaymentConsentStatus | null,
            card?: string | null,
            googlepay?: string | null,
            applepay?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        paymentMethodId?: string | null,
        paymentUserId?: string | null,
        disbursementMethodId?: string | null,
        receivingAccounts?:  {
          __typename: "ModelPaymentMethodConnection",
          items:  Array< {
            __typename: "PaymentMethod",
            id: string,
            paymentMethodType: PaymentMethodType,
            type?: string | null,
            fullName?: string | null,
            number?: string | null,
            expMonth?: string | null,
            expYear?: string | null,
            accountName?: string | null,
            bankName?: string | null,
            accountNumber?: string | null,
            routingNumber?: string | null,
            holderType?: BankHolderType | null,
            accountType?: BankAccountType | null,
            status?: PaymentMethodStatus | null,
            accountDirection?: AccountDirection | null,
            expiresAt?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            consentId?: string | null,
            consentStatus?: PaymentConsentStatus | null,
            card?: string | null,
            googlepay?: string | null,
            applepay?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        ubosCreated?: boolean | null,
        numUbosCreated?: number | null,
        subCategory?: string | null,
        clientsStatus?: EntityClientsStatus | null,
        ocrEmail?: string | null,
        termsInvoiceAccepted?: boolean | null,
        termsOcrAccepted?: boolean | null,
        owner?: string | null,
        referredBy?: string | null,
        connectedAccount?: string | null,
        accountStatus?: AccountStatus | null,
        customerId?: string | null,
        xeroSyncStatus?: XeroSyncStatus | null,
        xeroLastContactSyncAt?: string | null,
        xeroContactSyncStatus?: XeroSyncStatus | null,
        xeroInvoiceSyncStatus?: XeroSyncStatus | null,
        xeroLastInvoiceSyncAt?: string | null,
        xeroTenantId?: string | null,
        absorbFees?: boolean | null,
        subscriptionTier?: SubscriptionTier | null,
        invitationStatus?: InvitationStatus | null,
        clientsOnboardingStatus?: ClientsOnboardingStatus | null,
        createdBy?: string | null,
        createdByEntityId?: string | null,
        isFirm?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      firm?:  {
        __typename: "Entity",
        id: string,
        type: EntityType,
        taxNumber?: string | null,
        companyNumber?: string | null,
        billerCode?: number | null,
        name: string,
        legalName?: string | null,
        businessNames?: Array< string | null > | null,
        searchName?: string | null,
        address?:  {
          __typename: "Address",
          addressId?: string | null,
          contactName?: string | null,
          contactNumber?: string | null,
          fullAddress?: string | null,
          address1?: string | null,
          address2?: string | null,
          city?: string | null,
          country: string,
          countryCode: string,
          state: string,
          stateCode?: string | null,
          postalCode: string,
          invalid?: boolean | null,
        } | null,
        logo?:  {
          __typename: "Image",
          alt?: string | null,
          identityId?: string | null,
          key: string,
          level: S3UploadLevel,
          type?: string | null,
        } | null,
        brandColour?: string | null,
        website?: string | null,
        entityUsers?:  {
          __typename: "ModelEntityUserConnection",
          items:  Array< {
            __typename: "EntityUser",
            id: string,
            entityId: string,
            userId: string,
            firmId?: string | null,
            email?: string | null,
            invitedEmail?: string | null,
            ocrEmail?: string | null,
            referredBy?: string | null,
            invitedEntityId?: string | null,
            firmEntityId?: string | null,
            providerContactId?: string | null,
            ownerCode?: string | null,
            clientGroupCode?: string | null,
            clientCode?: string | null,
            firstName?: string | null,
            lastName?: string | null,
            role: EntityUserRole,
            jobTags?: Array< JobTags | null > | null,
            paymentsEnabled?: boolean | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            termsFirmPayTaxAccepted?: boolean | null,
            termsFirmPayTaxDetails?:  {
              __typename: "TermsFirmPayTaxDetails",
              document?:  {
                __typename: "S3Upload",
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type: S3UploadType,
                name?: string | null,
              } | null,
              acceptedAt?: string | null,
              email?: string | null,
              ip?: string | null,
              fullName?: string | null,
              firmId?: string | null,
            } | null,
            entitySearchName?: string | null,
            entity?:  {
              __typename: "Entity",
              id: string,
              type: EntityType,
              taxNumber?: string | null,
              companyNumber?: string | null,
              billerCode?: number | null,
              name: string,
              legalName?: string | null,
              businessNames?: Array< string | null > | null,
              searchName?: string | null,
              address?:  {
                __typename: "Address",
                addressId?: string | null,
                contactName?: string | null,
                contactNumber?: string | null,
                fullAddress?: string | null,
                address1?: string | null,
                address2?: string | null,
                city?: string | null,
                country: string,
                countryCode: string,
                state: string,
                stateCode?: string | null,
                postalCode: string,
                invalid?: boolean | null,
              } | null,
              logo?:  {
                __typename: "Image",
                alt?: string | null,
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type?: string | null,
              } | null,
              brandColour?: string | null,
              website?: string | null,
              entityUsers?:  {
                __typename: "ModelEntityUserConnection",
                nextToken?: string | null,
              } | null,
              gstRegistered?: boolean | null,
              gstReportingPeriod?: GSTReportingPeriod | null,
              providerEntityId?: string | null,
              providerCompanyId?: string | null,
              providerBillUserCompanyId?: string | null,
              providerBankAccountId?: string | null,
              providerDigitalWalletId?: string | null,
              providerBpayCrn?: string | null,
              contact?:  {
                __typename: "EntityContact",
                firstName?: string | null,
                lastName?: string | null,
                email?: string | null,
                phone?: string | null,
                role?: string | null,
              } | null,
              paymentMethods?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              paymentMethodId?: string | null,
              paymentUserId?: string | null,
              disbursementMethodId?: string | null,
              receivingAccounts?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              ubosCreated?: boolean | null,
              numUbosCreated?: number | null,
              subCategory?: string | null,
              clientsStatus?: EntityClientsStatus | null,
              ocrEmail?: string | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              owner?: string | null,
              referredBy?: string | null,
              connectedAccount?: string | null,
              accountStatus?: AccountStatus | null,
              customerId?: string | null,
              xeroSyncStatus?: XeroSyncStatus | null,
              xeroLastContactSyncAt?: string | null,
              xeroContactSyncStatus?: XeroSyncStatus | null,
              xeroInvoiceSyncStatus?: XeroSyncStatus | null,
              xeroLastInvoiceSyncAt?: string | null,
              xeroTenantId?: string | null,
              absorbFees?: boolean | null,
              subscriptionTier?: SubscriptionTier | null,
              invitationStatus?: InvitationStatus | null,
              clientsOnboardingStatus?: ClientsOnboardingStatus | null,
              createdBy?: string | null,
              createdByEntityId?: string | null,
              isFirm?: boolean | null,
              createdAt?: string | null,
              updatedAt?: string | null,
            } | null,
            firm?:  {
              __typename: "Entity",
              id: string,
              type: EntityType,
              taxNumber?: string | null,
              companyNumber?: string | null,
              billerCode?: number | null,
              name: string,
              legalName?: string | null,
              businessNames?: Array< string | null > | null,
              searchName?: string | null,
              address?:  {
                __typename: "Address",
                addressId?: string | null,
                contactName?: string | null,
                contactNumber?: string | null,
                fullAddress?: string | null,
                address1?: string | null,
                address2?: string | null,
                city?: string | null,
                country: string,
                countryCode: string,
                state: string,
                stateCode?: string | null,
                postalCode: string,
                invalid?: boolean | null,
              } | null,
              logo?:  {
                __typename: "Image",
                alt?: string | null,
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type?: string | null,
              } | null,
              brandColour?: string | null,
              website?: string | null,
              entityUsers?:  {
                __typename: "ModelEntityUserConnection",
                nextToken?: string | null,
              } | null,
              gstRegistered?: boolean | null,
              gstReportingPeriod?: GSTReportingPeriod | null,
              providerEntityId?: string | null,
              providerCompanyId?: string | null,
              providerBillUserCompanyId?: string | null,
              providerBankAccountId?: string | null,
              providerDigitalWalletId?: string | null,
              providerBpayCrn?: string | null,
              contact?:  {
                __typename: "EntityContact",
                firstName?: string | null,
                lastName?: string | null,
                email?: string | null,
                phone?: string | null,
                role?: string | null,
              } | null,
              paymentMethods?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              paymentMethodId?: string | null,
              paymentUserId?: string | null,
              disbursementMethodId?: string | null,
              receivingAccounts?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              ubosCreated?: boolean | null,
              numUbosCreated?: number | null,
              subCategory?: string | null,
              clientsStatus?: EntityClientsStatus | null,
              ocrEmail?: string | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              owner?: string | null,
              referredBy?: string | null,
              connectedAccount?: string | null,
              accountStatus?: AccountStatus | null,
              customerId?: string | null,
              xeroSyncStatus?: XeroSyncStatus | null,
              xeroLastContactSyncAt?: string | null,
              xeroContactSyncStatus?: XeroSyncStatus | null,
              xeroInvoiceSyncStatus?: XeroSyncStatus | null,
              xeroLastInvoiceSyncAt?: string | null,
              xeroTenantId?: string | null,
              absorbFees?: boolean | null,
              subscriptionTier?: SubscriptionTier | null,
              invitationStatus?: InvitationStatus | null,
              clientsOnboardingStatus?: ClientsOnboardingStatus | null,
              createdBy?: string | null,
              createdByEntityId?: string | null,
              isFirm?: boolean | null,
              createdAt?: string | null,
              updatedAt?: string | null,
            } | null,
            searchName?: string | null,
            taxNumber?: string | null,
            taskSendSMS?: boolean | null,
            companyNumber?: string | null,
            createdBy?: string | null,
            createdAt: string,
            updatedAt: string,
            status?: EntityUserStatus | null,
            partnerId?: string | null,
            managerId?: string | null,
            archivedAt?: string | null,
            taxPaymentReferences?:  {
              __typename: "TaxPaymentReferences",
              itr?:  {
                __typename: "TaxPaymentReference",
                referenceNumber?: string | null,
                updatedAt?: string | null,
              } | null,
              other?:  {
                __typename: "TaxPaymentReference",
                referenceNumber?: string | null,
                updatedAt?: string | null,
              } | null,
            } | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        gstRegistered?: boolean | null,
        gstReportingPeriod?: GSTReportingPeriod | null,
        providerEntityId?: string | null,
        providerCompanyId?: string | null,
        providerBillUserCompanyId?: string | null,
        providerBankAccountId?: string | null,
        providerDigitalWalletId?: string | null,
        providerBpayCrn?: string | null,
        contact?:  {
          __typename: "EntityContact",
          firstName?: string | null,
          lastName?: string | null,
          email?: string | null,
          phone?: string | null,
          role?: string | null,
        } | null,
        paymentMethods?:  {
          __typename: "ModelPaymentMethodConnection",
          items:  Array< {
            __typename: "PaymentMethod",
            id: string,
            paymentMethodType: PaymentMethodType,
            type?: string | null,
            fullName?: string | null,
            number?: string | null,
            expMonth?: string | null,
            expYear?: string | null,
            accountName?: string | null,
            bankName?: string | null,
            accountNumber?: string | null,
            routingNumber?: string | null,
            holderType?: BankHolderType | null,
            accountType?: BankAccountType | null,
            status?: PaymentMethodStatus | null,
            accountDirection?: AccountDirection | null,
            expiresAt?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            consentId?: string | null,
            consentStatus?: PaymentConsentStatus | null,
            card?: string | null,
            googlepay?: string | null,
            applepay?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        paymentMethodId?: string | null,
        paymentUserId?: string | null,
        disbursementMethodId?: string | null,
        receivingAccounts?:  {
          __typename: "ModelPaymentMethodConnection",
          items:  Array< {
            __typename: "PaymentMethod",
            id: string,
            paymentMethodType: PaymentMethodType,
            type?: string | null,
            fullName?: string | null,
            number?: string | null,
            expMonth?: string | null,
            expYear?: string | null,
            accountName?: string | null,
            bankName?: string | null,
            accountNumber?: string | null,
            routingNumber?: string | null,
            holderType?: BankHolderType | null,
            accountType?: BankAccountType | null,
            status?: PaymentMethodStatus | null,
            accountDirection?: AccountDirection | null,
            expiresAt?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            consentId?: string | null,
            consentStatus?: PaymentConsentStatus | null,
            card?: string | null,
            googlepay?: string | null,
            applepay?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        ubosCreated?: boolean | null,
        numUbosCreated?: number | null,
        subCategory?: string | null,
        clientsStatus?: EntityClientsStatus | null,
        ocrEmail?: string | null,
        termsInvoiceAccepted?: boolean | null,
        termsOcrAccepted?: boolean | null,
        owner?: string | null,
        referredBy?: string | null,
        connectedAccount?: string | null,
        accountStatus?: AccountStatus | null,
        customerId?: string | null,
        xeroSyncStatus?: XeroSyncStatus | null,
        xeroLastContactSyncAt?: string | null,
        xeroContactSyncStatus?: XeroSyncStatus | null,
        xeroInvoiceSyncStatus?: XeroSyncStatus | null,
        xeroLastInvoiceSyncAt?: string | null,
        xeroTenantId?: string | null,
        absorbFees?: boolean | null,
        subscriptionTier?: SubscriptionTier | null,
        invitationStatus?: InvitationStatus | null,
        clientsOnboardingStatus?: ClientsOnboardingStatus | null,
        createdBy?: string | null,
        createdByEntityId?: string | null,
        isFirm?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      searchName?: string | null,
      taxNumber?: string | null,
      taskSendSMS?: boolean | null,
      companyNumber?: string | null,
      createdBy?: string | null,
      createdAt: string,
      updatedAt: string,
      status?: EntityUserStatus | null,
      partnerId?: string | null,
      managerId?: string | null,
      archivedAt?: string | null,
      taxPaymentReferences?:  {
        __typename: "TaxPaymentReferences",
        itr?:  {
          __typename: "TaxPaymentReference",
          referenceNumber?: string | null,
          updatedAt?: string | null,
        } | null,
        other?:  {
          __typename: "TaxPaymentReference",
          referenceNumber?: string | null,
          updatedAt?: string | null,
        } | null,
      } | null,
    } | null >,
    total?: number | null,
  } | null,
};

export type EntityUsersByEntityIdQueryVariables = {
  entityId: string,
  searchName?: string | null,
  roles?: Array< EntityUserRole | null > | null,
  sortDirection?: ModelSortDirection | null,
  from?: number | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type EntityUsersByEntityIdQuery = {
  entityUsersByEntityId?:  {
    __typename: "ModelEntityUserOSConnection",
    items:  Array< {
      __typename: "EntityUser",
      id: string,
      entityId: string,
      userId: string,
      firmId?: string | null,
      email?: string | null,
      invitedEmail?: string | null,
      ocrEmail?: string | null,
      referredBy?: string | null,
      invitedEntityId?: string | null,
      firmEntityId?: string | null,
      providerContactId?: string | null,
      ownerCode?: string | null,
      clientGroupCode?: string | null,
      clientCode?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      role: EntityUserRole,
      jobTags?: Array< JobTags | null > | null,
      paymentsEnabled?: boolean | null,
      termsInvoiceAccepted?: boolean | null,
      termsOcrAccepted?: boolean | null,
      termsFirmPayTaxAccepted?: boolean | null,
      termsFirmPayTaxDetails?:  {
        __typename: "TermsFirmPayTaxDetails",
        document?:  {
          __typename: "S3Upload",
          identityId?: string | null,
          key: string,
          level: S3UploadLevel,
          type: S3UploadType,
          name?: string | null,
        } | null,
        acceptedAt?: string | null,
        email?: string | null,
        ip?: string | null,
        fullName?: string | null,
        firmId?: string | null,
      } | null,
      entitySearchName?: string | null,
      entity?:  {
        __typename: "Entity",
        id: string,
        type: EntityType,
        taxNumber?: string | null,
        companyNumber?: string | null,
        billerCode?: number | null,
        name: string,
        legalName?: string | null,
        businessNames?: Array< string | null > | null,
        searchName?: string | null,
        address?:  {
          __typename: "Address",
          addressId?: string | null,
          contactName?: string | null,
          contactNumber?: string | null,
          fullAddress?: string | null,
          address1?: string | null,
          address2?: string | null,
          city?: string | null,
          country: string,
          countryCode: string,
          state: string,
          stateCode?: string | null,
          postalCode: string,
          invalid?: boolean | null,
        } | null,
        logo?:  {
          __typename: "Image",
          alt?: string | null,
          identityId?: string | null,
          key: string,
          level: S3UploadLevel,
          type?: string | null,
        } | null,
        brandColour?: string | null,
        website?: string | null,
        entityUsers?:  {
          __typename: "ModelEntityUserConnection",
          items:  Array< {
            __typename: "EntityUser",
            id: string,
            entityId: string,
            userId: string,
            firmId?: string | null,
            email?: string | null,
            invitedEmail?: string | null,
            ocrEmail?: string | null,
            referredBy?: string | null,
            invitedEntityId?: string | null,
            firmEntityId?: string | null,
            providerContactId?: string | null,
            ownerCode?: string | null,
            clientGroupCode?: string | null,
            clientCode?: string | null,
            firstName?: string | null,
            lastName?: string | null,
            role: EntityUserRole,
            jobTags?: Array< JobTags | null > | null,
            paymentsEnabled?: boolean | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            termsFirmPayTaxAccepted?: boolean | null,
            termsFirmPayTaxDetails?:  {
              __typename: "TermsFirmPayTaxDetails",
              document?:  {
                __typename: "S3Upload",
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type: S3UploadType,
                name?: string | null,
              } | null,
              acceptedAt?: string | null,
              email?: string | null,
              ip?: string | null,
              fullName?: string | null,
              firmId?: string | null,
            } | null,
            entitySearchName?: string | null,
            entity?:  {
              __typename: "Entity",
              id: string,
              type: EntityType,
              taxNumber?: string | null,
              companyNumber?: string | null,
              billerCode?: number | null,
              name: string,
              legalName?: string | null,
              businessNames?: Array< string | null > | null,
              searchName?: string | null,
              address?:  {
                __typename: "Address",
                addressId?: string | null,
                contactName?: string | null,
                contactNumber?: string | null,
                fullAddress?: string | null,
                address1?: string | null,
                address2?: string | null,
                city?: string | null,
                country: string,
                countryCode: string,
                state: string,
                stateCode?: string | null,
                postalCode: string,
                invalid?: boolean | null,
              } | null,
              logo?:  {
                __typename: "Image",
                alt?: string | null,
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type?: string | null,
              } | null,
              brandColour?: string | null,
              website?: string | null,
              entityUsers?:  {
                __typename: "ModelEntityUserConnection",
                nextToken?: string | null,
              } | null,
              gstRegistered?: boolean | null,
              gstReportingPeriod?: GSTReportingPeriod | null,
              providerEntityId?: string | null,
              providerCompanyId?: string | null,
              providerBillUserCompanyId?: string | null,
              providerBankAccountId?: string | null,
              providerDigitalWalletId?: string | null,
              providerBpayCrn?: string | null,
              contact?:  {
                __typename: "EntityContact",
                firstName?: string | null,
                lastName?: string | null,
                email?: string | null,
                phone?: string | null,
                role?: string | null,
              } | null,
              paymentMethods?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              paymentMethodId?: string | null,
              paymentUserId?: string | null,
              disbursementMethodId?: string | null,
              receivingAccounts?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              ubosCreated?: boolean | null,
              numUbosCreated?: number | null,
              subCategory?: string | null,
              clientsStatus?: EntityClientsStatus | null,
              ocrEmail?: string | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              owner?: string | null,
              referredBy?: string | null,
              connectedAccount?: string | null,
              accountStatus?: AccountStatus | null,
              customerId?: string | null,
              xeroSyncStatus?: XeroSyncStatus | null,
              xeroLastContactSyncAt?: string | null,
              xeroContactSyncStatus?: XeroSyncStatus | null,
              xeroInvoiceSyncStatus?: XeroSyncStatus | null,
              xeroLastInvoiceSyncAt?: string | null,
              xeroTenantId?: string | null,
              absorbFees?: boolean | null,
              subscriptionTier?: SubscriptionTier | null,
              invitationStatus?: InvitationStatus | null,
              clientsOnboardingStatus?: ClientsOnboardingStatus | null,
              createdBy?: string | null,
              createdByEntityId?: string | null,
              isFirm?: boolean | null,
              createdAt?: string | null,
              updatedAt?: string | null,
            } | null,
            firm?:  {
              __typename: "Entity",
              id: string,
              type: EntityType,
              taxNumber?: string | null,
              companyNumber?: string | null,
              billerCode?: number | null,
              name: string,
              legalName?: string | null,
              businessNames?: Array< string | null > | null,
              searchName?: string | null,
              address?:  {
                __typename: "Address",
                addressId?: string | null,
                contactName?: string | null,
                contactNumber?: string | null,
                fullAddress?: string | null,
                address1?: string | null,
                address2?: string | null,
                city?: string | null,
                country: string,
                countryCode: string,
                state: string,
                stateCode?: string | null,
                postalCode: string,
                invalid?: boolean | null,
              } | null,
              logo?:  {
                __typename: "Image",
                alt?: string | null,
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type?: string | null,
              } | null,
              brandColour?: string | null,
              website?: string | null,
              entityUsers?:  {
                __typename: "ModelEntityUserConnection",
                nextToken?: string | null,
              } | null,
              gstRegistered?: boolean | null,
              gstReportingPeriod?: GSTReportingPeriod | null,
              providerEntityId?: string | null,
              providerCompanyId?: string | null,
              providerBillUserCompanyId?: string | null,
              providerBankAccountId?: string | null,
              providerDigitalWalletId?: string | null,
              providerBpayCrn?: string | null,
              contact?:  {
                __typename: "EntityContact",
                firstName?: string | null,
                lastName?: string | null,
                email?: string | null,
                phone?: string | null,
                role?: string | null,
              } | null,
              paymentMethods?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              paymentMethodId?: string | null,
              paymentUserId?: string | null,
              disbursementMethodId?: string | null,
              receivingAccounts?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              ubosCreated?: boolean | null,
              numUbosCreated?: number | null,
              subCategory?: string | null,
              clientsStatus?: EntityClientsStatus | null,
              ocrEmail?: string | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              owner?: string | null,
              referredBy?: string | null,
              connectedAccount?: string | null,
              accountStatus?: AccountStatus | null,
              customerId?: string | null,
              xeroSyncStatus?: XeroSyncStatus | null,
              xeroLastContactSyncAt?: string | null,
              xeroContactSyncStatus?: XeroSyncStatus | null,
              xeroInvoiceSyncStatus?: XeroSyncStatus | null,
              xeroLastInvoiceSyncAt?: string | null,
              xeroTenantId?: string | null,
              absorbFees?: boolean | null,
              subscriptionTier?: SubscriptionTier | null,
              invitationStatus?: InvitationStatus | null,
              clientsOnboardingStatus?: ClientsOnboardingStatus | null,
              createdBy?: string | null,
              createdByEntityId?: string | null,
              isFirm?: boolean | null,
              createdAt?: string | null,
              updatedAt?: string | null,
            } | null,
            searchName?: string | null,
            taxNumber?: string | null,
            taskSendSMS?: boolean | null,
            companyNumber?: string | null,
            createdBy?: string | null,
            createdAt: string,
            updatedAt: string,
            status?: EntityUserStatus | null,
            partnerId?: string | null,
            managerId?: string | null,
            archivedAt?: string | null,
            taxPaymentReferences?:  {
              __typename: "TaxPaymentReferences",
              itr?:  {
                __typename: "TaxPaymentReference",
                referenceNumber?: string | null,
                updatedAt?: string | null,
              } | null,
              other?:  {
                __typename: "TaxPaymentReference",
                referenceNumber?: string | null,
                updatedAt?: string | null,
              } | null,
            } | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        gstRegistered?: boolean | null,
        gstReportingPeriod?: GSTReportingPeriod | null,
        providerEntityId?: string | null,
        providerCompanyId?: string | null,
        providerBillUserCompanyId?: string | null,
        providerBankAccountId?: string | null,
        providerDigitalWalletId?: string | null,
        providerBpayCrn?: string | null,
        contact?:  {
          __typename: "EntityContact",
          firstName?: string | null,
          lastName?: string | null,
          email?: string | null,
          phone?: string | null,
          role?: string | null,
        } | null,
        paymentMethods?:  {
          __typename: "ModelPaymentMethodConnection",
          items:  Array< {
            __typename: "PaymentMethod",
            id: string,
            paymentMethodType: PaymentMethodType,
            type?: string | null,
            fullName?: string | null,
            number?: string | null,
            expMonth?: string | null,
            expYear?: string | null,
            accountName?: string | null,
            bankName?: string | null,
            accountNumber?: string | null,
            routingNumber?: string | null,
            holderType?: BankHolderType | null,
            accountType?: BankAccountType | null,
            status?: PaymentMethodStatus | null,
            accountDirection?: AccountDirection | null,
            expiresAt?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            consentId?: string | null,
            consentStatus?: PaymentConsentStatus | null,
            card?: string | null,
            googlepay?: string | null,
            applepay?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        paymentMethodId?: string | null,
        paymentUserId?: string | null,
        disbursementMethodId?: string | null,
        receivingAccounts?:  {
          __typename: "ModelPaymentMethodConnection",
          items:  Array< {
            __typename: "PaymentMethod",
            id: string,
            paymentMethodType: PaymentMethodType,
            type?: string | null,
            fullName?: string | null,
            number?: string | null,
            expMonth?: string | null,
            expYear?: string | null,
            accountName?: string | null,
            bankName?: string | null,
            accountNumber?: string | null,
            routingNumber?: string | null,
            holderType?: BankHolderType | null,
            accountType?: BankAccountType | null,
            status?: PaymentMethodStatus | null,
            accountDirection?: AccountDirection | null,
            expiresAt?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            consentId?: string | null,
            consentStatus?: PaymentConsentStatus | null,
            card?: string | null,
            googlepay?: string | null,
            applepay?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        ubosCreated?: boolean | null,
        numUbosCreated?: number | null,
        subCategory?: string | null,
        clientsStatus?: EntityClientsStatus | null,
        ocrEmail?: string | null,
        termsInvoiceAccepted?: boolean | null,
        termsOcrAccepted?: boolean | null,
        owner?: string | null,
        referredBy?: string | null,
        connectedAccount?: string | null,
        accountStatus?: AccountStatus | null,
        customerId?: string | null,
        xeroSyncStatus?: XeroSyncStatus | null,
        xeroLastContactSyncAt?: string | null,
        xeroContactSyncStatus?: XeroSyncStatus | null,
        xeroInvoiceSyncStatus?: XeroSyncStatus | null,
        xeroLastInvoiceSyncAt?: string | null,
        xeroTenantId?: string | null,
        absorbFees?: boolean | null,
        subscriptionTier?: SubscriptionTier | null,
        invitationStatus?: InvitationStatus | null,
        clientsOnboardingStatus?: ClientsOnboardingStatus | null,
        createdBy?: string | null,
        createdByEntityId?: string | null,
        isFirm?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      firm?:  {
        __typename: "Entity",
        id: string,
        type: EntityType,
        taxNumber?: string | null,
        companyNumber?: string | null,
        billerCode?: number | null,
        name: string,
        legalName?: string | null,
        businessNames?: Array< string | null > | null,
        searchName?: string | null,
        address?:  {
          __typename: "Address",
          addressId?: string | null,
          contactName?: string | null,
          contactNumber?: string | null,
          fullAddress?: string | null,
          address1?: string | null,
          address2?: string | null,
          city?: string | null,
          country: string,
          countryCode: string,
          state: string,
          stateCode?: string | null,
          postalCode: string,
          invalid?: boolean | null,
        } | null,
        logo?:  {
          __typename: "Image",
          alt?: string | null,
          identityId?: string | null,
          key: string,
          level: S3UploadLevel,
          type?: string | null,
        } | null,
        brandColour?: string | null,
        website?: string | null,
        entityUsers?:  {
          __typename: "ModelEntityUserConnection",
          items:  Array< {
            __typename: "EntityUser",
            id: string,
            entityId: string,
            userId: string,
            firmId?: string | null,
            email?: string | null,
            invitedEmail?: string | null,
            ocrEmail?: string | null,
            referredBy?: string | null,
            invitedEntityId?: string | null,
            firmEntityId?: string | null,
            providerContactId?: string | null,
            ownerCode?: string | null,
            clientGroupCode?: string | null,
            clientCode?: string | null,
            firstName?: string | null,
            lastName?: string | null,
            role: EntityUserRole,
            jobTags?: Array< JobTags | null > | null,
            paymentsEnabled?: boolean | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            termsFirmPayTaxAccepted?: boolean | null,
            termsFirmPayTaxDetails?:  {
              __typename: "TermsFirmPayTaxDetails",
              document?:  {
                __typename: "S3Upload",
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type: S3UploadType,
                name?: string | null,
              } | null,
              acceptedAt?: string | null,
              email?: string | null,
              ip?: string | null,
              fullName?: string | null,
              firmId?: string | null,
            } | null,
            entitySearchName?: string | null,
            entity?:  {
              __typename: "Entity",
              id: string,
              type: EntityType,
              taxNumber?: string | null,
              companyNumber?: string | null,
              billerCode?: number | null,
              name: string,
              legalName?: string | null,
              businessNames?: Array< string | null > | null,
              searchName?: string | null,
              address?:  {
                __typename: "Address",
                addressId?: string | null,
                contactName?: string | null,
                contactNumber?: string | null,
                fullAddress?: string | null,
                address1?: string | null,
                address2?: string | null,
                city?: string | null,
                country: string,
                countryCode: string,
                state: string,
                stateCode?: string | null,
                postalCode: string,
                invalid?: boolean | null,
              } | null,
              logo?:  {
                __typename: "Image",
                alt?: string | null,
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type?: string | null,
              } | null,
              brandColour?: string | null,
              website?: string | null,
              entityUsers?:  {
                __typename: "ModelEntityUserConnection",
                nextToken?: string | null,
              } | null,
              gstRegistered?: boolean | null,
              gstReportingPeriod?: GSTReportingPeriod | null,
              providerEntityId?: string | null,
              providerCompanyId?: string | null,
              providerBillUserCompanyId?: string | null,
              providerBankAccountId?: string | null,
              providerDigitalWalletId?: string | null,
              providerBpayCrn?: string | null,
              contact?:  {
                __typename: "EntityContact",
                firstName?: string | null,
                lastName?: string | null,
                email?: string | null,
                phone?: string | null,
                role?: string | null,
              } | null,
              paymentMethods?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              paymentMethodId?: string | null,
              paymentUserId?: string | null,
              disbursementMethodId?: string | null,
              receivingAccounts?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              ubosCreated?: boolean | null,
              numUbosCreated?: number | null,
              subCategory?: string | null,
              clientsStatus?: EntityClientsStatus | null,
              ocrEmail?: string | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              owner?: string | null,
              referredBy?: string | null,
              connectedAccount?: string | null,
              accountStatus?: AccountStatus | null,
              customerId?: string | null,
              xeroSyncStatus?: XeroSyncStatus | null,
              xeroLastContactSyncAt?: string | null,
              xeroContactSyncStatus?: XeroSyncStatus | null,
              xeroInvoiceSyncStatus?: XeroSyncStatus | null,
              xeroLastInvoiceSyncAt?: string | null,
              xeroTenantId?: string | null,
              absorbFees?: boolean | null,
              subscriptionTier?: SubscriptionTier | null,
              invitationStatus?: InvitationStatus | null,
              clientsOnboardingStatus?: ClientsOnboardingStatus | null,
              createdBy?: string | null,
              createdByEntityId?: string | null,
              isFirm?: boolean | null,
              createdAt?: string | null,
              updatedAt?: string | null,
            } | null,
            firm?:  {
              __typename: "Entity",
              id: string,
              type: EntityType,
              taxNumber?: string | null,
              companyNumber?: string | null,
              billerCode?: number | null,
              name: string,
              legalName?: string | null,
              businessNames?: Array< string | null > | null,
              searchName?: string | null,
              address?:  {
                __typename: "Address",
                addressId?: string | null,
                contactName?: string | null,
                contactNumber?: string | null,
                fullAddress?: string | null,
                address1?: string | null,
                address2?: string | null,
                city?: string | null,
                country: string,
                countryCode: string,
                state: string,
                stateCode?: string | null,
                postalCode: string,
                invalid?: boolean | null,
              } | null,
              logo?:  {
                __typename: "Image",
                alt?: string | null,
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type?: string | null,
              } | null,
              brandColour?: string | null,
              website?: string | null,
              entityUsers?:  {
                __typename: "ModelEntityUserConnection",
                nextToken?: string | null,
              } | null,
              gstRegistered?: boolean | null,
              gstReportingPeriod?: GSTReportingPeriod | null,
              providerEntityId?: string | null,
              providerCompanyId?: string | null,
              providerBillUserCompanyId?: string | null,
              providerBankAccountId?: string | null,
              providerDigitalWalletId?: string | null,
              providerBpayCrn?: string | null,
              contact?:  {
                __typename: "EntityContact",
                firstName?: string | null,
                lastName?: string | null,
                email?: string | null,
                phone?: string | null,
                role?: string | null,
              } | null,
              paymentMethods?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              paymentMethodId?: string | null,
              paymentUserId?: string | null,
              disbursementMethodId?: string | null,
              receivingAccounts?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              ubosCreated?: boolean | null,
              numUbosCreated?: number | null,
              subCategory?: string | null,
              clientsStatus?: EntityClientsStatus | null,
              ocrEmail?: string | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              owner?: string | null,
              referredBy?: string | null,
              connectedAccount?: string | null,
              accountStatus?: AccountStatus | null,
              customerId?: string | null,
              xeroSyncStatus?: XeroSyncStatus | null,
              xeroLastContactSyncAt?: string | null,
              xeroContactSyncStatus?: XeroSyncStatus | null,
              xeroInvoiceSyncStatus?: XeroSyncStatus | null,
              xeroLastInvoiceSyncAt?: string | null,
              xeroTenantId?: string | null,
              absorbFees?: boolean | null,
              subscriptionTier?: SubscriptionTier | null,
              invitationStatus?: InvitationStatus | null,
              clientsOnboardingStatus?: ClientsOnboardingStatus | null,
              createdBy?: string | null,
              createdByEntityId?: string | null,
              isFirm?: boolean | null,
              createdAt?: string | null,
              updatedAt?: string | null,
            } | null,
            searchName?: string | null,
            taxNumber?: string | null,
            taskSendSMS?: boolean | null,
            companyNumber?: string | null,
            createdBy?: string | null,
            createdAt: string,
            updatedAt: string,
            status?: EntityUserStatus | null,
            partnerId?: string | null,
            managerId?: string | null,
            archivedAt?: string | null,
            taxPaymentReferences?:  {
              __typename: "TaxPaymentReferences",
              itr?:  {
                __typename: "TaxPaymentReference",
                referenceNumber?: string | null,
                updatedAt?: string | null,
              } | null,
              other?:  {
                __typename: "TaxPaymentReference",
                referenceNumber?: string | null,
                updatedAt?: string | null,
              } | null,
            } | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        gstRegistered?: boolean | null,
        gstReportingPeriod?: GSTReportingPeriod | null,
        providerEntityId?: string | null,
        providerCompanyId?: string | null,
        providerBillUserCompanyId?: string | null,
        providerBankAccountId?: string | null,
        providerDigitalWalletId?: string | null,
        providerBpayCrn?: string | null,
        contact?:  {
          __typename: "EntityContact",
          firstName?: string | null,
          lastName?: string | null,
          email?: string | null,
          phone?: string | null,
          role?: string | null,
        } | null,
        paymentMethods?:  {
          __typename: "ModelPaymentMethodConnection",
          items:  Array< {
            __typename: "PaymentMethod",
            id: string,
            paymentMethodType: PaymentMethodType,
            type?: string | null,
            fullName?: string | null,
            number?: string | null,
            expMonth?: string | null,
            expYear?: string | null,
            accountName?: string | null,
            bankName?: string | null,
            accountNumber?: string | null,
            routingNumber?: string | null,
            holderType?: BankHolderType | null,
            accountType?: BankAccountType | null,
            status?: PaymentMethodStatus | null,
            accountDirection?: AccountDirection | null,
            expiresAt?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            consentId?: string | null,
            consentStatus?: PaymentConsentStatus | null,
            card?: string | null,
            googlepay?: string | null,
            applepay?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        paymentMethodId?: string | null,
        paymentUserId?: string | null,
        disbursementMethodId?: string | null,
        receivingAccounts?:  {
          __typename: "ModelPaymentMethodConnection",
          items:  Array< {
            __typename: "PaymentMethod",
            id: string,
            paymentMethodType: PaymentMethodType,
            type?: string | null,
            fullName?: string | null,
            number?: string | null,
            expMonth?: string | null,
            expYear?: string | null,
            accountName?: string | null,
            bankName?: string | null,
            accountNumber?: string | null,
            routingNumber?: string | null,
            holderType?: BankHolderType | null,
            accountType?: BankAccountType | null,
            status?: PaymentMethodStatus | null,
            accountDirection?: AccountDirection | null,
            expiresAt?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            consentId?: string | null,
            consentStatus?: PaymentConsentStatus | null,
            card?: string | null,
            googlepay?: string | null,
            applepay?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        ubosCreated?: boolean | null,
        numUbosCreated?: number | null,
        subCategory?: string | null,
        clientsStatus?: EntityClientsStatus | null,
        ocrEmail?: string | null,
        termsInvoiceAccepted?: boolean | null,
        termsOcrAccepted?: boolean | null,
        owner?: string | null,
        referredBy?: string | null,
        connectedAccount?: string | null,
        accountStatus?: AccountStatus | null,
        customerId?: string | null,
        xeroSyncStatus?: XeroSyncStatus | null,
        xeroLastContactSyncAt?: string | null,
        xeroContactSyncStatus?: XeroSyncStatus | null,
        xeroInvoiceSyncStatus?: XeroSyncStatus | null,
        xeroLastInvoiceSyncAt?: string | null,
        xeroTenantId?: string | null,
        absorbFees?: boolean | null,
        subscriptionTier?: SubscriptionTier | null,
        invitationStatus?: InvitationStatus | null,
        clientsOnboardingStatus?: ClientsOnboardingStatus | null,
        createdBy?: string | null,
        createdByEntityId?: string | null,
        isFirm?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      searchName?: string | null,
      taxNumber?: string | null,
      taskSendSMS?: boolean | null,
      companyNumber?: string | null,
      createdBy?: string | null,
      createdAt: string,
      updatedAt: string,
      status?: EntityUserStatus | null,
      partnerId?: string | null,
      managerId?: string | null,
      archivedAt?: string | null,
      taxPaymentReferences?:  {
        __typename: "TaxPaymentReferences",
        itr?:  {
          __typename: "TaxPaymentReference",
          referenceNumber?: string | null,
          updatedAt?: string | null,
        } | null,
        other?:  {
          __typename: "TaxPaymentReference",
          referenceNumber?: string | null,
          updatedAt?: string | null,
        } | null,
      } | null,
    } | null >,
    total?: number | null,
  } | null,
};

export type EntityUsersByFirmIdQueryVariables = {
  firmId: string,
  searchName?: string | null,
  clientGroupCode?: string | null,
  roles?: Array< EntityUserRole | null > | null,
  sortDirection?: ModelSortDirection | null,
  from?: number | null,
  limit?: number | null,
  nextToken?: string | null,
  includeArchived?: boolean | null,
  archivedOnly?: boolean | null,
};

export type EntityUsersByFirmIdQuery = {
  entityUsersByFirmId?:  {
    __typename: "ModelEntityUserOSConnection",
    items:  Array< {
      __typename: "EntityUser",
      id: string,
      entityId: string,
      userId: string,
      firmId?: string | null,
      email?: string | null,
      invitedEmail?: string | null,
      ocrEmail?: string | null,
      referredBy?: string | null,
      invitedEntityId?: string | null,
      firmEntityId?: string | null,
      providerContactId?: string | null,
      ownerCode?: string | null,
      clientGroupCode?: string | null,
      clientCode?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      role: EntityUserRole,
      jobTags?: Array< JobTags | null > | null,
      paymentsEnabled?: boolean | null,
      termsInvoiceAccepted?: boolean | null,
      termsOcrAccepted?: boolean | null,
      termsFirmPayTaxAccepted?: boolean | null,
      termsFirmPayTaxDetails?:  {
        __typename: "TermsFirmPayTaxDetails",
        document?:  {
          __typename: "S3Upload",
          identityId?: string | null,
          key: string,
          level: S3UploadLevel,
          type: S3UploadType,
          name?: string | null,
        } | null,
        acceptedAt?: string | null,
        email?: string | null,
        ip?: string | null,
        fullName?: string | null,
        firmId?: string | null,
      } | null,
      entitySearchName?: string | null,
      entity?:  {
        __typename: "Entity",
        id: string,
        type: EntityType,
        taxNumber?: string | null,
        companyNumber?: string | null,
        billerCode?: number | null,
        name: string,
        legalName?: string | null,
        businessNames?: Array< string | null > | null,
        searchName?: string | null,
        address?:  {
          __typename: "Address",
          addressId?: string | null,
          contactName?: string | null,
          contactNumber?: string | null,
          fullAddress?: string | null,
          address1?: string | null,
          address2?: string | null,
          city?: string | null,
          country: string,
          countryCode: string,
          state: string,
          stateCode?: string | null,
          postalCode: string,
          invalid?: boolean | null,
        } | null,
        logo?:  {
          __typename: "Image",
          alt?: string | null,
          identityId?: string | null,
          key: string,
          level: S3UploadLevel,
          type?: string | null,
        } | null,
        brandColour?: string | null,
        website?: string | null,
        entityUsers?:  {
          __typename: "ModelEntityUserConnection",
          items:  Array< {
            __typename: "EntityUser",
            id: string,
            entityId: string,
            userId: string,
            firmId?: string | null,
            email?: string | null,
            invitedEmail?: string | null,
            ocrEmail?: string | null,
            referredBy?: string | null,
            invitedEntityId?: string | null,
            firmEntityId?: string | null,
            providerContactId?: string | null,
            ownerCode?: string | null,
            clientGroupCode?: string | null,
            clientCode?: string | null,
            firstName?: string | null,
            lastName?: string | null,
            role: EntityUserRole,
            jobTags?: Array< JobTags | null > | null,
            paymentsEnabled?: boolean | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            termsFirmPayTaxAccepted?: boolean | null,
            termsFirmPayTaxDetails?:  {
              __typename: "TermsFirmPayTaxDetails",
              document?:  {
                __typename: "S3Upload",
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type: S3UploadType,
                name?: string | null,
              } | null,
              acceptedAt?: string | null,
              email?: string | null,
              ip?: string | null,
              fullName?: string | null,
              firmId?: string | null,
            } | null,
            entitySearchName?: string | null,
            entity?:  {
              __typename: "Entity",
              id: string,
              type: EntityType,
              taxNumber?: string | null,
              companyNumber?: string | null,
              billerCode?: number | null,
              name: string,
              legalName?: string | null,
              businessNames?: Array< string | null > | null,
              searchName?: string | null,
              address?:  {
                __typename: "Address",
                addressId?: string | null,
                contactName?: string | null,
                contactNumber?: string | null,
                fullAddress?: string | null,
                address1?: string | null,
                address2?: string | null,
                city?: string | null,
                country: string,
                countryCode: string,
                state: string,
                stateCode?: string | null,
                postalCode: string,
                invalid?: boolean | null,
              } | null,
              logo?:  {
                __typename: "Image",
                alt?: string | null,
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type?: string | null,
              } | null,
              brandColour?: string | null,
              website?: string | null,
              entityUsers?:  {
                __typename: "ModelEntityUserConnection",
                nextToken?: string | null,
              } | null,
              gstRegistered?: boolean | null,
              gstReportingPeriod?: GSTReportingPeriod | null,
              providerEntityId?: string | null,
              providerCompanyId?: string | null,
              providerBillUserCompanyId?: string | null,
              providerBankAccountId?: string | null,
              providerDigitalWalletId?: string | null,
              providerBpayCrn?: string | null,
              contact?:  {
                __typename: "EntityContact",
                firstName?: string | null,
                lastName?: string | null,
                email?: string | null,
                phone?: string | null,
                role?: string | null,
              } | null,
              paymentMethods?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              paymentMethodId?: string | null,
              paymentUserId?: string | null,
              disbursementMethodId?: string | null,
              receivingAccounts?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              ubosCreated?: boolean | null,
              numUbosCreated?: number | null,
              subCategory?: string | null,
              clientsStatus?: EntityClientsStatus | null,
              ocrEmail?: string | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              owner?: string | null,
              referredBy?: string | null,
              connectedAccount?: string | null,
              accountStatus?: AccountStatus | null,
              customerId?: string | null,
              xeroSyncStatus?: XeroSyncStatus | null,
              xeroLastContactSyncAt?: string | null,
              xeroContactSyncStatus?: XeroSyncStatus | null,
              xeroInvoiceSyncStatus?: XeroSyncStatus | null,
              xeroLastInvoiceSyncAt?: string | null,
              xeroTenantId?: string | null,
              absorbFees?: boolean | null,
              subscriptionTier?: SubscriptionTier | null,
              invitationStatus?: InvitationStatus | null,
              clientsOnboardingStatus?: ClientsOnboardingStatus | null,
              createdBy?: string | null,
              createdByEntityId?: string | null,
              isFirm?: boolean | null,
              createdAt?: string | null,
              updatedAt?: string | null,
            } | null,
            firm?:  {
              __typename: "Entity",
              id: string,
              type: EntityType,
              taxNumber?: string | null,
              companyNumber?: string | null,
              billerCode?: number | null,
              name: string,
              legalName?: string | null,
              businessNames?: Array< string | null > | null,
              searchName?: string | null,
              address?:  {
                __typename: "Address",
                addressId?: string | null,
                contactName?: string | null,
                contactNumber?: string | null,
                fullAddress?: string | null,
                address1?: string | null,
                address2?: string | null,
                city?: string | null,
                country: string,
                countryCode: string,
                state: string,
                stateCode?: string | null,
                postalCode: string,
                invalid?: boolean | null,
              } | null,
              logo?:  {
                __typename: "Image",
                alt?: string | null,
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type?: string | null,
              } | null,
              brandColour?: string | null,
              website?: string | null,
              entityUsers?:  {
                __typename: "ModelEntityUserConnection",
                nextToken?: string | null,
              } | null,
              gstRegistered?: boolean | null,
              gstReportingPeriod?: GSTReportingPeriod | null,
              providerEntityId?: string | null,
              providerCompanyId?: string | null,
              providerBillUserCompanyId?: string | null,
              providerBankAccountId?: string | null,
              providerDigitalWalletId?: string | null,
              providerBpayCrn?: string | null,
              contact?:  {
                __typename: "EntityContact",
                firstName?: string | null,
                lastName?: string | null,
                email?: string | null,
                phone?: string | null,
                role?: string | null,
              } | null,
              paymentMethods?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              paymentMethodId?: string | null,
              paymentUserId?: string | null,
              disbursementMethodId?: string | null,
              receivingAccounts?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              ubosCreated?: boolean | null,
              numUbosCreated?: number | null,
              subCategory?: string | null,
              clientsStatus?: EntityClientsStatus | null,
              ocrEmail?: string | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              owner?: string | null,
              referredBy?: string | null,
              connectedAccount?: string | null,
              accountStatus?: AccountStatus | null,
              customerId?: string | null,
              xeroSyncStatus?: XeroSyncStatus | null,
              xeroLastContactSyncAt?: string | null,
              xeroContactSyncStatus?: XeroSyncStatus | null,
              xeroInvoiceSyncStatus?: XeroSyncStatus | null,
              xeroLastInvoiceSyncAt?: string | null,
              xeroTenantId?: string | null,
              absorbFees?: boolean | null,
              subscriptionTier?: SubscriptionTier | null,
              invitationStatus?: InvitationStatus | null,
              clientsOnboardingStatus?: ClientsOnboardingStatus | null,
              createdBy?: string | null,
              createdByEntityId?: string | null,
              isFirm?: boolean | null,
              createdAt?: string | null,
              updatedAt?: string | null,
            } | null,
            searchName?: string | null,
            taxNumber?: string | null,
            taskSendSMS?: boolean | null,
            companyNumber?: string | null,
            createdBy?: string | null,
            createdAt: string,
            updatedAt: string,
            status?: EntityUserStatus | null,
            partnerId?: string | null,
            managerId?: string | null,
            archivedAt?: string | null,
            taxPaymentReferences?:  {
              __typename: "TaxPaymentReferences",
              itr?:  {
                __typename: "TaxPaymentReference",
                referenceNumber?: string | null,
                updatedAt?: string | null,
              } | null,
              other?:  {
                __typename: "TaxPaymentReference",
                referenceNumber?: string | null,
                updatedAt?: string | null,
              } | null,
            } | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        gstRegistered?: boolean | null,
        gstReportingPeriod?: GSTReportingPeriod | null,
        providerEntityId?: string | null,
        providerCompanyId?: string | null,
        providerBillUserCompanyId?: string | null,
        providerBankAccountId?: string | null,
        providerDigitalWalletId?: string | null,
        providerBpayCrn?: string | null,
        contact?:  {
          __typename: "EntityContact",
          firstName?: string | null,
          lastName?: string | null,
          email?: string | null,
          phone?: string | null,
          role?: string | null,
        } | null,
        paymentMethods?:  {
          __typename: "ModelPaymentMethodConnection",
          items:  Array< {
            __typename: "PaymentMethod",
            id: string,
            paymentMethodType: PaymentMethodType,
            type?: string | null,
            fullName?: string | null,
            number?: string | null,
            expMonth?: string | null,
            expYear?: string | null,
            accountName?: string | null,
            bankName?: string | null,
            accountNumber?: string | null,
            routingNumber?: string | null,
            holderType?: BankHolderType | null,
            accountType?: BankAccountType | null,
            status?: PaymentMethodStatus | null,
            accountDirection?: AccountDirection | null,
            expiresAt?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            consentId?: string | null,
            consentStatus?: PaymentConsentStatus | null,
            card?: string | null,
            googlepay?: string | null,
            applepay?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        paymentMethodId?: string | null,
        paymentUserId?: string | null,
        disbursementMethodId?: string | null,
        receivingAccounts?:  {
          __typename: "ModelPaymentMethodConnection",
          items:  Array< {
            __typename: "PaymentMethod",
            id: string,
            paymentMethodType: PaymentMethodType,
            type?: string | null,
            fullName?: string | null,
            number?: string | null,
            expMonth?: string | null,
            expYear?: string | null,
            accountName?: string | null,
            bankName?: string | null,
            accountNumber?: string | null,
            routingNumber?: string | null,
            holderType?: BankHolderType | null,
            accountType?: BankAccountType | null,
            status?: PaymentMethodStatus | null,
            accountDirection?: AccountDirection | null,
            expiresAt?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            consentId?: string | null,
            consentStatus?: PaymentConsentStatus | null,
            card?: string | null,
            googlepay?: string | null,
            applepay?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        ubosCreated?: boolean | null,
        numUbosCreated?: number | null,
        subCategory?: string | null,
        clientsStatus?: EntityClientsStatus | null,
        ocrEmail?: string | null,
        termsInvoiceAccepted?: boolean | null,
        termsOcrAccepted?: boolean | null,
        owner?: string | null,
        referredBy?: string | null,
        connectedAccount?: string | null,
        accountStatus?: AccountStatus | null,
        customerId?: string | null,
        xeroSyncStatus?: XeroSyncStatus | null,
        xeroLastContactSyncAt?: string | null,
        xeroContactSyncStatus?: XeroSyncStatus | null,
        xeroInvoiceSyncStatus?: XeroSyncStatus | null,
        xeroLastInvoiceSyncAt?: string | null,
        xeroTenantId?: string | null,
        absorbFees?: boolean | null,
        subscriptionTier?: SubscriptionTier | null,
        invitationStatus?: InvitationStatus | null,
        clientsOnboardingStatus?: ClientsOnboardingStatus | null,
        createdBy?: string | null,
        createdByEntityId?: string | null,
        isFirm?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      firm?:  {
        __typename: "Entity",
        id: string,
        type: EntityType,
        taxNumber?: string | null,
        companyNumber?: string | null,
        billerCode?: number | null,
        name: string,
        legalName?: string | null,
        businessNames?: Array< string | null > | null,
        searchName?: string | null,
        address?:  {
          __typename: "Address",
          addressId?: string | null,
          contactName?: string | null,
          contactNumber?: string | null,
          fullAddress?: string | null,
          address1?: string | null,
          address2?: string | null,
          city?: string | null,
          country: string,
          countryCode: string,
          state: string,
          stateCode?: string | null,
          postalCode: string,
          invalid?: boolean | null,
        } | null,
        logo?:  {
          __typename: "Image",
          alt?: string | null,
          identityId?: string | null,
          key: string,
          level: S3UploadLevel,
          type?: string | null,
        } | null,
        brandColour?: string | null,
        website?: string | null,
        entityUsers?:  {
          __typename: "ModelEntityUserConnection",
          items:  Array< {
            __typename: "EntityUser",
            id: string,
            entityId: string,
            userId: string,
            firmId?: string | null,
            email?: string | null,
            invitedEmail?: string | null,
            ocrEmail?: string | null,
            referredBy?: string | null,
            invitedEntityId?: string | null,
            firmEntityId?: string | null,
            providerContactId?: string | null,
            ownerCode?: string | null,
            clientGroupCode?: string | null,
            clientCode?: string | null,
            firstName?: string | null,
            lastName?: string | null,
            role: EntityUserRole,
            jobTags?: Array< JobTags | null > | null,
            paymentsEnabled?: boolean | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            termsFirmPayTaxAccepted?: boolean | null,
            termsFirmPayTaxDetails?:  {
              __typename: "TermsFirmPayTaxDetails",
              document?:  {
                __typename: "S3Upload",
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type: S3UploadType,
                name?: string | null,
              } | null,
              acceptedAt?: string | null,
              email?: string | null,
              ip?: string | null,
              fullName?: string | null,
              firmId?: string | null,
            } | null,
            entitySearchName?: string | null,
            entity?:  {
              __typename: "Entity",
              id: string,
              type: EntityType,
              taxNumber?: string | null,
              companyNumber?: string | null,
              billerCode?: number | null,
              name: string,
              legalName?: string | null,
              businessNames?: Array< string | null > | null,
              searchName?: string | null,
              address?:  {
                __typename: "Address",
                addressId?: string | null,
                contactName?: string | null,
                contactNumber?: string | null,
                fullAddress?: string | null,
                address1?: string | null,
                address2?: string | null,
                city?: string | null,
                country: string,
                countryCode: string,
                state: string,
                stateCode?: string | null,
                postalCode: string,
                invalid?: boolean | null,
              } | null,
              logo?:  {
                __typename: "Image",
                alt?: string | null,
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type?: string | null,
              } | null,
              brandColour?: string | null,
              website?: string | null,
              entityUsers?:  {
                __typename: "ModelEntityUserConnection",
                nextToken?: string | null,
              } | null,
              gstRegistered?: boolean | null,
              gstReportingPeriod?: GSTReportingPeriod | null,
              providerEntityId?: string | null,
              providerCompanyId?: string | null,
              providerBillUserCompanyId?: string | null,
              providerBankAccountId?: string | null,
              providerDigitalWalletId?: string | null,
              providerBpayCrn?: string | null,
              contact?:  {
                __typename: "EntityContact",
                firstName?: string | null,
                lastName?: string | null,
                email?: string | null,
                phone?: string | null,
                role?: string | null,
              } | null,
              paymentMethods?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              paymentMethodId?: string | null,
              paymentUserId?: string | null,
              disbursementMethodId?: string | null,
              receivingAccounts?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              ubosCreated?: boolean | null,
              numUbosCreated?: number | null,
              subCategory?: string | null,
              clientsStatus?: EntityClientsStatus | null,
              ocrEmail?: string | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              owner?: string | null,
              referredBy?: string | null,
              connectedAccount?: string | null,
              accountStatus?: AccountStatus | null,
              customerId?: string | null,
              xeroSyncStatus?: XeroSyncStatus | null,
              xeroLastContactSyncAt?: string | null,
              xeroContactSyncStatus?: XeroSyncStatus | null,
              xeroInvoiceSyncStatus?: XeroSyncStatus | null,
              xeroLastInvoiceSyncAt?: string | null,
              xeroTenantId?: string | null,
              absorbFees?: boolean | null,
              subscriptionTier?: SubscriptionTier | null,
              invitationStatus?: InvitationStatus | null,
              clientsOnboardingStatus?: ClientsOnboardingStatus | null,
              createdBy?: string | null,
              createdByEntityId?: string | null,
              isFirm?: boolean | null,
              createdAt?: string | null,
              updatedAt?: string | null,
            } | null,
            firm?:  {
              __typename: "Entity",
              id: string,
              type: EntityType,
              taxNumber?: string | null,
              companyNumber?: string | null,
              billerCode?: number | null,
              name: string,
              legalName?: string | null,
              businessNames?: Array< string | null > | null,
              searchName?: string | null,
              address?:  {
                __typename: "Address",
                addressId?: string | null,
                contactName?: string | null,
                contactNumber?: string | null,
                fullAddress?: string | null,
                address1?: string | null,
                address2?: string | null,
                city?: string | null,
                country: string,
                countryCode: string,
                state: string,
                stateCode?: string | null,
                postalCode: string,
                invalid?: boolean | null,
              } | null,
              logo?:  {
                __typename: "Image",
                alt?: string | null,
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type?: string | null,
              } | null,
              brandColour?: string | null,
              website?: string | null,
              entityUsers?:  {
                __typename: "ModelEntityUserConnection",
                nextToken?: string | null,
              } | null,
              gstRegistered?: boolean | null,
              gstReportingPeriod?: GSTReportingPeriod | null,
              providerEntityId?: string | null,
              providerCompanyId?: string | null,
              providerBillUserCompanyId?: string | null,
              providerBankAccountId?: string | null,
              providerDigitalWalletId?: string | null,
              providerBpayCrn?: string | null,
              contact?:  {
                __typename: "EntityContact",
                firstName?: string | null,
                lastName?: string | null,
                email?: string | null,
                phone?: string | null,
                role?: string | null,
              } | null,
              paymentMethods?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              paymentMethodId?: string | null,
              paymentUserId?: string | null,
              disbursementMethodId?: string | null,
              receivingAccounts?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              ubosCreated?: boolean | null,
              numUbosCreated?: number | null,
              subCategory?: string | null,
              clientsStatus?: EntityClientsStatus | null,
              ocrEmail?: string | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              owner?: string | null,
              referredBy?: string | null,
              connectedAccount?: string | null,
              accountStatus?: AccountStatus | null,
              customerId?: string | null,
              xeroSyncStatus?: XeroSyncStatus | null,
              xeroLastContactSyncAt?: string | null,
              xeroContactSyncStatus?: XeroSyncStatus | null,
              xeroInvoiceSyncStatus?: XeroSyncStatus | null,
              xeroLastInvoiceSyncAt?: string | null,
              xeroTenantId?: string | null,
              absorbFees?: boolean | null,
              subscriptionTier?: SubscriptionTier | null,
              invitationStatus?: InvitationStatus | null,
              clientsOnboardingStatus?: ClientsOnboardingStatus | null,
              createdBy?: string | null,
              createdByEntityId?: string | null,
              isFirm?: boolean | null,
              createdAt?: string | null,
              updatedAt?: string | null,
            } | null,
            searchName?: string | null,
            taxNumber?: string | null,
            taskSendSMS?: boolean | null,
            companyNumber?: string | null,
            createdBy?: string | null,
            createdAt: string,
            updatedAt: string,
            status?: EntityUserStatus | null,
            partnerId?: string | null,
            managerId?: string | null,
            archivedAt?: string | null,
            taxPaymentReferences?:  {
              __typename: "TaxPaymentReferences",
              itr?:  {
                __typename: "TaxPaymentReference",
                referenceNumber?: string | null,
                updatedAt?: string | null,
              } | null,
              other?:  {
                __typename: "TaxPaymentReference",
                referenceNumber?: string | null,
                updatedAt?: string | null,
              } | null,
            } | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        gstRegistered?: boolean | null,
        gstReportingPeriod?: GSTReportingPeriod | null,
        providerEntityId?: string | null,
        providerCompanyId?: string | null,
        providerBillUserCompanyId?: string | null,
        providerBankAccountId?: string | null,
        providerDigitalWalletId?: string | null,
        providerBpayCrn?: string | null,
        contact?:  {
          __typename: "EntityContact",
          firstName?: string | null,
          lastName?: string | null,
          email?: string | null,
          phone?: string | null,
          role?: string | null,
        } | null,
        paymentMethods?:  {
          __typename: "ModelPaymentMethodConnection",
          items:  Array< {
            __typename: "PaymentMethod",
            id: string,
            paymentMethodType: PaymentMethodType,
            type?: string | null,
            fullName?: string | null,
            number?: string | null,
            expMonth?: string | null,
            expYear?: string | null,
            accountName?: string | null,
            bankName?: string | null,
            accountNumber?: string | null,
            routingNumber?: string | null,
            holderType?: BankHolderType | null,
            accountType?: BankAccountType | null,
            status?: PaymentMethodStatus | null,
            accountDirection?: AccountDirection | null,
            expiresAt?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            consentId?: string | null,
            consentStatus?: PaymentConsentStatus | null,
            card?: string | null,
            googlepay?: string | null,
            applepay?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        paymentMethodId?: string | null,
        paymentUserId?: string | null,
        disbursementMethodId?: string | null,
        receivingAccounts?:  {
          __typename: "ModelPaymentMethodConnection",
          items:  Array< {
            __typename: "PaymentMethod",
            id: string,
            paymentMethodType: PaymentMethodType,
            type?: string | null,
            fullName?: string | null,
            number?: string | null,
            expMonth?: string | null,
            expYear?: string | null,
            accountName?: string | null,
            bankName?: string | null,
            accountNumber?: string | null,
            routingNumber?: string | null,
            holderType?: BankHolderType | null,
            accountType?: BankAccountType | null,
            status?: PaymentMethodStatus | null,
            accountDirection?: AccountDirection | null,
            expiresAt?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            consentId?: string | null,
            consentStatus?: PaymentConsentStatus | null,
            card?: string | null,
            googlepay?: string | null,
            applepay?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        ubosCreated?: boolean | null,
        numUbosCreated?: number | null,
        subCategory?: string | null,
        clientsStatus?: EntityClientsStatus | null,
        ocrEmail?: string | null,
        termsInvoiceAccepted?: boolean | null,
        termsOcrAccepted?: boolean | null,
        owner?: string | null,
        referredBy?: string | null,
        connectedAccount?: string | null,
        accountStatus?: AccountStatus | null,
        customerId?: string | null,
        xeroSyncStatus?: XeroSyncStatus | null,
        xeroLastContactSyncAt?: string | null,
        xeroContactSyncStatus?: XeroSyncStatus | null,
        xeroInvoiceSyncStatus?: XeroSyncStatus | null,
        xeroLastInvoiceSyncAt?: string | null,
        xeroTenantId?: string | null,
        absorbFees?: boolean | null,
        subscriptionTier?: SubscriptionTier | null,
        invitationStatus?: InvitationStatus | null,
        clientsOnboardingStatus?: ClientsOnboardingStatus | null,
        createdBy?: string | null,
        createdByEntityId?: string | null,
        isFirm?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      searchName?: string | null,
      taxNumber?: string | null,
      taskSendSMS?: boolean | null,
      companyNumber?: string | null,
      createdBy?: string | null,
      createdAt: string,
      updatedAt: string,
      status?: EntityUserStatus | null,
      partnerId?: string | null,
      managerId?: string | null,
      archivedAt?: string | null,
      taxPaymentReferences?:  {
        __typename: "TaxPaymentReferences",
        itr?:  {
          __typename: "TaxPaymentReference",
          referenceNumber?: string | null,
          updatedAt?: string | null,
        } | null,
        other?:  {
          __typename: "TaxPaymentReference",
          referenceNumber?: string | null,
          updatedAt?: string | null,
        } | null,
      } | null,
    } | null >,
    total?: number | null,
  } | null,
};

export type NotificationsByUserQueryVariables = {
  sortDirection?: ModelSortDirection | null,
  filter?: ModelNotificationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type NotificationsByUserQuery = {
  notificationsByUser?:  {
    __typename: "ModelNotificationConnection",
    items:  Array< {
      __typename: "Notification",
      id: string,
      title?: string | null,
      message?: string | null,
      status?: NotificationStatus | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetOptionQueryVariables = {
  id: string,
};

export type GetOptionQuery = {
  getOption?:  {
    __typename: "Option",
    name?: string | null,
    label: string,
    value: string,
    group?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    id: string,
  } | null,
};

export type ListOptionsQueryVariables = {
  filter?: ModelOptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListOptionsQuery = {
  listOptions?:  {
    __typename: "ModelOptionConnection",
    items:  Array< {
      __typename: "Option",
      name?: string | null,
      label: string,
      value: string,
      group?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      id: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type OptionsByNameQueryVariables = {
  name: string,
  label?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelOptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type OptionsByNameQuery = {
  optionsByName?:  {
    __typename: "ModelOptionConnection",
    items:  Array< {
      __typename: "Option",
      name?: string | null,
      label: string,
      value: string,
      group?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      id: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type OptionsByGroupQueryVariables = {
  group: string,
  label?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelOptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type OptionsByGroupQuery = {
  optionsByGroup?:  {
    __typename: "ModelOptionConnection",
    items:  Array< {
      __typename: "Option",
      name?: string | null,
      label: string,
      value: string,
      group?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      id: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPaymentGuestQueryVariables = {
  id: string,
};

export type GetPaymentGuestQuery = {
  getPaymentGuest?:  {
    __typename: "PaymentGuest",
    id: string,
    entityId: string,
    taskId?: string | null,
    paymentIntentId?: string | null,
    amount?: number | null,
    installment?: number | null,
    installments?: number | null,
    feeAmount?: number | null,
    paymentType?: PaymentType | null,
    taxAmount?: number | null,
    currency?: string | null,
    feeId?: string | null,
    status: PaymentStatus,
    payerUserStatus?: PayerUserStatus | null,
    isUnlimitedRecurring?: boolean | null,
    scheduledAt?: string | null,
    paidAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    owner?: string | null,
  } | null,
};

export type GetServiceQueryVariables = {
  id: string,
};

export type GetServiceQuery = {
  getService?:  {
    __typename: "Service",
    id: string,
    entityId: string,
    title?: string | null,
    description?: string | null,
    amount: number,
    feeType?: FeeType | null,
    taxType: TaxType,
    searchName?: string | null,
    status: ServiceStatus,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ServicesByEntityQueryVariables = {
  entityId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelServiceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ServicesByEntityQuery = {
  servicesByEntity?:  {
    __typename: "ModelServiceConnection",
    items?:  Array< {
      __typename: "Service",
      id: string,
      entityId: string,
      title?: string | null,
      description?: string | null,
      amount: number,
      feeType?: FeeType | null,
      taxType: TaxType,
      searchName?: string | null,
      status: ServiceStatus,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetTaskQueryVariables = {
  id: string,
  entityId: string,
};

export type GetTaskQuery = {
  getTask?:  {
    __typename: "Task",
    entityId: string,
    taskNumber?: string | null,
    invoiceStatus?: InvoiceStatus | null,
    agreementUuid?: string | null,
    documentType?: DocumentType | null,
    subCategory?: string | null,
    id: string,
    linkedTaskId?: string | null,
    managerId?: string | null,
    partnerId?: string | null,
    bindingId?: string | null,
    futureLinkedTask?:  {
      __typename: "FutureTask",
      fromId: string,
      fromType: FromToType,
      toId?: string | null,
      toType?: FromToType | null,
      numberOfPayments?: number | null,
      paymentFrequency?: PaymentFrequency | null,
      reference: string,
      bpayReferenceNumber?: string | null,
      amount?: number | null,
      gstInclusive?: boolean | null,
      lineItems?:  Array< {
        __typename: "LineItem",
        serviceId?: string | null,
        description: string,
        quantity: number,
        unitAmount: number,
        taxType: TaxType,
        lineAmount?: number | null,
        newService?: boolean | null,
      } | null > | null,
      isUnlimitedRecurring?: boolean | null,
      direction?: TaskDirection | null,
      invoiceStatus?: InvoiceStatus | null,
      dueAt: string,
      paymentAt?: string | null,
      lodgementAt?: string | null,
    } | null,
    documentAnalysisId?: string | null,
    activity?:  {
      __typename: "ModelActivityConnection",
      items:  Array< {
        __typename: "Activity",
        id: string,
        compositeId: string,
        userId?: string | null,
        entityId?: string | null,
        type: ActivityType,
        message?: string | null,
        metadata?:  {
          __typename: "ActivityMetadata",
          name?: string | null,
          email?: string | null,
        } | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    amount?: number | null,
    taxAmount?: number | null,
    annotations?: string | null,
    entityIdFrom?: string | null,
    fromId: string,
    fromType: FromToType,
    toId?: string | null,
    toType?: FromToType | null,
    firmId?: string | null,
    entityIdTo?: string | null,
    contactIdFrom?: string | null,
    contactIdTo?: string | null,
    contactId?: string | null,
    entityByIdContactId?: string | null,
    firmByIdContactId?: string | null,
    firmById?: string | null,
    searchName?: string | null,
    status: TaskStatus,
    quoteStatus?: TaskQuoteStatus | null,
    signatureStatus?: TaskSignatureStatus | null,
    paymentStatus?: TaskPaymentStatus | null,
    type: TaskType,
    category?: TaskCategory | null,
    documents?:  Array< {
      __typename: "S3Upload",
      identityId?: string | null,
      key: string,
      level: S3UploadLevel,
      type: S3UploadType,
      name?: string | null,
    } | null > | null,
    emailMessage?: string | null,
    supportDocuments?:  Array< {
      __typename: "S3Upload",
      identityId?: string | null,
      key: string,
      level: S3UploadLevel,
      type: S3UploadType,
      name?: string | null,
    } | null > | null,
    numberOfPayments?: number | null,
    paymentFrequency?: PaymentFrequency | null,
    paymentTypes: Array< PaymentType | null >,
    maximumInstallments?: number | null,
    reference?: string | null,
    bpayReferenceNumber?: string | null,
    settlementStatus?: TaskSettlementStatus | null,
    signers?:  Array< {
      __typename: "EntityUser",
      id: string,
      entityId: string,
      userId: string,
      firmId?: string | null,
      email?: string | null,
      invitedEmail?: string | null,
      ocrEmail?: string | null,
      referredBy?: string | null,
      invitedEntityId?: string | null,
      firmEntityId?: string | null,
      providerContactId?: string | null,
      ownerCode?: string | null,
      clientGroupCode?: string | null,
      clientCode?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      role: EntityUserRole,
      jobTags?: Array< JobTags | null > | null,
      paymentsEnabled?: boolean | null,
      termsInvoiceAccepted?: boolean | null,
      termsOcrAccepted?: boolean | null,
      termsFirmPayTaxAccepted?: boolean | null,
      termsFirmPayTaxDetails?:  {
        __typename: "TermsFirmPayTaxDetails",
        document?:  {
          __typename: "S3Upload",
          identityId?: string | null,
          key: string,
          level: S3UploadLevel,
          type: S3UploadType,
          name?: string | null,
        } | null,
        acceptedAt?: string | null,
        email?: string | null,
        ip?: string | null,
        fullName?: string | null,
        firmId?: string | null,
      } | null,
      entitySearchName?: string | null,
      entity?:  {
        __typename: "Entity",
        id: string,
        type: EntityType,
        taxNumber?: string | null,
        companyNumber?: string | null,
        billerCode?: number | null,
        name: string,
        legalName?: string | null,
        businessNames?: Array< string | null > | null,
        searchName?: string | null,
        address?:  {
          __typename: "Address",
          addressId?: string | null,
          contactName?: string | null,
          contactNumber?: string | null,
          fullAddress?: string | null,
          address1?: string | null,
          address2?: string | null,
          city?: string | null,
          country: string,
          countryCode: string,
          state: string,
          stateCode?: string | null,
          postalCode: string,
          invalid?: boolean | null,
        } | null,
        logo?:  {
          __typename: "Image",
          alt?: string | null,
          identityId?: string | null,
          key: string,
          level: S3UploadLevel,
          type?: string | null,
        } | null,
        brandColour?: string | null,
        website?: string | null,
        entityUsers?:  {
          __typename: "ModelEntityUserConnection",
          items:  Array< {
            __typename: "EntityUser",
            id: string,
            entityId: string,
            userId: string,
            firmId?: string | null,
            email?: string | null,
            invitedEmail?: string | null,
            ocrEmail?: string | null,
            referredBy?: string | null,
            invitedEntityId?: string | null,
            firmEntityId?: string | null,
            providerContactId?: string | null,
            ownerCode?: string | null,
            clientGroupCode?: string | null,
            clientCode?: string | null,
            firstName?: string | null,
            lastName?: string | null,
            role: EntityUserRole,
            jobTags?: Array< JobTags | null > | null,
            paymentsEnabled?: boolean | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            termsFirmPayTaxAccepted?: boolean | null,
            termsFirmPayTaxDetails?:  {
              __typename: "TermsFirmPayTaxDetails",
              document?:  {
                __typename: "S3Upload",
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type: S3UploadType,
                name?: string | null,
              } | null,
              acceptedAt?: string | null,
              email?: string | null,
              ip?: string | null,
              fullName?: string | null,
              firmId?: string | null,
            } | null,
            entitySearchName?: string | null,
            entity?:  {
              __typename: "Entity",
              id: string,
              type: EntityType,
              taxNumber?: string | null,
              companyNumber?: string | null,
              billerCode?: number | null,
              name: string,
              legalName?: string | null,
              businessNames?: Array< string | null > | null,
              searchName?: string | null,
              address?:  {
                __typename: "Address",
                addressId?: string | null,
                contactName?: string | null,
                contactNumber?: string | null,
                fullAddress?: string | null,
                address1?: string | null,
                address2?: string | null,
                city?: string | null,
                country: string,
                countryCode: string,
                state: string,
                stateCode?: string | null,
                postalCode: string,
                invalid?: boolean | null,
              } | null,
              logo?:  {
                __typename: "Image",
                alt?: string | null,
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type?: string | null,
              } | null,
              brandColour?: string | null,
              website?: string | null,
              entityUsers?:  {
                __typename: "ModelEntityUserConnection",
                nextToken?: string | null,
              } | null,
              gstRegistered?: boolean | null,
              gstReportingPeriod?: GSTReportingPeriod | null,
              providerEntityId?: string | null,
              providerCompanyId?: string | null,
              providerBillUserCompanyId?: string | null,
              providerBankAccountId?: string | null,
              providerDigitalWalletId?: string | null,
              providerBpayCrn?: string | null,
              contact?:  {
                __typename: "EntityContact",
                firstName?: string | null,
                lastName?: string | null,
                email?: string | null,
                phone?: string | null,
                role?: string | null,
              } | null,
              paymentMethods?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              paymentMethodId?: string | null,
              paymentUserId?: string | null,
              disbursementMethodId?: string | null,
              receivingAccounts?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              ubosCreated?: boolean | null,
              numUbosCreated?: number | null,
              subCategory?: string | null,
              clientsStatus?: EntityClientsStatus | null,
              ocrEmail?: string | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              owner?: string | null,
              referredBy?: string | null,
              connectedAccount?: string | null,
              accountStatus?: AccountStatus | null,
              customerId?: string | null,
              xeroSyncStatus?: XeroSyncStatus | null,
              xeroLastContactSyncAt?: string | null,
              xeroContactSyncStatus?: XeroSyncStatus | null,
              xeroInvoiceSyncStatus?: XeroSyncStatus | null,
              xeroLastInvoiceSyncAt?: string | null,
              xeroTenantId?: string | null,
              absorbFees?: boolean | null,
              subscriptionTier?: SubscriptionTier | null,
              invitationStatus?: InvitationStatus | null,
              clientsOnboardingStatus?: ClientsOnboardingStatus | null,
              createdBy?: string | null,
              createdByEntityId?: string | null,
              isFirm?: boolean | null,
              createdAt?: string | null,
              updatedAt?: string | null,
            } | null,
            firm?:  {
              __typename: "Entity",
              id: string,
              type: EntityType,
              taxNumber?: string | null,
              companyNumber?: string | null,
              billerCode?: number | null,
              name: string,
              legalName?: string | null,
              businessNames?: Array< string | null > | null,
              searchName?: string | null,
              address?:  {
                __typename: "Address",
                addressId?: string | null,
                contactName?: string | null,
                contactNumber?: string | null,
                fullAddress?: string | null,
                address1?: string | null,
                address2?: string | null,
                city?: string | null,
                country: string,
                countryCode: string,
                state: string,
                stateCode?: string | null,
                postalCode: string,
                invalid?: boolean | null,
              } | null,
              logo?:  {
                __typename: "Image",
                alt?: string | null,
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type?: string | null,
              } | null,
              brandColour?: string | null,
              website?: string | null,
              entityUsers?:  {
                __typename: "ModelEntityUserConnection",
                nextToken?: string | null,
              } | null,
              gstRegistered?: boolean | null,
              gstReportingPeriod?: GSTReportingPeriod | null,
              providerEntityId?: string | null,
              providerCompanyId?: string | null,
              providerBillUserCompanyId?: string | null,
              providerBankAccountId?: string | null,
              providerDigitalWalletId?: string | null,
              providerBpayCrn?: string | null,
              contact?:  {
                __typename: "EntityContact",
                firstName?: string | null,
                lastName?: string | null,
                email?: string | null,
                phone?: string | null,
                role?: string | null,
              } | null,
              paymentMethods?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              paymentMethodId?: string | null,
              paymentUserId?: string | null,
              disbursementMethodId?: string | null,
              receivingAccounts?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              ubosCreated?: boolean | null,
              numUbosCreated?: number | null,
              subCategory?: string | null,
              clientsStatus?: EntityClientsStatus | null,
              ocrEmail?: string | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              owner?: string | null,
              referredBy?: string | null,
              connectedAccount?: string | null,
              accountStatus?: AccountStatus | null,
              customerId?: string | null,
              xeroSyncStatus?: XeroSyncStatus | null,
              xeroLastContactSyncAt?: string | null,
              xeroContactSyncStatus?: XeroSyncStatus | null,
              xeroInvoiceSyncStatus?: XeroSyncStatus | null,
              xeroLastInvoiceSyncAt?: string | null,
              xeroTenantId?: string | null,
              absorbFees?: boolean | null,
              subscriptionTier?: SubscriptionTier | null,
              invitationStatus?: InvitationStatus | null,
              clientsOnboardingStatus?: ClientsOnboardingStatus | null,
              createdBy?: string | null,
              createdByEntityId?: string | null,
              isFirm?: boolean | null,
              createdAt?: string | null,
              updatedAt?: string | null,
            } | null,
            searchName?: string | null,
            taxNumber?: string | null,
            taskSendSMS?: boolean | null,
            companyNumber?: string | null,
            createdBy?: string | null,
            createdAt: string,
            updatedAt: string,
            status?: EntityUserStatus | null,
            partnerId?: string | null,
            managerId?: string | null,
            archivedAt?: string | null,
            taxPaymentReferences?:  {
              __typename: "TaxPaymentReferences",
              itr?:  {
                __typename: "TaxPaymentReference",
                referenceNumber?: string | null,
                updatedAt?: string | null,
              } | null,
              other?:  {
                __typename: "TaxPaymentReference",
                referenceNumber?: string | null,
                updatedAt?: string | null,
              } | null,
            } | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        gstRegistered?: boolean | null,
        gstReportingPeriod?: GSTReportingPeriod | null,
        providerEntityId?: string | null,
        providerCompanyId?: string | null,
        providerBillUserCompanyId?: string | null,
        providerBankAccountId?: string | null,
        providerDigitalWalletId?: string | null,
        providerBpayCrn?: string | null,
        contact?:  {
          __typename: "EntityContact",
          firstName?: string | null,
          lastName?: string | null,
          email?: string | null,
          phone?: string | null,
          role?: string | null,
        } | null,
        paymentMethods?:  {
          __typename: "ModelPaymentMethodConnection",
          items:  Array< {
            __typename: "PaymentMethod",
            id: string,
            paymentMethodType: PaymentMethodType,
            type?: string | null,
            fullName?: string | null,
            number?: string | null,
            expMonth?: string | null,
            expYear?: string | null,
            accountName?: string | null,
            bankName?: string | null,
            accountNumber?: string | null,
            routingNumber?: string | null,
            holderType?: BankHolderType | null,
            accountType?: BankAccountType | null,
            status?: PaymentMethodStatus | null,
            accountDirection?: AccountDirection | null,
            expiresAt?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            consentId?: string | null,
            consentStatus?: PaymentConsentStatus | null,
            card?: string | null,
            googlepay?: string | null,
            applepay?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        paymentMethodId?: string | null,
        paymentUserId?: string | null,
        disbursementMethodId?: string | null,
        receivingAccounts?:  {
          __typename: "ModelPaymentMethodConnection",
          items:  Array< {
            __typename: "PaymentMethod",
            id: string,
            paymentMethodType: PaymentMethodType,
            type?: string | null,
            fullName?: string | null,
            number?: string | null,
            expMonth?: string | null,
            expYear?: string | null,
            accountName?: string | null,
            bankName?: string | null,
            accountNumber?: string | null,
            routingNumber?: string | null,
            holderType?: BankHolderType | null,
            accountType?: BankAccountType | null,
            status?: PaymentMethodStatus | null,
            accountDirection?: AccountDirection | null,
            expiresAt?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            consentId?: string | null,
            consentStatus?: PaymentConsentStatus | null,
            card?: string | null,
            googlepay?: string | null,
            applepay?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        ubosCreated?: boolean | null,
        numUbosCreated?: number | null,
        subCategory?: string | null,
        clientsStatus?: EntityClientsStatus | null,
        ocrEmail?: string | null,
        termsInvoiceAccepted?: boolean | null,
        termsOcrAccepted?: boolean | null,
        owner?: string | null,
        referredBy?: string | null,
        connectedAccount?: string | null,
        accountStatus?: AccountStatus | null,
        customerId?: string | null,
        xeroSyncStatus?: XeroSyncStatus | null,
        xeroLastContactSyncAt?: string | null,
        xeroContactSyncStatus?: XeroSyncStatus | null,
        xeroInvoiceSyncStatus?: XeroSyncStatus | null,
        xeroLastInvoiceSyncAt?: string | null,
        xeroTenantId?: string | null,
        absorbFees?: boolean | null,
        subscriptionTier?: SubscriptionTier | null,
        invitationStatus?: InvitationStatus | null,
        clientsOnboardingStatus?: ClientsOnboardingStatus | null,
        createdBy?: string | null,
        createdByEntityId?: string | null,
        isFirm?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      firm?:  {
        __typename: "Entity",
        id: string,
        type: EntityType,
        taxNumber?: string | null,
        companyNumber?: string | null,
        billerCode?: number | null,
        name: string,
        legalName?: string | null,
        businessNames?: Array< string | null > | null,
        searchName?: string | null,
        address?:  {
          __typename: "Address",
          addressId?: string | null,
          contactName?: string | null,
          contactNumber?: string | null,
          fullAddress?: string | null,
          address1?: string | null,
          address2?: string | null,
          city?: string | null,
          country: string,
          countryCode: string,
          state: string,
          stateCode?: string | null,
          postalCode: string,
          invalid?: boolean | null,
        } | null,
        logo?:  {
          __typename: "Image",
          alt?: string | null,
          identityId?: string | null,
          key: string,
          level: S3UploadLevel,
          type?: string | null,
        } | null,
        brandColour?: string | null,
        website?: string | null,
        entityUsers?:  {
          __typename: "ModelEntityUserConnection",
          items:  Array< {
            __typename: "EntityUser",
            id: string,
            entityId: string,
            userId: string,
            firmId?: string | null,
            email?: string | null,
            invitedEmail?: string | null,
            ocrEmail?: string | null,
            referredBy?: string | null,
            invitedEntityId?: string | null,
            firmEntityId?: string | null,
            providerContactId?: string | null,
            ownerCode?: string | null,
            clientGroupCode?: string | null,
            clientCode?: string | null,
            firstName?: string | null,
            lastName?: string | null,
            role: EntityUserRole,
            jobTags?: Array< JobTags | null > | null,
            paymentsEnabled?: boolean | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            termsFirmPayTaxAccepted?: boolean | null,
            termsFirmPayTaxDetails?:  {
              __typename: "TermsFirmPayTaxDetails",
              document?:  {
                __typename: "S3Upload",
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type: S3UploadType,
                name?: string | null,
              } | null,
              acceptedAt?: string | null,
              email?: string | null,
              ip?: string | null,
              fullName?: string | null,
              firmId?: string | null,
            } | null,
            entitySearchName?: string | null,
            entity?:  {
              __typename: "Entity",
              id: string,
              type: EntityType,
              taxNumber?: string | null,
              companyNumber?: string | null,
              billerCode?: number | null,
              name: string,
              legalName?: string | null,
              businessNames?: Array< string | null > | null,
              searchName?: string | null,
              address?:  {
                __typename: "Address",
                addressId?: string | null,
                contactName?: string | null,
                contactNumber?: string | null,
                fullAddress?: string | null,
                address1?: string | null,
                address2?: string | null,
                city?: string | null,
                country: string,
                countryCode: string,
                state: string,
                stateCode?: string | null,
                postalCode: string,
                invalid?: boolean | null,
              } | null,
              logo?:  {
                __typename: "Image",
                alt?: string | null,
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type?: string | null,
              } | null,
              brandColour?: string | null,
              website?: string | null,
              entityUsers?:  {
                __typename: "ModelEntityUserConnection",
                nextToken?: string | null,
              } | null,
              gstRegistered?: boolean | null,
              gstReportingPeriod?: GSTReportingPeriod | null,
              providerEntityId?: string | null,
              providerCompanyId?: string | null,
              providerBillUserCompanyId?: string | null,
              providerBankAccountId?: string | null,
              providerDigitalWalletId?: string | null,
              providerBpayCrn?: string | null,
              contact?:  {
                __typename: "EntityContact",
                firstName?: string | null,
                lastName?: string | null,
                email?: string | null,
                phone?: string | null,
                role?: string | null,
              } | null,
              paymentMethods?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              paymentMethodId?: string | null,
              paymentUserId?: string | null,
              disbursementMethodId?: string | null,
              receivingAccounts?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              ubosCreated?: boolean | null,
              numUbosCreated?: number | null,
              subCategory?: string | null,
              clientsStatus?: EntityClientsStatus | null,
              ocrEmail?: string | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              owner?: string | null,
              referredBy?: string | null,
              connectedAccount?: string | null,
              accountStatus?: AccountStatus | null,
              customerId?: string | null,
              xeroSyncStatus?: XeroSyncStatus | null,
              xeroLastContactSyncAt?: string | null,
              xeroContactSyncStatus?: XeroSyncStatus | null,
              xeroInvoiceSyncStatus?: XeroSyncStatus | null,
              xeroLastInvoiceSyncAt?: string | null,
              xeroTenantId?: string | null,
              absorbFees?: boolean | null,
              subscriptionTier?: SubscriptionTier | null,
              invitationStatus?: InvitationStatus | null,
              clientsOnboardingStatus?: ClientsOnboardingStatus | null,
              createdBy?: string | null,
              createdByEntityId?: string | null,
              isFirm?: boolean | null,
              createdAt?: string | null,
              updatedAt?: string | null,
            } | null,
            firm?:  {
              __typename: "Entity",
              id: string,
              type: EntityType,
              taxNumber?: string | null,
              companyNumber?: string | null,
              billerCode?: number | null,
              name: string,
              legalName?: string | null,
              businessNames?: Array< string | null > | null,
              searchName?: string | null,
              address?:  {
                __typename: "Address",
                addressId?: string | null,
                contactName?: string | null,
                contactNumber?: string | null,
                fullAddress?: string | null,
                address1?: string | null,
                address2?: string | null,
                city?: string | null,
                country: string,
                countryCode: string,
                state: string,
                stateCode?: string | null,
                postalCode: string,
                invalid?: boolean | null,
              } | null,
              logo?:  {
                __typename: "Image",
                alt?: string | null,
                identityId?: string | null,
                key: string,
                level: S3UploadLevel,
                type?: string | null,
              } | null,
              brandColour?: string | null,
              website?: string | null,
              entityUsers?:  {
                __typename: "ModelEntityUserConnection",
                nextToken?: string | null,
              } | null,
              gstRegistered?: boolean | null,
              gstReportingPeriod?: GSTReportingPeriod | null,
              providerEntityId?: string | null,
              providerCompanyId?: string | null,
              providerBillUserCompanyId?: string | null,
              providerBankAccountId?: string | null,
              providerDigitalWalletId?: string | null,
              providerBpayCrn?: string | null,
              contact?:  {
                __typename: "EntityContact",
                firstName?: string | null,
                lastName?: string | null,
                email?: string | null,
                phone?: string | null,
                role?: string | null,
              } | null,
              paymentMethods?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              paymentMethodId?: string | null,
              paymentUserId?: string | null,
              disbursementMethodId?: string | null,
              receivingAccounts?:  {
                __typename: "ModelPaymentMethodConnection",
                nextToken?: string | null,
              } | null,
              ubosCreated?: boolean | null,
              numUbosCreated?: number | null,
              subCategory?: string | null,
              clientsStatus?: EntityClientsStatus | null,
              ocrEmail?: string | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              owner?: string | null,
              referredBy?: string | null,
              connectedAccount?: string | null,
              accountStatus?: AccountStatus | null,
              customerId?: string | null,
              xeroSyncStatus?: XeroSyncStatus | null,
              xeroLastContactSyncAt?: string | null,
              xeroContactSyncStatus?: XeroSyncStatus | null,
              xeroInvoiceSyncStatus?: XeroSyncStatus | null,
              xeroLastInvoiceSyncAt?: string | null,
              xeroTenantId?: string | null,
              absorbFees?: boolean | null,
              subscriptionTier?: SubscriptionTier | null,
              invitationStatus?: InvitationStatus | null,
              clientsOnboardingStatus?: ClientsOnboardingStatus | null,
              createdBy?: string | null,
              createdByEntityId?: string | null,
              isFirm?: boolean | null,
              createdAt?: string | null,
              updatedAt?: string | null,
            } | null,
            searchName?: string | null,
            taxNumber?: string | null,
            taskSendSMS?: boolean | null,
            companyNumber?: string | null,
            createdBy?: string | null,
            createdAt: string,
            updatedAt: string,
            status?: EntityUserStatus | null,
            partnerId?: string | null,
            managerId?: string | null,
            archivedAt?: string | null,
            taxPaymentReferences?:  {
              __typename: "TaxPaymentReferences",
              itr?:  {
                __typename: "TaxPaymentReference",
                referenceNumber?: string | null,
                updatedAt?: string | null,
              } | null,
              other?:  {
                __typename: "TaxPaymentReference",
                referenceNumber?: string | null,
                updatedAt?: string | null,
              } | null,
            } | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        gstRegistered?: boolean | null,
        gstReportingPeriod?: GSTReportingPeriod | null,
        providerEntityId?: string | null,
        providerCompanyId?: string | null,
        providerBillUserCompanyId?: string | null,
        providerBankAccountId?: string | null,
        providerDigitalWalletId?: string | null,
        providerBpayCrn?: string | null,
        contact?:  {
          __typename: "EntityContact",
          firstName?: string | null,
          lastName?: string | null,
          email?: string | null,
          phone?: string | null,
          role?: string | null,
        } | null,
        paymentMethods?:  {
          __typename: "ModelPaymentMethodConnection",
          items:  Array< {
            __typename: "PaymentMethod",
            id: string,
            paymentMethodType: PaymentMethodType,
            type?: string | null,
            fullName?: string | null,
            number?: string | null,
            expMonth?: string | null,
            expYear?: string | null,
            accountName?: string | null,
            bankName?: string | null,
            accountNumber?: string | null,
            routingNumber?: string | null,
            holderType?: BankHolderType | null,
            accountType?: BankAccountType | null,
            status?: PaymentMethodStatus | null,
            accountDirection?: AccountDirection | null,
            expiresAt?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            consentId?: string | null,
            consentStatus?: PaymentConsentStatus | null,
            card?: string | null,
            googlepay?: string | null,
            applepay?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        paymentMethodId?: string | null,
        paymentUserId?: string | null,
        disbursementMethodId?: string | null,
        receivingAccounts?:  {
          __typename: "ModelPaymentMethodConnection",
          items:  Array< {
            __typename: "PaymentMethod",
            id: string,
            paymentMethodType: PaymentMethodType,
            type?: string | null,
            fullName?: string | null,
            number?: string | null,
            expMonth?: string | null,
            expYear?: string | null,
            accountName?: string | null,
            bankName?: string | null,
            accountNumber?: string | null,
            routingNumber?: string | null,
            holderType?: BankHolderType | null,
            accountType?: BankAccountType | null,
            status?: PaymentMethodStatus | null,
            accountDirection?: AccountDirection | null,
            expiresAt?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            consentId?: string | null,
            consentStatus?: PaymentConsentStatus | null,
            card?: string | null,
            googlepay?: string | null,
            applepay?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        ubosCreated?: boolean | null,
        numUbosCreated?: number | null,
        subCategory?: string | null,
        clientsStatus?: EntityClientsStatus | null,
        ocrEmail?: string | null,
        termsInvoiceAccepted?: boolean | null,
        termsOcrAccepted?: boolean | null,
        owner?: string | null,
        referredBy?: string | null,
        connectedAccount?: string | null,
        accountStatus?: AccountStatus | null,
        customerId?: string | null,
        xeroSyncStatus?: XeroSyncStatus | null,
        xeroLastContactSyncAt?: string | null,
        xeroContactSyncStatus?: XeroSyncStatus | null,
        xeroInvoiceSyncStatus?: XeroSyncStatus | null,
        xeroLastInvoiceSyncAt?: string | null,
        xeroTenantId?: string | null,
        absorbFees?: boolean | null,
        subscriptionTier?: SubscriptionTier | null,
        invitationStatus?: InvitationStatus | null,
        clientsOnboardingStatus?: ClientsOnboardingStatus | null,
        createdBy?: string | null,
        createdByEntityId?: string | null,
        isFirm?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      searchName?: string | null,
      taxNumber?: string | null,
      taskSendSMS?: boolean | null,
      companyNumber?: string | null,
      createdBy?: string | null,
      createdAt: string,
      updatedAt: string,
      status?: EntityUserStatus | null,
      partnerId?: string | null,
      managerId?: string | null,
      archivedAt?: string | null,
      taxPaymentReferences?:  {
        __typename: "TaxPaymentReferences",
        itr?:  {
          __typename: "TaxPaymentReference",
          referenceNumber?: string | null,
          updatedAt?: string | null,
        } | null,
        other?:  {
          __typename: "TaxPaymentReference",
          referenceNumber?: string | null,
          updatedAt?: string | null,
        } | null,
      } | null,
    } | null > | null,
    otherRecipients?:  Array< {
      __typename: "OtherRecipient",
      email: string,
      sendOnCompletion: boolean,
    } | null > | null,
    payments?:  {
      __typename: "ModelPaymentConnection",
      items:  Array< {
        __typename: "Payment",
        id: string,
        paymentIntentId?: string | null,
        taskId?: string | null,
        entityId?: string | null,
        payInPaymentId?: string | null,
        providerTransactionId?: string | null,
        paymentProvider?: PaymentProvider | null,
        disbursementId?: string | null,
        fromId: string,
        fromType: FromToType,
        toId?: string | null,
        toType?: FromToType | null,
        buyerId?: string | null,
        sellerId?: string | null,
        entityIdTo?: string | null,
        amount?: number | null,
        netAmount?: number | null,
        payerFees?: number | null,
        totalAmount?: number | null,
        gstAmount?: number | null,
        installment?: number | null,
        installments?: number | null,
        feeAmount?: number | null,
        reference?: string | null,
        paymentType?: PaymentType | null,
        taxAmount?: number | null,
        currency?: string | null,
        feeIds?: Array< string | null > | null,
        ipAddress?: string | null,
        status: PaymentStatus,
        payerUserStatus?: PayerUserStatus | null,
        declinedReason?: string | null,
        isUnlimitedRecurring?: boolean | null,
        payoutFailureReason?: string | null,
        payoutFailureFields?: Array< string | null > | null,
        payoutDetails?:  {
          __typename: "PayoutDetails",
          bank?:  {
            __typename: "ContactBankAccount",
            id?: string | null,
            accountName?: string | null,
            bankName?: string | null,
            accountNumber: string,
            routingNumber: string,
            holderType?: BankHolderType | null,
            accountType?: BankAccountType | null,
            country?: string | null,
          } | null,
          bpay?:  {
            __typename: "ContactBpay",
            billerCode?: number | null,
            referenceNumber?: string | null,
          } | null,
        } | null,
        scheduledAt?: string | null,
        paidAt?: string | null,
        declinedAt?: string | null,
        createdAt?: string | null,
        receivedAt?: string | null,
        paidOutAt?: string | null,
        updatedAt?: string | null,
        voidedAt?: string | null,
        owner?: string | null,
        payoutFailedAt?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdBy: string,
    entityIdBy?: string | null,
    dueAt: string,
    issuedAt?: string | null,
    notes?: string | null,
    reviewerFeedback?:  Array< {
      __typename: "ReviewerFeedback",
      reviewedById: string,
      feedback: string,
      status: ReviewerFeedbackStatus,
      createdAt: string,
    } | null > | null,
    direction?: TaskDirection | null,
    readBy?: Array< string | null > | null,
    gstInclusive?: boolean | null,
    isUnlimitedRecurring?: boolean | null,
    owner?: string | null,
    lineItems?:  Array< {
      __typename: "LineItem",
      serviceId?: string | null,
      description: string,
      quantity: number,
      unitAmount: number,
      taxType: TaxType,
      lineAmount?: number | null,
      newService?: boolean | null,
    } | null > | null,
    xeroTenantId?: string | null,
    sendSMS?: boolean | null,
    automaticGenerateInvoice?: boolean | null,
    automaticInvoicePaymentAt?: string | null,
    automaticInvoicePaymentTerms?: PaymentTerms | null,
    quoteRequiresSignature?: boolean | null,
    automaticallyGeneratedFromQuote?: boolean | null,
    sendTemplate?: boolean | null,
    includeLetterhead?: boolean | null,
    templateJson?: string | null,
    templateHtml?: string | null,
    paymentAt?: string | null,
    lodgementAt?: string | null,
    period?: string | null,
    year?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    viewedAt?: string | null,
    readAt?: string | null,
    paidAt?: string | null,
    endAt?: string | null,
    quoteAcceptedAt?: string | null,
    completedAt?: string | null,
    payoutErrors?: Array< string | null > | null,
  } | null,
};

export type GetTaskGuestQueryVariables = {
  id?: string | null,
  entityId?: string | null,
};

export type GetTaskGuestQuery = {
  getTaskGuest?:  {
    __typename: "TaskGuest",
    id: string,
    entityId: string,
    amount?: number | null,
    taxAmount?: number | null,
    annotations?: string | null,
    documentType?: DocumentType | null,
    subCategory?: string | null,
    fromId: string,
    linkedTaskId?: string | null,
    futureLinkedTask?:  {
      __typename: "FutureTaskGuest",
      fromId: string,
      fromType: FromToType,
      from?:  {
        __typename: "EntityGuest",
        id: string,
        name: string,
        taxNumber?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      toId?: string | null,
      toType?: FromToType | null,
      to?:  {
        __typename: "EntityGuest",
        id: string,
        name: string,
        taxNumber?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      numberOfPayments?: number | null,
      paymentFrequency?: PaymentFrequency | null,
      reference: string,
      bpayReferenceNumber?: string | null,
      amount?: number | null,
      gstInclusive?: boolean | null,
      lineItems?:  Array< {
        __typename: "LineItem",
        serviceId?: string | null,
        description: string,
        quantity: number,
        unitAmount: number,
        taxType: TaxType,
        lineAmount?: number | null,
        newService?: boolean | null,
      } | null > | null,
      isUnlimitedRecurring?: boolean | null,
      direction?: TaskDirection | null,
      invoiceStatus?: InvoiceStatus | null,
      dueAt: string,
      paymentAt?: string | null,
      lodgementAt?: string | null,
    } | null,
    firm?:  {
      __typename: "EntityGuest",
      id: string,
      name: string,
      taxNumber?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    fromEntity?:  {
      __typename: "EntityGuest",
      id: string,
      name: string,
      taxNumber?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    from?:  {
      __typename: "EntityGuest",
      id: string,
      name: string,
      taxNumber?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    fromContact?:  {
      __typename: "ContactGuest",
      id: string,
      firstName?: string | null,
      lastName?: string | null,
      name?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    fromType?: FromToType | null,
    toEntity?:  {
      __typename: "EntityGuest",
      id: string,
      name: string,
      taxNumber?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    toContact?:  {
      __typename: "ContactGuest",
      id: string,
      firstName?: string | null,
      lastName?: string | null,
      name?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    toId?: string | null,
    to?:  {
      __typename: "EntityGuest",
      id: string,
      name: string,
      taxNumber?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    toType?: FromToType | null,
    isFinalSigner?: boolean | null,
    status: TaskStatus,
    signatureStatus?: TaskSignatureStatus | null,
    paymentStatus?: TaskPaymentStatus | null,
    quoteStatus?: TaskQuoteStatus | null,
    invoiceStatus?: InvoiceStatus | null,
    settlementStatus?: TaskSettlementStatus | null,
    type: TaskType,
    category?: TaskCategory | null,
    documents?:  Array< {
      __typename: "S3Upload",
      identityId?: string | null,
      key: string,
      level: S3UploadLevel,
      type: S3UploadType,
      name?: string | null,
    } | null > | null,
    supportDocuments?:  Array< {
      __typename: "S3Upload",
      identityId?: string | null,
      key: string,
      level: S3UploadLevel,
      type: S3UploadType,
      name?: string | null,
    } | null > | null,
    numberOfPayments?: number | null,
    paymentFrequency?: PaymentFrequency | null,
    paymentTypes: Array< PaymentType | null >,
    reference?: string | null,
    bpayReferenceNumber?: string | null,
    createdBy: string,
    gstInclusive?: boolean | null,
    entityIdBy?: string | null,
    dueAt: string,
    issuedAt?: string | null,
    notes?: string | null,
    direction?: TaskDirection | null,
    paymentAt?: string | null,
    lodgementAt?: string | null,
    readAt?: string | null,
    paidAt?: string | null,
    quoteAcceptedAt?: string | null,
    completedAt?: string | null,
    owner?: string | null,
    metaHashData?: string | null,
    automaticGenerateInvoice?: boolean | null,
    automaticInvoicePaymentAt?: string | null,
    automaticInvoicePaymentTerms?: PaymentTerms | null,
    quoteRequiresSignature?: boolean | null,
    automaticallyGeneratedFromQuote?: boolean | null,
    termsFirmPayTaxAccepted?: boolean | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    token?: string | null,
    period?: string | null,
    year?: string | null,
  } | null,
};

export type GetTaskPublicQueryVariables = {
  token: string,
};

export type GetTaskPublicQuery = {
  getTaskPublic?:  {
    __typename: "TaskGuest",
    id: string,
    entityId: string,
    amount?: number | null,
    taxAmount?: number | null,
    annotations?: string | null,
    documentType?: DocumentType | null,
    subCategory?: string | null,
    fromId: string,
    linkedTaskId?: string | null,
    futureLinkedTask?:  {
      __typename: "FutureTaskGuest",
      fromId: string,
      fromType: FromToType,
      from?:  {
        __typename: "EntityGuest",
        id: string,
        name: string,
        taxNumber?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      toId?: string | null,
      toType?: FromToType | null,
      to?:  {
        __typename: "EntityGuest",
        id: string,
        name: string,
        taxNumber?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      numberOfPayments?: number | null,
      paymentFrequency?: PaymentFrequency | null,
      reference: string,
      bpayReferenceNumber?: string | null,
      amount?: number | null,
      gstInclusive?: boolean | null,
      lineItems?:  Array< {
        __typename: "LineItem",
        serviceId?: string | null,
        description: string,
        quantity: number,
        unitAmount: number,
        taxType: TaxType,
        lineAmount?: number | null,
        newService?: boolean | null,
      } | null > | null,
      isUnlimitedRecurring?: boolean | null,
      direction?: TaskDirection | null,
      invoiceStatus?: InvoiceStatus | null,
      dueAt: string,
      paymentAt?: string | null,
      lodgementAt?: string | null,
    } | null,
    firm?:  {
      __typename: "EntityGuest",
      id: string,
      name: string,
      taxNumber?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    fromEntity?:  {
      __typename: "EntityGuest",
      id: string,
      name: string,
      taxNumber?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    from?:  {
      __typename: "EntityGuest",
      id: string,
      name: string,
      taxNumber?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    fromContact?:  {
      __typename: "ContactGuest",
      id: string,
      firstName?: string | null,
      lastName?: string | null,
      name?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    fromType?: FromToType | null,
    toEntity?:  {
      __typename: "EntityGuest",
      id: string,
      name: string,
      taxNumber?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    toContact?:  {
      __typename: "ContactGuest",
      id: string,
      firstName?: string | null,
      lastName?: string | null,
      name?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    toId?: string | null,
    to?:  {
      __typename: "EntityGuest",
      id: string,
      name: string,
      taxNumber?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    toType?: FromToType | null,
    isFinalSigner?: boolean | null,
    status: TaskStatus,
    signatureStatus?: TaskSignatureStatus | null,
    paymentStatus?: TaskPaymentStatus | null,
    quoteStatus?: TaskQuoteStatus | null,
    invoiceStatus?: InvoiceStatus | null,
    settlementStatus?: TaskSettlementStatus | null,
    type: TaskType,
    category?: TaskCategory | null,
    documents?:  Array< {
      __typename: "S3Upload",
      identityId?: string | null,
      key: string,
      level: S3UploadLevel,
      type: S3UploadType,
      name?: string | null,
    } | null > | null,
    supportDocuments?:  Array< {
      __typename: "S3Upload",
      identityId?: string | null,
      key: string,
      level: S3UploadLevel,
      type: S3UploadType,
      name?: string | null,
    } | null > | null,
    numberOfPayments?: number | null,
    paymentFrequency?: PaymentFrequency | null,
    paymentTypes: Array< PaymentType | null >,
    reference?: string | null,
    bpayReferenceNumber?: string | null,
    createdBy: string,
    gstInclusive?: boolean | null,
    entityIdBy?: string | null,
    dueAt: string,
    issuedAt?: string | null,
    notes?: string | null,
    direction?: TaskDirection | null,
    paymentAt?: string | null,
    lodgementAt?: string | null,
    readAt?: string | null,
    paidAt?: string | null,
    quoteAcceptedAt?: string | null,
    completedAt?: string | null,
    owner?: string | null,
    metaHashData?: string | null,
    automaticGenerateInvoice?: boolean | null,
    automaticInvoicePaymentAt?: string | null,
    automaticInvoicePaymentTerms?: PaymentTerms | null,
    quoteRequiresSignature?: boolean | null,
    automaticallyGeneratedFromQuote?: boolean | null,
    termsFirmPayTaxAccepted?: boolean | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    token?: string | null,
    period?: string | null,
    year?: string | null,
  } | null,
};

export type GetBindingTasksPublicQueryVariables = {
  token: string,
};

export type GetBindingTasksPublicQuery = {
  getBindingTasksPublic?:  {
    __typename: "BindingTasksPublicResult",
    tasks:  Array< {
      __typename: "TaskGuest",
      id: string,
      entityId: string,
      amount?: number | null,
      taxAmount?: number | null,
      annotations?: string | null,
      documentType?: DocumentType | null,
      subCategory?: string | null,
      fromId: string,
      linkedTaskId?: string | null,
      futureLinkedTask?:  {
        __typename: "FutureTaskGuest",
        fromId: string,
        fromType: FromToType,
        from?:  {
          __typename: "EntityGuest",
          id: string,
          name: string,
          taxNumber?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | null,
        toId?: string | null,
        toType?: FromToType | null,
        to?:  {
          __typename: "EntityGuest",
          id: string,
          name: string,
          taxNumber?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | null,
        numberOfPayments?: number | null,
        paymentFrequency?: PaymentFrequency | null,
        reference: string,
        bpayReferenceNumber?: string | null,
        amount?: number | null,
        gstInclusive?: boolean | null,
        lineItems?:  Array< {
          __typename: "LineItem",
          serviceId?: string | null,
          description: string,
          quantity: number,
          unitAmount: number,
          taxType: TaxType,
          lineAmount?: number | null,
          newService?: boolean | null,
        } | null > | null,
        isUnlimitedRecurring?: boolean | null,
        direction?: TaskDirection | null,
        invoiceStatus?: InvoiceStatus | null,
        dueAt: string,
        paymentAt?: string | null,
        lodgementAt?: string | null,
      } | null,
      firm?:  {
        __typename: "EntityGuest",
        id: string,
        name: string,
        taxNumber?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      fromEntity?:  {
        __typename: "EntityGuest",
        id: string,
        name: string,
        taxNumber?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      from?:  {
        __typename: "EntityGuest",
        id: string,
        name: string,
        taxNumber?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      fromContact?:  {
        __typename: "ContactGuest",
        id: string,
        firstName?: string | null,
        lastName?: string | null,
        name?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      fromType?: FromToType | null,
      toEntity?:  {
        __typename: "EntityGuest",
        id: string,
        name: string,
        taxNumber?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      toContact?:  {
        __typename: "ContactGuest",
        id: string,
        firstName?: string | null,
        lastName?: string | null,
        name?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      toId?: string | null,
      to?:  {
        __typename: "EntityGuest",
        id: string,
        name: string,
        taxNumber?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      toType?: FromToType | null,
      isFinalSigner?: boolean | null,
      status: TaskStatus,
      signatureStatus?: TaskSignatureStatus | null,
      paymentStatus?: TaskPaymentStatus | null,
      quoteStatus?: TaskQuoteStatus | null,
      invoiceStatus?: InvoiceStatus | null,
      settlementStatus?: TaskSettlementStatus | null,
      type: TaskType,
      category?: TaskCategory | null,
      documents?:  Array< {
        __typename: "S3Upload",
        identityId?: string | null,
        key: string,
        level: S3UploadLevel,
        type: S3UploadType,
        name?: string | null,
      } | null > | null,
      supportDocuments?:  Array< {
        __typename: "S3Upload",
        identityId?: string | null,
        key: string,
        level: S3UploadLevel,
        type: S3UploadType,
        name?: string | null,
      } | null > | null,
      numberOfPayments?: number | null,
      paymentFrequency?: PaymentFrequency | null,
      paymentTypes: Array< PaymentType | null >,
      reference?: string | null,
      bpayReferenceNumber?: string | null,
      createdBy: string,
      gstInclusive?: boolean | null,
      entityIdBy?: string | null,
      dueAt: string,
      issuedAt?: string | null,
      notes?: string | null,
      direction?: TaskDirection | null,
      paymentAt?: string | null,
      lodgementAt?: string | null,
      readAt?: string | null,
      paidAt?: string | null,
      quoteAcceptedAt?: string | null,
      completedAt?: string | null,
      owner?: string | null,
      metaHashData?: string | null,
      automaticGenerateInvoice?: boolean | null,
      automaticInvoicePaymentAt?: string | null,
      automaticInvoicePaymentTerms?: PaymentTerms | null,
      quoteRequiresSignature?: boolean | null,
      automaticallyGeneratedFromQuote?: boolean | null,
      termsFirmPayTaxAccepted?: boolean | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      token?: string | null,
      period?: string | null,
      year?: string | null,
    } | null >,
    documents?:  Array< {
      __typename: "S3Upload",
      identityId?: string | null,
      key: string,
      level: S3UploadLevel,
      type: S3UploadType,
      name?: string | null,
    } | null > | null,
  } | null,
};

export type SearchTasksQueryVariables = {
  firmId?: string | null,
  entityId?: string | null,
  contactId?: string | null,
  bindingId?: string | null,
  createdBy?: string | null,
  status?: TaskSearchStatus | null,
  type: TaskSearchType,
  searchName?: string | null,
  dueAtStart?: string | null,
  dueAtEnd?: string | null,
  sortBy?: SearchTasksSortBy | null,
  sortDirection?: ModelSortDirection | null,
  from?: number | null,
  limit?: number | null,
};

export type SearchTasksQuery = {
  searchTasks?:  {
    __typename: "ModelOpenSearchTaskConnection",
    items:  Array< {
      __typename: "Task",
      entityId: string,
      taskNumber?: string | null,
      invoiceStatus?: InvoiceStatus | null,
      agreementUuid?: string | null,
      documentType?: DocumentType | null,
      subCategory?: string | null,
      id: string,
      linkedTaskId?: string | null,
      managerId?: string | null,
      partnerId?: string | null,
      bindingId?: string | null,
      futureLinkedTask?:  {
        __typename: "FutureTask",
        fromId: string,
        fromType: FromToType,
        toId?: string | null,
        toType?: FromToType | null,
        numberOfPayments?: number | null,
        paymentFrequency?: PaymentFrequency | null,
        reference: string,
        bpayReferenceNumber?: string | null,
        amount?: number | null,
        gstInclusive?: boolean | null,
        lineItems?:  Array< {
          __typename: "LineItem",
          serviceId?: string | null,
          description: string,
          quantity: number,
          unitAmount: number,
          taxType: TaxType,
          lineAmount?: number | null,
          newService?: boolean | null,
        } | null > | null,
        isUnlimitedRecurring?: boolean | null,
        direction?: TaskDirection | null,
        invoiceStatus?: InvoiceStatus | null,
        dueAt: string,
        paymentAt?: string | null,
        lodgementAt?: string | null,
      } | null,
      documentAnalysisId?: string | null,
      activity?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          compositeId: string,
          userId?: string | null,
          entityId?: string | null,
          type: ActivityType,
          message?: string | null,
          metadata?:  {
            __typename: "ActivityMetadata",
            name?: string | null,
            email?: string | null,
          } | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      amount?: number | null,
      taxAmount?: number | null,
      annotations?: string | null,
      entityIdFrom?: string | null,
      fromId: string,
      fromType: FromToType,
      toId?: string | null,
      toType?: FromToType | null,
      firmId?: string | null,
      entityIdTo?: string | null,
      contactIdFrom?: string | null,
      contactIdTo?: string | null,
      contactId?: string | null,
      entityByIdContactId?: string | null,
      firmByIdContactId?: string | null,
      firmById?: string | null,
      searchName?: string | null,
      status: TaskStatus,
      quoteStatus?: TaskQuoteStatus | null,
      signatureStatus?: TaskSignatureStatus | null,
      paymentStatus?: TaskPaymentStatus | null,
      type: TaskType,
      category?: TaskCategory | null,
      documents?:  Array< {
        __typename: "S3Upload",
        identityId?: string | null,
        key: string,
        level: S3UploadLevel,
        type: S3UploadType,
        name?: string | null,
      } | null > | null,
      emailMessage?: string | null,
      supportDocuments?:  Array< {
        __typename: "S3Upload",
        identityId?: string | null,
        key: string,
        level: S3UploadLevel,
        type: S3UploadType,
        name?: string | null,
      } | null > | null,
      numberOfPayments?: number | null,
      paymentFrequency?: PaymentFrequency | null,
      paymentTypes: Array< PaymentType | null >,
      maximumInstallments?: number | null,
      reference?: string | null,
      bpayReferenceNumber?: string | null,
      settlementStatus?: TaskSettlementStatus | null,
      signers?:  Array< {
        __typename: "EntityUser",
        id: string,
        entityId: string,
        userId: string,
        firmId?: string | null,
        email?: string | null,
        invitedEmail?: string | null,
        ocrEmail?: string | null,
        referredBy?: string | null,
        invitedEntityId?: string | null,
        firmEntityId?: string | null,
        providerContactId?: string | null,
        ownerCode?: string | null,
        clientGroupCode?: string | null,
        clientCode?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        role: EntityUserRole,
        jobTags?: Array< JobTags | null > | null,
        paymentsEnabled?: boolean | null,
        termsInvoiceAccepted?: boolean | null,
        termsOcrAccepted?: boolean | null,
        termsFirmPayTaxAccepted?: boolean | null,
        termsFirmPayTaxDetails?:  {
          __typename: "TermsFirmPayTaxDetails",
          document?:  {
            __typename: "S3Upload",
            identityId?: string | null,
            key: string,
            level: S3UploadLevel,
            type: S3UploadType,
            name?: string | null,
          } | null,
          acceptedAt?: string | null,
          email?: string | null,
          ip?: string | null,
          fullName?: string | null,
          firmId?: string | null,
        } | null,
        entitySearchName?: string | null,
        entity?:  {
          __typename: "Entity",
          id: string,
          type: EntityType,
          taxNumber?: string | null,
          companyNumber?: string | null,
          billerCode?: number | null,
          name: string,
          legalName?: string | null,
          businessNames?: Array< string | null > | null,
          searchName?: string | null,
          address?:  {
            __typename: "Address",
            addressId?: string | null,
            contactName?: string | null,
            contactNumber?: string | null,
            fullAddress?: string | null,
            address1?: string | null,
            address2?: string | null,
            city?: string | null,
            country: string,
            countryCode: string,
            state: string,
            stateCode?: string | null,
            postalCode: string,
            invalid?: boolean | null,
          } | null,
          logo?:  {
            __typename: "Image",
            alt?: string | null,
            identityId?: string | null,
            key: string,
            level: S3UploadLevel,
            type?: string | null,
          } | null,
          brandColour?: string | null,
          website?: string | null,
          entityUsers?:  {
            __typename: "ModelEntityUserConnection",
            items:  Array< {
              __typename: "EntityUser",
              id: string,
              entityId: string,
              userId: string,
              firmId?: string | null,
              email?: string | null,
              invitedEmail?: string | null,
              ocrEmail?: string | null,
              referredBy?: string | null,
              invitedEntityId?: string | null,
              firmEntityId?: string | null,
              providerContactId?: string | null,
              ownerCode?: string | null,
              clientGroupCode?: string | null,
              clientCode?: string | null,
              firstName?: string | null,
              lastName?: string | null,
              role: EntityUserRole,
              jobTags?: Array< JobTags | null > | null,
              paymentsEnabled?: boolean | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              termsFirmPayTaxAccepted?: boolean | null,
              termsFirmPayTaxDetails?:  {
                __typename: "TermsFirmPayTaxDetails",
                acceptedAt?: string | null,
                email?: string | null,
                ip?: string | null,
                fullName?: string | null,
                firmId?: string | null,
              } | null,
              entitySearchName?: string | null,
              entity?:  {
                __typename: "Entity",
                id: string,
                type: EntityType,
                taxNumber?: string | null,
                companyNumber?: string | null,
                billerCode?: number | null,
                name: string,
                legalName?: string | null,
                businessNames?: Array< string | null > | null,
                searchName?: string | null,
                brandColour?: string | null,
                website?: string | null,
                gstRegistered?: boolean | null,
                gstReportingPeriod?: GSTReportingPeriod | null,
                providerEntityId?: string | null,
                providerCompanyId?: string | null,
                providerBillUserCompanyId?: string | null,
                providerBankAccountId?: string | null,
                providerDigitalWalletId?: string | null,
                providerBpayCrn?: string | null,
                paymentMethodId?: string | null,
                paymentUserId?: string | null,
                disbursementMethodId?: string | null,
                ubosCreated?: boolean | null,
                numUbosCreated?: number | null,
                subCategory?: string | null,
                clientsStatus?: EntityClientsStatus | null,
                ocrEmail?: string | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                owner?: string | null,
                referredBy?: string | null,
                connectedAccount?: string | null,
                accountStatus?: AccountStatus | null,
                customerId?: string | null,
                xeroSyncStatus?: XeroSyncStatus | null,
                xeroLastContactSyncAt?: string | null,
                xeroContactSyncStatus?: XeroSyncStatus | null,
                xeroInvoiceSyncStatus?: XeroSyncStatus | null,
                xeroLastInvoiceSyncAt?: string | null,
                xeroTenantId?: string | null,
                absorbFees?: boolean | null,
                subscriptionTier?: SubscriptionTier | null,
                invitationStatus?: InvitationStatus | null,
                clientsOnboardingStatus?: ClientsOnboardingStatus | null,
                createdBy?: string | null,
                createdByEntityId?: string | null,
                isFirm?: boolean | null,
                createdAt?: string | null,
                updatedAt?: string | null,
              } | null,
              firm?:  {
                __typename: "Entity",
                id: string,
                type: EntityType,
                taxNumber?: string | null,
                companyNumber?: string | null,
                billerCode?: number | null,
                name: string,
                legalName?: string | null,
                businessNames?: Array< string | null > | null,
                searchName?: string | null,
                brandColour?: string | null,
                website?: string | null,
                gstRegistered?: boolean | null,
                gstReportingPeriod?: GSTReportingPeriod | null,
                providerEntityId?: string | null,
                providerCompanyId?: string | null,
                providerBillUserCompanyId?: string | null,
                providerBankAccountId?: string | null,
                providerDigitalWalletId?: string | null,
                providerBpayCrn?: string | null,
                paymentMethodId?: string | null,
                paymentUserId?: string | null,
                disbursementMethodId?: string | null,
                ubosCreated?: boolean | null,
                numUbosCreated?: number | null,
                subCategory?: string | null,
                clientsStatus?: EntityClientsStatus | null,
                ocrEmail?: string | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                owner?: string | null,
                referredBy?: string | null,
                connectedAccount?: string | null,
                accountStatus?: AccountStatus | null,
                customerId?: string | null,
                xeroSyncStatus?: XeroSyncStatus | null,
                xeroLastContactSyncAt?: string | null,
                xeroContactSyncStatus?: XeroSyncStatus | null,
                xeroInvoiceSyncStatus?: XeroSyncStatus | null,
                xeroLastInvoiceSyncAt?: string | null,
                xeroTenantId?: string | null,
                absorbFees?: boolean | null,
                subscriptionTier?: SubscriptionTier | null,
                invitationStatus?: InvitationStatus | null,
                clientsOnboardingStatus?: ClientsOnboardingStatus | null,
                createdBy?: string | null,
                createdByEntityId?: string | null,
                isFirm?: boolean | null,
                createdAt?: string | null,
                updatedAt?: string | null,
              } | null,
              searchName?: string | null,
              taxNumber?: string | null,
              taskSendSMS?: boolean | null,
              companyNumber?: string | null,
              createdBy?: string | null,
              createdAt: string,
              updatedAt: string,
              status?: EntityUserStatus | null,
              partnerId?: string | null,
              managerId?: string | null,
              archivedAt?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gstRegistered?: boolean | null,
          gstReportingPeriod?: GSTReportingPeriod | null,
          providerEntityId?: string | null,
          providerCompanyId?: string | null,
          providerBillUserCompanyId?: string | null,
          providerBankAccountId?: string | null,
          providerDigitalWalletId?: string | null,
          providerBpayCrn?: string | null,
          contact?:  {
            __typename: "EntityContact",
            firstName?: string | null,
            lastName?: string | null,
            email?: string | null,
            phone?: string | null,
            role?: string | null,
          } | null,
          paymentMethods?:  {
            __typename: "ModelPaymentMethodConnection",
            items:  Array< {
              __typename: "PaymentMethod",
              id: string,
              paymentMethodType: PaymentMethodType,
              type?: string | null,
              fullName?: string | null,
              number?: string | null,
              expMonth?: string | null,
              expYear?: string | null,
              accountName?: string | null,
              bankName?: string | null,
              accountNumber?: string | null,
              routingNumber?: string | null,
              holderType?: BankHolderType | null,
              accountType?: BankAccountType | null,
              status?: PaymentMethodStatus | null,
              accountDirection?: AccountDirection | null,
              expiresAt?: string | null,
              createdAt?: string | null,
              updatedAt?: string | null,
              consentId?: string | null,
              consentStatus?: PaymentConsentStatus | null,
              card?: string | null,
              googlepay?: string | null,
              applepay?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          paymentMethodId?: string | null,
          paymentUserId?: string | null,
          disbursementMethodId?: string | null,
          receivingAccounts?:  {
            __typename: "ModelPaymentMethodConnection",
            items:  Array< {
              __typename: "PaymentMethod",
              id: string,
              paymentMethodType: PaymentMethodType,
              type?: string | null,
              fullName?: string | null,
              number?: string | null,
              expMonth?: string | null,
              expYear?: string | null,
              accountName?: string | null,
              bankName?: string | null,
              accountNumber?: string | null,
              routingNumber?: string | null,
              holderType?: BankHolderType | null,
              accountType?: BankAccountType | null,
              status?: PaymentMethodStatus | null,
              accountDirection?: AccountDirection | null,
              expiresAt?: string | null,
              createdAt?: string | null,
              updatedAt?: string | null,
              consentId?: string | null,
              consentStatus?: PaymentConsentStatus | null,
              card?: string | null,
              googlepay?: string | null,
              applepay?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          ubosCreated?: boolean | null,
          numUbosCreated?: number | null,
          subCategory?: string | null,
          clientsStatus?: EntityClientsStatus | null,
          ocrEmail?: string | null,
          termsInvoiceAccepted?: boolean | null,
          termsOcrAccepted?: boolean | null,
          owner?: string | null,
          referredBy?: string | null,
          connectedAccount?: string | null,
          accountStatus?: AccountStatus | null,
          customerId?: string | null,
          xeroSyncStatus?: XeroSyncStatus | null,
          xeroLastContactSyncAt?: string | null,
          xeroContactSyncStatus?: XeroSyncStatus | null,
          xeroInvoiceSyncStatus?: XeroSyncStatus | null,
          xeroLastInvoiceSyncAt?: string | null,
          xeroTenantId?: string | null,
          absorbFees?: boolean | null,
          subscriptionTier?: SubscriptionTier | null,
          invitationStatus?: InvitationStatus | null,
          clientsOnboardingStatus?: ClientsOnboardingStatus | null,
          createdBy?: string | null,
          createdByEntityId?: string | null,
          isFirm?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | null,
        firm?:  {
          __typename: "Entity",
          id: string,
          type: EntityType,
          taxNumber?: string | null,
          companyNumber?: string | null,
          billerCode?: number | null,
          name: string,
          legalName?: string | null,
          businessNames?: Array< string | null > | null,
          searchName?: string | null,
          address?:  {
            __typename: "Address",
            addressId?: string | null,
            contactName?: string | null,
            contactNumber?: string | null,
            fullAddress?: string | null,
            address1?: string | null,
            address2?: string | null,
            city?: string | null,
            country: string,
            countryCode: string,
            state: string,
            stateCode?: string | null,
            postalCode: string,
            invalid?: boolean | null,
          } | null,
          logo?:  {
            __typename: "Image",
            alt?: string | null,
            identityId?: string | null,
            key: string,
            level: S3UploadLevel,
            type?: string | null,
          } | null,
          brandColour?: string | null,
          website?: string | null,
          entityUsers?:  {
            __typename: "ModelEntityUserConnection",
            items:  Array< {
              __typename: "EntityUser",
              id: string,
              entityId: string,
              userId: string,
              firmId?: string | null,
              email?: string | null,
              invitedEmail?: string | null,
              ocrEmail?: string | null,
              referredBy?: string | null,
              invitedEntityId?: string | null,
              firmEntityId?: string | null,
              providerContactId?: string | null,
              ownerCode?: string | null,
              clientGroupCode?: string | null,
              clientCode?: string | null,
              firstName?: string | null,
              lastName?: string | null,
              role: EntityUserRole,
              jobTags?: Array< JobTags | null > | null,
              paymentsEnabled?: boolean | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              termsFirmPayTaxAccepted?: boolean | null,
              termsFirmPayTaxDetails?:  {
                __typename: "TermsFirmPayTaxDetails",
                acceptedAt?: string | null,
                email?: string | null,
                ip?: string | null,
                fullName?: string | null,
                firmId?: string | null,
              } | null,
              entitySearchName?: string | null,
              entity?:  {
                __typename: "Entity",
                id: string,
                type: EntityType,
                taxNumber?: string | null,
                companyNumber?: string | null,
                billerCode?: number | null,
                name: string,
                legalName?: string | null,
                businessNames?: Array< string | null > | null,
                searchName?: string | null,
                brandColour?: string | null,
                website?: string | null,
                gstRegistered?: boolean | null,
                gstReportingPeriod?: GSTReportingPeriod | null,
                providerEntityId?: string | null,
                providerCompanyId?: string | null,
                providerBillUserCompanyId?: string | null,
                providerBankAccountId?: string | null,
                providerDigitalWalletId?: string | null,
                providerBpayCrn?: string | null,
                paymentMethodId?: string | null,
                paymentUserId?: string | null,
                disbursementMethodId?: string | null,
                ubosCreated?: boolean | null,
                numUbosCreated?: number | null,
                subCategory?: string | null,
                clientsStatus?: EntityClientsStatus | null,
                ocrEmail?: string | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                owner?: string | null,
                referredBy?: string | null,
                connectedAccount?: string | null,
                accountStatus?: AccountStatus | null,
                customerId?: string | null,
                xeroSyncStatus?: XeroSyncStatus | null,
                xeroLastContactSyncAt?: string | null,
                xeroContactSyncStatus?: XeroSyncStatus | null,
                xeroInvoiceSyncStatus?: XeroSyncStatus | null,
                xeroLastInvoiceSyncAt?: string | null,
                xeroTenantId?: string | null,
                absorbFees?: boolean | null,
                subscriptionTier?: SubscriptionTier | null,
                invitationStatus?: InvitationStatus | null,
                clientsOnboardingStatus?: ClientsOnboardingStatus | null,
                createdBy?: string | null,
                createdByEntityId?: string | null,
                isFirm?: boolean | null,
                createdAt?: string | null,
                updatedAt?: string | null,
              } | null,
              firm?:  {
                __typename: "Entity",
                id: string,
                type: EntityType,
                taxNumber?: string | null,
                companyNumber?: string | null,
                billerCode?: number | null,
                name: string,
                legalName?: string | null,
                businessNames?: Array< string | null > | null,
                searchName?: string | null,
                brandColour?: string | null,
                website?: string | null,
                gstRegistered?: boolean | null,
                gstReportingPeriod?: GSTReportingPeriod | null,
                providerEntityId?: string | null,
                providerCompanyId?: string | null,
                providerBillUserCompanyId?: string | null,
                providerBankAccountId?: string | null,
                providerDigitalWalletId?: string | null,
                providerBpayCrn?: string | null,
                paymentMethodId?: string | null,
                paymentUserId?: string | null,
                disbursementMethodId?: string | null,
                ubosCreated?: boolean | null,
                numUbosCreated?: number | null,
                subCategory?: string | null,
                clientsStatus?: EntityClientsStatus | null,
                ocrEmail?: string | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                owner?: string | null,
                referredBy?: string | null,
                connectedAccount?: string | null,
                accountStatus?: AccountStatus | null,
                customerId?: string | null,
                xeroSyncStatus?: XeroSyncStatus | null,
                xeroLastContactSyncAt?: string | null,
                xeroContactSyncStatus?: XeroSyncStatus | null,
                xeroInvoiceSyncStatus?: XeroSyncStatus | null,
                xeroLastInvoiceSyncAt?: string | null,
                xeroTenantId?: string | null,
                absorbFees?: boolean | null,
                subscriptionTier?: SubscriptionTier | null,
                invitationStatus?: InvitationStatus | null,
                clientsOnboardingStatus?: ClientsOnboardingStatus | null,
                createdBy?: string | null,
                createdByEntityId?: string | null,
                isFirm?: boolean | null,
                createdAt?: string | null,
                updatedAt?: string | null,
              } | null,
              searchName?: string | null,
              taxNumber?: string | null,
              taskSendSMS?: boolean | null,
              companyNumber?: string | null,
              createdBy?: string | null,
              createdAt: string,
              updatedAt: string,
              status?: EntityUserStatus | null,
              partnerId?: string | null,
              managerId?: string | null,
              archivedAt?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gstRegistered?: boolean | null,
          gstReportingPeriod?: GSTReportingPeriod | null,
          providerEntityId?: string | null,
          providerCompanyId?: string | null,
          providerBillUserCompanyId?: string | null,
          providerBankAccountId?: string | null,
          providerDigitalWalletId?: string | null,
          providerBpayCrn?: string | null,
          contact?:  {
            __typename: "EntityContact",
            firstName?: string | null,
            lastName?: string | null,
            email?: string | null,
            phone?: string | null,
            role?: string | null,
          } | null,
          paymentMethods?:  {
            __typename: "ModelPaymentMethodConnection",
            items:  Array< {
              __typename: "PaymentMethod",
              id: string,
              paymentMethodType: PaymentMethodType,
              type?: string | null,
              fullName?: string | null,
              number?: string | null,
              expMonth?: string | null,
              expYear?: string | null,
              accountName?: string | null,
              bankName?: string | null,
              accountNumber?: string | null,
              routingNumber?: string | null,
              holderType?: BankHolderType | null,
              accountType?: BankAccountType | null,
              status?: PaymentMethodStatus | null,
              accountDirection?: AccountDirection | null,
              expiresAt?: string | null,
              createdAt?: string | null,
              updatedAt?: string | null,
              consentId?: string | null,
              consentStatus?: PaymentConsentStatus | null,
              card?: string | null,
              googlepay?: string | null,
              applepay?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          paymentMethodId?: string | null,
          paymentUserId?: string | null,
          disbursementMethodId?: string | null,
          receivingAccounts?:  {
            __typename: "ModelPaymentMethodConnection",
            items:  Array< {
              __typename: "PaymentMethod",
              id: string,
              paymentMethodType: PaymentMethodType,
              type?: string | null,
              fullName?: string | null,
              number?: string | null,
              expMonth?: string | null,
              expYear?: string | null,
              accountName?: string | null,
              bankName?: string | null,
              accountNumber?: string | null,
              routingNumber?: string | null,
              holderType?: BankHolderType | null,
              accountType?: BankAccountType | null,
              status?: PaymentMethodStatus | null,
              accountDirection?: AccountDirection | null,
              expiresAt?: string | null,
              createdAt?: string | null,
              updatedAt?: string | null,
              consentId?: string | null,
              consentStatus?: PaymentConsentStatus | null,
              card?: string | null,
              googlepay?: string | null,
              applepay?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          ubosCreated?: boolean | null,
          numUbosCreated?: number | null,
          subCategory?: string | null,
          clientsStatus?: EntityClientsStatus | null,
          ocrEmail?: string | null,
          termsInvoiceAccepted?: boolean | null,
          termsOcrAccepted?: boolean | null,
          owner?: string | null,
          referredBy?: string | null,
          connectedAccount?: string | null,
          accountStatus?: AccountStatus | null,
          customerId?: string | null,
          xeroSyncStatus?: XeroSyncStatus | null,
          xeroLastContactSyncAt?: string | null,
          xeroContactSyncStatus?: XeroSyncStatus | null,
          xeroInvoiceSyncStatus?: XeroSyncStatus | null,
          xeroLastInvoiceSyncAt?: string | null,
          xeroTenantId?: string | null,
          absorbFees?: boolean | null,
          subscriptionTier?: SubscriptionTier | null,
          invitationStatus?: InvitationStatus | null,
          clientsOnboardingStatus?: ClientsOnboardingStatus | null,
          createdBy?: string | null,
          createdByEntityId?: string | null,
          isFirm?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | null,
        searchName?: string | null,
        taxNumber?: string | null,
        taskSendSMS?: boolean | null,
        companyNumber?: string | null,
        createdBy?: string | null,
        createdAt: string,
        updatedAt: string,
        status?: EntityUserStatus | null,
        partnerId?: string | null,
        managerId?: string | null,
        archivedAt?: string | null,
        taxPaymentReferences?:  {
          __typename: "TaxPaymentReferences",
          itr?:  {
            __typename: "TaxPaymentReference",
            referenceNumber?: string | null,
            updatedAt?: string | null,
          } | null,
          other?:  {
            __typename: "TaxPaymentReference",
            referenceNumber?: string | null,
            updatedAt?: string | null,
          } | null,
        } | null,
      } | null > | null,
      otherRecipients?:  Array< {
        __typename: "OtherRecipient",
        email: string,
        sendOnCompletion: boolean,
      } | null > | null,
      payments?:  {
        __typename: "ModelPaymentConnection",
        items:  Array< {
          __typename: "Payment",
          id: string,
          paymentIntentId?: string | null,
          taskId?: string | null,
          entityId?: string | null,
          payInPaymentId?: string | null,
          providerTransactionId?: string | null,
          paymentProvider?: PaymentProvider | null,
          disbursementId?: string | null,
          fromId: string,
          fromType: FromToType,
          toId?: string | null,
          toType?: FromToType | null,
          buyerId?: string | null,
          sellerId?: string | null,
          entityIdTo?: string | null,
          amount?: number | null,
          netAmount?: number | null,
          payerFees?: number | null,
          totalAmount?: number | null,
          gstAmount?: number | null,
          installment?: number | null,
          installments?: number | null,
          feeAmount?: number | null,
          reference?: string | null,
          paymentType?: PaymentType | null,
          taxAmount?: number | null,
          currency?: string | null,
          feeIds?: Array< string | null > | null,
          ipAddress?: string | null,
          status: PaymentStatus,
          payerUserStatus?: PayerUserStatus | null,
          declinedReason?: string | null,
          isUnlimitedRecurring?: boolean | null,
          payoutFailureReason?: string | null,
          payoutFailureFields?: Array< string | null > | null,
          payoutDetails?:  {
            __typename: "PayoutDetails",
            bank?:  {
              __typename: "ContactBankAccount",
              id?: string | null,
              accountName?: string | null,
              bankName?: string | null,
              accountNumber: string,
              routingNumber: string,
              holderType?: BankHolderType | null,
              accountType?: BankAccountType | null,
              country?: string | null,
            } | null,
            bpay?:  {
              __typename: "ContactBpay",
              billerCode?: number | null,
              referenceNumber?: string | null,
            } | null,
          } | null,
          scheduledAt?: string | null,
          paidAt?: string | null,
          declinedAt?: string | null,
          createdAt?: string | null,
          receivedAt?: string | null,
          paidOutAt?: string | null,
          updatedAt?: string | null,
          voidedAt?: string | null,
          owner?: string | null,
          payoutFailedAt?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdBy: string,
      entityIdBy?: string | null,
      dueAt: string,
      issuedAt?: string | null,
      notes?: string | null,
      reviewerFeedback?:  Array< {
        __typename: "ReviewerFeedback",
        reviewedById: string,
        feedback: string,
        status: ReviewerFeedbackStatus,
        createdAt: string,
      } | null > | null,
      direction?: TaskDirection | null,
      readBy?: Array< string | null > | null,
      gstInclusive?: boolean | null,
      isUnlimitedRecurring?: boolean | null,
      owner?: string | null,
      lineItems?:  Array< {
        __typename: "LineItem",
        serviceId?: string | null,
        description: string,
        quantity: number,
        unitAmount: number,
        taxType: TaxType,
        lineAmount?: number | null,
        newService?: boolean | null,
      } | null > | null,
      xeroTenantId?: string | null,
      sendSMS?: boolean | null,
      automaticGenerateInvoice?: boolean | null,
      automaticInvoicePaymentAt?: string | null,
      automaticInvoicePaymentTerms?: PaymentTerms | null,
      quoteRequiresSignature?: boolean | null,
      automaticallyGeneratedFromQuote?: boolean | null,
      sendTemplate?: boolean | null,
      includeLetterhead?: boolean | null,
      templateJson?: string | null,
      templateHtml?: string | null,
      paymentAt?: string | null,
      lodgementAt?: string | null,
      period?: string | null,
      year?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      viewedAt?: string | null,
      readAt?: string | null,
      paidAt?: string | null,
      endAt?: string | null,
      quoteAcceptedAt?: string | null,
      completedAt?: string | null,
      payoutErrors?: Array< string | null > | null,
    } | null >,
    total?: number | null,
  } | null,
};

export type SearchTaskCountsQueryVariables = {
  firmId?: string | null,
  entityId?: string | null,
  contactId?: string | null,
  createdBy?: string | null,
  status?: TaskSearchStatus | null,
  searchName?: string | null,
  dueAtStart?: string | null,
  dueAtEnd?: string | null,
};

export type SearchTaskCountsQuery = {
  searchTaskCounts?:  {
    __typename: "TaskCounts",
    ALL?: number | null,
    TAX_BILLS?: number | null,
    INVOICES?: number | null,
    QUOTES?: number | null,
    BILLS?: number | null,
    ESIGNATURE?: number | null,
  } | null,
};

export type TasksOverdueCountsQueryVariables = {
  firmId?: string | null,
  entityId?: string | null,
  contactId?: string | null,
  status?: TaskSearchStatus | null,
  types: Array< TaskSearchType >,
  sortDirection?: ModelSortDirection | null,
  createdBy?: string | null,
};

export type TasksOverdueCountsQuery = {
  tasksOverdueCounts?:  {
    __typename: "TasksOverdueResponse",
    TAX_BILLS?:  {
      __typename: "TaskOverdueCounts",
      tasks: number,
      clients: number,
      amount: number,
    } | null,
    INVOICES?:  {
      __typename: "TaskOverdueCounts",
      tasks: number,
      clients: number,
      amount: number,
    } | null,
    BILLS?:  {
      __typename: "TaskOverdueCounts",
      tasks: number,
      clients: number,
      amount: number,
    } | null,
    ESIGNATURE?:  {
      __typename: "TaskOverdueCounts",
      tasks: number,
      clients: number,
      amount: number,
    } | null,
  } | null,
};

export type TransactionsByEntityQueryVariables = {
  entityId: string,
  direction?: string | null,
  status?: string | null,
  startDate?: string | null,
  endDate?: string | null,
  amount?: number | null,
  netAmount?: number | null,
  sortDirection?: ModelSortDirection | null,
  from?: number | null,
  limit?: number | null,
};

export type TransactionsByEntityQuery = {
  transactionsByEntity?:  {
    __typename: "ModelTransactionOSConnection",
    items:  Array< {
      __typename: "Transaction",
      id: string,
      amount?: number | null,
      netAmount?: number | null,
      fee?: number | null,
      description?: string | null,
      status?: string | null,
      direction?: TransactionDirection | null,
      taskId?: string | null,
      entityId?: string | null,
      paymentId?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    total?: number | null,
  } | null,
};

export type GetTaskNumberQueryVariables = {
  entityId: string,
};

export type GetTaskNumberQuery = {
  getTaskNumber:  {
    __typename: "TaskNumber",
    id?: string | null,
    invoice?: number | null,
    quote?: number | null,
  },
};

export type GetTemplateQueryVariables = {
  id: string,
};

export type GetTemplateQuery = {
  getTemplate?:  {
    __typename: "Template",
    id: string,
    entityId: string,
    title: string,
    searchName?: string | null,
    templateJson?: string | null,
    templateHtml?: string | null,
    status: TemplateStatus,
    canDelete?: boolean | null,
    type: TemplateType,
    includeLetterhead?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type TemplatesByEntityQueryVariables = {
  entityId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type TemplatesByEntityQuery = {
  templatesByEntity?:  {
    __typename: "ModelTemplateConnection",
    items?:  Array< {
      __typename: "Template",
      id: string,
      entityId: string,
      title: string,
      searchName?: string | null,
      templateJson?: string | null,
      templateHtml?: string | null,
      status: TemplateStatus,
      canDelete?: boolean | null,
      type: TemplateType,
      includeLetterhead?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetTranslationQueryVariables = {
  language?: string | null,
  namespace?: string | null,
};

export type GetTranslationQuery = {
  getTranslation?:  {
    __typename: "Translation",
    language: string,
    namespace: string,
    data?: string | null,
  } | null,
};

export type ListTranslationsQuery = {
  listTranslations?:  Array< {
    __typename: "TranslationConnection",
    language?: string | null,
    items?:  Array< {
      __typename: "Translation",
      language: string,
      namespace: string,
      data?: string | null,
    } | null > | null,
  } | null > | null,
};

export type GetUserQueryVariables = {
  id: string,
};

export type GetUserQuery = {
  getUser?:  {
    __typename: "User",
    id: string,
    identityId?: string | null,
    referralCode?: string | null,
    referredBy?: string | null,
    email?: string | null,
    about?: string | null,
    firstName?: string | null,
    firmId?: string | null,
    lastName?: string | null,
    phone?: string | null,
    blocked?: Array< string | null > | null,
    blockedBy?: Array< string | null > | null,
    country?: string | null,
    profileImg?:  {
      __typename: "Image",
      alt?: string | null,
      identityId?: string | null,
      key: string,
      level: S3UploadLevel,
      type?: string | null,
    } | null,
    interests?: Array< string | null > | null,
    locale?: string | null,
    onboardingStatus?: OnboardingStatus | null,
    onboardingEntity?: string | null,
    selectedEntityId?: string | null,
    selectedSignatureKey?: string | null,
    signatures?:  {
      __typename: "ModelSignatureConnection",
      items:  Array< {
        __typename: "Signature",
        id: string,
        userId: string,
        key: string,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    userType?: UserType | null,
    rating?: number | null,
    reportReasons?: Array< string | null > | null,
    notificationPreferences?:  {
      __typename: "NotificationPreferences",
      email?: boolean | null,
      push?: boolean | null,
      sms?: boolean | null,
    } | null,
    paymentUserId?: string | null,
    providerWalletId?: string | null,
    providerNppCrn?: string | null,
    ipAddress?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    owner?: string | null,
    loyaltyStatus?: RewardStatus | null,
    nextLoyaltyStatus?: RewardStatus | null,
    nextLoyaltyStatusPoint?: number | null,
    statusPoint?: number | null,
    pointsTotal?: number | null,
    pointsBalance?: number | null,
    invitedTo?: string | null,
  } | null,
};

export type ListUsersQueryVariables = {
  id?: string | null,
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListUsersQuery = {
  listUsers?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      identityId?: string | null,
      referralCode?: string | null,
      referredBy?: string | null,
      email?: string | null,
      about?: string | null,
      firstName?: string | null,
      firmId?: string | null,
      lastName?: string | null,
      phone?: string | null,
      blocked?: Array< string | null > | null,
      blockedBy?: Array< string | null > | null,
      country?: string | null,
      profileImg?:  {
        __typename: "Image",
        alt?: string | null,
        identityId?: string | null,
        key: string,
        level: S3UploadLevel,
        type?: string | null,
      } | null,
      interests?: Array< string | null > | null,
      locale?: string | null,
      onboardingStatus?: OnboardingStatus | null,
      onboardingEntity?: string | null,
      selectedEntityId?: string | null,
      selectedSignatureKey?: string | null,
      signatures?:  {
        __typename: "ModelSignatureConnection",
        items:  Array< {
          __typename: "Signature",
          id: string,
          userId: string,
          key: string,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      userType?: UserType | null,
      rating?: number | null,
      reportReasons?: Array< string | null > | null,
      notificationPreferences?:  {
        __typename: "NotificationPreferences",
        email?: boolean | null,
        push?: boolean | null,
        sms?: boolean | null,
      } | null,
      paymentUserId?: string | null,
      providerWalletId?: string | null,
      providerNppCrn?: string | null,
      ipAddress?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      owner?: string | null,
      loyaltyStatus?: RewardStatus | null,
      nextLoyaltyStatus?: RewardStatus | null,
      nextLoyaltyStatusPoint?: number | null,
      statusPoint?: number | null,
      pointsTotal?: number | null,
      pointsBalance?: number | null,
      invitedTo?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetActivitiesByUserQueryVariables = {
  id: string,
  filter?: ModelActivityFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type GetActivitiesByUserQuery = {
  getActivitiesByUser?:  {
    __typename: "ModelActivityConnection",
    items:  Array< {
      __typename: "Activity",
      id: string,
      compositeId: string,
      userId?: string | null,
      entityId?: string | null,
      type: ActivityType,
      message?: string | null,
      metadata?:  {
        __typename: "ActivityMetadata",
        name?: string | null,
        email?: string | null,
      } | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetReferralsByUserQueryVariables = {
  id: string,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type GetReferralsByUserQuery = {
  getReferralsByUser?:  {
    __typename: "ModelReferralConnection",
    items:  Array< {
      __typename: "Referral",
      id: string,
      userId: string,
      referredId: string,
      firstName?: string | null,
      lastName?: string | null,
      taskPaidCount?: number | null,
      referredByCode?: string | null,
      referredCompleted?: boolean | null,
      referredSignedStatus?: boolean | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type XeroListContactsQueryVariables = {
  page?: number | null,
};

export type XeroListContactsQuery = {
  xeroListContacts?:  Array< {
    __typename: "XeroContact",
    contactID: string,
    contactNumber?: string | null,
    accountNumber?: string | null,
    contactStatus?: ContactStatus | null,
    name?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    emailAddress?: string | null,
    bankAccountDetails?: string | null,
    companyNumber?: string | null,
    taxNumber?: string | null,
    accountsReceivableTaxType?: string | null,
    accountsPayableTaxType?: string | null,
    addresses?:  Array< {
      __typename: "XeroAddress",
      addressType?: string | null,
      addressLine1?: string | null,
      addressLine2?: string | null,
      addressLine3?: string | null,
      addressLine4?: string | null,
      city?: string | null,
      region?: string | null,
      postalCode?: string | null,
      country?: string | null,
      attentionTo?: string | null,
    } | null > | null,
    phones?:  Array< {
      __typename: "XeroPhone",
      phoneType?: string | null,
      phoneNumber?: string | null,
      phoneAreaCode?: string | null,
      phoneCountryCode?: string | null,
    } | null > | null,
    isSupplier?: boolean | null,
    isCustomer?: boolean | null,
    defaultCurrency?: string | null,
    updatedDateUTC?: string | null,
    contactPersons?:  Array< {
      __typename: "XeroContactPerson",
      firstName?: string | null,
      lastName?: string | null,
      emailAddress?: string | null,
      includeInEmails?: boolean | null,
    } | null > | null,
    xeroNetworkKey?: string | null,
    mergedToContactID?: string | null,
    salesDefaultAccountCode?: string | null,
    purchasesDefaultAccountCode?: string | null,
    salesTrackingCategories?: Array< string | null > | null,
    purchasesTrackingCategories?: Array< string | null > | null,
    salesDefaultLineAmountType?: string | null,
    purchasesDefaultLineAmountType?: string | null,
    trackingCategoryName?: string | null,
    trackingCategoryOption?: string | null,
    paymentTerms?: string | null,
    website?: string | null,
    brandingTheme?: string | null,
    batchPayments?: string | null,
    discount?: number | null,
    validationErrors?: Array< string | null > | null,
    hasValidationErrors?: boolean | null,
    hasAttachments?: boolean | null,
    balances?:  {
      __typename: "Balances",
      accountsReceivable?: number | null,
      accountsPayable?: number | null,
    } | null,
    statusAttributeString?: string | null,
  } | null > | null,
};

export type XeroListTransactionsQueryVariables = {
  statuses?: Array< XeroInvoiceStatus | null > | null,
  page?: number | null,
};

export type XeroListTransactionsQuery = {
  xeroListTransactions?:  Array< {
    __typename: "XeroInvoice",
    invoiceID: string,
    type?: string | null,
    status?: XeroInvoiceStatus | null,
    lineAmountTypes?: string | null,
    currencyCode?: string | null,
    date?: string | null,
    dueDate?: string | null,
    lineItems?:  Array< {
      __typename: "XeroLineItem",
      lineItemID: string,
      description?: string | null,
      quantity?: number | null,
      unitAmount?: number | null,
      itemCode?: string | null,
      accountCode?: string | null,
      accountID?: string | null,
      taxType?: string | null,
      taxAmount?: number | null,
      lineAmount?: number | null,
      taxNumber?: number | null,
      discountRate?: number | null,
      discountAmount?: number | null,
      repeatingInvoiceID?: string | null,
    } | null > | null,
    subTotal?: number | null,
    totalTax?: number | null,
    total?: number | null,
    invoiceNumber?: string | null,
    reference?: string | null,
    hasAttachments?: boolean | null,
    updatedDateUTC?: string | null,
    currencyRate?: number | null,
    remainingCredit?: number | null,
    amountDue?: number | null,
    amountPaid?: number | null,
    fullyPaidOnDate?: string | null,
    amountCredited?: number | null,
    brandingThemeID?: string | null,
    hasErrors?: boolean | null,
    contact?:  {
      __typename: "XeroContact",
      contactID: string,
      contactNumber?: string | null,
      accountNumber?: string | null,
      contactStatus?: ContactStatus | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      emailAddress?: string | null,
      bankAccountDetails?: string | null,
      companyNumber?: string | null,
      taxNumber?: string | null,
      accountsReceivableTaxType?: string | null,
      accountsPayableTaxType?: string | null,
      addresses?:  Array< {
        __typename: "XeroAddress",
        addressType?: string | null,
        addressLine1?: string | null,
        addressLine2?: string | null,
        addressLine3?: string | null,
        addressLine4?: string | null,
        city?: string | null,
        region?: string | null,
        postalCode?: string | null,
        country?: string | null,
        attentionTo?: string | null,
      } | null > | null,
      phones?:  Array< {
        __typename: "XeroPhone",
        phoneType?: string | null,
        phoneNumber?: string | null,
        phoneAreaCode?: string | null,
        phoneCountryCode?: string | null,
      } | null > | null,
      isSupplier?: boolean | null,
      isCustomer?: boolean | null,
      defaultCurrency?: string | null,
      updatedDateUTC?: string | null,
      contactPersons?:  Array< {
        __typename: "XeroContactPerson",
        firstName?: string | null,
        lastName?: string | null,
        emailAddress?: string | null,
        includeInEmails?: boolean | null,
      } | null > | null,
      xeroNetworkKey?: string | null,
      mergedToContactID?: string | null,
      salesDefaultAccountCode?: string | null,
      purchasesDefaultAccountCode?: string | null,
      salesTrackingCategories?: Array< string | null > | null,
      purchasesTrackingCategories?: Array< string | null > | null,
      salesDefaultLineAmountType?: string | null,
      purchasesDefaultLineAmountType?: string | null,
      trackingCategoryName?: string | null,
      trackingCategoryOption?: string | null,
      paymentTerms?: string | null,
      website?: string | null,
      brandingTheme?: string | null,
      batchPayments?: string | null,
      discount?: number | null,
      validationErrors?: Array< string | null > | null,
      hasValidationErrors?: boolean | null,
      hasAttachments?: boolean | null,
      balances?:  {
        __typename: "Balances",
        accountsReceivable?: number | null,
        accountsPayable?: number | null,
      } | null,
      statusAttributeString?: string | null,
    } | null,
  } | null > | null,
};

export type XeroGetConnectionStatusQuery = {
  xeroGetConnectionStatus:  {
    __typename: "XeroConnectionStatus",
    isConnected: boolean,
  },
};

export type XeroGetEntityConnectionStatusQueryVariables = {
  input?: XeroGetEntityConnectionStatusInput | null,
};

export type XeroGetEntityConnectionStatusQuery = {
  xeroGetEntityConnectionStatus:  {
    __typename: "XeroConnectionStatus",
    isConnected: boolean,
  },
};

export type XeroGetSyncedTenantsQuery = {
  xeroGetSyncedTenants:  Array< {
    __typename: "XeroTenant",
    id?: string | null,
    authEventId?: string | null,
    tenantId?: string | null,
    tenantType?: XeroTenantType | null,
    tenantName?: string | null,
    createdDateUtc?: string | null,
    updatedDateUtc?: string | null,
  } | null >,
};

export type XeroGetAccountsQueryVariables = {
  input?: XeroGetAccountsInput | null,
};

export type XeroGetAccountsQuery = {
  xeroGetAccounts?:  Array< {
    __typename: "XeroAccount",
    code?: string | null,
    name?: string | null,
    accountID?: string | null,
    type?: XeroAccountType | null,
    bankAccountNumber?: string | null,
    status?: XeroAccountStatus | null,
    description?: string | null,
    bankAccountType?: XeroBankAccountType | null,
    currencyCode?: string | null,
    taxType?: string | null,
    enablePaymentsToAccount?: boolean | null,
    showInExpenseClaims?: boolean | null,
    _class?: XeroAccountClass | null,
    systemAccount?: XeroSystemAccountType | null,
    reportingCode?: string | null,
    reportingCodeName?: string | null,
    hasAttachments?: boolean | null,
    updatedDateUTC?: string | null,
    addToWatchlist?: boolean | null,
  } | null > | null,
};

export type GetEmailProviderConnectionStatusQueryVariables = {
  entityId: string,
  provider: string,
};

export type GetEmailProviderConnectionStatusQuery = {
  getEmailProviderConnectionStatus?:  {
    __typename: "EmailProviderConnectionStatus",
    isConnected: boolean,
  } | null,
};

export type GetEntityPayIdQueryVariables = {
  entityId: string,
  billPayments?: Array< BillsPaymentInput | null > | null,
};

export type GetEntityPayIdQuery = {
  getEntityPayId?:  {
    __typename: "EntityPayId",
    transferAmount?: number | null,
    payId?: string | null,
    currency?: string | null,
    accountName?: string | null,
    accountNumber?: string | null,
    routingNumber?: string | null,
    currentBalance?:  {
      __typename: "CurrentBalance",
      availableAmount?: number | null,
      currency?: string | null,
      pendingAmount?: number | null,
      reservedAmount?: number | null,
      payableTaxAmount?: number | null,
      totalAmount?: number | null,
    } | null,
  } | null,
};

export type GetCustomerSecretQueryVariables = {
  entityId: string,
};

export type GetCustomerSecretQuery = {
  getCustomerSecret?: string | null,
};

export type GetBalanceHistoryQueryVariables = {
  entityId: string,
  limit?: number | null,
  pageNum?: string | null,
  currency?: string | null,
};

export type GetBalanceHistoryQuery = {
  getBalanceHistory?:  {
    __typename: "BalanceHistory",
    hasMore?: boolean | null,
    items:  Array< {
      __typename: "BalanceHistoryItem",
      source?: string | null,
      amount: string,
      currency: string,
      balance: string,
      description?: string | null,
      fee?: string | null,
      postedAt: string,
      sourceType: string,
      transactionType?: string | null,
    } | null >,
    pageBefore?: string | null,
    pageAfter?: string | null,
  } | null,
};

export type GetAdmiinAccountQueryVariables = {
  entityId: string,
  currency?: string | null,
};

export type GetAdmiinAccountQuery = {
  getAdmiinAccount?:  {
    __typename: "AdmiinAccount",
    id: string,
    currency?: string | null,
    accountName?: string | null,
    accountNumber?: string | null,
    routingNumber?: string | null,
    currentBalance?:  {
      __typename: "CurrentBalance",
      availableAmount?: number | null,
      currency?: string | null,
      pendingAmount?: number | null,
      reservedAmount?: number | null,
      payableTaxAmount?: number | null,
      totalAmount?: number | null,
    } | null,
  } | null,
};

export type TransactionHistoryQueryVariables = {
  entityId: string,
  type?: HistoryType | null,
  startDate?: string | null,
  endDate?: string | null,
  page?: string | null,
  limit?: number | null,
};

export type TransactionHistoryQuery = {
  transactionHistory?:  {
    __typename: "ModelTransactionHistory",
    items:  Array< {
      __typename: "ModelTransactionHistoryItem",
      receiver?: string | null,
      payer?: string | null,
      reference?: string | null,
      description?: string | null,
      netAmount?: number | null,
      payerFees?: number | null,
      taxAmount?: number | null,
      totalAmount?: number | null,
      balance?: number | null,
      amount?: number | null,
      date?: string | null,
    } | null >,
  } | null,
};

export type OnUpdateDocumentAnalysisSubscriptionVariables = {
  entityId: string,
};

export type OnUpdateDocumentAnalysisSubscription = {
  onUpdateDocumentAnalysis?:  {
    __typename: "DocumentAnalysis",
    id: string,
    entityId?: string | null,
    firmId?: string | null,
    fileKey?: string | null,
    documents?:  Array< {
      __typename: "S3Upload",
      identityId?: string | null,
      key: string,
      level: S3UploadLevel,
      type: S3UploadType,
      name?: string | null,
    } | null > | null,
    status: DocumentAnalysisStatus,
    expenseStatus?: DocumentAnalysisStatus | null,
    queryStatus?: DocumentAnalysisStatus | null,
    matchedBiller?:  {
      __typename: "BillerDetails",
      billerCode?: number | null,
      billerCategory?: string | null,
      shortName?: string | null,
      longName?: string | null,
      type?: BillerType | null,
      industryCode?: string | null,
      industryCodeDescription?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    matchedContactId?: string | null,
    matchedContact?:  {
      __typename: "Contact",
      id: string,
      entityId: string,
      xeroTenantId?: string | null,
      entityType?: EntityType | null,
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      mobile?: string | null,
      phone?: string | null,
      taxNumber?: string | null,
      companyNumber?: string | null,
      name?: string | null,
      legalName?: string | null,
      searchName?: string | null,
      status?: ContactStatus | null,
      website?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      contactType?: ContactType | null,
      bank?:  {
        __typename: "ContactBankAccount",
        id?: string | null,
        accountName?: string | null,
        bankName?: string | null,
        accountNumber: string,
        routingNumber: string,
        holderType?: BankHolderType | null,
        accountType?: BankAccountType | null,
        country?: string | null,
      } | null,
      bpay?:  {
        __typename: "ContactBpay",
        billerCode?: number | null,
        referenceNumber?: string | null,
      } | null,
      invalidFields?: Array< string | null > | null,
      bulkUploadFileKey?: string | null,
      owner?: string | null,
      createdBy?: string | null,
      beneficiaryBankId?: string | null,
      beneficiaryBpayId?: string | null,
      address?:  {
        __typename: "Address",
        addressId?: string | null,
        contactName?: string | null,
        contactNumber?: string | null,
        fullAddress?: string | null,
        address1?: string | null,
        address2?: string | null,
        city?: string | null,
        country: string,
        countryCode: string,
        state: string,
        stateCode?: string | null,
        postalCode: string,
        invalid?: boolean | null,
      } | null,
      postal?:  {
        __typename: "Address",
        addressId?: string | null,
        contactName?: string | null,
        contactNumber?: string | null,
        fullAddress?: string | null,
        address1?: string | null,
        address2?: string | null,
        city?: string | null,
        country: string,
        countryCode: string,
        state: string,
        stateCode?: string | null,
        postalCode: string,
        invalid?: boolean | null,
      } | null,
      payoutErrors?: Array< string | null > | null,
    } | null,
    matchedEntityId?: string | null,
    matchedEntity?:  {
      __typename: "Entity",
      id: string,
      type: EntityType,
      taxNumber?: string | null,
      companyNumber?: string | null,
      billerCode?: number | null,
      name: string,
      legalName?: string | null,
      businessNames?: Array< string | null > | null,
      searchName?: string | null,
      address?:  {
        __typename: "Address",
        addressId?: string | null,
        contactName?: string | null,
        contactNumber?: string | null,
        fullAddress?: string | null,
        address1?: string | null,
        address2?: string | null,
        city?: string | null,
        country: string,
        countryCode: string,
        state: string,
        stateCode?: string | null,
        postalCode: string,
        invalid?: boolean | null,
      } | null,
      logo?:  {
        __typename: "Image",
        alt?: string | null,
        identityId?: string | null,
        key: string,
        level: S3UploadLevel,
        type?: string | null,
      } | null,
      brandColour?: string | null,
      website?: string | null,
      entityUsers?:  {
        __typename: "ModelEntityUserConnection",
        items:  Array< {
          __typename: "EntityUser",
          id: string,
          entityId: string,
          userId: string,
          firmId?: string | null,
          email?: string | null,
          invitedEmail?: string | null,
          ocrEmail?: string | null,
          referredBy?: string | null,
          invitedEntityId?: string | null,
          firmEntityId?: string | null,
          providerContactId?: string | null,
          ownerCode?: string | null,
          clientGroupCode?: string | null,
          clientCode?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          role: EntityUserRole,
          jobTags?: Array< JobTags | null > | null,
          paymentsEnabled?: boolean | null,
          termsInvoiceAccepted?: boolean | null,
          termsOcrAccepted?: boolean | null,
          termsFirmPayTaxAccepted?: boolean | null,
          termsFirmPayTaxDetails?:  {
            __typename: "TermsFirmPayTaxDetails",
            document?:  {
              __typename: "S3Upload",
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type: S3UploadType,
              name?: string | null,
            } | null,
            acceptedAt?: string | null,
            email?: string | null,
            ip?: string | null,
            fullName?: string | null,
            firmId?: string | null,
          } | null,
          entitySearchName?: string | null,
          entity?:  {
            __typename: "Entity",
            id: string,
            type: EntityType,
            taxNumber?: string | null,
            companyNumber?: string | null,
            billerCode?: number | null,
            name: string,
            legalName?: string | null,
            businessNames?: Array< string | null > | null,
            searchName?: string | null,
            address?:  {
              __typename: "Address",
              addressId?: string | null,
              contactName?: string | null,
              contactNumber?: string | null,
              fullAddress?: string | null,
              address1?: string | null,
              address2?: string | null,
              city?: string | null,
              country: string,
              countryCode: string,
              state: string,
              stateCode?: string | null,
              postalCode: string,
              invalid?: boolean | null,
            } | null,
            logo?:  {
              __typename: "Image",
              alt?: string | null,
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type?: string | null,
            } | null,
            brandColour?: string | null,
            website?: string | null,
            entityUsers?:  {
              __typename: "ModelEntityUserConnection",
              items:  Array< {
                __typename: "EntityUser",
                id: string,
                entityId: string,
                userId: string,
                firmId?: string | null,
                email?: string | null,
                invitedEmail?: string | null,
                ocrEmail?: string | null,
                referredBy?: string | null,
                invitedEntityId?: string | null,
                firmEntityId?: string | null,
                providerContactId?: string | null,
                ownerCode?: string | null,
                clientGroupCode?: string | null,
                clientCode?: string | null,
                firstName?: string | null,
                lastName?: string | null,
                role: EntityUserRole,
                jobTags?: Array< JobTags | null > | null,
                paymentsEnabled?: boolean | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                termsFirmPayTaxAccepted?: boolean | null,
                entitySearchName?: string | null,
                searchName?: string | null,
                taxNumber?: string | null,
                taskSendSMS?: boolean | null,
                companyNumber?: string | null,
                createdBy?: string | null,
                createdAt: string,
                updatedAt: string,
                status?: EntityUserStatus | null,
                partnerId?: string | null,
                managerId?: string | null,
                archivedAt?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gstRegistered?: boolean | null,
            gstReportingPeriod?: GSTReportingPeriod | null,
            providerEntityId?: string | null,
            providerCompanyId?: string | null,
            providerBillUserCompanyId?: string | null,
            providerBankAccountId?: string | null,
            providerDigitalWalletId?: string | null,
            providerBpayCrn?: string | null,
            contact?:  {
              __typename: "EntityContact",
              firstName?: string | null,
              lastName?: string | null,
              email?: string | null,
              phone?: string | null,
              role?: string | null,
            } | null,
            paymentMethods?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            paymentMethodId?: string | null,
            paymentUserId?: string | null,
            disbursementMethodId?: string | null,
            receivingAccounts?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            ubosCreated?: boolean | null,
            numUbosCreated?: number | null,
            subCategory?: string | null,
            clientsStatus?: EntityClientsStatus | null,
            ocrEmail?: string | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            owner?: string | null,
            referredBy?: string | null,
            connectedAccount?: string | null,
            accountStatus?: AccountStatus | null,
            customerId?: string | null,
            xeroSyncStatus?: XeroSyncStatus | null,
            xeroLastContactSyncAt?: string | null,
            xeroContactSyncStatus?: XeroSyncStatus | null,
            xeroInvoiceSyncStatus?: XeroSyncStatus | null,
            xeroLastInvoiceSyncAt?: string | null,
            xeroTenantId?: string | null,
            absorbFees?: boolean | null,
            subscriptionTier?: SubscriptionTier | null,
            invitationStatus?: InvitationStatus | null,
            clientsOnboardingStatus?: ClientsOnboardingStatus | null,
            createdBy?: string | null,
            createdByEntityId?: string | null,
            isFirm?: boolean | null,
            createdAt?: string | null,
            updatedAt?: string | null,
          } | null,
          firm?:  {
            __typename: "Entity",
            id: string,
            type: EntityType,
            taxNumber?: string | null,
            companyNumber?: string | null,
            billerCode?: number | null,
            name: string,
            legalName?: string | null,
            businessNames?: Array< string | null > | null,
            searchName?: string | null,
            address?:  {
              __typename: "Address",
              addressId?: string | null,
              contactName?: string | null,
              contactNumber?: string | null,
              fullAddress?: string | null,
              address1?: string | null,
              address2?: string | null,
              city?: string | null,
              country: string,
              countryCode: string,
              state: string,
              stateCode?: string | null,
              postalCode: string,
              invalid?: boolean | null,
            } | null,
            logo?:  {
              __typename: "Image",
              alt?: string | null,
              identityId?: string | null,
              key: string,
              level: S3UploadLevel,
              type?: string | null,
            } | null,
            brandColour?: string | null,
            website?: string | null,
            entityUsers?:  {
              __typename: "ModelEntityUserConnection",
              items:  Array< {
                __typename: "EntityUser",
                id: string,
                entityId: string,
                userId: string,
                firmId?: string | null,
                email?: string | null,
                invitedEmail?: string | null,
                ocrEmail?: string | null,
                referredBy?: string | null,
                invitedEntityId?: string | null,
                firmEntityId?: string | null,
                providerContactId?: string | null,
                ownerCode?: string | null,
                clientGroupCode?: string | null,
                clientCode?: string | null,
                firstName?: string | null,
                lastName?: string | null,
                role: EntityUserRole,
                jobTags?: Array< JobTags | null > | null,
                paymentsEnabled?: boolean | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                termsFirmPayTaxAccepted?: boolean | null,
                entitySearchName?: string | null,
                searchName?: string | null,
                taxNumber?: string | null,
                taskSendSMS?: boolean | null,
                companyNumber?: string | null,
                createdBy?: string | null,
                createdAt: string,
                updatedAt: string,
                status?: EntityUserStatus | null,
                partnerId?: string | null,
                managerId?: string | null,
                archivedAt?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gstRegistered?: boolean | null,
            gstReportingPeriod?: GSTReportingPeriod | null,
            providerEntityId?: string | null,
            providerCompanyId?: string | null,
            providerBillUserCompanyId?: string | null,
            providerBankAccountId?: string | null,
            providerDigitalWalletId?: string | null,
            providerBpayCrn?: string | null,
            contact?:  {
              __typename: "EntityContact",
              firstName?: string | null,
              lastName?: string | null,
              email?: string | null,
              phone?: string | null,
              role?: string | null,
            } | null,
            paymentMethods?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            paymentMethodId?: string | null,
            paymentUserId?: string | null,
            disbursementMethodId?: string | null,
            receivingAccounts?:  {
              __typename: "ModelPaymentMethodConnection",
              items:  Array< {
                __typename: "PaymentMethod",
                id: string,
                paymentMethodType: PaymentMethodType,
                type?: string | null,
                fullName?: string | null,
                number?: string | null,
                expMonth?: string | null,
                expYear?: string | null,
                accountName?: string | null,
                bankName?: string | null,
                accountNumber?: string | null,
                routingNumber?: string | null,
                holderType?: BankHolderType | null,
                accountType?: BankAccountType | null,
                status?: PaymentMethodStatus | null,
                accountDirection?: AccountDirection | null,
                expiresAt?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                consentId?: string | null,
                consentStatus?: PaymentConsentStatus | null,
                card?: string | null,
                googlepay?: string | null,
                applepay?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            ubosCreated?: boolean | null,
            numUbosCreated?: number | null,
            subCategory?: string | null,
            clientsStatus?: EntityClientsStatus | null,
            ocrEmail?: string | null,
            termsInvoiceAccepted?: boolean | null,
            termsOcrAccepted?: boolean | null,
            owner?: string | null,
            referredBy?: string | null,
            connectedAccount?: string | null,
            accountStatus?: AccountStatus | null,
            customerId?: string | null,
            xeroSyncStatus?: XeroSyncStatus | null,
            xeroLastContactSyncAt?: string | null,
            xeroContactSyncStatus?: XeroSyncStatus | null,
            xeroInvoiceSyncStatus?: XeroSyncStatus | null,
            xeroLastInvoiceSyncAt?: string | null,
            xeroTenantId?: string | null,
            absorbFees?: boolean | null,
            subscriptionTier?: SubscriptionTier | null,
            invitationStatus?: InvitationStatus | null,
            clientsOnboardingStatus?: ClientsOnboardingStatus | null,
            createdBy?: string | null,
            createdByEntityId?: string | null,
            isFirm?: boolean | null,
            createdAt?: string | null,
            updatedAt?: string | null,
          } | null,
          searchName?: string | null,
          taxNumber?: string | null,
          taskSendSMS?: boolean | null,
          companyNumber?: string | null,
          createdBy?: string | null,
          createdAt: string,
          updatedAt: string,
          status?: EntityUserStatus | null,
          partnerId?: string | null,
          managerId?: string | null,
          archivedAt?: string | null,
          taxPaymentReferences?:  {
            __typename: "TaxPaymentReferences",
            itr?:  {
              __typename: "TaxPaymentReference",
              referenceNumber?: string | null,
              updatedAt?: string | null,
            } | null,
            other?:  {
              __typename: "TaxPaymentReference",
              referenceNumber?: string | null,
              updatedAt?: string | null,
            } | null,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gstRegistered?: boolean | null,
      gstReportingPeriod?: GSTReportingPeriod | null,
      providerEntityId?: string | null,
      providerCompanyId?: string | null,
      providerBillUserCompanyId?: string | null,
      providerBankAccountId?: string | null,
      providerDigitalWalletId?: string | null,
      providerBpayCrn?: string | null,
      contact?:  {
        __typename: "EntityContact",
        firstName?: string | null,
        lastName?: string | null,
        email?: string | null,
        phone?: string | null,
        role?: string | null,
      } | null,
      paymentMethods?:  {
        __typename: "ModelPaymentMethodConnection",
        items:  Array< {
          __typename: "PaymentMethod",
          id: string,
          paymentMethodType: PaymentMethodType,
          type?: string | null,
          fullName?: string | null,
          number?: string | null,
          expMonth?: string | null,
          expYear?: string | null,
          accountName?: string | null,
          bankName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
          holderType?: BankHolderType | null,
          accountType?: BankAccountType | null,
          status?: PaymentMethodStatus | null,
          accountDirection?: AccountDirection | null,
          expiresAt?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          consentId?: string | null,
          consentStatus?: PaymentConsentStatus | null,
          card?: string | null,
          googlepay?: string | null,
          applepay?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      paymentMethodId?: string | null,
      paymentUserId?: string | null,
      disbursementMethodId?: string | null,
      receivingAccounts?:  {
        __typename: "ModelPaymentMethodConnection",
        items:  Array< {
          __typename: "PaymentMethod",
          id: string,
          paymentMethodType: PaymentMethodType,
          type?: string | null,
          fullName?: string | null,
          number?: string | null,
          expMonth?: string | null,
          expYear?: string | null,
          accountName?: string | null,
          bankName?: string | null,
          accountNumber?: string | null,
          routingNumber?: string | null,
          holderType?: BankHolderType | null,
          accountType?: BankAccountType | null,
          status?: PaymentMethodStatus | null,
          accountDirection?: AccountDirection | null,
          expiresAt?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          consentId?: string | null,
          consentStatus?: PaymentConsentStatus | null,
          card?: string | null,
          googlepay?: string | null,
          applepay?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      ubosCreated?: boolean | null,
      numUbosCreated?: number | null,
      subCategory?: string | null,
      clientsStatus?: EntityClientsStatus | null,
      ocrEmail?: string | null,
      termsInvoiceAccepted?: boolean | null,
      termsOcrAccepted?: boolean | null,
      owner?: string | null,
      referredBy?: string | null,
      connectedAccount?: string | null,
      accountStatus?: AccountStatus | null,
      customerId?: string | null,
      xeroSyncStatus?: XeroSyncStatus | null,
      xeroLastContactSyncAt?: string | null,
      xeroContactSyncStatus?: XeroSyncStatus | null,
      xeroInvoiceSyncStatus?: XeroSyncStatus | null,
      xeroLastInvoiceSyncAt?: string | null,
      xeroTenantId?: string | null,
      absorbFees?: boolean | null,
      subscriptionTier?: SubscriptionTier | null,
      invitationStatus?: InvitationStatus | null,
      clientsOnboardingStatus?: ClientsOnboardingStatus | null,
      createdBy?: string | null,
      createdByEntityId?: string | null,
      isFirm?: boolean | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    newContact?:  {
      __typename: "DocumentAnalysisContact",
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      mobile?: string | null,
      phone?: string | null,
      name?: string | null,
      taxNumber?: string | null,
      address?:  {
        __typename: "Address",
        addressId?: string | null,
        contactName?: string | null,
        contactNumber?: string | null,
        fullAddress?: string | null,
        address1?: string | null,
        address2?: string | null,
        city?: string | null,
        country: string,
        countryCode: string,
        state: string,
        stateCode?: string | null,
        postalCode: string,
        invalid?: boolean | null,
      } | null,
    } | null,
    task?:  {
      __typename: "DocumentAnalysisTask",
      reference?: string | null,
      dueAt?: string | null,
      issuedAt?: string | null,
      lodgementAt?: string | null,
      paymentAt?: string | null,
      gstInclusive?: boolean | null,
      notes?: string | null,
      amount?: number | null,
      gstAmount?: number | null,
      taxAmount?: number | null,
      lineItems?:  Array< {
        __typename: "DocumentAnalysisLineItem",
        description?: string | null,
        quantity?: number | null,
        unitPrice?: number | null,
        price?: number | null,
        productCode?: string | null,
        taxType?: TaxType | null,
      } | null > | null,
      numberOfPayments?: number | null,
      paymentFrequency?: PaymentFrequency | null,
      shippingAmount?: number | null,
      settlementStatus?: TaskSettlementStatus | null,
      partnerId?: string | null,
      managerId?: string | null,
      documentType?: DocumentType | null,
      subCategory?: string | null,
      category?: TaskCategory | null,
      period?: string | null,
      year?: string | null,
    } | null,
    bpay?:  {
      __typename: "ContactBpay",
      billerCode?: number | null,
      referenceNumber?: string | null,
    } | null,
    bank?:  {
      __typename: "DocumentAnalysisBankAccount",
      accountNumber?: string | null,
      routingNumber?: string | null,
    } | null,
    category?: TaskCategory | null,
    source?: DocumentAnalysisSource | null,
    isCorrect?: boolean | null,
    fromEmail?: string | null,
    textContent?: string | null,
    createdBy?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnUpdateEntitySubscriptionVariables = {
  entityId: string,
};

export type OnUpdateEntitySubscription = {
  onUpdateEntity?:  {
    __typename: "Entity",
    id: string,
    type: EntityType,
    taxNumber?: string | null,
    companyNumber?: string | null,
    billerCode?: number | null,
    name: string,
    legalName?: string | null,
    businessNames?: Array< string | null > | null,
    searchName?: string | null,
    address?:  {
      __typename: "Address",
      addressId?: string | null,
      contactName?: string | null,
      contactNumber?: string | null,
      fullAddress?: string | null,
      address1?: string | null,
      address2?: string | null,
      city?: string | null,
      country: string,
      countryCode: string,
      state: string,
      stateCode?: string | null,
      postalCode: string,
      invalid?: boolean | null,
    } | null,
    logo?:  {
      __typename: "Image",
      alt?: string | null,
      identityId?: string | null,
      key: string,
      level: S3UploadLevel,
      type?: string | null,
    } | null,
    brandColour?: string | null,
    website?: string | null,
    entityUsers?:  {
      __typename: "ModelEntityUserConnection",
      items:  Array< {
        __typename: "EntityUser",
        id: string,
        entityId: string,
        userId: string,
        firmId?: string | null,
        email?: string | null,
        invitedEmail?: string | null,
        ocrEmail?: string | null,
        referredBy?: string | null,
        invitedEntityId?: string | null,
        firmEntityId?: string | null,
        providerContactId?: string | null,
        ownerCode?: string | null,
        clientGroupCode?: string | null,
        clientCode?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        role: EntityUserRole,
        jobTags?: Array< JobTags | null > | null,
        paymentsEnabled?: boolean | null,
        termsInvoiceAccepted?: boolean | null,
        termsOcrAccepted?: boolean | null,
        termsFirmPayTaxAccepted?: boolean | null,
        termsFirmPayTaxDetails?:  {
          __typename: "TermsFirmPayTaxDetails",
          document?:  {
            __typename: "S3Upload",
            identityId?: string | null,
            key: string,
            level: S3UploadLevel,
            type: S3UploadType,
            name?: string | null,
          } | null,
          acceptedAt?: string | null,
          email?: string | null,
          ip?: string | null,
          fullName?: string | null,
          firmId?: string | null,
        } | null,
        entitySearchName?: string | null,
        entity?:  {
          __typename: "Entity",
          id: string,
          type: EntityType,
          taxNumber?: string | null,
          companyNumber?: string | null,
          billerCode?: number | null,
          name: string,
          legalName?: string | null,
          businessNames?: Array< string | null > | null,
          searchName?: string | null,
          address?:  {
            __typename: "Address",
            addressId?: string | null,
            contactName?: string | null,
            contactNumber?: string | null,
            fullAddress?: string | null,
            address1?: string | null,
            address2?: string | null,
            city?: string | null,
            country: string,
            countryCode: string,
            state: string,
            stateCode?: string | null,
            postalCode: string,
            invalid?: boolean | null,
          } | null,
          logo?:  {
            __typename: "Image",
            alt?: string | null,
            identityId?: string | null,
            key: string,
            level: S3UploadLevel,
            type?: string | null,
          } | null,
          brandColour?: string | null,
          website?: string | null,
          entityUsers?:  {
            __typename: "ModelEntityUserConnection",
            items:  Array< {
              __typename: "EntityUser",
              id: string,
              entityId: string,
              userId: string,
              firmId?: string | null,
              email?: string | null,
              invitedEmail?: string | null,
              ocrEmail?: string | null,
              referredBy?: string | null,
              invitedEntityId?: string | null,
              firmEntityId?: string | null,
              providerContactId?: string | null,
              ownerCode?: string | null,
              clientGroupCode?: string | null,
              clientCode?: string | null,
              firstName?: string | null,
              lastName?: string | null,
              role: EntityUserRole,
              jobTags?: Array< JobTags | null > | null,
              paymentsEnabled?: boolean | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              termsFirmPayTaxAccepted?: boolean | null,
              termsFirmPayTaxDetails?:  {
                __typename: "TermsFirmPayTaxDetails",
                acceptedAt?: string | null,
                email?: string | null,
                ip?: string | null,
                fullName?: string | null,
                firmId?: string | null,
              } | null,
              entitySearchName?: string | null,
              entity?:  {
                __typename: "Entity",
                id: string,
                type: EntityType,
                taxNumber?: string | null,
                companyNumber?: string | null,
                billerCode?: number | null,
                name: string,
                legalName?: string | null,
                businessNames?: Array< string | null > | null,
                searchName?: string | null,
                brandColour?: string | null,
                website?: string | null,
                gstRegistered?: boolean | null,
                gstReportingPeriod?: GSTReportingPeriod | null,
                providerEntityId?: string | null,
                providerCompanyId?: string | null,
                providerBillUserCompanyId?: string | null,
                providerBankAccountId?: string | null,
                providerDigitalWalletId?: string | null,
                providerBpayCrn?: string | null,
                paymentMethodId?: string | null,
                paymentUserId?: string | null,
                disbursementMethodId?: string | null,
                ubosCreated?: boolean | null,
                numUbosCreated?: number | null,
                subCategory?: string | null,
                clientsStatus?: EntityClientsStatus | null,
                ocrEmail?: string | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                owner?: string | null,
                referredBy?: string | null,
                connectedAccount?: string | null,
                accountStatus?: AccountStatus | null,
                customerId?: string | null,
                xeroSyncStatus?: XeroSyncStatus | null,
                xeroLastContactSyncAt?: string | null,
                xeroContactSyncStatus?: XeroSyncStatus | null,
                xeroInvoiceSyncStatus?: XeroSyncStatus | null,
                xeroLastInvoiceSyncAt?: string | null,
                xeroTenantId?: string | null,
                absorbFees?: boolean | null,
                subscriptionTier?: SubscriptionTier | null,
                invitationStatus?: InvitationStatus | null,
                clientsOnboardingStatus?: ClientsOnboardingStatus | null,
                createdBy?: string | null,
                createdByEntityId?: string | null,
                isFirm?: boolean | null,
                createdAt?: string | null,
                updatedAt?: string | null,
              } | null,
              firm?:  {
                __typename: "Entity",
                id: string,
                type: EntityType,
                taxNumber?: string | null,
                companyNumber?: string | null,
                billerCode?: number | null,
                name: string,
                legalName?: string | null,
                businessNames?: Array< string | null > | null,
                searchName?: string | null,
                brandColour?: string | null,
                website?: string | null,
                gstRegistered?: boolean | null,
                gstReportingPeriod?: GSTReportingPeriod | null,
                providerEntityId?: string | null,
                providerCompanyId?: string | null,
                providerBillUserCompanyId?: string | null,
                providerBankAccountId?: string | null,
                providerDigitalWalletId?: string | null,
                providerBpayCrn?: string | null,
                paymentMethodId?: string | null,
                paymentUserId?: string | null,
                disbursementMethodId?: string | null,
                ubosCreated?: boolean | null,
                numUbosCreated?: number | null,
                subCategory?: string | null,
                clientsStatus?: EntityClientsStatus | null,
                ocrEmail?: string | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                owner?: string | null,
                referredBy?: string | null,
                connectedAccount?: string | null,
                accountStatus?: AccountStatus | null,
                customerId?: string | null,
                xeroSyncStatus?: XeroSyncStatus | null,
                xeroLastContactSyncAt?: string | null,
                xeroContactSyncStatus?: XeroSyncStatus | null,
                xeroInvoiceSyncStatus?: XeroSyncStatus | null,
                xeroLastInvoiceSyncAt?: string | null,
                xeroTenantId?: string | null,
                absorbFees?: boolean | null,
                subscriptionTier?: SubscriptionTier | null,
                invitationStatus?: InvitationStatus | null,
                clientsOnboardingStatus?: ClientsOnboardingStatus | null,
                createdBy?: string | null,
                createdByEntityId?: string | null,
                isFirm?: boolean | null,
                createdAt?: string | null,
                updatedAt?: string | null,
              } | null,
              searchName?: string | null,
              taxNumber?: string | null,
              taskSendSMS?: boolean | null,
              companyNumber?: string | null,
              createdBy?: string | null,
              createdAt: string,
              updatedAt: string,
              status?: EntityUserStatus | null,
              partnerId?: string | null,
              managerId?: string | null,
              archivedAt?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gstRegistered?: boolean | null,
          gstReportingPeriod?: GSTReportingPeriod | null,
          providerEntityId?: string | null,
          providerCompanyId?: string | null,
          providerBillUserCompanyId?: string | null,
          providerBankAccountId?: string | null,
          providerDigitalWalletId?: string | null,
          providerBpayCrn?: string | null,
          contact?:  {
            __typename: "EntityContact",
            firstName?: string | null,
            lastName?: string | null,
            email?: string | null,
            phone?: string | null,
            role?: string | null,
          } | null,
          paymentMethods?:  {
            __typename: "ModelPaymentMethodConnection",
            items:  Array< {
              __typename: "PaymentMethod",
              id: string,
              paymentMethodType: PaymentMethodType,
              type?: string | null,
              fullName?: string | null,
              number?: string | null,
              expMonth?: string | null,
              expYear?: string | null,
              accountName?: string | null,
              bankName?: string | null,
              accountNumber?: string | null,
              routingNumber?: string | null,
              holderType?: BankHolderType | null,
              accountType?: BankAccountType | null,
              status?: PaymentMethodStatus | null,
              accountDirection?: AccountDirection | null,
              expiresAt?: string | null,
              createdAt?: string | null,
              updatedAt?: string | null,
              consentId?: string | null,
              consentStatus?: PaymentConsentStatus | null,
              card?: string | null,
              googlepay?: string | null,
              applepay?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          paymentMethodId?: string | null,
          paymentUserId?: string | null,
          disbursementMethodId?: string | null,
          receivingAccounts?:  {
            __typename: "ModelPaymentMethodConnection",
            items:  Array< {
              __typename: "PaymentMethod",
              id: string,
              paymentMethodType: PaymentMethodType,
              type?: string | null,
              fullName?: string | null,
              number?: string | null,
              expMonth?: string | null,
              expYear?: string | null,
              accountName?: string | null,
              bankName?: string | null,
              accountNumber?: string | null,
              routingNumber?: string | null,
              holderType?: BankHolderType | null,
              accountType?: BankAccountType | null,
              status?: PaymentMethodStatus | null,
              accountDirection?: AccountDirection | null,
              expiresAt?: string | null,
              createdAt?: string | null,
              updatedAt?: string | null,
              consentId?: string | null,
              consentStatus?: PaymentConsentStatus | null,
              card?: string | null,
              googlepay?: string | null,
              applepay?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          ubosCreated?: boolean | null,
          numUbosCreated?: number | null,
          subCategory?: string | null,
          clientsStatus?: EntityClientsStatus | null,
          ocrEmail?: string | null,
          termsInvoiceAccepted?: boolean | null,
          termsOcrAccepted?: boolean | null,
          owner?: string | null,
          referredBy?: string | null,
          connectedAccount?: string | null,
          accountStatus?: AccountStatus | null,
          customerId?: string | null,
          xeroSyncStatus?: XeroSyncStatus | null,
          xeroLastContactSyncAt?: string | null,
          xeroContactSyncStatus?: XeroSyncStatus | null,
          xeroInvoiceSyncStatus?: XeroSyncStatus | null,
          xeroLastInvoiceSyncAt?: string | null,
          xeroTenantId?: string | null,
          absorbFees?: boolean | null,
          subscriptionTier?: SubscriptionTier | null,
          invitationStatus?: InvitationStatus | null,
          clientsOnboardingStatus?: ClientsOnboardingStatus | null,
          createdBy?: string | null,
          createdByEntityId?: string | null,
          isFirm?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | null,
        firm?:  {
          __typename: "Entity",
          id: string,
          type: EntityType,
          taxNumber?: string | null,
          companyNumber?: string | null,
          billerCode?: number | null,
          name: string,
          legalName?: string | null,
          businessNames?: Array< string | null > | null,
          searchName?: string | null,
          address?:  {
            __typename: "Address",
            addressId?: string | null,
            contactName?: string | null,
            contactNumber?: string | null,
            fullAddress?: string | null,
            address1?: string | null,
            address2?: string | null,
            city?: string | null,
            country: string,
            countryCode: string,
            state: string,
            stateCode?: string | null,
            postalCode: string,
            invalid?: boolean | null,
          } | null,
          logo?:  {
            __typename: "Image",
            alt?: string | null,
            identityId?: string | null,
            key: string,
            level: S3UploadLevel,
            type?: string | null,
          } | null,
          brandColour?: string | null,
          website?: string | null,
          entityUsers?:  {
            __typename: "ModelEntityUserConnection",
            items:  Array< {
              __typename: "EntityUser",
              id: string,
              entityId: string,
              userId: string,
              firmId?: string | null,
              email?: string | null,
              invitedEmail?: string | null,
              ocrEmail?: string | null,
              referredBy?: string | null,
              invitedEntityId?: string | null,
              firmEntityId?: string | null,
              providerContactId?: string | null,
              ownerCode?: string | null,
              clientGroupCode?: string | null,
              clientCode?: string | null,
              firstName?: string | null,
              lastName?: string | null,
              role: EntityUserRole,
              jobTags?: Array< JobTags | null > | null,
              paymentsEnabled?: boolean | null,
              termsInvoiceAccepted?: boolean | null,
              termsOcrAccepted?: boolean | null,
              termsFirmPayTaxAccepted?: boolean | null,
              termsFirmPayTaxDetails?:  {
                __typename: "TermsFirmPayTaxDetails",
                acceptedAt?: string | null,
                email?: string | null,
                ip?: string | null,
                fullName?: string | null,
                firmId?: string | null,
              } | null,
              entitySearchName?: string | null,
              entity?:  {
                __typename: "Entity",
                id: string,
                type: EntityType,
                taxNumber?: string | null,
                companyNumber?: string | null,
                billerCode?: number | null,
                name: string,
                legalName?: string | null,
                businessNames?: Array< string | null > | null,
                searchName?: string | null,
                brandColour?: string | null,
                website?: string | null,
                gstRegistered?: boolean | null,
                gstReportingPeriod?: GSTReportingPeriod | null,
                providerEntityId?: string | null,
                providerCompanyId?: string | null,
                providerBillUserCompanyId?: string | null,
                providerBankAccountId?: string | null,
                providerDigitalWalletId?: string | null,
                providerBpayCrn?: string | null,
                paymentMethodId?: string | null,
                paymentUserId?: string | null,
                disbursementMethodId?: string | null,
                ubosCreated?: boolean | null,
                numUbosCreated?: number | null,
                subCategory?: string | null,
                clientsStatus?: EntityClientsStatus | null,
                ocrEmail?: string | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                owner?: string | null,
                referredBy?: string | null,
                connectedAccount?: string | null,
                accountStatus?: AccountStatus | null,
                customerId?: string | null,
                xeroSyncStatus?: XeroSyncStatus | null,
                xeroLastContactSyncAt?: string | null,
                xeroContactSyncStatus?: XeroSyncStatus | null,
                xeroInvoiceSyncStatus?: XeroSyncStatus | null,
                xeroLastInvoiceSyncAt?: string | null,
                xeroTenantId?: string | null,
                absorbFees?: boolean | null,
                subscriptionTier?: SubscriptionTier | null,
                invitationStatus?: InvitationStatus | null,
                clientsOnboardingStatus?: ClientsOnboardingStatus | null,
                createdBy?: string | null,
                createdByEntityId?: string | null,
                isFirm?: boolean | null,
                createdAt?: string | null,
                updatedAt?: string | null,
              } | null,
              firm?:  {
                __typename: "Entity",
                id: string,
                type: EntityType,
                taxNumber?: string | null,
                companyNumber?: string | null,
                billerCode?: number | null,
                name: string,
                legalName?: string | null,
                businessNames?: Array< string | null > | null,
                searchName?: string | null,
                brandColour?: string | null,
                website?: string | null,
                gstRegistered?: boolean | null,
                gstReportingPeriod?: GSTReportingPeriod | null,
                providerEntityId?: string | null,
                providerCompanyId?: string | null,
                providerBillUserCompanyId?: string | null,
                providerBankAccountId?: string | null,
                providerDigitalWalletId?: string | null,
                providerBpayCrn?: string | null,
                paymentMethodId?: string | null,
                paymentUserId?: string | null,
                disbursementMethodId?: string | null,
                ubosCreated?: boolean | null,
                numUbosCreated?: number | null,
                subCategory?: string | null,
                clientsStatus?: EntityClientsStatus | null,
                ocrEmail?: string | null,
                termsInvoiceAccepted?: boolean | null,
                termsOcrAccepted?: boolean | null,
                owner?: string | null,
                referredBy?: string | null,
                connectedAccount?: string | null,
                accountStatus?: AccountStatus | null,
                customerId?: string | null,
                xeroSyncStatus?: XeroSyncStatus | null,
                xeroLastContactSyncAt?: string | null,
                xeroContactSyncStatus?: XeroSyncStatus | null,
                xeroInvoiceSyncStatus?: XeroSyncStatus | null,
                xeroLastInvoiceSyncAt?: string | null,
                xeroTenantId?: string | null,
                absorbFees?: boolean | null,
                subscriptionTier?: SubscriptionTier | null,
                invitationStatus?: InvitationStatus | null,
                clientsOnboardingStatus?: ClientsOnboardingStatus | null,
                createdBy?: string | null,
                createdByEntityId?: string | null,
                isFirm?: boolean | null,
                createdAt?: string | null,
                updatedAt?: string | null,
              } | null,
              searchName?: string | null,
              taxNumber?: string | null,
              taskSendSMS?: boolean | null,
              companyNumber?: string | null,
              createdBy?: string | null,
              createdAt: string,
              updatedAt: string,
              status?: EntityUserStatus | null,
              partnerId?: string | null,
              managerId?: string | null,
              archivedAt?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gstRegistered?: boolean | null,
          gstReportingPeriod?: GSTReportingPeriod | null,
          providerEntityId?: string | null,
          providerCompanyId?: string | null,
          providerBillUserCompanyId?: string | null,
          providerBankAccountId?: string | null,
          providerDigitalWalletId?: string | null,
          providerBpayCrn?: string | null,
          contact?:  {
            __typename: "EntityContact",
            firstName?: string | null,
            lastName?: string | null,
            email?: string | null,
            phone?: string | null,
            role?: string | null,
          } | null,
          paymentMethods?:  {
            __typename: "ModelPaymentMethodConnection",
            items:  Array< {
              __typename: "PaymentMethod",
              id: string,
              paymentMethodType: PaymentMethodType,
              type?: string | null,
              fullName?: string | null,
              number?: string | null,
              expMonth?: string | null,
              expYear?: string | null,
              accountName?: string | null,
              bankName?: string | null,
              accountNumber?: string | null,
              routingNumber?: string | null,
              holderType?: BankHolderType | null,
              accountType?: BankAccountType | null,
              status?: PaymentMethodStatus | null,
              accountDirection?: AccountDirection | null,
              expiresAt?: string | null,
              createdAt?: string | null,
              updatedAt?: string | null,
              consentId?: string | null,
              consentStatus?: PaymentConsentStatus | null,
              card?: string | null,
              googlepay?: string | null,
              applepay?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          paymentMethodId?: string | null,
          paymentUserId?: string | null,
          disbursementMethodId?: string | null,
          receivingAccounts?:  {
            __typename: "ModelPaymentMethodConnection",
            items:  Array< {
              __typename: "PaymentMethod",
              id: string,
              paymentMethodType: PaymentMethodType,
              type?: string | null,
              fullName?: string | null,
              number?: string | null,
              expMonth?: string | null,
              expYear?: string | null,
              accountName?: string | null,
              bankName?: string | null,
              accountNumber?: string | null,
              routingNumber?: string | null,
              holderType?: BankHolderType | null,
              accountType?: BankAccountType | null,
              status?: PaymentMethodStatus | null,
              accountDirection?: AccountDirection | null,
              expiresAt?: string | null,
              createdAt?: string | null,
              updatedAt?: string | null,
              consentId?: string | null,
              consentStatus?: PaymentConsentStatus | null,
              card?: string | null,
              googlepay?: string | null,
              applepay?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          ubosCreated?: boolean | null,
          numUbosCreated?: number | null,
          subCategory?: string | null,
          clientsStatus?: EntityClientsStatus | null,
          ocrEmail?: string | null,
          termsInvoiceAccepted?: boolean | null,
          termsOcrAccepted?: boolean | null,
          owner?: string | null,
          referredBy?: string | null,
          connectedAccount?: string | null,
          accountStatus?: AccountStatus | null,
          customerId?: string | null,
          xeroSyncStatus?: XeroSyncStatus | null,
          xeroLastContactSyncAt?: string | null,
          xeroContactSyncStatus?: XeroSyncStatus | null,
          xeroInvoiceSyncStatus?: XeroSyncStatus | null,
          xeroLastInvoiceSyncAt?: string | null,
          xeroTenantId?: string | null,
          absorbFees?: boolean | null,
          subscriptionTier?: SubscriptionTier | null,
          invitationStatus?: InvitationStatus | null,
          clientsOnboardingStatus?: ClientsOnboardingStatus | null,
          createdBy?: string | null,
          createdByEntityId?: string | null,
          isFirm?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | null,
        searchName?: string | null,
        taxNumber?: string | null,
        taskSendSMS?: boolean | null,
        companyNumber?: string | null,
        createdBy?: string | null,
        createdAt: string,
        updatedAt: string,
        status?: EntityUserStatus | null,
        partnerId?: string | null,
        managerId?: string | null,
        archivedAt?: string | null,
        taxPaymentReferences?:  {
          __typename: "TaxPaymentReferences",
          itr?:  {
            __typename: "TaxPaymentReference",
            referenceNumber?: string | null,
            updatedAt?: string | null,
          } | null,
          other?:  {
            __typename: "TaxPaymentReference",
            referenceNumber?: string | null,
            updatedAt?: string | null,
          } | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    gstRegistered?: boolean | null,
    gstReportingPeriod?: GSTReportingPeriod | null,
    providerEntityId?: string | null,
    providerCompanyId?: string | null,
    providerBillUserCompanyId?: string | null,
    providerBankAccountId?: string | null,
    providerDigitalWalletId?: string | null,
    providerBpayCrn?: string | null,
    contact?:  {
      __typename: "EntityContact",
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      phone?: string | null,
      role?: string | null,
    } | null,
    paymentMethods?:  {
      __typename: "ModelPaymentMethodConnection",
      items:  Array< {
        __typename: "PaymentMethod",
        id: string,
        paymentMethodType: PaymentMethodType,
        type?: string | null,
        fullName?: string | null,
        number?: string | null,
        expMonth?: string | null,
        expYear?: string | null,
        accountName?: string | null,
        bankName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
        holderType?: BankHolderType | null,
        accountType?: BankAccountType | null,
        status?: PaymentMethodStatus | null,
        accountDirection?: AccountDirection | null,
        expiresAt?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        consentId?: string | null,
        consentStatus?: PaymentConsentStatus | null,
        card?: string | null,
        googlepay?: string | null,
        applepay?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    paymentMethodId?: string | null,
    paymentUserId?: string | null,
    disbursementMethodId?: string | null,
    receivingAccounts?:  {
      __typename: "ModelPaymentMethodConnection",
      items:  Array< {
        __typename: "PaymentMethod",
        id: string,
        paymentMethodType: PaymentMethodType,
        type?: string | null,
        fullName?: string | null,
        number?: string | null,
        expMonth?: string | null,
        expYear?: string | null,
        accountName?: string | null,
        bankName?: string | null,
        accountNumber?: string | null,
        routingNumber?: string | null,
        holderType?: BankHolderType | null,
        accountType?: BankAccountType | null,
        status?: PaymentMethodStatus | null,
        accountDirection?: AccountDirection | null,
        expiresAt?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        consentId?: string | null,
        consentStatus?: PaymentConsentStatus | null,
        card?: string | null,
        googlepay?: string | null,
        applepay?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    ubosCreated?: boolean | null,
    numUbosCreated?: number | null,
    subCategory?: string | null,
    clientsStatus?: EntityClientsStatus | null,
    ocrEmail?: string | null,
    termsInvoiceAccepted?: boolean | null,
    termsOcrAccepted?: boolean | null,
    owner?: string | null,
    referredBy?: string | null,
    connectedAccount?: string | null,
    accountStatus?: AccountStatus | null,
    customerId?: string | null,
    xeroSyncStatus?: XeroSyncStatus | null,
    xeroLastContactSyncAt?: string | null,
    xeroContactSyncStatus?: XeroSyncStatus | null,
    xeroInvoiceSyncStatus?: XeroSyncStatus | null,
    xeroLastInvoiceSyncAt?: string | null,
    xeroTenantId?: string | null,
    absorbFees?: boolean | null,
    subscriptionTier?: SubscriptionTier | null,
    invitationStatus?: InvitationStatus | null,
    clientsOnboardingStatus?: ClientsOnboardingStatus | null,
    createdBy?: string | null,
    createdByEntityId?: string | null,
    isFirm?: boolean | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnCreateNotificationSubscription = {
  onCreateNotification?:  {
    __typename: "Notification",
    id: string,
    title?: string | null,
    message?: string | null,
    status?: NotificationStatus | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    type?: string | null,
    owner: string,
  } | null,
};
